var exports =
webpackJsonpexports([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _plugins = __webpack_require__(193);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var csrfCookieName = window.csrfCookieName || 'sc';
	
	// setup jquery for CSRF tokens
	function getCookie(name) {
	  var cookieValue = null;
	  if (document.cookie && document.cookie !== '') {
	    var cookies = document.cookie.split(';');
	    for (var i = 0; i < cookies.length; i++) {
	      var cookie = _jquery2['default'].trim(cookies[i]);
	      // Does this cookie string begin with the name we want?
	      if (cookie.substring(0, name.length + 1) == name + '=') {
	        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
	        break;
	      }
	    }
	  }
	  return cookieValue;
	}
	
	function csrfSafeMethod(method) {
	  // these HTTP methods do not require CSRF protection
	  return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method)
	  );
	}
	
	_jquery2['default'].ajaxSetup({
	  beforeSend: function beforeSend(xhr, settings) {
	    if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
	      xhr.setRequestHeader('X-CSRFToken', getCookie(csrfCookieName));
	    }
	  }
	});
	
	// these get exported to a global variable, which is important as its the only
	// way we can call into scoped objects
	
	exports['default'] = {
	  jQuery: _jquery2['default'],
	  moment: __webpack_require__(19),
	  Raven: __webpack_require__(108),
	  React: __webpack_require__(1),
	  ReactDOM: __webpack_require__(20),
	  Reflux: __webpack_require__(11),
	  Router: __webpack_require__(8),
	  underscore: __webpack_require__(12),
	
	  Sentry: {
	    api: __webpack_require__(131),
	    routes: __webpack_require__(616),
	    plugins: {
	      add: _plugins2['default'].add,
	      BasePlugin: _plugins2['default'].BasePlugin,
	      DefaultIssuePlugin: _plugins2['default'].DefaultIssuePlugin
	    },
	
	    Alerts: __webpack_require__(268),
	    AlertActions: __webpack_require__(62),
	    AvatarSettings: __webpack_require__(545),
	    mixins: {
	      ApiMixin: __webpack_require__(3),
	      TooltipMixin: __webpack_require__(38)
	    },
	    BarChart: __webpack_require__(132),
	    i18n: __webpack_require__(2),
	    ConfigStore: __webpack_require__(27),
	    Count: __webpack_require__(71),
	    DateTime: __webpack_require__(72),
	    DropdownLink: __webpack_require__(33),
	    FlotChart: __webpack_require__(135),
	    Form: __webpack_require__(277),
	    FormState: __webpack_require__(36).FormState,
	    HookStore: __webpack_require__(90),
	    Indicators: __webpack_require__(288),
	    IndicatorStore: __webpack_require__(17),
	    LoadingError: __webpack_require__(9),
	    LoadingIndicator: __webpack_require__(6),
	    ListLink: __webpack_require__(47),
	    MenuItem: __webpack_require__(37),
	    OrganizationHomeContainer: __webpack_require__(64),
	    OrganizationsLoader: __webpack_require__(291),
	    Pagination: __webpack_require__(39),
	    PluginConfig: __webpack_require__(187),
	    ProjectIssueTracking: __webpack_require__(683),
	    ProjectSelector: __webpack_require__(136),
	    RuleEditor: __webpack_require__(696),
	    Sidebar: __webpack_require__(137),
	    StackedBarChart: __webpack_require__(106),
	    TimeSince: __webpack_require__(40),
	    TodoList: __webpack_require__(191),
	    U2fEnrollment: __webpack_require__(607),
	    U2fSign: __webpack_require__(608),
	    utils: {
	      errorHandler: __webpack_require__(304)
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.setLocaleDebug = setLocaleDebug;
	exports.setLocale = setLocale;
	exports.parseComponentTemplate = parseComponentTemplate;
	exports.renderComponentTemplate = renderComponentTemplate;
	exports.format = format;
	exports.gettext = gettext;
	exports.ngettext = ngettext;
	exports.gettextComponentTemplate = gettextComponentTemplate;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _jed = __webpack_require__(315);
	
	var _jed2 = _interopRequireDefault(_jed);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _translations = __webpack_require__(619);
	
	var _sprintfJs = __webpack_require__(411);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var LOCALE_DEBUG = false;
	
	if (sessionStorage && sessionStorage.getItem('localeDebug') == '1') {
	  LOCALE_DEBUG = true;
	}
	
	function setLocaleDebug(value) {
	  sessionStorage.setItem('localeDebug', value ? '1' : '0');
	  /*eslint no-console:0*/
	  console.log('Locale debug is: ', value ? 'on' : 'off', '. Reload page to apply changes!');
	}
	
	var i18n = null;
	
	function setLocale(locale) {
	  var translations = (0, _translations.getTranslations)(locale);
	  i18n = new _jed2['default']({
	    'domain': 'sentry',
	    'missing_key_callback': function missing_key_callback(key) {},
	    'locale_data': {
	      'sentry': translations
	    }
	  });
	}
	
	setLocale('en');
	
	function formatForReact(formatString, args) {
	  var rv = [];
	  var cursor = 0;
	
	  // always re-parse, do not cache, because we change the match
	  _sprintfJs.sprintf.parse(formatString).forEach(function (match, idx) {
	    if (_underscore2['default'].isString(match)) {
	      rv.push(match);
	    } else {
	      var arg = null;
	      if (match[2]) {
	        arg = args[0][match[2][0]];
	      } else if (match[1]) {
	        arg = args[parseInt(match[1], 10) - 1];
	      } else {
	        arg = args[cursor++];
	      }
	
	      // this points to a react element!
	      if (_react2['default'].isValidElement(arg)) {
	        rv.push(_react2['default'].cloneElement(arg, { key: idx }));
	        // not a react element, fuck around with it so that sprintf.format
	        // can format it for us.  We make sure match[2] is null so that we
	        // do not go down the object path, and we set match[1] to the first
	        // index and then pass an array with two items in.
	      } else {
	          match[2] = null;
	          match[1] = 1;
	          rv.push(_react2['default'].createElement(
	            'span',
	            { key: idx++ },
	            _sprintfJs.sprintf.format([match], [null, arg])
	          ));
	        }
	    }
	  });
	
	  return rv;
	}
	
	function argsInvolveReact(args) {
	  if (args.some(_react2['default'].isValidElement)) {
	    return true;
	  }
	  if (args.length == 1 && _underscore2['default'].isObject(args[0])) {
	    return Object.keys(args[0]).some(function (key) {
	      return _react2['default'].isValidElement(args[0][key]);
	    });
	  }
	  return false;
	}
	
	function parseComponentTemplate(string) {
	  var rv = {};
	
	  function process(startPos, group, inGroup) {
	    var regex = /\[(.*?)(:|\])|\]/g;
	    var match = undefined;
	    var buf = [];
	    var satisfied = false;
	
	    var pos = regex.lastIndex = startPos;
	    while ((match = regex.exec(string)) !== null) {
	      // eslint-disable-line no-cond-assign
	      var substr = string.substr(pos, match.index - pos);
	      if (substr !== '') {
	        buf.push(substr);
	      }
	
	      if (match[0] == ']') {
	        if (inGroup) {
	          satisfied = true;
	          break;
	        } else {
	          pos = regex.lastIndex;
	          continue;
	        }
	      }
	
	      if (match[2] == ']') {
	        pos = regex.lastIndex;
	      } else {
	        pos = regex.lastIndex = process(regex.lastIndex, match[1], true);
	      }
	      buf.push({ group: match[1] });
	    }
	
	    var endPos = regex.lastIndex;
	    if (!satisfied) {
	      var rest = string.substr(pos);
	      if (rest) {
	        buf.push(rest);
	      }
	      endPos = string.length;
	    }
	
	    rv[group] = buf;
	    return endPos;
	  }
	
	  process(0, 'root', false);
	
	  return rv;
	}
	
	function renderComponentTemplate(template, components) {
	  var idx = 0;
	  function renderGroup(group) {
	    var children = [];
	
	    (template[group] || []).forEach(function (item) {
	      if (_underscore2['default'].isString(item)) {
	        children.push(_react2['default'].createElement(
	          'span',
	          { key: idx++ },
	          item
	        ));
	      } else {
	        children.push(renderGroup(item.group));
	      }
	    });
	
	    // in case we cannot find our component, we call back to an empty
	    // span so that stuff shows up at least.
	    var reference = components[group] || _react2['default'].createElement('span', { key: idx++ });
	    if (!_react2['default'].isValidElement(reference)) {
	      reference = _react2['default'].createElement(
	        'span',
	        { key: idx++ },
	        reference
	      );
	    }
	
	    if (children.length > 0) {
	      return _react2['default'].cloneElement(reference, { key: idx++ }, children);
	    } else {
	      return _react2['default'].cloneElement(reference, { key: idx++ });
	    }
	  }
	
	  return renderGroup('root');
	}
	
	function mark(rv) {
	  if (!LOCALE_DEBUG) {
	    return rv;
	  }
	
	  var proxy = {
	    $$typeof: Symbol['for']('react.element'),
	    type: 'span',
	    key: null,
	    ref: null,
	    props: {
	      className: 'translation-wrapper',
	      children: _underscore2['default'].isArray(rv) ? rv : [rv]
	    },
	    _owner: null,
	    _store: {}
	  };
	
	  proxy.toString = function () {
	    return '🇦🇹' + rv + '🇦🇹';
	  };
	
	  return proxy;
	}
	
	function format(formatString, args) {
	  if (argsInvolveReact(args)) {
	    return formatForReact(formatString, args);
	  } else {
	    return _sprintfJs.sprintf.apply(undefined, [formatString].concat(_toConsumableArray(args)));
	  }
	}
	
	function gettext(string) {
	  var rv = i18n.gettext(string);
	
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  if (args.length > 0) {
	    rv = format(rv, args);
	  }
	  return mark(rv);
	}
	
	function ngettext(singular, plural) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    args[_key2 - 2] = arguments[_key2];
	  }
	
	  return mark(format(i18n.ngettext(singular, plural, args[0] || 0), args));
	}
	
	/* special form of gettext where you can render nested react
	   components in template strings.  Example:
	
	      gettextComponentTemplate('Welcome. Click [link:here]', {
	        root: <p/>,
	        link: <a href="#" />
	      });
	
	   the root string is always called "root", the rest is prefixed
	   with the name in the brackets */
	
	function gettextComponentTemplate(template, components) {
	  var tmpl = parseComponentTemplate(i18n.gettext(template));
	  return mark(renderComponentTemplate(tmpl, components));
	}
	
	var t = gettext;
	exports.t = t;
	var tn = ngettext;
	exports.tn = tn;
	var tct = gettextComponentTemplate;
	exports.tct = tct;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _api = __webpack_require__(131);
	
	var ApiMixin = {
	  componentWillMount: function componentWillMount() {
	    this.api = new _api.Client();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.api.clear();
	  }
	};
	
	exports['default'] = ApiMixin;
	module.exports = exports['default'];

/***/ },
/* 4 */,
/* 5 */,
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function LoadingIndicator(props) {
	  var mini = props.mini;
	  var triangle = props.triangle;
	
	  var classes = {
	    loading: true,
	    mini: mini,
	    triangle: triangle
	  };
	
	  return _react2['default'].createElement(
	    'div',
	    { className: (0, _classnames2['default'])(props.className, classes) },
	    _react2['default'].createElement('div', { className: 'loading-indicator' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'loading-message' },
	      props.children
	    )
	  );
	}
	
	LoadingIndicator.propTypes = {
	  mini: _react2['default'].PropTypes.bool,
	  triangle: _react2['default'].PropTypes.bool
	};
	
	exports['default'] = LoadingIndicator;
	module.exports = exports['default'];

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	/*eslint no-use-before-define:0*/
	var modelsEqual = function modelsEqual(obj1, obj2) {
	  if (!obj1 && !obj2) return true;
	  if (obj1.id && !obj2) return false;
	  if (obj2.id && !obj1) return false;
	  return obj1.id === obj2.id;
	};
	
	var arrayIsEqual = function arrayIsEqual(arr, other, deep) {
	  // if the other array is a falsy value, return
	  if (!arr && !other) {
	    return true;
	  }
	
	  if (!arr || !other) {
	    return false;
	  }
	
	  // compare lengths - can save a lot of time
	  if (arr.length != other.length) {
	    return false;
	  }
	
	  for (var i = 0, l = Math.max(arr.length, other.length); i < l; i++) {
	    return valueIsEqual(arr[i], other[i], deep);
	  }
	};
	
	var valueIsEqual = function valueIsEqual(value, other, deep) {
	  if (value === other) {
	    return true;
	  } else if (_underscore2['default'].isArray(value) || _underscore2['default'].isArray(other)) {
	    if (arrayIsEqual(value, other, deep)) {
	      return true;
	    }
	  } else if (_underscore2['default'].isObject(value) || _underscore2['default'].isObject(other)) {
	    if (objectMatchesSubset(value, other, deep)) {
	      return true;
	    }
	  }
	  return false;
	};
	
	var objectMatchesSubset = function objectMatchesSubset(obj, other, deep) {
	  var k = undefined;
	
	  if (obj === other) {
	    return true;
	  }
	
	  if (!obj || !other) {
	    return false;
	  }
	
	  if (deep !== true) {
	    for (k in other) {
	      if (obj[k] != other[k]) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  for (k in other) {
	    if (!valueIsEqual(obj[k], other[k], deep)) {
	      return false;
	    }
	  }
	  return true;
	};
	
	// XXX(dcramer): the previous mechanism of using _.map here failed
	// miserably if a param was named 'length'
	var objectToArray = function objectToArray(obj) {
	  var result = [];
	  for (var key in obj) {
	    result.push([key, obj[key]]);
	  }
	  return result;
	};
	
	var compareArrays = function compareArrays(arr1, arr2, compFunc) {
	  if (arr1 === arr2) {
	    return true;
	  }
	  if (!arr1) {
	    arr1 = [];
	  }
	  if (!arr2) {
	    arr2 = [];
	  }
	
	  if (arr1.length != arr2.length) {
	    return false;
	  }
	
	  for (var i = 0; i < Math.max(arr1.length, arr2.length); i++) {
	    if (!arr1[i]) {
	      return false;
	    }
	    if (!arr2[i]) {
	      return false;
	    }
	    if (!compFunc(arr1[i], arr2[i])) {
	      return false;
	    }
	  }
	  return true;
	};
	
	var intcomma = function intcomma(x) {
	  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};
	
	exports['default'] = {
	  getQueryParams: function getQueryParams() {
	    var hashes = undefined,
	        hash = undefined;
	    var vars = {},
	        href = window.location.href;
	
	    if (href.indexOf('?') == -1) return vars;
	
	    hashes = href.slice(href.indexOf('?') + 1, href.indexOf('#') != -1 ? href.indexOf('#') : href.length).split('&');
	
	    hashes.forEach(function (chunk) {
	      hash = chunk.split('=');
	      if (!hash[0] && !hash[1]) {
	        return;
	      }
	
	      vars[decodeURIComponent(hash[0])] = hash[1] ? decodeURIComponent(hash[1]).replace(/\+/, ' ') : '';
	    });
	
	    return vars;
	  },
	
	  sortArray: function sortArray(arr, score_fn) {
	    arr.sort(function (a, b) {
	      var a_score = score_fn(a),
	          b_score = score_fn(b);
	
	      for (var i = 0; i < a_score.length; i++) {
	        if (a_score[i] > b_score[i]) {
	          return 1;
	        }
	        if (a_score[i] < b_score[i]) {
	          return -1;
	        }
	      }
	      return 0;
	    });
	
	    return arr;
	  },
	
	  objectIsEmpty: function objectIsEmpty(obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	
	    return true;
	  },
	
	  trim: function trim(str) {
	    return str.replace(/^\s+|\s+$/g, '');
	  },
	
	  defined: function defined(item) {
	    return !_underscore2['default'].isUndefined(item) && item !== null;
	  },
	
	  nl2br: function nl2br(str) {
	    return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
	  },
	
	  isUrl: function isUrl(str) {
	    return !!str && _underscore2['default'].isString(str) && (str.indexOf('http://') === 0 || str.indexOf('https://') === 0);
	  },
	
	  escape: function escape(str) {
	    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  },
	
	  percent: function percent(value, totalValue, precise) {
	    return value / totalValue * 100;
	  },
	
	  urlize: function urlize(str) {
	    // TODO
	    return str;
	  },
	
	  toTitleCase: function toTitleCase(str) {
	    return str.replace(/\w\S*/g, function (txt) {
	      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	    });
	  },
	
	  arrayIsEqual: arrayIsEqual,
	  objectMatchesSubset: objectMatchesSubset,
	  compareArrays: compareArrays,
	  intcomma: intcomma,
	  modelsEqual: modelsEqual,
	  valueIsEqual: valueIsEqual,
	  parseLinkHeader: __webpack_require__(195),
	  deviceNameMapper: __webpack_require__(623),
	  objectToArray: objectToArray,
	
	  Collection: __webpack_require__(620),
	  PendingChangeQueue: __webpack_require__(624),
	  StreamManager: __webpack_require__(626),
	  CursorPoller: __webpack_require__(622)
	};
	module.exports = exports['default'];

/***/ },
/* 8 */,
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__(2);
	
	var LoadingError = _react2['default'].createClass({
	  displayName: 'LoadingError',
	
	  propTypes: {
	    onRetry: _react2['default'].PropTypes.func,
	    message: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      message: (0, _locale.t)('There was an error loading data.')
	    };
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    return false;
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'alert alert-error alert-block' },
	      _react2['default'].createElement(
	        'p',
	        null,
	        this.props.message,
	        this.props.onRetry && _react2['default'].createElement(
	          'a',
	          { onClick: this.props.onRetry, className: 'btn btn-default btn-sm',
	            style: { marginLeft: 5 } },
	          (0, _locale.t)('Retry')
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = LoadingError;
	module.exports = exports['default'];

/***/ },
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var PropTypes = {
	  AnyModel: _react2['default'].PropTypes.shape({
	    id: _react2['default'].PropTypes.string.isRequired
	  }),
	  Group: _react2['default'].PropTypes.shape({
	    id: _react2['default'].PropTypes.string.isRequired
	  }),
	  Event: _react2['default'].PropTypes.shape({
	    id: _react2['default'].PropTypes.string.isRequired
	  }),
	  Organization: _react2['default'].PropTypes.shape({
	    id: _react2['default'].PropTypes.string.isRequired
	  }),
	  Project: _react2['default'].PropTypes.shape({
	    id: _react2['default'].PropTypes.string.isRequired
	  }),
	  TagKey: _react2['default'].PropTypes.shape({
	    key: _react2['default'].PropTypes.string.isRequired
	  }),
	  Team: _react2['default'].PropTypes.shape({
	    id: _react2['default'].PropTypes.string.isRequired
	  }),
	  User: _react2['default'].PropTypes.shape({
	    id: _react2['default'].PropTypes.string.isRequired
	  })
	};
	
	exports['default'] = PropTypes;
	module.exports = exports['default'];

/***/ },
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var IndicatorStore = _reflux2['default'].createStore({
	  init: function init() {
	    this.items = [];
	    this.lastId = 0;
	  },
	
	  add: function add(message, type, options) {
	    var _this = this;
	
	    options = options || {};
	
	    var indicator = {
	      id: this.lastId++,
	      message: message,
	      type: type,
	      options: options
	    };
	
	    if (options.duration) {
	      setTimeout(function () {
	        _this.remove(indicator);
	      }, options.duration);
	    }
	    this.items = [indicator]; // replace
	    this.trigger(this.items);
	    return indicator;
	  },
	
	  remove: function remove(indicator) {
	    this.items = this.items.filter(function (item) {
	      return item !== indicator;
	    });
	    this.trigger(this.items);
	  }
	});
	
	exports['default'] = IndicatorStore;
	module.exports = exports['default'];

/***/ },
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var OrganizationState = {
	  contextTypes: {
	    organization: _proptypes2['default'].Organization
	  },
	
	  getOrganization: function getOrganization() {
	    return this.context.organization;
	  },
	
	  getAccess: function getAccess() {
	    return new Set(this.context.organization.access);
	  },
	
	  getFeatures: function getFeatures() {
	    return new Set(this.context.organization.features);
	  },
	
	  getOnboardingTasks: function getOnboardingTasks() {
	    return new Set(this.context.organization.onboardingTasks);
	  }
	};
	
	exports['default'] = OrganizationState;
	module.exports = exports['default'];

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _momentTimezone = __webpack_require__(317);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _locale = __webpack_require__(2);
	
	var ConfigStore = _reflux2['default'].createStore({
	  init: function init() {
	    this.config = {};
	  },
	
	  get: function get(key) {
	    return this.config[key];
	  },
	
	  set: function set(key, value) {
	    this.config[key] = value;
	    var out = {};
	    out[key] = value;
	    this.trigger(out);
	  },
	
	  getConfig: function getConfig() {
	    return this.config;
	  },
	
	  loadInitialData: function loadInitialData(config) {
	    config.features = new Set(config.features || []);
	    this.config = config;
	
	    // TODO(dcramer): abstract this out of ConfigStore
	    if (config.user) {
	      _momentTimezone2['default'].tz.setDefault(config.user.options.timezone);
	      (0, _locale.setLocale)(config.user.options.language || 'en');
	    }
	
	    this.trigger(config);
	  }
	});
	
	exports['default'] = ConfigStore;
	module.exports = exports['default'];

/***/ },
/* 28 */,
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _cryptoJsMd5 = __webpack_require__(313);
	
	var _cryptoJsMd52 = _interopRequireDefault(_cryptoJsMd5);
	
	var _componentsUserLetterAvatar = __webpack_require__(609);
	
	var _componentsUserLetterAvatar2 = _interopRequireDefault(_componentsUserLetterAvatar);
	
	var Avatar = _react2['default'].createClass({
	  displayName: 'Avatar',
	
	  propTypes: {
	    user: _react2['default'].PropTypes.object,
	    size: _react2['default'].PropTypes.number,
	    'default': _react2['default'].PropTypes.string,
	    title: _react2['default'].PropTypes.string,
	    gravatar: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      className: 'avatar',
	      size: 64,
	      gravatar: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      showBackupAvatar: false,
	      loadError: false
	    };
	  },
	
	  buildGravatarUrl: function buildGravatarUrl() {
	    var url = 'https://secure.gravatar.com/avatar/';
	
	    url += (0, _cryptoJsMd52['default'])(this.props.user.email.toLowerCase());
	
	    var query = {
	      s: this.props.size || undefined,
	      d: this.props['default'] || 'blank'
	    };
	
	    url += '?' + _jquery2['default'].param(query);
	
	    return url;
	  },
	
	  buildProfileUrl: function buildProfileUrl() {
	    var url = '/avatar/' + this.props.user.avatar.avatarUuid + '/';
	    if (this.props.size) {
	      url += '?' + _jquery2['default'].param({ s: this.props.size });
	    }
	    return url;
	  },
	
	  onLoad: function onLoad() {
	    this.setState({ showBackupAvatar: true });
	  },
	
	  onError: function onError() {
	    this.setState({ showBackupAvatar: true, loadError: true });
	  },
	
	  renderImg: function renderImg() {
	    if (this.state.loadError) {
	      return null;
	    }
	    var user = this.props.user;
	    var avatarType = null;
	    if (user.avatar) {
	      avatarType = user.avatar.avatarType;
	    } else {
	      avatarType = user.email && this.props.gravatar ? 'gravatar' : 'letter_avatar';
	    }
	    var props = { title: this.props.title, onError: this.onError, onLoad: this.onLoad };
	    if (user.options && user.options.avatarType) {
	      avatarType = user.options.avatarType;
	    }
	    if (avatarType === 'gravatar') {
	      return _react2['default'].createElement('img', _extends({ src: this.buildGravatarUrl() }, props));
	    } else if (avatarType === 'upload') {
	      return _react2['default'].createElement('img', _extends({ src: this.buildProfileUrl() }, props));
	    } else {
	      return _react2['default'].createElement(_componentsUserLetterAvatar2['default'], { user: user });
	    }
	  },
	
	  render: function render() {
	    var user = this.props.user;
	    if (!user) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      { className: this.props.className },
	      this.state.showBackupAvatar && _react2['default'].createElement(_componentsUserLetterAvatar2['default'], { user: user }),
	      this.renderImg()
	    );
	  }
	});
	
	exports['default'] = Avatar;
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var GroupEventDataSection = _react2['default'].createClass({
	  displayName: 'GroupEventDataSection',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    title: _react2['default'].PropTypes.any,
	    type: _react2['default'].PropTypes.string.isRequired,
	    wrapTitle: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      wrapTitle: true
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (location.hash) {
	      var _location$hash$split = location.hash.split('#');
	
	      var _location$hash$split2 = _slicedToArray(_location$hash$split, 2);
	
	      var hash = _location$hash$split2[1];
	
	      var anchorElement = hash && document.querySelector('div#' + hash);
	      if (anchorElement) {
	        anchorElement.scrollIntoView();
	      }
	    }
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: (this.props.className || '') + ' box' },
	      this.props.title && _react2['default'].createElement(
	        'div',
	        { className: 'box-header', id: this.props.type },
	        _react2['default'].createElement(
	          'a',
	          { href: '#' + this.props.type, className: 'permalink' },
	          _react2['default'].createElement('em', { className: 'icon-anchor' })
	        ),
	        this.props.wrapTitle ? _react2['default'].createElement(
	          'h3',
	          null,
	          this.props.title
	        ) : _react2['default'].createElement(
	          'div',
	          null,
	          this.props.title
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-content with-padding' },
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = GroupEventDataSection;
	module.exports = exports['default'];

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(881);

/***/ },
/* 32 */,
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(311);
	
	var DropdownLink = _react2['default'].createClass({
	  displayName: 'DropdownLink',
	
	  propTypes: {
	    title: _react2['default'].PropTypes.node,
	    caret: _react2['default'].PropTypes.bool,
	    disabled: _react2['default'].PropTypes.bool,
	    onOpen: _react2['default'].PropTypes.func,
	    onClose: _react2['default'].PropTypes.func,
	    topLevelClasses: _react2['default'].PropTypes.string,
	    menuClasses: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false,
	      caret: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      isOpen: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    (0, _jquery2['default'])(this.refs.dropdownToggle).dropdown();
	    (0, _jquery2['default'])(this.refs.dropdownToggle.parentNode).on('shown.bs.dropdown', function (e) {
	      _this.setState({
	        isOpen: true
	      });
	      _this.props.onOpen && _this.props.onOpen(e);
	    }).on('hidden.bs.dropdown', function (e) {
	      setTimeout(function () {
	        if (!_this.isMounted()) {
	          return;
	        }
	        _this.setState({
	          isOpen: false
	        });
	        _this.props.onClose && _this.props.onClose(e);
	      });
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    (0, _jquery2['default'])(this.refs.dropdownToggle.parentNode).off();
	  },
	
	  close: function close() {
	    this.setState({ isOpen: false });
	  },
	
	  render: function render() {
	    var className = (0, _classnames2['default'])({
	      'dropdown-toggle': true,
	      'disabled': this.props.disabled
	    });
	
	    var topLevelClasses = (0, _classnames2['default'])({
	      'dropdown': true,
	      'open': this.state.isOpen
	    });
	
	    return _react2['default'].createElement(
	      'span',
	      { className: (0, _classnames2['default'])(this.props.topLevelClasses, topLevelClasses) },
	      _react2['default'].createElement(
	        'a',
	        { className: (0, _classnames2['default'])(this.props.className, className),
	          'data-toggle': 'dropdown',
	          ref: 'dropdownToggle' },
	        this.props.title,
	        this.props.caret && _react2['default'].createElement('i', { className: 'icon-arrow-down' })
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: (0, _classnames2['default'])(this.props.menuClasses, 'dropdown-menu') },
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = DropdownLink;
	module.exports = exports['default'];

/***/ },
/* 34 */,
/* 35 */,
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var FormState = {
	  LOADING: 'Loading',
	  READY: 'Ready',
	  SAVING: 'Saving',
	  ERROR: 'Error'
	};
	
	var _booleanField = __webpack_require__(275);
	
	exports.BooleanField = _interopRequire(_booleanField);
	
	var _emailField = __webpack_require__(276);
	
	exports.EmailField = _interopRequire(_emailField);
	
	var _form = __webpack_require__(277);
	
	exports.Form = _interopRequire(_form);
	
	var _genericField = __webpack_require__(584);
	
	exports.GenericField = _interopRequire(_genericField);
	
	var _multipleCheckboxField = __webpack_require__(585);
	
	exports.MultipleCheckboxField = _interopRequire(_multipleCheckboxField);
	
	var _numberField = __webpack_require__(279);
	
	exports.NumberField = _interopRequire(_numberField);
	
	var _passwordField = __webpack_require__(280);
	
	exports.PasswordField = _interopRequire(_passwordField);
	
	var _rangeField = __webpack_require__(281);
	
	exports.RangeField = _interopRequire(_rangeField);
	
	var _select2FieldAutocomplete = __webpack_require__(283);
	
	exports.Select2FieldAutocomplete = _interopRequire(_select2FieldAutocomplete);
	
	var _select2Field = __webpack_require__(282);
	
	exports.Select2Field = _interopRequire(_select2Field);
	
	var _textField = __webpack_require__(284);
	
	exports.TextField = _interopRequire(_textField);
	
	var _textareaField = __webpack_require__(285);
	
	exports.TextareaField = _interopRequire(_textareaField);
	exports.FormState = FormState;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MenuItem = _react2['default'].createClass({
	  displayName: 'MenuItem',
	
	  propTypes: {
	    header: _react2['default'].PropTypes.bool,
	    divider: _react2['default'].PropTypes.bool,
	    title: _react2['default'].PropTypes.string,
	    onSelect: _react2['default'].PropTypes.func,
	    eventKey: _react2['default'].PropTypes.any,
	    isActive: _react2['default'].PropTypes.bool,
	    noAnchor: _react2['default'].PropTypes.bool,
	    // basic link
	    href: _react2['default'].PropTypes.string,
	    // router link
	    to: _react2['default'].PropTypes.string,
	    query: _react2['default'].PropTypes.object,
	    linkClassName: _react2['default'].PropTypes.string,
	    onClick: _react2['default'].PropTypes.func
	  },
	
	  handleClick: function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	      this.props.onSelect(this.props.eventKey);
	    }
	  },
	
	  renderAnchor: function renderAnchor() {
	    if (this.props.to) {
	      return _react2['default'].createElement(
	        _reactRouter.Link,
	        {
	          to: { pathname: this.props.to, query: this.props.query },
	          title: this.props.title,
	          onClick: this.handleClick,
	          className: this.props.linkClassName,
	          tabIndex: '-1' },
	        this.props.children
	      );
	    }
	    return _react2['default'].createElement(
	      'a',
	      { title: this.props.title, onClick: this.handleClick,
	        href: this.props.href, className: this.props.linkClassName,
	        tabIndex: '-1' },
	      this.props.children
	    );
	  },
	
	  render: function render() {
	    var classes = {
	      'dropdown-header': this.props.header,
	      'divider': this.props.divider,
	      'active': this.props.isActive
	    };
	
	    var children = null;
	    if (this.props.noAnchor) {
	      children = this.props.children;
	    } else if (this.props.header) {
	      children = this.props.children;
	    } else if (!this.props.divider) {
	      children = this.renderAnchor();
	    }
	
	    return _react2['default'].createElement(
	      'li',
	      { role: 'presentation', title: null, href: null,
	        className: (0, _classnames2['default'])(this.props.className, classes),
	        onClick: this.props.onClick },
	      children
	    );
	  }
	});
	
	exports['default'] = MenuItem;
	module.exports = exports['default'];

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(312);
	
	exports['default'] = function (options) {
	  options = options || {};
	  return {
	    componentDidMount: function componentDidMount() {
	      this.attachTooltips();
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      this.removeTooltips();
	      (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)).unbind();
	    },
	
	    attachTooltips: function attachTooltips() {
	      (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)).tooltip(Object.prototype.toString.call(options) === '[object Function]' ? options.call(this) : options);
	    },
	
	    removeTooltips: function removeTooltips() {
	      (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)).tooltip('destroy') // destroy tooltips on parent ...
	      .find(options.selector).tooltip('destroy'); // ... and descendents
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _reactRouter = __webpack_require__(8);
	
	var _locale = __webpack_require__(2);
	
	var Pagination = _react2['default'].createClass({
	  displayName: 'Pagination',
	
	  propTypes: {
	    pageLinks: _react2['default'].PropTypes.string,
	    to: _react2['default'].PropTypes.string
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  render: function render() {
	    if (!this.props.pageLinks) {
	      return null;
	    }
	
	    var links = _utils2['default'].parseLinkHeader(this.props.pageLinks);
	
	    var previousPageClassName = 'btn btn-default btn-lg prev';
	    if (links.previous.results === false) {
	      previousPageClassName += ' disabled';
	    }
	
	    var nextPageClassName = 'btn btn-default btn-lg next';
	    if (links.next.results === false) {
	      nextPageClassName += ' disabled';
	    }
	
	    var location = this.context.location;
	    return _react2['default'].createElement(
	      'div',
	      { className: 'stream-pagination' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'btn-group pull-right' },
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          {
	            to: {
	              pathname: this.props.to || location.pathname,
	              query: _extends({}, location.query, { cursor: links.previous.cursor })
	            },
	            className: previousPageClassName,
	            disabled: links.previous.results === false },
	          _react2['default'].createElement('span', { title: (0, _locale.t)('Previous'), className: 'icon-arrow-left' })
	        ),
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: {
	              pathname: this.props.to || location.pathname,
	              query: _extends({}, location.query, { cursor: links.next.cursor })
	            },
	            className: nextPageClassName,
	            disabled: links.next.results === false },
	          _react2['default'].createElement('span', { title: (0, _locale.t)('Next'), className: 'icon-arrow-right' })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = Pagination;
	module.exports = exports['default'];

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _storesConfigStoreJsx = __webpack_require__(27);
	
	var _storesConfigStoreJsx2 = _interopRequireDefault(_storesConfigStoreJsx);
	
	var _locale = __webpack_require__(2);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var TimeSince = _react2['default'].createClass({
	  displayName: 'TimeSince',
	
	  propTypes: {
	    date: _react2['default'].PropTypes.any.isRequired,
	    suffix: _react2['default'].PropTypes.string
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default']],
	
	  statics: {
	    getDateObj: function getDateObj(date) {
	      if (_underscore2['default'].isString(date) || _underscore2['default'].isNumber(date)) {
	        date = new Date(date);
	      }
	      return date;
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      suffix: 'ago'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      relative: this.getRelativeDate()
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.setRelativeDateTicker();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.ticker) {
	      clearTimeout(this.ticker);
	      this.ticker = null;
	    }
	  },
	
	  setRelativeDateTicker: function setRelativeDateTicker() {
	    var _this = this;
	
	    var ONE_MINUTE_IN_MS = 60000;
	
	    this.ticker = setTimeout(function () {
	      _this.setState({
	        relative: _this.getRelativeDate()
	      });
	      _this.setRelativeDateTicker();
	    }, ONE_MINUTE_IN_MS);
	  },
	
	  getRelativeDate: function getRelativeDate() {
	    var date = TimeSince.getDateObj(this.props.date);
	    if (!this.props.suffix) {
	      return (0, _moment2['default'])(date).fromNow(true);
	    } else if (this.props.suffix === 'ago') {
	      return (0, _moment2['default'])(date).fromNow();
	    } else if (this.props.suffix == 'old') {
	      return (0, _locale.t)('%(time)s old', { time: (0, _moment2['default'])(date).fromNow(true) });
	    } else {
	      throw new Error('Unsupported time format suffix');
	    }
	  },
	
	  render: function render() {
	    var date = TimeSince.getDateObj(this.props.date);
	    var user = _storesConfigStoreJsx2['default'].get('user');
	    var options = user ? user.options : {};
	    var format = options.clock24Hours ? 'MMMM D YYYY HH:mm:ss z' : 'LLL z';
	
	    return _react2['default'].createElement(
	      'time',
	      {
	        dateTime: date.toISOString(),
	        title: (0, _moment2['default'])(date).format(format),
	        className: this.props.className },
	      this.state.relative
	    );
	  }
	});
	
	exports['default'] = TimeSince;
	module.exports = exports['default'];

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _teamState = __webpack_require__(611);
	
	var _teamState2 = _interopRequireDefault(_teamState);
	
	var ProjectState = {
	  mixins: [_teamState2['default']],
	
	  contextTypes: {
	    project: _proptypes2['default'].Project
	  },
	
	  getProjectFeatures: function getProjectFeatures() {
	    return new Set(this.context.project.features);
	  },
	
	  getProject: function getProject() {
	    return this.context.project;
	  }
	};
	
	exports['default'] = ProjectState;
	module.exports = exports['default'];

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _actionsGroupActions = __webpack_require__(169);
	
	var _actionsGroupActions2 = _interopRequireDefault(_actionsGroupActions);
	
	var _indicatorStore = __webpack_require__(17);
	
	var _indicatorStore2 = _interopRequireDefault(_indicatorStore);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _locale = __webpack_require__(2);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function showAlert(msg, type) {
	  _indicatorStore2['default'].add(msg, type, {
	    duration: 4000
	  });
	}
	
	var GroupStore = _reflux2['default'].createStore({
	  listenables: [_actionsGroupActions2['default']],
	
	  init: function init() {
	    this.items = [];
	    this.statuses = {};
	    this.pendingChanges = new _utils2['default'].PendingChangeQueue();
	  },
	
	  reset: function reset() {
	    this.items = [];
	    this.statuses = {};
	    this.pendingChanges.clear();
	  },
	
	  // TODO(dcramer): this should actually come from an action of some sorts
	  loadInitialData: function loadInitialData(items) {
	    var _this = this;
	
	    this.reset();
	
	    var itemIds = new Set();
	    items.forEach(function (item) {
	      itemIds.add(item.id);
	      _this.items.push(item);
	    });
	
	    this.trigger(itemIds);
	  },
	
	  add: function add(items) {
	    var _this2 = this;
	
	    if (!_underscore2['default'].isArray(items)) {
	      items = [items];
	    }
	
	    var itemsById = {};
	    var itemIds = new Set();
	    items.forEach(function (item) {
	      itemsById[item.id] = item;
	      itemIds.add(item.id);
	    });
	
	    // See if any existing items are updated by this new set of items
	    this.items.forEach(function (item, idx) {
	      if (itemsById[item.id]) {
	        _this2.items[idx] = _jquery2['default'].extend(true, {}, item, itemsById[item.id]);
	        delete itemsById[item.id];
	      }
	    });
	
	    // New items
	    for (var itemId in itemsById) {
	      this.items.push(itemsById[itemId]);
	    }
	
	    this.trigger(itemIds);
	  },
	
	  remove: function remove(itemId) {
	    var _this3 = this;
	
	    this.items.forEach(function (item, idx) {
	      if (item.id === itemId) {
	        _this3.items.splice(idx, idx + 1);
	      }
	    });
	
	    this.trigger(new Set([itemId]));
	  },
	
	  addStatus: function addStatus(id, status) {
	    if (_underscore2['default'].isUndefined(this.statuses[id])) {
	      this.statuses[id] = {};
	    }
	    this.statuses[id][status] = true;
	  },
	
	  clearStatus: function clearStatus(id, status) {
	    if (_underscore2['default'].isUndefined(this.statuses[id])) {
	      return;
	    }
	    this.statuses[id][status] = false;
	  },
	
	  hasStatus: function hasStatus(id, status) {
	    if (_underscore2['default'].isUndefined(this.statuses[id])) {
	      return false;
	    }
	    return this.statuses[id][status] || false;
	  },
	
	  indexOfActivity: function indexOfActivity(group_id, id) {
	    var group = this.get(group_id);
	    if (!group) return -1;
	
	    for (var i = 0; i < group.activity.length; i++) {
	      if (group.activity[i].id === id) {
	        return i;
	      }
	    }
	    return -1;
	  },
	
	  addActivity: function addActivity(id, data) {
	    var index = arguments.length <= 2 || arguments[2] === undefined ? -1 : arguments[2];
	
	    var group = this.get(id);
	    if (!group) return;
	
	    // insert into beginning by default
	    if (index === -1) {
	      group.activity.unshift(data);
	    } else {
	      group.activity.splice(index, 0, data);
	    }
	    if (data.type === 'note') group.numComments++;
	
	    this.trigger(new Set([id]));
	  },
	
	  updateActivity: function updateActivity(group_id, id, data) {
	    var group = this.get(group_id);
	    if (!group) return;
	
	    var index = this.indexOfActivity(group_id, id);
	    if (index === -1) return;
	
	    // Here, we want to merge the new `data` being passed in
	    // into the existing `data` object. This effectively
	    // allows passing in an object of only changes.
	    group.activity[index].data = Object.assign(group.activity[index].data, data);
	    this.trigger(new Set([group.id]));
	  },
	
	  removeActivity: function removeActivity(group_id, id) {
	    var group = this.get(group_id);
	    if (!group) return -1;
	
	    var index = this.indexOfActivity(group.id, id);
	    if (index === -1) return -1;
	
	    var activity = group.activity.splice(index, 1);
	
	    if (activity[0].type === 'note') group.numComments--;
	
	    this.trigger(new Set([group.id]));
	    return index;
	  },
	
	  get: function get(id) {
	    var pendingForId = [];
	    this.pendingChanges.forEach(function (change) {
	      if (change.id === id) {
	        pendingForId.push(change);
	      }
	    });
	
	    for (var i = 0; i < this.items.length; i++) {
	      if (this.items[i].id === id) {
	        var rItem = this.items[i];
	        if (pendingForId.length) {
	          // copy the object so dirty state doesnt mutate original
	          rItem = _jquery2['default'].extend(true, {}, rItem);
	
	          for (var c = 0; c < pendingForId.length; c++) {
	            rItem = _jquery2['default'].extend(true, rItem, pendingForId[c].params);
	          }
	        }
	        return rItem;
	      }
	    }
	  },
	
	  getAllItemIds: function getAllItemIds() {
	    return this.items.map(function (item) {
	      return item.id;
	    });
	  },
	
	  getAllItems: function getAllItems() {
	    // regroup pending changes by their itemID
	    var pendingById = {};
	    this.pendingChanges.forEach(function (change) {
	      if (_underscore2['default'].isUndefined(pendingById[change.id])) {
	        pendingById[change.id] = [];
	      }
	      pendingById[change.id].push(change);
	    });
	
	    return this.items.map(function (item) {
	      var rItem = item;
	      if (!_underscore2['default'].isUndefined(pendingById[item.id])) {
	        // copy the object so dirty state doesnt mutate original
	        rItem = _jquery2['default'].extend(true, {}, rItem);
	        pendingById[item.id].forEach(function (change) {
	          rItem = _jquery2['default'].extend(true, rItem, change.params);
	        });
	      }
	      return rItem;
	    });
	  },
	
	  onAssignTo: function onAssignTo(changeId, itemId, data) {
	    this.addStatus(itemId, 'assignTo');
	    this.trigger(new Set([itemId]));
	  },
	
	  // TODO(dcramer): This is not really the best place for this
	  onAssignToError: function onAssignToError(changeId, itemId, error) {
	    this.clearStatus(itemId, 'assignTo');
	    showAlert((0, _locale.t)('Unable to change assignee. Please try again.'), 'error');
	  },
	
	  onAssignToSuccess: function onAssignToSuccess(changeId, itemId, response) {
	    var item = this.get(itemId);
	    if (!item) {
	      return;
	    }
	    item.assignedTo = response.assignedTo;
	    this.clearStatus(itemId, 'assignTo');
	    this.trigger(new Set([itemId]));
	  },
	
	  onDelete: function onDelete(changeId, itemIds) {
	    var _this4 = this;
	
	    itemIds.forEach(function (itemId) {
	      _this4.addStatus(itemId, 'delete');
	    });
	    this.trigger(new Set(itemIds));
	  },
	
	  onDeleteError: function onDeleteError(changeId, itemIds, response) {
	    var _this5 = this;
	
	    itemIds.forEach(function (itemId) {
	      _this5.clearStatus(itemId, 'delete');
	    });
	    showAlert((0, _locale.t)('Unable to delete events. Please try again.'), 'error');
	    this.trigger(new Set(itemIds));
	  },
	
	  onDeleteSuccess: function onDeleteSuccess(changeId, itemIds, response) {
	    var _this6 = this;
	
	    var itemIdSet = new Set(itemIds);
	    itemIds.forEach(function (itemId) {
	      delete _this6.statuses[itemId];
	      _this6.clearStatus(itemId, 'delete');
	    });
	    this.items = this.items.filter(function (item) {
	      return !itemIdSet.has(item.id);
	    });
	    showAlert((0, _locale.t)('The selected events have been scheduled for deletion.'), 'success');
	    this.trigger(new Set(itemIds));
	  },
	
	  onMerge: function onMerge(changeId, itemIds) {
	    var _this7 = this;
	
	    itemIds = this._itemIdsOrAll(itemIds);
	
	    itemIds.forEach(function (itemId) {
	      _this7.addStatus(itemId, 'merge');
	    });
	    this.trigger(new Set(itemIds));
	  },
	
	  onMergeError: function onMergeError(changeId, itemIds, response) {
	    var _this8 = this;
	
	    itemIds = this._itemIdsOrAll(itemIds);
	
	    itemIds.forEach(function (itemId) {
	      _this8.clearStatus(itemId, 'merge');
	    });
	    showAlert((0, _locale.t)('Unable to merge events. Please try again.'), 'error');
	    this.trigger(new Set(itemIds));
	  },
	
	  onMergeSuccess: function onMergeSuccess(changeId, mergedIds, response) {
	    var _this9 = this;
	
	    mergedIds = this._itemIdsOrAll(mergedIds); // everything on page
	
	    mergedIds.forEach(function (itemId) {
	      _this9.clearStatus(itemId, 'merge');
	    });
	
	    // Remove all but parent id (items were merged into this one)
	    var mergedIdSet = new Set(mergedIds);
	    this.items = this.items.filter(function (item) {
	      return !mergedIdSet.has(item.id) || item.id === response.merge.parent;
	    });
	
	    showAlert((0, _locale.t)('The selected events have been scheduled for merge.'), 'success');
	    this.trigger(new Set(mergedIds));
	  },
	
	  /**
	   * If itemIds is undefined, returns all ids in the store
	   */
	  _itemIdsOrAll: function _itemIdsOrAll(itemIds) {
	    if (_underscore2['default'].isUndefined(itemIds)) {
	      itemIds = this.items.map(function (item) {
	        return item.id;
	      });
	    }
	    return itemIds;
	  },
	
	  onUpdate: function onUpdate(changeId, itemIds, data) {
	    var _this10 = this;
	
	    itemIds = this._itemIdsOrAll(itemIds);
	
	    itemIds.forEach(function (itemId) {
	      _this10.addStatus(itemId, 'update');
	      _this10.pendingChanges.push(changeId, itemId, data);
	    });
	    this.trigger(new Set(itemIds));
	  },
	
	  onUpdateError: function onUpdateError(changeId, itemIds, error, failSilently) {
	    var _this11 = this;
	
	    itemIds = this._itemIdsOrAll(itemIds);
	
	    this.pendingChanges.remove(changeId);
	    itemIds.forEach(function (itemId) {
	      _this11.clearStatus(itemId, 'update');
	    });
	    if (!failSilently) {
	      showAlert((0, _locale.t)('Unable to update events. Please try again.'), 'error');
	    }
	    this.trigger(new Set(itemIds));
	  },
	
	  onUpdateSuccess: function onUpdateSuccess(changeId, itemIds, response) {
	    var _this12 = this;
	
	    itemIds = this._itemIdsOrAll(itemIds);
	
	    this.items.forEach(function (item, idx) {
	      if (itemIds.indexOf(item.id) !== -1) {
	        _this12.items[idx] = _jquery2['default'].extend(true, {}, item, response);
	        _this12.clearStatus(item.id, 'update');
	      }
	    });
	    this.pendingChanges.remove(changeId);
	    this.trigger(new Set(itemIds));
	  }
	
	});
	
	exports['default'] = GroupStore;
	module.exports = exports['default'];

/***/ },
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reactRouter = __webpack_require__(8);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var ListLink = _react2['default'].createClass({
	  displayName: 'ListLink',
	
	  propTypes: {
	    activeClassName: _react2['default'].PropTypes.string.isRequired,
	    to: _react2['default'].PropTypes.string.isRequired,
	    query: _react2['default'].PropTypes.object,
	    onClick: _react2['default'].PropTypes.func,
	    index: _react2['default'].PropTypes.bool,
	
	    // If supplied by parent component, decides whether link element
	    // is "active" or not ... overriding default behavior of strict
	    // route matching
	    isActive: _react2['default'].PropTypes.func
	  },
	
	  contextTypes: {
	    router: _react2['default'].PropTypes.object.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      activeClassName: 'active',
	      index: false
	    };
	  },
	
	  isActive: function isActive() {
	    return (this.props.isActive || this.context.router.isActive)({ pathname: this.props.to, query: this.props.query }, this.props.index);
	  },
	
	  getClassName: function getClassName() {
	    var _classNames = {};
	
	    if (this.props.className) _classNames[this.props.className] = true;
	
	    if (this.isActive()) _classNames[this.props.activeClassName] = true;
	
	    return (0, _classnames2['default'])(_classNames);
	  },
	
	  render: function render() {
	    var carriedProps = _underscore2['default'].omit(this.props, 'activeClassName', 'isActive', 'index');
	    return _react2['default'].createElement(
	      'li',
	      { className: this.getClassName() },
	      _react2['default'].createElement(
	        _reactRouter.Link,
	        _extends({}, carriedProps, { onlyActiveOnIndex: this.props.index }),
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = ListLink;
	module.exports = exports['default'];

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _projectState = __webpack_require__(41);
	
	var _projectState2 = _interopRequireDefault(_projectState);
	
	var GroupState = {
	  mixins: [_projectState2['default']],
	
	  contextTypes: {
	    group: _proptypes2['default'].Group.isRequired
	  },
	
	  getGroup: function getGroup() {
	    return this.context.group;
	  }
	};
	
	exports['default'] = GroupState;
	module.exports = exports['default'];

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes += ' ' + arg;
				} else if (Array.isArray(arg)) {
					classes += ' ' + classNames.apply(null, arg);
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes += ' ' + key;
						}
					}
				}
			}
	
			return classes.substr(1);
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var AlertActions = _reflux2['default'].createActions(['addAlert', 'closeAlert']);
	
	exports['default'] = AlertActions;
	module.exports = exports['default'];

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _formField = __webpack_require__(278);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _utils = __webpack_require__(7);
	
	var InputField = (function (_FormField) {
	  _inherits(InputField, _FormField);
	
	  function InputField(props) {
	    _classCallCheck(this, InputField);
	
	    _get(Object.getPrototypeOf(InputField.prototype), 'constructor', this).call(this, props);
	
	    this.onChange = this.onChange.bind(this);
	
	    this.state.value = this.valueFromProps(props);
	  }
	
	  _createClass(InputField, [{
	    key: 'valueFromProps',
	    value: function valueFromProps(props) {
	      return (0, _utils.defined)(props.value) ? props.value : props.defaultValue || '';
	    }
	
	    // XXX(dcramer): this comes from TooltipMixin
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.attachTooltips();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeTooltips();
	      (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)).unbind();
	    }
	  }, {
	    key: 'attachTooltips',
	    value: function attachTooltips() {
	      (0, _jquery2['default'])('.tip', _reactDom2['default'].findDOMNode(this)).tooltip();
	    }
	  }, {
	    key: 'removeTooltips',
	    value: function removeTooltips() {
	      (0, _jquery2['default'])('.tip', _reactDom2['default'].findDOMNode(this)).tooltip('destroy');
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this = this;
	
	      this.setState({
	        value: e.target.value
	      }, function () {
	        _this.props.onChange(_this.state.value);
	      });
	    }
	  }, {
	    key: 'getId',
	    value: function getId() {
	      return 'id-' + this.props.name;
	    }
	  }, {
	    key: 'getField',
	    value: function getField() {
	      return _react2['default'].createElement('input', { id: this.getId(),
	        type: this.getType(),
	        className: 'form-control',
	        placeholder: this.props.placeholder,
	        onChange: this.onChange,
	        disabled: this.props.disabled,
	        ref: 'input',
	        required: this.props.required,
	        value: this.state.value });
	    }
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      return 'control-group';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.getClassName();
	      if (this.props.error) {
	        className += ' has-error';
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: className },
	        _react2['default'].createElement(
	          'div',
	          { className: 'controls' },
	          _react2['default'].createElement(
	            'label',
	            { htmlFor: this.getId(), className: 'control-label' },
	            this.props.label
	          ),
	          this.props.disabled && this.props.disabledReason && _react2['default'].createElement(
	            'span',
	            { className: 'disabled-indicator tip', title: this.props.disabledReason },
	            _react2['default'].createElement('span', { className: 'icon-question' })
	          ),
	          this.getField(),
	          (0, _utils.defined)(this.props.help) && _react2['default'].createElement(
	            'p',
	            { className: 'help-block' },
	            this.props.help
	          ),
	          this.props.error && _react2['default'].createElement(
	            'p',
	            { className: 'error' },
	            this.props.error
	          )
	        )
	      );
	    }
	  }]);
	
	  return InputField;
	})(_formField2['default']);
	
	InputField.propTypes = Object.assign({
	  placeholder: _react2['default'].PropTypes.string
	}, _formField2['default'].propTypes);
	
	exports['default'] = InputField;
	module.exports = exports['default'];

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _homeSidebar = __webpack_require__(597);
	
	var _homeSidebar2 = _interopRequireDefault(_homeSidebar);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _projectHeaderProjectSelector = __webpack_require__(136);
	
	var _projectHeaderProjectSelector2 = _interopRequireDefault(_projectHeaderProjectSelector);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _locale = __webpack_require__(2);
	
	var HomeContainer = _react2['default'].createClass({
	  displayName: 'HomeContainer',
	
	  mixins: [_mixinsOrganizationState2['default'], (0, _mixinsTooltip2['default'])({
	    selector: '.tip'
	  })],
	
	  render: function render() {
	    var org = this.getOrganization();
	    var access = this.getAccess();
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'organization-home' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'sub-header flex flex-container flex-vertically-centered' },
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(_projectHeaderProjectSelector2['default'], {
	            organization: org })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'align-right hidden-xs' },
	          access.has('project:write') ? _react2['default'].createElement(
	            'a',
	            { href: '/organizations/' + org.slug + '/projects/new/', className: 'btn btn-primary',
	              style: { marginRight: 5 } },
	            (0, _locale.t)('New Project')
	          ) : _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-primary btn-disabled tip', 'data-placement': 'bottom',
	              title: (0, _locale.t)('You do not have enough permission to create new projects'),
	              style: { marginRight: 5 } },
	            (0, _locale.t)('New Project')
	          ),
	          access.has('team:write') ? _react2['default'].createElement(
	            'a',
	            { href: '/organizations/' + org.slug + '/teams/new/', className: 'btn btn-primary' },
	            (0, _locale.t)('New Team')
	          ) : _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-primary btn-disabled tip', 'data-placement': 'bottom',
	              title: (0, _locale.t)('You do not have enough permission to create new teams') },
	            (0, _locale.t)('New Team')
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'container' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'content row' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-md-2 org-sidebar' },
	            _react2['default'].createElement(_homeSidebar2['default'], null)
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-md-10' },
	            this.props.children
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = HomeContainer;
	module.exports = exports['default'];

/***/ },
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Count = _react2['default'].createClass({
	    displayName: 'Count',
	
	    propTypes: {
	        value: _react2['default'].PropTypes.any.isRequired
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        return this.props.value !== nextProps.value;
	    },
	
	    numberFormats: [[1000000000, 'b'], [1000000, 'm'], [1000, 'k']],
	
	    floatFormat: function floatFormat(number, places) {
	        var multi = Math.pow(10, places);
	        return parseInt(number * multi, 10) / multi;
	    },
	
	    formatNumber: function formatNumber(number) {
	        var b = undefined,
	            x = undefined,
	            y = undefined,
	            o = undefined,
	            p = undefined;
	
	        number = parseInt(number, 10);
	
	        /*eslint no-cond-assign:0*/
	        for (var i = 0; b = this.numberFormats[i]; i++) {
	            x = b[0];
	            y = b[1];
	            o = Math.floor(number / x);
	            p = number % x;
	            if (o > 0) {
	                if (o / 10 > 1 || !p) return '' + o + y;
	                return '' + this.floatFormat(number / x, 1) + y;
	            }
	        }
	        return '' + number;
	    },
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'span',
	            null,
	            this.formatNumber(this.props.value)
	        );
	    }
	});
	
	exports['default'] = Count;
	module.exports = exports['default'];

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _storesConfigStoreJsx = __webpack_require__(27);
	
	var _storesConfigStoreJsx2 = _interopRequireDefault(_storesConfigStoreJsx);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var DateTime = _react2['default'].createClass({
	  displayName: 'DateTime',
	
	  propTypes: {
	    date: _react2['default'].PropTypes.any.isRequired,
	    seconds: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      seconds: true
	    };
	  },
	
	  getDefaultFormat: function getDefaultFormat() {
	    return this.props.seconds ? 'll LTS z' : 'lll';
	  },
	
	  render: function render() {
	    var date = this.props.date;
	    var user = _storesConfigStoreJsx2['default'].get('user');
	    var options = user ? user.options : {};
	    var format = options.clock24Hours ? 'MMMM D YYYY HH:mm:ss z' : this.getDefaultFormat();
	
	    if (_underscore2['default'].isString(date) || _underscore2['default'].isNumber(date)) {
	      date = new Date(date);
	    }
	
	    var carriedProps = _underscore2['default'].omit(this.props, 'date', 'seconds');
	    return _react2['default'].createElement(
	      'time',
	      carriedProps,
	      (0, _moment2['default'])(date).format(format)
	    );
	  }
	});
	
	exports['default'] = DateTime;
	module.exports = exports['default'];

/***/ },
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _contextData = __webpack_require__(173);
	
	var _contextData2 = _interopRequireDefault(_contextData);
	
	var _utils = __webpack_require__(7);
	
	var KeyValueList = _react2['default'].createClass({
	  displayName: 'KeyValueList',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.any.isRequired,
	    isContextData: _react2['default'].PropTypes.bool,
	    isSorted: _react2['default'].PropTypes.bool,
	    onClick: _react2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      isContextData: false,
	      isSorted: true
	    };
	  },
	
	  render: function render() {
	    var _this = this;
	
	    // TODO(dcramer): use non-string keys as reserved words ("unauthorized")
	    // break rendering
	
	    var data = this.props.data;
	    if (data === undefined || data === null) {
	      data = [];
	    } else if (!(data instanceof Array)) {
	      data = Object.keys(data).map(function (key) {
	        return [key, data[key]];
	      });
	    }
	
	    data = this.props.isSorted ? _underscore2['default'].sortBy(data, function (key, value) {
	      return key;
	    }) : data;
	
	    var props = this.props.onClick ? { onClick: this.props.onClick } : {};
	    return _react2['default'].createElement(
	      'table',
	      _extends({ className: 'table key-value' }, props),
	      _react2['default'].createElement(
	        'tbody',
	        null,
	        data.map(function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 2);
	
	          var key = _ref2[0];
	          var value = _ref2[1];
	
	          if (_this.props.isContextData) {
	            return [_react2['default'].createElement(
	              'tr',
	              { key: key },
	              _react2['default'].createElement(
	                'td',
	                { className: 'key' },
	                key
	              ),
	              _react2['default'].createElement(
	                'td',
	                { className: 'value' },
	                _react2['default'].createElement(_contextData2['default'], { data: value })
	              )
	            )];
	          } else {
	            return [_react2['default'].createElement(
	              'tr',
	              { key: key },
	              _react2['default'].createElement(
	                'td',
	                { className: 'key' },
	                key
	              ),
	              _react2['default'].createElement(
	                'td',
	                { className: 'value' },
	                _react2['default'].createElement(
	                  'pre',
	                  null,
	                  (0, _utils.deviceNameMapper)('' + value || ' ')
	                )
	              )
	            )];
	          }
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = KeyValueList;
	module.exports = exports['default'];

/***/ },
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var validHookNames = new Set(['footer', 'organization:header', 'organization:sidebar', 'routes', 'routes:admin', 'routes:organization']);
	
	var HookStore = _reflux2['default'].createStore({
	  init: function init() {
	    this.hooks = {};
	  },
	
	  add: function add(hookName, callback) {
	    if (!validHookNames.has(hookName)) {
	      throw new Error('Invalid hook name: ' + hookName);
	    }
	    if (_underscore2['default'].isUndefined(this.hooks[hookName])) {
	      this.hooks[hookName] = [];
	    }
	    this.hooks[hookName].push(callback);
	    this.trigger(hookName, [callback]);
	  },
	
	  remove: function remove(hookName, callback) {
	    if (_underscore2['default'].isUndefined(this.hooks[hookName])) {
	      return;
	    }
	    this.hooks[hookName] = this.hooks[hookName].filter(function (cb) {
	      return cb !== callback;
	    });
	    this.trigger(hookName, this.hooks[hookName]);
	  },
	
	  get: function get(hookName) {
	    return this.hooks[hookName] || [];
	  }
	});
	
	exports['default'] = HookStore;
	module.exports = exports['default'];

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var MemberListStore = _reflux2['default'].createStore({
	  // listenables: MemberActions,
	
	  init: function init() {
	    this.items = [];
	  },
	
	  // TODO(dcramer): this should actually come from an action of some sorts
	  loadInitialData: function loadInitialData(items) {
	    this.items = items;
	    this.trigger(this.items, 'initial');
	  },
	
	  getById: function getById(id) {
	    id = '' + id;
	    for (var i = 0; i < this.items.length; i++) {
	      if (this.items[i].id === id) {
	        return this.items[i];
	      }
	    }
	    return null;
	  },
	
	  getByEmail: function getByEmail(email) {
	    email = email.toLowerCase();
	    for (var i = 0; i < this.items.length; i++) {
	      if (this.items[i].email.toLowerCase() === email) {
	        return this.items[i];
	      }
	    }
	    return null;
	  },
	
	  getAll: function getAll() {
	    return this.items;
	  }
	});
	
	exports['default'] = MemberListStore;
	module.exports = exports['default'];

/***/ },
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _storesHookStore = __webpack_require__(90);
	
	var _storesHookStore2 = _interopRequireDefault(_storesHookStore);
	
	var _locale = __webpack_require__(2);
	
	var Footer = _react2['default'].createClass({
	  displayName: 'Footer',
	
	  getInitialState: function getInitialState() {
	    // Allow injection via getsentry et all
	    var hooks = [];
	    _storesHookStore2['default'].get('footer').forEach(function (cb) {
	      hooks.push(cb());
	    });
	
	    return {
	      hooks: hooks
	    };
	  },
	
	  render: function render() {
	    var config = _storesConfigStore2['default'].getConfig();
	    return _react2['default'].createElement(
	      'footer',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'container' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'pull-right' },
	          _react2['default'].createElement(
	            'a',
	            { className: 'hidden-xs', href: '/api/' },
	            (0, _locale.t)('API')
	          ),
	          _react2['default'].createElement(
	            'a',
	            { href: '/docs/' },
	            (0, _locale.t)('Docs')
	          ),
	          _react2['default'].createElement(
	            'a',
	            { className: 'hidden-xs', href: 'https://github.com/getsentry/sentry', rel: 'noreferrer' },
	            (0, _locale.t)('Contribute')
	          ),
	          config.isOnPremise && _react2['default'].createElement(
	            'a',
	            { className: 'hidden-xs', href: '/out/' },
	            (0, _locale.t)('Migrate to SaaS')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'version pull-left' },
	          'Sentry',
	          ' ',
	          config.version.current
	        ),
	        _react2['default'].createElement('a', { href: '/', className: 'icon-sentry-logo' }),
	        this.state.hooks
	      )
	    );
	  }
	});
	
	exports['default'] = Footer;
	module.exports = exports['default'];

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(7);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _storesConfigStoreJsx = __webpack_require__(27);
	
	var _storesConfigStoreJsx2 = _interopRequireDefault(_storesConfigStoreJsx);
	
	var StackedBarChart = _react2['default'].createClass({
	  displayName: 'StackedBarChart',
	
	  propTypes: {
	    points: _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.shape({
	      x: _react2['default'].PropTypes.number.isRequired,
	      y: _react2['default'].PropTypes.array.isRequired,
	      label: _react2['default'].PropTypes.string
	    })),
	    interval: _react2['default'].PropTypes.string,
	    height: _react2['default'].PropTypes.number,
	    width: _react2['default'].PropTypes.number,
	    placement: _react2['default'].PropTypes.string,
	    label: _react2['default'].PropTypes.string,
	    markers: _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.shape({
	      x: _react2['default'].PropTypes.number.isRequired,
	      label: _react2['default'].PropTypes.string
	    })),
	    tooltip: _react2['default'].PropTypes.func,
	    barClasses: _react2['default'].PropTypes.array
	  },
	
	  mixins: [(0, _mixinsTooltip2['default'])(function () {
	    var chart = this;
	
	    return {
	      html: true,
	      placement: this.props.placement,
	      selector: '.tip',
	      viewport: this.props.viewport,
	
	      // This callback is fired when the user hovers over the
	      // barchart / triggers tooltip rendering. This is better
	      // than using data-title, which renders up-front for each
	      // StackedBarChart (slow).
	      title: function title(instance) {
	        // `this` is the targeted element
	        var pointIdx = this.getAttribute('data-point-index');
	        var tooltipFunc = chart.props.tooltip || chart.renderTooltip;
	
	        if (pointIdx) return tooltipFunc(chart.props.points[pointIdx], pointIdx, chart);else return this.getAttribute('data-title');
	      }
	    };
	  })],
	
	  statics: {
	    getInterval: function getInterval(points) {
	      return points.length > 1 ? points[1].x - points[0].x : null;
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      className: '',
	      height: null,
	      label: 'events',
	      placement: 'bottom',
	      points: [],
	      markers: [],
	      width: null,
	      barClasses: ['chart-bar'],
	      tooltip: this.renderTooltip
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      interval: StackedBarChart.getInterval(this.props.points)
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.points) {
	      this.setState({
	        interval: StackedBarChart.getInterval(nextProps.points)
	      });
	    }
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !(0, _utils.valueIsEqual)(this.props, nextProps, true);
	  },
	
	  use24Hours: function use24Hours() {
	    var user = _storesConfigStoreJsx2['default'].get('user');
	    var options = user ? user.options : {};
	    return options.clock24Hours;
	  },
	
	  floatFormat: function floatFormat(number, places) {
	    var multi = Math.pow(10, places);
	    return parseInt(number * multi, 10) / multi;
	  },
	
	  timeLabelAsHour: function timeLabelAsHour(point) {
	    var timeMoment = (0, _moment2['default'])(point.x * 1000);
	    var nextMoment = timeMoment.clone().add(59, 'minute');
	    var format = this.use24Hours() ? 'HH:mm' : 'LT';
	
	    return '<span>' + timeMoment.format('LL') + '<br />' + timeMoment.format(format) + '  &#8594; ' + nextMoment.format(format) + '</span>';
	  },
	
	  timeLabelAsDay: function timeLabelAsDay(point) {
	    var timeMoment = (0, _moment2['default'])(point.x * 1000);
	
	    return '<span>' + timeMoment.format('LL') + '</span>';
	  },
	
	  timeLabelAsRange: function timeLabelAsRange(interval, point) {
	    var timeMoment = (0, _moment2['default'])(point.x * 1000);
	    var nextMoment = timeMoment.clone().add(interval - 1, 'second');
	    var format = this.use24Hours() ? 'MMM Do, HH:mm' : 'MMM Do, h:mm a';
	
	    return '<span>' +
	    // e.g. Aug 23rd, 12:50 pm
	    timeMoment.format(format) + ' &#8594 ' + nextMoment.format(format) + '</span>';
	  },
	
	  timeLabelAsFull: function timeLabelAsFull(point) {
	    var timeMoment = (0, _moment2['default'])(point.x * 1000);
	    return timeMoment.format('lll');
	  },
	
	  getTimeLabel: function getTimeLabel(point) {
	    switch (this.state.interval) {
	      case 3600:
	        return this.timeLabelAsHour(point);
	      case 86400:
	        return this.timeLabelAsDay(point);
	      case null:
	        return this.timeLabelAsFull(point);
	      default:
	        return this.timeLabelAsRange(this.state.interval, point);
	    }
	  },
	
	  maxPointValue: function maxPointValue() {
	    var maxval = 10;
	    this.props.points.forEach(function (point) {
	      var totalY = 0;
	      point.y.forEach(function (y) {
	        totalY += y;
	      });
	      if (totalY > maxval) {
	        maxval = totalY;
	      }
	    });
	    return maxval;
	  },
	
	  renderMarker: function renderMarker(marker) {
	    var timeLabel = (0, _moment2['default'])(marker.x * 1000).format('lll');
	    var title = '<div style="width:130px">' + marker.label + '<br/>' + timeLabel + '</div>';
	    var className = 'chart-marker tip ' + (marker.className || '');
	
	    // example key: m-last-seen-22811123, m-first-seen-228191
	    var key = ['m', marker.className, marker.x].join('-');
	
	    return _react2['default'].createElement(
	      'a',
	      { key: key, className: className, 'data-title': title },
	      _react2['default'].createElement(
	        'span',
	        null,
	        marker.label
	      )
	    );
	  },
	
	  renderTooltip: function renderTooltip(point, pointIdx) {
	    var timeLabel = this.getTimeLabel(point);
	    var totalY = 0;
	    for (var i = 0; i < point.y.length; i++) {
	      totalY += point.y[i];
	    }
	    var title = '<div style="width:130px">' + ('<div class="time-label">' + timeLabel + '</div>') + ('<div class="value-label">' + (0, _utils.intcomma)(totalY) + ' ' + this.props.label + '</div>') + '</div>';
	    if (point.label) {
	      title += '<div>(' + point.label + ')</div>';
	    }
	    return title;
	  },
	
	  renderChartColumn: function renderChartColumn(pointIdx, maxval, pointWidth) {
	    var _this = this;
	
	    var point = this.props.points[pointIdx];
	    var totalY = 0;
	    for (var i = 0; i < point.y.length; i++) {
	      totalY += point.y[i];
	    }
	    var totalPct = totalY / maxval;
	    var prevPct = 0;
	    var pts = point.y.map(function (y, i) {
	      var pct = totalY && _this.floatFormat(y / totalY * totalPct * 99, 2);
	      var pt = _react2['default'].createElement(
	        'span',
	        { key: i, className: _this.props.barClasses[i],
	          style: { height: pct + '%', bottom: prevPct + '%' } },
	        y
	      );
	      prevPct += pct;
	      return pt;
	    });
	    return _react2['default'].createElement(
	      'a',
	      { key: point.x,
	        className: 'chart-column tip',
	        'data-point-index': pointIdx,
	        style: { width: pointWidth }
	      },
	      pts
	    );
	  },
	
	  renderChart: function renderChart() {
	    var _this2 = this;
	
	    var points = this.props.points;
	    var pointWidth = this.floatFormat(100.0 / points.length, 2) + '%';
	
	    var maxval = this.maxPointValue();
	
	    var markers = this.props.markers.slice();
	
	    var children = [];
	    points.forEach(function (point, pointIdx) {
	      while (markers.length && markers[0].x <= point.x) {
	        children.push(_this2.renderMarker(markers.shift()));
	      }
	
	      children.push(_this2.renderChartColumn(pointIdx, maxval, pointWidth));
	    });
	
	    // in bizarre case where markers never got rendered, render them last
	    // NOTE: should this ever happen?
	    markers.forEach(function (marker) {
	      children.push(_this2.renderMarker(marker));
	    });
	
	    return children;
	  },
	
	  render: function render() {
	    var figureClass = [this.props.className, 'barchart'].join(' ');
	    var maxval = this.maxPointValue();
	
	    return _react2['default'].createElement(
	      'figure',
	      { className: figureClass, height: this.props.height, width: this.props.width },
	      _react2['default'].createElement(
	        'span',
	        { className: 'max-y' },
	        maxval
	      ),
	      _react2['default'].createElement(
	        'span',
	        { className: 'min-y' },
	        '0'
	      ),
	      _react2['default'].createElement(
	        'span',
	        null,
	        this.renderChart()
	      )
	    );
	  }
	});
	
	exports['default'] = StackedBarChart;
	module.exports = exports['default'];

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var Version = _react2['default'].createClass({
	  displayName: 'Version',
	
	  propTypes: {
	    anchor: _react2['default'].PropTypes.bool,
	    version: _react2['default'].PropTypes.string.isRequired,
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      anchor: true
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	    var version = _props.version;
	
	    var shortVersion = version.match(/^[a-f0-9]{40}$/) ? version.substr(0, 12) : version;
	
	    if (this.props.anchor) {
	      return(
	        // NOTE: version is encoded because it can contain slashes "/",
	        //       which can interfere with URL construction
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: '/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(version) + '/' },
	          _react2['default'].createElement(
	            'span',
	            { title: version },
	            shortVersion
	          )
	        )
	      );
	    }
	    return _react2['default'].createElement(
	      'span',
	      { title: version },
	      shortVersion
	    );
	  }
	});
	
	exports['default'] = Version;
	module.exports = exports['default'];

/***/ },
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.update = update;
	exports.loadStats = loadStats;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _actionsProjectActions = __webpack_require__(264);
	
	var _actionsProjectActions2 = _interopRequireDefault(_actionsProjectActions);
	
	function update(api, params) {
	  _actionsProjectActions2['default'].update(params.projectId, params.data);
	
	  var endpoint = '/projects/' + params.orgId + '/' + params.projectId + '/';
	  api.request(endpoint, {
	    method: 'PUT',
	    data: params.data,
	    success: function success(data) {
	      _actionsProjectActions2['default'].updateSuccess(data);
	    },
	    error: function error(data) {
	      _actionsProjectActions2['default'].updateError(data);
	    }
	  });
	}
	
	function loadStats(api, params) {
	  _actionsProjectActions2['default'].loadStats(params.orgId, params.data);
	
	  var endpoint = '/organizations/' + params.orgId + '/stats/';
	  api.request(endpoint, {
	    query: params.query,
	    success: function success(data) {
	      _actionsProjectActions2['default'].loadStatsSuccess(data);
	    },
	    error: function error(data) {
	      _actionsProjectActions2['default'].loadStatsError(data);
	    }
	  });
	}

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.paramsToQueryArgs = paramsToQueryArgs;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _actionsGroupActions = __webpack_require__(169);
	
	var _actionsGroupActions2 = _interopRequireDefault(_actionsGroupActions);
	
	var _actionsTeamActions = __webpack_require__(266);
	
	var _actionsTeamActions2 = _interopRequireDefault(_actionsTeamActions);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var Request = (function () {
	  function Request(xhr) {
	    _classCallCheck(this, Request);
	
	    this.xhr = xhr;
	    this.alive = true;
	  }
	
	  /**
	   * Converts input parameters to API-compatible query arguments
	   * @param params
	   */
	
	  _createClass(Request, [{
	    key: 'cancel',
	    value: function cancel() {
	      this.alive = false;
	      this.xhr.abort();
	    }
	  }]);
	
	  return Request;
	})();
	
	exports.Request = Request;
	
	function paramsToQueryArgs(params) {
	  return params.itemIds ? { id: params.itemIds } // items matching array of itemids
	  : params.query ? { query: params.query } // items matching search query
	  : undefined; // all items
	}
	
	var Client = (function () {
	  function Client(options) {
	    _classCallCheck(this, Client);
	
	    if (_underscore2['default'].isUndefined(options)) {
	      options = {};
	    }
	    this.baseUrl = options.baseUrl || '/api/0';
	    this.activeRequests = {};
	  }
	
	  _createClass(Client, [{
	    key: 'uniqueId',
	    value: function uniqueId() {
	      var s4 = function s4() {
	        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	      };
	      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	    }
	  }, {
	    key: 'wrapCallback',
	    value: function wrapCallback(id, func, cleanup) {
	      var _this = this;
	
	      /*eslint consistent-return:0*/
	      if (_underscore2['default'].isUndefined(func)) {
	        return;
	      }
	
	      return function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        var req = _this.activeRequests[id];
	        if (cleanup === true) {
	          delete _this.activeRequests[id];
	        }
	        if (req && req.alive) {
	          return func.apply(req, args);
	        }
	      };
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      for (var id in this.activeRequests) {
	        this.activeRequests[id].cancel();
	      }
	    }
	  }, {
	    key: 'request',
	    value: function request(path) {
	      var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var query = _jquery2['default'].param(options.query || '', true);
	      var method = options.method || (options.data ? 'POST' : 'GET');
	      var data = options.data;
	      var id = this.uniqueId();
	
	      if (!_underscore2['default'].isUndefined(data) && method !== 'GET') {
	        data = JSON.stringify(data);
	      }
	
	      var fullUrl = undefined;
	      if (path.indexOf(this.baseUrl) === -1) {
	        fullUrl = this.baseUrl + path;
	      } else {
	        fullUrl = path;
	      }
	      if (query) {
	        if (fullUrl.indexOf('?') !== -1) {
	          fullUrl += '&' + query;
	        } else {
	          fullUrl += '?' + query;
	        }
	      }
	
	      this.activeRequests[id] = new Request(_jquery2['default'].ajax({
	        url: fullUrl,
	        method: method,
	        data: data,
	        contentType: 'application/json',
	        headers: {
	          'Accept': 'application/json; charset=utf-8'
	        },
	        success: this.wrapCallback(id, options.success),
	        error: this.wrapCallback(id, options.error),
	        complete: this.wrapCallback(id, options.complete, true)
	      }));
	
	      return this.activeRequests[id];
	    }
	  }, {
	    key: '_chain',
	    value: function _chain() {
	      for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        funcs[_key2] = arguments[_key2];
	      }
	
	      funcs = funcs.filter(function (f) {
	        return !_underscore2['default'].isUndefined(f) && f;
	      });
	      return function () {
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	          args[_key3] = arguments[_key3];
	        }
	
	        funcs.forEach(function (func) {
	          func.apply(funcs, args);
	        });
	      };
	    }
	  }, {
	    key: '_wrapRequest',
	    value: function _wrapRequest(path, options, extraParams) {
	      if (_underscore2['default'].isUndefined(extraParams)) {
	        extraParams = {};
	      }
	
	      options.success = this._chain(options.success, extraParams.success);
	      options.error = this._chain(options.error, extraParams.error);
	      options.complete = this._chain(options.complete, extraParams.complete);
	
	      return this.request(path, options);
	    }
	  }, {
	    key: 'bulkDelete',
	    value: function bulkDelete(params, options) {
	      var path = '/projects/' + params.orgId + '/' + params.projectId + '/issues/';
	      var query = paramsToQueryArgs(params);
	      var id = this.uniqueId();
	
	      _actionsGroupActions2['default']['delete'](id, params.itemIds);
	
	      return this._wrapRequest(path, {
	        query: query,
	        method: 'DELETE',
	        success: function success(response) {
	          _actionsGroupActions2['default'].deleteSuccess(id, params.itemIds, response);
	        },
	        error: function error(_error) {
	          _actionsGroupActions2['default'].deleteError(id, params.itemIds, _error);
	        }
	      }, options);
	    }
	  }, {
	    key: 'bulkUpdate',
	    value: function bulkUpdate(params, options) {
	      var path = '/projects/' + params.orgId + '/' + params.projectId + '/issues/';
	      var query = paramsToQueryArgs(params);
	      var id = this.uniqueId();
	
	      _actionsGroupActions2['default'].update(id, params.itemIds, params.data);
	
	      return this._wrapRequest(path, {
	        query: query,
	        method: 'PUT',
	        data: params.data,
	        success: function success(response) {
	          _actionsGroupActions2['default'].updateSuccess(id, params.itemIds, response);
	        },
	        error: function error(_error2) {
	          _actionsGroupActions2['default'].updateError(id, params.itemIds, _error2, params.failSilently);
	        }
	      }, options);
	    }
	  }, {
	    key: 'merge',
	    value: function merge(params, options) {
	      var path = '/projects/' + params.orgId + '/' + params.projectId + '/issues/';
	      var query = paramsToQueryArgs(params);
	      var id = this.uniqueId();
	
	      _actionsGroupActions2['default'].merge(id, params.itemIds);
	
	      return this._wrapRequest(path, {
	        query: query,
	        method: 'PUT',
	        data: { merge: 1 },
	        success: function success(response) {
	          _actionsGroupActions2['default'].mergeSuccess(id, params.itemIds, response);
	        },
	        error: function error(_error3) {
	          _actionsGroupActions2['default'].mergeError(id, params.itemIds, _error3);
	        }
	      }, options);
	    }
	  }, {
	    key: 'assignTo',
	    value: function assignTo(params, options) {
	      var path = '/issues/' + params.id + '/';
	      var id = this.uniqueId();
	
	      _actionsGroupActions2['default'].assignTo(id, params.id, { email: params.member && params.member.email || '' });
	
	      return this._wrapRequest(path, {
	        method: 'PUT',
	        // Sending an empty value to assignedTo is the same as "clear",
	        // so if no member exists, that implies that we want to clear the
	        // current assignee.
	        data: { assignedTo: params.member && params.member.id || '' },
	        success: function success(response) {
	          _actionsGroupActions2['default'].assignToSuccess(id, params.id, response);
	        },
	        error: function error(_error4) {
	          _actionsGroupActions2['default'].assignToError(id, params.id, _error4);
	        }
	      }, options);
	    }
	  }, {
	    key: 'joinTeam',
	    value: function joinTeam(params, options) {
	      var path = '/organizations/' + params.orgId + '/members/' + (params.memberId || 'me') + '/teams/' + params.teamId + '/';
	      var id = this.uniqueId();
	
	      _actionsTeamActions2['default'].update(id, params.teamId);
	
	      return this._wrapRequest(path, {
	        method: 'POST',
	        success: function success(response) {
	          _actionsTeamActions2['default'].updateSuccess(id, params.teamId, response);
	        },
	        error: function error(_error5) {
	          _actionsTeamActions2['default'].updateError(id, params.teamId, _error5);
	        }
	      }, options);
	    }
	  }, {
	    key: 'leaveTeam',
	    value: function leaveTeam(params, options) {
	      var path = '/organizations/' + params.orgId + '/members/' + (params.memberId || 'me') + '/teams/' + params.teamId + '/';
	      var id = this.uniqueId();
	
	      _actionsTeamActions2['default'].update(id, params.teamId);
	
	      return this._wrapRequest(path, {
	        method: 'DELETE',
	        success: function success(response) {
	          _actionsTeamActions2['default'].updateSuccess(id, params.teamId, response);
	        },
	        error: function error(_error6) {
	          _actionsTeamActions2['default'].updateError(id, params.teamId, _error6);
	        }
	      }, options);
	    }
	  }]);
	
	  return Client;
	})();

	exports.Client = Client;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsStackedBarChart = __webpack_require__(106);
	
	var _componentsStackedBarChart2 = _interopRequireDefault(_componentsStackedBarChart);
	
	var BarChart = _react2['default'].createClass({
	  displayName: 'BarChart',
	
	  propTypes: {
	    points: _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.shape({
	      x: _react2['default'].PropTypes.number.isRequired,
	      y: _react2['default'].PropTypes.number.isRequired,
	      label: _react2['default'].PropTypes.string
	    })),
	    interval: _react2['default'].PropTypes.string,
	    height: _react2['default'].PropTypes.number,
	    width: _react2['default'].PropTypes.number,
	    placement: _react2['default'].PropTypes.string,
	    label: _react2['default'].PropTypes.string,
	    markers: _react2['default'].PropTypes.arrayOf(_react2['default'].PropTypes.shape({
	      x: _react2['default'].PropTypes.number.isRequired,
	      label: _react2['default'].PropTypes.string
	    }))
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      points: []
	    };
	  },
	
	  render: function render() {
	    var points = this.props.points.map(function (point) {
	      return { x: point.x, y: [point.y] };
	    });
	    var props = Object.assign({}, this.props, { points: points });
	    return _react2['default'].createElement(_componentsStackedBarChart2['default'], props);
	  }
	
	});
	
	exports['default'] = BarChart;
	module.exports = exports['default'];

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _interfacesKeyValueList = __webpack_require__(81);
	
	var _interfacesKeyValueList2 = _interopRequireDefault(_interfacesKeyValueList);
	
	var _utils = __webpack_require__(7);
	
	var ContextBlock = _react2['default'].createClass({
	  displayName: 'ContextBlock',
	
	  propTypes: {
	    alias: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired,
	    knownData: _react2['default'].PropTypes.array
	  },
	
	  render: function render() {
	    var data = [];
	    var className = 'context-block context-block-' + this.props.data.type;
	
	    (this.props.knownData || []).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var key = _ref2[0];
	      var value = _ref2[1];
	
	      var allowSkip = false;
	      if (key[0] === '?') {
	        allowSkip = true;
	        key = key.substr(1);
	      }
	      if (!(0, _utils.defined)(value)) {
	        if (allowSkip) {
	          return;
	        }
	        value = 'n/a';
	      }
	      data.push([key, value]);
	    });
	
	    var extraData = [];
	    for (var key in this.props.data) {
	      if (key !== 'type' && key !== 'title') {
	        extraData.push([key, this.props.data[key]]);
	      }
	    }
	
	    if (extraData.length > 0) {
	      data = data.concat(_underscore2['default'].sortBy(extraData, function (key, value) {
	        return key;
	      }));
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: className },
	      _react2['default'].createElement(_interfacesKeyValueList2['default'], { data: data, isSorted: false })
	    );
	  }
	});
	
	exports['default'] = ContextBlock;
	module.exports = exports['default'];

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.trimPackage = trimPackage;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentsClippedBox = __webpack_require__(172);
	
	var _componentsClippedBox2 = _interopRequireDefault(_componentsClippedBox);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _strictClick = __webpack_require__(605);
	
	var _strictClick2 = _interopRequireDefault(_strictClick);
	
	var _componentsTruncate = __webpack_require__(298);
	
	var _componentsTruncate2 = _interopRequireDefault(_componentsTruncate);
	
	var _locale = __webpack_require__(2);
	
	var _utils = __webpack_require__(7);
	
	var _contextLine = __webpack_require__(566);
	
	var _contextLine2 = _interopRequireDefault(_contextLine);
	
	var _frameVariables = __webpack_require__(573);
	
	var _frameVariables2 = _interopRequireDefault(_frameVariables);
	
	function trimPackage(pkg) {
	  var pieces = pkg.split(/\//g);
	  var rv = pieces[pieces.length - 1] || pieces[pieces.length - 2] || pkg;
	  var match = rv.match(/^(.*?)\.(dylib|so|a)$/);
	  return match && match[1] || rv;
	}
	
	var Frame = _react2['default'].createClass({
	  displayName: 'Frame',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired,
	    nextFrameInApp: _react2['default'].PropTypes.bool,
	    platform: _react2['default'].PropTypes.string,
	    isExpanded: _react2['default'].PropTypes.bool,
	    emptySourceNotation: _react2['default'].PropTypes.bool,
	    isOnlyFrame: _react2['default'].PropTypes.bool,
	    timesRepeated: _react2['default'].PropTypes.number
	  },
	
	  mixins: [(0, _mixinsTooltip2['default'])({
	    html: true,
	    selector: '.tip',
	    trigger: 'hover'
	  })],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      isExpanded: false,
	      emptySourceNotation: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    // isExpanded can be initialized to true via parent component;
	    // data synchronization is not important
	    // https://facebook.github.io/react/tips/props-in-getInitialState-as-anti-pattern.html
	    return {
	      isExpanded: this.props.isExpanded
	    };
	  },
	
	  toggleContext: function toggleContext(evt) {
	    evt && evt.preventDefault();
	
	    this.setState({
	      isExpanded: !this.state.isExpanded
	    });
	  },
	
	  hasContextSource: function hasContextSource() {
	    return (0, _utils.defined)(this.props.data.context) && this.props.data.context.length;
	  },
	
	  hasContextVars: function hasContextVars() {
	    return !(0, _utils.objectIsEmpty)(this.props.data.vars);
	  },
	
	  isExpandable: function isExpandable() {
	    return !this.props.isOnlyFrame && this.props.emptySourceNotation || this.hasContextSource() || this.hasContextVars();
	  },
	
	  renderOriginalSourceInfo: function renderOriginalSourceInfo() {
	    var data = this.props.data;
	
	    var sourceMapText = (0, _locale.t)('Source Map');
	
	    var out = '\n    <div>\n      <strong>' + sourceMapText + '</strong><br/>';
	
	    // mapUrl not always present; e.g. uploaded source maps
	    if (data.mapUrl) out += _underscore2['default'].escape(data.mapUrl) + '<br/>';else out += _underscore2['default'].escape(data.map) + '<br/>';
	
	    out += '</div>';
	
	    return out;
	  },
	
	  getPlatform: function getPlatform() {
	    // prioritize the frame platform but fall back to the platform
	    // of the stacktrace / exception
	    return this.props.data.platform || this.props.platform;
	  },
	
	  shouldPrioritizeModuleName: function shouldPrioritizeModuleName() {
	    switch (this.getPlatform()) {
	      case 'java':
	      case 'csharp':
	        return true;
	      default:
	        return false;
	    }
	  },
	
	  preventCollapse: function preventCollapse(evt) {
	    evt.stopPropagation();
	  },
	
	  renderDefaultTitle: function renderDefaultTitle() {
	    var data = this.props.data;
	    var title = [];
	
	    // TODO(dcramer): this needs to use a formatted string so it can be
	    // localized correctly
	
	    if ((0, _utils.defined)(data.filename || data.module)) {
	      // prioritize module name for Java as filename is often only basename
	      var shouldPrioritizeModuleName = this.shouldPrioritizeModuleName();
	      var pathName = shouldPrioritizeModuleName ? data.module || data.filename : data.filename || data.module;
	
	      title.push(_react2['default'].createElement(
	        'code',
	        { key: 'filename', className: 'filename' },
	        _react2['default'].createElement(_componentsTruncate2['default'], { value: pathName, maxLength: 100, leftTrim: true })
	      ));
	
	      // in case we prioritized the module name but we also have a filename info
	      // we want to show a litle (?) icon that on hover shows the actual filename
	      if (shouldPrioritizeModuleName && data.filename) {
	        title.push(_react2['default'].createElement(
	          'a',
	          { key: 'real-filename', className: 'in-at tip real-filename', 'data-title': _underscore2['default'].escape(data.filename) },
	          _react2['default'].createElement('span', { className: 'icon-question' })
	        ));
	      }
	
	      if ((0, _utils.isUrl)(data.absPath)) {
	        title.push(_react2['default'].createElement('a', { href: data.absPath, className: 'icon-open', key: 'share', target: '_blank', onClick: this.preventCollapse }));
	      }
	      if ((0, _utils.defined)(data['function'])) {
	        title.push(_react2['default'].createElement(
	          'span',
	          { className: 'in-at', key: 'in' },
	          ' in '
	        ));
	      }
	    }
	
	    if ((0, _utils.defined)(data['function'])) {
	      title.push(_react2['default'].createElement(
	        'code',
	        { key: 'function', className: 'function' },
	        data['function']
	      ));
	    }
	
	    // we don't want to render out zero line numbers which are used to
	    // indicate lack of source information for native setups.  We could
	    // TODO(mitsuhiko): only do this for events from native platforms?
	    if ((0, _utils.defined)(data.lineNo) && data.lineNo != 0) {
	      title.push(_react2['default'].createElement(
	        'span',
	        { className: 'in-at in-at-line', key: 'no' },
	        ' at line '
	      ));
	      title.push(_react2['default'].createElement(
	        'code',
	        { key: 'line', className: 'lineno' },
	        (0, _utils.defined)(data.colNo) ? data.lineNo + ':' + data.colNo : data.lineNo
	      ));
	    }
	
	    if ((0, _utils.defined)(data['package'])) {
	      title.push(_react2['default'].createElement(
	        'span',
	        { className: 'within', key: 'within' },
	        ' within '
	      ));
	      title.push(_react2['default'].createElement(
	        'code',
	        { title: data['package'], className: 'package', key: 'package' },
	        trimPackage(data['package'])
	      ));
	    }
	
	    if ((0, _utils.defined)(data.origAbsPath)) {
	      title.push(_react2['default'].createElement(
	        'a',
	        { key: 'original-src', className: 'in-at tip original-src', 'data-title': this.renderOriginalSourceInfo() },
	        _react2['default'].createElement('span', { className: 'icon-question' })
	      ));
	    }
	
	    title.push(this.renderExpander());
	
	    return title;
	  },
	
	  renderContext: function renderContext() {
	    var data = this.props.data;
	    var context = '';
	    var isExpanded = this.state.isExpanded;
	
	    var outerClassName = 'context';
	    if (isExpanded) {
	      outerClassName += ' expanded';
	    }
	
	    var hasContextSource = this.hasContextSource();
	    var hasContextVars = this.hasContextVars();
	    var expandable = this.isExpandable();
	
	    var contextLines = isExpanded ? data.context : data.context && data.context.filter(function (l) {
	      return l[0] === data.lineNo;
	    });
	
	    if (hasContextSource || hasContextVars) {
	      var startLineNo = hasContextSource ? data.context[0][0] : '';
	      context = _react2['default'].createElement(
	        'ol',
	        { start: startLineNo, className: outerClassName },
	        (0, _utils.defined)(data.errors) && _react2['default'].createElement(
	          'li',
	          { className: expandable ? 'expandable error' : 'error',
	            key: 'errors' },
	          data.errors.join(', ')
	        ),
	        data.context && contextLines.map(function (line, index) {
	          return _react2['default'].createElement(_contextLine2['default'], { key: index, line: line, isActive: data.lineNo === line[0] });
	        }),
	        hasContextVars && _react2['default'].createElement(
	          _componentsClippedBox2['default'],
	          { clipHeight: 100 },
	          _react2['default'].createElement(_frameVariables2['default'], { data: data.vars, key: 'vars' })
	        )
	      );
	    } else if (this.props.emptySourceNotation) {
	      context = _react2['default'].createElement(
	        'div',
	        { className: 'empty-context' },
	        _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	        _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.t)('No additional details are available for this frame.')
	        )
	      );
	    }
	    return context;
	  },
	
	  renderExpander: function renderExpander() {
	    if (!this.isExpandable()) {
	      return null;
	    }
	    return _react2['default'].createElement(
	      'a',
	      {
	        key: 'expander',
	        title: (0, _locale.t)('Toggle context'),
	        onClick: this.toggleContext,
	        className: 'btn btn-sm btn-default btn-toggle' },
	      _react2['default'].createElement('span', { className: this.state.isExpanded ? 'icon-minus' : 'icon-plus' })
	    );
	  },
	
	  leadsToApp: function leadsToApp() {
	    return !this.props.data.inApp && this.props.nextFrameInApp;
	  },
	
	  renderLeadHint: function renderLeadHint() {
	    if (this.leadsToApp() && !this.state.isExpanded) {
	      return _react2['default'].createElement(
	        'span',
	        { className: 'leads-to-app-hint' },
	        'Called from: '
	      );
	    } else return null;
	  },
	
	  renderRepeats: function renderRepeats() {
	    if (this.props.timesRepeated > 0) {
	      return _react2['default'].createElement(
	        'span',
	        { className: 'repeated-frames',
	          title: 'Frame repeated ' + this.props.timesRepeated + ' times' },
	        _react2['default'].createElement('span', { className: 'icon-refresh' }),
	        _react2['default'].createElement(
	          'span',
	          null,
	          this.props.timesRepeated
	        )
	      );
	    } else return null;
	  },
	
	  renderDefaultLine: function renderDefaultLine() {
	    return _react2['default'].createElement(
	      _strictClick2['default'],
	      { onClick: this.isExpandable() ? this.toggleContext : null },
	      _react2['default'].createElement(
	        'div',
	        { className: 'title' },
	        this.renderLeadHint(),
	        this.renderDefaultTitle(),
	        this.renderRepeats()
	      )
	    );
	  },
	
	  renderCocoaLine: function renderCocoaLine() {
	    var data = this.props.data;
	    return _react2['default'].createElement(
	      _strictClick2['default'],
	      { onClick: this.isExpandable() ? this.toggleContext : null },
	      _react2['default'].createElement(
	        'div',
	        { className: 'title as-table' },
	        this.renderLeadHint(),
	        (0, _utils.defined)(data['package']) ? _react2['default'].createElement(
	          'span',
	          { className: 'package', title: data['package'] },
	          trimPackage(data['package'])
	        ) : _react2['default'].createElement('span', { className: 'package' }),
	        _react2['default'].createElement(
	          'span',
	          { className: 'address' },
	          data.instructionAddr
	        ),
	        _react2['default'].createElement(
	          'span',
	          { className: 'symbol' },
	          _react2['default'].createElement(
	            'code',
	            null,
	            data['function'] || '<unknown>'
	          ),
	          data.instructionOffset && _react2['default'].createElement(
	            'span',
	            { className: 'offset' },
	            ' + ' + data.instructionOffset
	          ),
	          data.filename && _react2['default'].createElement(
	            'span',
	            { className: 'filename' },
	            data.filename,
	            data.lineNo ? ':' + data.lineNo : ''
	          ),
	          this.renderExpander()
	        )
	      )
	    );
	  },
	
	  renderLine: function renderLine() {
	    switch (this.getPlatform()) {
	      case 'objc':
	      case 'cocoa':
	        return this.renderCocoaLine();
	      default:
	        return this.renderDefaultLine();
	    }
	  },
	
	  render: function render() {
	    var data = this.props.data;
	    var className = (0, _classnames2['default'])({
	      'frame': true,
	      'is-expandable': this.isExpandable(),
	      'expanded': this.state.isExpanded,
	      'collapsed': !this.state.isExpanded,
	      'system-frame': !data.inApp,
	      'frame-errors': data.errors,
	      'leads-to-app': this.leadsToApp()
	    });
	    var props = { className: className };
	
	    var context = this.renderContext();
	
	    return _react2['default'].createElement(
	      'li',
	      props,
	      this.renderLine(),
	      context
	    );
	  }
	});
	
	exports['default'] = Frame;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	// we need flot and the various plugins
	__webpack_require__(414);
	__webpack_require__(415);
	__webpack_require__(416);
	__webpack_require__(413);
	
	var timeUnitSize = {
	  'second': 1000,
	  'minute': 60 * 1000,
	  'hour': 60 * 60 * 1000,
	  'day': 24 * 60 * 60 * 1000,
	  'month': 30 * 24 * 60 * 60 * 1000,
	  'quarter': 3 * 30 * 24 * 60 * 60 * 1000,
	  'year': 365.2425 * 24 * 60 * 60 * 1000
	};
	
	var numberWithCommas = function numberWithCommas(x) {
	  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};
	
	var buildTooltipHandler = function buildTooltipHandler(series) {
	  return function (_l, xval, _y, flotItem) {
	    var yval = undefined;
	    var content = '<h6>' + (0, _moment2['default'])(parseInt(xval, 10)).format('MMMM D YYYY HH:mm z') + '</h6>';
	    for (var i = 0; i < series.length; i++) {
	      // we're assuming series are identical
	      yval = numberWithCommas(series[i].data[flotItem.dataIndex][1] || 0);
	      content += '<strong style="color:' + series[i].color + '">' + series[i].label + ':</strong> ' + yval + '<br>';
	    }
	    return content;
	  };
	};
	
	var tickFormatter = function tickFormatter(value, axis) {
	  var d = (0, _moment2['default'])(parseInt(value, 10));
	
	  var t = axis.tickSize[0] * timeUnitSize[axis.tickSize[1]];
	  var span = axis.max - axis.min;
	  var fmt = undefined;
	
	  if (t < timeUnitSize.minute) {
	    fmt = 'LT';
	  } else if (t < timeUnitSize.day) {
	    fmt = 'LT';
	    if (span < 2 * timeUnitSize.day) {
	      fmt = 'LT';
	    } else {
	      fmt = 'MMM D LT';
	    }
	  } else if (t < timeUnitSize.month) {
	    fmt = 'MMM D';
	  } else if (t < timeUnitSize.year) {
	    if (span < timeUnitSize.year) {
	      fmt = 'MMM';
	    } else {
	      fmt = 'MMM YY';
	    }
	  } else {
	    fmt = 'YY';
	  }
	
	  return d.format(fmt);
	};
	
	var FlotChart = _react2['default'].createClass({
	  displayName: 'FlotChart',
	
	  propTypes: {
	    plotData: _react2['default'].PropTypes.array,
	    style: _react2['default'].PropTypes.object
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.renderChart();
	    (0, _jquery2['default'])(window).resize(this.renderChart);
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    // TODO(dcramer): improve logic here
	    return nextProps.plotData.length > 0;
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.renderChart();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    (0, _jquery2['default'])(window).unbind('resize', this.renderChart);
	  },
	
	  renderChart: function renderChart(options) {
	    var series = this.props.plotData;
	    var plotOptions = {
	      xaxis: {
	        mode: 'time',
	        minTickSize: [1, 'day'],
	        tickFormatter: tickFormatter
	      },
	      yaxis: {
	        min: 0,
	        minTickSize: 1,
	        tickFormatter: function tickFormatter(value) {
	          if (value > 999999) {
	            return value / 1000000 + 'mm';
	          }
	          if (value > 999) {
	            return value / 1000 + 'k';
	          }
	          return value;
	        }
	      },
	      tooltip: true,
	      tooltipOpts: {
	        content: buildTooltipHandler(series),
	        defaultTheme: false
	      },
	      grid: {
	        show: true,
	        hoverable: true,
	        backgroundColor: '#ffffff',
	        borderColor: '#DEE3E9',
	        borderWidth: 2,
	        tickColor: '#DEE3E9'
	      },
	      hoverable: false,
	      legend: {
	        noColumns: series.length,
	        position: 'nw'
	      },
	      lines: { show: false }
	    };
	
	    var chart = _reactDom2['default'].findDOMNode(this.refs.chartNode);
	    _jquery2['default'].plot(chart, series, plotOptions);
	  },
	
	  render: function render() {
	    return _react2['default'].createElement('figure', {
	      className: this.props.className || 'chart',
	      style: this.props.style,
	      ref: 'chartNode' });
	  }
	});
	
	exports['default'] = FlotChart;
	module.exports = exports['default'];

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(8);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsProjectLabel = __webpack_require__(292);
	
	var _componentsProjectLabel2 = _interopRequireDefault(_componentsProjectLabel);
	
	var _dropdownLink = __webpack_require__(33);
	
	var _dropdownLink2 = _interopRequireDefault(_dropdownLink);
	
	var _menuItem = __webpack_require__(37);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _link = __webpack_require__(182);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _utils = __webpack_require__(7);
	
	var _locale = __webpack_require__(2);
	
	var ProjectSelector = _react2['default'].createClass({
	  displayName: 'ProjectSelector',
	
	  propTypes: {
	    // Accepts a project id (slug) and not a project *object* because ProjectSelector
	    // is created from Django templates, and only organization is serialized
	    projectId: _react2['default'].PropTypes.string,
	    organization: _react2['default'].PropTypes.object.isRequired
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      projectId: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return _extends({
	      filter: '',
	      currentIndex: -1
	    }, this.getProjectState({ filter: '' }));
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    // XXX(dcramer): fix odd dedraw issue as of Chrome 45.0.2454.15 dev (64-bit)
	    var node = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this.refs.container));
	    node.hide().show(0);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.filterBlurTimeout) {
	      clearTimeout(this.filterBlurTimeout);
	    }
	  },
	
	  onFilterChange: function onFilterChange(evt) {
	    this.setState(_extends({
	      filter: evt.target.value,
	      currentIndex: -1
	    }, this.getProjectState({ filter: evt.target.value })));
	  },
	
	  onKeyUp: function onKeyUp(evt) {
	    if (evt.key === 'Escape' || evt.keyCode === 27) {
	      // blur handler should additionally hide dropdown
	      this.close();
	    }
	  },
	
	  onFilterBlur: function onFilterBlur() {
	    var _this = this;
	
	    // HACK: setTimeout because blur might be caused by clicking
	    // project link; in which case, will close dropdown before
	    // link click is processed. Why 200ms? Decently short time
	    // period that seemed to work in all browsers.
	    this.filterBlurTimeout = setTimeout(function () {
	      _this.filterBlurTimeout = null;
	      _this.close();
	    }, 200);
	  },
	
	  close: function close() {
	    this.setState(_extends({
	      filter: '',
	      currentIndex: -1
	    }, this.getProjectState({ filter: '' })));
	    // dropdownLink might not exist because we try to close within
	    // onFilterBlur above after a timeout. My hunch is that sometimes
	    // this DOM element is removed within the 200ms, so we error out.
	    this.refs.dropdownLink && this.refs.dropdownLink.close();
	  },
	
	  getProjectNode: function getProjectNode(team, project, highlightText, hasSingleTeam, isSelected) {
	    var projectId = project.slug;
	    var label = this.getProjectLabel(team, project, hasSingleTeam, highlightText);
	
	    var menuItemProps = _extends({
	      key: projectId, // TODO: what if two projects w/ same name under diff orgs?
	      linkClassName: projectId == this.props.projectId ? 'active' : '',
	      className: isSelected ? 'project-selected' : ''
	
	    }, this.getProjectUrlProps(project));
	
	    return _react2['default'].createElement(
	      _menuItem2['default'],
	      menuItemProps,
	      project.isBookmarked && _react2['default'].createElement('span', { className: 'icon-star-solid bookmark ' }),
	      label
	    );
	  },
	
	  getProjectLabel: function getProjectLabel(team, project, hasSingleTeam, highlightText) {
	    var label = undefined,
	        text = undefined;
	    if (!hasSingleTeam && project.name.indexOf(team.name) === -1) {
	      label = _react2['default'].createElement(
	        'span',
	        null,
	        team.name,
	        ' / ',
	        _react2['default'].createElement(_componentsProjectLabel2['default'], {
	          project: project, organization: this.props.organization })
	      );
	      text = team.name + ' / ' + project.name;
	    } else {
	      label = _react2['default'].createElement(
	        'span',
	        null,
	        project.name
	      );
	      text = project.name;
	    }
	
	    if (!highlightText) {
	      return label;
	    }
	
	    // in case we have something to highlight we just render a replacement
	    // selector without the callsigns.
	    // TODO(mitsuhiko): make this work with the project label.
	    highlightText = highlightText.toLowerCase();
	    var idx = text.toLowerCase().indexOf(highlightText);
	    if (idx === -1) {
	      return text;
	    }
	    return _react2['default'].createElement(
	      'span',
	      null,
	      text.substr(0, idx),
	      _react2['default'].createElement(
	        'strong',
	        { className: 'highlight' },
	        text.substr(idx, highlightText.length)
	      ),
	      text.substr(idx + highlightText.length)
	    );
	  },
	
	  /**
	   * Returns an object with the target project url. If
	   * the router is present, passed as the 'to' property.
	   * If not, passed as an absolute URL via the 'href' property.
	   */
	  getProjectUrlProps: function getProjectUrlProps(project) {
	    var org = this.props.organization;
	    var path = '/' + org.slug + '/' + project.slug + '/';
	
	    if (this.context.location) {
	      return { to: path };
	    } else {
	      return { href: path };
	    }
	  },
	
	  getLinkNode: function getLinkNode(team, project) {
	    var org = this.props.organization;
	    var label = this.getProjectLabel(team, project);
	
	    if (!this.context.location) {
	      return _react2['default'].createElement(
	        'a',
	        this.getProjectUrlProps(project),
	        label
	      );
	    }
	
	    var orgId = org.slug;
	    var projectId = project.slug;
	
	    return _react2['default'].createElement(
	      'span',
	      null,
	      _react2['default'].createElement(
	        _link2['default'],
	        { to: '/' + orgId + '/' + projectId + '/' },
	        label
	      )
	    );
	  },
	
	  onOpen: function onOpen(evt) {
	    _reactDom2['default'].findDOMNode(this.refs.filter).focus();
	  },
	
	  onClose: function onClose() {
	    this.setState(_extends({
	      filter: '',
	      currentIndex: -1
	    }, this.getProjectState({ filter: '' })));
	  },
	
	  onKeyDown: function onKeyDown(evt) {
	    var projects = this.state.projectList;
	    if (evt.key === 'Down' || evt.keyCode === 40) {
	      if (this.state.currentIndex + 1 < projects.length) {
	        this.setState({
	          currentIndex: this.state.currentIndex + 1
	        });
	      }
	    } else if (evt.key === 'Up' || evt.keyCode === 38) {
	      if (this.state.currentIndex > 0) {
	        this.setState({
	          currentIndex: this.state.currentIndex - 1
	        });
	      }
	    } else if (evt.key === 'Enter' || evt.keyCode === 13) {
	      if (this.state.currentIndex > -1) {
	        var url = this.getProjectUrlProps(projects[this.state.currentIndex][1]);
	        if (url.to) {
	          _reactRouter.browserHistory.pushState(null, url.to);
	        } else if (url.href) {
	          window.location = url.href;
	        }
	      }
	    }
	  },
	
	  getProjectState: function getProjectState(state) {
	    var _this2 = this;
	
	    state = state || this.state;
	    var org = this.props.organization;
	    var filter = state.filter.toLowerCase();
	    var projectList = [];
	    var activeTeam = undefined;
	    var activeProject = undefined;
	    org.teams.forEach(function (team) {
	      if (!team.isMember) {
	        return;
	      }
	      team.projects.forEach(function (project) {
	        if (project.slug == _this2.props.projectId) {
	          activeProject = project;
	          activeTeam = team;
	        }
	        var fullName = [team.name, project.name, team.slug, project.slug].join(' ').toLowerCase();
	        if (filter && fullName.indexOf(filter) === -1) {
	          return;
	        }
	        projectList.push([team, project]);
	      });
	    });
	    return {
	      projectList: projectList,
	      activeTeam: activeTeam,
	      activeProject: activeProject
	    };
	  },
	
	  render: function render() {
	    var _this3 = this;
	
	    var org = this.props.organization;
	    var hasSingleTeam = org.teams.length === 1;
	
	    var projectList = (0, _utils.sortArray)(this.state.projectList, function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var team = _ref2[0];
	      var project = _ref2[1];
	
	      return [!project.isBookmarked, team.name, project.name];
	    });
	
	    var children = projectList.map(function (_ref3, index) {
	      var _ref32 = _slicedToArray(_ref3, 2);
	
	      var team = _ref32[0];
	      var project = _ref32[1];
	
	      return _this3.getProjectNode(team, project, _this3.state.filter, hasSingleTeam, _this3.state.currentIndex === index);
	    });
	    return _react2['default'].createElement(
	      'div',
	      { className: 'project-select', ref: 'container' },
	      _react2['default'].createElement(
	        'h3',
	        null,
	        _react2['default'].createElement(
	          _link2['default'],
	          { to: '/' + org.slug + '/', className: 'home-crumb' },
	          _react2['default'].createElement('span', { className: 'icon-home' })
	        ),
	        this.state.activeProject ? this.getLinkNode(this.state.activeTeam, this.state.activeProject) : (0, _locale.t)('Select a project'),
	        _react2['default'].createElement(
	          _dropdownLink2['default'],
	          { ref: 'dropdownLink', title: '', topLevelClasses: 'project-dropdown',
	            onOpen: this.onOpen, onClose: this.onClose },
	          _react2['default'].createElement(
	            'li',
	            { className: 'project-filter', key: '_filter' },
	            _react2['default'].createElement('input', {
	              value: this.state.filter,
	              type: 'text',
	              placeholder: (0, _locale.t)('Filter projects'),
	              onChange: this.onFilterChange,
	              onKeyUp: this.onKeyUp,
	              onKeyDown: this.onKeyDown,
	              onBlur: this.onFilterBlur,
	              ref: 'filter' })
	          ),
	          children
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectSelector;
	module.exports = exports['default'];
	// When router is available, use `to` property. Otherwise, use href
	// property. For example - when project selector is loaded on
	// Django-powered Settings pages.

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _actionCreatorsIncidents = __webpack_require__(535);
	
	var _broadcasts = __webpack_require__(600);
	
	var _broadcasts2 = _interopRequireDefault(_broadcasts);
	
	var _incidents = __webpack_require__(601);
	
	var _incidents2 = _interopRequireDefault(_incidents);
	
	var _userNav = __webpack_require__(603);
	
	var _userNav2 = _interopRequireDefault(_userNav);
	
	var _requiredAdminActions = __webpack_require__(293);
	
	var _requiredAdminActions2 = _interopRequireDefault(_requiredAdminActions);
	
	var _organizationSelector = __webpack_require__(602);
	
	var _organizationSelector2 = _interopRequireDefault(_organizationSelector);
	
	var _sidebarPanel = __webpack_require__(138);
	
	var _sidebarPanel2 = _interopRequireDefault(_sidebarPanel);
	
	var _todos = __webpack_require__(191);
	
	var _todos2 = _interopRequireDefault(_todos);
	
	var _issueList = __webpack_require__(181);
	
	var _issueList2 = _interopRequireDefault(_issueList);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _locale = __webpack_require__(2);
	
	var OnboardingStatus = _react2['default'].createClass({
	  displayName: 'OnboardingStatus',
	
	  propTypes: {
	    org: _react2['default'].PropTypes.object.isRequired,
	    currentPanel: _react2['default'].PropTypes.string,
	    onShowPanel: _react2['default'].PropTypes.func,
	    showPanel: _react2['default'].PropTypes.bool,
	    hidePanel: _react2['default'].PropTypes.func
	  },
	
	  render: function render() {
	    var org = this.props.org;
	    if (org.features.indexOf('onboarding') === -1) return null;
	
	    var percentage = Math.round((org.onboardingTasks || []).filter(function (task) {
	      return task.status === 'complete' || task.status === 'skipped';
	    }).length / _todos2['default'].TASKS.length * 100).toString();
	    var style = {
	      height: percentage + '%'
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      { className: this.props.currentPanel == 'todos' ? 'onboarding active' : 'onboarding' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'onboarding-progress-bar', onClick: this.props.onShowPanel },
	        _react2['default'].createElement('div', { className: 'slider', style: style })
	      ),
	      this.props.showPanel && this.props.currentPanel == 'todos' && _react2['default'].createElement(
	        _sidebarPanel2['default'],
	        {
	          title: 'Getting Started with Sentry',
	          hidePanel: this.props.hidePanel },
	        _react2['default'].createElement(_todos2['default'], null)
	      )
	    );
	  }
	});
	
	function getFirstRequiredAdminAction(org) {
	  for (var key in _requiredAdminActions2['default']) {
	    var action = _requiredAdminActions2['default'][key];
	    if (action.requiresAction(org)) {
	      return action;
	    }
	  }
	  return null;
	}
	
	var Sidebar = _react2['default'].createClass({
	  displayName: 'Sidebar',
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      showTodos: location.hash === '#welcome'
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    (0, _jquery2['default'])(window).on('hashchange', this.hashChangeHandler);
	    (0, _jquery2['default'])(document).on('click', this.documentClickHandler);
	
	    (0, _actionCreatorsIncidents.load)();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
	    var location = this.context.location;
	
	    var nextLocation = nextContext.location;
	
	    // Close active panel if we navigated anywhere
	    if (location.pathname != nextLocation.pathname) {
	      this.hidePanel();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    (0, _jquery2['default'])(window).off('hashchange', this.hashChangeHandler);
	    (0, _jquery2['default'])(document).off('click', this.documentClickHandler);
	  },
	
	  documentClickHandler: function documentClickHandler(evt) {
	    // If click occurs outside of sidebar, close any
	    // active panel
	    if (!this.refs.navbar.contains(evt.target)) {
	      this.hidePanel();
	    }
	  },
	
	  hashChangeHandler: function hashChangeHandler() {
	    if (location.hash == '#welcome') {
	      this.setState({ showTodos: true });
	    }
	  },
	
	  toggleTodos: function toggleTodos(e) {
	    this.setState({ showTodos: !this.state.showTodos });
	  },
	
	  hidePanel: function hidePanel() {
	    this.setState({
	      showPanel: false,
	      currentPanel: ''
	    });
	  },
	
	  showPanel: function showPanel(panel) {
	    this.setState({
	      showPanel: true,
	      currentPanel: panel
	    });
	  },
	
	  togglePanel: function togglePanel(panel) {
	    if (this.state.currentPanel === panel) this.hidePanel();else this.showPanel(panel);
	  },
	
	  renderBody: function renderBody() {
	    var _this = this;
	
	    var org = this.getOrganization();
	    var config = _storesConfigStore2['default'].getConfig();
	
	    if (!org) {
	      // When no organization, just render Sentry logo at top
	      return _react2['default'].createElement(
	        'ul',
	        { className: 'navbar-nav' },
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { className: 'logo', href: '/' },
	            _react2['default'].createElement('span', { className: 'icon-sentry-logo' })
	          )
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(_organizationSelector2['default'], {
	        organization: org,
	        showPanel: this.state.showPanel,
	        currentPanel: this.state.currentPanel,
	        togglePanel: function () {
	          return _this.togglePanel('org-selector');
	        },
	        hidePanel: function () {
	          return _this.hidePanel();
	        } }),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'navbar-nav divider-bottom' },
	        _react2['default'].createElement(
	          'li',
	          { className: this.state.currentPanel == 'assigned' ? 'active' : null },
	          _react2['default'].createElement(
	            'a',
	            { title: 'Assigned to me' },
	            _react2['default'].createElement('span', { className: 'icon icon-user', onClick: function () {
	                return _this.togglePanel('assigned');
	              } })
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          { className: this.state.currentPanel == 'bookmarks' ? 'active' : null },
	          _react2['default'].createElement(
	            'a',
	            { title: 'My Bookmarks' },
	            _react2['default'].createElement('span', { className: 'icon icon-star-solid', onClick: function () {
	                return _this.togglePanel('bookmarks');
	              } })
	          )
	        ),
	        _react2['default'].createElement(
	          'li',
	          { className: this.state.currentPanel == 'history' ? 'active' : null },
	          _react2['default'].createElement(
	            'a',
	            { title: 'Recently Viewed' },
	            _react2['default'].createElement('span', { className: 'icon icon-av_timer', onClick: function () {
	                return _this.togglePanel('history');
	              } })
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'navbar-nav' },
	        _react2['default'].createElement(_broadcasts2['default'], {
	          showPanel: this.state.showPanel,
	          currentPanel: this.state.currentPanel,
	          onShowPanel: function () {
	            return _this.togglePanel('broadcasts');
	          },
	          hidePanel: function () {
	            return _this.hidePanel();
	          } }),
	        _react2['default'].createElement(_incidents2['default'], {
	          showPanel: this.state.showPanel,
	          currentPanel: this.state.currentPanel,
	          onShowPanel: function () {
	            return _this.togglePanel('statusupdate');
	          },
	          hidePanel: function () {
	            return _this.hidePanel();
	          } }),
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { title: 'Support', href: !config.isOnPremise ? '/organizations/' + org.slug + '/support/' : 'https://forum.sentry.io/' },
	            _react2['default'].createElement('span', { className: 'icon icon-support' })
	          )
	        )
	      ),
	      this.state.showPanel && this.state.currentPanel == 'assigned' && _react2['default'].createElement(
	        _sidebarPanel2['default'],
	        { title: (0, _locale.t)('Assigned to me'),
	          hidePanel: function () {
	            return _this.hidePanel();
	          } },
	        _react2['default'].createElement(_issueList2['default'], {
	          endpoint: '/organizations/' + org.slug + '/members/me/issues/assigned/',
	          query: {
	            statsPeriod: '24h',
	            per_page: 10,
	            status: 'unresolved'
	          },
	          pagination: false,
	          renderEmpty: function () {
	            return _react2['default'].createElement(
	              'div',
	              { className: 'sidebar-panel-empty', key: 'none' },
	              (0, _locale.t)('No issues have been assigned to you.')
	            );
	          },
	          ref: 'issueList',
	          showActions: false,
	          params: { orgId: org.slug } })
	      ),
	      this.state.showPanel && this.state.currentPanel == 'bookmarks' && _react2['default'].createElement(
	        _sidebarPanel2['default'],
	        { title: (0, _locale.t)('My Bookmarks'),
	          hidePanel: function () {
	            return _this.hidePanel();
	          } },
	        _react2['default'].createElement(_issueList2['default'], {
	          endpoint: '/organizations/' + org.slug + '/members/me/issues/bookmarked/',
	          query: {
	            statsPeriod: '24h',
	            per_page: 10,
	            status: 'unresolved'
	          },
	          pagination: false,
	          renderEmpty: function () {
	            return _react2['default'].createElement(
	              'div',
	              { className: 'sidebar-panel-empty', key: 'no' },
	              (0, _locale.t)('You have no bookmarked issues.')
	            );
	          },
	          ref: 'issueList',
	          showActions: false,
	          params: { orgId: org.slug } })
	      ),
	      this.state.showPanel && this.state.currentPanel == 'history' && _react2['default'].createElement(
	        _sidebarPanel2['default'],
	        { title: (0, _locale.t)('Recently Viewed'),
	          hidePanel: function () {
	            return _this.hidePanel();
	          } },
	        _react2['default'].createElement(_issueList2['default'], {
	          endpoint: '/organizations/' + org.slug + '/members/me/issues/viewed/',
	          query: {
	            statsPeriod: '24h',
	            per_page: 10,
	            status: 'unresolved'
	          },
	          pagination: false,
	          renderEmpty: function () {
	            return _react2['default'].createElement(
	              'div',
	              { className: 'sidebar-panel-empty', key: 'none' },
	              (0, _locale.t)('No recently viewed issues.')
	            );
	          },
	          ref: 'issueList',
	          showActions: false,
	          params: { orgId: org.slug } })
	      )
	    );
	  },
	
	  renderRequiredActions: function renderRequiredActions() {
	    // TODO: investigate if this is seriously deprecated
	    var org = this.getOrganization();
	    var requiredAction = org && getFirstRequiredAdminAction(org);
	
	    if (org && requiredAction !== null) {
	      var slugId = requiredAction.ID.toLowerCase().replace(/_/g, '-');
	      var url = '/organizations/' + org.slug + '/actions/' + slugId + '/';
	      return _react2['default'].createElement(
	        'span',
	        { className: 'admin-action-message' },
	        _react2['default'].createElement(
	          'a',
	          { href: url },
	          (0, _locale.t)('Required Action:'),
	          ' ',
	          requiredAction.getActionLinkTitle()
	        )
	      );
	    }
	
	    return null;
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var org = this.getOrganization();
	
	    // NOTE: this.props.orgId not guaranteed to be specified
	    return _react2['default'].createElement(
	      'nav',
	      { className: 'navbar', role: 'navigation', ref: 'navbar' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'anchor-top' },
	        this.renderBody()
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'anchor-bottom' },
	        _react2['default'].createElement(
	          'ul',
	          { className: 'navbar-nav' },
	          org && _react2['default'].createElement(OnboardingStatus, {
	            org: org,
	            showPanel: this.state.showPanel,
	            currentPanel: this.state.currentPanel,
	            onShowPanel: function () {
	              return _this2.togglePanel('todos');
	            },
	            hidePanel: function () {
	              return _this2.hidePanel();
	            } }),
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(_userNav2['default'], { className: 'user-settings' })
	          )
	        )
	      ),
	      this.renderRequiredActions()
	    );
	  }
	});
	
	exports['default'] = Sidebar;
	module.exports = exports['default'];
	/* Top nav links */ /* Panel bodies */ /* Bottom nav links */

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sidebarPanelItem = __webpack_require__(295);
	
	var _sidebarPanelItem2 = _interopRequireDefault(_sidebarPanelItem);
	
	var SidebarPanel = _react2['default'].createClass({
	  displayName: 'SidebarPanel',
	
	  propTypes: {
	    title: _react2['default'].PropTypes.string,
	    items: _react2['default'].PropTypes.array,
	    hidePanel: _react2['default'].PropTypes.func
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'sidebar-panel' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'sidebar-panel-header' },
	        _react2['default'].createElement(
	          'a',
	          { className: 'close pull-right', onClick: this.props.hidePanel },
	          _react2['default'].createElement('span', { className: 'icon-close' })
	        ),
	        _react2['default'].createElement(
	          'h2',
	          null,
	          this.props.title
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'sidebar-panel-body' },
	        !this.props.children && _react2['default'].createElement(
	          'div',
	          { className: 'sidebar-panel-items' },
	          _react2['default'].createElement(_sidebarPanelItem2['default'], null)
	        ),
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = SidebarPanel;
	module.exports = exports['default'];

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var OrganizationStore = _reflux2['default'].createStore({
	  init: function init() {
	    this.items = [];
	  },
	
	  get: function get(slug) {
	    return this.items.find(function (item) {
	      return item.slug === slug;
	    });
	  },
	
	  getAll: function getAll() {
	    return this.items;
	  },
	
	  load: function load(items) {
	    this.items = items;
	    this.trigger(items);
	  }
	});
	
	exports['default'] = OrganizationStore;
	module.exports = exports['default'];

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _groupStore = __webpack_require__(42);
	
	var _groupStore2 = _interopRequireDefault(_groupStore);
	
	var SelectedGroupStore = _reflux2['default'].createStore({
	  init: function init() {
	    this.records = {};
	
	    this.listenTo(_groupStore2['default'], this.onGroupChange, this.onGroupChange);
	  },
	
	  onGroupChange: function onGroupChange(itemIds) {
	    this.prune();
	    this.add(itemIds);
	    this.trigger();
	  },
	
	  add: function add(ids) {
	    var _this = this;
	
	    var allSelected = this.allSelected();
	    ids.forEach(function (id) {
	      if (!_this.records.hasOwnProperty(id)) {
	        _this.records[id] = allSelected;
	      }
	    });
	  },
	
	  prune: function prune() {
	    var existingIds = new Set(_groupStore2['default'].getAllItemIds());
	
	    // Remove ids that no longer exist
	    for (var itemId in this.records) {
	      if (!existingIds.has(itemId)) {
	        delete this.records[itemId];
	      }
	    }
	  },
	
	  allSelected: function allSelected() {
	    var itemIds = this.getSelectedIds();
	    var numRecords = this.numSelected();
	    return itemIds.size > 0 && itemIds.size === numRecords;
	  },
	
	  numSelected: function numSelected() {
	    return Object.keys(this.records).length;
	  },
	
	  anySelected: function anySelected() {
	    var itemIds = this.getSelectedIds();
	    return itemIds.size > 0;
	  },
	
	  multiSelected: function multiSelected() {
	    var itemIds = this.getSelectedIds();
	    return itemIds.size > 1;
	  },
	
	  getSelectedIds: function getSelectedIds() {
	    var selected = new Set();
	    for (var itemId in this.records) {
	      if (this.records[itemId]) {
	        selected.add(itemId);
	      }
	    }
	    return selected;
	  },
	
	  isSelected: function isSelected(itemId) {
	    return this.records[itemId] === true;
	  },
	
	  deselectAll: function deselectAll() {
	    for (var itemId in this.records) {
	      this.records[itemId] = false;
	    }
	    this.trigger();
	  },
	
	  toggleSelect: function toggleSelect(itemId) {
	    if (!this.records.hasOwnProperty(itemId)) return;
	    this.records[itemId] = !this.records[itemId];
	    this.trigger();
	  },
	
	  toggleSelectAll: function toggleSelectAll() {
	    var allSelected = !this.allSelected();
	
	    for (var itemId in this.records) {
	      this.records[itemId] = allSelected;
	    }
	
	    this.trigger();
	  }
	});
	
	exports['default'] = SelectedGroupStore;
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _actionsTeamActions = __webpack_require__(266);
	
	var _actionsTeamActions2 = _interopRequireDefault(_actionsTeamActions);
	
	var _projectStore = __webpack_require__(194);
	
	var _projectStore2 = _interopRequireDefault(_projectStore);
	
	var TeamStore = _reflux2['default'].createStore({
	  init: function init() {
	    this.reset();
	
	    this.listenTo(_actionsTeamActions2['default'].updateSuccess, this.onUpdateSuccess);
	    this.listenTo(_projectStore2['default'], this.onProject);
	  },
	
	  reset: function reset() {
	    this.items = [];
	    this.projectMap = {}; // map of project ids => team ids
	  },
	
	  loadInitialData: function loadInitialData(items) {
	    var _this = this;
	
	    items.forEach(function (item) {
	      item.projects.forEach(function (project) {
	        _this.projectMap[project.id] = item.id;
	      });
	    });
	    this.items = items;
	    this.trigger(new Set(items.map(function (item) {
	      return item.id;
	    })));
	  },
	
	  onUpdateSuccess: function onUpdateSuccess(changeId, itemId, response) {
	    if (!response) return;
	
	    var item = this.getBySlug(itemId);
	    if (!item) {
	      this.items.push(response);
	    } else {
	      $.extend(true, /*deep*/item, response);
	    }
	
	    this.trigger(new Set([itemId]));
	  },
	
	  onProject: function onProject(projectIds) {
	    var _this2 = this;
	
	    var teamsChanged = new Set();
	    projectIds.forEach(function (set, projectId) {
	      var teamId = _this2.projectMap[projectId];
	      var team = _this2.getById(teamId);
	
	      // TODO: make copy of project? right now just assigning reference
	      // to project form project store
	      var project = _projectStore2['default'].getById(projectId);
	      team.project = project;
	      teamsChanged.add(team.id);
	    });
	    this.trigger(teamsChanged);
	  },
	
	  getById: function getById(id) {
	    return this.items.find(function (item) {
	      return item.id === '' + id;
	    }) || null;
	  },
	
	  getBySlug: function getBySlug(slug) {
	    return this.items.find(function (item) {
	      return item.slug === slug;
	    }) || null;
	  },
	
	  getActive: function getActive() {
	    return this.items.filter(function (item) {
	      return item.isMember;
	    });
	  },
	
	  getAll: function getAll() {
	    return this.items;
	  }
	});
	
	window.TeamStore = TeamStore;
	
	exports['default'] = TeamStore;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.logException = logException;
	exports.logAjaxError = logAjaxError;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _ravenJs = __webpack_require__(108);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	function logException(ex, context) {
	  _ravenJs2['default'].captureException(ex, {
	    extra: context
	  });
	  /*eslint no-console:0*/
	  window.console && console.error && console.error(ex);
	}
	
	function logAjaxError(error, context) {
	  var errorString = error.responseJSON ? error.responseJSON.detail || error.responseJSON.toString() : error.responseText ? error.responseText.substr(0, 255) : '<unknown response>'; // occassionally responseText is undefined
	
	  var message = 'HTTP ' + error.status + ': ' + errorString;
	  _ravenJs2['default'].captureMessage(message, {
	    extra: context
	  });
	  /*eslint no-console:0*/
	  window.console && console.error && console.error(message);
	}

/***/ },
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	// TODO(dcramer): we should probably just make every parameter update
	// work on bulk groups
	var GroupActions = _reflux2['default'].createActions(['assignTo', 'assignToError', 'assignToSuccess', 'delete', 'deleteError', 'deleteSuccess', 'update', 'updateError', 'updateSuccess', 'merge', 'mergeError', 'mergeSuccess']);
	
	exports['default'] = GroupActions;
	module.exports = exports['default'];

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var AutoSelectText = _react2['default'].createClass({
	  displayName: 'AutoSelectText',
	
	  componentDidMount: function componentDidMount() {
	    var ref = _reactDom2['default'].findDOMNode(this.refs.element);
	    (0, _jquery2['default'])(ref).bind('click', this.selectText);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    var ref = _reactDom2['default'].findDOMNode(this.refs.element);
	    (0, _jquery2['default'])(ref).unbind('click', this.selectText);
	  },
	
	  selectText: function selectText() {
	    var node = _reactDom2['default'].findDOMNode(this.refs.element).firstChild;
	    if (document.selection) {
	      var range = document.body.createTextRange();
	      range.moveToElementText(node);
	      range.select();
	    } else if (window.getSelection) {
	      var range = document.createRange();
	      range.selectNode(node);
	      window.getSelection().addRange(range);
	    }
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { ref: 'element', className: this.props.className },
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = AutoSelectText;
	module.exports = exports['default'];

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _api = __webpack_require__(131);
	
	var _componentsForms = __webpack_require__(36);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _locale = __webpack_require__(2);
	
	var callbackWithArgs = function callbackWithArgs(callback) {
	  if (_underscore2['default'].isFunction(callback)) {
	    var _callback;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    callback = (_callback = callback).bind.apply(_callback, [this].concat(args));
	  } else {
	    callback = null;
	  }
	  return callback;
	};
	
	var PluginComponentBase = (function (_React$Component) {
	  _inherits(PluginComponentBase, _React$Component);
	
	  function PluginComponentBase(props) {
	    var _this = this;
	
	    _classCallCheck(this, PluginComponentBase);
	
	    _get(Object.getPrototypeOf(PluginComponentBase.prototype), 'constructor', this).call(this, props);
	
	    ['onLoadSuccess', 'onLoadError', 'onSave', 'onSaveSuccess', 'onSaveError', 'onSaveComplete', 'renderField'].map(function (method) {
	      return _this[method] = _this[method].bind(_this);
	    });
	
	    if (this.fetchData) {
	      this.fetchData = this.onLoad.bind(this, this.fetchData.bind(this));
	    }
	    if (this.onSubmit) {
	      this.onSubmit = this.onSave.bind(this, this.onSubmit.bind(this));
	    }
	
	    this.state = {
	      state: _componentsForms.FormState.READY
	    };
	  }
	
	  _createClass(PluginComponentBase, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.api = new _api.Client();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.api.clear();
	    }
	  }, {
	    key: 'onLoad',
	    value: function onLoad(callback) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      this.setState({
	        state: _componentsForms.FormState.LOADING
	      }, callbackWithArgs.apply(undefined, [callback].concat(args)));
	    }
	  }, {
	    key: 'onLoadSuccess',
	    value: function onLoadSuccess(callback) {
	      for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        args[_key3 - 1] = arguments[_key3];
	      }
	
	      this.setState({
	        state: _componentsForms.FormState.READY
	      }, callbackWithArgs.apply(undefined, [callback].concat(args)));
	    }
	  }, {
	    key: 'onLoadError',
	    value: function onLoadError(callback) {
	      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	        args[_key4 - 1] = arguments[_key4];
	      }
	
	      this.setState({
	        state: _componentsForms.FormState.ERROR
	      }, callbackWithArgs.apply(undefined, [callback].concat(args)));
	      _storesIndicatorStore2['default'].add((0, _locale.t)('An error occurred.'), 'error', {
	        duration: 3000
	      });
	    }
	  }, {
	    key: 'onSave',
	    value: function onSave(callback) {
	      var _this2 = this;
	
	      if (this.state.state == _componentsForms.FormState.SAVING) {
	        return;
	      }
	
	      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	        args[_key5 - 1] = arguments[_key5];
	      }
	
	      callback = callbackWithArgs.apply(undefined, [callback].concat(args));
	      this.setState({
	        state: _componentsForms.FormState.SAVING
	      }, function () {
	        _this2._loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	        callback && callback();
	      });
	    }
	  }, {
	    key: 'onSaveSuccess',
	    value: function onSaveSuccess(callback) {
	      for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	        args[_key6 - 1] = arguments[_key6];
	      }
	
	      this.setState({
	        state: _componentsForms.FormState.READY
	      }, callbackWithArgs.apply(undefined, [callback].concat(args)));
	      _storesIndicatorStore2['default'].add((0, _locale.t)('Success!'), 'success', {
	        duration: 3000
	      });
	    }
	  }, {
	    key: 'onSaveError',
	    value: function onSaveError(callback) {
	      for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	        args[_key7 - 1] = arguments[_key7];
	      }
	
	      callback = callbackWithArgs.apply(undefined, [callback].concat(args));
	      this.setState({
	        state: _componentsForms.FormState.ERROR
	      }, function () {
	        _storesIndicatorStore2['default'].add((0, _locale.t)('Unable to save changes. Please try again.'), 'error', {
	          duration: 3000
	        });
	        callback && callback();
	      });
	    }
	  }, {
	    key: 'onSaveComplete',
	    value: function onSaveComplete(callback) {
	      _storesIndicatorStore2['default'].remove(this._loadingIndicator);
	
	      for (var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
	        args[_key8 - 1] = arguments[_key8];
	      }
	
	      callback = callbackWithArgs.apply(undefined, [callback].concat(args));
	      callback && callback();
	    }
	  }, {
	    key: 'renderField',
	    value: function renderField(props) {
	      return _react2['default'].createElement(_componentsForms.GenericField, props);
	    }
	  }]);
	
	  return PluginComponentBase;
	})(_react2['default'].Component);
	
	exports['default'] = PluginComponentBase;
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _locale = __webpack_require__(2);
	
	var ClippedBox = _react2['default'].createClass({
	  displayName: 'ClippedBox',
	
	  propTypes: {
	    title: _react2['default'].PropTypes.string,
	    defaultClipped: _react2['default'].PropTypes.bool,
	    clipHeight: _react2['default'].PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultClipped: false,
	      clipHeight: 200,
	      renderedHeight: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      clipped: this.props.defaultClipped,
	      revealed: false };
	  },
	
	  // True once user has clicked "Show More" button
	  componentDidMount: function componentDidMount() {
	    var renderedHeight = _reactDom2['default'].findDOMNode(this).offsetHeight;
	
	    if (renderedHeight > this.props.clipHeight) {
	      /*eslint react/no-did-mount-set-state:0*/
	      // okay if this causes re-render; cannot determine until
	      // rendered first anyways
	      this.setState({
	        clipped: true
	      });
	    }
	  },
	
	  reveal: function reveal(e) {
	    e.stopPropagation();
	
	    this.setState({
	      clipped: false,
	      revealed: true
	    });
	  },
	
	  render: function render() {
	    var className = 'box-clippable';
	    if (this.state.clipped) {
	      className += ' clipped';
	    }
	    if (this.state.revealed) {
	      className += ' revealed';
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: className },
	      this.props.title && _react2['default'].createElement(
	        'h5',
	        null,
	        this.props.title
	      ),
	      this.props.children,
	      this.state.clipped && _react2['default'].createElement(
	        'div',
	        { className: 'clip-fade' },
	        _react2['default'].createElement(
	          'a',
	          { onClick: this.reveal, className: 'show-more btn btn-primary btn-xs' },
	          (0, _locale.t)('Show more')
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ClippedBox;
	module.exports = exports['default'];

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _utils = __webpack_require__(7);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function looksLikeObjectRepr(value) {
	  var a = value[0];
	  var z = value[value.length - 1];
	  if (a == '<' && z == '>') {
	    return true;
	  } else if (a == '[' && z == ']') {
	    return true;
	  } else if (a == '(' && z == ')') {
	    return true;
	  } else if (z == ')' && value.match(/^[\w\d._-]+\(/)) {
	    return true;
	  }
	  return false;
	}
	
	function looksLikeMultiLineString(value) {
	  return !!value.match(/[\r\n]/);
	}
	
	function padNumbersInString(string) {
	  return string.replace(/(\d+)/g, function (num) {
	    var isNegative = false;
	    num = parseInt(num, 10);
	    if (num < 0) {
	      num *= -1;
	      isNegative = true;
	    }
	    var s = '0000000000000' + num;
	    s = s.substr(s.length - (isNegative ? 11 : 12));
	    if (isNegative) {
	      s = '-' + s;
	    }
	    return s;
	  });
	}
	
	function naturalCaseInsensitiveSort(a, b) {
	  a = padNumbersInString(a).toLowerCase();
	  b = padNumbersInString(b).toLowerCase();
	  return a === b ? 0 : a < b ? -1 : 1;
	}
	
	function analyzeStringForRepr(value) {
	  var rv = {
	    repr: value,
	    isString: true,
	    isMultiLine: false,
	    isStripped: false
	  };
	
	  // stripped for security reasons
	  if (value.match(/^['"]?\*{8,}['"]?$/)) {
	    rv.isStripped = true;
	    return rv;
	  }
	
	  if (looksLikeObjectRepr(value)) {
	    rv.isString = false;
	  } else {
	    rv.isMultiLine = looksLikeMultiLineString(value);
	  }
	
	  return rv;
	}
	
	var ContextData = _react2['default'].createClass({
	  displayName: 'ContextData',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      data: null
	    };
	  },
	
	  renderValue: function renderValue(value) {
	    function toggle(evt) {
	      (0, _jquery2['default'])(evt.target).parent().toggleClass('val-toggle-open');
	      evt.preventDefault();
	    }
	
	    function makeToggle(highUp, childCount, children) {
	      if (childCount === 0) {
	        return null;
	      }
	      if (highUp) {
	        return children;
	      }
	      return _react2['default'].createElement(
	        'span',
	        { className: 'val-toggle' },
	        _react2['default'].createElement('a', { href: '#', className: 'val-toggle-link', onClick: toggle }),
	        children
	      );
	    }
	
	    /*eslint no-shadow:0*/
	    function walk(value, depth) {
	      var i = 0,
	          children = [];
	      if (value === null) {
	        return _react2['default'].createElement(
	          'span',
	          { className: 'val-null' },
	          'None'
	        );
	      } else if (value === true || value === false) {
	        return _react2['default'].createElement(
	          'span',
	          { className: 'val-bool' },
	          value ? 'True' : 'False'
	        );
	      } else if (_underscore2['default'].isString(value)) {
	        var valueInfo = analyzeStringForRepr(value);
	
	        var out = [_react2['default'].createElement(
	          'span',
	          { key: 'value', className: (valueInfo.isString ? 'val-string' : 'val-repr') + (valueInfo.isStripped ? ' val-stripped' : '') + (valueInfo.isMultiLine ? ' val-string-multiline' : '') },
	          valueInfo.repr
	        )];
	
	        if (valueInfo.isString && (0, _utils.isUrl)(value)) {
	          out.push(_react2['default'].createElement(
	            'a',
	            { key: 'external', href: value, className: 'external-icon' },
	            _react2['default'].createElement('em', { className: 'icon-open' })
	          ));
	        }
	
	        return out;
	      } else if (_underscore2['default'].isNumber(value)) {
	        return _react2['default'].createElement(
	          'span',
	          { className: 'val-number' },
	          value
	        );
	      } else if (_underscore2['default'].isArray(value)) {
	        for (i = 0; i < value.length; i++) {
	          children.push(_react2['default'].createElement(
	            'span',
	            { className: 'val-array-item', key: i },
	            walk(value[i], depth + 1),
	            i < value.length - 1 ? _react2['default'].createElement(
	              'span',
	              { className: 'val-array-sep' },
	              ', '
	            ) : null
	          ));
	        }
	        return _react2['default'].createElement(
	          'span',
	          { className: 'val-array' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'val-array-marker' },
	            '['
	          ),
	          makeToggle(depth <= 2, children.length, _react2['default'].createElement(
	            'span',
	            { className: 'val-array-items' },
	            children
	          )),
	          _react2['default'].createElement(
	            'span',
	            { className: 'val-array-marker' },
	            ']'
	          )
	        );
	      } else {
	        var keys = Object.keys(value);
	        keys.sort(naturalCaseInsensitiveSort);
	        for (i = 0; i < keys.length; i++) {
	          var key = keys[i];
	          children.push(_react2['default'].createElement(
	            'span',
	            { className: 'val-dict-pair', key: key },
	            _react2['default'].createElement(
	              'span',
	              { className: 'val-dict-key' },
	              _react2['default'].createElement(
	                'span',
	                { className: 'val-string' },
	                key
	              )
	            ),
	            _react2['default'].createElement(
	              'span',
	              { className: 'val-dict-col' },
	              ': '
	            ),
	            _react2['default'].createElement(
	              'span',
	              { className: 'val-dict-value' },
	              walk(value[key], depth + 1),
	              i < keys.length - 1 ? _react2['default'].createElement(
	                'span',
	                { className: 'val-dict-sep' },
	                ', '
	              ) : null
	            )
	          ));
	        }
	        return _react2['default'].createElement(
	          'span',
	          { className: 'val-dict' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'val-dict-marker' },
	            '{'
	          ),
	          makeToggle(depth <= 1, children.length, _react2['default'].createElement(
	            'span',
	            { className: 'val-dict-items' },
	            children
	          )),
	          _react2['default'].createElement(
	            'span',
	            { className: 'val-dict-marker' },
	            '}'
	          )
	        );
	      }
	    }
	    return walk(value, 0);
	  },
	
	  renderKeyPosValue: function renderKeyPosValue(value) {
	    if (_underscore2['default'].isString(value)) {
	      return _react2['default'].createElement(
	        'span',
	        { className: 'val-string' },
	        value
	      );
	    }
	    return this.renderValue(value);
	  },
	
	  render: function render() {
	    // XXX(dcramer): babel does not support this yet
	    // let {data, className, ...other} = this.props;
	    var data = this.props.data;
	    var className = this.props.className;
	    var other = {};
	    for (var key in this.props) {
	      if (key !== 'data' && key !== 'className') {
	        other[key] = this.props[key];
	      }
	    }
	    other.className = 'val ' + (className || '');
	
	    return _react2['default'].createElement(
	      'pre',
	      other,
	      this.renderValue(data)
	    );
	  }
	});
	
	exports['default'] = ContextData;
	module.exports = exports['default'];

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Duration = _react2['default'].createClass({
	  displayName: 'Duration',
	
	  propTypes: {
	    seconds: _react2['default'].PropTypes.number.isRequired
	  },
	
	  getDuration: function getDuration() {
	    var value = Math.abs(this.props.seconds * 1000);
	    var result = '';
	
	    if (value >= 604800000) {
	      // one week
	      result = Math.round(value / 604800000);
	      result = result !== 1 ? result + ' weeks' : result + ' week';
	    } else if (value >= 172800000) {
	      // two days
	      result = Math.round(value / 86400000);
	      result = result !== 1 ? result + ' days' : result + ' day';
	    } else if (value >= 7200000) {
	      result = Math.round(value / 3600000);
	      result = result !== 1 ? result + ' hours' : result + ' hour';
	    } else if (value >= 120000) {
	      result = Math.round(value / 60000);
	      result = result !== 1 ? result + ' minutes' : result + ' minute';
	    } else if (value >= 1000) {
	      result = Math.round(value / 1000);
	      result = result !== 1 ? result + ' seconds' : result + ' second';
	    } else {
	      result = Math.round(value) + ' ms';
	    }
	
	    return result;
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'span',
	      { className: this.props.className },
	      this.getDuration()
	    );
	  }
	});
	
	exports['default'] = Duration;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _category = __webpack_require__(562);
	
	var _category2 = _interopRequireDefault(_category);
	
	var CrumbTable = _react2['default'].createClass({
	  displayName: 'CrumbTable',
	
	  propTypes: {
	    crumb: _react2['default'].PropTypes.object,
	    title: _react2['default'].PropTypes.string,
	    kvData: _react2['default'].PropTypes.object,
	    summary: _react2['default'].PropTypes.object
	  },
	
	  renderData: function renderData() {
	    if (!this.props.kvData) {
	      return null;
	    }
	    return _underscore2['default'].chain(this.props.kvData).map(function (val, key) {
	      return [val, key];
	    }).map(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var val = _ref2[0];
	      var key = _ref2[1];
	
	      return _react2['default'].createElement(
	        'tr',
	        { key: key },
	        _react2['default'].createElement(
	          'td',
	          { className: 'key' },
	          key
	        ),
	        _react2['default'].createElement(
	          'td',
	          { className: 'value' },
	          _react2['default'].createElement(
	            'pre',
	            null,
	            val + ''
	          )
	        )
	      );
	    }).value();
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'table',
	      { className: 'table key-value' },
	      _react2['default'].createElement(
	        'thead',
	        null,
	        _react2['default'].createElement(
	          'tr',
	          null,
	          _react2['default'].createElement(
	            'td',
	            { className: 'key' },
	            _react2['default'].createElement(_category2['default'], { value: this.props.crumb.category })
	          ),
	          _react2['default'].createElement(
	            'td',
	            { className: 'value' },
	            this.props.summary
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'tbody',
	        null,
	        this.props.children,
	        this.renderData()
	      )
	    );
	  }
	});
	
	exports['default'] = CrumbTable;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function isOverflowing(el) {
	  // XXX(mitsuhiko): subtract one because of reasons. Not sure which ones.
	  return el.offsetHeight < el.scrollHeight - 1;
	}
	
	var SummaryLine = _react2['default'].createClass({
	  displayName: 'SummaryLine',
	
	  propTypes: {
	    crumb: _react2['default'].PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      expanded: false,
	      hasOverflow: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.domElement = null;
	    window.addEventListener('resize', this.respondToLayoutChanges);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.domElement = null;
	    window.addEventListener('resize', this.respondToLayoutChanges);
	  },
	
	  makeSummariesGreatAgain: function makeSummariesGreatAgain(ref) {
	    this.domElement = ref;
	    this.respondToLayoutChanges();
	  },
	
	  respondToLayoutChanges: function respondToLayoutChanges() {
	    if (!this.domElement) {
	      return;
	    }
	    var hasOverflow = isOverflowing(this.domElement);
	    if (hasOverflow !== this.state.hasOverflow) {
	      this.setState({
	        hasOverflow: hasOverflow
	      });
	    }
	  },
	
	  onToggle: function onToggle() {
	    this.setState({
	      expanded: !this.state.expanded
	    });
	  },
	
	  render: function render() {
	    var className = 'summary';
	    if (this.state.hasOverflow) {
	      className += ' can-expand';
	    }
	    if (this.state.expanded) {
	      className += ' expanded';
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: className,
	        onClick: this.onToggle,
	        ref: this.makeSummariesGreatAgain },
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = SummaryLine;
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _rawStacktraceContent = __webpack_require__(273);
	
	var _rawStacktraceContent2 = _interopRequireDefault(_rawStacktraceContent);
	
	var _stacktraceContent = __webpack_require__(274);
	
	var _stacktraceContent2 = _interopRequireDefault(_stacktraceContent);
	
	var _exceptionContent = __webpack_require__(571);
	
	var _exceptionContent2 = _interopRequireDefault(_exceptionContent);
	
	var _rawExceptionContent = __webpack_require__(575);
	
	var _rawExceptionContent2 = _interopRequireDefault(_rawExceptionContent);
	
	var CrashContent = _react2['default'].createClass({
	  displayName: 'CrashContent',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    stackView: _react2['default'].PropTypes.string.isRequired,
	    stackType: _react2['default'].PropTypes.string,
	    newestFirst: _react2['default'].PropTypes.bool.isRequired,
	    exception: _react2['default'].PropTypes.object,
	    stacktrace: _react2['default'].PropTypes.object
	  },
	
	  renderException: function renderException() {
	    var _props = this.props;
	    var event = _props.event;
	    var stackView = _props.stackView;
	    var stackType = _props.stackType;
	    var newestFirst = _props.newestFirst;
	    var exception = _props.exception;
	
	    return stackView === 'raw' ? _react2['default'].createElement(_rawExceptionContent2['default'], {
	      type: stackType,
	      values: exception.values,
	      platform: event.platform }) : _react2['default'].createElement(_exceptionContent2['default'], {
	      type: stackType,
	      view: stackView,
	      values: exception.values,
	      platform: event.platform,
	      newestFirst: newestFirst });
	  },
	
	  renderStacktrace: function renderStacktrace() {
	    var _props2 = this.props;
	    var event = _props2.event;
	    var stackView = _props2.stackView;
	    var newestFirst = _props2.newestFirst;
	    var stacktrace = _props2.stacktrace;
	
	    return stackView === 'raw' ? _react2['default'].createElement(
	      'pre',
	      { className: 'traceback plain' },
	      (0, _rawStacktraceContent2['default'])(stacktrace, event.platform)
	    ) : _react2['default'].createElement(_stacktraceContent2['default'], {
	      data: stacktrace,
	      className: 'no-exception',
	      includeSystemFrames: stackView === 'full',
	      platform: event.platform,
	      newestFirst: newestFirst });
	  },
	
	  render: function render() {
	    if (this.props.exception) {
	      return this.renderException();
	    }
	    if (this.props.stacktrace) {
	      return this.renderStacktrace();
	    }
	  }
	});
	
	exports['default'] = CrashContent;
	module.exports = exports['default'];

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _locale = __webpack_require__(2);
	
	var CrashHeader = _react2['default'].createClass({
	  displayName: 'CrashHeader',
	
	  propTypes: {
	    title: _react2['default'].PropTypes.string,
	    beforeTitle: _react2['default'].PropTypes.any,
	    group: _proptypes2['default'].Group.isRequired,
	    platform: _react2['default'].PropTypes.string,
	    thread: _react2['default'].PropTypes.object,
	    exception: _react2['default'].PropTypes.object,
	    stacktrace: _react2['default'].PropTypes.object,
	    stackView: _react2['default'].PropTypes.string.isRequired,
	    newestFirst: _react2['default'].PropTypes.bool.isRequired,
	    stackType: _react2['default'].PropTypes.string, // 'original', 'minified', or falsy (none)
	    onChange: _react2['default'].PropTypes.func
	  },
	
	  mixins: [(0, _mixinsTooltip2['default'])({
	    html: false,
	    selector: '.tip',
	    trigger: 'hover'
	  })],
	
	  hasSystemFrames: function hasSystemFrames() {
	    var _props = this.props;
	    var stacktrace = _props.stacktrace;
	    var thread = _props.thread;
	    var exception = _props.exception;
	
	    return stacktrace && stacktrace.hasSystemFrames || thread && thread.stacktrace && thread.stacktrace.hasSystemFrames || exception && exception.values.find(function (x) {
	      return !!(x.stacktrace && x.stacktrace.hasSystemFrames);
	    });
	  },
	
	  hasMinified: function hasMinified() {
	    if (!this.props.stackType) {
	      return false;
	    }
	    var _props2 = this.props;
	    var exception = _props2.exception;
	    var thread = _props2.thread;
	
	    return exception && !!exception.values.find(function (x) {
	      return x.rawStacktrace;
	    }) || thread && !!thread.rawStacktrace;
	  },
	
	  getOriginalButtonLabel: function getOriginalButtonLabel() {
	    if (this.props.platform === 'javascript' || this.props.platform === 'node') {
	      return (0, _locale.t)('Original');
	    } else {
	      return (0, _locale.t)('Symbolicated');
	    }
	  },
	
	  getMinifiedButtonLabel: function getMinifiedButtonLabel() {
	    if (this.props.platform === 'javascript' || this.props.platform === 'node') {
	      return (0, _locale.t)('Minified');
	    } else {
	      return (0, _locale.t)('Unsymbolicated');
	    }
	  },
	
	  toggleOrder: function toggleOrder() {
	    this.notify({
	      newestFirst: !this.props.newestFirst
	    });
	  },
	
	  setStackType: function setStackType(type) {
	    this.notify({
	      stackType: type
	    });
	  },
	
	  setStackView: function setStackView(view) {
	    this.notify({
	      stackView: view
	    });
	  },
	
	  notify: function notify(obj) {
	    if (this.props.onChange) {
	      this.props.onChange(obj);
	    }
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props3 = this.props;
	    var stackView = _props3.stackView;
	    var stackType = _props3.stackType;
	    var newestFirst = _props3.newestFirst;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'crash-title' },
	      this.props.beforeTitle,
	      _react2['default'].createElement(
	        'h3',
	        { className: 'pull-left' },
	        this.props.title !== undefined ? this.props.title : (0, _locale.t)('Exception'),
	        _react2['default'].createElement(
	          'small',
	          { style: { marginLeft: 5 } },
	          '(',
	          _react2['default'].createElement(
	            'a',
	            { onClick: this.toggleOrder, className: 'tip', title: (0, _locale.t)('Toggle stacktrace order'), style: { borderBottom: '1px dotted #aaa' } },
	            newestFirst ? (0, _locale.t)('most recent call first') : (0, _locale.t)('most recent call last')
	          ),
	          ')'
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'btn-group', style: { marginLeft: 10 } },
	        this.hasSystemFrames() && _react2['default'].createElement(
	          'a',
	          { className: (stackView === 'app' ? 'active' : '') + ' btn btn-default btn-sm', onClick: this.setStackView.bind(this, 'app') },
	          (0, _locale.t)('App Only')
	        ),
	        _react2['default'].createElement(
	          'a',
	          { className: (stackView === 'full' ? 'active' : '') + ' btn btn-default btn-sm', onClick: this.setStackView.bind(this, 'full') },
	          (0, _locale.t)('Full')
	        ),
	        _react2['default'].createElement(
	          'a',
	          { className: (stackView === 'raw' ? 'active' : '') + ' btn btn-default btn-sm', onClick: this.setStackView.bind(this, 'raw') },
	          (0, _locale.t)('Raw')
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'btn-group' },
	        this.hasMinified() && [_react2['default'].createElement(
	          'a',
	          { key: 'original', className: (stackType === 'original' ? 'active' : '') + ' btn btn-default btn-sm', onClick: function () {
	              return _this.setStackType('original');
	            } },
	          this.getOriginalButtonLabel()
	        ), _react2['default'].createElement(
	          'a',
	          { key: 'minified', className: (stackType === 'minified' ? 'active' : '') + ' btn btn-default btn-sm', onClick: function () {
	              return _this.setStackType('minified');
	            } },
	          this.getMinifiedButtonLabel()
	        )]
	      )
	    );
	  }
	});
	
	exports['default'] = CrashHeader;
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.isStacktraceNewestFirst = isStacktraceNewestFirst;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _locale = __webpack_require__(2);
	
	var _crashHeader = __webpack_require__(178);
	
	var _crashHeader2 = _interopRequireDefault(_crashHeader);
	
	var _crashContent = __webpack_require__(177);
	
	var _crashContent2 = _interopRequireDefault(_crashContent);
	
	function isStacktraceNewestFirst() {
	  var user = _storesConfigStore2['default'].get('user');
	  // user may not be authenticated
	  var options = user ? user.options : {};
	  switch (options.stacktraceOrder) {
	    case 'newestFirst':
	      return true;
	    case 'newestLast':
	      return false;
	    case 'default': // is "default" a valid value? or bad case statement
	    default:
	      return true;
	  }
	}
	
	var StacktraceInterface = _react2['default'].createClass({
	  displayName: 'StacktraceInterface',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    type: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired,
	    platform: _react2['default'].PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      stackView: this.props.data.hasSystemFrames ? 'app' : 'full',
	      newestFirst: isStacktraceNewestFirst()
	    };
	  },
	
	  toggleStack: function toggleStack(value) {
	    this.setState({
	      stackView: value
	    });
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var group = this.props.group;
	    var evt = this.props.event;
	    var data = this.props.data;
	    var stackView = this.state.stackView;
	    var newestFirst = this.state.newestFirst;
	
	    var title = _react2['default'].createElement(_crashHeader2['default'], {
	      title: (0, _locale.t)('Stacktrace'),
	      group: group,
	      platform: evt.platform,
	      stacktrace: data,
	      stackView: stackView,
	      newestFirst: newestFirst,
	      onChange: function (newState) {
	        _this.setState(newState);
	      }
	    });
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: group,
	        event: evt,
	        type: this.props.type,
	        title: title,
	        wrapTitle: false },
	      _react2['default'].createElement(_crashContent2['default'], {
	        group: group,
	        event: evt,
	        stackView: stackView,
	        newestFirst: newestFirst,
	        stacktrace: data })
	    );
	  }
	});
	
	exports['default'] = StacktraceInterface;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var FileSize = _react2['default'].createClass({
	  displayName: 'FileSize',
	
	  propTypes: {
	    bytes: _react2['default'].PropTypes.number.isRequired
	  },
	
	  units: ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	
	  formatBytes: function formatBytes(bytes) {
	    var thresh = 1024;
	    if (bytes < thresh) {
	      return bytes + ' B';
	    }
	
	    var u = -1;
	    do {
	      bytes /= thresh;
	      ++u;
	    } while (bytes >= thresh);
	    return bytes.toFixed(1) + ' ' + this.units[u];
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'span',
	      null,
	      this.formatBytes(this.props.bytes)
	    );
	  }
	});
	
	exports['default'] = FileSize;
	module.exports = exports['default'];

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _compactIssue = __webpack_require__(270);
	
	var _compactIssue2 = _interopRequireDefault(_compactIssue);
	
	var _loadingError = __webpack_require__(9);
	
	var _loadingError2 = _interopRequireDefault(_loadingError);
	
	var _loadingIndicator = __webpack_require__(6);
	
	var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);
	
	var _pagination = __webpack_require__(39);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _locale = __webpack_require__(2);
	
	var IssueList = _react2['default'].createClass({
	  displayName: 'IssueList',
	
	  propTypes: {
	    endpoint: _react2['default'].PropTypes.string.isRequired,
	    query: _react2['default'].PropTypes.object,
	    pagination: _react2['default'].PropTypes.bool,
	    renderEmpty: _react2['default'].PropTypes.func,
	    statsPeriod: _react2['default'].PropTypes.string,
	    showActions: _react2['default'].PropTypes.bool
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      pagination: true,
	      query: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      issueIds: [],
	      loading: true,
	      error: false,
	      pageLinks: null
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var location = this.props.location;
	    var nextLocation = nextProps.location;
	    if (!location) return;
	
	    if (location.pathname != nextLocation.pathname || location.search != nextLocation.search) {
	      this.remountComponent();
	    }
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var location = this.props.location;
	    this.api.clear();
	    this.api.request(this.props.endpoint, {
	      method: 'GET',
	      query: _extends({
	        cursor: location && location.query && location.query.cursor || ''
	      }, this.props.query),
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          data: data,
	          loading: false,
	          error: false,
	          issueIds: data.map(function (item) {
	            return item.id;
	          }),
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  renderResults: function renderResults() {
	    var _this2 = this;
	
	    var body = undefined;
	    var params = this.props.params;
	
	    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = _react2['default'].createElement(_loadingError2['default'], { onRetry: this.fetchData });else if (this.state.issueIds.length > 0) {
	      body = _react2['default'].createElement(
	        'ul',
	        { className: 'issue-list' },
	        this.state.data.map(function (issue) {
	          return _react2['default'].createElement(_compactIssue2['default'], {
	            key: issue.id,
	            id: issue.id,
	            data: issue,
	            orgId: params.orgId,
	            statsPeriod: _this2.props.statsPeriod,
	            showActions: _this2.props.showActions
	          });
	        })
	      );
	    } else body = (this.props.renderEmpty || this.renderEmpty)();
	
	    return body;
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_loadingIndicator2['default'], null)
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty' },
	      (0, _locale.t)('Nothing to show here, move along.')
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.renderResults(),
	      this.props.pagination && this.state.pageLinks && _react2['default'].createElement(_pagination2['default'], _extends({ pageLinks: this.state.pageLinks }, this.props))
	    );
	  }
	});
	
	exports['default'] = IssueList;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	/**
	 * A context-aware version of Link (from react-router) that falls
	 * back to <a> if there is no router present.
	 */
	var Link = _react2['default'].createClass({
	  displayName: 'Link',
	
	  propTypes: {
	    to: _react2['default'].PropTypes.string.isRequired
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  render: function render() {
	    if (this.context.location) {
	      return _react2['default'].createElement(
	        _reactRouter.Link,
	        this.props,
	        this.props.children
	      );
	    } else {
	      var props = _underscore2['default'].omit(this.props, 'to');
	      props.href = this.props.to;
	      return _react2['default'].createElement(
	        'a',
	        props,
	        this.props.children
	      );
	    }
	  }
	});
	
	exports['default'] = Link;
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapLibModal = __webpack_require__(73);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _locale = __webpack_require__(2);
	
	var LinkWithConfirmation = _react2['default'].createClass({
	  displayName: 'LinkWithConfirmation',
	
	  propTypes: {
	    disabled: _react2['default'].PropTypes.bool,
	    message: _react2['default'].PropTypes.string.isRequired,
	    title: _react2['default'].PropTypes.string.isRequired,
	    onConfirm: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      isModalOpen: false
	    };
	  },
	
	  onConfirm: function onConfirm() {
	    this.setState({
	      isModalOpen: false
	    });
	
	    this.props.onConfirm();
	  },
	
	  onToggle: function onToggle() {
	    if (this.props.disabled) {
	      return;
	    }
	    this.setState({
	      isModalOpen: !this.state.isModalOpen
	    });
	  },
	
	  render: function render() {
	    var className = this.props.className;
	    if (this.props.disabled) {
	      className += ' disabled';
	    }
	    return _react2['default'].createElement(
	      'a',
	      { className: className, disabled: this.props.disabled, onClick: this.onToggle, title: this.props.title },
	      this.props.children,
	      _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: this.state.isModalOpen, title: (0, _locale.t)('Please confirm'), animation: false, onHide: this.onToggle },
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-body' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            _react2['default'].createElement(
	              'strong',
	              null,
	              this.props.message
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-footer' },
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-default',
	              onClick: this.onToggle },
	            (0, _locale.t)('Cancel')
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary',
	              onClick: this.onConfirm },
	            (0, _locale.t)('Confirm')
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = LinkWithConfirmation;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _issueList = __webpack_require__(181);
	
	var _issueList2 = _interopRequireDefault(_issueList);
	
	var _organizationsHomeContainer = __webpack_require__(64);
	
	var _organizationsHomeContainer2 = _interopRequireDefault(_organizationsHomeContainer);
	
	var _locale = __webpack_require__(2);
	
	var OrganizationIssueList = _react2['default'].createClass({
	  displayName: 'OrganizationIssueList',
	
	  propTypes: {
	    title: _react2['default'].PropTypes.string,
	    endpoint: _react2['default'].PropTypes.string.isRequired,
	    pageSize: _react2['default'].PropTypes.number
	  },
	
	  getInitialState: function getInitialState() {
	    return this.getQueryStringState(this.props);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.location.search !== this.props.location.search) {
	      this.setState(this.getQueryStringState(nextProps), this.fetchData);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _storesGroupStore2['default'].reset();
	  },
	
	  getQueryStringState: function getQueryStringState(props) {
	    var location = props.location;
	    var status = location.query.hasOwnProperty('status') ? location.query.status : 'unresolved';
	    return {
	      status: status
	    };
	  },
	
	  render: function render() {
	    var path = this.props.location.pathname;
	    var status = this.state.status;
	
	    return _react2['default'].createElement(
	      _organizationsHomeContainer2['default'],
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'pull-right' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'btn-group' },
	          _react2['default'].createElement(
	            _reactRouter.Link,
	            { to: path,
	              className: 'btn btn-sm btn-default' + (status === 'unresolved' ? ' active' : '') },
	            (0, _locale.t)('Unresolved')
	          ),
	          _react2['default'].createElement(
	            _reactRouter.Link,
	            { to: { pathname: path, query: { status: '' } },
	              className: 'btn btn-sm btn-default' + (status === '' ? ' active' : '') },
	            (0, _locale.t)('All Issues')
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'h3',
	        null,
	        this.props.title
	      ),
	      _react2['default'].createElement(_issueList2['default'], _extends({ endpoint: this.props.endpoint, query: {
	          status: this.state.status,
	          statsPeriod: '24h',
	          per_page: this.props.pageSize || 25
	        }, statsPeriod: '24h' }, this.props))
	    );
	  }
	});
	
	exports['default'] = OrganizationIssueList;
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Pill = _react2['default'].createClass({
	  displayName: 'Pill',
	
	  propTypes: {
	    className: _react2['default'].PropTypes.string,
	    name: _react2['default'].PropTypes.string,
	    value: _react2['default'].PropTypes.any
	  },
	
	  renderValue: function renderValue() {
	    var value = this.props.value;
	
	    if (value === undefined) {
	      return [null, null];
	    }
	    var extraClass = null;
	    var renderedValue = undefined;
	    if (value === true || value === false) {
	      extraClass = value ? 'true' : 'false';
	      renderedValue = value ? 'yes' : 'no';
	    } else if (value === null) {
	      extraClass = 'false';
	      renderedValue = 'n/a';
	    } else {
	      renderedValue = value.toString();
	    }
	    return [extraClass, renderedValue];
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var name = _props.name;
	    var value = _props.value;
	    var children = _props.children;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['name', 'value', 'children', 'className']);
	
	    var _renderValue = this.renderValue();
	
	    var _renderValue2 = _slicedToArray(_renderValue, 2);
	
	    var extraClass = _renderValue2[0];
	    var renderedValue = _renderValue2[1];
	
	    return _react2['default'].createElement(
	      'li',
	      _extends({ className: (className || '') + (extraClass ? ' ' + extraClass : '') }, props),
	      _react2['default'].createElement(
	        'span',
	        { className: 'key' },
	        name
	      ),
	      _react2['default'].createElement(
	        'span',
	        { className: 'value' },
	        renderedValue,
	        children
	      )
	    );
	  }
	});
	
	exports['default'] = Pill;
	module.exports = exports['default'];

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Pills = _react2['default'].createClass({
	  displayName: 'Pills',
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: this.props.className + ' pills' },
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = Pills;
	module.exports = exports['default'];

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _plugins = __webpack_require__(193);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _locale = __webpack_require__(2);
	
	var PluginConfig = _react2['default'].createClass({
	  displayName: 'PluginConfig',
	
	  propTypes: {
	    organization: _react2['default'].PropTypes.object.isRequired,
	    project: _react2['default'].PropTypes.object.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired,
	    onDisablePlugin: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onDisablePlugin: function onDisablePlugin() {
	        window.location.reload();
	      }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: !_plugins2['default'].isLoaded(this.props.data)
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.loadPlugin(this.props.data);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!_underscore2['default'].isEqual(nextProps.data, this.props.data)) {
	      this.loadPlugin(nextProps.data);
	    }
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !_underscore2['default'].isEqual(nextState, this.state) || !_underscore2['default'].isEqual(nextProps.data, this.props.data);
	  },
	
	  loadPlugin: function loadPlugin(data) {
	    var _this = this;
	
	    if (_plugins2['default'].isLoaded(data)) return;
	
	    this.setState({
	      loading: true
	    }, function () {
	      _plugins2['default'].load(data, function () {
	        _this.setState({ loading: false });
	      });
	    });
	  },
	
	  getPluginEndpoint: function getPluginEndpoint() {
	    var _props = this.props;
	    var organization = _props.organization;
	    var project = _props.project;
	    var data = _props.data;
	
	    return '/projects/' + organization.slug + '/' + project.slug + '/plugins/' + data.id + '/';
	  },
	
	  disablePlugin: function disablePlugin() {
	    var _this2 = this;
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	    this.api.request(this.getPluginEndpoint(), {
	      method: 'DELETE',
	      success: function success() {
	        _this2.props.onDisablePlugin();
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      },
	      error: function error(_error) {
	        _storesIndicatorStore2['default'].add((0, _locale.t)('Unable to disable plugin. Please try again.'), 'error');
	      }
	    });
	  },
	
	  render: function render() {
	    var data = this.props.data;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box ref-plugin-config-' + data.id },
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-header' },
	        data.canDisable && data.enabled && _react2['default'].createElement(
	          'div',
	          { className: 'pull-right' },
	          _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-sm btn-default',
	              onClick: this.disablePlugin },
	            (0, _locale.t)('Disable')
	          )
	        ),
	        _react2['default'].createElement(
	          'h3',
	          null,
	          data.name
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-content with-padding' },
	        this.state.loading ? _react2['default'].createElement(_componentsLoadingIndicator2['default'], null) : _plugins2['default'].get(data).renderSettings({
	          organization: this.props.organization,
	          project: this.props.project
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = PluginConfig;
	module.exports = exports['default'];

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _dropdownLink = __webpack_require__(33);
	
	var _dropdownLink2 = _interopRequireDefault(_dropdownLink);
	
	var _menuItem = __webpack_require__(37);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _pagination = __webpack_require__(39);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var Filter = _react2['default'].createClass({
	  displayName: 'Filter',
	
	  propTypes: {
	    name: _react2['default'].PropTypes.string.isRequired,
	    queryKey: _react2['default'].PropTypes.string.isRequired,
	    options: _react2['default'].PropTypes.array.isRequired,
	    path: _react2['default'].PropTypes.string.isRequired,
	    value: _react2['default'].PropTypes.any
	  },
	
	  getCurrentLabel: function getCurrentLabel() {
	    var _this = this;
	
	    var selected = this.props.options.filter(function (item) {
	      return item[0] === (_this.props.value || '');
	    })[0];
	    if (selected) return this.props.name + ': ' + selected[1];
	    return this.props.name + ': ' + 'Any';
	  },
	
	  getDefaultItem: function getDefaultItem() {
	    var query = _jquery2['default'].extend({}, this.props.location.query, {
	      cursor: ''
	    });
	    delete query[this.props.queryKey];
	
	    return _react2['default'].createElement(
	      _menuItem2['default'],
	      {
	        key: '',
	        isActive: this.props.value === '' || !this.props.value,
	        to: this.props.path,
	        query: query },
	      'Any'
	    );
	  },
	
	  getSelector: function getSelector() {
	    var _this2 = this;
	
	    return _react2['default'].createElement(
	      _dropdownLink2['default'],
	      { title: this.getCurrentLabel() },
	      this.getDefaultItem(),
	      this.props.options.map(function (item) {
	        var filterQuery = {};
	        filterQuery[_this2.props.queryKey] = item[0];
	        filterQuery.cursor = '';
	        var query = _jquery2['default'].extend({}, _this2.props.location.query, filterQuery);
	        return _react2['default'].createElement(
	          _menuItem2['default'],
	          {
	            key: item[0],
	            isActive: _this2.props.value === item[0],
	            to: _this2.props.path,
	            query: query },
	          item[1]
	        );
	      })
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'filter-options' },
	      this.props.options.length === 1 ? _react2['default'].createElement(
	        'strong',
	        null,
	        this.getCurrentLabel()
	      ) : this.getSelector()
	    );
	  }
	});
	
	var SortBy = _react2['default'].createClass({
	  displayName: 'SortBy',
	
	  propTypes: {
	    options: _react2['default'].PropTypes.array.isRequired,
	    path: _react2['default'].PropTypes.string.isRequired,
	    location: _react2['default'].PropTypes.string.isRequired,
	    value: _react2['default'].PropTypes.any
	  },
	
	  getCurrentSortLabel: function getCurrentSortLabel() {
	    var _this3 = this;
	
	    return this.props.options.filter(function (item) {
	      return item[0] === _this3.props.value;
	    })[0][1];
	  },
	
	  getSortBySelector: function getSortBySelector() {
	    var _this4 = this;
	
	    return _react2['default'].createElement(
	      _dropdownLink2['default'],
	      { title: this.getCurrentSortLabel(), className: 'sorted-by' },
	      this.props.options.map(function (item) {
	        var query = _jquery2['default'].extend({}, _this4.props.location.query, {
	          sortBy: item[0],
	          cursor: ''
	        });
	        return _react2['default'].createElement(
	          _menuItem2['default'],
	          {
	            isActive: _this4.props.value === item[0],
	            key: item[0],
	            to: _this4.props.path,
	            query: query },
	          item[1]
	        );
	      })
	    );
	  },
	
	  render: function render() {
	    if (this.props.options.length === 0) return null;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'sort-options' },
	      'Showing results sorted by',
	      this.props.options.length === 1 ? _react2['default'].createElement(
	        'strong',
	        { className: 'sorted-by' },
	        this.getCurrentSortLabel()
	      ) : this.getSortBySelector()
	    );
	  }
	});
	
	var ResultGrid = _react2['default'].createClass({
	  displayName: 'ResultGrid',
	
	  propTypes: {
	    columns: _react2['default'].PropTypes.array,
	    columnsForRow: _react2['default'].PropTypes.func,
	    defaultSort: _react2['default'].PropTypes.string,
	    defaultParams: _react2['default'].PropTypes.object,
	    endpoint: _react2['default'].PropTypes.string,
	    filters: _react2['default'].PropTypes.object,
	    hasPagination: _react2['default'].PropTypes.bool,
	    hasSearch: _react2['default'].PropTypes.bool,
	    keyForRow: _react2['default'].PropTypes.func,
	    location: _react2['default'].PropTypes.string,
	    method: _react2['default'].PropTypes.string,
	    options: _react2['default'].PropTypes.array,
	    path: _react2['default'].PropTypes.string,
	    sortOptions: _react2['default'].PropTypes.array
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      path: '',
	      endpoint: '',
	      method: 'GET',
	      columns: [],
	      sortOptions: [],
	      filters: {},
	      defaultSort: '',
	      keyForRow: function keyForRow(row) {
	        return row.id;
	      },
	      columnsForRow: function columnsForRow(row) {
	        return [];
	      },
	      defaultParams: {
	        per_page: 50
	      },
	      hasPagination: true,
	      hasSearch: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var queryParams = (this.props.location || {}).query || {};
	
	    return {
	      rows: [],
	      loading: true,
	      error: false,
	      pageLinks: null,
	      query: queryParams.query || '',
	      sortBy: queryParams.sortBy || this.props.defaultSort,
	      filters: Object.assign({}, queryParams)
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var queryParams = (nextProps.location || {}).query || {};
	    this.setState({
	      query: queryParams.query || '',
	      sortBy: queryParams.sortBy || this.props.defaultSort,
	      filters: Object.assign({}, queryParams),
	      pageLinks: null,
	      loading: true,
	      error: false
	    }, this.fetchData);
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  refresh: function refresh() {
	    this.setState({
	      loading: true
	    }, this.fetchData());
	  },
	
	  fetchData: function fetchData() {
	    var _this5 = this;
	
	    // TODO(dcramer): this should whitelist filters/sortBy/cursor/perPage
	    var queryParams = _jquery2['default'].extend({}, this.props.defaultParams, { sortBy: this.state.sortBy }, (this.props.location || {}).query || {});
	
	    this.api.request(this.props.endpoint, {
	      method: this.props.method,
	      data: queryParams,
	      success: function success(data, _, jqXHR) {
	        _this5.setState({
	          loading: false,
	          error: false,
	          rows: data,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this5.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  onSearch: function onSearch(e) {
	    var location = this.props.location || {};
	    var query = this.state.query;
	
	    var targetQueryParams = jQuery.extend({}, location.query || {}, {
	      query: query,
	      cursor: ''
	    });
	
	    e.preventDefault();
	
	    _reactRouter.browserHistory.pushState(null, this.props.path, targetQueryParams);
	  },
	
	  onQueryChange: function onQueryChange(evt) {
	    this.setState({ query: evt.target.value });
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'tr',
	      null,
	      _react2['default'].createElement(
	        'td',
	        { colSpan: this.props.columns.length },
	        _react2['default'].createElement(
	          'div',
	          { className: 'loading' },
	          _react2['default'].createElement('div', { className: 'loading-indicator' }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'loading-message' },
	            'Hold on to your butts!'
	          )
	        )
	      )
	    );
	  },
	
	  renderError: function renderError() {
	    return _react2['default'].createElement(
	      'tr',
	      null,
	      _react2['default'].createElement(
	        'td',
	        { colSpan: this.props.columns.length },
	        _react2['default'].createElement(
	          'div',
	          { className: 'alert-block alert-error' },
	          'Something bad happened :('
	        )
	      )
	    );
	  },
	
	  renderNoResults: function renderNoResults() {
	    return _react2['default'].createElement(
	      'tr',
	      null,
	      _react2['default'].createElement(
	        'td',
	        { colSpan: this.props.columns.length },
	        'No results found.'
	      )
	    );
	  },
	
	  renderResults: function renderResults() {
	    var _this6 = this;
	
	    return this.state.rows.map(function (row) {
	      return _react2['default'].createElement(
	        'tr',
	        { key: _this6.props.keyForRow(row) },
	        _this6.props.columnsForRow(row)
	      );
	    });
	  },
	
	  render: function render() {
	    var _this7 = this;
	
	    var filters = this.props.filters;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'result-grid' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'table-options' },
	        this.props.hasSearch && _react2['default'].createElement(
	          'div',
	          { className: 'result-grid-search' },
	          _react2['default'].createElement(
	            'form',
	            { onSubmit: this.onSearch },
	            _react2['default'].createElement(
	              'div',
	              { className: 'form-group' },
	              _react2['default'].createElement('input', { type: 'text',
	                className: 'form-control input-search',
	                placeholder: 'search',
	                style: { width: 300 },
	                name: 'query',
	                ref: 'searchInput',
	                autoComplete: 'off',
	                value: this.state.query,
	                onChange: this.onQueryChange }),
	              _react2['default'].createElement(
	                'button',
	                { type: 'submit', className: 'btn btn-sm btn-primary' },
	                _react2['default'].createElement('span', { className: 'icon-search' })
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(SortBy, { options: this.props.sortOptions,
	          value: this.state.sortBy,
	          path: this.props.path,
	          location: this.props.location }),
	        Object.keys(filters).map(function (filterKey) {
	          return _react2['default'].createElement(Filter, _extends({
	            key: filterKey,
	            queryKey: filterKey,
	            value: _this7.state.filters[filterKey],
	            path: _this7.props.path,
	            location: _this7.props.location
	          }, filters[filterKey]));
	        })
	      ),
	      _react2['default'].createElement(
	        'table',
	        { className: 'table table-grid' },
	        _react2['default'].createElement(
	          'thead',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            null,
	            this.props.columns
	          )
	        ),
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          this.state.loading ? this.renderLoading() : this.state.error ? this.renderError() : this.state.rows.length === 0 ? this.renderNoResults() : this.renderResults()
	        )
	      ),
	      this.props.hasPagination && this.state.pageLinks && _react2['default'].createElement(_pagination2['default'], { pageLinks: this.state.pageLinks })
	    );
	  }
	});
	
	exports['default'] = ResultGrid;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var SearchBar = _react2['default'].createClass({
	  displayName: 'SearchBar',
	
	  propTypes: {
	    query: _react2['default'].PropTypes.string,
	    defaultQuery: _react2['default'].PropTypes.string,
	    onSearch: _react2['default'].PropTypes.func,
	    onQueryChange: _react2['default'].PropTypes.func,
	    placeholder: _react2['default'].PropTypes.string
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultQuery: '',
	      query: '',
	      onSearch: function onSearch() {},
	      onQueryChange: function onQueryChange() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      query: this.props.query || this.props.defaultQuery
	    };
	  },
	
	  blur: function blur() {
	    _reactDom2['default'].findDOMNode(this.refs.searchInput).blur();
	  },
	
	  onSubmit: function onSubmit(evt) {
	    evt.preventDefault();
	    this.blur();
	    this.props.onSearch(this.state.query);
	  },
	
	  clearSearch: function clearSearch() {
	    var _this = this;
	
	    this.setState({ query: this.props.defaultQuery }, function () {
	      return _this.props.onSearch(_this.state.query);
	    });
	  },
	
	  onQueryFocus: function onQueryFocus() {
	    this.setState({
	      dropdownVisible: true
	    });
	  },
	
	  onQueryBlur: function onQueryBlur() {
	    this.setState({ dropdownVisible: false });
	  },
	
	  onQueryChange: function onQueryChange(evt) {
	    this.setState({ query: evt.target.value });
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'search' },
	      _react2['default'].createElement(
	        'form',
	        { className: 'form-horizontal', ref: 'searchForm', onSubmit: this.onSubmit },
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('input', { type: 'text', className: 'search-input form-control',
	            placeholder: this.props.placeholder,
	            name: 'query',
	            ref: 'searchInput',
	            autoComplete: 'off',
	            value: this.state.query,
	            onBlur: this.onQueryBlur,
	            onChange: this.onQueryChange
	          }),
	          _react2['default'].createElement('span', { className: 'icon-search' }),
	          this.state.query !== this.props.defaultQuery && _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { className: 'search-clear-form', onClick: this.clearSearch },
	              _react2['default'].createElement('span', { className: 'icon-circle-cross' })
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = SearchBar;
	module.exports = exports['default'];

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var SelectInput = _react2['default'].createClass({
	  displayName: 'SelectInput',
	
	  propTypes: {
	    disabled: _react2['default'].PropTypes.bool,
	    multiple: _react2['default'].PropTypes.bool,
	    required: _react2['default'].PropTypes.bool,
	    placeholder: _react2['default'].PropTypes.string,
	    value: _react2['default'].PropTypes.string,
	    onChange: _react2['default'].PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      // HTML attrs
	      disabled: false,
	      multiple: false,
	      required: false,
	
	      // Extra options
	      placeholder: 'Select an option...',
	
	      // Component options
	      value: '',
	      onChange: $.noop
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.create();
	    /*below is a hack for a bug in edge related to form submitting.
	    see: https://github.com/facebook/react/issues/7655
	    (@maxbittker)*/
	    if (this.refs.select) {
	      var selectedIndex = this.refs.select.selectedIndex;
	      if (selectedIndex >= 0) {
	        var options = this.refs.select.options;
	        var tempIndex = (selectedIndex + 1) % options.length;
	
	        options[tempIndex].selected = true;
	        options[selectedIndex].selected = true;
	      }
	    }
	  },
	
	  componentWillUpdate: function componentWillUpdate() {
	    this.destroy();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this.create();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.destroy();
	  },
	
	  getValue: function getValue() {
	    return this.select2.getValue();
	  },
	
	  create: function create() {
	    this.select2 = (0, _jquery2['default'])(this.refs.select).select2({
	      width: 'element'
	    });
	    this.select2.on('change', this.onChange);
	  },
	
	  destroy: function destroy() {
	    (0, _jquery2['default'])(this.refs.select).select2('destroy');
	  },
	
	  onChange: function onChange() {
	    var _props$onChange;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    (_props$onChange = this.props.onChange).call.apply(_props$onChange, [this, this.select2].concat(args));
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'select',
	      _extends({ ref: 'select' }, this.props),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = SelectInput;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__(2);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var TodoItem = _react2['default'].createClass({
	  displayName: 'TodoItem',
	
	  propTypes: {
	    task: _react2['default'].PropTypes.object,
	    onSkip: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      showConfirmation: false
	    };
	  },
	
	  toggleConfirmation: function toggleConfirmation() {
	    this.setState({ showConfirmation: !this.state.showConfirmation });
	  },
	
	  skip: function skip(task) {
	    this.props.onSkip(task);
	    this.setState({ showConfirmation: false });
	  },
	
	  render: function render() {
	    var org = this.getOrganization();
	
	    var classNames = '';
	    var description = undefined;
	
	    switch (this.props.task.status) {
	      case 'complete':
	        classNames += ' checked';
	        description = (0, _locale.tct)('[user] completed [dateCompleted]', {
	          user: this.props.task.user,
	          dateCompleted: (0, _moment2['default'])(this.props.task.dateCompleted).fromNow()
	        });
	        break;
	      case 'pending':
	        classNames += ' pending';
	        description = (0, _locale.tct)('[user] kicked off [dateCompleted]', {
	          user: this.props.task.user,
	          dateCompleted: (0, _moment2['default'])(this.props.task.dateCompleted).fromNow()
	        });
	        break;
	      case 'skipped':
	        classNames += ' skipped';
	        description = (0, _locale.tct)('[user] skipped [dateCompleted]', {
	          user: this.props.task.user,
	          dateCompleted: (0, _moment2['default'])(this.props.task.dateCompleted).fromNow()
	        });
	        break;
	      default:
	        description = this.props.task.description;
	    }
	
	    if (this.state.showConfirmation) {
	      classNames += ' blur';
	    }
	
	    var learnMoreUrl = '';
	    if (this.props.task.featureLocation === 'project') {
	      learnMoreUrl = '/organizations/' + org.slug + '/projects/choose/?onboarding=1&task=' + this.props.task.task;
	    } else if (this.props.task.featureLocation === 'organization') {
	      learnMoreUrl = '/organizations/' + org.slug + '/' + this.props.task.location;
	    } else if (this.props.task.featureLocation === 'absolute') {
	      learnMoreUrl = this.props.task.location;
	    }
	
	    var showSkipButton = this.props.task.skippable && this.props.task.status != 'skipped' && this.props.task.status != 'complete' && !this.state.showConfirmation;
	
	    return _react2['default'].createElement(
	      'li',
	      { className: classNames },
	      this.props.task.status == 'pending' && _react2['default'].createElement('div', { className: 'pending-bar' }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'todo-content' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'ob-checkbox' },
	          this.props.task.status == 'complete' && _react2['default'].createElement('span', { className: 'icon-checkmark' }),
	          this.props.task.status == 'skipped' && _react2['default'].createElement('span', { className: 'icon-x' }),
	          this.props.task.status == 'pending' && _react2['default'].createElement('span', { className: 'icon-ellipsis' })
	        ),
	        _react2['default'].createElement(
	          'a',
	          { href: learnMoreUrl },
	          _react2['default'].createElement(
	            'h4',
	            null,
	            this.props.task.title
	          )
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          description
	        ),
	        showSkipButton && _react2['default'].createElement(
	          'a',
	          { className: 'skip-btn btn btn-default', onClick: this.toggleConfirmation },
	          (0, _locale.t)('Skip')
	        )
	      ),
	      this.state.showConfirmation && _react2['default'].createElement(Confirmation, { task: this.props.task.task, onSkip: this.skip, dismiss: this.toggleConfirmation })
	    );
	  }
	});
	
	var Confirmation = _react2['default'].createClass({
	  displayName: 'Confirmation',
	
	  propTypes: {
	    task: _react2['default'].PropTypes.number,
	    onSkip: _react2['default'].PropTypes.func.isRequired,
	    dismiss: _react2['default'].PropTypes.func.isRequired
	  },
	
	  skip: function skip(e) {
	    e.preventDefault();
	    this.props.onSkip(this.props.task);
	  },
	
	  dismiss: function dismiss() {
	    this.props.dismiss();
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'ob-confirmation', onClick: this.dismiss },
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('Need help?')
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'a',
	          { href: 'mailto:support@sentry.io?subject=Help with onboarding' },
	          (0, _locale.t)('Ask us!')
	        ),
	        ' · ',
	        _react2['default'].createElement(
	          'a',
	          { onClick: this.skip },
	          (0, _locale.t)('Skip')
	        )
	      )
	    );
	  }
	});
	
	var TodoList = _react2['default'].createClass({
	  displayName: 'TodoList',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsOrganizationState2['default']],
	
	  statics: {
	    TASKS: [{
	      'task': 1,
	      'title': (0, _locale.t)('Create a project'),
	      'description': (0, _locale.t)('Create your first Sentry project'),
	      'skippable': false,
	      'prereq': [],
	      'featureLocation': 'organization',
	      'location': 'projects/new/'
	    }, {
	      'task': 2,
	      'title': (0, _locale.t)('Send your first event'),
	      'description': (0, _locale.t)('Install Sentry\'s client and send an event'),
	      'skippable': false,
	      'prereq': [1],
	      'featureLocation': 'project',
	      'location': 'settings/install/'
	    }, {
	      'task': 3,
	      'title': (0, _locale.t)('Invite team member'),
	      'description': (0, _locale.t)('Bring your team aboard'),
	      'skippable': true,
	      'prereq': [],
	      'featureLocation': 'organization',
	      'location': 'members/'
	    }, {
	      'task': 4,
	      'title': (0, _locale.t)('Add a second platform'),
	      'description': (0, _locale.t)('Add Sentry to a second platform'),
	      'skippable': true,
	      'prereq': [1, 2],
	      'featureLocation': 'organization',
	      'location': 'projects/new/'
	    }, {
	      'task': 5,
	      'title': (0, _locale.t)('Add user context'),
	      'description': (0, _locale.t)('Know who is being affected by crashes'),
	      'skippable': true,
	      'prereq': [1, 2],
	      'featureLocation': 'absolute',
	      'location': 'https://docs.sentry.io/hosted/learn/context/#capturing-the-user'
	    }, {
	      'task': 6,
	      'title': (0, _locale.t)('Set up release tracking'),
	      'description': (0, _locale.t)('See what releases are generating errors.'),
	      'skippable': true,
	      'prereq': [1, 2],
	      'featureLocation': 'project',
	      'location': 'settings/release-tracking/'
	    }, {
	      'task': 7,
	      'title': (0, _locale.t)('Upload sourcemaps'),
	      'description': (0, _locale.t)('Deminify javascript stacktraces'),
	      'skippable': true,
	      'prereq': [1, 2], // Is one of the platforms javascript?
	      'featureLocation': 'absolute',
	      'location': 'https://docs.sentry.io/hosted/clients/javascript/sourcemaps/'
	    },
	    // {
	    //   'task': 8,
	    //   'title': 'User crash reports',
	    //   'description': 'Collect user feedback when your application crashes',
	    //   'skippable': false,
	    //   'prereq': [1, 2, 5]
	    //   'featureLocation': 'project',
	    //   'location': 'settings/user-reports/'
	    // },
	    {
	      'task': 9,
	      'title': (0, _locale.t)('Set up issue tracking'),
	      'description': (0, _locale.t)('Link to Sentry issues within your issue tracker'),
	      'skippable': true,
	      'prereq': [1, 2],
	      'featureLocation': 'project',
	      'location': 'settings/issue-tracking/'
	    }, {
	      'task': 10,
	      'title': (0, _locale.t)('Set up an alerts service'),
	      'description': (0, _locale.t)('Receive Sentry alerts in Slack or HipChat'),
	      'skippable': true,
	      'prereq': [1, 2],
	      'featureLocation': 'project',
	      'location': 'settings/alerts/'
	    }]
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      tasks: [],
	      seeAll: false };
	  },
	
	  // Show all tasks, included those completed
	  componentWillMount: function componentWillMount() {
	    // Map server task state (who finished what) to TodoList.TASK objects
	    var org = this.getOrganization();
	    var tasks = TodoList.TASKS.map(function (task) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = org.onboardingTasks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var server_task = _step.value;
	
	          if (server_task.task == task.task) {
	            Object.assign(task, server_task);
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator['return']) {
	            _iterator['return']();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return task;
	    });
	    this.setState({ tasks: tasks });
	  },
	
	  skipTask: function skipTask(skipped_task) {
	    var _this = this;
	
	    var org = this.getOrganization();
	    this.api.request('/organizations/' + org.slug + '/onboarding-tasks/', {
	      method: 'POST',
	      data: { 'task': skipped_task, 'status': 'skipped' },
	      success: function success() {
	        var new_state = _this.state.tasks.map(function (task) {
	          if (task.task == skipped_task) {
	            task.status = 'skipped';
	          }
	          return task;
	        });
	        _this.setState({ tasks: new_state });
	      }
	    });
	    this.getOnboardingTasks();
	  },
	
	  click: function click(e) {
	    // e.preventDefault();
	    e.stopPropagation();
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var nextTasks = this.state.tasks;
	
	    var todo_list = nextTasks.map(function (task) {
	      return _react2['default'].createElement(TodoItem, { key: task.task, task: task, onSkip: _this2.skipTask });
	    }, this);
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { onClick: this.click, className: 'onboarding-wrapper' },
	        _react2['default'].createElement(
	          'ul',
	          { className: 'list-unstyled' },
	          todo_list
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = TodoList;
	module.exports = exports['default'];

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsSettings = __webpack_require__(613);
	
	var _componentsSettings2 = _interopRequireDefault(_componentsSettings);
	
	var BasePlugin = (function () {
	    function BasePlugin(data) {
	        _classCallCheck(this, BasePlugin);
	
	        Object.assign(this, data);
	    }
	
	    _createClass(BasePlugin, [{
	        key: 'renderSettings',
	        value: function renderSettings(props) {
	            return _react2['default'].createElement(_componentsSettings2['default'], _extends({ plugin: this }, props));
	        }
	    }]);
	
	    return BasePlugin;
	})();
	
	BasePlugin.DefaultSettings = _componentsSettings2['default'];
	
	exports['default'] = BasePlugin;
	module.exports = exports['default'];

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _registry = __webpack_require__(615);
	
	var _registry2 = _interopRequireDefault(_registry);
	
	var _basePlugin = __webpack_require__(192);
	
	var _basePlugin2 = _interopRequireDefault(_basePlugin);
	
	var _defaultIssuePlugin = __webpack_require__(301);
	
	var _defaultIssuePlugin2 = _interopRequireDefault(_defaultIssuePlugin);
	
	var registry = new _registry2['default']();
	
	exports.BasePlugin = _basePlugin2['default'];
	exports.registry = registry;
	exports.DefaultIssuePlugin = _defaultIssuePlugin2['default'];
	exports['default'] = {
	    BasePlugin: _basePlugin2['default'],
	    DefaultIssuePlugin: _defaultIssuePlugin2['default'],
	
	    add: registry.add.bind(registry),
	    get: registry.get.bind(registry),
	    isLoaded: registry.isLoaded.bind(registry),
	    load: registry.load.bind(registry),
	    loadAll: registry.loadAll.bind(registry)
	};

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _actionsProjectActions = __webpack_require__(264);
	
	var _actionsProjectActions2 = _interopRequireDefault(_actionsProjectActions);
	
	var ProjectStore = _reflux2['default'].createStore({
	  init: function init() {
	    this.reset();
	
	    this.listenTo(_actionsProjectActions2['default'].updateSuccess, this.onUpdateSuccess);
	    this.listenTo(_actionsProjectActions2['default'].loadStatsSuccess, this.onStatsLoadSuccess);
	  },
	
	  reset: function reset() {
	    this.items = [];
	    this.itemsById = {};
	  },
	
	  loadInitialData: function loadInitialData(items) {
	    this.items = items;
	    this.itemsById = this.items.reduce(function (map, project) {
	      map[project.id] = project;
	      return map;
	    }, {});
	    this.trigger(new Set(Object.keys(this.itemsById)));
	  },
	
	  onUpdateSuccess: function onUpdateSuccess(data) {
	    var project = this.getById(data.id);
	    Object.assign(project, data);
	    this.trigger(new Set([data.id]));
	  },
	
	  onStatsLoadSuccess: function onStatsLoadSuccess(data) {
	    var _this = this;
	
	    var touchedIds = [];
	    _underscore2['default'].each(data || [], function (stats, projectId) {
	      if (projectId in _this.itemsById) {
	        _this.itemsById[projectId].stats = stats;
	        touchedIds.push(projectId);
	      }
	    });
	    this.trigger(new Set(touchedIds));
	  },
	
	  getAll: function getAll() {
	    return this.items;
	  },
	
	  getById: function getById(id) {
	    return this.items.find(function (project) {
	      return project.id === id;
	    });
	  },
	
	  getBySlug: function getBySlug(slug) {
	    return this.items.find(function (project) {
	      return project.slug === slug;
	    });
	  }
	});
	
	exports['default'] = ProjectStore;
	module.exports = exports['default'];

/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function (header) {
	  if (header === null) {
	    return {};
	  }
	
	  var header_vals = header.split(','),
	      links = {};
	
	  header_vals.forEach(function (val) {
	    var match = /<([^>]+)>; rel="([^"]+)"(?:; results="([^"]+)")?(?:; cursor="([^"]+)")?/g.exec(val);
	    var hasResults = match[3] === 'true' ? true : match[3] === 'false' ? false : null;
	
	    links[match[2]] = {
	      href: match[1],
	      results: hasResults,
	      cursor: match[4]
	    };
	  });
	
	  return links;
	};
	
	module.exports = exports['default'];

/***/ },
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	exports['default'] = _reflux2['default'].createActions(['update', 'updateError', 'updateSuccess']);
	module.exports = exports['default'];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	exports['default'] = _reflux2['default'].createActions(['update', 'updateError', 'updateSuccess', 'loadStats', 'loadStatsError', 'loadStatsSuccess']);
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	exports['default'] = _reflux2['default'].createActions(['loadTags', 'loadTagsError', 'loadTagsSuccess']);
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var TeamActions = _reflux2['default'].createActions(['update', 'updateError', 'updateSuccess']);
	
	exports['default'] = TeamActions;
	module.exports = exports['default'];

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _marked = __webpack_require__(143);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _utilsLogging = __webpack_require__(142);
	
	var _utilsLocalStorage = __webpack_require__(306);
	
	var _locale = __webpack_require__(2);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var localStorageKey = 'noteinput:latest';
	
	function makeDefaultErrorJson() {
	  return { detail: (0, _locale.t)('Unknown error. Please try again.') };
	}
	
	var NoteInput = _react2['default'].createClass({
	  displayName: 'NoteInput',
	
	  propTypes: {
	    item: _react2['default'].PropTypes.object,
	    group: _react2['default'].PropTypes.object.isRequired,
	    onFinish: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default'], _mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var item = _props.item;
	    var group = _props.group;
	
	    var updating = !!item;
	    var defaultText = '';
	
	    if (updating) {
	      defaultText = item.data.text;
	    } else {
	      var storage = (0, _utilsLocalStorage.getItem)(localStorageKey);
	      if (storage) {
	        var _JSON$parse = JSON.parse(storage);
	
	        var groupId = _JSON$parse.groupId;
	        var value = _JSON$parse.value;
	
	        if (groupId === group.id) {
	          defaultText = value;
	        }
	      }
	    }
	
	    return {
	      loading: false,
	      error: false,
	      errorJSON: null,
	      expanded: false,
	      preview: false,
	      updating: updating,
	      value: defaultText
	    };
	  },
	
	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    // We can't support this when editing an existing Note since it'll
	    // clobber the other storages
	    if (this.state.updating) return;
	
	    // Nothing changed
	    if (this.state.value === nextState.value) return;
	
	    try {
	      (0, _utilsLocalStorage.setItem)(localStorageKey, JSON.stringify({
	        groupId: this.props.group.id,
	        value: nextState.value
	      }));
	    } catch (ex) {
	      (0, _utilsLogging.logException)(ex);
	    }
	  },
	
	  toggleEdit: function toggleEdit() {
	    this.setState({ preview: false });
	  },
	
	  togglePreview: function togglePreview() {
	    this.setState({ preview: true });
	  },
	
	  onSubmit: function onSubmit(e) {
	    e.preventDefault();
	    this.submitForm();
	  },
	
	  submitForm: function submitForm() {
	    this.setState({
	      loading: true,
	      error: false,
	      errorJSON: null
	    });
	
	    if (this.state.updating) {
	      this.update();
	    } else {
	      this.create();
	    }
	  },
	
	  create: function create() {
	    var _this = this;
	
	    var group = this.props.group;
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Posting comment..'));
	
	    this.api.request('/issues/' + group.id + '/comments/', {
	      method: 'POST',
	      data: {
	        text: this.state.value
	      },
	      error: function error(_error) {
	        _this.setState({
	          loading: false,
	          preview: false,
	          error: true,
	          errorJSON: _error.responseJSON || makeDefaultErrorJson()
	        });
	      },
	      success: function success(data) {
	        _this.setState({
	          value: '',
	          preview: false,
	          expanded: false,
	          loading: false
	        });
	        _storesGroupStore2['default'].addActivity(group.id, data);
	        _this.finish();
	      },
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  update: function update() {
	    var _this2 = this;
	
	    var _props2 = this.props;
	    var group = _props2.group;
	    var item = _props2.item;
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Updating comment..'));
	
	    this.api.request('/issues/' + group.id + '/comments/' + item.id + '/', {
	      method: 'PUT',
	      data: {
	        text: this.state.value
	      },
	      error: function error(_error2) {
	        _this2.setState({
	          loading: false,
	          preview: false,
	          error: true,
	          errorJSON: _error2.responseJSON || makeDefaultErrorJson()
	        });
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      },
	      success: function success(data) {
	        _this2.setState({
	          preview: false,
	          expanded: false,
	          loading: false
	        });
	        _storesGroupStore2['default'].updateActivity(group.id, item.id, { text: _this2.state.value });
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	        _this2.finish();
	      }
	    });
	  },
	
	  onChange: function onChange(e) {
	    this.setState({ value: e.target.value });
	  },
	
	  onKeyDown: function onKeyDown(e) {
	    // Auto submit the form on [meta] + Enter
	    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
	      this.submitForm();
	    }
	  },
	
	  onCancel: function onCancel(e) {
	    e.preventDefault();
	    this.finish();
	  },
	
	  finish: function finish() {
	    this.props.onFinish && this.props.onFinish();
	  },
	
	  expand: function expand(e) {
	    this.setState({ expanded: true });
	
	    // HACK: Move cursor to end of text after autoFocus
	    // we do this my making sure this is only done on the first
	    // onFocus event
	    if (!this.state._hasFocused) {
	      this.setState({ _hasFocused: true });
	      var value = e.target.value;
	      e.target.value = '';
	      e.target.value = value;
	    }
	  },
	
	  maybeCollapse: function maybeCollapse() {
	    if (this.state.value === '') {
	      this.setState({ expanded: false });
	    }
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var error = _state.error;
	    var errorJSON = _state.errorJSON;
	    var loading = _state.loading;
	    var preview = _state.preview;
	    var updating = _state.updating;
	    var value = _state.value;
	
	    var classNames = 'activity-field';
	    if (error) {
	      classNames += ' error';
	    }
	    if (loading) {
	      classNames += ' loading';
	    }
	
	    var btnText = updating ? (0, _locale.t)('Save Comment') : (0, _locale.t)('Post Comment');
	
	    return _react2['default'].createElement(
	      'form',
	      { className: classNames, onSubmit: this.onSubmit },
	      _react2['default'].createElement(
	        'div',
	        { className: 'activity-notes' },
	        _react2['default'].createElement(
	          'ul',
	          { className: 'nav nav-tabs' },
	          _react2['default'].createElement(
	            'li',
	            { className: !preview ? 'active' : '' },
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.toggleEdit },
	              updating ? (0, _locale.t)('Edit') : (0, _locale.t)('Write')
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            { className: preview ? 'active' : '' },
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.togglePreview },
	              (0, _locale.t)('Preview')
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            { className: 'markdown' },
	            _react2['default'].createElement('span', { className: 'icon-markdown' }),
	            _react2['default'].createElement(
	              'span',
	              { className: 'supported' },
	              (0, _locale.t)('Markdown supported')
	            )
	          )
	        ),
	        preview ? _react2['default'].createElement('div', { className: 'note-preview',
	          dangerouslySetInnerHTML: { __html: (0, _marked2['default'])(value) } }) : _react2['default'].createElement('textarea', { placeholder: (0, _locale.t)('Add details or updates to this event'),
	          onChange: this.onChange,
	          onKeyDown: this.onKeyDown,
	          onFocus: this.expand, onBlur: this.maybeCollapse,
	          required: true,
	          autoFocus: true,
	          value: value }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'activity-actions' },
	          errorJSON && errorJSON.detail && _react2['default'].createElement(
	            'small',
	            { className: 'error' },
	            errorJSON.detail
	          ),
	          _react2['default'].createElement(
	            'button',
	            { className: 'btn btn-default', type: 'submit',
	              disabled: loading },
	            btnText
	          ),
	          updating && _react2['default'].createElement(
	            'button',
	            { className: 'btn btn-danger', onClick: this.onCancel },
	            (0, _locale.t)('Cancel')
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = NoteInput;
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _storesAlertStore = __webpack_require__(617);
	
	var _storesAlertStore2 = _interopRequireDefault(_storesAlertStore);
	
	var _alertMessage = __webpack_require__(541);
	
	var _alertMessage2 = _interopRequireDefault(_alertMessage);
	
	var Alerts = _react2['default'].createClass({
	  displayName: 'Alerts',
	
	  mixins: [_reactAddonsPureRenderMixin2['default'], _reflux2['default'].connect(_storesAlertStore2['default'], 'alerts')],
	
	  getInitialState: function getInitialState() {
	    return {
	      alerts: []
	    };
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      this.props,
	      this.state.alerts.map(function (alert) {
	        return _react2['default'].createElement(_alertMessage2['default'], { alert: alert, key: alert.key });
	      })
	    );
	  }
	});
	
	exports['default'] = Alerts;
	module.exports = exports['default'];

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _dropdownLink = __webpack_require__(33);
	
	var _dropdownLink2 = _interopRequireDefault(_dropdownLink);
	
	var _storesMemberListStore = __webpack_require__(91);
	
	var _storesMemberListStore2 = _interopRequireDefault(_storesMemberListStore);
	
	var _menuItem = __webpack_require__(37);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _utilsFormatters = __webpack_require__(305);
	
	var _utils = __webpack_require__(7);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _locale = __webpack_require__(2);
	
	var AssigneeSelector = _react2['default'].createClass({
	  displayName: 'AssigneeSelector',
	
	  propTypes: {
	    id: _react2['default'].PropTypes.string.isRequired
	  },
	
	  mixins: [_reflux2['default'].listenTo(_storesGroupStore2['default'], 'onGroupChange'), (0, _mixinsTooltip2['default'])({
	    selector: '.tip'
	  }), _mixinsApiMixin2['default']],
	
	  statics: {
	    filterMembers: function filterMembers(memberList, filter) {
	      if (!filter) return memberList;
	
	      filter = filter.toLowerCase();
	      return memberList.filter(function (item) {
	        var fullName = [item.name, item.email].join(' ').toLowerCase();
	
	        return fullName.indexOf(filter) !== -1;
	      });
	    },
	
	    putSessionUserFirst: function putSessionUserFirst(members) {
	      // If session user is in the filtered list of members, put them at the top
	      var sessionUser = _storesConfigStore2['default'].get('user');
	      var sessionUserIndex = members.findIndex(function (member) {
	        return sessionUser && member.id === sessionUser.id;
	      });
	
	      if (sessionUserIndex === -1) return members;
	
	      return [members[sessionUserIndex]].concat(members.slice(0, sessionUserIndex)).concat(members.slice(sessionUserIndex + 1));
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    var group = _storesGroupStore2['default'].get(this.props.id);
	
	    return {
	      assignedTo: group.assignedTo,
	      memberList: _storesMemberListStore2['default'].getAll(),
	      filter: '',
	      loading: false
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var loading = _storesGroupStore2['default'].hasStatus(nextProps.id, 'assignTo');
	    if (nextProps.id != this.props.id || loading != this.state.loading) {
	      var group = _storesGroupStore2['default'].get(this.props.id);
	      this.setState({
	        assignedTo: group.assignedTo,
	        memberList: _storesMemberListStore2['default'].getAll(),
	        loading: loading
	      });
	    }
	  },
	
	  // TODO(dcramer): this should check changes in member list
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (nextState.filter !== this.state.filter) {
	      return true;
	    }
	    if (nextState.loading !== this.state.loading) {
	      return true;
	    }
	    return !(0, _utils.valueIsEqual)(nextState.assignedTo, this.state.assignedTo, true);
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    // XXX(dcramer): fix odd dedraw issue as of Chrome 45.0.2454.15 dev (64-bit)
	    var node = jQuery(_reactDom2['default'].findDOMNode(this.refs.container));
	    node.hide().show(0);
	    var oldAssignee = prevState.assignedTo && prevState.assignedTo.id;
	    var newAssignee = this.state.assignedTo && this.state.assignedTo.id;
	    if (oldAssignee !== newAssignee) {
	      this.removeTooltips();
	      if (newAssignee) {
	        this.attachTooltips();
	      }
	    }
	  },
	
	  onGroupChange: function onGroupChange(itemIds) {
	    if (!itemIds.has(this.props.id)) {
	      return;
	    }
	    var group = _storesGroupStore2['default'].get(this.props.id);
	    this.setState({
	      assignedTo: group.assignedTo,
	      loading: _storesGroupStore2['default'].hasStatus(this.props.id, 'assignTo')
	    });
	  },
	
	  assignTo: function assignTo(member) {
	    this.api.assignTo({ id: this.props.id, member: member });
	    this.setState({ filter: '', loading: true });
	  },
	
	  clearAssignTo: function clearAssignTo() {
	    this.api.assignTo({ id: this.props.id });
	    this.setState({ filter: '', loading: true });
	  },
	
	  onFilterKeyUp: function onFilterKeyUp(evt) {
	    if (evt.key === 'Escape') {
	      this.refs.dropdown.close();
	    } else {
	      this.setState({
	        filter: evt.target.value
	      });
	    }
	  },
	
	  onFilterKeyDown: function onFilterKeyDown(evt) {
	    if (evt.key === 'Enter' && this.state.filter) {
	      var members = AssigneeSelector.filterMembers(this.state.memberList, this.state.filter);
	      if (members.length > 0) {
	        this.assignTo(members[0]);
	      }
	    }
	  },
	
	  onDropdownOpen: function onDropdownOpen() {
	    _reactDom2['default'].findDOMNode(this.refs.filter).focus();
	  },
	
	  onDropdownClose: function onDropdownClose() {
	    this.setState({
	      filter: ''
	    });
	  },
	
	  highlight: function highlight(text, highlightText) {
	    if (!highlightText) {
	      return text;
	    }
	    highlightText = highlightText.toLowerCase();
	    var idx = text.toLowerCase().indexOf(highlightText);
	    if (idx === -1) {
	      return text;
	    }
	    return _react2['default'].createElement(
	      'span',
	      null,
	      text.substr(0, idx),
	      _react2['default'].createElement(
	        'strong',
	        { className: 'highlight' },
	        text.substr(idx, highlightText.length)
	      ),
	      text.substr(idx + highlightText.length)
	    );
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var loading = this.state.loading;
	    var assignedTo = this.state.assignedTo;
	
	    var className = 'assignee-selector anchor-right';
	    if (!assignedTo) {
	      className += ' unassigned';
	    }
	
	    var members = AssigneeSelector.filterMembers(this.state.memberList, this.state.filter);
	    members = AssigneeSelector.putSessionUserFirst(members);
	
	    var memberNodes = members.map(function (item) {
	      return _react2['default'].createElement(
	        _menuItem2['default'],
	        { key: item.id,
	          disabled: loading,
	          onSelect: _this.assignTo.bind(_this, item) },
	        _react2['default'].createElement(_componentsAvatar2['default'], { user: item, className: 'avatar', size: 48 }),
	        _this.highlight(item.name || item.email, _this.state.filter)
	      );
	    });
	
	    if (memberNodes.length === 0) {
	      memberNodes = [_react2['default'].createElement(
	        'li',
	        { className: 'not-found', key: 'no-user' },
	        _react2['default'].createElement(
	          'span',
	          null,
	          (0, _locale.t)('No matching users found.')
	        )
	      )];
	    }
	
	    var tooltipTitle = null;
	    if (assignedTo) {
	      tooltipTitle = (0, _utilsFormatters.userDisplayName)(assignedTo);
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { ref: 'container' },
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(className, 'tip'), title: tooltipTitle },
	        loading ? _react2['default'].createElement(_componentsLoadingIndicator2['default'], { mini: true }) : _react2['default'].createElement(
	          _dropdownLink2['default'],
	          {
	            ref: 'dropdown',
	            className: 'assignee-selector-toggle',
	            onOpen: this.onDropdownOpen,
	            onClose: this.onDropdownClose,
	            title: assignedTo ? _react2['default'].createElement(_componentsAvatar2['default'], { user: assignedTo, className: 'avatar', size: 48 }) : _react2['default'].createElement('span', { className: 'icon-user' }) },
	          _react2['default'].createElement(
	            _menuItem2['default'],
	            { noAnchor: true, key: 'filter' },
	            _react2['default'].createElement('input', { type: 'text', className: 'form-control input-sm',
	              placeholder: (0, _locale.t)('Filter people'), ref: 'filter',
	              onKeyDown: this.onFilterKeyDown,
	              onKeyUp: this.onFilterKeyUp })
	          ),
	          assignedTo ? _react2['default'].createElement(
	            _menuItem2['default'],
	            { key: 'clear',
	              className: 'clear-assignee',
	              disabled: !loading,
	              onSelect: this.clearAssignTo },
	            _react2['default'].createElement('span', { className: 'icon-circle-cross' }),
	            ' ',
	            (0, _locale.t)('Clear Assignee')
	          ) : '',
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'ul',
	              null,
	              memberNodes
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = AssigneeSelector;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _dropdownLink = __webpack_require__(33);
	
	var _dropdownLink2 = _interopRequireDefault(_dropdownLink);
	
	var _issuesSnoozeAction = __webpack_require__(594);
	
	var _issuesSnoozeAction2 = _interopRequireDefault(_issuesSnoozeAction);
	
	var _streamGroupChart = __webpack_require__(297);
	
	var _streamGroupChart2 = _interopRequireDefault(_streamGroupChart);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _link = __webpack_require__(182);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _locale = __webpack_require__(2);
	
	var CompactIssueHeader = _react2['default'].createClass({
	  displayName: 'CompactIssueHeader',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired,
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired
	  },
	
	  getTitle: function getTitle() {
	    var data = this.props.data;
	    var metadata = data.metadata;
	    switch (data.type) {
	      case 'error':
	        return _react2['default'].createElement(
	          'span',
	          null,
	          _react2['default'].createElement(
	            'span',
	            { style: { marginRight: 10 } },
	            metadata.type
	          ),
	          _react2['default'].createElement(
	            'em',
	            null,
	            data.culprit
	          ),
	          _react2['default'].createElement('br', null)
	        );
	      case 'csp':
	        return _react2['default'].createElement(
	          'span',
	          null,
	          _react2['default'].createElement(
	            'span',
	            { style: { marginRight: 10 } },
	            metadata.directive
	          ),
	          _react2['default'].createElement(
	            'em',
	            null,
	            metadata.uri
	          ),
	          _react2['default'].createElement('br', null)
	        );
	      case 'default':
	        return _react2['default'].createElement(
	          'span',
	          null,
	          metadata.title
	        );
	      default:
	        return _react2['default'].createElement(
	          'span',
	          null,
	          data.title
	        );
	    }
	  },
	
	  getMessage: function getMessage() {
	    var data = this.props.data;
	    var metadata = data.metadata;
	    switch (data.type) {
	      case 'error':
	        return metadata.value;
	      case 'csp':
	        return metadata.message;
	      default:
	        return '';
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	    var data = _props.data;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement('span', { className: 'error-level truncate', title: data.level }),
	      _react2['default'].createElement(
	        'h3',
	        { className: 'truncate' },
	        _react2['default'].createElement(
	          _link2['default'],
	          { to: '/' + orgId + '/' + projectId + '/issues/' + data.id + '/' },
	          _react2['default'].createElement('span', { className: 'icon icon-soundoff' }),
	          _react2['default'].createElement('span', { className: 'icon icon-star-solid' }),
	          this.getTitle()
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'event-extra' },
	        _react2['default'].createElement(
	          'span',
	          { className: 'project-name' },
	          _react2['default'].createElement(
	            _link2['default'],
	            { to: '/' + orgId + '/' + projectId + '/' },
	            data.project.name
	          )
	        ),
	        data.numComments !== 0 && _react2['default'].createElement(
	          'span',
	          null,
	          _react2['default'].createElement(
	            _link2['default'],
	            { to: '/' + orgId + '/' + projectId + '/issues/' + data.id + '/activity/', className: 'comments' },
	            _react2['default'].createElement('span', { className: 'icon icon-comments' }),
	            _react2['default'].createElement(
	              'span',
	              { className: 'tag-count' },
	              data.numComments
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'span',
	          { className: 'culprit' },
	          this.getMessage()
	        )
	      )
	    );
	  }
	});
	
	var CompactIssue = _react2['default'].createClass({
	  displayName: 'CompactIssue',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object,
	    id: _react2['default'].PropTypes.string,
	    orgId: _react2['default'].PropTypes.string,
	    statsPeriod: _react2['default'].PropTypes.string,
	    showActions: _react2['default'].PropTypes.bool
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _reflux2['default'].listenTo(_storesGroupStore2['default'], 'onGroupChange')],
	
	  getInitialState: function getInitialState() {
	    return {
	      issue: this.props.data || _storesGroupStore2['default'].get(this.props.id)
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.id != this.props.id) {
	      this.setState({
	        issue: _storesGroupStore2['default'].get(this.props.id)
	      });
	    }
	  },
	
	  onGroupChange: function onGroupChange(itemIds) {
	    if (!itemIds.has(this.props.id)) {
	      return;
	    }
	    var id = this.props.id;
	    var issue = _storesGroupStore2['default'].get(id);
	    this.setState({
	      issue: issue
	    });
	  },
	
	  onSnooze: function onSnooze(duration) {
	    var data = {
	      status: 'ignored'
	    };
	
	    if (duration) data.ignoreDuration = duration;
	
	    this.onUpdate(data);
	  },
	
	  onUpdate: function onUpdate(data) {
	    var issue = this.state.issue;
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	
	    this.api.bulkUpdate({
	      orgId: this.props.orgId,
	      projectId: issue.project.slug,
	      itemIds: [issue.id],
	      data: data
	    }, {
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  render: function render() {
	    var issue = this.state.issue;
	
	    var className = 'issue';
	    if (issue.isBookmarked) {
	      className += ' isBookmarked';
	    }
	    if (issue.hasSeen) {
	      className += ' hasSeen';
	    }
	    if (issue.status === 'resolved') {
	      className += ' isResolved';
	    }
	    if (issue.status === 'ignored') {
	      className += ' isIgnored';
	    }
	
	    className += ' level-' + issue.level;
	
	    if (this.props.statsPeriod) {
	      className += ' with-graph';
	    }
	
	    var _props2 = this.props;
	    var id = _props2.id;
	    var orgId = _props2.orgId;
	
	    var projectId = issue.project.slug;
	    var title = _react2['default'].createElement('span', { className: 'icon-more' });
	
	    return _react2['default'].createElement(
	      'li',
	      { className: className, onClick: this.toggleSelect },
	      _react2['default'].createElement(CompactIssueHeader, { data: issue, orgId: orgId, projectId: projectId }),
	      this.props.statsPeriod && _react2['default'].createElement(
	        'div',
	        { className: 'event-graph' },
	        _react2['default'].createElement(_streamGroupChart2['default'], { id: id, statsPeriod: this.props.statsPeriod, data: this.props.data })
	      ),
	      this.props.showActions && _react2['default'].createElement(
	        'div',
	        { className: 'more-menu-container align-right' },
	        _react2['default'].createElement(
	          _dropdownLink2['default'],
	          {
	            topLevelClasses: 'more-menu',
	            className: 'more-menu-toggle',
	            caret: false,
	            title: title },
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.onUpdate.bind(this, { status: issue.status !== 'resolved' ? 'resolved' : 'unresolved' }) },
	              _react2['default'].createElement('span', { className: 'icon-checkmark' })
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.onUpdate.bind(this, { isBookmarked: !issue.isBookmarked }) },
	              _react2['default'].createElement('span', { className: 'icon-star-solid' })
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(_issuesSnoozeAction2['default'], {
	              orgId: orgId,
	              projectId: projectId,
	              groupId: id,
	              onSnooze: this.onSnooze })
	          ),
	          false && _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: '#' },
	              _react2['default'].createElement('span', { className: 'icon-user' })
	            )
	          )
	        )
	      ),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = CompactIssue;
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__(2);
	
	var NotFound = _react2['default'].createClass({
	  displayName: 'NotFound',
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'alert alert-block alert-error' },
	      _react2['default'].createElement(
	        'div',
	        { style: { fontSize: 24, marginBottom: 10 } },
	        _react2['default'].createElement('span', { className: 'icon-exclamation', style: { fontSize: 20, marginRight: 10 } }),
	        _react2['default'].createElement(
	          'span',
	          null,
	          (0, _locale.t)('Page Not Found')
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'The page you are looking for was not found.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'You may wish to try the following:'
	      ),
	      _react2['default'].createElement(
	        'ul',
	        null,
	        _react2['default'].createElement(
	          'li',
	          null,
	          'If you entered the address manually, double check the path. Did you forget a trailing slash?'
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          'If you followed a link here, try hitting back and reloading the page. It\'s possible the resource was moved out from under you.'
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          'If all else fails, ',
	          _react2['default'].createElement(
	            'a',
	            { href: 'http://github.com/getsentry/sentry/issues' },
	            'create an issue'
	          ),
	          ' with more details.'
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Not sure what to do? ',
	        _react2['default'].createElement(
	          'a',
	          { href: '/' },
	          'Return to the dashboard'
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = NotFound;
	module.exports = exports['default'];

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsLogging = __webpack_require__(142);
	
	var _contexts = __webpack_require__(548);
	
	var _contexts2 = _interopRequireDefault(_contexts);
	
	var _contextSummary = __webpack_require__(547);
	
	var _contextSummary2 = _interopRequireDefault(_contextSummary);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _errors = __webpack_require__(556);
	
	var _errors2 = _interopRequireDefault(_errors);
	
	var _extraData = __webpack_require__(559);
	
	var _extraData2 = _interopRequireDefault(_extraData);
	
	var _packageData = __webpack_require__(581);
	
	var _packageData2 = _interopRequireDefault(_packageData);
	
	var _eventTags = __webpack_require__(557);
	
	var _eventTags2 = _interopRequireDefault(_eventTags);
	
	var _sdk = __webpack_require__(582);
	
	var _sdk2 = _interopRequireDefault(_sdk);
	
	var _device = __webpack_require__(554);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _userReport = __webpack_require__(583);
	
	var _userReport2 = _interopRequireDefault(_userReport);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _locale = __webpack_require__(2);
	
	var _interfacesException = __webpack_require__(570);
	
	var _interfacesException2 = _interopRequireDefault(_interfacesException);
	
	var _interfacesMessage = __webpack_require__(574);
	
	var _interfacesMessage2 = _interopRequireDefault(_interfacesMessage);
	
	var _interfacesRequest = __webpack_require__(576);
	
	var _interfacesRequest2 = _interopRequireDefault(_interfacesRequest);
	
	var _interfacesStacktrace = __webpack_require__(179);
	
	var _interfacesStacktrace2 = _interopRequireDefault(_interfacesStacktrace);
	
	var _interfacesTemplate = __webpack_require__(578);
	
	var _interfacesTemplate2 = _interopRequireDefault(_interfacesTemplate);
	
	var _interfacesCsp = __webpack_require__(567);
	
	var _interfacesCsp2 = _interopRequireDefault(_interfacesCsp);
	
	var _interfacesBreadcrumbs = __webpack_require__(560);
	
	var _interfacesBreadcrumbs2 = _interopRequireDefault(_interfacesBreadcrumbs);
	
	var _interfacesThreads = __webpack_require__(579);
	
	var _interfacesThreads2 = _interopRequireDefault(_interfacesThreads);
	
	var INTERFACES = {
	  exception: _interfacesException2['default'],
	  message: _interfacesMessage2['default'],
	  request: _interfacesRequest2['default'],
	  stacktrace: _interfacesStacktrace2['default'],
	  template: _interfacesTemplate2['default'],
	  csp: _interfacesCsp2['default'],
	  breadcrumbs: _interfacesBreadcrumbs2['default'],
	  threads: _interfacesThreads2['default']
	};
	
	exports.INTERFACES = INTERFACES;
	var EventEntries = _react2['default'].createClass({
	  displayName: 'EventEntries',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    project: _react2['default'].PropTypes.object.isRequired,
	    // TODO(dcramer): ideally isShare would be replaced with simple permission
	    // checks
	    isShare: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      isShare: false
	    };
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return this.props.event.id !== nextProps.event.id;
	  },
	
	  interfaces: INTERFACES,
	
	  render: function render() {
	    var _this = this;
	
	    var group = this.props.group;
	    var evt = this.props.event;
	    var isShare = this.props.isShare;
	    var project = this.props.project;
	
	    var entries = evt.entries.map(function (entry, entryIdx) {
	      try {
	        var Component = _this.interfaces[entry.type];
	        if (!Component) {
	          /*eslint no-console:0*/
	          window.console && console.error && console.error('Unregistered interface: ' + entry.type);
	          return null;
	        }
	        return _react2['default'].createElement(Component, {
	          key: 'entry-' + entryIdx,
	          group: group,
	          event: evt,
	          type: entry.type,
	          data: entry.data,
	          isShare: isShare });
	      } catch (ex) {
	        (0, _utilsLogging.logException)(ex);
	        return _react2['default'].createElement(
	          _eventDataSection2['default'],
	          {
	            group: group,
	            event: evt,
	            type: entry.type,
	            title: entry.type },
	          _react2['default'].createElement(
	            'p',
	            null,
	            (0, _locale.t)('There was an error rendering this data.')
	          )
	        );
	      }
	    });
	
	    var hasContext = !_utils2['default'].objectIsEmpty(evt.user) || !_utils2['default'].objectIsEmpty(evt.contexts);
	
	    var hasContextSummary = hasContext && (evt.platform === 'cocoa' || evt.platform === 'javascript');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'entries' },
	      evt.userReport && _react2['default'].createElement(_userReport2['default'], {
	        group: group,
	        event: evt }),
	      !_utils2['default'].objectIsEmpty(evt.errors) && _react2['default'].createElement(_errors2['default'], {
	        group: group,
	        event: evt }),
	      !_utils2['default'].objectIsEmpty(evt.sdk) && evt.sdk.upstream.isNewer && _react2['default'].createElement(
	        'div',
	        { className: 'alert-block alert-info box' },
	        _react2['default'].createElement('span', { className: 'icon-exclamation' }),
	        (0, _locale.t)('This event was reported with an old version of the %s SDK.', evt.platform),
	        evt.sdk.upstream.url && _react2['default'].createElement(
	          'a',
	          { href: evt.sdk.upstream.url,
	            className: 'btn btn-sm btn-default' },
	          (0, _locale.t)('Learn More')
	        )
	      ),
	      hasContextSummary && _react2['default'].createElement(_contextSummary2['default'], {
	        group: group,
	        event: evt }),
	      _react2['default'].createElement(_eventTags2['default'], {
	        group: group,
	        event: evt,
	        orgId: this.props.orgId,
	        projectId: project.slug }),
	      entries,
	      hasContext && _react2['default'].createElement(_contexts2['default'], {
	        group: group,
	        event: evt }),
	      !_utils2['default'].objectIsEmpty(evt.context) && _react2['default'].createElement(_extraData2['default'], {
	        group: group,
	        event: evt }),
	      !_utils2['default'].objectIsEmpty(evt.packages) && _react2['default'].createElement(_packageData2['default'], {
	        group: group,
	        event: evt }),
	      !_utils2['default'].objectIsEmpty(evt.device) && _react2['default'].createElement(_device2['default'], {
	        group: group,
	        event: evt }),
	      !_utils2['default'].objectIsEmpty(evt.sdk) && _react2['default'].createElement(_sdk2['default'], {
	        group: group,
	        event: evt })
	    );
	  }
	});
	
	exports['default'] = EventEntries;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.getPHPFrame = getPHPFrame;
	exports.getPythonFrame = getPythonFrame;
	exports.getJavaFrame = getJavaFrame;
	exports.getCocoaFrame = getCocoaFrame;
	exports.getJavaPreamble = getJavaPreamble;
	exports['default'] = render;
	
	var _utils = __webpack_require__(7);
	
	var _frame = __webpack_require__(134);
	
	function getJavaScriptFrame(frame) {
	  var result = '';
	  if ((0, _utils.defined)(frame['function'])) {
	    result += '  at ' + frame['function'] + '(';
	  } else {
	    result += '  at ? (';
	  }
	  if ((0, _utils.defined)(frame.filename)) {
	    result += frame.filename;
	  } else if ((0, _utils.defined)(frame.module)) {
	    result += frame.module;
	  }
	  if ((0, _utils.defined)(frame.lineNo) && frame.lineNo >= 0) {
	    result += ':' + frame.lineNo;
	  }
	  if ((0, _utils.defined)(frame.colNo) && frame.colNo >= 0) {
	    result += ':' + frame.colNo;
	  }
	  result += ')';
	  return result;
	}
	
	function getRubyFrame(frame) {
	  var result = '  from ';
	  if ((0, _utils.defined)(frame.filename)) {
	    result += frame.filename;
	  } else if ((0, _utils.defined)(frame.module)) {
	    result += '(' + frame.module + ')';
	  } else {
	    result += '?';
	  }
	  if ((0, _utils.defined)(frame.lineNo) && frame.lineNo >= 0) {
	    result += ':' + frame.lineNo;
	  }
	  if ((0, _utils.defined)(frame.colNo) && frame.colNo >= 0) {
	    result += ':' + frame.colNo;
	  }
	  if ((0, _utils.defined)(frame['function'])) {
	    result += ':in `' + frame['function'] + '\'';
	  }
	  return result;
	}
	
	function getPHPFrame(frame, idx) {
	  var funcName = frame['function'] === 'null' ? '{main}' : frame['function'];
	  return '#' + idx + ' ' + (frame.filename || frame.module) + '(' + frame.lineNo + '): ' + funcName;
	}
	
	function getPythonFrame(frame) {
	  var result = '';
	  if ((0, _utils.defined)(frame.filename)) {
	    result += '  File "' + frame.filename + '"';
	  } else if ((0, _utils.defined)(frame.module)) {
	    result += '  Module "' + frame.module + '"';
	  } else {
	    result += '  ?';
	  }
	  if ((0, _utils.defined)(frame.lineNo) && frame.lineNo >= 0) {
	    result += ', line ' + frame.lineNo;
	  }
	  if ((0, _utils.defined)(frame.colNo) && frame.colNo >= 0) {
	    result += ', col ' + frame.colNo;
	  }
	  if ((0, _utils.defined)(frame['function'])) {
	    result += ', in ' + frame['function'];
	  }
	  if ((0, _utils.defined)(frame.context)) {
	    frame.context.forEach(function (item) {
	      if (item[0] === frame.lineNo) {
	        result += '\n    ' + (0, _utils.trim)(item[1]);
	      }
	    });
	  }
	  return result;
	}
	
	function getJavaFrame(frame) {
	  var result = '    at';
	  if ((0, _utils.defined)(frame.module)) {
	    result += ' ' + frame.module + '.';
	  }
	  if ((0, _utils.defined)(frame['function'])) {
	    result += frame['function'];
	  }
	  if ((0, _utils.defined)(frame.filename)) {
	    result += '(' + frame.filename;
	    if ((0, _utils.defined)(frame.lineNo) && frame.lineNo >= 0) {
	      result += ':' + frame.lineNo;
	    }
	    result += ')';
	  }
	  return result;
	}
	
	function ljust(str, len) {
	  return str + Array(Math.max(0, len - str.length) + 1).join(' ');
	}
	
	function getCocoaFrame(frame) {
	  var result = '  ';
	  if ((0, _utils.defined)(frame['package'])) {
	    result += ljust((0, _frame.trimPackage)(frame['package']), 20);
	  }
	  if ((0, _utils.defined)(frame.instructionAddr)) {
	    result += ljust(frame.instructionAddr, 12);
	  }
	  result += ' ' + (frame['function'] || frame.symbolAddr);
	  if (frame.instructionOffset) {
	    result += ' + ' + frame.instructionOffset;
	  }
	  if ((0, _utils.defined)(frame.filename)) {
	    result += ' (' + frame.filename;
	    if ((0, _utils.defined)(frame.lineNo) && frame.lineNo >= 0) {
	      result += ':' + frame.lineNo;
	    }
	    result += ')';
	  }
	  return result;
	}
	
	function getJavaPreamble(exception) {
	  var result = exception.type + ': ' + exception.value;
	  if (exception.module) {
	    result = exception.module + '.' + result;
	  }
	  return result;
	}
	
	function getPreamble(exception, platform) {
	  switch (platform) {
	    case 'java':
	      return getJavaPreamble(exception);
	    default:
	      return exception.type + ': ' + exception.value;
	  }
	}
	
	function getFrame(frame, frameIdx, platform) {
	  if (frame.platform) {
	    platform = frame.platform;
	  }
	  switch (platform) {
	    case 'javascript':
	      return getJavaScriptFrame(frame, frameIdx);
	    case 'ruby':
	      return getRubyFrame(frame, frameIdx);
	    case 'php':
	      return getPHPFrame(frame, frameIdx);
	    case 'python':
	      return getPythonFrame(frame, frameIdx);
	    case 'java':
	      return getJavaFrame(frame, frameIdx);
	    case 'objc':
	    case 'cocoa':
	      return getCocoaFrame(frame, frameIdx);
	    default:
	      return getPythonFrame(frame, frameIdx);
	  }
	}
	
	function render(data, platform, exception) {
	  var firstFrameOmitted = undefined,
	      lastFrameOmitted = undefined;
	  var frames = [];
	
	  if (data.framesOmitted) {
	    firstFrameOmitted = data.framesOmitted[0];
	    lastFrameOmitted = data.framesOmitted[1];
	  } else {
	    firstFrameOmitted = null;
	    lastFrameOmitted = null;
	  }
	
	  data.frames.forEach(function (frame, frameIdx) {
	    frames.push(getFrame(frame, frameIdx, platform));
	    if (frameIdx === firstFrameOmitted) {
	      frames.push('.. frames ' + firstFrameOmitted + ' until ' + lastFrameOmitted + ' were omitted and not available ..');
	    }
	  });
	
	  if (platform !== 'python') {
	    frames.reverse();
	  }
	
	  if (exception) {
	    frames.unshift(getPreamble(exception, platform));
	  }
	
	  return frames.join('\n');
	}

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	//import GroupEventDataSection from "../eventDataSection";
	
	var _frame = __webpack_require__(134);
	
	var _frame2 = _interopRequireDefault(_frame);
	
	var _locale = __webpack_require__(2);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var StacktraceContent = _react2['default'].createClass({
	  displayName: 'StacktraceContent',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired,
	    includeSystemFrames: _react2['default'].PropTypes.bool,
	    expandFirstFrame: _react2['default'].PropTypes.bool,
	    platform: _react2['default'].PropTypes.string,
	    newestFirst: _react2['default'].PropTypes.bool
	  },
	  mixins: [_mixinsOrganizationState2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      includeSystemFrames: true,
	      expandFirstFrame: true
	    };
	  },
	
	  shouldRenderAsTable: function shouldRenderAsTable() {
	    return this.props.platform === 'cocoa';
	  },
	
	  renderOmittedFrames: function renderOmittedFrames(firstFrameOmitted, lastFrameOmitted) {
	    var props = {
	      className: 'frame frames-omitted',
	      key: 'omitted'
	    };
	    var text = (0, _locale.t)('Frames %d until %d were omitted and not available.', firstFrameOmitted, lastFrameOmitted);
	    return _react2['default'].createElement(
	      'li',
	      props,
	      text
	    );
	  },
	
	  frameIsVisible: function frameIsVisible(frame, nextFrame) {
	    return this.props.includeSystemFrames || frame.inApp || nextFrame && nextFrame.inApp;
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var data = this.props.data;
	    var firstFrameOmitted = undefined,
	        lastFrameOmitted = undefined;
	
	    if (data.framesOmitted) {
	      firstFrameOmitted = data.framesOmitted[0];
	      lastFrameOmitted = data.framesOmitted[1];
	    } else {
	      firstFrameOmitted = null;
	      lastFrameOmitted = null;
	    }
	
	    var lastFrameIdx = null;
	    data.frames.forEach(function (frame, frameIdx) {
	      if (frame.inApp) lastFrameIdx = frameIdx;
	    });
	    if (lastFrameIdx === null) {
	      lastFrameIdx = data.frames.length - 1;
	    }
	
	    var expandFirstFrame = this.props.expandFirstFrame;
	    var frames = [];
	    var nRepeats = 0;
	    data.frames.forEach(function (frame, frameIdx) {
	      var nextFrame = data.frames[frameIdx + 1];
	      var repeatedFrame = nextFrame && frame.lineNo === nextFrame.lineNo && frame['function'] === nextFrame['function'];
	
	      if (repeatedFrame) {
	        nRepeats++;
	      }
	
	      if (_this.frameIsVisible(frame, nextFrame) && !repeatedFrame) {
	        frames.push(_react2['default'].createElement(_frame2['default'], {
	          key: frameIdx,
	          data: frame,
	          isExpanded: expandFirstFrame && lastFrameIdx === frameIdx,
	          emptySourceNotation: lastFrameIdx === frameIdx && frameIdx === 0,
	          isOnlyFrame: _this.props.data.frames.length === 1,
	          nextFrameInApp: nextFrame && nextFrame.inApp,
	          platform: _this.props.platform,
	          timesRepeated: nRepeats }));
	      }
	
	      if (!repeatedFrame) {
	        nRepeats = 0;
	      }
	
	      if (frameIdx === firstFrameOmitted) {
	        frames.push(_this.renderOmittedFrames(firstFrameOmitted, lastFrameOmitted));
	      }
	    });
	    if (this.props.newestFirst) {
	      frames.reverse();
	    }
	    var className = this.props.className || '';
	    className += ' traceback';
	
	    if (this.props.includeSystemFrames) {
	      className += ' full-traceback';
	    } else {
	      className += ' in-app-traceback';
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: className },
	      _react2['default'].createElement(
	        'ul',
	        null,
	        frames
	      )
	    );
	  }
	});
	
	exports['default'] = StacktraceContent;
	module.exports = exports['default'];

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(7);
	
	var _inputField = __webpack_require__(63);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var BooleanField = (function (_InputField) {
	  _inherits(BooleanField, _InputField);
	
	  function BooleanField() {
	    _classCallCheck(this, BooleanField);
	
	    _get(Object.getPrototypeOf(BooleanField.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(BooleanField, [{
	    key: 'valueFromProps',
	    value: function valueFromProps(props) {
	      var value = _get(Object.getPrototypeOf(BooleanField.prototype), 'valueFromProps', this).call(this, props);
	      return value ? true : false;
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this = this;
	
	      this.setState({
	        value: e.target.checked
	      }, function () {
	        _this.props.onChange(_this.state.value);
	      });
	    }
	  }, {
	    key: 'getField',
	    value: function getField() {
	      return _react2['default'].createElement('input', { id: this.getId(),
	        type: this.getType(),
	        onChange: this.onChange.bind(this),
	        disabled: this.props.disabled,
	        defaultChecked: this.state.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var className = this.getClassName();
	      if (this.props.error) {
	        className += ' has-error';
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: className },
	        _react2['default'].createElement(
	          'div',
	          { className: 'controls' },
	          _react2['default'].createElement(
	            'label',
	            { className: 'control-label' },
	            this.getField(),
	            this.props.label,
	            this.props.disabled && this.props.disabledReason && _react2['default'].createElement(
	              'span',
	              { className: 'disabled-indicator tip', title: this.props.disabledReason },
	              _react2['default'].createElement('span', { className: 'icon-question' })
	            )
	          ),
	          (0, _utils.defined)(this.props.help) && _react2['default'].createElement(
	            'p',
	            { className: 'help-block' },
	            this.props.help
	          ),
	          this.props.error && _react2['default'].createElement(
	            'p',
	            { className: 'error' },
	            this.props.error
	          )
	        )
	      );
	    }
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      return 'control-group checkbox';
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return 'checkbox';
	    }
	  }]);
	
	  return BooleanField;
	})(_inputField2['default']);
	
	exports['default'] = BooleanField;
	module.exports = exports['default'];

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _inputField = __webpack_require__(63);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var EmailField = (function (_InputField) {
	  _inherits(EmailField, _InputField);
	
	  function EmailField() {
	    _classCallCheck(this, EmailField);
	
	    _get(Object.getPrototypeOf(EmailField.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(EmailField, [{
	    key: 'getType',
	    value: function getType() {
	      return 'email';
	    }
	  }]);
	
	  return EmailField;
	})(_inputField2['default']);
	
	exports['default'] = EmailField;
	module.exports = exports['default'];

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__(2);
	
	var Form = _react2['default'].createClass({
	  displayName: 'Form',
	
	  propTypes: {
	    onSubmit: _react2['default'].PropTypes.func.isRequired,
	    submitDisabled: _react2['default'].PropTypes.bool,
	    submitLabel: _react2['default'].PropTypes.string.isRequired,
	    footerClass: _react2['default'].PropTypes.string,
	    extraButton: _react2['default'].PropTypes.element
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      submitLabel: (0, _locale.t)('Save Changes'),
	      submitDisabled: false,
	      footerClass: 'form-actions align-right'
	    };
	  },
	
	  onSubmit: function onSubmit(e) {
	    e.preventDefault();
	    this.props.onSubmit();
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'form',
	      { onSubmit: this.onSubmit },
	      this.props.children,
	      _react2['default'].createElement(
	        'div',
	        { className: this.props.footerClass, style: { marginTop: 25 } },
	        _react2['default'].createElement(
	          'button',
	          { className: 'btn btn-primary',
	            disabled: this.props.submitDisabled,
	            type: 'submit' },
	          this.props.submitLabel
	        ),
	        this.props.extraButton
	      )
	    );
	  }
	});
	
	exports['default'] = Form;
	module.exports = exports['default'];

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var FormField = (function (_React$Component) {
	  _inherits(FormField, _React$Component);
	
	  function FormField(props) {
	    _classCallCheck(this, FormField);
	
	    _get(Object.getPrototypeOf(FormField.prototype), 'constructor', this).call(this, props);
	    this.state = {};
	  }
	
	  return FormField;
	})(_react2['default'].Component);
	
	FormField.propTypes = {
	  label: _react2['default'].PropTypes.string.isRequired,
	  name: _react2['default'].PropTypes.string.isRequired,
	
	  defaultValue: _react2['default'].PropTypes.any,
	  disabled: _react2['default'].PropTypes.bool,
	  error: _react2['default'].PropTypes.string,
	  help: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.element]),
	  onChange: _react2['default'].PropTypes.func,
	  required: _react2['default'].PropTypes.bool,
	  value: _react2['default'].PropTypes.any
	};
	
	FormField.defaultProps = {
	  disabled: false,
	  onChange: function onChange(value) {},
	  required: false
	};
	
	exports['default'] = FormField;
	module.exports = exports['default'];

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _inputField = __webpack_require__(63);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var NumberField = (function (_InputField) {
	  _inherits(NumberField, _InputField);
	
	  function NumberField() {
	    _classCallCheck(this, NumberField);
	
	    _get(Object.getPrototypeOf(NumberField.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(NumberField, [{
	    key: 'getType',
	    value: function getType() {
	      return 'number';
	    }
	  }]);
	
	  return NumberField;
	})(_inputField2['default']);
	
	exports['default'] = NumberField;
	module.exports = exports['default'];

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputField = __webpack_require__(63);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var PasswordField = (function (_InputField) {
	  _inherits(PasswordField, _InputField);
	
	  function PasswordField(props) {
	    _classCallCheck(this, PasswordField);
	
	    _get(Object.getPrototypeOf(PasswordField.prototype), 'constructor', this).call(this, props);
	
	    this.startEdit = this.startEdit.bind(this);
	    this.cancelEdit = this.cancelEdit.bind(this);
	
	    this.state.editing = false;
	  }
	
	  _createClass(PasswordField, [{
	    key: 'getType',
	    value: function getType() {
	      return 'password';
	    }
	  }, {
	    key: 'cancelEdit',
	    value: function cancelEdit(ev) {
	      var _this = this;
	
	      ev.preventDefault();
	      this.setState({
	        value: '',
	        editing: false
	      }, function () {
	        _this.props.onChange('');
	      });
	    }
	  }, {
	    key: 'startEdit',
	    value: function startEdit(ev) {
	      ev.preventDefault();
	      this.setState({
	        editing: true
	      });
	    }
	  }, {
	    key: 'getField',
	    value: function getField() {
	      if (!this.props.has_saved_value) {
	        return _get(Object.getPrototypeOf(PasswordField.prototype), 'getField', this).call(this);
	      }
	
	      if (this.state.editing) {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'form-password editing' },
	          _react2['default'].createElement(
	            'div',
	            null,
	            _get(Object.getPrototypeOf(PasswordField.prototype), 'getField', this).call(this)
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: '#', onClick: this.cancelEdit },
	              'Cancel'
	            )
	          )
	        );
	      } else {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'form-password saved' },
	          _react2['default'].createElement(
	            'span',
	            null,
	            this.props.prefix + new Array(21 - this.props.prefix.length).join('*')
	          ),
	          !this.props.disabled && _react2['default'].createElement(
	            'a',
	            { href: '#', onClick: this.startEdit },
	            'Edit'
	          )
	        );
	      }
	    }
	  }]);
	
	  return PasswordField;
	})(_inputField2['default']);
	
	PasswordField.defaultProps = Object.assign({}, _inputField2['default'].defaultProps, {
	  'has_saved_value': false,
	  'prefix': ''
	});
	
	exports['default'] = PasswordField;
	module.exports = exports['default'];

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _inputField = __webpack_require__(63);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var RangeField = (function (_InputField) {
	  _inherits(RangeField, _InputField);
	
	  function RangeField() {
	    _classCallCheck(this, RangeField);
	
	    _get(Object.getPrototypeOf(RangeField.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(RangeField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get(Object.getPrototypeOf(RangeField.prototype), 'componentDidMount', this).call(this);
	      this.attachSlider();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeSlider();
	      _get(Object.getPrototypeOf(RangeField.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'attachSlider',
	    value: function attachSlider() {
	      var _this = this;
	
	      var $value = (0, _jquery2['default'])('<span class="value" />');
	      (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this.refs.input)).on('slider:ready', function (e, data) {
	        $value.appendTo(data.el);
	        $value.html(_this.props.formatLabel(data.value));
	      }).on('slider:changed', function (e, data) {
	        $value.html(_this.props.formatLabel(data.value));
	        _this.props.onChange(data.value);
	      }).simpleSlider({
	        range: [this.props.min, this.props.max],
	        step: this.props.step,
	        snap: this.props.snap,
	        allowedValues: this.props.allowedValues
	      });
	    }
	  }, {
	    key: 'removeSlider',
	    value: function removeSlider() {
	      // TODO(dcramer): it seems we cant actually implement this with the current slider
	      // implementation
	    }
	  }, {
	    key: 'getField',
	    value: function getField() {
	      return _react2['default'].createElement('input', { id: this.getId(),
	        type: this.getType(),
	        className: 'form-control',
	        placeholder: this.props.placeholder,
	        onChange: this.onChange.bind(this),
	        disabled: this.props.disabled,
	        ref: 'input',
	        min: this.props.min,
	        max: this.props.max,
	        step: this.props.step,
	        value: this.state.value });
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return 'range';
	    }
	  }]);
	
	  return RangeField;
	})(_inputField2['default']);
	
	exports['default'] = RangeField;
	
	RangeField.formatMinutes = function (val) {
	  val = parseInt(val / 60, 10);
	  return val + ' minute' + (val != 1 ? 's' : '');
	};
	
	RangeField.defaultProps = {
	  onChange: function onChange(value) {},
	  formatLabel: function formatLabel(value) {
	    return value;
	  },
	  min: 0,
	  max: 100,
	  step: 1,
	  snap: true,
	  allowedValues: null
	};
	module.exports = exports['default'];

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputField = __webpack_require__(63);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var Select2Field = (function (_InputField) {
	  _inherits(Select2Field, _InputField);
	
	  function Select2Field() {
	    _classCallCheck(this, Select2Field);
	
	    _get(Object.getPrototypeOf(Select2Field.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Select2Field, [{
	    key: 'getField',
	    value: function getField() {
	      return _react2['default'].createElement(
	        'select',
	        { id: this.getId(),
	          className: 'form-control',
	          ref: 'input',
	          placeholder: this.props.placeholder,
	          onChange: this.onChange.bind(this),
	          disabled: this.props.disabled,
	          required: this.props.required,
	          multiple: this.props.multiple || false,
	          value: this.state.value },
	        (this.props.choices || []).map(function (choice) {
	          return _react2['default'].createElement(
	            'option',
	            { key: choice[0],
	              value: choice[0] },
	            choice[1]
	          );
	        })
	      );
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(e) {
	      var _this = this;
	
	      if (this.props.multiple) {
	        var options = e.target.options;
	        var value = [];
	        for (var i = 0; i < options.length; i++) {
	          if (options[i].selected) {
	            value.push(options[i].value);
	          }
	        }
	        this.setState({
	          value: value
	        }, function () {
	          _this.props.onChange(_this.state.value);
	        });
	        return;
	      }
	      _get(Object.getPrototypeOf(Select2Field.prototype), 'onChange', this).call(this, e);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _jquery2['default'])(this.refs.input).select2().on('change', this.onChange);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _jquery2['default'])(this.refs.select).select2('destroy');
	    }
	  }]);
	
	  return Select2Field;
	})(_inputField2['default']);
	
	Select2Field.propTypes = Object.assign({
	  choices: _react2['default'].PropTypes.array.isRequired
	}, _inputField2['default'].propTypes);
	
	exports['default'] = Select2Field;
	module.exports = exports['default'];

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _inputField = __webpack_require__(63);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var Select2FieldAutocomplete = (function (_InputField) {
	  _inherits(Select2FieldAutocomplete, _InputField);
	
	  function Select2FieldAutocomplete() {
	    _classCallCheck(this, Select2FieldAutocomplete);
	
	    _get(Object.getPrototypeOf(Select2FieldAutocomplete.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Select2FieldAutocomplete, [{
	    key: 'getType',
	    value: function getType() {
	      return 'text';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      var $el = $('input', _reactDom2['default'].findDOMNode(this));
	      $el.on('change.autocomplete', this.onChange.bind(this));
	      var separator = this.props.url.includes('?') ? '&' : '?';
	      var url = this.props.url + separator + 'autocomplete_field=' + this.props.name;
	
	      $el.select2({
	        placeholder: this.props.placeholder || 'Start typing to search for an issue',
	        minimumInputLength: 1,
	        ajax: {
	          quietMillis: 100,
	          url: url,
	          dataType: 'json',
	          data: function data(q) {
	            return { autocomplete_query: q };
	          },
	          results: function results(data) {
	            return { results: data[_this.props.name] };
	          }
	        },
	        formatAjaxError: function formatAjaxError(error) {
	          var resp = error.responseJSON;
	          if (resp && resp.error_type === 'validation') {
	            var message = resp.errors[0] && resp.errors[0].__all__;
	            if (message) {
	              return message;
	            }
	          }
	          return 'Loading failed';
	        }
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var $el = $('input', _reactDom2['default'].findDOMNode(this));
	      $el.off('change.autocomplete');
	    }
	  }]);
	
	  return Select2FieldAutocomplete;
	})(_inputField2['default']);
	
	exports['default'] = Select2FieldAutocomplete;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _inputField = __webpack_require__(63);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var TextField = (function (_InputField) {
	  _inherits(TextField, _InputField);
	
	  function TextField() {
	    _classCallCheck(this, TextField);
	
	    _get(Object.getPrototypeOf(TextField.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TextField, [{
	    key: 'getType',
	    value: function getType() {
	      return 'text';
	    }
	  }]);
	
	  return TextField;
	})(_inputField2['default']);
	
	exports['default'] = TextField;
	module.exports = exports['default'];

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputField = __webpack_require__(63);
	
	var _inputField2 = _interopRequireDefault(_inputField);
	
	var TextareaField = (function (_InputField) {
	  _inherits(TextareaField, _InputField);
	
	  function TextareaField() {
	    _classCallCheck(this, TextareaField);
	
	    _get(Object.getPrototypeOf(TextareaField.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TextareaField, [{
	    key: 'getField',
	    value: function getField() {
	      return _react2['default'].createElement('textarea', {
	        id: this.getId(),
	        ref: 'input',
	        className: 'form-control',
	        value: this.state.value,
	        disabled: this.props.disabled,
	        required: this.props.required,
	        placeholder: this.props.placeholder,
	        onChange: this.onChange.bind(this) });
	    }
	  }]);
	
	  return TextareaField;
	})(_inputField2['default']);
	
	exports['default'] = TextareaField;
	module.exports = exports['default'];

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var GroupTitle = _react2['default'].createClass({
	  displayName: 'GroupTitle',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var data = this.props.data;
	    var metadata = data.metadata;
	    var title = data.title;
	    var subtitle = null;
	    if (data.type == 'error') {
	      title = metadata.type;
	      subtitle = data.culprit;
	    } else if (data.type == 'csp') {
	      title = metadata.directive;
	      subtitle = metadata.uri;
	    } else if (data.type == 'default') {
	      title = metadata.title;
	    }
	    if (subtitle) {
	      return _react2['default'].createElement(
	        'span',
	        null,
	        _react2['default'].createElement(
	          'span',
	          { style: { marginRight: 10 } },
	          title
	        ),
	        _react2['default'].createElement(
	          'em',
	          null,
	          subtitle
	        ),
	        _react2['default'].createElement('br', null)
	      );
	    }
	    return _react2['default'].createElement(
	      'span',
	      null,
	      title
	    );
	  }
	});
	
	exports['default'] = GroupTitle;
	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsGroupListHeader = __webpack_require__(593);
	
	var _componentsGroupListHeader2 = _interopRequireDefault(_componentsGroupListHeader);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var _componentsStreamGroup = __webpack_require__(296);
	
	var _componentsStreamGroup2 = _interopRequireDefault(_componentsStreamGroup);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _locale = __webpack_require__(2);
	
	var GroupList = _react2['default'].createClass({
	  displayName: 'GroupList',
	
	  propTypes: {
	    query: _react2['default'].PropTypes.string.isRequired,
	    canSelectGroups: _react2['default'].PropTypes.bool,
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    bulkActions: _react2['default'].PropTypes.bool.isRequired
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsProjectState2['default'], _reflux2['default'].listenTo(_storesGroupStore2['default'], 'onGroupChange'), _mixinsApiMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      canSelectGroups: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      groupIds: []
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this._streamManager = new _utils2['default'].StreamManager(_storesGroupStore2['default']);
	
	    this.fetchData();
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !_utils2['default'].valueIsEqual(this.state, nextState, true);
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.orgId !== this.props.orgId || prevProps.projectId !== this.props.projectId) {
	      this.fetchData();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _storesGroupStore2['default'].loadInitialData([]);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    _storesGroupStore2['default'].loadInitialData([]);
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(this.getGroupListEndpoint(), {
	      success: function success(data, _, jqXHR) {
	        _this._streamManager.push(data);
	
	        _this.setState({
	          error: false,
	          loading: false,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  getGroupListEndpoint: function getGroupListEndpoint() {
	    var queryParams = this.context.location.query;
	    queryParams.limit = 50;
	    queryParams.sort = 'new';
	    queryParams.query = this.props.query;
	    var querystring = _jquery2['default'].param(queryParams);
	
	    var props = this.props;
	    return '/projects/' + props.orgId + '/' + props.projectId + '/issues/?' + querystring;
	  },
	
	  onGroupChange: function onGroupChange() {
	    var groupIds = this._streamManager.getAllItems().map(function (item) {
	      return item.id;
	    });
	    if (!_utils2['default'].valueIsEqual(groupIds, this.state.groupIds)) {
	      this.setState({
	        groupIds: groupIds
	      });
	    }
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });else if (this.state.groupIds.length === 0) return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('There doesn\'t seem to be any events fitting the query.')
	      )
	    );
	
	    var wrapperClass = undefined;
	
	    if (!this.props.bulkActions) {
	      wrapperClass = 'stream-no-bulk-actions';
	    }
	
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: wrapperClass },
	      _react2['default'].createElement(_componentsGroupListHeader2['default'], null),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'group-list' },
	        this.state.groupIds.map(function (id) {
	          return _react2['default'].createElement(_componentsStreamGroup2['default'], {
	            key: id,
	            id: id,
	            orgId: orgId,
	            projectId: projectId,
	            canSelect: _this2.props.canSelectGroups
	          });
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = GroupList;
	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(738);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsAlertsToastIndicator = __webpack_require__(542);
	
	var _componentsAlertsToastIndicator2 = _interopRequireDefault(_componentsAlertsToastIndicator);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var Indicators = _react2['default'].createClass({
	  displayName: 'Indicators',
	
	  mixins: [_reflux2['default'].connect(_storesIndicatorStore2['default'], 'items')],
	
	  getInitialState: function getInitialState() {
	    return {
	      items: []
	    };
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      this.props,
	      _react2['default'].createElement(
	        _reactAddonsCssTransitionGroup2['default'],
	        { transitionName: 'toast', transitionEnter: false, transitionLeaveTimeout: 500 },
	        this.state.items.map(function (indicator) {
	          if (indicator.type === 'error' || indicator.type === 'success') {
	            return _react2['default'].createElement(
	              _componentsAlertsToastIndicator2['default'],
	              { type: indicator.type, key: indicator.id },
	              indicator.message
	            );
	          } else {
	            return _react2['default'].createElement(
	              _componentsLoadingIndicator2['default'],
	              { className: 'toast', key: indicator.id },
	              indicator.message
	            );
	          }
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = Indicators;
	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	/**
	 * Also see avatar.py. Anything changed in this file (how colors
	 * are selected, the svg, etc) will also need to be changed there.
	 */
	
	var LetterAvatar = _react2['default'].createClass({
	  displayName: 'LetterAvatar',
	
	  propTypes: {
	    identifier: _react2['default'].PropTypes.string.isRequired,
	    displayName: _react2['default'].PropTypes.string.isRequired
	  },
	
	  COLORS: ['#4674ca', // blue
	  '#315cac', // blue_dark
	  '#57be8c', // green
	  '#3fa372', // green_dark
	  '#f9a66d', // yellow_orange
	  '#ec5e44', // red
	  '#e63717', // red_dark
	  '#f868bc', // pink
	  '#6c5fc7', // purple
	  '#4e3fb4', // purple_dark
	  '#57b1be', // teal
	  '#847a8c' // gray
	  ],
	
	  getColor: function getColor() {
	    var id = this.hashIdentifier(this.props.identifier);
	    return this.COLORS[id % this.COLORS.length];
	  },
	
	  hashIdentifier: function hashIdentifier(identifier) {
	    identifier += '';
	    var hash = 0;
	    for (var i = 0; i < identifier.length; i++) {
	      hash += identifier.charCodeAt(i);
	    }
	    return hash;
	  },
	
	  getInitials: function getInitials() {
	    var names = (this.props.displayName.trim() || '?').split(' ');
	    var initials = names[0][0] + (names.length > 1 ? names[names.length - 1][0] : '');
	    return initials.toUpperCase();
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'svg',
	      { viewBox: '0 0 120 120', className: this.props.className },
	      _react2['default'].createElement('rect', { x: '0', y: '0', width: '120', height: '120', rx: '15', ry: '15', fill: this.getColor() }),
	      _react2['default'].createElement(
	        'text',
	        { x: '50%', y: '50%', fontSize: '65', style: { 'dominantBaseline': 'central' },
	          textAnchor: 'middle', fill: '#FFFFFF' },
	        this.getInitials()
	      )
	    );
	  }
	});
	
	exports['default'] = LetterAvatar;
	module.exports = exports['default'];

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsFooter = __webpack_require__(105);
	
	var _componentsFooter2 = _interopRequireDefault(_componentsFooter);
	
	var NarryLayout = _react2['default'].createClass({
	  displayName: 'NarryLayout',
	
	  componentWillMount: function componentWillMount() {
	    (0, _jquery2['default'])(document.body).addClass('narrow');
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    (0, _jquery2['default'])(document.body).removeClass('narrow');
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'app' },
	      _react2['default'].createElement('div', { className: 'pattern-bg' }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'container' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box box-modal' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'box-header' },
	            _react2['default'].createElement(
	              'a',
	              { href: '/' },
	              _react2['default'].createElement('span', { className: 'icon-sentry-logo' })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'box-content with-padding' },
	            this.props.children
	          )
	        )
	      ),
	      _react2['default'].createElement(_componentsFooter2['default'], null)
	    );
	  }
	});
	
	exports['default'] = NarryLayout;
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesOrganizationStore = __webpack_require__(139);
	
	var _storesOrganizationStore2 = _interopRequireDefault(_storesOrganizationStore);
	
	var OrganizationsLoader = _react2['default'].createClass({
	  displayName: 'OrganizationsLoader',
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.api.request('/organizations/', {
	      query: {
	        'member': '1'
	      },
	      success: function success(data) {
	        _storesOrganizationStore2['default'].load(data);
	        _this.setState({
	          loading: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _storesOrganizationStore2['default'].load([]);
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = OrganizationsLoader;
	module.exports = exports['default'];

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var ProjectLabel = _react2['default'].createClass({
	  displayName: 'ProjectLabel',
	
	  propTypes: {
	    project: _react2['default'].PropTypes.object,
	    organization: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default']],
	
	  render: function render() {
	    var project = this.props.project;
	    return _react2['default'].createElement(
	      'span',
	      { className: 'project-label' },
	      _react2['default'].createElement(
	        'span',
	        { className: 'project-name' },
	        project.name
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectLabel;
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _viewsRequiredAdminActionsSetCallsigns = __webpack_require__(310);
	
	var _viewsRequiredAdminActionsSetCallsigns2 = _interopRequireDefault(_viewsRequiredAdminActionsSetCallsigns);
	
	var requiredAdminActions = {
	  SET_CALLSIGNS: _viewsRequiredAdminActionsSetCallsigns2['default']
	};
	
	for (var key in requiredAdminActions) {
	  requiredAdminActions[key].ID = key;
	}
	
	exports['default'] = requiredAdminActions;
	module.exports = exports['default'];

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var _autoSelectText = __webpack_require__(170);
	
	var _autoSelectText2 = _interopRequireDefault(_autoSelectText);
	
	var ShortId = _react2['default'].createClass({
	  displayName: 'ShortId',
	
	  propTypes: {
	    shortId: _react2['default'].PropTypes.string,
	    project: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default'], _mixinsProjectState2['default']],
	
	  preventPropagation: function preventPropagation(e) {
	    // this is a hack for the stream so the click handler doesn't
	    // affect this element
	    e.stopPropagation();
	  },
	
	  render: function render() {
	    var shortId = this.props.shortId;
	    if (!this.getFeatures().has('callsigns') || !shortId) {
	      return null;
	    }
	    return _react2['default'].createElement(
	      'span',
	      { className: 'short-id', onClick: this.preventPropagation },
	      _react2['default'].createElement(
	        _autoSelectText2['default'],
	        null,
	        shortId
	      )
	    );
	  }
	});
	
	exports['default'] = ShortId;
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var SidebarPanelItem = _react2['default'].createClass({
	  displayName: 'SidebarPanelItem',
	
	  propTypes: {
	    title: _react2['default'].PropTypes.string,
	    image: _react2['default'].PropTypes.string,
	    message: _react2['default'].PropTypes.any,
	    link: _react2['default'].PropTypes.string,
	    hasSeen: _react2['default'].PropTypes.bool
	  },
	
	  render: function render() {
	    var className = 'sidebar-panel-item';
	    if (this.props.hasSeen) {
	      className += ' has-seen';
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: className },
	      this.props.title && _react2['default'].createElement(
	        'h3',
	        null,
	        this.props.title
	      ),
	      this.props.image && _react2['default'].createElement(
	        'div',
	        { className: 'image' },
	        _react2['default'].createElement('img', { src: this.props.image })
	      ),
	      this.props.message && _react2['default'].createElement(
	        'p',
	        { className: 'message' },
	        this.props.message
	      ),
	      this.props.link && _react2['default'].createElement(
	        'p',
	        { className: 'link' },
	        _react2['default'].createElement(
	          'a',
	          { href: this.props.link, target: '_blank' },
	          'Read More'
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = SidebarPanelItem;
	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _reactRouter = __webpack_require__(8);
	
	var _assigneeSelector = __webpack_require__(269);
	
	var _assigneeSelector2 = _interopRequireDefault(_assigneeSelector);
	
	var _count = __webpack_require__(71);
	
	var _count2 = _interopRequireDefault(_count);
	
	var _groupChart = __webpack_require__(297);
	
	var _groupChart2 = _interopRequireDefault(_groupChart);
	
	var _groupCheckBox = __webpack_require__(604);
	
	var _groupCheckBox2 = _interopRequireDefault(_groupCheckBox);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var _timeSince = __webpack_require__(40);
	
	var _timeSince2 = _interopRequireDefault(_timeSince);
	
	var _groupTitle = __webpack_require__(286);
	
	var _groupTitle2 = _interopRequireDefault(_groupTitle);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _storesSelectedGroupStore = __webpack_require__(140);
	
	var _storesSelectedGroupStore2 = _interopRequireDefault(_storesSelectedGroupStore);
	
	var _shortId = __webpack_require__(294);
	
	var _shortId2 = _interopRequireDefault(_shortId);
	
	var _utils = __webpack_require__(7);
	
	var StreamGroupHeader = _react2['default'].createClass({
	  displayName: 'StreamGroupHeader',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired,
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired
	  },
	
	  getMessage: function getMessage() {
	    var data = this.props.data;
	    var metadata = data.metadata;
	    switch (data.type) {
	      case 'error':
	        return metadata.value;
	      case 'csp':
	        return metadata.message;
	      default:
	        return this.props.data.culprit || '';
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	    var data = _props.data;
	
	    var message = this.getMessage();
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h3',
	        { className: 'truncate' },
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: '/' + orgId + '/' + projectId + '/issues/' + data.id + '/' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'error-level truncate' },
	            data.level
	          ),
	          _react2['default'].createElement('span', { className: 'icon icon-soundoff' }),
	          _react2['default'].createElement('span', { className: 'icon icon-star-solid' }),
	          _react2['default'].createElement(_groupTitle2['default'], { data: data })
	        )
	      ),
	      message && _react2['default'].createElement(
	        'div',
	        { className: 'event-message truncate' },
	        _react2['default'].createElement(
	          'span',
	          { className: 'message' },
	          this.getMessage()
	        )
	      )
	    );
	  }
	});
	
	var StreamGroup = _react2['default'].createClass({
	  displayName: 'StreamGroup',
	
	  propTypes: {
	    id: _react2['default'].PropTypes.string.isRequired,
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    statsPeriod: _react2['default'].PropTypes.string.isRequired,
	    canSelect: _react2['default'].PropTypes.bool
	  },
	
	  mixins: [_reflux2['default'].listenTo(_storesGroupStore2['default'], 'onGroupChange'), _mixinsProjectState2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      canSelect: true,
	      id: '',
	      statsPeriod: '24h'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      data: _storesGroupStore2['default'].get(this.props.id)
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.id != this.props.id) {
	      this.setState({
	        data: _storesGroupStore2['default'].get(this.props.id)
	      });
	    }
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (nextProps.statsPeriod !== this.props.statsPeriod) {
	      return true;
	    }
	    if (!(0, _utils.valueIsEqual)(this.state.data, nextState.data)) {
	      return true;
	    }
	    return false;
	  },
	
	  onGroupChange: function onGroupChange(itemIds) {
	    if (!itemIds.has(this.props.id)) {
	      return;
	    }
	    var id = this.props.id;
	    var data = _storesGroupStore2['default'].get(id);
	    this.setState({
	      data: data
	    });
	  },
	
	  toggleSelect: function toggleSelect(evt) {
	    if (evt.target.tagName === 'A') return;
	    if (evt.target.tagName === 'INPUT') return;
	    if ((0, _jquery2['default'])(evt.target).parents('a').length !== 0) return;
	
	    _storesSelectedGroupStore2['default'].toggleSelect(this.state.data.id);
	  },
	
	  render: function render() {
	    var data = this.state.data;
	    var userCount = data.userCount;
	
	    var className = 'group row';
	    if (data.isBookmarked) {
	      className += ' isBookmarked';
	    }
	    if (data.hasSeen) {
	      className += ' hasSeen';
	    }
	    if (data.status === 'resolved') {
	      className += ' isResolved';
	    }
	    if (data.status === 'ignored') {
	      className += ' isIgnored';
	    }
	
	    className += ' type-' + data.type;
	    className += ' level-' + data.level;
	
	    var _props2 = this.props;
	    var id = _props2.id;
	    var orgId = _props2.orgId;
	    var projectId = _props2.projectId;
	
	    return _react2['default'].createElement(
	      'li',
	      { className: className, onClick: this.toggleSelect },
	      _react2['default'].createElement(
	        'div',
	        { className: 'col-md-7 col-xs-8 event-details' },
	        this.props.canSelect && _react2['default'].createElement(
	          'div',
	          { className: 'checkbox' },
	          _react2['default'].createElement(_groupCheckBox2['default'], { id: data.id })
	        ),
	        _react2['default'].createElement(StreamGroupHeader, {
	          orgId: orgId,
	          projectId: projectId,
	          data: data }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'event-extra' },
	          _react2['default'].createElement(
	            'ul',
	            null,
	            this.getFeatures().has('callsigns') && data.shortId && _react2['default'].createElement(
	              'li',
	              null,
	              _react2['default'].createElement(_shortId2['default'], { shortId: data.shortId })
	            ),
	            _react2['default'].createElement(
	              'li',
	              null,
	              _react2['default'].createElement('span', { className: 'icon icon-clock' }),
	              _react2['default'].createElement(_timeSince2['default'], { date: data.lastSeen }),
	              ' — ',
	              _react2['default'].createElement(_timeSince2['default'], { date: data.firstSeen, suffix: 'old' })
	            ),
	            data.numComments !== 0 && _react2['default'].createElement(
	              'li',
	              null,
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/' + orgId + '/' + projectId + '/issues/' + id + '/activity/', className: 'comments' },
	                _react2['default'].createElement('span', { className: 'icon icon-comments' }),
	                _react2['default'].createElement(
	                  'span',
	                  { className: 'tag-count' },
	                  data.numComments
	                )
	              )
	            ),
	            data.logger && _react2['default'].createElement(
	              'li',
	              { className: 'event-annotation' },
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: { pathname: '/' + orgId + '/' + projectId + '/', query: { query: 'logger:' + data.logger } } },
	                data.logger
	              )
	            ),
	            data.annotations.map(function (annotation, key) {
	              return _react2['default'].createElement('li', { className: 'event-annotation',
	                dangerouslySetInnerHTML: { __html: annotation },
	                key: key });
	            })
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'event-assignee col-md-1 hidden-sm hidden-xs' },
	        _react2['default'].createElement(_assigneeSelector2['default'], { id: data.id })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'col-md-2 hidden-sm hidden-xs event-graph align-right' },
	        _react2['default'].createElement(_groupChart2['default'], { id: data.id, statsPeriod: this.props.statsPeriod, data: data })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'col-md-1 col-xs-2 event-count align-right' },
	        _react2['default'].createElement(_count2['default'], { value: data.count })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'col-md-1 col-xs-2 event-users align-right' },
	        _react2['default'].createElement(_count2['default'], { value: userCount })
	      )
	    );
	  }
	});
	
	exports['default'] = StreamGroup;
	module.exports = exports['default'];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactLazyLoad = __webpack_require__(354);
	
	var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _barChart = __webpack_require__(132);
	
	var _barChart2 = _interopRequireDefault(_barChart);
	
	var GroupChart = _react2['default'].createClass({
	  displayName: 'GroupChart',
	
	  propTypes: {
	    statsPeriod: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    // Sometimes statsPeriod updates before graph data has been
	    // pulled from server / propagated down to components ...
	    // don't update until data is available
	    var data = nextProps.data;
	    var statsPeriod = nextProps.statsPeriod;
	
	    return data.hasOwnProperty(statsPeriod);
	  },
	
	  render: function render() {
	    var stats = this.props.statsPeriod ? this.props.data.stats[this.props.statsPeriod] : null;
	    if (!stats || !stats.length) return null;
	
	    var chartData = stats.map(function (point) {
	      return { x: point[0], y: point[1] };
	    });
	
	    return _react2['default'].createElement(
	      _reactLazyLoad2['default'],
	      null,
	      _react2['default'].createElement(_barChart2['default'], { points: chartData, className: 'sparkline' })
	    );
	  }
	});
	
	exports['default'] = GroupChart;
	module.exports = exports['default'];

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Truncate = _react2['default'].createClass({
	  displayName: 'Truncate',
	
	  propTypes: {
	    value: _react2['default'].PropTypes.string.isRequired,
	    leftTrim: _react2['default'].PropTypes.bool,
	    maxLength: _react2['default'].PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      leftTrim: false,
	      maxLength: 50
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isExpanded: false
	    };
	  },
	
	  onFocus: function onFocus(e) {
	    var _props = this.props;
	    var value = _props.value;
	    var maxLength = _props.maxLength;
	
	    if (value.length <= maxLength) return;
	    this.setState({ isExpanded: true });
	  },
	
	  onBlur: function onBlur(e) {
	    if (this.state.isExpanded) this.setState({ isExpanded: false });
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var leftTrim = _props2.leftTrim;
	    var maxLength = _props2.maxLength;
	    var value = _props2.value;
	
	    var isTruncated = value.length > maxLength;
	    var shortValue = '';
	
	    if (isTruncated) {
	      if (leftTrim) {
	        shortValue = _react2['default'].createElement(
	          'span',
	          null,
	          '… ',
	          value.slice(value.length - (maxLength - 4), value.length)
	        );
	      } else {
	        shortValue = _react2['default'].createElement(
	          'span',
	          null,
	          value.slice(0, maxLength - 4),
	          ' …'
	        );
	      }
	    } else {
	      shortValue = value;
	    }
	
	    var className = this.props.className || '';
	    className += ' truncated';
	    if (this.state.isExpanded) className += ' expanded';
	
	    return _react2['default'].createElement(
	      'span',
	      {
	        className: className,
	        onMouseOver: this.onFocus,
	        onMouseOut: this.onBlur,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur },
	      _react2['default'].createElement(
	        'span',
	        { className: 'short-value' },
	        shortValue
	      ),
	      isTruncated && _react2['default'].createElement(
	        'span',
	        { className: 'full-value' },
	        value
	      )
	    );
	  }
	});
	
	exports['default'] = Truncate;
	module.exports = exports['default'];

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _u2fApi = __webpack_require__(958);
	
	var _u2fApi2 = _interopRequireDefault(_u2fApi);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _locale = __webpack_require__(2);
	
	var U2fInterface = _react2['default'].createClass({
	  displayName: 'U2fInterface',
	
	  propTypes: {
	    challengeData: _react2['default'].PropTypes.object.isRequired,
	    flowMode: _react2['default'].PropTypes.string.isRequired,
	    onTap: _react2['default'].PropTypes.func,
	    silentIfUnsupported: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      silentIfUnsupported: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isSupported: null,
	      formElement: null,
	      challengeElement: null,
	      hasBeenTapped: false,
	      deviceFailure: null,
	      responseElement: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    _u2fApi2['default'].isSupported().then(function (supported) {
	      _this.setState({
	        isSupported: supported
	      });
	      if (!supported) {
	        return;
	      }
	      _this.invokeU2fFlow();
	    });
	  },
	
	  onTryAgain: function onTryAgain() {
	    var _this2 = this;
	
	    this.setState({
	      hasBeenTapped: false,
	      deviceFailure: null
	    }, function () {
	      _this2.invokeU2fFlow();
	    });
	  },
	
	  invokeU2fFlow: function invokeU2fFlow() {
	    var _this3 = this;
	
	    var promise = undefined;
	    if (this.props.flowMode === 'sign') {
	      promise = _u2fApi2['default'].sign(this.props.challengeData.authenticateRequests);
	    } else if (this.props.flowMode === 'enroll') {
	      var _props$challengeData = this.props.challengeData;
	      var registerRequests = _props$challengeData.registerRequests;
	      var authenticateRequests = _props$challengeData.authenticateRequests;
	
	      promise = _u2fApi2['default'].register(registerRequests, authenticateRequests);
	    } else {
	      throw new Error('Unsupported flow mode \'' + this.props.flowMode + '\'');
	    }
	    promise.then(function (data) {
	      _this3.setState({
	        hasBeenTapped: true
	      }, function () {
	        _this3.state.responseElement.value = JSON.stringify(data);
	        if (!_this3.props.onTap || _this3.props.onTap()) {
	          _this3.state.formElement.submit();
	        }
	      });
	    })['catch'](function (err) {
	      var failure = 'DEVICE_ERROR';
	      if (err.metaData.type === 'DEVICE_INELIGIBLE') {
	        if (_this3.props.flowMode === 'enroll') {
	          failure = 'DUPLICATE_DEVICE';
	        } else {
	          failure = 'UNKNOWN_DEVICE';
	        }
	      } else if (err.metaData.type === 'BAD_REQUEST') {
	        failure = 'BAD_APPID';
	      }
	      _this3.setState({
	        deviceFailure: failure,
	        hasBeenTapped: false
	      });
	    });
	  },
	
	  bindChallengeElement: function bindChallengeElement(ref) {
	    this.setState({
	      challengeElement: ref,
	      formElement: ref.form
	    });
	    ref.value = JSON.stringify(this.props.challengeData);
	  },
	
	  bindResponseElement: function bindResponseElement(ref) {
	    this.setState({
	      responseElement: ref
	    });
	  },
	
	  renderUnsupported: function renderUnsupported() {
	    if (this.props.silentIfUnsupported) {
	      return null;
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: 'u2f-box' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'inner' },
	        _react2['default'].createElement(
	          'p',
	          { className: 'error' },
	          (0, _locale.t)('\n             Unfortunately your browser does not support U2F. You need to use\n             a different two-factor method or switch to a browser that supports\n             it (Google Chrome or Microsoft Edge).\n            ')
	        )
	      )
	    );
	  },
	
	  canTryAgain: function canTryAgain() {
	    return this.state.deviceFailure !== 'BAD_APPID';
	  },
	
	  renderFailure: function renderFailure() {
	    var deviceFailure = this.state.deviceFailure;
	
	    var supportMail = _storesConfigStore2['default'].get('supportEmail');
	    var support = supportMail ? _react2['default'].createElement(
	      'a',
	      { href: 'mailto:' + supportMail },
	      supportMail
	    ) : _react2['default'].createElement(
	      'span',
	      null,
	      (0, _locale.t)('Support')
	    );
	    return _react2['default'].createElement(
	      'div',
	      { className: 'failure-message' },
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'strong',
	          null,
	          (0, _locale.t)('Error: ')
	        ),
	        ' ',
	        ({
	          'DEVICE_ERROR': (0, _locale.t)('Your U2F device reported an error.'),
	          'DUPLICATE_DEVICE': (0, _locale.t)('This device is already in use.'),
	          'UNKNOWN_DEVICE': (0, _locale.t)('The device you used for sign-in is unknown.'),
	          'BAD_APPID': (0, _locale.tct)('[p1:The Sentry server administrator modified the ' + 'device registrations.]' + '[p2:You need to remove and re-add the device to continue ' + 'using your U2F device. Use a different sign-in method or ' + 'contact [support] for assistance.]', {
	            p1: _react2['default'].createElement('p', null),
	            p2: _react2['default'].createElement('p', null),
	            support: support
	          })
	        })[deviceFailure]
	      ),
	      this.canTryAgain() && _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'a',
	          { onClick: this.onTryAgain, className: 'btn btn-primary' },
	          (0, _locale.t)('Try Again')
	        )
	      )
	    );
	  },
	
	  renderBody: function renderBody() {
	    if (this.state.deviceFailure) {
	      return this.renderFailure();
	    } else {
	      return this.props.children;
	    }
	  },
	
	  renderPrompt: function renderPrompt() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'u2f-box' + (this.state.hasBeenTapped ? ' tapped' : '') + (this.state.deviceFailure ? ' device-failure' : '') },
	      _react2['default'].createElement(
	        'div',
	        { className: 'device-animation-frame' },
	        _react2['default'].createElement('div', { className: 'device-failed' }),
	        _react2['default'].createElement('div', { className: 'device-animation' }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'loading-dots' },
	          _react2['default'].createElement('span', { className: 'dot' }),
	          _react2['default'].createElement('span', { className: 'dot' }),
	          _react2['default'].createElement('span', { className: 'dot' })
	        )
	      ),
	      _react2['default'].createElement('input', { type: 'hidden', name: 'challenge', ref: this.bindChallengeElement }),
	      _react2['default'].createElement('input', { type: 'hidden', name: 'response', ref: this.bindResponseElement }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'inner' },
	        this.renderBody()
	      )
	    );
	  },
	
	  render: function render() {
	    var isSupported = this.state.isSupported;
	
	    // if we are still waiting for the browser to tell us if we can do u2f
	    // this will be null.
	    if (isSupported === null) {
	      return null;
	    } else if (!isSupported) {
	      return this.renderUnsupported();
	    } else {
	      return this.renderPrompt();
	    }
	  }
	});
	
	exports['default'] = U2fInterface;
	module.exports = exports['default'];

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getOption = getOption;
	exports.getOptionField = getOptionField;
	exports.getForm = getForm;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _locale = __webpack_require__(2);
	
	var _componentsForms = __webpack_require__(36);
	
	// This are ordered based on their display order visually
	var sections = [{
	  key: 'system'
	}, {
	  key: 'mail',
	  heading: (0, _locale.t)('Outbound email')
	}];
	
	// This are ordered based on their display order visually
	var definitions = [{
	  key: 'system.url-prefix',
	  label: (0, _locale.t)('Root URL'),
	  placeholder: 'https://sentry.example.com',
	  help: (0, _locale.t)('The root web address which is used to communicate with the Sentry backend.'),
	  defaultValue: function defaultValue() {
	    return document.location.protocol + '//' + document.location.host;
	  }
	}, {
	  key: 'system.admin-email',
	  label: (0, _locale.t)('Admin Email'),
	  placeholder: 'admin@example.com',
	  help: (0, _locale.t)('The technical contact for this Sentry installation.'),
	  // TODO(dcramer): this should not be hardcoded to a component
	  component: _componentsForms.EmailField,
	  defaultValue: function defaultValue() {
	    return _storesConfigStore2['default'].get('user').email;
	  }
	}, {
	  key: 'system.rate-limit',
	  label: (0, _locale.t)('Rate Limit'),
	  placeholder: 'e.g. 500',
	  help: (0, _locale.t)('The maximum number of events the system should accept per minute. A value of 0 will disable the default rate limit.')
	}, {
	  key: 'auth.ip-rate-limit',
	  label: (0, _locale.t)('IP Rate Limit'),
	  placeholder: 'e.g. 10',
	  help: (0, _locale.t)('The maximum number of times an authentication attempt may be made by a single IP address in a 60 second window.')
	}, {
	  key: 'auth.user-rate-limit',
	  label: (0, _locale.t)('User Rate Limit'),
	  placeholder: 'e.g. 10',
	  help: (0, _locale.t)('The maximum number of times an authentication attempt may be made against a single account in a 60 second window.')
	}, {
	  key: 'api.rate-limit.org-create',
	  label: 'Organization Creation Rate Limit',
	  placeholder: 'e.g. 5',
	  help: (0, _locale.t)('The maximum number of organizations which may be created by a single account in a one hour window.')
	}, {
	  key: 'mail.from',
	  label: (0, _locale.t)('Email From'),
	  component: _componentsForms.EmailField,
	  defaultValue: function defaultValue() {
	    return 'sentry@' + document.location.hostname;
	  },
	  help: (0, _locale.t)('Email address to be used in From for all outbound email.')
	}, {
	  key: 'mail.host',
	  label: (0, _locale.t)('SMTP Host'),
	  placeholder: 'localhost',
	  defaultValue: function defaultValue() {
	    return 'localhost';
	  }
	}, {
	  key: 'mail.port',
	  label: (0, _locale.t)('SMTP Port'),
	  placeholder: '25',
	  defaultValue: function defaultValue() {
	    return '25';
	  }
	}, {
	  key: 'mail.username',
	  label: (0, _locale.t)('SMTP Username'),
	  defaultValue: function defaultValue() {
	    return '';
	  }
	}, {
	  key: 'mail.password',
	  label: (0, _locale.t)('SMTP Password'),
	  // TODO(mattrobenolt): We don't want to use a real password field unless
	  // there's a way to reveal it. Without being able to see the password, it's
	  // impossible to confirm if it's right.
	  // component: PasswordField,
	  defaultValue: function defaultValue() {
	    return '';
	  }
	}, {
	  key: 'mail.use-tls',
	  label: (0, _locale.t)('Use TLS?'),
	  component: _componentsForms.BooleanField,
	  defaultValue: function defaultValue() {
	    return false;
	  }
	}];
	
	var definitionsMap = _underscore2['default'].indexBy(definitions, 'key');
	
	var disabledReasons = {
	  diskPriority: 'This setting is defined in config.yml and may not be changed via the web UI.',
	  smtpDisabled: 'SMTP mail has been disabled, so this option is unavailable'
	};
	
	function getOption(option) {
	  return definitionsMap[option];
	}
	
	function optionsForSection(section) {
	  return definitions.filter(function (option) {
	    return option.key.split('.')[0] === section.key;
	  });
	}
	
	function getOptionField(option, onChange, value, field) {
	  var meta = _extends({}, getOption(option), field);
	  var Field = meta.component || _componentsForms.TextField;
	  return _react2['default'].createElement(Field, {
	    name: option,
	    key: option,
	    label: meta.label,
	    defaultValue: meta.defaultValue ? meta.defaultValue() : undefined,
	    placeholder: meta.placeholder,
	    help: meta.help,
	    onChange: onChange,
	    required: meta.required && !meta.allowEmpty,
	    value: value,
	    disabled: meta.disabled,
	    disabledReason: meta.disabledReason && disabledReasons[meta.disabledReason] });
	}
	
	function getSectionFieldSet(section, fields) {
	  return _react2['default'].createElement(
	    'fieldset',
	    { key: section.key },
	    section.heading && _react2['default'].createElement(
	      'legend',
	      null,
	      section.heading
	    ),
	    fields
	  );
	}
	
	function getForm(fields) {
	  // fields is a object mapping key name to Fields, so the goal is to split
	  // them up into multiple sections, and spit out fieldsets with a grouping of
	  // all fields, in the right order, under their section.
	  var sets = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var section = _step.value;
	
	      var set = [];
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = optionsForSection(section)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var option = _step2.value;
	
	          if (fields[option.key]) {
	            set.push(fields[option.key]);
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	            _iterator2['return']();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      if (set.length) {
	        sets.push(getSectionFieldSet(section, set));
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return sets;
	}

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _basePlugin = __webpack_require__(192);
	
	var _basePlugin2 = _interopRequireDefault(_basePlugin);
	
	var _componentsIssueActions = __webpack_require__(612);
	
	var _componentsIssueActions2 = _interopRequireDefault(_componentsIssueActions);
	
	var DefaultIssuePlugin = (function (_BasePlugin) {
	    _inherits(DefaultIssuePlugin, _BasePlugin);
	
	    function DefaultIssuePlugin() {
	        _classCallCheck(this, DefaultIssuePlugin);
	
	        _get(Object.getPrototypeOf(DefaultIssuePlugin.prototype), 'constructor', this).apply(this, arguments);
	    }
	
	    _createClass(DefaultIssuePlugin, [{
	        key: 'renderGroupActions',
	        value: function renderGroupActions(props) {
	            return _react2['default'].createElement(_componentsIssueActions2['default'], _extends({ plugin: this }, props));
	        }
	    }]);
	
	    return DefaultIssuePlugin;
	})(_basePlugin2['default']);
	
	exports.DefaultIssuePlugin = DefaultIssuePlugin;
	
	DefaultIssuePlugin.DefaultIssueActions = _componentsIssueActions2['default'];
	
	exports['default'] = DefaultIssuePlugin;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var EnvironmentStore = _reflux2['default'].createStore({
	  init: function init() {
	    this.items = [];
	  },
	
	  loadInitialData: function loadInitialData(items) {
	    this.items = items;
	    this.trigger(this.items, 'initial');
	  },
	
	  getByName: function getByName(name) {
	    name = '' + name;
	    for (var i = 0; i < this.items.length; i++) {
	      if (this.items[i].name === name) {
	        return this.items[i];
	      }
	    }
	    return null;
	  },
	
	  getAll: function getAll() {
	    return this.items;
	  }
	});
	
	exports['default'] = EnvironmentStore;
	module.exports = exports['default'];

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _actionsStreamTagActions = __webpack_require__(265);
	
	var _actionsStreamTagActions2 = _interopRequireDefault(_actionsStreamTagActions);
	
	var _memberListStore = __webpack_require__(91);
	
	var _memberListStore2 = _interopRequireDefault(_memberListStore);
	
	var getMemberListStoreUsernames = function getMemberListStoreUsernames() {
	  return _memberListStore2['default'].getAll().map(function (user) {
	    return user.username || user.email;
	  });
	};
	
	var StreamTagStore = _reflux2['default'].createStore({
	  listenables: _actionsStreamTagActions2['default'],
	
	  init: function init() {
	    this.listenTo(_memberListStore2['default'], this.onMemberListStoreChange);
	    this.reset();
	  },
	
	  reset: function reset() {
	    // TODO(mitsuhiko): what do we do with translations here?
	    this.tags = {
	      is: {
	        key: 'is',
	        name: 'Status',
	        values: ['resolved', 'unresolved', 'ignored',
	        // TODO(dcramer): remove muted once data is migrated and 9.0+
	        'muted', 'assigned', 'unassigned'],
	        predefined: true
	      },
	      has: {
	        key: 'has',
	        name: 'Has Tag',
	        values: [],
	        predefined: true
	      },
	      assigned: {
	        key: 'assigned',
	        name: 'Assigned To',
	        values: getMemberListStoreUsernames(),
	        predefined: true
	      },
	      bookmarks: {
	        key: 'bookmarks',
	        name: 'Bookmarked By',
	        values: getMemberListStoreUsernames(),
	        predefined: true
	      }
	    };
	    this.trigger(this.tags);
	  },
	
	  getTag: function getTag(tagName) {
	    return this.tags[tagName];
	  },
	
	  getAllTags: function getAllTags() {
	    return this.tags;
	  },
	
	  getTagKeys: function getTagKeys() {
	    return Object.keys(this.tags);
	  },
	
	  getTagValues: function getTagValues(tagKey, query) {
	    return this.tags[tagKey].values || [];
	  },
	
	  onLoadTagsSuccess: function onLoadTagsSuccess(data) {
	    var _this = this;
	
	    Object.assign(this.tags, _underscore2['default'].reduce(data, function (obj, tag) {
	
	      tag = Object.assign({
	        values: []
	      }, tag);
	
	      var old = _this.tags[tag.key];
	
	      // Don't override predefined filters (e.g. "is")
	      if (!old || !old.predefined) obj[tag.key] = tag;
	
	      return obj;
	    }, {}));
	    this.tags.has.values = data.map(function (tag) {
	      return tag.key;
	    });
	    this.trigger(this.tags);
	  },
	
	  onMemberListStoreChange: function onMemberListStoreChange(members) {
	    var assignedTag = this.tags.assigned;
	    assignedTag.values = getMemberListStoreUsernames();
	    assignedTag.values.unshift('me');
	    this.tags.bookmarks.values = assignedTag.values;
	    this.trigger(this.tags);
	  }
	});
	
	exports['default'] = StreamTagStore;
	module.exports = exports['default'];

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = errorHandler;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _viewsRouteError = __webpack_require__(694);
	
	var _viewsRouteError2 = _interopRequireDefault(_viewsRouteError);
	
	function errorHandler(Component) {
	  var originalRender = Component.prototype.render;
	  Component.prototype.render = function () {
	    try {
	      return originalRender.apply(this, arguments);
	    } catch (err) {
	      /*eslint no-console:0*/
	      setTimeout(function () {
	        throw err;
	      });
	      return _react2['default'].createElement(_viewsRouteError2['default'], { error: err, component: this });
	    }
	  };
	  return Component;
	}
	
	module.exports = exports['default'];

/***/ },
/* 305 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.userDisplayName = userDisplayName;
	
	function userDisplayName(user) {
	  var displayName = user.name;
	  if (user.email !== user.name) {
	    displayName += ' (' + user.email + ')';
	  }
	  return displayName;
	}

/***/ },
/* 306 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var functions = {};
	
	try {
	  var mod = 'sentry';
	  localStorage.setItem(mod, mod);
	  localStorage.removeItem(mod);
	
	  functions = {
	    setItem: localStorage.setItem.bind(localStorage),
	    getItem: localStorage.getItem.bind(localStorage)
	  };
	} catch (e) {
	  functions = {
	    setItem: function setItem() {
	      return;
	    },
	    // Returns null if key doesn't exist:
	    // https://developer.mozilla.org/en-US/docs/Web/API/Storage/getItem
	    getItem: function getItem() {
	      return null;
	    }
	  };
	}
	
	exports['default'] = functions;
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _marked = __webpack_require__(143);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	function isSafeHref(href, pattern) {
	  try {
	    return pattern.test(decodeURIComponent(unescape(href)));
	  } catch (e) {
	    return false;
	  }
	}
	
	// We need to implement our own marked Renderer to not render
	// potentially malicious uris.
	// This is copy/pasted from
	// https://github.com/chjj/marked/blob/master/lib/marked.js#L869-L888
	// and modified.
	function Renderer() {
	  return _marked2['default'].Renderer.apply(this, arguments);
	}
	Object.assign(Renderer.prototype, _marked2['default'].Renderer.prototype);
	
	// Anythign except javascript, vbscript, data protocols
	var safeLinkPattern = /^(?!javascript|vbscript|data:)/i;
	
	Renderer.prototype.link = function (href, title, text) {
	  // For a bad link, just return the plain text href
	  if (this.options.sanitize && !isSafeHref(href, safeLinkPattern)) return href;
	
	  var out = '<a href="' + href + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += '>' + text + '</a>';
	  return out;
	};
	
	// Only allow http(s) for image tags
	var safeImagePattern = /^https?:\/\/./i;
	
	Renderer.prototype.image = function (href, title, text) {
	  // For a bad image, return an empty string
	  if (this.options.sanitize && !isSafeHref(href, safeImagePattern)) return '';
	
	  var out = '<img src="' + href + '" alt="' + text + '"';
	  if (title) {
	    out += ' title="' + title + '"';
	  }
	  out += this.options.xhtml ? '/>' : '>';
	  return out;
	};
	
	_marked2['default'].setOptions({
	  renderer: new Renderer(),
	  // Disable all HTML input and only accept Markdown
	  sanitize: true
	});
	
	exports['default'] = _marked2['default'];
	module.exports = exports['default'];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var ProjectDocsContext = _react2['default'].createClass({
	  displayName: 'ProjectDocsContext',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsProjectState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      platformList: null,
	      project: null,
	      team: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.fetchData();
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var org = this.context.organization;
	    if (!org) {
	      return;
	    }
	
	    var orgId = org.slug;
	    var projectId = this.context.project.slug;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/docs/', {
	      success: function success(data) {
	        _this.setState({
	          loading: false,
	          data: data
	        });
	      }
	    });
	  },
	
	  render: function render() {
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	
	    var data = this.state.data;
	    return _react2['default'].cloneElement(this.props.children, {
	      platformData: data // {...this.props}
	    });
	  }
	});
	
	exports['default'] = ProjectDocsContext;
	module.exports = exports['default'];

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesEnvironmentStore = __webpack_require__(302);
	
	var _storesEnvironmentStore2 = _interopRequireDefault(_storesEnvironmentStore);
	
	var _storesMemberListStore = __webpack_require__(91);
	
	var _storesMemberListStore2 = _interopRequireDefault(_storesMemberListStore);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsMissingProjectMembership = __webpack_require__(595);
	
	var _componentsMissingProjectMembership2 = _interopRequireDefault(_componentsMissingProjectMembership);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _storesTeamStore = __webpack_require__(141);
	
	var _storesTeamStore2 = _interopRequireDefault(_storesTeamStore);
	
	var _storesProjectStore = __webpack_require__(194);
	
	var _storesProjectStore2 = _interopRequireDefault(_storesProjectStore);
	
	var _locale = __webpack_require__(2);
	
	var ERROR_TYPES = {
	  MISSING_MEMBERSHIP: 'MISSING_MEMBERSHIP',
	  PROJECT_NOT_FOUND: 'PROJECT_NOT_FOUND'
	};
	
	/**
	 * Higher-order component that sets `project` and `team` as child context
	 * values to be accessed by child elements.
	 *
	 * Additionally delays rendering of children until project XHR has finished
	 * and context is populated.
	 */
	var ProjectContext = _react2['default'].createClass({
	  displayName: 'ProjectContext',
	
	  propTypes: {
	    projectId: _react2['default'].PropTypes.string,
	    orgId: _react2['default'].PropTypes.string
	  },
	
	  childContextTypes: {
	    project: _proptypes2['default'].Project,
	    team: _proptypes2['default'].Team
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _reflux2['default'].connect(_storesMemberListStore2['default'], 'memberList'), _reflux2['default'].listenTo(_storesTeamStore2['default'], 'onTeamChange'), _reflux2['default'].listenTo(_storesProjectStore2['default'], 'onProjectChange'), _mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      errorType: null,
	      memberList: [],
	      project: null,
	      team: null,
	      projectNavSection: null
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      project: this.state.project,
	      team: this.state.team
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.projectId !== this.props.projectId) {
	      this.remountComponent();
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.projectId !== this.props.projectId) {
	      this.fetchData();
	    }
	
	    // Call forceUpdate() on <DocumentTitle/> if either project or organization
	    // state has changed. This is because <DocumentTitle/>'s shouldComponentUpdate()
	    // returns false unless props differ; meaning context changes for project/org
	    // do NOT trigger renders for <DocumentTitle/> OR any subchildren. The end result
	    // being that child elements that listen for context changes on project/org will
	    // NOT update (without this hack).
	    // See: https://github.com/gaearon/react-document-title/issues/35
	
	    // intentionally shallow comparing references
	    if (prevState.project !== this.state.project || prevState.organization !== this.state.organization) {
	      var docTitle = this.refs.docTitle;
	      if (docTitle) docTitle.forceUpdate();
	    }
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState());
	  },
	
	  getTitle: function getTitle() {
	    if (this.state.project) return this.state.team.name + ' / ' + this.state.project.name;
	    return 'Sentry';
	  },
	
	  onTeamChange: function onTeamChange(itemIds) {
	    if (!this.state.team) return;
	    if (!itemIds.has(this.state.team.id)) return;
	
	    this.setState({
	      team: _extends({}, _storesTeamStore2['default'].getById(this.state.team.id))
	    });
	  },
	
	  onProjectChange: function onProjectChange(projectIds) {
	    if (!this.state.project) return;
	    if (!projectIds.has(this.state.project.id)) return;
	
	    this.setState({
	      project: _extends({}, _storesProjectStore2['default'].getById(this.state.project.id))
	    });
	  },
	
	  identifyProject: function identifyProject() {
	    var projectId = this.props.projectId;
	
	    var projectSlug = projectId;
	    var activeProject = null;
	    var activeTeam = null;
	    var org = this.context.organization;
	    org.teams.forEach(function (team) {
	      team.projects.forEach(function (project) {
	        if (project.slug == projectSlug) {
	          activeProject = project;
	          activeTeam = team;
	        }
	      });
	    });
	    return [activeTeam, activeProject];
	  },
	
	  fetchData: function fetchData() {
	    var org = this.context.organization;
	    if (!org) {
	      return;
	    }
	
	    var _identifyProject = this.identifyProject();
	
	    var _identifyProject2 = _slicedToArray(_identifyProject, 2);
	
	    var activeTeam = _identifyProject2[0];
	    var activeProject = _identifyProject2[1];
	
	    var hasAccess = activeTeam && activeTeam.hasAccess;
	
	    this.setState({
	      loading: true,
	      project: activeProject,
	      team: activeTeam
	    });
	
	    if (activeProject && hasAccess) {
	      // TODO(dcramer): move member list to organization level
	      this.api.request(this.getMemberListEndpoint(), {
	        success: function success(data) {
	          _storesMemberListStore2['default'].loadInitialData(data.filter(function (m) {
	            return m.user;
	          }).map(function (m) {
	            return m.user;
	          }));
	        }
	      });
	
	      this.api.request(this.getEnvironmentListEndpoint(), {
	        success: function success(data) {
	          _storesEnvironmentStore2['default'].loadInitialData(data);
	        }
	      });
	
	      this.setState({
	        loading: false,
	        error: false,
	        errorType: null
	      });
	    } else if (activeTeam && activeTeam.isMember) {
	      this.setState({
	        loading: false,
	        error: true,
	        errorType: ERROR_TYPES.MISSING_MEMBERSHIP
	      });
	    } else {
	      this.setState({
	        loading: false,
	        error: true,
	        errorType: ERROR_TYPES.PROJECT_NOT_FOUND
	      });
	    }
	  },
	
	  getEnvironmentListEndpoint: function getEnvironmentListEndpoint() {
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	
	    return '/projects/' + orgId + '/' + projectId + '/environments/';
	  },
	
	  getMemberListEndpoint: function getMemberListEndpoint() {
	    var _props2 = this.props;
	    var orgId = _props2.orgId;
	    var projectId = _props2.projectId;
	
	    return '/projects/' + orgId + '/' + projectId + '/members/';
	  },
	
	  setProjectNavSection: function setProjectNavSection(section) {
	    this.setState({
	      projectNavSection: section
	    });
	  },
	
	  renderBody: function renderBody() {
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) {
	      switch (this.state.errorType) {
	        case ERROR_TYPES.PROJECT_NOT_FOUND:
	          return _react2['default'].createElement(
	            'div',
	            { className: 'container' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'alert alert-block' },
	              (0, _locale.t)('The project you were looking for was not found.')
	            )
	          );
	        case ERROR_TYPES.MISSING_MEMBERSHIP:
	          // TODO(dcramer): add various controls to improve this flow and break it
	          // out into a reusable missing access error component
	          return _react2['default'].createElement(_componentsMissingProjectMembership2['default'], {
	            organization: this.getOrganization(),
	            team: this.state.team,
	            project: this.state.project });
	        default:
	          return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.remountComponent });
	      }
	    }
	
	    return this.props.children;
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { ref: 'docTitle', title: this.getTitle() },
	      this.renderBody()
	    );
	  }
	});
	
	exports['default'] = ProjectContext;
	module.exports = exports['default'];

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _componentsActionOverlay = __webpack_require__(536);
	
	var _componentsActionOverlay2 = _interopRequireDefault(_componentsActionOverlay);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _locale = __webpack_require__(2);
	
	var _reactAddonsUpdate = __webpack_require__(739);
	
	var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);
	
	/* given an organization find information about the projects that are
	   needed for callsign review.  Splits up projects you are a member of or
	   not into different lists. */
	function getProjectInfoForReview(org) {
	  var memberProjects = [];
	  var nonMemberProjects = [];
	  var requiresReview = 0;
	  var canReviewAnything = false;
	  var canWriteProjects = new Set(org.access).has('project:write');
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = org.teams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var team = _step.value;
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = team.projects[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var project = _step2.value;
	
	          var canReview = false;
	          var targetList = nonMemberProjects;
	          if (team.isMember) {
	            canReview = canWriteProjects;
	            if (!project.callSignReviewed) {
	              requiresReview++;
	              canReviewAnything = canReviewAnything || canReview;
	            }
	            targetList = memberProjects;
	          }
	          targetList.push({
	            projectId: project.id,
	            projectName: project.name,
	            isMember: team.isMember,
	            requiresReview: !project.callSignReviewed,
	            canReview: canReview,
	            teamName: team.name,
	            callSign: project.callSign || null
	          });
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	            _iterator2['return']();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return {
	    memberProjects: memberProjects,
	    nonMemberProjects: nonMemberProjects,
	    projects: memberProjects.concat(nonMemberProjects),
	    requiresReview: requiresReview,
	    canReviewAnything: canReviewAnything,
	    hasNonMemberProjects: nonMemberProjects.length > 0
	  };
	}
	
	var SetCallsignsAction = _react2['default'].createClass({
	  displayName: 'SetCallsignsAction',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      isLoading: true,
	      info: {},
	      slugs: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  onSubmit: function onSubmit(event) {
	    var _this = this;
	
	    this.setState({
	      isLoading: true
	    });
	
	    var orgId = this.getOrganization().slug;
	    this.api.request('/organizations/' + orgId + '/slugs/', {
	      method: 'PUT',
	      data: { slugs: this.state.slugs },
	      success: function success(data) {
	        _reactRouter.browserHistory.pushState('refresh', '/' + orgId + '/');
	      },
	      error: function error(_error) {
	        /*eslint no-console:0*/
	        console.log('Failed to set slugs:', _error);
	        /*eslint no-alert:0*/
	        alert((0, _locale.t)('Failed to set slugs'));
	      },
	      complete: function complete() {
	        _this.setState({
	          isLoading: false
	        });
	      }
	    });
	  },
	
	  onSetShortName: function onSetShortName(projectId, event) {
	    this.setState({
	      slugs: (0, _reactAddonsUpdate2['default'])(this.state.slugs, _defineProperty({}, projectId, { $set: event.target.value.toUpperCase().trim() }))
	    });
	  },
	
	  fetchData: function fetchData() {
	    var info = getProjectInfoForReview(this.getOrganization());
	    var slugs = {};
	    info.memberProjects.forEach(function (project) {
	      slugs[project.projectId] = project.callSign;
	    });
	
	    this.setState({
	      info: info,
	      slugs: slugs,
	      isLoading: false
	    });
	  },
	
	  isValidCallsign: function isValidCallsign(callsign) {
	    var found = 0;
	
	    if (callsign.match(/^[A-Z]{2,6}$/) === null) {
	      return false;
	    }
	
	    for (var key in this.state.slugs) {
	      if (this.state.slugs[key] === callsign) {
	        found++;
	      }
	    }
	
	    this.state.info.nonMemberProjects.forEach(function (project) {
	      if (project.callSign === callsign) {
	        found++;
	      }
	    });
	
	    return found <= 1;
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var org = this.getOrganization();
	    var info = this.state.info;
	    var canSubmit = true;
	
	    return _react2['default'].createElement(
	      _componentsActionOverlay2['default'],
	      { actionId: 'SET_CALLSIGNS', isLoading: this.state.isLoading },
	      _react2['default'].createElement(
	        'h1',
	        null,
	        (0, _locale.t)('Review Call Signs for Projects')
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('Sentry now requires you to specify a call sign (short name) for each project in the organization “%s”. These short names are used to identify the project in the issue IDs.  Ideally they are two or three letter long.', org.name)
	      ),
	      info.hasNonMemberProjects ? _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('Projects of teams you are not a member of are not shown.')
	      ) : null,
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('Projects which have been previously reviewed are shown in green.')
	      ),
	      _react2['default'].createElement(
	        'form',
	        { className: 'form-horizontal' },
	        info.memberProjects.map(function (project) {
	          var inputId = 'input-' + project.projectId;
	          var className = 'form-group short-id-form-group';
	          var callsign = _this2.state.slugs[project.projectId] || '';
	          if (!project.requiresReview) {
	            className += ' reviewed';
	          }
	          if (!_this2.isValidCallsign(callsign)) {
	            className += ' invalid';
	            canSubmit = false;
	          }
	          if (callsign == '') {
	            className += ' empty';
	            canSubmit = false;
	          }
	
	          return _react2['default'].createElement(
	            'div',
	            { className: className, key: project.projectId },
	            _react2['default'].createElement(
	              'label',
	              { htmlFor: inputId,
	                className: 'col-sm-6 col-sm-offset-2 control-label' },
	              project.teamName,
	              ' / ',
	              project.projectName
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-2' },
	              _react2['default'].createElement('input', { type: 'text',
	                id: inputId,
	                className: 'form-control',
	                onChange: _this2.onSetShortName.bind(_this2, project.projectId),
	                value: callsign })
	            )
	          );
	        }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'actions' },
	          _react2['default'].createElement(
	            'button',
	            { type: 'button',
	              onClick: this.onSubmit,
	              className: 'btn btn-primary btn-lg',
	              disabled: !canSubmit },
	            (0, _locale.t)('Set Call Signs')
	          )
	        )
	      )
	    );
	  }
	});
	
	SetCallsignsAction.requiresAction = function (org) {
	  var info = getProjectInfoForReview(org);
	  return info.requiresReview > 0 && info.canReviewAnything && new Set(org.access).has('callsigns');
	};
	
	SetCallsignsAction.getActionLinkTitle = function () {
	  return (0, _locale.t)('Review Call Signs for Projects');
	};
	
	exports['default'] = SetCallsignsAction;
	module.exports = exports['default'];

/***/ },
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.0.4
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	(function (factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			var _OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = _OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					value = encodeURIComponent(String(value));
					value = value.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					return (document.cookie = [
						key, '=', value,
						attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
						attributes.path    && '; path=' + attributes.path,
						attributes.domain  && '; domain=' + attributes.domain,
						attributes.secure ? '; secure' : ''
					].join(''));
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var name = parts[0].replace(rdecode, decodeURIComponent);
					var cookie = parts.slice(1).join('=');
	
					if (cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						cookie = converter && converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.get = api.set = api;
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init();
	}));


/***/ },
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var _require = __webpack_require__(20);
	
	var findDOMNode = _require.findDOMNode;
	var Children = React.Children;
	var Component = React.Component;
	var PropTypes = React.PropTypes;
	
	var _require2 = __webpack_require__(817);
	
	var add = _require2.add;
	var remove = _require2.remove;
	
	var debounce = __webpack_require__(818);
	var throttle = __webpack_require__(819);
	
	var parentScroll = __webpack_require__(816);
	var inViewport = __webpack_require__(815);
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(LazyLoad).call(this, props));
	
	    _this.lazyLoadHandler = _this.lazyLoadHandler.bind(_this);
	
	    if (props.throttle > 0) {
	      if (props.debounce) {
	        _this.lazyLoadHandler = debounce(_this.lazyLoadHandler, props.throttle);
	      } else {
	        _this.lazyLoadHandler = throttle(_this.lazyLoadHandler, props.throttle);
	      }
	    }
	
	    _this.state = { visible: false };
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var eventNode = this.getEventNode();
	
	      this.lazyLoadHandler();
	
	      if (this.lazyLoadHandler.flush) {
	        this.lazyLoadHandler.flush();
	      }
	
	      add(window, 'resize', this.lazyLoadHandler);
	      add(eventNode, 'scroll', this.lazyLoadHandler);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (!this.state.visible) {
	        this.lazyLoadHandler();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(_nextProps, nextState) {
	      return nextState.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.lazyLoadHandler.cancel) {
	        this.lazyLoadHandler.cancel();
	      }
	
	      this.detachListeners();
	    }
	  }, {
	    key: 'getEventNode',
	    value: function getEventNode() {
	      return parentScroll(findDOMNode(this));
	    }
	  }, {
	    key: 'getOffset',
	    value: function getOffset() {
	      var _props = this.props;
	      var offset = _props.offset;
	      var offsetVertical = _props.offsetVertical;
	      var offsetHorizontal = _props.offsetHorizontal;
	      var offsetTop = _props.offsetTop;
	      var offsetBottom = _props.offsetBottom;
	      var offsetLeft = _props.offsetLeft;
	      var offsetRight = _props.offsetRight;
	      var threshold = _props.threshold;
	
	      var _offsetAll = threshold || offset;
	      var _offsetVertical = offsetVertical || _offsetAll;
	      var _offsetHorizontal = offsetHorizontal || _offsetAll;
	
	      return {
	        top: offsetTop || _offsetVertical,
	        bottom: offsetBottom || _offsetVertical,
	        left: offsetLeft || _offsetHorizontal,
	        right: offsetRight || _offsetHorizontal
	      };
	    }
	  }, {
	    key: 'lazyLoadHandler',
	    value: function lazyLoadHandler() {
	      var offset = this.getOffset();
	      var node = findDOMNode(this);
	      var eventNode = this.getEventNode();
	
	      if (inViewport(node, eventNode, offset)) {
	        var onContentVisible = this.props.onContentVisible;
	
	        this.setState({ visible: true });
	        this.detachListeners();
	
	        if (onContentVisible) {
	          onContentVisible();
	        }
	      }
	    }
	  }, {
	    key: 'detachListeners',
	    value: function detachListeners() {
	      var eventNode = this.getEventNode();
	
	      remove(window, 'resize', this.lazyLoadHandler);
	      remove(eventNode, 'scroll', this.lazyLoadHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var children = _props2.children;
	      var className = _props2.className;
	      var height = _props2.height;
	      var width = _props2.width;
	      var visible = this.state.visible;
	
	      var elStyles = { height: height, width: width };
	      var elClasses = 'LazyLoad' + (visible ? ' is-visible' : '') + (className ? ' ' + className : '');
	
	      return React.createElement(
	        'div',
	        { className: elClasses, style: elStyles },
	        visible && Children.only(children)
	      );
	    }
	  }]);
	
	  return LazyLoad;
	}(Component);
	
	LazyLoad.propTypes = {
	  children: PropTypes.node.isRequired,
	  className: PropTypes.string,
	  debounce: PropTypes.bool,
	  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  offset: PropTypes.number,
	  offsetBottom: PropTypes.number,
	  offsetHorizontal: PropTypes.number,
	  offsetLeft: PropTypes.number,
	  offsetRight: PropTypes.number,
	  offsetTop: PropTypes.number,
	  offsetVertical: PropTypes.number,
	  threshold: PropTypes.number,
	  throttle: PropTypes.number,
	  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  onContentVisible: PropTypes.func
	};
	
	LazyLoad.defaultProps = {
	  debounce: true,
	  offset: 0,
	  offsetBottom: 0,
	  offsetHorizontal: 0,
	  offsetLeft: 0,
	  offsetRight: 0,
	  offsetTop: 0,
	  offsetVertical: 0,
	  throttle: 250
	};
	
	module.exports = LazyLoad;

/***/ },
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Channel = function Channel(data) {
	  _classCallCheck(this, Channel);
	
	  var listeners = [];
	  data = data || {};
	
	  this.subscribe = function (fn) {
	    listeners.push(fn);
	  };
	
	  this.unsubscribe = function (fn) {
	    var idx = listeners.indexOf(fn);
	    if (idx !== -1) listeners.splice(idx, 1);
	  };
	
	  this.update = function (fn) {
	    if (fn) fn(data);
	    listeners.forEach(function (l) {
	      return l(data);
	    });
	  };
	};
	
	exports.default = Channel;
	module.exports = exports['default'];

/***/ },
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	(function(window) {
	    var re = {
	        not_string: /[^s]/,
	        number: /[diefg]/,
	        json: /[j]/,
	        not_json: /[^j]/,
	        text: /^[^\x25]+/,
	        modulo: /^\x25{2}/,
	        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijosuxX])/,
	        key: /^([a-z_][a-z_\d]*)/i,
	        key_access: /^\.([a-z_][a-z_\d]*)/i,
	        index_access: /^\[(\d+)\]/,
	        sign: /^[\+\-]/
	    }
	
	    function sprintf() {
	        var key = arguments[0], cache = sprintf.cache
	        if (!(cache[key] && cache.hasOwnProperty(key))) {
	            cache[key] = sprintf.parse(key)
	        }
	        return sprintf.format.call(null, cache[key], arguments)
	    }
	
	    sprintf.format = function(parse_tree, argv) {
	        var cursor = 1, tree_length = parse_tree.length, node_type = "", arg, output = [], i, k, match, pad, pad_character, pad_length, is_positive = true, sign = ""
	        for (i = 0; i < tree_length; i++) {
	            node_type = get_type(parse_tree[i])
	            if (node_type === "string") {
	                output[output.length] = parse_tree[i]
	            }
	            else if (node_type === "array") {
	                match = parse_tree[i] // convenience purposes only
	                if (match[2]) { // keyword argument
	                    arg = argv[cursor]
	                    for (k = 0; k < match[2].length; k++) {
	                        if (!arg.hasOwnProperty(match[2][k])) {
	                            throw new Error(sprintf("[sprintf] property '%s' does not exist", match[2][k]))
	                        }
	                        arg = arg[match[2][k]]
	                    }
	                }
	                else if (match[1]) { // positional argument (explicit)
	                    arg = argv[match[1]]
	                }
	                else { // positional argument (implicit)
	                    arg = argv[cursor++]
	                }
	
	                if (get_type(arg) == "function") {
	                    arg = arg()
	                }
	
	                if (re.not_string.test(match[8]) && re.not_json.test(match[8]) && (get_type(arg) != "number" && isNaN(arg))) {
	                    throw new TypeError(sprintf("[sprintf] expecting number but found %s", get_type(arg)))
	                }
	
	                if (re.number.test(match[8])) {
	                    is_positive = arg >= 0
	                }
	
	                switch (match[8]) {
	                    case "b":
	                        arg = arg.toString(2)
	                    break
	                    case "c":
	                        arg = String.fromCharCode(arg)
	                    break
	                    case "d":
	                    case "i":
	                        arg = parseInt(arg, 10)
	                    break
	                    case "j":
	                        arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0)
	                    break
	                    case "e":
	                        arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential()
	                    break
	                    case "f":
	                        arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg)
	                    break
	                    case "g":
	                        arg = match[7] ? parseFloat(arg).toPrecision(match[7]) : parseFloat(arg)
	                    break
	                    case "o":
	                        arg = arg.toString(8)
	                    break
	                    case "s":
	                        arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg)
	                    break
	                    case "u":
	                        arg = arg >>> 0
	                    break
	                    case "x":
	                        arg = arg.toString(16)
	                    break
	                    case "X":
	                        arg = arg.toString(16).toUpperCase()
	                    break
	                }
	                if (re.json.test(match[8])) {
	                    output[output.length] = arg
	                }
	                else {
	                    if (re.number.test(match[8]) && (!is_positive || match[3])) {
	                        sign = is_positive ? "+" : "-"
	                        arg = arg.toString().replace(re.sign, "")
	                    }
	                    else {
	                        sign = ""
	                    }
	                    pad_character = match[4] ? match[4] === "0" ? "0" : match[4].charAt(1) : " "
	                    pad_length = match[6] - (sign + arg).length
	                    pad = match[6] ? (pad_length > 0 ? str_repeat(pad_character, pad_length) : "") : ""
	                    output[output.length] = match[5] ? sign + arg + pad : (pad_character === "0" ? sign + pad + arg : pad + sign + arg)
	                }
	            }
	        }
	        return output.join("")
	    }
	
	    sprintf.cache = {}
	
	    sprintf.parse = function(fmt) {
	        var _fmt = fmt, match = [], parse_tree = [], arg_names = 0
	        while (_fmt) {
	            if ((match = re.text.exec(_fmt)) !== null) {
	                parse_tree[parse_tree.length] = match[0]
	            }
	            else if ((match = re.modulo.exec(_fmt)) !== null) {
	                parse_tree[parse_tree.length] = "%"
	            }
	            else if ((match = re.placeholder.exec(_fmt)) !== null) {
	                if (match[2]) {
	                    arg_names |= 1
	                    var field_list = [], replacement_field = match[2], field_match = []
	                    if ((field_match = re.key.exec(replacement_field)) !== null) {
	                        field_list[field_list.length] = field_match[1]
	                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
	                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
	                                field_list[field_list.length] = field_match[1]
	                            }
	                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
	                                field_list[field_list.length] = field_match[1]
	                            }
	                            else {
	                                throw new SyntaxError("[sprintf] failed to parse named argument key")
	                            }
	                        }
	                    }
	                    else {
	                        throw new SyntaxError("[sprintf] failed to parse named argument key")
	                    }
	                    match[2] = field_list
	                }
	                else {
	                    arg_names |= 2
	                }
	                if (arg_names === 3) {
	                    throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported")
	                }
	                parse_tree[parse_tree.length] = match
	            }
	            else {
	                throw new SyntaxError("[sprintf] unexpected placeholder")
	            }
	            _fmt = _fmt.substring(match[0].length)
	        }
	        return parse_tree
	    }
	
	    var vsprintf = function(fmt, argv, _argv) {
	        _argv = (argv || []).slice(0)
	        _argv.splice(0, 0, fmt)
	        return sprintf.apply(null, _argv)
	    }
	
	    /**
	     * helpers
	     */
	    function get_type(variable) {
	        return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase()
	    }
	
	    function str_repeat(input, multiplier) {
	        return Array(multiplier + 1).join(input)
	    }
	
	    /**
	     * export to either browser or node.js
	     */
	    if (true) {
	        exports.sprintf = sprintf
	        exports.vsprintf = vsprintf
	    }
	    else {
	        window.sprintf = sprintf
	        window.vsprintf = vsprintf
	
	        if (typeof define === "function" && define.amd) {
	            define(function() {
	                return {
	                    sprintf: sprintf,
	                    vsprintf: vsprintf
	                }
	            })
	        }
	    }
	})(typeof window === "undefined" ? this : window);


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./bg/LC_MESSAGES/django.po": 318,
		"./cs/LC_MESSAGES/django.po": 319,
		"./de/LC_MESSAGES/django.po": 320,
		"./en/LC_MESSAGES/django.po": 730,
		"./es/LC_MESSAGES/django.po": 321,
		"./fi/LC_MESSAGES/django.po": 322,
		"./fr/LC_MESSAGES/django.po": 323,
		"./it/LC_MESSAGES/django.po": 324,
		"./ja/LC_MESSAGES/django.po": 325,
		"./ru/LC_MESSAGES/django.po": 326,
		"./zh_CN/LC_MESSAGES/django.po": 327,
		"./zh_TW/LC_MESSAGES/django.po": 328
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 412;


/***/ },
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports.load = load;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _actionsIncidentActions = __webpack_require__(263);
	
	var _actionsIncidentActions2 = _interopRequireDefault(_actionsIncidentActions);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function getIncidentsFromIncidentResponse(incidents) {
	  if (incidents === null || incidents.length == 0) {
	    return [[], 'none'];
	  }
	
	  var isMajor = false;
	  var log = [];
	  incidents.forEach(function (item) {
	    if (!isMajor && item.impact === 'major') {
	      isMajor = true;
	    }
	    log.push({
	      name: item.name,
	      updates: item.incident_updates.map(function (update) {
	        return update.body;
	      }),
	      url: item.shortlink,
	      status: item.status
	    });
	  });
	
	  return [log, isMajor ? 'major' : 'minor'];
	}
	
	function load() {
	  var cfg = _storesConfigStore2['default'].get('statuspage');
	  if (cfg && cfg.id) {
	    _actionsIncidentActions2['default'].update();
	
	    _jquery2['default'].ajax({
	      type: 'GET',
	      url: 'https://' + cfg.id + '.' + cfg.api_host + '/api/v2/incidents/unresolved.json',
	      crossDomain: true,
	      cache: false,
	      success: function success(data) {
	        var _getIncidentsFromIncidentResponse = getIncidentsFromIncidentResponse(data.incidents);
	
	        var _getIncidentsFromIncidentResponse2 = _slicedToArray(_getIncidentsFromIncidentResponse, 2);
	
	        var incidents = _getIncidentsFromIncidentResponse2[0];
	        var indicator = _getIncidentsFromIncidentResponse2[1];
	
	        _actionsIncidentActions2['default'].updateSuccess({
	          status: {
	            incidents: incidents,
	            indicator: indicator,
	            url: data.page.url
	          }
	        });
	      },
	      error: function error() {
	        _actionsIncidentActions2['default'].updateError({
	          status: null
	        });
	      }
	    });
	  }
	}

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _locale = __webpack_require__(2);
	
	var _componentsRequiredAdminActions = __webpack_require__(293);
	
	var _componentsRequiredAdminActions2 = _interopRequireDefault(_componentsRequiredAdminActions);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var ActionOverlay = _react2['default'].createClass({
	  displayName: 'ActionOverlay',
	
	  propTypes: {
	    actionId: _react2['default'].PropTypes.string.isRequired,
	    isLoading: _react2['default'].PropTypes.bool
	  },
	
	  contextTypes: {
	    router: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_mixinsOrganizationState2['default']],
	
	  componentWillMount: function componentWillMount() {
	    var action = this.getAction();
	    if (!action.requiresAction(this.getOrganization())) {
	      this.dismiss();
	    }
	  },
	
	  getAction: function getAction() {
	    return _componentsRequiredAdminActions2['default'][this.props.actionId];
	  },
	
	  dismiss: function dismiss() {
	    // is this the right thing?
	    this.context.router.goBack();
	  },
	
	  onDoThisLater: function onDoThisLater(event) {
	    event.preventDefault();
	    this.dismiss();
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var isLoading = _props.isLoading;
	
	    var other = _objectWithoutProperties(_props, ['children', 'isLoading']);
	
	    var orgUrl = '/organizations/' + this.getOrganization().slug + '/';
	    var className = 'admin-action-overlay';
	    if (isLoading) {
	      className += ' loading-data';
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      _extends({ className: className }, other),
	      _react2['default'].createElement('div', { className: 'pattern' }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'container' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'dialog' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'dialog-contents' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'discard-bar' },
	              _react2['default'].createElement(
	                'a',
	                { href: orgUrl, onClick: this.onDoThisLater },
	                (0, _locale.t)('Do this later …')
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'content' },
	              children
	            ),
	            isLoading ? _react2['default'].createElement(
	              'div',
	              { className: 'loading-overlay' },
	              _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	            ) : null
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ActionOverlay;
	module.exports = exports['default'];

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _item = __webpack_require__(538);
	
	var _item2 = _interopRequireDefault(_item);
	
	var _loadingError = __webpack_require__(9);
	
	var _loadingError2 = _interopRequireDefault(_loadingError);
	
	var _loadingIndicator = __webpack_require__(6);
	
	var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);
	
	var _pagination = __webpack_require__(39);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _locale = __webpack_require__(2);
	
	var _utilsLogging = __webpack_require__(142);
	
	var ActivityFeed = _react2['default'].createClass({
	  displayName: 'ActivityFeed',
	
	  propTypes: {
	    endpoint: _react2['default'].PropTypes.string,
	    query: _react2['default'].PropTypes.object,
	    renderEmpty: _react2['default'].PropTypes.func,
	    pagination: _react2['default'].PropTypes.bool
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      pagination: true,
	      query: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      itemList: [],
	      loading: true,
	      error: false,
	      pageLinks: null
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var location = this.props.location;
	    var nextLocation = nextProps.location;
	    if (location.pathname != nextLocation.pathname || location.search != nextLocation.search) {
	      this.remountComponent();
	    }
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var location = this.props.location;
	    this.api.clear();
	    this.api.request(this.props.endpoint, {
	      method: 'GET',
	      query: _extends({
	        cursor: location.query.cursor || ''
	      }, this.props.query),
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          loading: false,
	          error: false,
	          itemList: data,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  renderResults: function renderResults() {
	    var body = undefined;
	    var orgId = this.props.params.orgId;
	
	    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = _react2['default'].createElement(_loadingError2['default'], { onRetry: this.fetchData });else if (this.state.itemList.length > 0) {
	      body = _react2['default'].createElement(
	        'div',
	        { className: 'activity-container' },
	        _react2['default'].createElement(
	          'ul',
	          { className: 'activity' },
	          this.state.itemList.map(function (item) {
	            try {
	              return _react2['default'].createElement(_item2['default'], { key: item.id, orgId: orgId, item: item });
	            } catch (ex) {
	              (0, _utilsLogging.logException)(ex, {
	                itemId: item.id
	              });
	              return null;
	            }
	          })
	        )
	      );
	    } else body = (this.props.renderEmpty || this.renderEmpty)();
	
	    return body;
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_loadingIndicator2['default'], null)
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty' },
	      (0, _locale.t)('Nothing to show here, move along.')
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.renderResults(),
	      this.props.pagination && this.state.pageLinks && _react2['default'].createElement(_pagination2['default'], _extends({ pageLinks: this.state.pageLinks }, this.props))
	    );
	  }
	});
	
	exports['default'] = ActivityFeed;
	module.exports = exports['default'];

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _marked = __webpack_require__(143);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsDuration = __webpack_require__(174);
	
	var _componentsDuration2 = _interopRequireDefault(_componentsDuration);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _reactRouter = __webpack_require__(8);
	
	var _storesMemberListStore = __webpack_require__(91);
	
	var _storesMemberListStore2 = _interopRequireDefault(_storesMemberListStore);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _componentsVersion = __webpack_require__(107);
	
	var _componentsVersion2 = _interopRequireDefault(_componentsVersion);
	
	var _locale = __webpack_require__(2);
	
	var ActivityItem = _react2['default'].createClass({
	  displayName: 'ActivityItem',
	
	  propTypes: {
	    clipHeight: _react2['default'].PropTypes.number,
	    defaultClipped: _react2['default'].PropTypes.bool,
	    item: _react2['default'].PropTypes.object.isRequired,
	    orgId: _react2['default'].PropTypes.string.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultClipped: false,
	      clipHeight: 68
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      clipped: this.props.defaultClipped
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.refs.activityBubble) {
	      var bubbleHeight = this.refs.activityBubble.offsetHeight;
	
	      if (bubbleHeight > this.props.clipHeight) {
	        /*eslint react/no-did-mount-set-state:0*/
	        // okay if this causes re-render; cannot determine until
	        // rendered first anyways
	        this.setState({
	          clipped: true
	        });
	      }
	    }
	  },
	
	  formatProjectActivity: function formatProjectActivity(author, item) {
	    var data = item.data;
	    var orgId = this.props.orgId;
	    var project = item.project;
	    var issue = item.issue;
	
	    switch (item.type) {
	      case 'note':
	        return (0, _locale.tct)('[author] commented on [link:an issue]', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/activity/#event_' + item.id })
	        });
	      case 'set_resolved':
	        return (0, _locale.tct)('[author] marked [link:an issue] as resolved', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'set_resolved_by_age':
	        return (0, _locale.tct)('[author] marked [link:an issue] as resolved due to age', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'set_resolved_in_release':
	        if (data.version) {
	          return (0, _locale.tct)('[author] marked [link:an issue] as resolved in [version]', {
	            author: author,
	            version: _react2['default'].createElement(_componentsVersion2['default'], { version: data.version, orgId: orgId, projectId: project.slug }),
	            link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	          });
	        }
	        return (0, _locale.tct)('[author] marked [link:an issue] as resolved in the upcoming release', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'set_unresolved':
	        return (0, _locale.tct)('[author] marked [link:an issue] as unresolved', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'set_ignored':
	        if (data.ignoreDuration) {
	          return (0, _locale.tct)('[author] ignored [link:an issue] for [duration]', {
	            author: author,
	            duration: _react2['default'].createElement(_componentsDuration2['default'], { seconds: data.ignoreDuration * 60 }),
	            link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	          });
	        }
	        return (0, _locale.tct)('[author] ignored [link:an issue]', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'set_public':
	        return (0, _locale.tct)('[author] made an [link:an issue] public', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'set_private':
	        return (0, _locale.tct)('[author] made an [link:an issue] private', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'set_regression':
	        if (data.version) {
	          return (0, _locale.tct)('[author] marked [link:an issue] as a regression in [version]', {
	            author: author,
	            version: _react2['default'].createElement(_componentsVersion2['default'], { version: data.version, orgId: orgId, projectId: project.slug }),
	            link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	          });
	        }
	        return (0, _locale.tct)('[author] marked [link:an issue] as a regression', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'create_issue':
	        return (0, _locale.tct)('[author] linked [link:an issue] on [provider]', {
	          author: author,
	          provider: data.provider,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'first_seen':
	        return (0, _locale.tct)('[author] saw [link:a new issue]', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'assigned':
	        var assignee = undefined;
	        if (item.user && data.assignee === item.user.id) {
	          return (0, _locale.tct)('[author] assigned [link:an issue] to themselves', {
	            author: author,
	            link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	          });
	        }
	        assignee = _storesMemberListStore2['default'].getById(data.assignee);
	        if (assignee && assignee.email) {
	          return (0, _locale.tct)('[author] assigned [link:an issue] to [assignee]', {
	            author: author,
	            assignee: _react2['default'].createElement(
	              'span',
	              { title: assignee.email },
	              assignee.name
	            ),
	            link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	          });
	        } else if (data.assigneeEmail) {
	          return (0, _locale.tct)('[author] assigned [link:an issue] to [assignee]', {
	            author: author,
	            assignee: data.assigneeEmail,
	            link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	          });
	        }
	        return (0, _locale.tct)('[author] assigned [link:an issue] to an [help:unknown user]', {
	          author: author,
	          help: _react2['default'].createElement('span', { title: data.assignee }),
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'unassigned':
	        return (0, _locale.tct)('[author] unassigned [link:an issue]', {
	          author: author,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'merge':
	        return (0, _locale.tct)('[author] merged [count] [link:issues]', {
	          author: author,
	          count: data.issues.length + 1,
	          link: _react2['default'].createElement(_reactRouter.Link, { to: '/' + orgId + '/' + project.slug + '/issues/' + issue.id + '/' })
	        });
	      case 'release':
	        return (0, _locale.tct)('[author] released version [version]', {
	          author: author,
	          version: _react2['default'].createElement(_componentsVersion2['default'], { version: data.version, orgId: orgId, projectId: project.slug })
	        });
	      default:
	        return ''; // should never hit (?)
	    }
	  },
	
	  render: function render() {
	    var item = this.props.item;
	    var orgId = this.props.orgId;
	
	    var bubbleClassName = 'activity-item-bubble';
	    if (this.state.clipped) {
	      bubbleClassName += ' clipped';
	    }
	
	    var avatar = item.user ? _react2['default'].createElement(_componentsAvatar2['default'], { user: item.user, size: 64, className: 'avatar' }) : _react2['default'].createElement(
	      'div',
	      { className: 'avatar sentry' },
	      _react2['default'].createElement('span', { className: 'icon-sentry-logo' })
	    );
	
	    var author = {
	      name: item.user ? item.user.name : 'Sentry',
	      avatar: avatar
	    };
	
	    if (item.type === 'note') {
	      var noteBody = (0, _marked2['default'])(item.data.text);
	      return _react2['default'].createElement(
	        'li',
	        { className: 'activity-item activity-item-compact' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'activity-item-content' },
	          this.formatProjectActivity(_react2['default'].createElement(
	            'span',
	            null,
	            author.avatar,
	            _react2['default'].createElement(
	              'span',
	              { className: 'activity-author' },
	              author.name
	            )
	          ), item),
	          _react2['default'].createElement('div', { className: bubbleClassName, ref: 'activityBubble', dangerouslySetInnerHTML: { __html: noteBody } }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'activity-meta' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              {
	                className: 'project',
	                to: '/' + orgId + '/' + item.project.slug + '/' },
	              item.project.name
	            ),
	            _react2['default'].createElement('span', { className: 'bullet' }),
	            _react2['default'].createElement(_componentsTimeSince2['default'], { date: item.dateCreated })
	          )
	        )
	      );
	    } else if (item.type === 'create_issue') {
	      return _react2['default'].createElement(
	        'li',
	        { className: 'activity-item activity-item-compact' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'activity-item-content' },
	          this.formatProjectActivity(_react2['default'].createElement(
	            'span',
	            null,
	            author.avatar,
	            _react2['default'].createElement(
	              'span',
	              { className: 'activity-author' },
	              author.name
	            )
	          ), item),
	          _react2['default'].createElement(
	            'div',
	            { className: 'activity-item-bubble' },
	            _react2['default'].createElement(
	              'a',
	              { href: item.data.location },
	              item.data.title
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'activity-meta' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              {
	                className: 'project',
	                to: '/' + orgId + '/' + item.project.slug + '/' },
	              item.project.name
	            ),
	            _react2['default'].createElement('span', { className: 'bullet' }),
	            _react2['default'].createElement(_componentsTimeSince2['default'], { date: item.dateCreated })
	          )
	        )
	      );
	    } else {
	      return _react2['default'].createElement(
	        'li',
	        { className: 'activity-item activity-item-compact' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'activity-item-content' },
	          this.formatProjectActivity(_react2['default'].createElement(
	            'span',
	            null,
	            author.avatar,
	            _react2['default'].createElement(
	              'span',
	              { className: 'activity-author' },
	              author.name
	            )
	          ), item),
	          _react2['default'].createElement(
	            'div',
	            { className: 'activity-meta' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              {
	                className: 'project',
	                to: '/' + orgId + '/' + item.project.slug + '/' },
	              item.project.name
	            ),
	            _react2['default'].createElement('span', { className: 'bullet' }),
	            _react2['default'].createElement(_componentsTimeSince2['default'], { date: item.dateCreated })
	          )
	        )
	      );
	    }
	  }
	});
	
	exports['default'] = ActivityItem;
	module.exports = exports['default'];

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _componentsLinkWithConfirmation = __webpack_require__(183);
	
	var _componentsLinkWithConfirmation2 = _interopRequireDefault(_componentsLinkWithConfirmation);
	
	var _locale = __webpack_require__(2);
	
	var _utilsMarked = __webpack_require__(307);
	
	var _utilsMarked2 = _interopRequireDefault(_utilsMarked);
	
	var Note = _react2['default'].createClass({
	  displayName: 'Note',
	
	  propTypes: {
	    author: _react2['default'].PropTypes.object.isRequired,
	    item: _react2['default'].PropTypes.object.isRequired,
	    onEdit: _react2['default'].PropTypes.func.isRequired,
	    onDelete: _react2['default'].PropTypes.func.isRequired
	  },
	
	  canEdit: function canEdit() {
	    var user = _storesConfigStore2['default'].get('user');
	    return user.isSuperuser || user.id === this.props.item.user.id;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var item = _props.item;
	    var author = _props.author;
	    var onEdit = _props.onEdit;
	    var onDelete = _props.onDelete;
	
	    var noteBody = (0, _utilsMarked2['default'])(item.data.text);
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(_componentsTimeSince2['default'], { date: item.dateCreated }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'activity-author' },
	        author.name,
	        this.canEdit() && _react2['default'].createElement(
	          'span',
	          { className: 'editor-tools' },
	          _react2['default'].createElement(
	            'a',
	            { onClick: onEdit },
	            (0, _locale.t)('Edit')
	          ),
	          _react2['default'].createElement(
	            _componentsLinkWithConfirmation2['default'],
	            {
	              className: 'danger',
	              message: (0, _locale.t)('Are you sure you wish to delete this comment?'),
	              onConfirm: onDelete },
	            (0, _locale.t)('Remove')
	          )
	        )
	      ),
	      _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: noteBody } })
	    );
	  }
	});
	
	exports['default'] = Note;
	module.exports = exports['default'];

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _note = __webpack_require__(539);
	
	var _note2 = _interopRequireDefault(_note);
	
	var _noteInput = __webpack_require__(267);
	
	var _noteInput2 = _interopRequireDefault(_noteInput);
	
	var NoteContainer = _react2['default'].createClass({
	  displayName: 'NoteContainer',
	
	  propTypes: {
	    group: _react2['default'].PropTypes.object.isRequired,
	    item: _react2['default'].PropTypes.object.isRequired,
	    author: _react2['default'].PropTypes.object.isRequired,
	    onDelete: _react2['default'].PropTypes.func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      editing: false
	    };
	  },
	
	  onEdit: function onEdit() {
	    this.setState({ editing: true });
	  },
	
	  onFinish: function onFinish() {
	    this.setState({ editing: false });
	  },
	
	  onDelete: function onDelete() {
	    this.props.onDelete(this.props.item);
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var group = _props.group;
	    var item = _props.item;
	    var author = _props.author;
	
	    return _react2['default'].createElement(
	      'li',
	      { className: 'activity-note' },
	      author.avatar,
	      _react2['default'].createElement(
	        'div',
	        { className: 'activity-bubble' },
	        this.state.editing ? _react2['default'].createElement(_noteInput2['default'], {
	          group: group,
	          item: item,
	          onFinish: this.onFinish }) : _react2['default'].createElement(_note2['default'], {
	          item: item,
	          author: author,
	          onEdit: this.onEdit,
	          onDelete: this.onDelete })
	      )
	    );
	  }
	});
	
	exports['default'] = NoteContainer;
	module.exports = exports['default'];

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsAlertActions = __webpack_require__(62);
	
	var _actionsAlertActions2 = _interopRequireDefault(_actionsAlertActions);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _locale = __webpack_require__(2);
	
	var AlertMessage = _react2['default'].createClass({
	  displayName: 'AlertMessage',
	
	  propTypes: {
	    alert: _react2['default'].PropTypes.shape({
	      id: _react2['default'].PropTypes.string,
	      message: _react2['default'].PropTypes.string.isRequired,
	      type: _react2['default'].PropTypes.oneOf(['success', 'error', 'warning']),
	      url: _react2['default'].PropTypes.string
	    })
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default']],
	
	  closeAlert: function closeAlert() {
	    _actionsAlertActions2['default'].closeAlert(this.props.alert);
	  },
	
	  render: function render() {
	    var className = 'alert';
	    if (this.props.alert.type !== '') {
	      className += ' alert-' + this.props.alert.type;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: className },
	      _react2['default'].createElement(
	        'div',
	        { className: 'container' },
	        _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'close', 'aria-label': (0, _locale.t)('Close'),
	            onClick: this.closeAlert },
	          _react2['default'].createElement(
	            'span',
	            { 'aria-hidden': 'true' },
	            '×'
	          )
	        ),
	        _react2['default'].createElement('span', { className: 'icon' }),
	        this.props.alert.url ? _react2['default'].createElement(
	          'a',
	          { href: this.props.alert.url },
	          this.props.alert.message
	        ) : this.props.alert.message
	      )
	    );
	  }
	});
	
	exports['default'] = AlertMessage;
	module.exports = exports['default'];

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function ToastIndicator(_ref) {
	  var type = _ref.type;
	  var children = _ref.children;
	
	  return _react2['default'].createElement(
	    'div',
	    { className: (0, _classnames2['default'])('toast', type) },
	    _react2['default'].createElement('span', { className: 'icon' }),
	    _react2['default'].createElement(
	      'div',
	      { className: 'toast-message' },
	      children
	    )
	  );
	}
	
	exports['default'] = ToastIndicator;
	module.exports = exports['default'];

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsAlertActions = __webpack_require__(62);
	
	var _actionsAlertActions2 = _interopRequireDefault(_actionsAlertActions);
	
	var _locale = __webpack_require__(2);
	
	var AvatarCropper = _react2['default'].createClass({
	  displayName: 'AvatarCropper',
	
	  propTypes: {
	    user: _react2['default'].PropTypes.object.isRequired,
	    updateDataUrlState: _react2['default'].PropTypes.func.isRequired,
	    savedDataUrl: _react2['default'].PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      mousePosition: {
	        pageX: null,
	        pageY: null
	      },
	      resizeDimensions: {
	        top: 0,
	        left: 0,
	        size: 0
	      }
	    };
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.revokeObjectUrl();
	  },
	
	  MIN_DIMENSION: 256,
	
	  MAX_DIMENSION: 1024,
	
	  onChange: function onChange(ev) {
	    var _this = this;
	
	    /*eslint consistent-return:0*/
	    var file = ev.target.files[0];
	
	    if (!file) return; // No file selected (e.g. user clicked "cancel")
	
	    if (!/^image\//.test(file.type)) return void this.handleError('That is not a supported file type.');
	
	    this.revokeObjectUrl();
	    this.setState({
	      file: file,
	      objectURL: window.URL.createObjectURL(file)
	    }, function () {
	      _this.props.updateDataUrlState({ savedDataUrl: null });
	    });
	  },
	
	  revokeObjectUrl: function revokeObjectUrl() {
	    this.state.objectURL && window.URL.revokeObjectURL(this.state.objectURL);
	  },
	
	  updateDimensions: function updateDimensions(ev) {
	    var $container = $(this.refs.cropContainer);
	    var resizeDimensions = this.state.resizeDimensions;
	    var pageY = ev.pageY;
	    var pageX = ev.pageX;
	    var top = resizeDimensions.top + (pageY - this.state.mousePosition.pageY);
	    var left = resizeDimensions.left + (pageX - this.state.mousePosition.pageX);
	    if (top < 0) {
	      top = 0;
	      pageY = this.state.mousePosition.pageY;
	    } else if (top + resizeDimensions.size > $container.height()) {
	      top = $container.height() - resizeDimensions.size;
	      pageY = this.state.mousePosition.pageY;
	    }
	    if (left < 0) {
	      left = 0;
	      pageX = this.state.mousePosition.pageX;
	    } else if (left + resizeDimensions.size > $container.width()) {
	      left = $container.width() - resizeDimensions.size;
	      pageX = this.state.mousePosition.pageX;
	    }
	    this.setState({
	      resizeDimensions: Object.assign({}, resizeDimensions, { top: top, left: left }),
	      mousePosition: { pageX: pageX, pageY: pageY }
	    });
	  },
	
	  startMove: function startMove() {
	    $(document).on('mousemove', this.updateDimensions);
	    $(document).on('mouseup', this.onMouseUp);
	  },
	
	  stopMove: function stopMove() {
	    $(document).off('mousemove', this.updateDimensions);
	    $(document).off('mouseup', this.onMouseUp);
	    this.drawToCanvas();
	  },
	
	  onMouseDown: function onMouseDown(ev) {
	    ev.preventDefault();
	    this.setState({ mousePosition: {
	        pageY: ev.pageY,
	        pageX: ev.pageX
	      } });
	    this.startMove();
	  },
	
	  onMouseUp: function onMouseUp(ev) {
	    ev.preventDefault();
	    this.stopMove();
	  },
	
	  startResize: function startResize(direction, ev) {
	    ev.stopPropagation();
	    ev.preventDefault();
	    $(document).on('mousemove', this.updateSize);
	    $(document).on('mouseup', this.stopResize);
	    this.setState({
	      resizeDirection: direction,
	      mousePosition: {
	        pageY: ev.pageY,
	        pageX: ev.pageX
	      }
	    });
	  },
	
	  stopResize: function stopResize(ev) {
	    ev.stopPropagation();
	    ev.preventDefault();
	    $(document).off('mousemove', this.updateSize);
	    $(document).off('mouseup', this.stopResize);
	    this.drawToCanvas();
	  },
	
	  updateSize: function updateSize(ev) {
	    var yDiff = ev.pageY - this.state.mousePosition.pageY;
	    var xDiff = ev.pageX - this.state.mousePosition.pageX;
	    var $container = $(this.refs.cropContainer);
	
	    this.setState({
	      resizeDimensions: this.getNewDimensions($container, yDiff, xDiff),
	      mousePosition: { pageX: ev.pageX, pageY: ev.pageY }
	    });
	  },
	
	  // Normalize diff accross dimensions so that negative diffs
	  // are always making the cropper smaller and positive ones
	  // are making the cropper larger
	  getDiffNW: function getDiffNW(yDiff, xDiff) {
	    return (yDiff - yDiff * 2 + (xDiff - xDiff * 2)) / 2;
	  },
	
	  getDiffNE: function getDiffNE(yDiff, xDiff) {
	    return (yDiff - yDiff * 2 + xDiff) / 2;
	  },
	
	  getDiffSW: function getDiffSW(yDiff, xDiff) {
	    return (yDiff + (xDiff - xDiff * 2)) / 2;
	  },
	
	  getDiffSE: function getDiffSE(yDiff, xDiff) {
	    return (yDiff + xDiff) / 2;
	  },
	
	  getNewDimensions: function getNewDimensions($container, yDiff, xDiff) {
	    var oldDimensions = this.state.resizeDimensions;
	    var resizeDirection = this.state.resizeDirection;
	    var diff = this['getDiff' + resizeDirection.toUpperCase()](yDiff, xDiff);
	
	    var height = $container.height() - oldDimensions.top;
	    var width = $container.width() - oldDimensions.left;
	
	    // Depending on the direction, we update different dimensions:
	    // nw: size, top, left
	    // ne: size, top
	    // sw: size, left
	    // se: size
	    var editingTop = resizeDirection === 'nw' || resizeDirection === 'ne';
	    var editingLeft = resizeDirection === 'nw' || resizeDirection === 'sw';
	    var newDimensions = { size: oldDimensions.size + diff };
	    if (editingTop) {
	      newDimensions.top = oldDimensions.top - diff;
	      height = $container.height() - newDimensions.top;
	    }
	
	    if (editingLeft) {
	      newDimensions.left = oldDimensions.left - diff;
	      width = $container.width() - newDimensions.left;
	    }
	
	    if (newDimensions.top < 0) {
	      newDimensions.size = newDimensions.size + newDimensions.top;
	      if (editingLeft) {
	        newDimensions.left = newDimensions.left - newDimensions.top;
	      }
	      newDimensions.top = 0;
	    }
	
	    if (newDimensions.left < 0) {
	      newDimensions.size = newDimensions.size + newDimensions.left;
	      if (editingTop) {
	        newDimensions.top = newDimensions.top - newDimensions.left;
	      }
	      newDimensions.left = 0;
	    }
	
	    var maxSize = Math.min(width, height);
	    if (newDimensions.size > maxSize) {
	      if (editingTop) {
	        newDimensions.top = newDimensions.top + newDimensions.size - maxSize;
	      }
	      if (editingLeft) {
	        newDimensions.left = newDimensions.left + newDimensions.size - maxSize;
	      }
	      newDimensions.size = maxSize;
	    } else if (newDimensions.size < this.MIN_DIMENSION) {
	      if (editingTop) {
	        newDimensions.top = newDimensions.top + newDimensions.size - this.MIN_DIMENSION;
	      }
	      if (editingLeft) {
	        newDimensions.left = newDimensions.left + newDimensions.size - this.MIN_DIMENSION;
	      }
	      newDimensions.size = this.MIN_DIMENSION;
	    }
	    return Object.assign({}, oldDimensions, newDimensions);
	  },
	
	  handleError: function handleError(msg) {
	    _actionsAlertActions2['default'].addAlert({
	      message: (0, _locale.t)(msg),
	      type: 'error'
	    });
	  },
	
	  validateImage: function validateImage() {
	    var img = this.refs.image;
	    if (img.naturalWidth < this.MIN_DIMENSION || img.naturalHeight < this.MIN_DIMENSION) {
	      return 'Please upload an image larger than ' + (this.MIN_DIMENSION - 1) + 'px by ' + (this.MIN_DIMENSION - 1) + 'px.';
	    }
	    if (img.naturalWidth > this.MAX_DIMENSION || img.naturalHeight > this.MAX_DIMENSION) {
	      return 'Please upload an image smaller than ' + this.MAX_DIMENSION + 'px by ' + this.MAX_DIMENSION + 'px.';
	    }
	  },
	
	  onLoad: function onLoad(ev) {
	    var error = this.validateImage();
	    if (error) {
	      window.URL.revokeObjectURL(this.state.objectURL);
	      this.setState({ objectURL: null });
	      this.handleError(error);
	      return;
	    }
	    var $img = $(this.refs.image);
	    var dimension = Math.min($img.height(), $img.width());
	    this.setState({
	      resizeDimensions: Object.assign({ size: dimension, top: 0, left: 0 })
	    }, this.drawToCanvas);
	  },
	
	  drawToCanvas: function drawToCanvas() {
	    var canvas = this.refs.canvas;
	    var resizeDimensions = this.state.resizeDimensions;
	    var img = this.refs.image;
	    // Calculate difference between natural dimensions and rendered dimensions
	    var imgRatio = (img.naturalHeight / $(img).height() + img.naturalWidth / $(img).width()) / 2;
	    canvas.width = resizeDimensions.size * imgRatio;
	    canvas.height = resizeDimensions.size * imgRatio;
	    canvas.getContext('2d').drawImage(img, resizeDimensions.left * imgRatio, resizeDimensions.top * imgRatio, resizeDimensions.size * imgRatio, resizeDimensions.size * imgRatio, 0, 0, resizeDimensions.size * imgRatio, resizeDimensions.size * imgRatio);
	    this.finishCrop();
	  },
	
	  finishCrop: function finishCrop() {
	    var canvas = this.refs.canvas;
	    this.props.updateDataUrlState({ dataUrl: canvas.toDataURL() });
	  },
	
	  getImgSrc: function getImgSrc() {
	    var uuid = this.props.user.avatar.avatarUuid;
	    var photoUrl = uuid && '/avatar/' + uuid + '/';
	    return this.props.savedDataUrl || this.state.objectURL || photoUrl;
	  },
	
	  onImgDrag: function onImgDrag(ev) {
	    ev.preventDefault();
	  },
	
	  renderImageCrop: function renderImageCrop() {
	    var src = this.getImgSrc();
	    if (!src) {
	      return null;
	    }
	    var resizeDimensions = this.state.resizeDimensions;
	    var style = {
	      top: resizeDimensions.top,
	      left: resizeDimensions.left,
	      width: resizeDimensions.size,
	      height: resizeDimensions.size
	    };
	    return _react2['default'].createElement(
	      'div',
	      { className: 'image-cropper' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'crop-container', ref: 'cropContainer' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'image-container' },
	          _react2['default'].createElement('img', { className: 'preview', ref: 'image', src: src,
	            onLoad: this.onLoad, onDragStart: this.onImgDrag })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'cropper', style: style, onMouseDown: this.onMouseDown },
	          _react2['default'].createElement('div', { onMouseDown: this.startResize.bind(this, 'nw'), className: 'resizer nw' }),
	          _react2['default'].createElement('div', { onMouseDown: this.startResize.bind(this, 'ne'), className: 'resizer ne' }),
	          _react2['default'].createElement('div', { onMouseDown: this.startResize.bind(this, 'se'), className: 'resizer se' }),
	          _react2['default'].createElement('div', { onMouseDown: this.startResize.bind(this, 'sw'), className: 'resizer sw' })
	        )
	      )
	    );
	  },
	
	  uploadClick: function uploadClick(ev) {
	    ev.preventDefault();
	    this.refs.file.click();
	  },
	
	  renderCanvas: function renderCanvas() {
	    if (!this.getImgSrc()) {
	      return null;
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: 'canvas-container' },
	      _react2['default'].createElement('canvas', { ref: 'canvas' })
	    );
	  },
	
	  render: function render() {
	    var src = this.getImgSrc();
	    var style = {
	      position: 'absolute'
	    };
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      !src && _react2['default'].createElement(
	        'div',
	        { className: 'image-well well blankslate' },
	        _react2['default'].createElement(
	          'p',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { onClick: this.uploadClick },
	            _react2['default'].createElement(
	              'strong',
	              null,
	              'Upload a photo'
	            )
	          ),
	          ' to get started.'
	        )
	      ),
	      this.renderImageCrop(),
	      this.renderCanvas(),
	      _react2['default'].createElement(
	        'div',
	        { className: 'form-group' },
	        src && _react2['default'].createElement(
	          'a',
	          { onClick: this.uploadClick },
	          (0, _locale.t)('Change Photo')
	        ),
	        _react2['default'].createElement('input', { ref: 'file', type: 'file', accept: 'image/gif,image/jpeg,image/png', onChange: this.onChange, style: style })
	      )
	    );
	  }
	});
	
	exports['default'] = AvatarCropper;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__(2);
	
	var AvatarRadio = _react2['default'].createClass({
	  displayName: 'AvatarRadio',
	
	  propTypes: {
	    user: _react2['default'].PropTypes.object.isRequired,
	    updateUser: _react2['default'].PropTypes.func.isRequired
	  },
	
	  OPTIONS: {
	    upload: 'Upload a Photo',
	    gravatar: 'Use Gravatar',
	    letter_avatar: 'Use my initials'
	  },
	
	  onChange: function onChange(ev) {
	    var avatar = Object.assign({}, this.props.user.avatar, { avatarType: ev.target.value });
	    this.props.user.avatar = avatar;
	    this.props.updateUser(this.props.user);
	  },
	
	  render: function render() {
	    var radios = [];
	    for (var opt in this.OPTIONS) {
	      radios.push(_react2['default'].createElement(
	        'li',
	        { className: 'radio', key: opt },
	        _react2['default'].createElement(
	          'label',
	          null,
	          _react2['default'].createElement('input', { type: 'radio', name: 'avatar-type', value: opt, onChange: this.onChange,
	            checked: this.props.user.avatar.avatarType === opt }),
	          this.OPTIONS[opt]
	        )
	      ));
	    }
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'legend',
	        null,
	        (0, _locale.t)('Avatar Type')
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'radio-inputs' },
	        radios
	      )
	    );
	  }
	});
	
	exports['default'] = AvatarRadio;
	module.exports = exports['default'];

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsAlertActions = __webpack_require__(62);
	
	var _actionsAlertActions2 = _interopRequireDefault(_actionsAlertActions);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsAvatarCropper = __webpack_require__(543);
	
	var _componentsAvatarCropper2 = _interopRequireDefault(_componentsAvatarCropper);
	
	var _componentsAvatarRadio = __webpack_require__(544);
	
	var _componentsAvatarRadio2 = _interopRequireDefault(_componentsAvatarRadio);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _locale = __webpack_require__(2);
	
	var AvatarSettings = _react2['default'].createClass({
	  displayName: 'AvatarSettings',
	
	  propTypes: {
	    userId: _react2['default'].PropTypes.number
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      user: null,
	      savedDataUrl: null,
	      dataUrl: null,
	      hasError: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.api.request(this.getEndpoint(), {
	      method: 'GET',
	      success: this.updateUserState,
	      error: function error() {
	        _this.setState({ hasError: true });
	      }
	    });
	  },
	
	  getEndpoint: function getEndpoint() {
	    return '/users/me/avatar/';
	  },
	
	  updateUserState: function updateUserState(user) {
	    this.setState({ user: user });
	  },
	
	  updateDataUrlState: function updateDataUrlState(dataUrlState) {
	    this.setState(dataUrlState);
	  },
	
	  handleError: function handleError(msg) {
	    _actionsAlertActions2['default'].addAlert({
	      message: (0, _locale.t)(msg),
	      type: 'error'
	    });
	  },
	
	  handleSuccess: function handleSuccess(user) {
	    this.setState({ user: user });
	    _actionsAlertActions2['default'].addAlert({
	      message: (0, _locale.t)('Successfully saved avatar preferences'),
	      type: 'success',
	      expireAfrer: 3000
	    });
	  },
	
	  saveSettings: function saveSettings(ev) {
	    var _this2 = this;
	
	    ev.preventDefault();
	    var avatarPhoto = null;
	    if (this.state.dataUrl) {
	      avatarPhoto = this.state.dataUrl.split(',')[1];
	    }
	    this.api.request(this.getEndpoint(), {
	      method: 'PUT',
	      data: {
	        avatar_photo: avatarPhoto,
	        avatar_type: this.state.user.avatar.avatarType
	      },
	      success: function success(user) {
	        _this2.setState({ savedDataUrl: _this2.state.dataUrl });
	        _this2.handleSuccess(user);
	      },
	      error: this.handleError.bind(this, 'There was an error saving your preferences.')
	    });
	  },
	
	  render: function render() {
	    if (this.state.hasError) {
	      return _react2['default'].createElement(_componentsLoadingError2['default'], null);
	    }
	    if (!this.state.user) {
	      return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);
	    }
	
	    var gravatarMessage = _react2['default'].createElement(
	      'div',
	      { className: 'well' },
	      (0, _locale.t)('Gravatars are managed through '),
	      _react2['default'].createElement(
	        'a',
	        { href: 'http://gravatar.com', target: '_blank' },
	        'Gravatar.com'
	      )
	    );
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'form',
	        null,
	        _react2['default'].createElement(_componentsAvatarRadio2['default'], { user: this.state.user, updateUser: this.updateUserState }),
	        this.state.user.avatar.avatarType === 'gravatar' && gravatarMessage,
	        this.state.user.avatar.avatarType === 'upload' && _react2['default'].createElement(_componentsAvatarCropper2['default'], _extends({}, this.props, { user: this.state.user, savedDataUrl: this.state.savedDataUrl,
	          updateDataUrlState: this.updateDataUrlState })),
	        _react2['default'].createElement(
	          'fieldset',
	          { className: 'form-actions' },
	          _react2['default'].createElement(
	            'button',
	            { className: 'btn btn-primary', onClick: this.saveSettings },
	            (0, _locale.t)('Done')
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = AvatarSettings;
	module.exports = exports['default'];

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapLibModal = __webpack_require__(73);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _locale = __webpack_require__(2);
	
	var _sprintfJs = __webpack_require__(411);
	
	var CustomSnoozeModal = _react2['default'].createClass({
	  displayName: 'CustomSnoozeModal',
	
	  propTypes: {
	    onSelected: _react2['default'].PropTypes.func,
	    onCanceled: _react2['default'].PropTypes.func,
	    show: _react2['default'].PropTypes.bool
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      dateWarning: false
	    };
	  },
	
	  selectedSnoozeMinutes: function selectedSnoozeMinutes() {
	    var dateStr = this.refs.snoozeDateInput.value; // YYYY-MM-DD
	    var timeStr = this.refs.snoozeTimeInput.value; // HH:MM
	    if (dateStr && timeStr) {
	      var selectedDate = new Date(dateStr + 'T' + timeStr); // poor man's ISO datetime
	      if (!isNaN(selectedDate)) {
	        var now = new Date();
	        var millis = selectedDate.getTime() - now.getTime();
	        var minutes = parseInt(Math.ceil(millis / 1000.0 / 60.0), 10);
	        return minutes;
	      }
	    }
	    return 0;
	  },
	
	  snoozeClicked: function snoozeClicked() {
	    var minutes = this.selectedSnoozeMinutes();
	
	    this.setState({
	      dateWarning: minutes <= 0
	    });
	
	    if (minutes > 0) {
	      this.props.onSelected(minutes);
	    }
	  },
	
	  render: function render() {
	    // Give the user a sane starting point to select a date
	    // (prettier than the empty date/time inputs):
	    var defaultDate = new Date();
	    defaultDate.setDate(defaultDate.getDate() + 14);
	    defaultDate.setSeconds(0);
	    defaultDate.setMilliseconds(0);
	
	    var defaultDateVal = (0, _sprintfJs.sprintf)('%d-%02d-%02d', defaultDate.getUTCFullYear(), defaultDate.getUTCMonth() + 1, defaultDate.getUTCDate());
	
	    var defaultTimeVal = (0, _sprintfJs.sprintf)('%02d:00', defaultDate.getUTCHours());
	
	    return _react2['default'].createElement(
	      _reactBootstrapLibModal2['default'],
	      { show: this.props.show, animation: false, bsSize: 'sm' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'modal-header' },
	        _react2['default'].createElement(
	          'h4',
	          null,
	          (0, _locale.t)('Ignore until:')
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'modal-body' },
	        _react2['default'].createElement(
	          'form',
	          { className: 'form-horizontal' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'form-group' },
	            _react2['default'].createElement(
	              'label',
	              { htmlFor: 'snooze-until-date',
	                className: 'col-sm-4 control-label' },
	              (0, _locale.t)('Date:')
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-8' },
	              _react2['default'].createElement('input', { className: 'form-control',
	                type: 'date',
	                id: 'snooze-until-date',
	                defaultValue: defaultDateVal,
	                ref: 'snoozeDateInput',
	                style: { padding: '0 10px' }
	              })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'form-group m-b-1' },
	            _react2['default'].createElement(
	              'label',
	              { htmlFor: 'snooze-until-time',
	                className: 'col-sm-4 control-label' },
	              (0, _locale.t)('Time (UTC):')
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-8' },
	              _react2['default'].createElement('input', { className: 'form-control',
	                type: 'time',
	                id: 'snooze-until-time',
	                defaultValue: defaultTimeVal,
	                ref: 'snoozeTimeInput',
	                style: { padding: '0 10px' }
	              })
	            )
	          )
	        )
	      ),
	      this.state.dateWarning && _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-error', style: { 'margin-top': '5px' } },
	        (0, _locale.t)('Please enter a valid date in the future')
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'modal-footer' },
	        _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-default',
	            onClick: this.props.onCanceled },
	          (0, _locale.t)('Cancel')
	        ),
	        _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-primary',
	            onClick: this.snoozeClicked },
	          (0, _locale.t)('Ignore')
	        )
	      )
	    );
	  }
	
	});
	
	exports['default'] = CustomSnoozeModal;
	module.exports = exports['default'];

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _locale = __webpack_require__(2);
	
	var _utils = __webpack_require__(7);
	
	var generateClassName = function generateClassName(name) {
	  return name.split(/\d/)[0].toLowerCase().replace(/[^a-z0-9\-]+/g, '-').replace(/\-+$/, '');
	};
	
	var NoSummary = _react2['default'].createClass({
	  displayName: 'NoSummary',
	
	  propTypes: {
	    title: _react2['default'].PropTypes.string.isRequired
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'context-item' },
	      _react2['default'].createElement('span', { className: 'context-item-icon' }),
	      _react2['default'].createElement(
	        'h3',
	        null,
	        this.props.title
	      )
	    );
	  }
	});
	
	var GenericSummary = _react2['default'].createClass({
	  displayName: 'GenericSummary',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired,
	    unknownTitle: _react2['default'].PropTypes.string.isRequired
	  },
	
	  render: function render() {
	    var data = this.props.data;
	
	    if ((0, _utils.objectIsEmpty)(data) || !data.name) {
	      return _react2['default'].createElement(NoSummary, { title: this.props.unknownTitle });
	    }
	
	    var className = generateClassName(data.name);
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'context-item ' + className },
	      _react2['default'].createElement('span', { className: 'context-item-icon' }),
	      _react2['default'].createElement(
	        'h3',
	        null,
	        data.name
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'strong',
	          null,
	          (0, _locale.t)('Version:')
	        ),
	        ' ',
	        data.version || (0, _locale.t)('Unknown')
	      )
	    );
	  }
	});
	
	var UserSummary = _react2['default'].createClass({
	  displayName: 'UserSummary',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var user = this.props.data;
	
	    if ((0, _utils.objectIsEmpty)(user)) {
	      return _react2['default'].createElement(NoSummary, { title: (0, _locale.t)('Unknown User') });
	    }
	
	    var userTitle = user.email ? user.email : user.ip_address || user.id || user.username;
	
	    if (!userTitle) {
	      return _react2['default'].createElement(NoSummary, { title: (0, _locale.t)('Unknown User') });
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'context-item user' },
	      userTitle ? _react2['default'].createElement(_componentsAvatar2['default'], { user: user, size: 48, className: 'context-item-icon',
	        gravatar: false }) : _react2['default'].createElement('span', { className: 'context-item-icon' }),
	      _react2['default'].createElement(
	        'h3',
	        null,
	        userTitle
	      ),
	      user.id && user.id !== userTitle ? _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'strong',
	          null,
	          (0, _locale.t)('ID:')
	        ),
	        ' ',
	        user.id
	      ) : user.username && user.username !== userTitle && _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'strong',
	          null,
	          (0, _locale.t)('Username:')
	        ),
	        ' ',
	        user.username
	      )
	    );
	  }
	});
	
	var DeviceSummary = _react2['default'].createClass({
	  displayName: 'DeviceSummary',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var data = this.props.data;
	
	    if ((0, _utils.objectIsEmpty)(data) || !data.model) {
	      return _react2['default'].createElement(NoSummary, { title: (0, _locale.t)('Unknown Device') });
	    }
	
	    // TODO(dcramer): we need a better way to parse it
	    var className = generateClassName(data.model);
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'context-item ' + className },
	      _react2['default'].createElement('span', { className: 'context-item-icon' }),
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _utils.deviceNameMapper)(data.model)
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        data.arch || data.model_id || ''
	      )
	    );
	  }
	});
	
	var EventContextSummary = _react2['default'].createClass({
	  displayName: 'EventContextSummary',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired
	  },
	
	  render: function render() {
	    var evt = this.props.event;
	    var contexts = evt.contexts;
	
	    var children = [_react2['default'].createElement(UserSummary, { key: 'user', data: evt.user })];
	    switch (evt.platform) {
	      case 'cocoa':
	        children.push(_react2['default'].createElement(DeviceSummary, {
	          key: 'device',
	          data: contexts.device }));
	        children.push(_react2['default'].createElement(GenericSummary, {
	          key: 'os',
	          data: contexts.os,
	          unknownTitle: (0, _locale.t)('Unknown OS') }));
	        break;
	      case 'javascript':
	        children.push(_react2['default'].createElement(GenericSummary, {
	          key: 'browser',
	          data: contexts.browser,
	          unknownTitle: (0, _locale.t)('Unknown Browser') }));
	        children.push(contexts.os ? _react2['default'].createElement(GenericSummary, {
	          key: 'os',
	          data: contexts.os,
	          unknownTitle: (0, _locale.t)('Unknown OS') }) : _react2['default'].createElement(DeviceSummary, {
	          key: 'device',
	          data: contexts.device }));
	        break;
	      default:
	        children.push(_react2['default'].createElement(GenericSummary, {
	          key: 'runtime',
	          data: contexts.runtime,
	          unknownTitle: (0, _locale.t)('Unknown Runtime') }));
	        children.push(contexts.os ? _react2['default'].createElement(GenericSummary, {
	          key: 'os',
	          data: contexts.os,
	          unknownTitle: (0, _locale.t)('Unknown OS') }) : _react2['default'].createElement(DeviceSummary, {
	          key: 'device',
	          data: contexts.device }));
	        break;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'context-summary' },
	      children
	    );
	  }
	});
	
	exports['default'] = EventContextSummary;
	module.exports = exports['default'];

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _utils = __webpack_require__(7);
	
	var CONTEXT_TYPES = {
	  'default': __webpack_require__(549),
	  'device': __webpack_require__(550),
	  'os': __webpack_require__(551),
	  'runtime': __webpack_require__(552),
	  'user': __webpack_require__(553)
	};
	
	var ContextChunk = _react2['default'].createClass({
	  displayName: 'ContextChunk',
	
	  propTypes: {
	    event: _react2['default'].PropTypes.object.isRequired,
	    group: _react2['default'].PropTypes.object.isRequired,
	    type: _react2['default'].PropTypes.string.isRequired,
	    alias: _react2['default'].PropTypes.string.isRequired,
	    value: _react2['default'].PropTypes.object.isRequired
	  },
	
	  renderTitle: function renderTitle() {
	    var _props = this.props;
	    var value = _props.value;
	    var alias = _props.alias;
	    var type = _props.type;
	
	    var title = null;
	    if ((0, _utils.defined)(value.title)) {
	      title = value.title;
	    } else {
	      var Component = CONTEXT_TYPES[type] || CONTEXT_TYPES['default'];
	      if (Component.getTitle) {
	        title = Component.getTitle(value);
	      }
	      if (!(0, _utils.defined)(title)) {
	        title = (0, _utils.toTitleCase)(alias);
	      }
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      null,
	      title + ' ',
	      alias !== type ? _react2['default'].createElement(
	        'small',
	        null,
	        '(',
	        alias,
	        ')'
	      ) : null
	    );
	  },
	
	  render: function render() {
	    var group = this.props.group;
	    var evt = this.props.event;
	    var _props2 = this.props;
	    var type = _props2.type;
	    var alias = _props2.alias;
	    var value = _props2.value;
	
	    var Component = CONTEXT_TYPES[type] || CONTEXT_TYPES['default'];
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: group,
	        event: evt,
	        key: 'context-' + alias,
	        type: 'context-' + alias,
	        title: this.renderTitle() },
	      _react2['default'].createElement(Component, { alias: alias, data: value })
	    );
	  }
	});
	
	var ContextsInterface = _react2['default'].createClass({
	  displayName: 'ContextsInterface',
	
	  propTypes: {
	    event: _react2['default'].PropTypes.object.isRequired,
	    group: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var group = this.props.group;
	    var evt = this.props.event;
	    var children = [];
	    if (!(0, _utils.objectIsEmpty)(evt.user)) {
	      children.push(_react2['default'].createElement(ContextChunk, {
	        group: group,
	        event: evt,
	        type: 'user',
	        alias: 'user',
	        value: evt.user,
	        key: 'user' }));
	    }
	
	    var value = null;
	    for (var key in evt.contexts) {
	      value = evt.contexts[key];
	      children.push(_react2['default'].createElement(ContextChunk, {
	        group: group,
	        event: evt,
	        type: value.type,
	        alias: key,
	        value: value,
	        key: key }));
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      children
	    );
	  }
	});
	
	exports['default'] = ContextsInterface;
	module.exports = exports['default'];

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contextBlock = __webpack_require__(133);
	
	var _contextBlock2 = _interopRequireDefault(_contextBlock);
	
	var DefaultContextType = _react2['default'].createClass({
	  displayName: 'DefaultContextType',
	
	  propTypes: {
	    alias: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(_contextBlock2['default'], { data: this.props.data, alias: this.props.alias });
	  }
	});
	
	exports['default'] = DefaultContextType;
	module.exports = exports['default'];

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contextBlock = __webpack_require__(133);
	
	var _contextBlock2 = _interopRequireDefault(_contextBlock);
	
	var _utils = __webpack_require__(7);
	
	var DeviceContextType = _react2['default'].createClass({
	  displayName: 'DeviceContextType',
	
	  propTypes: {
	    alias: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var _props$data = this.props.data;
	    var name = _props$data.name;
	    var family = _props$data.family;
	    var model = _props$data.model;
	    var model_id = _props$data.model_id;
	    var arch = _props$data.arch;
	    var battery_level = _props$data.battery_level;
	    var orientation = _props$data.orientation;
	
	    var data = _objectWithoutProperties(_props$data, ['name', 'family', 'model', 'model_id', 'arch', 'battery_level', 'orientation']);
	
	    return _react2['default'].createElement(_contextBlock2['default'], {
	      data: data,
	      knownData: [['?Name', name], ['Family', family], ['Model', model + (model_id ? ' (' + model_id + ')' : '')], ['Architecture', arch], ['?Battery Level', (0, _utils.defined)(battery_level) ? battery_level + '%' : null], ['?Orientation', orientation]],
	      alias: this.props.alias });
	  }
	});
	
	DeviceContextType.getTitle = function (value) {
	  return 'Device';
	};
	
	exports['default'] = DeviceContextType;
	module.exports = exports['default'];

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contextBlock = __webpack_require__(133);
	
	var _contextBlock2 = _interopRequireDefault(_contextBlock);
	
	var _utils = __webpack_require__(7);
	
	var OsContextType = _react2['default'].createClass({
	  displayName: 'OsContextType',
	
	  propTypes: {
	    alias: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var _props$data = this.props.data;
	    var name = _props$data.name;
	    var version = _props$data.version;
	    var build = _props$data.build;
	    var kernel_version = _props$data.kernel_version;
	    var rooted = _props$data.rooted;
	
	    var data = _objectWithoutProperties(_props$data, ['name', 'version', 'build', 'kernel_version', 'rooted']);
	
	    return _react2['default'].createElement(_contextBlock2['default'], {
	      data: data,
	      knownData: [['?Name', name], ['Version', version + (build ? ' (' + build + ')' : '')], ['Kernel Version', kernel_version], ['?Rooted', (0, _utils.defined)(rooted) ? rooted ? 'yes' : 'no' : null]],
	      alias: this.props.alias });
	  }
	});
	
	OsContextType.getTitle = function (value) {
	  return 'Operating System';
	};
	
	exports['default'] = OsContextType;
	module.exports = exports['default'];

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contextBlock = __webpack_require__(133);
	
	var _contextBlock2 = _interopRequireDefault(_contextBlock);
	
	var RuntimeContextType = _react2['default'].createClass({
	  displayName: 'RuntimeContextType',
	
	  propTypes: {
	    alias: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var _props$data = this.props.data;
	    var name = _props$data.name;
	    var version = _props$data.version;
	    var build = _props$data.build;
	
	    var data = _objectWithoutProperties(_props$data, ['name', 'version', 'build']);
	
	    return _react2['default'].createElement(_contextBlock2['default'], {
	      data: data,
	      knownData: [['Name', name], ['Version', version + (build ? ' (' + build + ')' : '')]],
	      alias: this.props.alias });
	  }
	});
	
	RuntimeContextType.getTitle = function (value) {
	  return 'Runtime';
	};
	
	exports['default'] = RuntimeContextType;
	module.exports = exports['default'];

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint react/jsx-key:0*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _interfacesKeyValueList = __webpack_require__(81);
	
	var _interfacesKeyValueList2 = _interopRequireDefault(_interfacesKeyValueList);
	
	var UserContextType = _react2['default'].createClass({
	  displayName: 'UserContextType',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var user = this.props.data;
	    var builtins = [];
	    var children = [];
	
	    // Handle our native attributes special
	    user.id && builtins.push(['ID', _react2['default'].createElement(
	      'pre',
	      null,
	      user.id
	    )]);
	    user.email && builtins.push(['Email', _react2['default'].createElement(
	      'pre',
	      null,
	      user.email,
	      _react2['default'].createElement(
	        'a',
	        { href: 'mailto:' + user.email, className: 'external-icon' },
	        _react2['default'].createElement('em', { className: 'icon-envelope' })
	      )
	    )]);
	    user.username && builtins.push(['Username', _react2['default'].createElement(
	      'pre',
	      null,
	      user.username
	    )]);
	    user.ip_address && builtins.push(['IP Address', _react2['default'].createElement(
	      'pre',
	      null,
	      user.ip_address
	    )]);
	
	    // We also attach user supplied data as 'user.data'
	    _underscore2['default'].each(user.data, function (value, key) {
	      children.push([key, value]);
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'user-widget' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'pull-left' },
	        _react2['default'].createElement(_componentsAvatar2['default'], { user: user, size: 96, gravatar: false })
	      ),
	      _react2['default'].createElement(
	        'table',
	        { className: 'key-value table' },
	        builtins.map(function (_ref) {
	          var _ref2 = _slicedToArray(_ref, 2);
	
	          var key = _ref2[0];
	          var value = _ref2[1];
	
	          return _react2['default'].createElement(
	            'tr',
	            { key: key },
	            _react2['default'].createElement(
	              'td',
	              { className: 'key', key: '0' },
	              key
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'value', key: '1' },
	              value
	            )
	          );
	        })
	      ),
	      children && _react2['default'].createElement(_interfacesKeyValueList2['default'], { data: children, isContextData: true })
	    );
	  }
	});
	
	UserContextType.getTitle = function (value) {
	  return 'User';
	};
	
	exports['default'] = UserContextType;
	module.exports = exports['default'];

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _locale = __webpack_require__(2);
	
	var _contextData = __webpack_require__(173);
	
	var _contextData2 = _interopRequireDefault(_contextData);
	
	// TODO(hazat): Is this interface used somewhere? If not delete it?
	var DeviceInterface = _react2['default'].createClass({
	  displayName: 'DeviceInterface',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var group = _props.group;
	    var event = _props.event;
	
	    var data = event.device;
	    var extras = Object.keys(data.data || {}).map(function (key) {
	      var value = data.data[key];
	      return _react2['default'].createElement(
	        'tr',
	        { key: key },
	        _react2['default'].createElement(
	          'td',
	          { className: 'key' },
	          key
	        ),
	        _react2['default'].createElement(
	          'td',
	          { className: 'value' },
	          _react2['default'].createElement(_contextData2['default'], { data: value })
	        )
	      );
	    });
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: group,
	        event: event,
	        type: 'device',
	        title: (0, _locale.t)('Device'),
	        wrapTitle: true },
	      _react2['default'].createElement(
	        'table',
	        { className: 'table key-value' },
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          data.name && _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement(
	              'td',
	              { className: 'key' },
	              'Name'
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'value' },
	              _react2['default'].createElement(
	                'pre',
	                null,
	                data.name
	              )
	            )
	          ),
	          data.version && _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement(
	              'td',
	              { className: 'key' },
	              'Version'
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'value' },
	              _react2['default'].createElement(
	                'pre',
	                null,
	                data.version
	              )
	            )
	          ),
	          data.build && _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement(
	              'td',
	              { className: 'key' },
	              'Build'
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'value' },
	              _react2['default'].createElement(
	                'pre',
	                null,
	                data.build
	              )
	            )
	          ),
	          extras
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = DeviceInterface;
	module.exports = exports['default'];

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__(2);
	
	var EventErrorItem = _react2['default'].createClass({
	  displayName: 'EventErrorItem',
	
	  propTypes: {
	    error: _react2['default'].PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isOpen: false
	    };
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return this.state.isOpen !== nextState.isOpen;
	  },
	
	  toggle: function toggle() {
	    this.setState({ isOpen: !this.state.isOpen });
	  },
	
	  render: function render() {
	    var error = this.props.error;
	    var isOpen = this.state.isOpen;
	    return _react2['default'].createElement(
	      'li',
	      null,
	      error.message,
	      _react2['default'].createElement(
	        'small',
	        null,
	        ' ',
	        _react2['default'].createElement(
	          'a',
	          { style: { marginLeft: 10 }, onClick: this.toggle },
	          isOpen ? (0, _locale.t)('Collapse') : (0, _locale.t)('Expand')
	        )
	      ),
	      _react2['default'].createElement(
	        'pre',
	        { style: { display: isOpen ? 'block' : 'none' } },
	        JSON.stringify(error.data, null, 2)
	      )
	    );
	  }
	});
	
	exports['default'] = EventErrorItem;
	module.exports = exports['default'];

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _errorItem = __webpack_require__(555);
	
	var _errorItem2 = _interopRequireDefault(_errorItem);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _locale = __webpack_require__(2);
	
	var EventErrors = _react2['default'].createClass({
	  displayName: 'EventErrors',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isOpen: false
	    };
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    if (this.state.isOpen != nextState.isOpen) {
	      return true;
	    }
	    return this.props.event.id !== nextProps.event.id;
	  },
	
	  toggle: function toggle() {
	    this.setState({ isOpen: !this.state.isOpen });
	  },
	
	  render: function render() {
	    var errors = this.props.event.errors;
	    var numErrors = errors.length;
	    var isOpen = this.state.isOpen;
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: this.props.group,
	        event: this.props.event,
	        type: 'errors',
	        className: 'errors' },
	      _react2['default'].createElement('span', { className: 'icon icon-alert' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'a',
	          { className: 'pull-right', onClick: this.toggle },
	          isOpen ? (0, _locale.t)('Hide') : (0, _locale.t)('Show')
	        ),
	        (0, _locale.tn)('There was %d error encountered while processing this event', 'There were %d errors encountered while processing this event', numErrors)
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { style: { display: isOpen ? 'block' : 'none' } },
	        errors.map(function (error, errorIdx) {
	          return _react2['default'].createElement(_errorItem2['default'], { key: errorIdx, error: error });
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = EventErrors;
	module.exports = exports['default'];

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _utils = __webpack_require__(7);
	
	var _locale = __webpack_require__(2);
	
	var _pills = __webpack_require__(186);
	
	var _pills2 = _interopRequireDefault(_pills);
	
	var _pill = __webpack_require__(185);
	
	var _pill2 = _interopRequireDefault(_pill);
	
	var EventTags = _react2['default'].createClass({
	  displayName: 'EventTags',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired
	  },
	
	  render: function render() {
	    var tags = this.props.event.tags;
	    if (_underscore2['default'].isEmpty(tags)) return null;
	
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: this.props.group,
	        event: this.props.event,
	        title: (0, _locale.t)('Tags'),
	        type: 'tags',
	        className: 'p-b-1'
	      },
	      _react2['default'].createElement(
	        _pills2['default'],
	        { className: 'no-margin' },
	        tags.map(function (tag) {
	          return _react2['default'].createElement(
	            _pill2['default'],
	            { key: tag.key, name: tag.key },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: '/' + orgId + '/' + projectId + '/',
	                  query: { query: tag.key + ':"' + tag.value + '"' }
	                } },
	              (0, _utils.deviceNameMapper)(tag.value)
	            ),
	            (0, _utils.isUrl)(tag.value) && _react2['default'].createElement(
	              'a',
	              { href: tag.value, className: 'external-icon' },
	              _react2['default'].createElement('em', { className: 'icon-open' })
	            )
	          );
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = EventTags;
	module.exports = exports['default'];

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsStackedBarChart = __webpack_require__(106);
	
	var _componentsStackedBarChart2 = _interopRequireDefault(_componentsStackedBarChart);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _locale = __webpack_require__(2);
	
	var EventsPerHour = _react2['default'].createClass({
	  displayName: 'EventsPerHour',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    var until = Math.floor(new Date().getTime() / 1000);
	    var since = until - 3600 * 24;
	
	    return {
	      rawOrgData: {},
	      formattedData: null,
	      querySince: since,
	      queryUntil: until,
	      error: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.fetchData();
	  },
	
	  // Use this so there's a standard order for y values and bar classes
	  STAT_OPTS: ['received', 'rejected', 'blacklisted'],
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var statEndpoint = this.getEndpoint();
	
	    var query = {
	      since: this.state.querySince,
	      until: this.state.queryUntil,
	      resolution: '1h'
	    };
	
	    $.when.apply($, this.STAT_OPTS.map(function (stat) {
	      var deferred = $.Deferred();
	      _this.api.request(statEndpoint, {
	        query: Object.assign({ stat: stat }, query),
	        success: deferred.resolve.bind(deferred),
	        error: deferred.reject.bind(deferred)
	      });
	      return deferred;
	    })).done((function () {
	      var rawOrgData = {};
	      for (var i = 0; i < this.STAT_OPTS.length; i++) {
	        rawOrgData[this.STAT_OPTS[i]] = arguments[i][0];
	      }
	      this.setState({
	        rawOrgData: rawOrgData,
	        formattedData: this.formatData(rawOrgData)
	      });
	    }).bind(this)).fail((function () {
	      this.setState({ error: true });
	    }).bind(this));
	  },
	
	  getEndpoint: function getEndpoint() {
	    return '/organizations/' + this.props.params.orgId + '/stats/';
	  },
	
	  formatData: function formatData(rawData) {
	    // Do this grossness to make sure data is zero filled
	    var allXValues = {};
	    var valueLookup = {};
	    this.STAT_OPTS.forEach(function (stat) {
	      valueLookup[stat] = {};
	      rawData[stat] && rawData[stat].forEach(function (point) {
	        allXValues[point[0]] = null;
	        valueLookup[stat][point[0]] = point[1];
	      });
	    });
	    allXValues = Object.keys(allXValues);
	
	    var chartData = [];
	    allXValues.forEach(function (x) {
	      var point = { x: +x, y: [] };
	      // convert received --> accepted
	      var acceptedY = valueLookup.received[x] - valueLookup.rejected[x] - valueLookup.blacklisted[x];
	      point.y.push(acceptedY);
	      ['rejected', 'blacklisted'].forEach(function (stat) {
	        var yVal = valueLookup[stat][x] || 0;
	        point.y.push(yVal);
	      });
	      chartData.push(point);
	    });
	
	    chartData.sort(function (a, b) {
	      if (a.x < b.x) {
	        return -1;
	      }
	      if (a.x > b.x) {
	        return 1;
	      }
	      return 0;
	    });
	
	    return chartData;
	  },
	
	  render: function render() {
	    if (this.state.error) {
	      return _react2['default'].createElement(_componentsLoadingError2['default'], null);
	    }
	
	    if (!this.state.formattedData) {
	      return null;
	    }
	    var org = this.getOrganization();
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        _reactRouter.Link,
	        { className: 'btn-sidebar-header', to: '/organizations/' + org.slug + '/stats/' },
	        (0, _locale.t)('View Stats')
	      ),
	      _react2['default'].createElement(
	        'h6',
	        { className: 'nav-header' },
	        (0, _locale.t)('Events Per Hour')
	      ),
	      _react2['default'].createElement(_componentsStackedBarChart2['default'], { points: this.state.formattedData, className: 'sparkline dashboard-sparkline', barClasses: this.STAT_OPTS })
	    );
	  }
	});
	
	exports['default'] = EventsPerHour;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _utils = __webpack_require__(7);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _interfacesKeyValueList = __webpack_require__(81);
	
	var _interfacesKeyValueList2 = _interopRequireDefault(_interfacesKeyValueList);
	
	var _locale = __webpack_require__(2);
	
	var EventExtraData = _react2['default'].createClass({
	  displayName: 'EventExtraData',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return this.props.event.id !== nextProps.event.id;
	  },
	
	  render: function render() {
	    var extraDataArray = (0, _utils.objectToArray)(this.props.event.context);
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: this.props.group,
	        event: this.props.event,
	        type: 'extra',
	        title: (0, _locale.t)('Additional Data') },
	      _react2['default'].createElement(_interfacesKeyValueList2['default'], {
	        data: extraDataArray,
	        isContextData: true })
	    );
	  }
	});
	
	exports['default'] = EventExtraData;
	module.exports = exports['default'];

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _breadcrumbsBreadcrumb = __webpack_require__(561);
	
	var _breadcrumbsBreadcrumb2 = _interopRequireDefault(_breadcrumbsBreadcrumb);
	
	var _locale = __webpack_require__(2);
	
	function Collapsed(props) {
	  return _react2['default'].createElement(
	    'li',
	    { className: 'crumbs-collapsed' },
	    _react2['default'].createElement(
	      'span',
	      { className: 'icon-container' },
	      _react2['default'].createElement('span', { className: 'icon icon-ellipsis' })
	    ),
	    _react2['default'].createElement(
	      'a',
	      { onClick: props.onClick },
	      'Show ',
	      props.count,
	      ' collapsed crumbs'
	    )
	  );
	}
	
	function moduleToCategory(module) {
	  if (!module) {
	    return null;
	  }
	  var match = module.match(/^.*\/(.*?)(:\d+)/);
	  if (match) {
	    return match[1];
	  }
	  return module.split(/./)[0];
	}
	
	Collapsed.propTypes = {
	  onClick: _react2['default'].PropTypes.func.isRequired,
	  count: _react2['default'].PropTypes.number.isRequired
	};
	
	var BreadcrumbsInterface = _react2['default'].createClass({
	  displayName: 'BreadcrumbsInterface',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    type: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired,
	    isShare: _react2['default'].PropTypes.bool
	  },
	
	  contextTypes: {
	    organization: _proptypes2['default'].Organization,
	    project: _proptypes2['default'].Project
	  },
	
	  statics: {
	    MAX_CRUMBS_WHEN_COLLAPSED: 10
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      collapsed: true,
	      queryValue: ''
	    };
	  },
	
	  onCollapseToggle: function onCollapseToggle() {
	    this.setState({
	      collapsed: !this.state.collapsed
	    });
	  },
	
	  renderBreadcrumbs: function renderBreadcrumbs(crumbs) {
	    // reverse array to get consistent idx between collapsed/expanded state
	    // (indexes begin and increment from last breadcrumb)
	    return crumbs.reverse().map(function (item, idx) {
	      return _react2['default'].createElement(_breadcrumbsBreadcrumb2['default'], { key: idx, crumb: item });
	    }).reverse(); // un-reverse rendered result
	  },
	
	  renderNoMatch: function renderNoMatch() {
	    return _react2['default'].createElement(
	      'li',
	      { className: 'crumb-empty' },
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	        ' ',
	        (0, _locale.t)('Sorry, no breadcrumbs match your search query.')
	      )
	    );
	  },
	
	  getVirtualCrumb: function getVirtualCrumb() {
	    var evt = this.props.event;
	    var crumb = undefined;
	
	    var exception = evt.entries.find(function (entry) {
	      return entry.type === 'exception';
	    });
	    if (exception) {
	      var _exception$data$values$0 = exception.data.values[0];
	      var type = _exception$data$values$0.type;
	      var value = _exception$data$values$0.value;
	      var _module2 = _exception$data$values$0.module;
	
	      crumb = {
	        type: 'error',
	        level: 'error',
	        category: moduleToCategory(_module2 || null) || 'exception',
	        data: {
	          type: type,
	          value: value
	        }
	      };
	    } else if (evt.message) {
	      var levelTag = (evt.tags || []).find(function (tag) {
	        return tag.key === 'level';
	      });
	      var level = levelTag && levelTag.value;
	      crumb = {
	        type: 'message',
	        level: level,
	        category: 'message',
	        message: evt.message
	      };
	    }
	
	    if (crumb) {
	      Object.assign(crumb, {
	        timestamp: evt.dateCreated,
	        last: true
	      });
	    }
	
	    return crumb;
	  },
	
	  setQuery: function setQuery(evt) {
	    this.setState({
	      queryValue: evt.target.value
	    });
	  },
	
	  filterCrumbs: function filterCrumbs(crumbs, queryValue) {
	    return crumbs.filter(function (item) {
	      // return true if any of category, message, or level contain queryValue
	      return !!['category', 'message', 'level'].find(function (prop) {
	        var propValue = (item[prop] || '').toLowerCase();
	        return propValue.includes(queryValue);
	      });
	    });
	  },
	
	  clearSearch: function clearSearch() {
	    this.setState({
	      queryValue: '',
	      collapsed: true
	    });
	  },
	
	  getSearchField: function getSearchField() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'breadcrumb-filter' },
	      _react2['default'].createElement('input', { type: 'text', className: 'search-input form-control',
	        placeholder: (0, _locale.t)('Search breadcrumbs...'),
	        autoComplete: 'off',
	        value: this.state.queryValue,
	        onChange: this.setQuery
	      }),
	      _react2['default'].createElement('span', { className: 'icon-search' }),
	      this.state.queryValue && _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'a',
	          { className: 'search-clear-form', onClick: this.clearSearch },
	          _react2['default'].createElement('span', { className: 'icon-circle-cross' })
	        )
	      )
	    );
	  },
	
	  render: function render() {
	    var group = this.props.group;
	    var evt = this.props.event;
	    var data = this.props.data;
	
	    var title = _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h3',
	        null,
	        _react2['default'].createElement(
	          'strong',
	          null,
	          'Breadcrumbs'
	        )
	      ),
	      this.getSearchField()
	    );
	
	    var all = data.values;
	
	    // Add the error event as the final (virtual) breadcrumb
	    var virtualCrumb = this.getVirtualCrumb();
	    if (virtualCrumb) {
	      // make copy of values array / don't mutate props
	      all = all.slice(0).concat([virtualCrumb]);
	    }
	
	    // filter breadcrumbs on text input
	    var queryValue = this.state.queryValue;
	
	    var filtered = queryValue ? this.filterCrumbs(all, queryValue.toLowerCase()) : all;
	
	    // cap max number of breadcrumbs to show
	    var MAX = BreadcrumbsInterface.MAX_CRUMBS_WHEN_COLLAPSED;
	    var crumbs = filtered;
	    if (this.state.collapsed && filtered.length > MAX) {
	      crumbs = filtered.slice(-MAX);
	    }
	
	    var numCollapsed = filtered.length - crumbs.length;
	
	    var crumbContent = undefined;
	    if (crumbs.length) {
	      crumbContent = this.renderBreadcrumbs(crumbs);
	    } else if (all.length) {
	      crumbContent = this.renderNoMatch();
	    }
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        className: 'breadcrumb-box',
	        group: group,
	        event: evt,
	        type: this.props.type,
	        title: title,
	        wrapTitle: false },
	      _react2['default'].createElement(
	        'ul',
	        { className: 'crumbs' },
	        numCollapsed > 0 && _react2['default'].createElement(Collapsed, { onClick: this.onCollapseToggle, count: numCollapsed }),
	        crumbContent
	      )
	    );
	  }
	});
	
	exports['default'] = BreadcrumbsInterface;
	module.exports = exports['default'];

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _httpRenderer = __webpack_require__(565);
	
	var _httpRenderer2 = _interopRequireDefault(_httpRenderer);
	
	var _errorRenderer = __webpack_require__(564);
	
	var _errorRenderer2 = _interopRequireDefault(_errorRenderer);
	
	var _defaultRenderer = __webpack_require__(563);
	
	var _defaultRenderer2 = _interopRequireDefault(_defaultRenderer);
	
	var CUSTOM_RENDERERS = {
	  http: _httpRenderer2['default'],
	  error: _errorRenderer2['default']
	};
	
	var Breadcrumb = _react2['default'].createClass({
	  displayName: 'Breadcrumb',
	
	  propTypes: {
	    crumb: _react2['default'].PropTypes.object.isRequired
	  },
	
	  getClassName: function getClassName() {
	    var crumb = this.props.crumb;
	
	    // use Set to avoid duplicate crumb classes (was previously adding
	    // values like "crumb-default" as many as three times)
	    var classes = new Set(['crumb', 'crumb-default', 'crumb-' + crumb.level]);
	
	    if (crumb.type !== 'default') {
	      classes.add('crumb-' + crumb.type.replace(/[\s_]+/g, '-').toLowerCase());
	    }
	
	    // special case for 'ui.' category breadcrumbs
	    // TODO: find a better way to customize UI around non-schema data
	    if (crumb.category && crumb.category.slice(0, 3) === 'ui.') {
	      classes.add('crumb-user');
	    }
	
	    if (crumb.last) {
	      classes.add('crumb-last');
	    }
	    return [].concat(_toConsumableArray(classes)).join(' ');
	  },
	
	  renderType: function renderType() {
	    var crumb = this.props.crumb;
	
	    var Renderer = CUSTOM_RENDERERS[crumb.type] || _defaultRenderer2['default'];
	    return _react2['default'].createElement(Renderer, { crumb: crumb });
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'li',
	      { className: this.getClassName() },
	      _react2['default'].createElement(
	        'span',
	        { className: 'icon-container' },
	        _react2['default'].createElement('span', { className: 'icon' })
	      ),
	      _react2['default'].createElement(
	        'span',
	        { className: 'dt' },
	        (0, _moment2['default'])(this.props.crumb.timestamp).format('HH:mm:ss')
	      ),
	      this.renderType()
	    );
	  }
	});
	
	exports['default'] = Breadcrumb;
	module.exports = exports['default'];

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Category = _react2['default'].createClass({
	  displayName: 'Category',
	
	  propTypes: {
	    value: _react2['default'].PropTypes.string,
	    title: _react2['default'].PropTypes.string,
	    hideIfEmpty: _react2['default'].PropTypes.bool
	  },
	
	  render: function render() {
	    var value = this.props.value;
	    if (!value) {
	      value = 'generic';
	      if (this.props.hideIfEmpty) {
	        return null;
	      }
	    }
	    var title = this.props.title;
	    if (title) {
	      title = title.replace('%s', value);
	    } else {
	      title = value;
	    }
	    return _react2['default'].createElement(
	      'span',
	      { className: 'crumb-category', title: title },
	      title
	    );
	  }
	});
	
	exports['default'] = Category;
	module.exports = exports['default'];

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _crumbTable = __webpack_require__(175);
	
	var _crumbTable2 = _interopRequireDefault(_crumbTable);
	
	var _summaryLine = __webpack_require__(176);
	
	var _summaryLine2 = _interopRequireDefault(_summaryLine);
	
	var DefaultRenderer = _react2['default'].createClass({
	  displayName: 'DefaultRenderer',
	
	  propTypes: {
	    crumb: _react2['default'].PropTypes.object.isRequired,
	    kvData: _react2['default'].PropTypes.object
	  },
	
	  getTitle: function getTitle() {
	    var crumb = this.props.crumb;
	    if (crumb.type === 'default') {
	      return null;
	    }
	    return crumb.type.split(/[_-\s]+/g).map(function (word) {
	      return word.substr(0, 1).toUpperCase() + word.substr(1);
	    }).join(' ');
	  },
	
	  renderSummary: function renderSummary() {
	    var crumb = this.props.crumb;
	
	    return _react2['default'].createElement(
	      _summaryLine2['default'],
	      { crumb: crumb },
	      crumb.message && _react2['default'].createElement(
	        'pre',
	        null,
	        _react2['default'].createElement(
	          'code',
	          null,
	          crumb.message
	        )
	      )
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(_crumbTable2['default'], _extends({
	      title: this.getTitle(),
	      summary: this.renderSummary(),
	      kvData: this.props.crumb.data || {}
	    }, this.props));
	  }
	});
	
	exports['default'] = DefaultRenderer;
	module.exports = exports['default'];

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _crumbTable = __webpack_require__(175);
	
	var _crumbTable2 = _interopRequireDefault(_crumbTable);
	
	var _summaryLine = __webpack_require__(176);
	
	var _summaryLine2 = _interopRequireDefault(_summaryLine);
	
	var ErrorRenderer = _react2['default'].createClass({
	  displayName: 'ErrorRenderer',
	
	  propTypes: {
	    crumb: _react2['default'].PropTypes.object.isRequired
	  },
	
	  renderUrl: function renderUrl(url) {
	    return url.match(/^https?:\/\//) ? _react2['default'].createElement(
	      'a',
	      { href: url },
	      url
	    ) : _react2['default'].createElement(
	      'em',
	      null,
	      url
	    );
	  },
	
	  render: function render() {
	    var crumb = this.props.crumb;
	
	    var _ref = crumb.data || {};
	
	    var type = _ref.type;
	    var value = _ref.value;
	
	    var extra = _objectWithoutProperties(_ref, ['type', 'value']);
	
	    var messages = [];
	
	    if (value) {
	      messages.push(value);
	    }
	    if (crumb.message) {
	      messages.push(crumb.message);
	    }
	
	    var summary = _react2['default'].createElement(
	      _summaryLine2['default'],
	      { crumb: crumb },
	      _react2['default'].createElement(
	        'pre',
	        null,
	        _react2['default'].createElement(
	          'code',
	          null,
	          type && _react2['default'].createElement(
	            'strong',
	            null,
	            type,
	            ': '
	          ),
	          messages.join('. ')
	        )
	      )
	    );
	
	    return _react2['default'].createElement(_crumbTable2['default'], _extends({
	      title: 'Error',
	      summary: summary,
	      kvData: extra
	    }, this.props));
	  }
	});
	
	exports['default'] = ErrorRenderer;
	module.exports = exports['default'];

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _crumbTable = __webpack_require__(175);
	
	var _crumbTable2 = _interopRequireDefault(_crumbTable);
	
	var _summaryLine = __webpack_require__(176);
	
	var _summaryLine2 = _interopRequireDefault(_summaryLine);
	
	var HttpRenderer = _react2['default'].createClass({
	  displayName: 'HttpRenderer',
	
	  propTypes: {
	    crumb: _react2['default'].PropTypes.object.isRequired
	  },
	
	  renderUrl: function renderUrl(url) {
	    return url.match(/^https?:\/\//) ? _react2['default'].createElement(
	      'a',
	      { href: url },
	      url
	    ) : _react2['default'].createElement(
	      'em',
	      null,
	      url
	    );
	  },
	
	  render: function render() {
	    var crumb = this.props.crumb;
	
	    var _ref = crumb.data || {};
	
	    var method = _ref.method;
	    var status_code = _ref.status_code;
	    var reason = _ref.reason;
	    var url = _ref.url;
	
	    var extra = _objectWithoutProperties(_ref, ['method', 'status_code', 'reason', 'url']);
	
	    var summary = _react2['default'].createElement(
	      _summaryLine2['default'],
	      { crumb: crumb },
	      _react2['default'].createElement(
	        'pre',
	        null,
	        _react2['default'].createElement(
	          'code',
	          null,
	          method && _react2['default'].createElement(
	            'strong',
	            null,
	            method,
	            ' '
	          ),
	          url && this.renderUrl(url),
	          status_code !== undefined ? _react2['default'].createElement(
	            'span',
	            null,
	            ' [' + status_code + ']'
	          ) : ''
	        )
	      )
	    );
	
	    return _react2['default'].createElement(_crumbTable2['default'], _extends({
	      title: 'HTTP Request',
	      summary: summary,
	      kvData: extra
	    }, this.props));
	  }
	});
	
	exports['default'] = HttpRenderer;
	module.exports = exports['default'];

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(7);
	
	var ContextLine = function ContextLine(props) {
	  var line = props.line;
	  var isActive = props.isActive;
	
	  var liClassName = 'expandable';
	  if (isActive) {
	    liClassName += ' active';
	  }
	
	  var lineWs = '';
	  var lineCode = '';
	  if ((0, _utils.defined)(line[1]) && line[1].match) {
	    var _line$1$match = line[1].match(/^(\s*)(.*?)$/m);
	
	    var _line$1$match2 = _slicedToArray(_line$1$match, 3);
	
	    lineWs = _line$1$match2[1];
	    lineCode = _line$1$match2[2];
	  }
	
	  return _react2['default'].createElement(
	    'li',
	    { className: liClassName, key: line[0] },
	    _react2['default'].createElement(
	      'span',
	      { className: 'ws' },
	      lineWs
	    ),
	    _react2['default'].createElement(
	      'span',
	      { className: 'contextline' },
	      lineCode
	    )
	  );
	};
	
	ContextLine.propTypes = {
	  line: _react2['default'].PropTypes.array.isRequired,
	  isActive: _react2['default'].PropTypes.bool
	};
	
	exports['default'] = ContextLine;
	module.exports = exports['default'];

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _cspContent = __webpack_require__(568);
	
	var _cspContent2 = _interopRequireDefault(_cspContent);
	
	var _cspHelp = __webpack_require__(569);
	
	var _cspHelp2 = _interopRequireDefault(_cspHelp);
	
	var _locale = __webpack_require__(2);
	
	function getView(view, data) {
	  switch (view) {
	    case 'report':
	      return _react2['default'].createElement(_cspContent2['default'], { data: data });
	    case 'raw':
	      return _react2['default'].createElement(
	        'pre',
	        null,
	        JSON.stringify({ 'csp-report': data }, null, 2)
	      );
	    case 'help':
	      return _react2['default'].createElement(_cspHelp2['default'], { data: data });
	    default:
	      throw new TypeError('Invalid view: ' + view);
	  }
	}
	
	var CSPInterface = _react2['default'].createClass({
	  displayName: 'CSPInterface',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    type: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var data = this.props.data;
	
	    // hide the report-uri since this is redundant and silly
	    data.original_policy = data.original_policy.replace(/(;\s+)?report-uri [^;]+/, '');
	
	    return {
	      view: 'report',
	      data: data
	    };
	  },
	
	  toggleView: function toggleView(value) {
	    this.setState({
	      view: value
	    });
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var view = _state.view;
	    var data = _state.data;
	    var _props = this.props;
	    var group = _props.group;
	    var event = _props.event;
	
	    var title = _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'btn-group' },
	        _react2['default'].createElement(
	          'a',
	          { className: (view === 'report' ? 'active' : '') + ' btn btn-default btn-sm', onClick: this.toggleView.bind(this, 'report') },
	          (0, _locale.t)('Report')
	        ),
	        _react2['default'].createElement(
	          'a',
	          { className: (view === 'raw' ? 'active' : '') + ' btn btn-default btn-sm', onClick: this.toggleView.bind(this, 'raw') },
	          (0, _locale.t)('Raw')
	        ),
	        _react2['default'].createElement(
	          'a',
	          { className: (view === 'help' ? 'active' : '') + ' btn btn-default btn-sm', onClick: this.toggleView.bind(this, 'help') },
	          (0, _locale.t)('Help')
	        )
	      ),
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('CSP Report')
	      )
	    );
	
	    var children = getView(view, data);
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: group,
	        event: event,
	        type: 'csp',
	        title: title,
	        wrapTitle: false },
	      children
	    );
	  }
	});
	
	exports['default'] = CSPInterface;
	module.exports = exports['default'];

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(7);
	
	var _keyValueList = __webpack_require__(81);
	
	var _keyValueList2 = _interopRequireDefault(_keyValueList);
	
	var CSPContent = _react2['default'].createClass({
	  displayName: 'CSPContent',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var data = this.props.data;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h4',
	        null,
	        _react2['default'].createElement(
	          'span',
	          null,
	          data.effective_directive
	        )
	      ),
	      _react2['default'].createElement(_keyValueList2['default'], { data: (0, _utils.objectToArray)(data), isContextData: true })
	    );
	  }
	});
	
	exports['default'] = CSPContent;
	module.exports = exports['default'];

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__(2);
	
	/*eslint getsentry/jsx-needs-il8n:0*/
	// TODO: Not sure what we're going to do here re: translations. - Ben
	
	var help = {
	  'base-uri': (0, _locale.t)('\nThe <code>base-uri</code> directive defines the URIs that a user agent\nmay use as the document base URL. If this value is absent, then any URI\nis allowed. If this directive is absent, the user agent will use the\nvalue in the <code>base</code> element.'),
	  'child-src': (0, _locale.t)('\nThe <code>child-src</code> directive defines the valid sources for web\nworkers and nested browsing contexts loaded using elements such as\n<frame> and <iframe>. This directive is preferred over the\n<code>frame-src</code> directive, which is deprecated. For workers,\nnon-compliant requests are treated as fatal network errors by the user agent.'),
	  'connect-src': (0, _locale.t)('\nThe <code>connect-src</code> directive defines valid sources for fetch,\n<code>XMLHttpRequest</code>, <code>WebSocket</code>, and\n<code>EventSource</code> connections.'),
	  'font-src': (0, _locale.t)('\nThe <code>font-src</code> directive specifies valid sources for fonts\nloaded using <code>@font-face</code>.'),
	  'form-action': (0, _locale.t)('\nThe <code>form-action</code> directive specifies valid endpoints for\n<code>&lt;form&gt;</code> submissions.'),
	  'frame-ancestors': (0, _locale.t)('\nThe <code>frame-ancestors</code> directive specifies valid parents that\nmay embed a page using the <code>&lt;frame&gt;</code> and\n<code>&lt;iframe&gt;</code> elements.'),
	  'img-src': (0, _locale.t)('\nThe <code>img-src</code> directive specifies valid sources of images and\nfavicons.'),
	  'manifest-src': (0, _locale.t)('\nThe <code>manifest-src</code> directive specifies which manifest can be\napplied to the resource.'),
	  'media-src': (0, _locale.t)('\nThe <code>media-src</code> directive specifies valid sources for loading\nmedia using the <code>&lt;audio&gt;</code> and <code>&lt;video&gt;</code>\nelements.'),
	  'object-src': (0, _locale.t)('\nThe <code>object-src</code> directive specifies valid sources for the\n<code>&lt;object&gt;</code>, <code>&lt;embed&gt;</code>, and\n<code>&lt;applet&gt;</code> elements.'),
	  'plugin-types': (0, _locale.t)('\nThe <code>plugin-types</code> directive specifies the valid plugins that\nthe user agent may invoke.'),
	  'referrer': (0, _locale.t)('\nThe <code>referrer</code> directive specifies information in the\n<code>Referer</code> header for links away from a page.'),
	  'script-src': (0, _locale.t)('\nThe <code>script-src</code> directive specifies valid sources\nfor JavaScript. When either the <code>script-src</code> or the\n<code>default-src</code> directive is included, inline script and\n<code>eval()</code> are disabled unless you specify \'unsafe-inline\'\nand \'unsafe-eval\', respectively.'),
	  'style-src': (0, _locale.t)('\nThe <code>style-src</code> directive specifies valid sources for\nstylesheets. This includes both externally-loaded stylesheets and inline\nuse of the <code>&lt;style&gt;</code> element and HTML style attributes.\nStylesheets from sources that aren\'t included in the source list are not\nrequested or loaded. When either the <code>style-src</code> or the\n<code>default-src</code> directive is included, inline use of the\n<code>&lt;style&gt;</code> element and HTML style attributes are disabled\nunless you specify \'unsafe-inline\'.')
	};
	
	var linkOverrides = {
	  'script-src': 'script-src_2'
	};
	
	function getHelp(key) {
	  return {
	    __html: help[key]
	  };
	}
	
	function getLinkHref(key) {
	  var link = key;
	  if (key in linkOverrides) {
	    link = linkOverrides[key];
	  }
	  return 'https://developer.mozilla.org/en-US/docs/Web/Security/CSP/CSP_policy_directives#' + link;
	}
	
	function getLink(key) {
	  var href = getLinkHref(key);
	
	  return _react2['default'].createElement(
	    'span',
	    null,
	    _react2['default'].createElement(
	      'a',
	      { href: href },
	      'developer.mozilla.org'
	    ),
	    _react2['default'].createElement(
	      'a',
	      { href: href, className: 'external-icon' },
	      _react2['default'].createElement('em', { className: 'icon-open' })
	    )
	  );
	}
	
	var CSPHelp = _react2['default'].createClass({
	  displayName: 'CSPHelp',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var data = this.props.data;
	
	    var key = data.effective_directive;
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h4',
	        null,
	        _react2['default'].createElement(
	          'code',
	          null,
	          key
	        )
	      ),
	      _react2['default'].createElement('blockquote', { dangerouslySetInnerHTML: getHelp(key) }),
	      _react2['default'].createElement(
	        'p',
	        { style: { textAlign: 'right' } },
	        '— MDN (',
	        getLink(key),
	        ')'
	      )
	    );
	  }
	});
	
	exports['default'] = CSPHelp;
	module.exports = exports['default'];

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _stacktrace = __webpack_require__(179);
	
	var _crashHeader = __webpack_require__(178);
	
	var _crashHeader2 = _interopRequireDefault(_crashHeader);
	
	var _crashContent = __webpack_require__(177);
	
	var _crashContent2 = _interopRequireDefault(_crashContent);
	
	var ExceptionInterface = _react2['default'].createClass({
	  displayName: 'ExceptionInterface',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    type: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      stackView: this.props.data.hasSystemFrames ? 'app' : 'full',
	      newestFirst: (0, _stacktrace.isStacktraceNewestFirst)(),
	      stackType: 'original'
	    };
	  },
	
	  eventHasThreads: function eventHasThreads() {
	    return !!this.props.event.entries.find(function (x) {
	      return x.type === 'threads';
	    });
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var group = this.props.group;
	    var event = this.props.event;
	    var data = this.props.data;
	    var stackView = this.state.stackView;
	    var stackType = this.state.stackType;
	    var newestFirst = this.state.newestFirst;
	
	    // in case there are threads in the event data, we don't render the
	    // exception block.  Instead the exception is contained within the
	    // thread interface.
	    if (this.eventHasThreads()) {
	      return null;
	    }
	
	    var title = _react2['default'].createElement(_crashHeader2['default'], {
	      group: group,
	      platform: event.platform,
	      exception: data,
	      stackView: stackView,
	      newestFirst: newestFirst,
	      stackType: stackType,
	      onChange: function (newState) {
	        _this.setState(newState);
	      }
	    });
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: group,
	        event: event,
	        type: this.props.type,
	        title: title,
	        wrapTitle: false },
	      _react2['default'].createElement(_crashContent2['default'], {
	        group: group,
	        event: event,
	        stackType: stackType,
	        stackView: stackView,
	        newestFirst: newestFirst,
	        exception: data })
	    );
	  }
	});
	
	exports['default'] = ExceptionInterface;
	module.exports = exports['default'];

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(7);
	
	var _stacktraceContent = __webpack_require__(274);
	
	var _stacktraceContent2 = _interopRequireDefault(_stacktraceContent);
	
	var _exceptionMechanism = __webpack_require__(572);
	
	var _exceptionMechanism2 = _interopRequireDefault(_exceptionMechanism);
	
	var ExceptionContent = _react2['default'].createClass({
	  displayName: 'ExceptionContent',
	
	  propTypes: {
	    type: _react2['default'].PropTypes.oneOf(['original', 'minified']),
	    values: _react2['default'].PropTypes.array.isRequired,
	    view: _react2['default'].PropTypes.string.isRequired,
	    platform: _react2['default'].PropTypes.string,
	    newestFirst: _react2['default'].PropTypes.bool
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var stackView = this.props.view;
	    var newestFirst = this.props.newestFirst;
	    var children = this.props.values.map(function (exc, excIdx) {
	      return _react2['default'].createElement(
	        'div',
	        { key: excIdx, className: 'exception' },
	        _react2['default'].createElement(
	          'h5',
	          { className: 'break-word', style: { marginBottom: 5 } },
	          _react2['default'].createElement(
	            'span',
	            null,
	            exc.type
	          )
	        ),
	        exc.value && _react2['default'].createElement(
	          'pre',
	          { className: 'exc-message', style: { marginTop: 0 } },
	          exc.value
	        ),
	        exc.mechanism && _react2['default'].createElement(_exceptionMechanism2['default'], {
	          data: exc.mechanism,
	          platform: _this.props.platform }),
	        (0, _utils.defined)(exc.stacktrace) && _react2['default'].createElement(_stacktraceContent2['default'], {
	          data: _this.props.type === 'original' ? exc.stacktrace : exc.rawStacktrace || exc.stacktrace,
	          expandFirstFrame: excIdx === 0,
	          includeSystemFrames: stackView === 'full',
	          platform: _this.props.platform,
	          newestFirst: newestFirst })
	      );
	    });
	    if (newestFirst) {
	      children.reverse();
	    }
	
	    // TODO(dcramer): implement exceptions omitted
	    return _react2['default'].createElement(
	      'div',
	      null,
	      children
	    );
	  }
	});
	
	exports['default'] = ExceptionContent;
	module.exports = exports['default'];

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pills = __webpack_require__(186);
	
	var _pills2 = _interopRequireDefault(_pills);
	
	var _pill = __webpack_require__(185);
	
	var _pill2 = _interopRequireDefault(_pill);
	
	var ExceptionMechanism = _react2['default'].createClass({
	  displayName: 'ExceptionMechanism',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired,
	    platform: _react2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var pills = [];
	
	    if (this.props.data.mach_exception) {
	      var mach_exception = this.props.data.mach_exception;
	
	      if (mach_exception.exception_name) {
	        pills.push(_react2['default'].createElement(_pill2['default'], {
	          key: 'mach-exception',
	          name: 'mach exception',
	          value: mach_exception.exception_name
	        }));
	      }
	      if (mach_exception.code_name) {
	        pills.push(_react2['default'].createElement(_pill2['default'], {
	          key: 'mach-code',
	          name: 'mach code',
	          value: mach_exception.code_name
	        }));
	      }
	    }
	    if (this.props.data.posix_signal) {
	      var posix_signal = this.props.data.posix_signal;
	
	      pills.push(_react2['default'].createElement(
	        _pill2['default'],
	        {
	          key: 'signal',
	          name: 'signal'
	        },
	        posix_signal.name,
	        ' ',
	        _react2['default'].createElement(
	          'em',
	          null,
	          '(',
	          posix_signal.signal,
	          ')'
	        )
	      ));
	    }
	
	    if (pills.length === 0) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'exception-mechanism' },
	      _react2['default'].createElement(
	        _pills2['default'],
	        null,
	        pills
	      )
	    );
	  }
	});
	
	exports['default'] = ExceptionMechanism;
	module.exports = exports['default'];

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(7);
	
	var _keyValueList = __webpack_require__(81);
	
	var _keyValueList2 = _interopRequireDefault(_keyValueList);
	
	var FrameVariables = _react2['default'].createClass({
	  displayName: 'FrameVariables',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  // make sure that clicking on the variables does not actually do
	  // anything on the containing element.
	  preventToggling: function preventToggling(evt) {
	    evt.stopPropagation();
	  },
	
	  render: function render() {
	    var data = (0, _utils.objectToArray)(this.props.data);
	
	    return _react2['default'].createElement(_keyValueList2['default'], { data: data, isContextData: true, onClick: this.preventToggling });
	  }
	});
	
	exports['default'] = FrameVariables;
	module.exports = exports['default'];

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _locale = __webpack_require__(2);
	
	var MessageInterface = _react2['default'].createClass({
	  displayName: 'MessageInterface',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    type: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var data = this.props.data;
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: this.props.group,
	        event: this.props.event,
	        type: 'message',
	        title: (0, _locale.t)('Message') },
	      _react2['default'].createElement('pre', { className: 'plain', dangerouslySetInnerHTML: {
	          __html: _utils2['default'].nl2br(_utils2['default'].urlize(_utils2['default'].escape(data.formatted || data.message)))
	        } }),
	      data.params && !data.formatted && _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h5',
	          null,
	          (0, _locale.t)('Params')
	        ),
	        _react2['default'].createElement(
	          'pre',
	          { className: 'plain' },
	          JSON.stringify(data.params, null, 2)
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = MessageInterface;
	module.exports = exports['default'];

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rawStacktraceContent = __webpack_require__(273);
	
	var _rawStacktraceContent2 = _interopRequireDefault(_rawStacktraceContent);
	
	var RawExceptionContent = _react2['default'].createClass({
	  displayName: 'RawExceptionContent',
	
	  propTypes: {
	    type: _react2['default'].PropTypes.oneOf(['original', 'minified']),
	    platform: _react2['default'].PropTypes.string,
	    values: _react2['default'].PropTypes.array.isRequired
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var type = this.props.type;
	
	    var children = this.props.values.map(function (exc, excIdx) {
	      return _react2['default'].createElement(
	        'pre',
	        { key: excIdx, className: 'traceback plain' },
	        exc.stacktrace && (0, _rawStacktraceContent2['default'])(type === 'original' ? exc.stacktrace : exc.rawStacktrace, _this.props.platform, exc)
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      children
	    );
	  }
	});
	
	exports['default'] = RawExceptionContent;
	module.exports = exports['default'];

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _richHttpContent = __webpack_require__(577);
	
	var _richHttpContent2 = _interopRequireDefault(_richHttpContent);
	
	var _utils = __webpack_require__(580);
	
	var _utils2 = __webpack_require__(7);
	
	var _locale = __webpack_require__(2);
	
	var _componentsTruncate = __webpack_require__(298);
	
	var _componentsTruncate2 = _interopRequireDefault(_componentsTruncate);
	
	var RequestInterface = _react2['default'].createClass({
	  displayName: 'RequestInterface',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    type: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired,
	    isShare: _react2['default'].PropTypes.bool
	  },
	
	  contextTypes: {
	    organization: _proptypes2['default'].Organization,
	    project: _proptypes2['default'].Project
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      view: 'rich'
	    };
	  },
	
	  isPartial: function isPartial() {
	    // We assume we only have a partial interface is we're missing
	    // an HTTP method. This means we don't have enough information
	    // to reliably construct a full HTTP request.
	    return !this.props.data.method;
	  },
	
	  toggleView: function toggleView(value) {
	    this.setState({
	      view: value
	    });
	  },
	
	  render: function render() {
	    var group = this.props.group;
	    var evt = this.props.event;
	    var data = this.props.data;
	    var view = this.state.view;
	
	    var fullUrl = data.url;
	    if (data.query) {
	      fullUrl = fullUrl + '?' + data.query;
	    }
	    if (data.fragment) {
	      fullUrl = fullUrl + '#' + data.fragment;
	    }
	
	    // lol
	    var parsedUrl = document.createElement('a');
	    parsedUrl.href = fullUrl;
	
	    var children = [];
	
	    // Check if the url passed in is a safe url to avoid XSS
	    var isValidUrl = (0, _utils2.isUrl)(fullUrl);
	
	    if (!this.isPartial() && isValidUrl) {
	      children.push(_react2['default'].createElement(
	        'div',
	        { key: 'view-buttons', className: 'btn-group' },
	        _react2['default'].createElement(
	          'a',
	          { className: (view === 'rich' ? 'active' : '') + ' btn btn-default btn-sm',
	            onClick: this.toggleView.bind(this, 'rich') },
	
	          /* Translators: this means "rich" rendering (fancy tables) */
	          (0, _locale.t)('Rich')
	        ),
	        _react2['default'].createElement(
	          'a',
	          { className: (view === 'curl' ? 'active' : '') + ' btn btn-default btn-sm',
	            onClick: this.toggleView.bind(this, 'curl') },
	          _react2['default'].createElement(
	            'code',
	            null,
	            'curl'
	          )
	        )
	      ));
	    }
	
	    children.push(_react2['default'].createElement(
	      'h3',
	      { key: 'title' },
	      _react2['default'].createElement(
	        'a',
	        { href: isValidUrl ? fullUrl : null, title: fullUrl },
	        _react2['default'].createElement(
	          'span',
	          { className: 'path' },
	          _react2['default'].createElement(
	            'strong',
	            null,
	            data.method || 'GET'
	          ),
	          _react2['default'].createElement(_componentsTruncate2['default'], { value: parsedUrl.pathname, maxLength: 36, leftTrim: true })
	        ),
	        isValidUrl && _react2['default'].createElement(
	          'span',
	          { className: 'external-icon' },
	          _react2['default'].createElement('em', { className: 'icon-open' })
	        )
	      ),
	      _react2['default'].createElement(
	        'small',
	        { style: { marginLeft: 10 }, className: 'host' },
	        parsedUrl.hostname
	      )
	    ));
	
	    var title = _react2['default'].createElement(
	      'div',
	      null,
	      children
	    );
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: group,
	        event: evt,
	        type: this.props.type,
	        title: title,
	        wrapTitle: false,
	        className: 'request' },
	      view === 'curl' ? _react2['default'].createElement(
	        'pre',
	        null,
	        (0, _utils.getCurlCommand)(data)
	      ) : _react2['default'].createElement(_richHttpContent2['default'], { data: data })
	    );
	  }
	});
	
	exports['default'] = RequestInterface;
	module.exports = exports['default'];

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clippedBox = __webpack_require__(172);
	
	var _clippedBox2 = _interopRequireDefault(_clippedBox);
	
	var _keyValueList = __webpack_require__(81);
	
	var _keyValueList2 = _interopRequireDefault(_keyValueList);
	
	var _contextData = __webpack_require__(173);
	
	var _contextData2 = _interopRequireDefault(_contextData);
	
	var _utils = __webpack_require__(7);
	
	var _queryString = __webpack_require__(731);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _locale = __webpack_require__(2);
	
	var RichHttpContent = _react2['default'].createClass({
	  displayName: 'RichHttpContent',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  /**
	   * Converts an object of body/querystring key/value pairs
	   * into a tuple of [key, value] pairs, and sorts them.
	   *
	   * Note that the query-string parser returns dupes like this:
	   *   { foo: ['bar', 'baz'] } // ?foo=bar&bar=baz
	   *
	   * This method accounts for this.
	   */
	  objectToSortedTupleArray: function objectToSortedTupleArray(obj) {
	    return Object.keys(obj).reduce(function (out, k) {
	      var val = obj[k];
	      return out.concat(({}).toString.call(val) === '[object Array]' ? val.map(function (v) {
	        return [k, v];
	      }) : // key has multiple values (array)
	      [[k, val]] // key has single value
	      );
	    }, []).sort(function (_ref, _ref3) {
	      var _ref2 = _slicedToArray(_ref, 1);
	
	      var keyA = _ref2[0];
	
	      var _ref32 = _slicedToArray(_ref3, 1);
	
	      var keyB = _ref32[0];
	
	      return keyA < keyB ? -1 : 1;
	    });
	  },
	
	  getBodySection: function getBodySection(data) {
	    /*eslint no-empty:0*/
	    var contentType = data.headers.find(function (h) {
	      return h[0] === 'Content-Type';
	    });
	    contentType = contentType && contentType[1].split(';')[0].toLowerCase();
	
	    // Ignoring Content-Type, we immediately just check if the body is parseable
	    // as JSON. Why? Because many applications don't set proper Content-Type values,
	    // e.g. x-www-form-urlencoded  actually contains JSON.
	    try {
	      return _react2['default'].createElement(_contextData2['default'], { data: JSON.parse(data.data) });
	    } catch (e) {}
	
	    if (contentType === 'application/x-www-form-urlencoded') {
	      return this.getQueryStringOrRaw(data.data);
	    } else {
	      return _react2['default'].createElement(
	        'pre',
	        null,
	        data.data
	      );
	    }
	  },
	
	  getQueryStringOrRaw: function getQueryStringOrRaw(data) {
	    try {
	      // Sentry API abbreviates long query string values, sometimes resulting in
	      // an un-parsable querystring ... stay safe kids
	      return _react2['default'].createElement(_keyValueList2['default'], { data: this.objectToSortedTupleArray(_queryString2['default'].parse(data)) });
	    } catch (e) {
	      return _react2['default'].createElement(
	        'pre',
	        null,
	        data
	      );
	    }
	  },
	
	  render: function render() {
	    var data = this.props.data;
	    return _react2['default'].createElement(
	      'div',
	      null,
	      data.query && _react2['default'].createElement(
	        _clippedBox2['default'],
	        { title: (0, _locale.t)('Query String') },
	        this.getQueryStringOrRaw(data.query)
	      ),
	      data.fragment && _react2['default'].createElement(
	        _clippedBox2['default'],
	        { title: (0, _locale.t)('Fragment') },
	        _react2['default'].createElement(
	          'pre',
	          null,
	          data.fragment
	        )
	      ),
	      data.data && _react2['default'].createElement(
	        _clippedBox2['default'],
	        { title: (0, _locale.t)('Body') },
	        this.getBodySection(data)
	      ),
	      data.cookies && !(0, _utils.objectIsEmpty)(data.cookies) && _react2['default'].createElement(
	        _clippedBox2['default'],
	        { title: (0, _locale.t)('Cookies'), defaultCollapsed: true },
	        _react2['default'].createElement(_keyValueList2['default'], { data: data.cookies })
	      ),
	      !(0, _utils.objectIsEmpty)(data.headers) && _react2['default'].createElement(
	        _clippedBox2['default'],
	        { title: (0, _locale.t)('Headers') },
	        _react2['default'].createElement(_keyValueList2['default'], { data: data.headers })
	      ),
	      !(0, _utils.objectIsEmpty)(data.env) && _react2['default'].createElement(
	        _clippedBox2['default'],
	        { title: (0, _locale.t)('Environment'), defaultCollapsed: true },
	        _react2['default'].createElement(_keyValueList2['default'], { data: this.objectToSortedTupleArray(data.env) })
	      )
	    );
	  }
	});
	
	exports['default'] = RichHttpContent;
	module.exports = exports['default'];

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _frame = __webpack_require__(134);
	
	var _frame2 = _interopRequireDefault(_frame);
	
	var _locale = __webpack_require__(2);
	
	var TemplateInterface = _react2['default'].createClass({
	  displayName: 'TemplateInterface',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    type: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: this.props.group,
	        event: this.props.event,
	        type: this.props.type,
	        title: _react2['default'].createElement(
	          'div',
	          null,
	          (0, _locale.t)('Template')
	        ) },
	      _react2['default'].createElement(
	        'div',
	        { className: 'traceback no-exception' },
	        _react2['default'].createElement(
	          'ul',
	          null,
	          _react2['default'].createElement(_frame2['default'], { data: this.props.data, isExpanded: true })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = TemplateInterface;
	module.exports = exports['default'];

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _stacktrace = __webpack_require__(179);
	
	var _utils = __webpack_require__(7);
	
	var _dropdownLink = __webpack_require__(33);
	
	var _dropdownLink2 = _interopRequireDefault(_dropdownLink);
	
	var _menuItem = __webpack_require__(37);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _frame = __webpack_require__(134);
	
	var _crashHeader = __webpack_require__(178);
	
	var _crashHeader2 = _interopRequireDefault(_crashHeader);
	
	var _crashContent = __webpack_require__(177);
	
	var _crashContent2 = _interopRequireDefault(_crashContent);
	
	var _pills = __webpack_require__(186);
	
	var _pills2 = _interopRequireDefault(_pills);
	
	var _pill = __webpack_require__(185);
	
	var _pill2 = _interopRequireDefault(_pill);
	
	function trimFilename(fn) {
	  var pieces = fn.split(/\//g);
	  return pieces[pieces.length - 1];
	}
	
	function findRelevantFrame(stacktrace) {
	  if (!stacktrace.hasSystemFrames) {
	    return stacktrace.frames[stacktrace.frames.length - 1];
	  }
	  for (var i = stacktrace.frames.length - 1; i >= 0; i--) {
	    var frame = stacktrace.frames[i];
	    if (frame.inApp) {
	      return frame;
	    }
	  }
	  // this should not happen
	  return stacktrace.frames[stacktrace.frames.length - 1];
	}
	
	function findThreadException(thread, event) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = event.entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var entry = _step.value;
	
	      if (entry.type !== 'exception') {
	        continue;
	      }
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = entry.data.values[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var exc = _step2.value;
	
	          if (exc.threadId === thread.id) {
	            return entry.data;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	            _iterator2['return']();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return null;
	}
	
	function findThreadStacktrace(thread, event, raw) {
	  if (raw && thread.rawStacktrace) {
	    return thread.rawStacktrace;
	  } else if (thread.stacktrace) {
	    return thread.stacktrace;
	  }
	  var exc = findThreadException(thread, event);
	  if (exc) {
	    var rv = null;
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = exc.values[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var singleExc = _step3.value;
	
	        if (singleExc.threadId === thread.id) {
	          rv = raw && singleExc.rawStacktrace || singleExc.stacktrace;
	        }
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	          _iterator3['return']();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    return rv;
	  }
	  return null;
	}
	
	function getThreadTitle(thread, event, simplified) {
	  var stacktrace = findThreadStacktrace(thread, event, false);
	  var bits = ['Thread'];
	  if ((0, _utils.defined)(thread.name)) {
	    bits.push(' "' + thread.name + '"');
	  }
	  if ((0, _utils.defined)(thread.id)) {
	    bits.push(' #' + thread.id);
	  }
	
	  if (!simplified) {
	    if (stacktrace) {
	      var frame = findRelevantFrame(stacktrace);
	      bits.push(' — ');
	      bits.push(_react2['default'].createElement(
	        'em',
	        { key: 'location' },
	        frame.filename ? trimFilename(frame.filename) : frame['package'] ? (0, _frame.trimPackage)(frame['package']) : frame.module ? frame.module : '<unknown>'
	      ));
	    }
	
	    if (thread.crashed) {
	      var exc = findThreadException(thread, event);
	      bits.push(' — ');
	      bits.push(_react2['default'].createElement(
	        'small',
	        { key: 'crashed' },
	        exc ? '(crashed with ' + exc.values[0].type + ')' : '(crashed)'
	      ));
	    }
	  }
	
	  return bits;
	}
	
	function getIntendedStackView(thread, event) {
	  var stacktrace = findThreadStacktrace(thread, event, false);
	  return stacktrace && stacktrace.hasSystemFrames ? 'app' : 'full';
	}
	
	function findBestThread(threads) {
	  var _iteratorNormalCompletion4 = true;
	  var _didIteratorError4 = false;
	  var _iteratorError4 = undefined;
	
	  try {
	    for (var _iterator4 = threads[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	      var thread = _step4.value;
	
	      if (thread.crashed) {
	        return thread;
	      }
	    }
	  } catch (err) {
	    _didIteratorError4 = true;
	    _iteratorError4 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion4 && _iterator4['return']) {
	        _iterator4['return']();
	      }
	    } finally {
	      if (_didIteratorError4) {
	        throw _iteratorError4;
	      }
	    }
	  }
	
	  var _iteratorNormalCompletion5 = true;
	  var _didIteratorError5 = false;
	  var _iteratorError5 = undefined;
	
	  try {
	    for (var _iterator5 = threads[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	      var thread = _step5.value;
	
	      if (thread.stacktrace) {
	        return thread;
	      }
	    }
	  } catch (err) {
	    _didIteratorError5 = true;
	    _iteratorError5 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion5 && _iterator5['return']) {
	        _iterator5['return']();
	      }
	    } finally {
	      if (_didIteratorError5) {
	        throw _iteratorError5;
	      }
	    }
	  }
	
	  return threads[0];
	}
	
	var Thread = _react2['default'].createClass({
	  displayName: 'Thread',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired,
	    stackView: _react2['default'].PropTypes.string,
	    stackType: _react2['default'].PropTypes.string,
	    newestFirst: _react2['default'].PropTypes.bool,
	    exception: _react2['default'].PropTypes.object,
	    stacktrace: _react2['default'].PropTypes.object
	  },
	
	  renderMissingStacktrace: function renderMissingStacktrace() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'traceback missing-traceback' },
	      _react2['default'].createElement(
	        'ul',
	        null,
	        _react2['default'].createElement(
	          'li',
	          { className: 'frame missing-frame' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'title' },
	            _react2['default'].createElement(
	              'span',
	              { className: 'informal' },
	              this.props.data.crashed ? 'Thread Crashed' : 'No or unknown stacktrace'
	            )
	          )
	        )
	      )
	    );
	  },
	
	  hasMissingStacktrace: function hasMissingStacktrace() {
	    var _props = this.props;
	    var exception = _props.exception;
	    var stacktrace = _props.stacktrace;
	
	    return !(exception || stacktrace);
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var data = _props2.data;
	    var group = _props2.group;
	    var event = _props2.event;
	    var stackView = _props2.stackView;
	    var stackType = _props2.stackType;
	    var newestFirst = _props2.newestFirst;
	    var exception = _props2.exception;
	    var stacktrace = _props2.stacktrace;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'thread' },
	      _react2['default'].createElement(
	        _pills2['default'],
	        null,
	        _react2['default'].createElement(_pill2['default'], { name: 'id', value: data.id }),
	        _react2['default'].createElement(_pill2['default'], { name: 'name', value: data.name }),
	        _react2['default'].createElement(_pill2['default'], { name: 'was active', value: data.current }),
	        _react2['default'].createElement(
	          _pill2['default'],
	          { name: 'crashed', className: data.crashed ? 'false' : 'true' },
	          data.crashed ? 'yes' : 'no'
	        )
	      ),
	      this.hasMissingStacktrace() ? this.renderMissingStacktrace() : _react2['default'].createElement(_crashContent2['default'], {
	        group: group,
	        event: event,
	        stackType: stackType,
	        stackView: stackView,
	        newestFirst: newestFirst,
	        exception: exception,
	        stacktrace: stacktrace })
	    );
	  }
	});
	
	var ThreadsInterface = _react2['default'].createClass({
	  displayName: 'ThreadsInterface',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired,
	    type: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired,
	    platform: _react2['default'].PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    var thread = findBestThread(this.props.data.values);
	    return {
	      activeThread: thread,
	      stackView: getIntendedStackView(thread, this.props.event),
	      stackType: 'original',
	      newestFirst: (0, _stacktrace.isStacktraceNewestFirst)()
	    };
	  },
	
	  toggleStack: function toggleStack(value) {
	    this.setState({
	      stackView: value
	    });
	  },
	
	  getStacktrace: function getStacktrace() {
	    return findThreadStacktrace(this.state.activeThread, this.props.event, this.state.stackType !== 'original');
	  },
	
	  getException: function getException() {
	    return findThreadException(this.state.activeThread, this.props.event);
	  },
	
	  onSelectNewThread: function onSelectNewThread(thread) {
	    var newStackView = this.state.stackView;
	    if (this.state.stackView !== 'raw') {
	      newStackView = getIntendedStackView(thread, this.props.event);
	    }
	    this.setState({
	      activeThread: thread,
	      stackView: newStackView,
	      stackType: 'original'
	    });
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var group = this.props.group;
	    var evt = this.props.event;
	    var _state = this.state;
	    var stackView = _state.stackView;
	    var stackType = _state.stackType;
	    var newestFirst = _state.newestFirst;
	    var activeThread = _state.activeThread;
	
	    var exception = this.getException();
	    var stacktrace = this.getStacktrace();
	
	    var threadSelector = _react2['default'].createElement(
	      'div',
	      { className: 'pull-left btn-group' },
	      _react2['default'].createElement(
	        _dropdownLink2['default'],
	        {
	          btnGroup: true,
	          caret: true,
	          className: 'btn btn-default btn-sm',
	          title: getThreadTitle(activeThread, this.props.event, true) },
	        this.props.data.values.map(function (thread, idx) {
	          return _react2['default'].createElement(
	            _menuItem2['default'],
	            { key: idx, noAnchor: true },
	            _react2['default'].createElement(
	              'a',
	              { onClick: _this.onSelectNewThread.bind(_this, thread) },
	              getThreadTitle(thread, _this.props.event, false)
	            )
	          );
	        })
	      )
	    );
	
	    var title = _react2['default'].createElement(_crashHeader2['default'], {
	      title: null,
	      beforeTitle: threadSelector,
	      group: group,
	      platform: event.platform,
	      thread: activeThread,
	      stacktrace: stacktrace,
	      exception: exception,
	      stackView: stackView,
	      newestFirst: newestFirst,
	      stackType: stackType,
	      onChange: function (newState) {
	        _this.setState(newState);
	      } });
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: group,
	        event: evt,
	        type: this.props.type,
	        title: title,
	        wrapTitle: false },
	      _react2['default'].createElement(Thread, {
	        group: group,
	        data: activeThread,
	        exception: exception,
	        stackView: stackView,
	        stackType: stackType,
	        stacktrace: stacktrace,
	        event: evt,
	        newestFirst: newestFirst })
	    );
	  }
	});
	
	exports['default'] = ThreadsInterface;
	module.exports = exports['default'];

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.escapeQuotes = escapeQuotes;
	exports.getCurlCommand = getCurlCommand;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(7);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function escapeQuotes(v) {
	  return v.replace(/"/g, '\\"');
	}
	
	// TODO(dcramer): support cookies
	
	function getCurlCommand(data) {
	  var result = 'curl';
	
	  if ((0, _utils.defined)(data.method) && data.method !== 'GET') {
	    result += ' \\\n -X ' + data.method;
	  }
	
	  // TODO(benvinegar): just gzip? what about deflate?
	  var compressed = data.headers.find(function (h) {
	    return h[0] === 'Accept-Encoding' && h[1].indexOf('gzip') !== -1;
	  });
	  if (compressed) {
	    result += ' \\\n --compressed';
	  }
	
	  // sort headers
	  var headers = data.headers.sort(function (a, b) {
	    return a[0] === b[0] ? 0 : a[0] < b[0] ? -1 : 1;
	  });
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = headers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var header = _step.value;
	
	      result += ' \\\n -H "' + header[0] + ': ' + escapeQuotes(header[1] + '') + '"';
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  if (_underscore2['default'].isString(data.data)) {
	    result += ' \\\n --data "' + escapeQuotes(data.data) + '"';
	  } else if ((0, _utils.defined)(data.data)) {
	    result += ' \\\n --data "' + escapeQuotes(jQuery.param(data.data)) + '"';
	  }
	
	  result += ' \\\n "' + data.url;
	
	  if ((0, _utils.defined)(data.query) && data.query) {
	    result += '?' + data.query;
	  }
	
	  result += '"';
	  return result;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _utils = __webpack_require__(7);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _clippedBox = __webpack_require__(172);
	
	var _clippedBox2 = _interopRequireDefault(_clippedBox);
	
	var _interfacesKeyValueList = __webpack_require__(81);
	
	var _interfacesKeyValueList2 = _interopRequireDefault(_interfacesKeyValueList);
	
	var _locale = __webpack_require__(2);
	
	var EventPackageData = _react2['default'].createClass({
	  displayName: 'EventPackageData',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return this.props.event.id !== nextProps.event.id;
	  },
	
	  render: function render() {
	    var packages = (0, _utils.objectToArray)(this.props.event.packages);
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: this.props.group,
	        event: this.props.event,
	        type: 'packages',
	        title: (0, _locale.t)('Packages') },
	      _react2['default'].createElement(
	        _clippedBox2['default'],
	        null,
	        _react2['default'].createElement(_interfacesKeyValueList2['default'], { data: packages })
	      )
	    );
	  }
	});
	
	exports['default'] = EventPackageData;
	module.exports = exports['default'];

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _eventDataSection = __webpack_require__(30);
	
	var _eventDataSection2 = _interopRequireDefault(_eventDataSection);
	
	var _locale = __webpack_require__(2);
	
	var EventSdk = _react2['default'].createClass({
	  displayName: 'EventSdk',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var group = _props.group;
	    var event = _props.event;
	
	    var data = event.sdk;
	
	    return _react2['default'].createElement(
	      _eventDataSection2['default'],
	      {
	        group: group,
	        event: event,
	        type: 'sdk',
	        title: (0, _locale.t)('SDK'),
	        wrapTitle: true },
	      _react2['default'].createElement(
	        'table',
	        { className: 'table key-value' },
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            { key: 'name' },
	            _react2['default'].createElement(
	              'td',
	              { className: 'key' },
	              'Name'
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'value' },
	              _react2['default'].createElement(
	                'pre',
	                null,
	                data.name
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'tr',
	            { key: 'version' },
	            _react2['default'].createElement(
	              'td',
	              { className: 'key' },
	              'Version'
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'value' },
	              _react2['default'].createElement(
	                'pre',
	                null,
	                data.version
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'tr',
	            { key: 'clientIP' },
	            _react2['default'].createElement(
	              'td',
	              { className: 'key' },
	              'Client IP'
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'value' },
	              _react2['default'].createElement(
	                'pre',
	                null,
	                data.clientIP || 'n/a'
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = EventSdk;
	module.exports = exports['default'];

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var EventUserReport = _react2['default'].createClass({
	  displayName: 'EventUserReport',
	
	  propTypes: {
	    event: _react2['default'].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var report = this.props.event.userReport;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'user-report' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'activity-container' },
	        _react2['default'].createElement(
	          'ul',
	          { className: 'activity' },
	          _react2['default'].createElement(
	            'li',
	            { className: 'activity-note' },
	            _react2['default'].createElement(_componentsAvatar2['default'], { user: report, size: 64, className: 'avatar' }),
	            _react2['default'].createElement(
	              'div',
	              { className: 'activity-bubble' },
	              _react2['default'].createElement(_componentsTimeSince2['default'], { date: report.dateCreated }),
	              _react2['default'].createElement(
	                'div',
	                { className: 'activity-author' },
	                report.name,
	                ' ',
	                _react2['default'].createElement(
	                  'small',
	                  null,
	                  report.email
	                )
	              ),
	              _react2['default'].createElement('p', { dangerouslySetInnerHTML: { __html: _utils2['default'].nl2br(_utils2['default'].urlize(_utils2['default'].escape(report.comments))) } })
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = EventUserReport;
	module.exports = exports['default'];

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(7);
	
	var _booleanField = __webpack_require__(275);
	
	var _booleanField2 = _interopRequireDefault(_booleanField);
	
	var _emailField = __webpack_require__(276);
	
	var _emailField2 = _interopRequireDefault(_emailField);
	
	var _numberField = __webpack_require__(279);
	
	var _numberField2 = _interopRequireDefault(_numberField);
	
	var _passwordField = __webpack_require__(280);
	
	var _passwordField2 = _interopRequireDefault(_passwordField);
	
	var _rangeField = __webpack_require__(281);
	
	var _rangeField2 = _interopRequireDefault(_rangeField);
	
	var _select2FieldAutocomplete = __webpack_require__(283);
	
	var _select2FieldAutocomplete2 = _interopRequireDefault(_select2FieldAutocomplete);
	
	var _select2Field = __webpack_require__(282);
	
	var _select2Field2 = _interopRequireDefault(_select2Field);
	
	var _textField = __webpack_require__(284);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _textareaField = __webpack_require__(285);
	
	var _textareaField2 = _interopRequireDefault(_textareaField);
	
	var GenericField = (function (_React$Component) {
	  _inherits(GenericField, _React$Component);
	
	  function GenericField() {
	    _classCallCheck(this, GenericField);
	
	    _get(Object.getPrototypeOf(GenericField.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(GenericField, [{
	    key: 'render',
	    value: function render() {
	      var config = this.props.config;
	      var required = (0, _utils.defined)(config.required) ? config.required : true;
	      var props = Object.assign(Object.assign({}, config), {
	        value: this.props.formData[config.name],
	        onChange: this.props.onChange,
	        label: config.label + (required ? '*' : ''),
	        placeholder: config.placeholder,
	        required: required,
	        name: config.name,
	        error: (this.props.formErrors || {})[config.name],
	        disabled: config.readonly,
	        key: config.name,
	        help: (0, _utils.defined)(config.help) && config.help !== '' ? _react2['default'].createElement('span', { dangerouslySetInnerHTML: { __html: config.help } }) : null
	      });
	
	      switch (config.type) {
	        case 'secret':
	          return _react2['default'].createElement(_passwordField2['default'], props);
	        case 'range':
	          return _react2['default'].createElement(_rangeField2['default'], props);
	        case 'bool':
	          return _react2['default'].createElement(_booleanField2['default'], props);
	        case 'email':
	          return _react2['default'].createElement(_emailField2['default'], props);
	        case 'string':
	        case 'text':
	        case 'url':
	          return _react2['default'].createElement(_textField2['default'], props);
	        case 'number':
	          return _react2['default'].createElement(_numberField2['default'], props);
	        case 'textarea':
	          return _react2['default'].createElement(_textareaField2['default'], props);
	        case 'choice':
	        case 'select':
	          // the chrome required tip winds up in weird places
	          // for select2 elements, so just make it look like
	          // it's required (with *) and rely on server validation
	          delete props.required;
	          if (props.has_autocomplete) {
	            return _react2['default'].createElement(_select2FieldAutocomplete2['default'], props);
	          }
	          return _react2['default'].createElement(_select2Field2['default'], props);
	        default:
	          return null;
	      }
	    }
	  }]);
	
	  return GenericField;
	})(_react2['default'].Component);
	
	GenericField.propTypes = {
	  config: _react2['default'].PropTypes.object.isRequired,
	  formData: _react2['default'].PropTypes.object,
	  formErrors: _react2['default'].PropTypes.object,
	  onChange: _react2['default'].PropTypes.func
	};
	
	exports['default'] = GenericField;
	module.exports = exports['default'];

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _formField = __webpack_require__(278);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var MultipleCheckboxField = (function (_FormField) {
	  _inherits(MultipleCheckboxField, _FormField);
	
	  function MultipleCheckboxField(props) {
	    _classCallCheck(this, MultipleCheckboxField);
	
	    _get(Object.getPrototypeOf(MultipleCheckboxField.prototype), 'constructor', this).call(this, props);
	
	    this.state.value = new Set(props.value || []);
	  }
	
	  // XXX(dcramer): this comes from TooltipMixin
	
	  _createClass(MultipleCheckboxField, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.attachTooltips();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeTooltips();
	      (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this)).unbind();
	    }
	  }, {
	    key: 'attachTooltips',
	    value: function attachTooltips() {
	      (0, _jquery2['default'])('.tip', _reactDom2['default'].findDOMNode(this)).tooltip();
	    }
	  }, {
	    key: 'removeTooltips',
	    value: function removeTooltips() {
	      (0, _jquery2['default'])('.tip', _reactDom2['default'].findDOMNode(this)).tooltip('destroy');
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(value, e) {
	      var _this = this;
	
	      if (e.target.checked) this.state.value.add(value);else this.state.value['delete'](value);
	      this.setState({
	        value: this.state.value
	      }, function () {
	        _this.props.onChange(Array.from(_this.state.value.keys()));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var className = 'control-group';
	      if (this.props.error) {
	        className += ' has-error';
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: className },
	        _react2['default'].createElement(
	          'label',
	          { className: 'control-label' },
	          this.props.label,
	          this.props.disabled && this.props.disabledReason && _react2['default'].createElement(
	            'span',
	            { className: 'disabled-indicator tip', title: this.props.disabledReason },
	            _react2['default'].createElement('span', { className: 'icon-question' })
	          )
	        ),
	        this.props.help && _react2['default'].createElement(
	          'p',
	          { className: 'help-block' },
	          this.props.help
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'controls control-list' },
	          this.props.choices.map(function (choice) {
	            return _react2['default'].createElement(
	              'label',
	              { className: 'checkbox', key: choice[0] },
	              _react2['default'].createElement('input', { type: 'checkbox',
	                value: choice[0],
	                onChange: _this2.onChange.bind(_this2, choice[0]),
	                disabled: _this2.props.disabled,
	                checked: _this2.state.value.has(choice[0]) }),
	              choice[1]
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return MultipleCheckboxField;
	})(_formField2['default']);
	
	exports['default'] = MultipleCheckboxField;
	module.exports = exports['default'];

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapLibModal = __webpack_require__(73);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsDropdownLink = __webpack_require__(33);
	
	var _componentsDropdownLink2 = _interopRequireDefault(_componentsDropdownLink);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _componentsMenuItem = __webpack_require__(37);
	
	var _componentsMenuItem2 = _interopRequireDefault(_componentsMenuItem);
	
	var _plugins = __webpack_require__(193);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _locale = __webpack_require__(2);
	
	var _utils = __webpack_require__(7);
	
	var IssuePluginActions = _react2['default'].createClass({
	  displayName: 'IssuePluginActions',
	
	  propTypes: {
	    plugin: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsGroupState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      showModal: false,
	      actionType: null,
	      pluginLoading: false
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.loadPlugin(this.props.plugin);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.plugin.id !== nextProps.plugin.id) {
	      this.loadPlugin(nextProps.plugin);
	    }
	  },
	
	  ACTION_LABELS: {
	    create: (0, _locale.t)('Create New Issue'),
	    link: (0, _locale.t)('Link with Existing Issue'),
	    unlink: (0, _locale.t)('Unlink Issue')
	  },
	
	  loadPlugin: function loadPlugin(data) {
	    var _this = this;
	
	    this.setState({
	      pluginLoading: true
	    }, function () {
	      _plugins2['default'].load(data, function () {
	        _this.setState({ pluginLoading: false });
	      });
	    });
	  },
	
	  openModal: function openModal(action) {
	    this.setState({
	      showModal: true,
	      actionType: action
	    });
	  },
	
	  closeModal: function closeModal() {
	    this.setState({
	      showModal: false,
	      actionType: null
	    });
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var plugin = this.props.plugin;
	
	    if (!plugin.allowed_actions || !plugin.allowed_actions.length) {
	      return null;
	    }
	
	    var allowedActions = plugin.allowed_actions.filter(plugin.issue ? function (action) {
	      return action === 'unlink';
	    } : function (action) {
	      return action !== 'unlink';
	    });
	
	    var button = undefined;
	    if (allowedActions.length === 1) {
	      button = _react2['default'].createElement(
	        'button',
	        { className: 'btn btn-default btn-sm btn-plugin-' + plugin.slug,
	          onClick: this.openModal.bind(this, allowedActions[0]) },
	        (0, _utils.toTitleCase)(allowedActions[0]) + ' ' + plugin.title + ' Issue'
	      );
	    } else {
	      button = _react2['default'].createElement(
	        'div',
	        { className: 'btn-group btn-plugin-' + plugin.slug },
	        _react2['default'].createElement(
	          _componentsDropdownLink2['default'],
	          {
	            caret: false,
	            className: 'btn btn-default btn-sm',
	            title: _react2['default'].createElement(
	              'span',
	              null,
	              plugin.title,
	              _react2['default'].createElement('span', { className: 'icon-arrow-down', style: { marginLeft: 3, marginRight: -3 } })
	            ) },
	          allowedActions.map(function (action) {
	            return _react2['default'].createElement(
	              _componentsMenuItem2['default'],
	              { key: action, noAnchor: true },
	              _react2['default'].createElement(
	                'a',
	                { onClick: _this2.openModal.bind(_this2, action) },
	                _this2.ACTION_LABELS[action]
	              )
	            );
	          })
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      'span',
	      null,
	      button,
	      _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: this.state.showModal, onHide: this.closeModal,
	          animation: false, backdrop: 'static', enforceFocus: false },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            plugin.title + ' Issue'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          !this.state.pluginLoading && this.state.actionType && _plugins2['default'].get(this.props.plugin).renderGroupActions({
	            plugin: this.props.plugin,
	            group: this.getGroup(),
	            project: this.getProject(),
	            organization: this.getOrganization(),
	            actionType: this.state.actionType,
	            onSuccess: this.closeModal
	          })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = IssuePluginActions;
	module.exports = exports['default'];

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _avatar = __webpack_require__(29);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var GroupParticipants = _react2['default'].createClass({
	  displayName: 'GroupParticipants',
	
	  propTypes: {
	    participants: _react2['default'].PropTypes.array.isRequired
	  },
	
	  render: function render() {
	    var participants = this.props.participants;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h6',
	        null,
	        _react2['default'].createElement(
	          'span',
	          null,
	          participants.length,
	          ' ',
	          'Participant' + (participants.length === 1 ? '' : 's')
	        )
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'faces' },
	        participants.map(function (user) {
	          return _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(_avatar2['default'], { size: 32, user: user })
	          );
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = GroupParticipants;
	module.exports = exports['default'];

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stackedBarChart = __webpack_require__(106);
	
	var _stackedBarChart2 = _interopRequireDefault(_stackedBarChart);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _locale = __webpack_require__(2);
	
	var _utils = __webpack_require__(7);
	
	var GroupReleaseChart = _react2['default'].createClass({
	  displayName: 'GroupReleaseChart',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    release: _react2['default'].PropTypes.shape({
	      version: _react2['default'].PropTypes.string.isRequired
	    }),
	    releaseStats: _react2['default'].PropTypes.object,
	    statsPeriod: _react2['default'].PropTypes.string.isRequired,
	    environment: _react2['default'].PropTypes.string,
	    environmentStats: _react2['default'].PropTypes.object,
	    firstSeen: _react2['default'].PropTypes.string,
	    lastSeen: _react2['default'].PropTypes.string,
	    title: _react2['default'].PropTypes.string
	  },
	
	  getInitialState: function getInitialState(props) {
	    if (!(0, _utils.defined)(props)) props = this.props;
	    var releaseStats = props.releaseStats;
	    var releasePoints = {};
	    if ((0, _utils.defined)(releaseStats)) {
	      releaseStats[this.props.statsPeriod].forEach(function (point) {
	        releasePoints[point[0]] = point[1];
	      });
	    }
	
	    var envStats = props.environmentStats;
	    var envPoints = {};
	    if ((0, _utils.defined)(envStats)) {
	      envStats[this.props.statsPeriod].forEach(function (point) {
	        envPoints[point[0]] = point[1];
	      });
	    }
	
	    return {
	      releasePoints: releasePoints,
	      envPoints: envPoints
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState(this.getInitialState());
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return(
	      // environment comes from grouprelease, so we can hack
	      this.props.environment !== nextProps.environment || this.props.group.id !== nextProps.group.id
	    );
	  },
	
	  renderTooltip: function renderTooltip(point, pointIdx, chart) {
	    var timeLabel = chart.getTimeLabel(point);
	    var totalY = 0;
	    for (var i = 0; i < point.y.length; i++) {
	      totalY += point.y[i];
	    }
	
	    var _props = this.props;
	    var environment = _props.environment;
	    var release = _props.release;
	    var _state = this.state;
	    var releasePoints = _state.releasePoints;
	    var envPoints = _state.envPoints;
	
	    return '<div style="width:150px">' + ('<div class="time-label">' + timeLabel + '</div>') + '<dl class="legend">' + '<dt class="inactive"><span></span></dt>' + ('<dd>' + (0, _utils.intcomma)(totalY) + ' event' + (totalY !== 1 ? 's' : '') + '</dd>') + (environment ? '<dt class="environment"><span></span></dt>' + ('<dd>' + (0, _utils.intcomma)(envPoints[point.x] || 0) + ' event' + (envPoints[point.x] !== 1 ? 's' : '')) + ('<small>in ' + (0, _utils.escape)(environment) + '</small></dd>') : '') + (release ? '<dt class="active"><span></span></dt>' + ('<dd>' + (0, _utils.intcomma)(releasePoints[point.x] || 0) + ' event' + (releasePoints[point.x] !== 1 ? 's' : '')) + ('<small>in ' + (0, _utils.escape)(release.version.substr(0, 12)) + '</small></dd>') : '') + '</dl>' + '</div>';
	  },
	
	  render: function render() {
	    var className = 'bar-chart group-chart ' + (this.props.className || '');
	
	    var group = this.props.group;
	    var stats = group.stats[this.props.statsPeriod];
	    if (!stats || !stats.length) return null;
	
	    var _state2 = this.state;
	    var releasePoints = _state2.releasePoints;
	    var envPoints = _state2.envPoints;
	
	    var points = stats.map(function (point) {
	      var rData = releasePoints[point[0]] || 0;
	      var eData = (envPoints[point[0]] || 0) - rData;
	      if (eData < 0) eData = 0;
	      var remaining = point[1] - rData - eData;
	      return {
	        x: point[0],
	        y: [rData, eData, remaining >= 0 ? remaining : 0]
	      };
	    });
	
	    var markers = [];
	
	    if (this.props.firstSeen) {
	      var firstSeenX = new Date(this.props.firstSeen).getTime() / 1000;
	      if (firstSeenX >= points[0].x) {
	        markers.push({
	          label: (0, _locale.t)('First seen'),
	          x: firstSeenX,
	          className: 'first-seen'
	        });
	      }
	    }
	
	    if (this.props.lastSeen) {
	      var lastSeenX = new Date(this.props.lastSeen).getTime() / 1000;
	      if (lastSeenX >= points[0].x) {
	        markers.push({
	          label: (0, _locale.t)('Last seen'),
	          x: lastSeenX,
	          className: 'last-seen'
	        });
	      }
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: className },
	      _react2['default'].createElement(
	        'h6',
	        null,
	        _react2['default'].createElement(
	          'span',
	          null,
	          this.props.title
	        )
	      ),
	      _react2['default'].createElement(_stackedBarChart2['default'], {
	        points: points,
	        height: 150,
	        className: 'sparkline',
	        markers: markers,
	        barClasses: ['release', 'environment', 'inactive'],
	        tooltip: this.renderTooltip })
	    );
	  }
	});
	
	exports['default'] = GroupReleaseChart;
	module.exports = exports['default'];

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _dropdownLink = __webpack_require__(33);
	
	var _dropdownLink2 = _interopRequireDefault(_dropdownLink);
	
	var _storesEnvironmentStore = __webpack_require__(302);
	
	var _storesEnvironmentStore2 = _interopRequireDefault(_storesEnvironmentStore);
	
	var _loadingIndicator = __webpack_require__(6);
	
	var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);
	
	var _loadingError = __webpack_require__(9);
	
	var _loadingError2 = _interopRequireDefault(_loadingError);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _releaseChart = __webpack_require__(588);
	
	var _releaseChart2 = _interopRequireDefault(_releaseChart);
	
	var _menuItem = __webpack_require__(37);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _seenInfo = __webpack_require__(590);
	
	var _seenInfo2 = _interopRequireDefault(_seenInfo);
	
	var _utils = __webpack_require__(7);
	
	var _locale = __webpack_require__(2);
	
	var DEFAULT_ENV_NAME = '(Default Environment)';
	
	var PRODUCTION_ENV_NAMES = new Set(['production', 'prod', 'release', 'master', 'trunk']);
	
	// TODO(dcramer): this should listen to EnvironmentStore
	// changes
	var GroupReleaseStats = _react2['default'].createClass({
	  displayName: 'GroupReleaseStats',
	
	  propTypes: {
	    defaultEnvironment: _react2['default'].PropTypes.string,
	    group: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsGroupState2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultEnvironment: ''
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var envList = _storesEnvironmentStore2['default'].getAll();
	    var queryParams = this.props.location.query;
	
	    var selectedEnvironment = queryParams.hasOwnProperty('environment') ? queryParams.environment : this.props.defaultEnvironment;
	
	    if (selectedEnvironment && envList.filter(function (e) {
	      return e.name === selectedEnvironment;
	    }).length === 0) {
	      selectedEnvironment = null;
	    }
	
	    if (!selectedEnvironment) {
	      var prodEnvs = envList.filter(function (e) {
	        return PRODUCTION_ENV_NAMES.has(e.name);
	      });
	      selectedEnvironment = prodEnvs.length && prodEnvs[0].name;
	    }
	
	    if (!selectedEnvironment) {
	      selectedEnvironment = envList.length && envList[0].name;
	    }
	
	    return {
	      loading: true,
	      error: false,
	      data: null,
	      envList: envList,
	      environment: selectedEnvironment || ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    if (this.state.loading) {
	      this.fetchData();
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var queryParams = nextProps.location.query;
	    if (queryParams.environment !== this.props.location.query.environment) {
	      this.setState({
	        environment: queryParams.environment,
	        loading: true,
	        error: false
	      }, this.fetchData);
	    }
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return this.state.loading !== nextState.loading || this.state.error !== nextState.error || this.state.environment !== nextState.environment || this.props.group.id !== nextProps.group.id;
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var group = this.props.group;
	    var env = this.state.environment || 'none';
	    var stats = this.props.group.stats['24h'];
	
	    // due to the current stats logic in Sentry we need to extend the bounds
	    var until = stats[stats.length - 1][0] + 1;
	
	    this.api.request('/issues/' + group.id + '/environments/' + env + '/', {
	      query: {
	        until: until
	      },
	      success: function success(data) {
	        _this.setState({
	          data: data,
	          loading: false,
	          error: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          data: null,
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  switchEnv: function switchEnv(env) {
	    if (this.state.environment === env) return;
	
	    var queryParams = Object.assign({}, this.props.location.query);
	    queryParams.environment = env;
	
	    _reactRouter.browserHistory.pushState(null, this.props.location.pathname, queryParams);
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var group = this.props.group;
	    var projectId = this.getProject().slug;
	    var orgId = this.getOrganization().slug;
	    var environment = this.state.environment;
	    var data = this.state.data || {};
	    var firstSeenEnv = data.firstSeen;
	    var lastSeenEnv = data.lastSeen;
	
	    var envList = this.state.envList;
	    var hasRelease = (0, _utils.defined)(group.lastRelease);
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'env-stats' },
	      _react2['default'].createElement(
	        'h6',
	        null,
	        _react2['default'].createElement(
	          'span',
	          null,
	          _react2['default'].createElement(
	            _dropdownLink2['default'],
	            { title: environment ? (0, _utils.toTitleCase)(environment) : DEFAULT_ENV_NAME },
	            envList.map(function (e) {
	              return _react2['default'].createElement(
	                _menuItem2['default'],
	                {
	                  key: e.name,
	                  isActive: environment === e.name,
	                  onClick: _this2.switchEnv.bind(_this2, e.name) },
	                (0, _utils.toTitleCase)(e.name) || DEFAULT_ENV_NAME
	              );
	            })
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'env-content' },
	        this.state.loading ? _react2['default'].createElement(_loadingIndicator2['default'], null) : this.state.error ? _react2['default'].createElement(_loadingError2['default'], null) : _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(_releaseChart2['default'], {
	            group: group,
	            environment: environment,
	            environmentStats: data.environment.stats,
	            release: data.currentRelease ? data.currentRelease.release : null,
	            releaseStats: data.currentRelease ? data.currentRelease.stats : null,
	            statsPeriod: '24h',
	            title: (0, _locale.t)('Last 24 Hours'),
	            firstSeen: group.firstSeen,
	            lastSeen: group.lastSeen }),
	          _react2['default'].createElement(_releaseChart2['default'], {
	            group: group,
	            environment: environment,
	            environmentStats: data.environment.stats,
	            release: data.currentRelease ? data.currentRelease.release : null,
	            releaseStats: data.currentRelease ? data.currentRelease.stats : null,
	            statsPeriod: '30d',
	            title: (0, _locale.t)('Last 30 Days'),
	            className: 'bar-chart-small',
	            firstSeen: group.firstSeen,
	            lastSeen: group.lastSeen }),
	          _react2['default'].createElement(
	            'h6',
	            null,
	            _react2['default'].createElement(
	              'span',
	              null,
	              (0, _locale.t)('First seen')
	            ),
	            environment && _react2['default'].createElement(
	              'small',
	              null,
	              '(',
	              environment,
	              ')'
	            )
	          ),
	          _react2['default'].createElement(_seenInfo2['default'], {
	            orgId: orgId,
	            projectId: projectId,
	            date: firstSeenEnv,
	            dateGlobal: group.firstSeen,
	            hasRelease: hasRelease,
	            environment: environment,
	            release: data.firstRelease ? data.firstRelease.release : null,
	            title: (0, _locale.t)('First seen') }),
	          _react2['default'].createElement(
	            'h6',
	            null,
	            _react2['default'].createElement(
	              'span',
	              null,
	              (0, _locale.t)('Last seen')
	            ),
	            environment && _react2['default'].createElement(
	              'small',
	              null,
	              '(',
	              environment,
	              ')'
	            )
	          ),
	          _react2['default'].createElement(_seenInfo2['default'], {
	            orgId: orgId,
	            projectId: projectId,
	            date: lastSeenEnv,
	            dateGlobal: group.lastSeen,
	            hasRelease: hasRelease,
	            environment: environment,
	            release: data.lastRelease ? data.lastRelease.release : null,
	            title: (0, _locale.t)('Last seen') })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = GroupReleaseStats;
	module.exports = exports['default'];

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsDateTime = __webpack_require__(72);
	
	var _componentsDateTime2 = _interopRequireDefault(_componentsDateTime);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _componentsVersion = __webpack_require__(107);
	
	var _componentsVersion2 = _interopRequireDefault(_componentsVersion);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _utils = __webpack_require__(7);
	
	var _utilsComponentToString = __webpack_require__(621);
	
	var _utilsComponentToString2 = _interopRequireDefault(_utilsComponentToString);
	
	var _locale = __webpack_require__(2);
	
	var SeenInfo = _react2['default'].createClass({
	  displayName: 'SeenInfo',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    date: _react2['default'].PropTypes.any,
	    dateGlobal: _react2['default'].PropTypes.any,
	    release: _react2['default'].PropTypes.shape({
	      version: _react2['default'].PropTypes.string.isRequired
	    }),
	    environment: _react2['default'].PropTypes.string,
	    hasRelease: _react2['default'].PropTypes.bool.isRequired
	  },
	
	  mixins: [(0, _mixinsTooltip2['default'])(function () {
	    var instance = this;
	
	    return {
	      html: true,
	      selector: '.tip',
	      title: function title() {
	        var _instance$props = instance.props;
	        var date = _instance$props.date;
	        var dateGlobal = _instance$props.dateGlobal;
	        var environment = _instance$props.environment;
	        var title = _instance$props.title;
	
	        return (0, _utilsComponentToString2['default'])(_react2['default'].createElement(
	          'div',
	          { style: { width: 170 } },
	          _react2['default'].createElement(
	            'div',
	            { className: 'time-label' },
	            title
	          ),
	          _react2['default'].createElement(
	            'dl',
	            { className: 'flat' },
	            environment && [_react2['default'].createElement(
	              'dt',
	              { key: '0' },
	              (0, _utils.toTitleCase)(environment)
	            ), _react2['default'].createElement(
	              'dd',
	              { key: '0.1' },
	              _react2['default'].createElement(_componentsTimeSince2['default'], { date: date }),
	              _react2['default'].createElement('br', null)
	            )],
	            _react2['default'].createElement(
	              'dt',
	              { key: '1' },
	              'Globally:'
	            ),
	            _react2['default'].createElement(
	              'dd',
	              { key: '1.1' },
	              _react2['default'].createElement(_componentsTimeSince2['default'], { date: dateGlobal }),
	              _react2['default'].createElement('br', null)
	            )
	          )
	        ));
	      }
	    };
	  })],
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return (this.props.release || {}).version !== (nextProps.release || {}).version || this.props.date !== nextProps.date;
	  },
	
	  getReleaseTrackingUrl: function getReleaseTrackingUrl() {
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	
	    return '/' + orgId + '/' + projectId + '/settings/release-tracking/';
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var date = _props2.date;
	    var dateGlobal = _props2.dateGlobal;
	    var environment = _props2.environment;
	    var release = _props2.release;
	    var orgId = _props2.orgId;
	    var projectId = _props2.projectId;
	
	    return _react2['default'].createElement(
	      'dl',
	      { className: 'seen-info' },
	      _react2['default'].createElement(
	        'dt',
	        { key: 0 },
	        (0, _locale.t)('When'),
	        ':'
	      ),
	      date ? _react2['default'].createElement(
	        'dd',
	        { key: 1 },
	        _react2['default'].createElement(
	          'span',
	          { className: 'tip' },
	          _react2['default'].createElement(_componentsTimeSince2['default'], { date: date })
	        ),
	        _react2['default'].createElement('br', null),
	        _react2['default'].createElement(
	          'small',
	          null,
	          _react2['default'].createElement(_componentsDateTime2['default'], { date: date, seconds: true })
	        )
	      ) : dateGlobal && environment === '' ? _react2['default'].createElement(
	        'dd',
	        { key: 1 },
	        _react2['default'].createElement(
	          'span',
	          { className: 'tip' },
	          _react2['default'].createElement(_componentsTimeSince2['default'], { date: dateGlobal })
	        ),
	        _react2['default'].createElement('br', null),
	        _react2['default'].createElement(
	          'small',
	          null,
	          _react2['default'].createElement(_componentsDateTime2['default'], { date: dateGlobal, seconds: true })
	        )
	      ) : _react2['default'].createElement(
	        'dd',
	        { key: 1 },
	        'n/a'
	      ),
	      _react2['default'].createElement(
	        'dt',
	        { key: 4 },
	        (0, _locale.t)('Release'),
	        ':'
	      ),
	      (0, _utils.defined)(release) ? _react2['default'].createElement(
	        'dd',
	        { key: 5 },
	        _react2['default'].createElement(_componentsVersion2['default'], { orgId: orgId, projectId: projectId, version: release.version })
	      ) : !this.props.hasRelease ? _react2['default'].createElement(
	        'dd',
	        { key: 5 },
	        _react2['default'].createElement(
	          'small',
	          { style: { marginLeft: 5, fontStyle: 'italic' } },
	          _react2['default'].createElement(
	            'a',
	            { href: this.getReleaseTrackingUrl() },
	            'not configured'
	          )
	        )
	      ) : _react2['default'].createElement(
	        'dd',
	        { key: 5 },
	        'n/a'
	      )
	    );
	  }
	});
	
	exports['default'] = SeenInfo;
	module.exports = exports['default'];

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _participants = __webpack_require__(587);
	
	var _participants2 = _interopRequireDefault(_participants);
	
	var _releaseStats = __webpack_require__(589);
	
	var _releaseStats2 = _interopRequireDefault(_releaseStats);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _tagDistributionMeter = __webpack_require__(592);
	
	var _tagDistributionMeter2 = _interopRequireDefault(_tagDistributionMeter);
	
	var _locale = __webpack_require__(2);
	
	var GroupSidebar = _react2['default'].createClass({
	  displayName: 'GroupSidebar',
	
	  propTypes: {
	    group: _react2['default'].PropTypes.object
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsGroupState2['default']],
	
	  subscriptionReasons: {
	    commented: (0, _locale.t)('You\'re receiving updates because you have commented on this issue.'),
	    assigned: (0, _locale.t)('You\'re receiving updates because you were assigned to this issue.'),
	    bookmarked: (0, _locale.t)('You\'re receiving updates because you have bookmarked this issue.'),
	    changed_status: (0, _locale.t)('You\'re receiving updates because you have changed the status of this issue.')
	  },
	
	  toggleSubscription: function toggleSubscription() {
	    var _this = this;
	
	    var group = this.props.group;
	    var project = this.getProject();
	    var org = this.getOrganization();
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	
	    this.api.bulkUpdate({
	      orgId: org.slug,
	      projectId: project.slug,
	      itemIds: [group.id],
	      data: {
	        isSubscribed: !group.isSubscribed
	      }
	    }, {
	      complete: function complete() {
	        _this.api.request('/issues/' + group.id + '/participants/', {
	          success: function success(data) {
	            _this.setState({ participants: data });
	            _storesIndicatorStore2['default'].remove(loadingIndicator);
	          }
	        });
	      }
	    });
	  },
	
	  renderPluginIssue: function renderPluginIssue() {
	    var issues = [];
	    (this.props.group.pluginIssues || []).forEach(function (plugin) {
	      var issue = plugin.issue;
	      if (issue) {
	        issues.push(_react2['default'].createElement(
	          'dl',
	          { key: plugin.slug },
	          _react2['default'].createElement(
	            'dt',
	            null,
	            plugin.title + ': '
	          ),
	          _react2['default'].createElement(
	            'dd',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: issue.url },
	              issue.label
	            )
	          )
	        ));
	      }
	    });
	    if (issues.length) {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h6',
	          null,
	          _react2['default'].createElement(
	            'span',
	            null,
	            (0, _locale.t)('External Issues')
	          )
	        ),
	        issues
	      );
	    }
	  },
	
	  getNotificationText: function getNotificationText() {
	    var group = this.getGroup();
	
	    if (group.isSubscribed) {
	      var result = (0, _locale.t)('You\'re receiving updates because you are subscribed to this issue.');
	      if (group.subscriptionDetails) {
	        var reason = group.subscriptionDetails.reason;
	        if (this.subscriptionReasons.hasOwnProperty(reason)) {
	          result = this.subscriptionReasons[reason];
	        }
	      } else {
	        result = (0, _locale.tct)('You\'re receiving updates because you are [link:subscribed to workflow notifications] for this project.', {
	          link: _react2['default'].createElement('a', { href: '/account/settings/notifications/' })
	        });
	      }
	      return result;
	    } else {
	      return (0, _locale.t)('You\'re not subscribed to this issue.');
	    }
	  },
	
	  render: function render() {
	    var project = this.getProject();
	    var projectId = project.slug;
	    var orgId = this.getOrganization().slug;
	    var defaultEnvironment = project.defaultEnvironment;
	    var group = this.getGroup();
	    var participants = (this.state || {}).participants || [];
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'group-stats' },
	      _react2['default'].createElement(_releaseStats2['default'], {
	        group: group,
	        location: this.context.location,
	        defaultEnvironment: defaultEnvironment }),
	      this.renderPluginIssue(),
	      _react2['default'].createElement(
	        'h6',
	        null,
	        _react2['default'].createElement(
	          'span',
	          null,
	          (0, _locale.t)('Tags')
	        )
	      ),
	      group.tags.map(function (data) {
	        return _react2['default'].createElement(_tagDistributionMeter2['default'], {
	          key: data.key,
	          orgId: orgId,
	          projectId: projectId,
	          group: group,
	          name: data.name,
	          tag: data.key });
	      }),
	      participants.length !== 0 && _react2['default'].createElement(_participants2['default'], { participants: participants }),
	      _react2['default'].createElement(
	        'h6',
	        null,
	        _react2['default'].createElement(
	          'span',
	          null,
	          (0, _locale.t)('Notifications')
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        { className: 'help-block' },
	        this.getNotificationText()
	      ),
	      _react2['default'].createElement(
	        'a',
	        { className: 'btn btn-default btn-subscribe ' + (group.isSubscribed && 'subscribed'),
	          onClick: this.toggleSubscription },
	        _react2['default'].createElement('span', { className: 'icon-signal' }),
	        ' ',
	        group.isSubscribed ? (0, _locale.t)('Unsubscribe') : (0, _locale.t)('Subscribe')
	      )
	    );
	  }
	});
	
	exports['default'] = GroupSidebar;
	module.exports = exports['default'];

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _utils = __webpack_require__(7);
	
	var _locale = __webpack_require__(2);
	
	var TagDistributionMeter = _react2['default'].createClass({
	  displayName: 'TagDistributionMeter',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired,
	    tag: _react2['default'].PropTypes.string.isRequired,
	    name: _react2['default'].PropTypes.string,
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default'], (0, _mixinsTooltip2['default'])({
	    html: true,
	    selector: '.segment',
	    container: 'body'
	  })],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      data: null
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return this.state.loading !== nextState.loading || this.state.error !== nextState.error || this.props.tag !== nextProps.tag || this.props.name !== nextProps.name;
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var url = '/issues/' + this.props.group.id + '/tags/' + encodeURIComponent(this.props.tag) + '/';
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(url, {
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          data: data,
	          error: false,
	          loading: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  /**
	   * Render segments of tag distribution
	   *
	   * e.g.
	   *
	   * .--------.-----.----------------.
	   * |  web-1 |web-2|     other      |
	   * `--------'-----'----------------'
	   */
	
	  renderSegments: function renderSegments() {
	    var _this2 = this;
	
	    var data = this.state.data;
	    var totalValues = data.totalValues;
	
	    var totalVisible = data.topValues.reduce(function (sum, value) {
	      return sum + value.count;
	    }, 0);
	
	    var hasOther = totalVisible < totalValues;
	    var otherPct = (0, _utils.percent)(totalValues - totalVisible, totalValues);
	    var otherPctLabel = Math.floor(otherPct);
	
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'segments' },
	      data.topValues.map(function (value, index) {
	        var pct = (0, _utils.percent)(value.count, totalValues);
	        var pctLabel = Math.floor(pct);
	        var className = 'segment segment-' + index;
	
	        return _react2['default'].createElement(
	          _reactRouter.Link,
	          {
	            key: value.id,
	            className: className, style: { width: pct + '%' },
	            to: '/' + orgId + '/' + projectId + '/issues/' + _this2.props.group.id + '/tags/' + _this2.props.tag + '/',
	            title: '<div class="truncate">' + (0, _utils.escape)((0, _utils.deviceNameMapper)(value.name)) + '</div>' + pctLabel + '%' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'tag-description' },
	            _react2['default'].createElement(
	              'span',
	              { className: 'tag-percentage' },
	              pctLabel,
	              '%'
	            ),
	            _react2['default'].createElement(
	              'span',
	              { className: 'tag-label' },
	              (0, _utils.deviceNameMapper)(value.name)
	            )
	          )
	        );
	      }),
	      hasOther && _react2['default'].createElement(
	        _reactRouter.Link,
	        {
	          key: 'other',
	          className: 'segment segment-9', style: { width: otherPct + '%' },
	          to: '/' + orgId + '/' + projectId + '/issues/' + this.props.group.id + '/tags/' + this.props.tag + '/',
	          title: 'Other<br/>' + otherPctLabel + '%' },
	        _react2['default'].createElement(
	          'span',
	          { className: 'tag-description' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'tag-percentage' },
	            otherPctLabel,
	            '%'
	          ),
	          _react2['default'].createElement(
	            'span',
	            { className: 'tag-label' },
	            (0, _locale.t)('Other')
	          )
	        )
	      )
	    );
	  },
	
	  renderBody: function renderBody() {
	    if (this.state.loading || this.state.error) return null;
	
	    if (!this.state.data.totalValues) return _react2['default'].createElement(
	      'p',
	      null,
	      (0, _locale.t)('No recent data.')
	    );
	
	    return this.renderSegments();
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'distribution-graph' },
	      _react2['default'].createElement(
	        'h6',
	        null,
	        _react2['default'].createElement(
	          'span',
	          null,
	          this.props.tag
	        )
	      ),
	      this.renderBody()
	    );
	  }
	});
	
	exports['default'] = TagDistributionMeter;
	module.exports = exports['default'];

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _locale = __webpack_require__(2);
	
	var GroupListHeader = _react2['default'].createClass({
	  displayName: 'GroupListHeader',
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'group-header' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'stream-actions row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'stream-actions-left col-md-7 col-sm-8 col-xs-8 nav-header' },
	          (0, _locale.t)('Event')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'hidden-sm hidden-xs stream-actions-graph col-md-2 col-md-offset-1 align-right nav-header' },
	          (0, _locale.t)('Last 24 hours')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'stream-actions-count align-right col-md-1 col-sm-2 col-xs-2' },
	          (0, _locale.t)('events')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'stream-actions-users align-right col-md-1 col-sm-2 col-xs-2' },
	          (0, _locale.t)('users')
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = GroupListHeader;
	module.exports = exports['default'];

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapLibModal = __webpack_require__(73);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _locale = __webpack_require__(2);
	
	var Snooze = {
	  // all values in minutes
	  '30MINUTES': 30,
	  '2HOURS': 60 * 2,
	  '24HOURS': 60 * 24
	};
	
	var SnoozeAction = _react2['default'].createClass({
	  displayName: 'SnoozeAction',
	
	  propTypes: {
	    disabled: _react2['default'].PropTypes.bool,
	    onSnooze: _react2['default'].PropTypes.func.isRequired,
	    tooltip: _react2['default'].PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isModalOpen: false
	    };
	  },
	
	  toggleModal: function toggleModal() {
	    if (this.props.disabled) {
	      return;
	    }
	    this.setState({
	      isModalOpen: !this.state.isModalOpen
	    });
	  },
	
	  closeModal: function closeModal() {
	    this.setState({ isModalOpen: false });
	  },
	
	  onSnooze: function onSnooze(duration) {
	    this.props.onSnooze(duration);
	    this.closeModal();
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'a',
	      { title: this.props.tooltip,
	        className: this.props.className,
	        disabled: this.props.disabled,
	        onClick: this.toggleModal },
	      _react2['default'].createElement(
	        'span',
	        null,
	        (0, _locale.t)('zZz')
	      ),
	      _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: this.state.isModalOpen, title: (0, _locale.t)('Please confirm'), animation: false,
	          onHide: this.closeModal, bsSize: 'sm' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-body' },
	          _react2['default'].createElement(
	            'h5',
	            null,
	            (0, _locale.t)('How long should we ignore this issue?')
	          ),
	          _react2['default'].createElement(
	            'ul',
	            { className: 'nav nav-stacked nav-pills' },
	            _react2['default'].createElement(
	              'li',
	              null,
	              _react2['default'].createElement(
	                'a',
	                { onClick: this.onSnooze.bind(this, Snooze['30MINUTES']) },
	                (0, _locale.t)('30 minutes')
	              )
	            ),
	            _react2['default'].createElement(
	              'li',
	              null,
	              _react2['default'].createElement(
	                'a',
	                { onClick: this.onSnooze.bind(this, Snooze['2HOURS']) },
	                (0, _locale.t)('2 hours')
	              )
	            ),
	            _react2['default'].createElement(
	              'li',
	              null,
	              _react2['default'].createElement(
	                'a',
	                { onClick: this.onSnooze.bind(this, Snooze['24HOURS']) },
	                (0, _locale.t)('24 hours')
	              )
	            ),
	            _react2['default'].createElement(
	              'li',
	              null,
	              _react2['default'].createElement(
	                'a',
	                { onClick: this.onSnooze.bind(this, undefined) },
	                (0, _locale.t)('Forever')
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-footer' },
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-default',
	              onClick: this.closeModal },
	            (0, _locale.t)('Cancel')
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = SnoozeAction;
	module.exports = exports['default'];
	/* override click event object w/ undefined to indicate "no duration" */

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionsAlertActions = __webpack_require__(62);
	
	var _actionsAlertActions2 = _interopRequireDefault(_actionsAlertActions);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _locale = __webpack_require__(2);
	
	var MissingProjectMembership = _react2['default'].createClass({
	  displayName: 'MissingProjectMembership',
	
	  propTypes: {
	    organization: _react2['default'].PropTypes.object.isRequired,
	    team: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: false,
	      error: false
	    };
	  },
	
	  joinTeam: function joinTeam() {
	    var _this = this;
	
	    this.setState({
	      loading: true
	    });
	
	    this.api.joinTeam({
	      orgId: this.props.organization.slug,
	      teamId: this.props.team.slug
	    }, {
	      success: function success() {
	        _this.setState({
	          loading: false,
	          error: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	        _actionsAlertActions2['default'].addAlert({
	          message: 'There was an error while trying to join the team.',
	          type: 'error'
	        });
	      }
	    });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var organization = _props.organization;
	    var team = _props.team;
	
	    var openMembership = organization.features.indexOf('open-membership') !== -1;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'container' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'box alert-box' },
	        _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	        _react2['default'].createElement(
	          'p',
	          null,
	          'You\'re not a member of this project.'
	        ),
	        openMembership ? _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.t)('To view this data you must first join the %s team.', team.name)
	        ) : _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.t)('To view this data you must first request access to the %s team.', team.name)
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          this.state.loading ? _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-default btn-loading btn-disabled' },
	            '...'
	          ) : team.isPending ? _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-default btn-disabled' },
	            (0, _locale.t)('Request Pending')
	          ) : openMembership ? _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-default',
	              onClick: this.joinTeam },
	            (0, _locale.t)('Join Team')
	          ) : _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-default',
	              onClick: this.joinTeam },
	            (0, _locale.t)('Request Access')
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = MissingProjectMembership;
	module.exports = exports['default'];

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _dateTime = __webpack_require__(72);
	
	var _dateTime2 = _interopRequireDefault(_dateTime);
	
	var _locale = __webpack_require__(2);
	
	var MutedBox = _react2['default'].createClass({
	  displayName: 'MutedBox',
	
	  propTypes: {
	    statusDetails: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default']],
	
	  render: function render() {
	    var statusDetails = this.props.statusDetails;
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement('span', { className: 'icon icon-soundoff' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        statusDetails.ignoreUntil ? _react2['default'].createElement(
	          'span',
	          null,
	          (0, _locale.t)('This issue has been ignored until %s', _react2['default'].createElement(
	            'strong',
	            null,
	            _react2['default'].createElement(_dateTime2['default'], { date: statusDetails.ignoreUntil })
	          )),
	          ' — '
	        ) : _react2['default'].createElement(
	          'span',
	          null,
	          (0, _locale.t)('This issue has been ignored'),
	          ' — '
	        ),
	        (0, _locale.t)('You will not be notified of any changes and it will not show up by default in feeds.')
	      )
	    );
	  }
	});
	
	exports['default'] = MutedBox;
	module.exports = exports['default'];

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _listLink = __webpack_require__(47);
	
	var _listLink2 = _interopRequireDefault(_listLink);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _storesHookStore = __webpack_require__(90);
	
	var _storesHookStore2 = _interopRequireDefault(_storesHookStore);
	
	var _locale = __webpack_require__(2);
	
	var HomeSidebar = _react2['default'].createClass({
	  displayName: 'HomeSidebar',
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    // Allow injection via getsentry et all
	    var org = this.getOrganization();
	    var hooks = [];
	    _storesHookStore2['default'].get('organization:sidebar').forEach(function (cb) {
	      hooks.push(cb(org));
	    });
	
	    return {
	      hooks: hooks
	    };
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var access = this.getAccess();
	    var features = this.getFeatures();
	    var org = this.getOrganization();
	
	    var orgId = org.slug;
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h6',
	        { className: 'nav-header' },
	        (0, _locale.t)('Organization')
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'nav nav-stacked' },
	        _react2['default'].createElement(
	          _listLink2['default'],
	          { to: '/' + orgId + '/', isActive: function () {
	              // return true if path matches /organizations/slug-name/teams/ OR /organizations/slug-name/all-teams/
	              return (/^\/[^\/]+\/$/.test(_this.context.location.pathname)
	              );
	            } },
	          (0, _locale.t)('Dashboard')
	        ),
	        _react2['default'].createElement(
	          _listLink2['default'],
	          { to: '/organizations/' + orgId + '/teams/', isActive: function () {
	              // return true if path matches /organizations/slug-name/teams/ OR /organizations/slug-name/all-teams/
	              return (/^\/organizations\/[^\/]+\/(teams|all-teams)\/$/.test(_this.context.location.pathname)
	              );
	            } },
	          (0, _locale.t)('Projects & Teams')
	        ),
	        access.has('org:read') && _react2['default'].createElement(
	          _listLink2['default'],
	          { to: '/organizations/' + orgId + '/stats/' },
	          (0, _locale.t)('Stats')
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h6',
	          { className: 'nav-header with-divider' },
	          (0, _locale.t)('Issues')
	        ),
	        _react2['default'].createElement(
	          'ul',
	          { className: 'nav nav-stacked' },
	          _react2['default'].createElement(
	            _listLink2['default'],
	            { to: '/organizations/' + orgId + '/issues/assigned/' },
	            (0, _locale.t)('Assigned to Me')
	          ),
	          _react2['default'].createElement(
	            _listLink2['default'],
	            { to: '/organizations/' + orgId + '/issues/bookmarks/' },
	            (0, _locale.t)('Bookmarks')
	          ),
	          _react2['default'].createElement(
	            _listLink2['default'],
	            { to: '/organizations/' + orgId + '/issues/history/' },
	            (0, _locale.t)('History')
	          )
	        )
	      ),
	      access.has('org:read') && _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h6',
	          { className: 'nav-header with-divider' },
	          (0, _locale.t)('Manage')
	        ),
	        _react2['default'].createElement(
	          'ul',
	          { className: 'nav nav-stacked' },
	          access.has('org:read') && _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: '/organizations/' + orgId + '/members/' },
	              (0, _locale.t)('Members'),
	              ' ',
	              access.has('org:write') && org.pendingAccessRequests > 0 && _react2['default'].createElement(
	                'span',
	                { className: 'badge', style: { marginLeft: 5 } },
	                org.pendingAccessRequests
	              )
	            )
	          ),
	          features.has('sso') && access.has('org:delete') && _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: '/organizations/' + orgId + '/auth/' },
	              (0, _locale.t)('Auth')
	            )
	          ),
	          access.has('org:delete') && features.has('api-keys') && _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: '/organizations/' + orgId + '/api-keys/' },
	              (0, _locale.t)('API Keys')
	            )
	          ),
	          access.has('org:write') && _react2['default'].createElement(
	            _listLink2['default'],
	            { to: '/organizations/' + orgId + '/audit-log/' },
	            (0, _locale.t)('Audit Log')
	          ),
	          access.has('org:write') && _react2['default'].createElement(
	            _listLink2['default'],
	            { to: '/organizations/' + orgId + '/rate-limits/' },
	            (0, _locale.t)('Rate Limits')
	          ),
	          features.has('repos') && access.has('org:write') && _react2['default'].createElement(
	            _listLink2['default'],
	            { to: '/organizations/' + orgId + '/repos/' },
	            (0, _locale.t)('Repositories')
	          ),
	          access.has('org:write') && _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: '/organizations/' + orgId + '/settings/' },
	              (0, _locale.t)('Settings')
	            )
	          )
	        )
	      ),
	      this.state.hooks
	    );
	  }
	});
	
	exports['default'] = HomeSidebar;
	module.exports = exports['default'];

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _projectSelector = __webpack_require__(136);
	
	var _projectSelector2 = _interopRequireDefault(_projectSelector);
	
	var _projectsBookmarkToggle = __webpack_require__(599);
	
	var _projectsBookmarkToggle2 = _interopRequireDefault(_projectsBookmarkToggle);
	
	var _locale = __webpack_require__(2);
	
	var ProjectHeader = _react2['default'].createClass({
	  displayName: 'ProjectHeader',
	
	  propTypes: {
	    project: _react2['default'].PropTypes.object.isRequired,
	    organization: _react2['default'].PropTypes.object.isRequired,
	    activeSection: _react2['default'].PropTypes.string
	  },
	
	  render: function render() {
	    var navSection = this.props.activeSection;
	    var project = this.props.project;
	    var org = this.props.organization;
	    var features = new Set(project.features);
	    var access = new Set(org.access);
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'sub-header flex flex-container flex-vertically-centered' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'p-t-1' },
	        _react2['default'].createElement(_projectSelector2['default'], {
	          organization: org,
	          projectId: project.slug }),
	        _react2['default'].createElement(
	          'ul',
	          { className: 'nav nav-tabs' },
	          _react2['default'].createElement(
	            'li',
	            { className: navSection == 'stream' ? 'active' : '' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/' + org.slug + '/' + project.slug + '/' },
	              (0, _locale.t)('Issues')
	            )
	          ),
	          features.has('global-events') && _react2['default'].createElement(
	            'li',
	            { className: navSection == 'events' ? 'active' : '' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/' + org.slug + '/' + project.slug + '/events/' },
	              (0, _locale.t)('Events')
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            { className: navSection == 'dashboard' ? 'active' : '' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/' + org.slug + '/' + project.slug + '/dashboard/' },
	              (0, _locale.t)('Overview')
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            { className: navSection == 'user-feedback' ? 'active' : '' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/' + org.slug + '/' + project.slug + '/user-feedback/' },
	              (0, _locale.t)('User Feedback')
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            { className: navSection == 'releases' ? 'active' : '' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/' + org.slug + '/' + project.slug + '/releases/' },
	              (0, _locale.t)('Releases')
	            )
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'align-right project-actions' },
	        _react2['default'].createElement(
	          _projectsBookmarkToggle2['default'],
	          { orgId: org.slug, project: project },
	          _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-sm btn-default' },
	            _react2['default'].createElement('span', { className: project.isBookmarked ? 'icon icon-star-solid active' : 'icon icon-star-solid' }),
	            project.isBookmarked ? _react2['default'].createElement(
	              'span',
	              null,
	              (0, _locale.t)('Unstar Project')
	            ) : _react2['default'].createElement(
	              'span',
	              null,
	              (0, _locale.t)('Star Project')
	            )
	          )
	        ),
	        access.has('project:write') && _react2['default'].createElement(
	          'a',
	          { className: navSection == 'settings' ? 'btn btn-sm btn-default active' : 'btn btn-sm btn-default', href: '/' + org.slug + '/' + project.slug + '/settings/' },
	          _react2['default'].createElement('span', { className: 'icon icon-settings' }),
	          ' ',
	          (0, _locale.t)('Project Settings')
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectHeader;
	module.exports = exports['default'];

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _actionCreatorsProjects = __webpack_require__(130);
	
	var BookmarkToggle = _react2['default'].createClass({
	  displayName: 'BookmarkToggle',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    project: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  handleBookmarkClick: function handleBookmarkClick() {
	    var project = this.props.project;
	
	    (0, _actionCreatorsProjects.update)(this.api, {
	      orgId: this.props.orgId,
	      projectId: project.slug,
	      data: {
	        isBookmarked: !project.isBookmarked
	      }
	    });
	  },
	
	  render: function render() {
	    // TODO: can't guarantee that a <span> is appropriate here 100% of the time
	    //       if this is to be truly re-usable
	    return _react2['default'].createElement(
	      'span',
	      { onClick: this.handleBookmarkClick },
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = BookmarkToggle;
	module.exports = exports['default'];

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _loadingIndicator = __webpack_require__(6);
	
	var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);
	
	var _locale = __webpack_require__(2);
	
	var _sidebarPanel = __webpack_require__(138);
	
	var _sidebarPanel2 = _interopRequireDefault(_sidebarPanel);
	
	var _sidebarPanelItem = __webpack_require__(295);
	
	var _sidebarPanelItem2 = _interopRequireDefault(_sidebarPanelItem);
	
	var MARK_SEEN_DELAY = 1000;
	var POLLER_DELAY = 60000;
	
	var Broadcasts = _react2['default'].createClass({
	  displayName: 'Broadcasts',
	
	  propTypes: {
	    showPanel: _react2['default'].PropTypes.bool,
	    currentPanel: _react2['default'].PropTypes.string,
	    hidePanel: _react2['default'].PropTypes.func,
	    onShowPanel: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      broadcasts: [],
	      loading: true,
	      error: false
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.timer) {
	      window.clearTimeout(this.timer);
	      this.timer = null;
	    }
	    if (this.poller) {
	      window.clearTimeout(this.poller);
	      this.poller = null;
	    }
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    if (this.poller) {
	      window.clearTimeout(this.poller);
	    }
	    this.api.request('/broadcasts/', {
	      method: 'GET',
	      success: function success(data) {
	        _this.setState({
	          broadcasts: data,
	          loading: false
	        });
	        _this.poller = window.setTimeout(_this.fetchData, POLLER_DELAY);
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	        _this.poller = window.setTimeout(_this.fetchData, POLLER_DELAY);
	      }
	    });
	  },
	
	  onShowPanel: function onShowPanel() {
	    this.timer = window.setTimeout(this.markSeen, MARK_SEEN_DELAY);
	    this.props.onShowPanel();
	  },
	
	  getUnseenIds: function getUnseenIds() {
	    return this.state.broadcasts.filter(function (item) {
	      return !item.hasSeen;
	    }).map(function (item) {
	      return item.id;
	    });
	  },
	
	  markSeen: function markSeen() {
	    var _this2 = this;
	
	    var unseenBroadcastIds = this.getUnseenIds();
	    if (unseenBroadcastIds.length === 0) return;
	
	    this.api.request('/broadcasts/', {
	      method: 'PUT',
	      query: { id: unseenBroadcastIds },
	      data: {
	        hasSeen: '1'
	      },
	      success: function success() {
	        _this2.setState({
	          broadcasts: _this2.state.broadcasts.map(function (item) {
	            item.hasSeen = true;
	            return item;
	          })
	        });
	      }
	    });
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var broadcasts = _state.broadcasts;
	    var loading = _state.loading;
	
	    return _react2['default'].createElement(
	      'li',
	      { className: this.props.currentPanel == 'broadcasts' ? 'active' : null },
	      _react2['default'].createElement(
	        'a',
	        { className: 'broadcasts-toggle', onClick: this.onShowPanel, title: 'Updates from Sentry' },
	        _react2['default'].createElement('span', { className: 'icon icon-globe' }),
	        this.getUnseenIds() > 0 && _react2['default'].createElement('span', { className: 'activity-indicator' })
	      ),
	      this.props.showPanel && this.props.currentPanel == 'broadcasts' && _react2['default'].createElement(
	        _sidebarPanel2['default'],
	        { title: (0, _locale.t)('Recent updates from Sentry'),
	          hidePanel: this.props.hidePanel },
	        loading ? _react2['default'].createElement(_loadingIndicator2['default'], null) : broadcasts.length === 0 ? _react2['default'].createElement(
	          'div',
	          { className: 'sidebar-panel-empty' },
	          (0, _locale.t)('No recent updates from the Sentry team.')
	        ) : broadcasts.map(function (item) {
	          return _react2['default'].createElement(_sidebarPanelItem2['default'], {
	            key: item.id,
	            className: !item.hasSeen && 'unseen',
	            title: item.title,
	            message: item.message,
	            link: item.link });
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = Broadcasts;
	module.exports = exports['default'];

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _sidebarPanel = __webpack_require__(138);
	
	var _sidebarPanel2 = _interopRequireDefault(_sidebarPanel);
	
	var _storesIncidentStore = __webpack_require__(618);
	
	var _storesIncidentStore2 = _interopRequireDefault(_storesIncidentStore);
	
	var _locale = __webpack_require__(2);
	
	var Incidents = _react2['default'].createClass({
	  displayName: 'Incidents',
	
	  propTypes: {
	    showPanel: _react2['default'].PropTypes.bool,
	    currentPanel: _react2['default'].PropTypes.string,
	    hidePanel: _react2['default'].PropTypes.func,
	    onShowPanel: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_reflux2['default'].listenTo(_storesIncidentStore2['default'], 'onIncidentChange')],
	
	  getInitialState: function getInitialState() {
	    return {
	      status: null
	    };
	  },
	
	  onIncidentChange: function onIncidentChange(status) {
	    this.setState({
	      status: _extends({}, status)
	    });
	  },
	
	  render: function render() {
	    var status = this.state.status;
	
	    if (!status) return null;
	
	    return status && status.incidents.length > 0 && _react2['default'].createElement(
	      'li',
	      { className: this.props.currentPanel == 'statusupdate' ? 'active' : null },
	      _react2['default'].createElement(
	        'a',
	        { onClick: this.props.onShowPanel },
	        _react2['default'].createElement('span', { className: 'icon icon-alert animated pulse infinite' })
	      ),
	      this.props.showPanel && this.props.currentPanel == 'statusupdate' && status && _react2['default'].createElement(
	        _sidebarPanel2['default'],
	        { title: (0, _locale.t)('Recent status updates'),
	          hidePanel: this.props.hidePanel },
	        _react2['default'].createElement(
	          'ul',
	          { className: 'incident-list list-unstyled' },
	          status.incidents.map(function (incident) {
	            return _react2['default'].createElement(
	              'li',
	              { className: 'incident-item', key: incident.id },
	              _react2['default'].createElement(
	                'h4',
	                null,
	                incident.title
	              ),
	              incident.updates ? _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                  'h6',
	                  null,
	                  'Latest updates:'
	                ),
	                _react2['default'].createElement(
	                  'ul',
	                  { className: 'status-list list-unstyled' },
	                  incident.updates.map(function (update, key) {
	                    return _react2['default'].createElement(
	                      'li',
	                      { className: 'status-item', key: key },
	                      _react2['default'].createElement(
	                        'p',
	                        null,
	                        update
	                      )
	                    );
	                  })
	                )
	              ) : null,
	              _react2['default'].createElement(
	                'p',
	                null,
	                _react2['default'].createElement(
	                  'a',
	                  { href: incident.url, className: 'btn btn-default btn-sm' },
	                  'Learn more'
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = Incidents;
	module.exports = exports['default'];

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _sidebarPanel = __webpack_require__(138);
	
	var _sidebarPanel2 = _interopRequireDefault(_sidebarPanel);
	
	var _letterAvatar = __webpack_require__(289);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	var _mixinsAppState = __webpack_require__(610);
	
	var _mixinsAppState2 = _interopRequireDefault(_mixinsAppState);
	
	var _storesOrganizationStore = __webpack_require__(139);
	
	var _storesOrganizationStore2 = _interopRequireDefault(_storesOrganizationStore);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _locale = __webpack_require__(2);
	
	var OrganizationSelector = _react2['default'].createClass({
	  displayName: 'OrganizationSelector',
	
	  propTypes: {
	    organization: _react2['default'].PropTypes.object,
	    showPanel: _react2['default'].PropTypes.bool,
	    togglePanel: _react2['default'].PropTypes.func,
	    hidePanel: _react2['default'].PropTypes.func,
	    currentPanel: _react2['default'].PropTypes.string
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsAppState2['default']],
	
	  getLinkNode: function getLinkNode(org, child, className) {
	    var url = '/' + org.slug + '/';
	    if (!this.context.location) {
	      return _react2['default'].createElement(
	        'a',
	        { className: className, href: url },
	        child
	      );
	    }
	    return _react2['default'].createElement(
	      _reactRouter.Link,
	      { className: className, to: '/' + org.slug + '/' },
	      child
	    );
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var isSingleOrg = _storesConfigStore2['default'].get('singleOrganization');
	    var activeOrg = this.props.organization;
	
	    // Single-org accounts can't create new orgs/select between them
	    if (isSingleOrg || !activeOrg) {
	      return null;
	    }
	
	    var features = _storesConfigStore2['default'].get('features');
	
	    var classNames = 'org-selector divider-bottom';
	    if (this.props.currentPanel == 'org-selector') {
	      classNames += ' active';
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: classNames },
	      _react2['default'].createElement(
	        'a',
	        { className: 'active-org', onClick: this.props.togglePanel },
	        _react2['default'].createElement(_letterAvatar2['default'], { displayName: activeOrg.name, identifier: activeOrg.slug })
	      ),
	      this.props.showPanel && this.props.currentPanel == 'org-selector' && _react2['default'].createElement(
	        _sidebarPanel2['default'],
	        {
	          title: (0, _locale.t)('Organizations'),
	          hidePanel: this.props.hidePanel },
	        _react2['default'].createElement(
	          'ul',
	          { className: 'org-list list-unstyled' },
	          _storesOrganizationStore2['default'].getAll().map(function (org) {
	            return _react2['default'].createElement(
	              'li',
	              { className: activeOrg.id === org.id ? 'org active' : 'org', key: org.slug },
	              _this.getLinkNode(org, _react2['default'].createElement(_letterAvatar2['default'], { displayName: org.name, identifier: org.slug }), 'org-avatar'),
	              _react2['default'].createElement(
	                'h5',
	                null,
	                _this.getLinkNode(org, org.name)
	              ),
	              _react2['default'].createElement(
	                'p',
	                null,
	                _react2['default'].createElement(
	                  'a',
	                  { href: '/organizations/' + org.slug + '/settings/' },
	                  _react2['default'].createElement('span', { className: 'icon-settings' }),
	                  ' ',
	                  (0, _locale.t)('Settings')
	                ),
	                _react2['default'].createElement(
	                  'a',
	                  { href: '/organizations/' + org.slug + '/members/' },
	                  _react2['default'].createElement('span', { className: 'icon-users' }),
	                  ' ',
	                  (0, _locale.t)('Members')
	                )
	              )
	            );
	          }),
	          features.has('organizations:create') && _react2['default'].createElement(
	            'li',
	            { className: 'org-create' },
	            _react2['default'].createElement(
	              'a',
	              { href: '/organizations/new/', className: 'btn btn-default btn-block' },
	              (0, _locale.t)('New Organization')
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = OrganizationSelector;
	module.exports = exports['default'];

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _dropdownLink = __webpack_require__(33);
	
	var _dropdownLink2 = _interopRequireDefault(_dropdownLink);
	
	var _avatar = __webpack_require__(29);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _menuItem = __webpack_require__(37);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _locale = __webpack_require__(2);
	
	var UserNav = _react2['default'].createClass({
	  displayName: 'UserNav',
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return false;
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var user = _storesConfigStore2['default'].get('user');
	
	    if (!user) {
	      // TODO
	      return null;
	    }
	
	    var title = _react2['default'].createElement(_avatar2['default'], { user: user, className: 'avatar' });
	
	    // "to" attribute => in-app router
	    // "href" attribute => Django-powered views
	    var to = function to(url) {
	      return _this.context.location ? { to: url } : { href: url };
	    };
	
	    return _react2['default'].createElement(
	      _dropdownLink2['default'],
	      {
	        topLevelClasses: this.props.className,
	        title: title,
	        caret: false
	      },
	      _react2['default'].createElement(
	        _menuItem2['default'],
	        { href: '/account/settings/' },
	        (0, _locale.t)('Account')
	      ),
	      _react2['default'].createElement(
	        _menuItem2['default'],
	        to('/api/'),
	        (0, _locale.t)('API')
	      ),
	      user.isSuperuser && _react2['default'].createElement(
	        _menuItem2['default'],
	        to('/manage/'),
	        (0, _locale.t)('Admin')
	      ),
	      _react2['default'].createElement(
	        _menuItem2['default'],
	        { href: '/auth/logout/' },
	        (0, _locale.t)('Sign out')
	      )
	    );
	  }
	});
	
	exports['default'] = UserNav;
	module.exports = exports['default'];

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _storesSelectedGroupStore = __webpack_require__(140);
	
	var _storesSelectedGroupStore2 = _interopRequireDefault(_storesSelectedGroupStore);
	
	var GroupCheckBox = _react2['default'].createClass({
	  displayName: 'GroupCheckBox',
	
	  propTypes: {
	    id: _react2['default'].PropTypes.string.isRequired
	  },
	
	  mixins: [_reflux2['default'].listenTo(_storesSelectedGroupStore2['default'], 'onSelectedGroupChange')],
	
	  getInitialState: function getInitialState() {
	    return {
	      isSelected: _storesSelectedGroupStore2['default'].isSelected(this.props.id)
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.id != this.props.id) {
	      this.setState({
	        isSelected: _storesSelectedGroupStore2['default'].isSelected(nextProps.id)
	      });
	    }
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return nextState.isSelected !== this.state.isSelected;
	  },
	
	  onSelectedGroupChange: function onSelectedGroupChange() {
	    var isSelected = _storesSelectedGroupStore2['default'].isSelected(this.props.id);
	    if (isSelected !== this.state.isSelected) {
	      this.setState({
	        isSelected: isSelected
	      });
	    }
	  },
	
	  onSelect: function onSelect() {
	    var id = this.props.id;
	    _storesSelectedGroupStore2['default'].toggleSelect(id);
	  },
	
	  render: function render() {
	    return _react2['default'].createElement('input', { type: 'checkbox', className: 'chk-select', value: this.props.id,
	      checked: this.state.isSelected,
	      onChange: this.onSelect });
	  }
	});
	
	exports['default'] = GroupCheckBox;
	module.exports = exports['default'];

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	/**
	 * Usage:
	 *   <StrictClick onClick={this.onClickHandler}>
	 *     <button>Some button</button>
	 *   </StrictClick>
	 */
	var StrictClick = _react2['default'].createClass({
	  displayName: 'StrictClick',
	
	  propTypes: {
	    onClick: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default']],
	
	  statics: {
	    MAX_DELTA_X: 10,
	    MAX_DELTA_Y: 10
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      startCoords: null
	    };
	  },
	
	  handleMouseDown: function handleMouseDown(evt) {
	    this.setState({
	      startCoords: {
	        x: evt.screenX,
	        y: evt.screenY
	      }
	    });
	  },
	
	  handleMouseClick: function handleMouseClick(evt) {
	    // Click happens if mouse down/up in same element - click will
	    // not fire if either initial mouse down OR final ouse up occurs in
	    // different element
	    var startCoords = this.state.startCoords;
	
	    var deltaX = Math.abs(evt.screenX - startCoords.x);
	    var deltaY = Math.abs(evt.screenY - startCoords.y);
	
	    // If mouse hasn't moved more than 10 pixels in either Y
	    // or X direction, fire onClick
	    if (deltaX < StrictClick.MAX_DELTA_X && deltaY < StrictClick.MAX_DELTA_Y) {
	      this.props.onClick(evt);
	    }
	    this.setState({
	      startCoords: null
	    });
	  },
	
	  render: function render() {
	    // Bail out early if there is no onClick handler
	    if (!this.props.onClick) return this.props.children;
	
	    return _react2['default'].cloneElement(this.props.children, {
	      onMouseDown: this.handleMouseDown,
	      onClick: this.handleMouseClick
	    });
	  }
	});
	
	exports['default'] = StrictClick;
	module.exports = exports['default'];

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Switch = _react2['default'].createClass({
	  displayName: 'Switch',
	
	  propTypes: {
	    size: _react2['default'].PropTypes.string,
	    isActive: _react2['default'].PropTypes.bool,
	    isLoading: _react2['default'].PropTypes.bool,
	    toggle: _react2['default'].PropTypes.func.isRequired
	  },
	
	  render: function render() {
	
	    var switchClasses = 'switch';
	
	    if (this.props.size) {
	      switchClasses += ' switch-' + this.props.size;
	    }
	
	    if (this.props.isActive) {
	      switchClasses += ' switch-on';
	    }
	
	    if (this.props.isLoading) {
	      switchClasses += ' switch-disabled';
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: switchClasses, onClick: this.props.toggle, role: 'checkbox', 'aria-checked': this.props.isActive },
	      _react2['default'].createElement('span', { className: 'switch-toggle' })
	    );
	  }
	});
	
	exports['default'] = Switch;
	module.exports = exports['default'];

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _u2finterface = __webpack_require__(299);
	
	var _u2finterface2 = _interopRequireDefault(_u2finterface);
	
	var _locale = __webpack_require__(2);
	
	var U2fEnrollment = _react2['default'].createClass({
	  displayName: 'U2fEnrollment',
	
	  propTypes: {
	    enrollmentData: _react2['default'].PropTypes.object
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _u2finterface2['default'],
	      {
	        challengeData: this.props.enrollmentData,
	        flowMode: 'enroll' },
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('\n            To enroll your U2F device insert it now or tap the button on it\n            to activate it.\n          ')
	      )
	    );
	  }
	});
	
	exports['default'] = U2fEnrollment;
	module.exports = exports['default'];

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _u2finterface = __webpack_require__(299);
	
	var _u2finterface2 = _interopRequireDefault(_u2finterface);
	
	var _locale = __webpack_require__(2);
	
	var U2fSign = _react2['default'].createClass({
	  displayName: 'U2fSign',
	
	  propTypes: {
	    challengeData: _react2['default'].PropTypes.object,
	    displayMode: _react2['default'].PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      displayMode: 'signin'
	    };
	  },
	
	  render: function render() {
	    var displayMode = this.props.displayMode;
	
	    return _react2['default'].createElement(
	      _u2finterface2['default'],
	      {
	        challengeData: this.props.challengeData,
	        silentIfUnsupported: displayMode === 'sudo',
	        flowMode: 'sign' },
	      _react2['default'].createElement(
	        'p',
	        null,
	        displayMode === 'signin' ? (0, _locale.t)('\n            Insert your U2F device or tap the button on it to confirm the\n            sign-in request.\n          ') : displayMode === 'sudo' ? (0, _locale.t)('\n            Alternatively you can use your U2F device to confirm the action.\n          ') : null
	      )
	    );
	  }
	});
	
	exports['default'] = U2fSign;
	module.exports = exports['default'];

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _letterAvatar = __webpack_require__(289);
	
	var _letterAvatar2 = _interopRequireDefault(_letterAvatar);
	
	var UserLetterAvatar = _react2['default'].createClass({
	  displayName: 'UserLetterAvatar',
	
	  propTypes: {
	    user: _react2['default'].PropTypes.object.isRequired
	  },
	
	  getIdentifier: function getIdentifier() {
	    var user = this.props.user;
	    return user.email || user.username || user.id || user.ip_address;
	  },
	
	  getDisplayName: function getDisplayName() {
	    var user = this.props.user;
	    return user.name || user.email || user.username || '';
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(_letterAvatar2['default'], {
	      identifier: this.getIdentifier(),
	      displayName: this.getDisplayName() });
	  }
	});
	
	exports['default'] = UserLetterAvatar;
	module.exports = exports['default'];

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _storesOrganizationStore = __webpack_require__(139);
	
	var _storesOrganizationStore2 = _interopRequireDefault(_storesOrganizationStore);
	
	var AppState = {
	  getOrganizationList: function getOrganizationList() {
	    return _storesOrganizationStore2['default'].getAll();
	  }
	};
	
	exports['default'] = AppState;
	module.exports = exports['default'];

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _organizationState = __webpack_require__(26);
	
	var _organizationState2 = _interopRequireDefault(_organizationState);
	
	var TeamState = {
	  mixins: [_organizationState2['default']],
	
	  contextTypes: {
	    team: _proptypes2['default'].Team.isRequired
	  },
	
	  getTeam: function getTeam() {
	    return this.context.team;
	  }
	};
	
	exports['default'] = TeamState;
	module.exports = exports['default'];

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsForms = __webpack_require__(36);
	
	var _actionsGroupActions = __webpack_require__(169);
	
	var _actionsGroupActions2 = _interopRequireDefault(_actionsGroupActions);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsBasesPluginComponentBase = __webpack_require__(171);
	
	var _componentsBasesPluginComponentBase2 = _interopRequireDefault(_componentsBasesPluginComponentBase);
	
	var _locale = __webpack_require__(2);
	
	var IssueActions = (function (_PluginComponentBase) {
	  _inherits(IssueActions, _PluginComponentBase);
	
	  function IssueActions(props) {
	    _classCallCheck(this, IssueActions);
	
	    _get(Object.getPrototypeOf(IssueActions.prototype), 'constructor', this).call(this, props);
	
	    this.createIssue = this.onSave.bind(this, this.createIssue.bind(this));
	    this.linkIssue = this.onSave.bind(this, this.linkIssue.bind(this));
	    this.unlinkIssue = this.onSave.bind(this, this.unlinkIssue.bind(this));
	    this.onSuccess = this.onSaveSuccess.bind(this, this.onSuccess.bind(this));
	    this.errorHandler = this.onLoadError.bind(this, this.errorHandler.bind(this));
	
	    Object.assign(this.state, {
	      createFieldList: null,
	      linkFieldList: null,
	      loading: ['link', 'create'].includes(this.props.actionType),
	      state: ['link', 'create'].includes(this.props.actionType) ? _componentsForms.FormState.LOADING : _componentsForms.FormState.READY,
	      error: null,
	      createFormData: {},
	      linkFormData: {}
	    });
	  }
	
	  _createClass(IssueActions, [{
	    key: 'getGroup',
	    value: function getGroup() {
	      return this.props.group;
	    }
	  }, {
	    key: 'getProject',
	    value: function getProject() {
	      return this.props.project;
	    }
	  }, {
	    key: 'getOrganization',
	    value: function getOrganization() {
	      return this.props.organization;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var plugin = this.props.plugin;
	      if (!plugin.issue && this.props.actionType !== 'unlink') {
	        this.fetchData();
	      }
	    }
	  }, {
	    key: 'getPluginCreateEndpoint',
	    value: function getPluginCreateEndpoint() {
	      return '/issues/' + this.getGroup().id + '/plugins/' + this.props.plugin.slug + '/create/';
	    }
	  }, {
	    key: 'getPluginLinkEndpoint',
	    value: function getPluginLinkEndpoint() {
	      return '/issues/' + this.getGroup().id + '/plugins/' + this.props.plugin.slug + '/link/';
	    }
	  }, {
	    key: 'getPluginUnlinkEndpoint',
	    value: function getPluginUnlinkEndpoint() {
	      return '/issues/' + this.getGroup().id + '/plugins/' + this.props.plugin.slug + '/unlink/';
	    }
	  }, {
	    key: 'setError',
	    value: function setError(error, defaultMessage) {
	      var errorBody = undefined;
	      if (error.status === 400 && error.responseJSON) {
	        errorBody = error.responseJSON;
	      } else {
	        errorBody = { message: defaultMessage };
	      }
	      this.setState({ error: errorBody });
	    }
	  }, {
	    key: 'errorHandler',
	    value: function errorHandler(error) {
	      var state = {
	        loading: false
	      };
	      if (error.status === 400 && error.responseJSON) {
	        state.error = error.responseJSON;
	      } else {
	        state.error = { message: (0, _locale.t)('An unknown error occurred.') };
	      }
	      this.setState(state);
	    }
	  }, {
	    key: 'fetchData',
	    value: function fetchData() {
	      var _this = this;
	
	      if (this.props.actionType === 'create') {
	        this.api.request(this.getPluginCreateEndpoint(), {
	          success: function success(data) {
	            var createFormData = {};
	            data.forEach(function (field) {
	              createFormData[field.name] = field['default'];
	            });
	            _this.setState({
	              createFieldList: data,
	              error: null,
	              loading: false,
	              createFormData: createFormData
	            }, _this.onLoadSuccess);
	          },
	          error: this.errorHandler
	        });
	      } else if (this.props.actionType === 'link') {
	        this.api.request(this.getPluginLinkEndpoint(), {
	          success: function success(data) {
	            var linkFormData = {};
	            data.forEach(function (field) {
	              linkFormData[field.name] = field['default'];
	            });
	            _this.setState({
	              linkFieldList: data,
	              error: null,
	              loading: false,
	              linkFormData: linkFormData
	            }, _this.onLoadSuccess);
	          },
	          error: this.errorHandler
	        });
	      }
	    }
	  }, {
	    key: 'onSuccess',
	    value: function onSuccess() {
	      _actionsGroupActions2['default'].updateSuccess(null, [this.getGroup().id], { stale: true });
	      this.props.onSuccess && this.props.onSuccess();
	    }
	  }, {
	    key: 'createIssue',
	    value: function createIssue() {
	      var _this2 = this;
	
	      this.api.request(this.getPluginCreateEndpoint(), {
	        data: this.state.createFormData,
	        success: this.onSuccess,
	        error: this.onSaveError.bind(this, function (error) {
	          _this2.setError(error, (0, _locale.t)('There was an error creating the issue.'));
	        }),
	        complete: this.onSaveComplete
	      });
	    }
	  }, {
	    key: 'linkIssue',
	    value: function linkIssue() {
	      var _this3 = this;
	
	      this.api.request(this.getPluginLinkEndpoint(), {
	        data: this.state.linkFormData,
	        success: this.onSuccess,
	        error: this.onSaveError.bind(this, function (error) {
	          _this3.setError(error, (0, _locale.t)('There was an error linking the issue.'));
	        }),
	        complete: this.onSaveComplete
	      });
	    }
	  }, {
	    key: 'unlinkIssue',
	    value: function unlinkIssue() {
	      var _this4 = this;
	
	      this.api.request(this.getPluginUnlinkEndpoint(), {
	        success: this.onSuccess,
	        error: this.onSaveError.bind(this, function (error) {
	          _this4.setError(error, (0, _locale.t)('There was an error unlinking the issue.'));
	        }),
	        complete: this.onSaveComplete
	      });
	    }
	  }, {
	    key: 'changeField',
	    value: function changeField(action, name, value) {
	      var key = action + 'FormData';
	      var formData = this.state[key];
	      formData[name] = value;
	      var state = {};
	      state[key] = formData;
	      this.setState(state);
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      var _this5 = this;
	
	      var form = undefined;
	      switch (this.props.actionType) {
	        case 'create':
	          if (this.state.createFieldList) {
	            form = _react2['default'].createElement(
	              _componentsForms.Form,
	              { onSubmit: this.createIssue, submitLabel: (0, _locale.t)('Create Issue'),
	                footerClass: '' },
	              this.state.createFieldList.map(function (field) {
	                if (field.has_autocomplete) {
	                  field = Object.assign({
	                    url: '/api/0/issues/' + _this5.getGroup().id + '/plugins/' + _this5.props.plugin.slug + '/autocomplete'
	                  }, field);
	                }
	                return _react2['default'].createElement(
	                  'div',
	                  { key: field.name },
	                  _this5.renderField({
	                    config: field,
	                    formData: _this5.state.createFormData,
	                    onChange: _this5.changeField.bind(_this5, 'create', field.name)
	                  })
	                );
	              })
	            );
	          }
	          break;
	        case 'link':
	          if (this.state.linkFieldList) {
	            form = _react2['default'].createElement(
	              _componentsForms.Form,
	              { onSubmit: this.linkIssue, submitLabel: (0, _locale.t)('Link Issue'),
	                footerClass: '' },
	              this.state.linkFieldList.map(function (field) {
	                if (field.has_autocomplete) {
	                  field = Object.assign({
	                    url: '/api/0/issues/' + _this5.getGroup().id + '/plugins/' + _this5.props.plugin.slug + '/autocomplete'
	                  }, field);
	                }
	                return _react2['default'].createElement(
	                  'div',
	                  { key: field.name },
	                  _this5.renderField({
	                    config: field,
	                    formData: _this5.state.linkFormData,
	                    onChange: _this5.changeField.bind(_this5, 'link', field.name)
	                  })
	                );
	              })
	            );
	          }
	          break;
	        case 'unlink':
	          form = _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'p',
	              null,
	              (0, _locale.t)('Are you sure you want to unlink this issue?')
	            ),
	            _react2['default'].createElement(
	              'button',
	              { onClick: this.unlinkIssue,
	                className: 'btn btn-danger' },
	              (0, _locale.t)('Unlink Issue')
	            )
	          );
	          break;
	        default:
	          form = null;
	      }
	      return form;
	    }
	  }, {
	    key: 'getPluginConfigureUrl',
	    value: function getPluginConfigureUrl() {
	      var org = this.getOrganization();
	      var project = this.getProject();
	      var plugin = this.props.plugin;
	      return '/' + org.slug + '/' + project.slug + '/settings/plugins/' + plugin.slug;
	    }
	  }, {
	    key: 'renderError',
	    value: function renderError() {
	      var error = this.state.error;
	      if (!error) {
	        return null;
	      }
	      if (error.error_type === 'auth') {
	        var authUrl = error.auth_url;
	        if (authUrl.indexOf('?') === -1) {
	          authUrl += '?next=' + encodeURIComponent(document.location.pathname);
	        } else {
	          authUrl += '&next=' + encodeURIComponent(document.location.pathname);
	        }
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'div',
	            { className: 'alert alert-warning m-b-1' },
	            'You need to associate an identity with ' + error.title + ' before you can create issues with this service.'
	          ),
	          _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-primary', href: authUrl },
	            'Associate Identity'
	          )
	        );
	      } else if (error.error_type === 'config') {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'alert alert-block' },
	          !error.has_auth_configured ? _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'p',
	              null,
	              'Your server administrator will need to configure authentication with ',
	              _react2['default'].createElement(
	                'strong',
	                null,
	                error.auth_provider
	              ),
	              ' before you can use this plugin.'
	            ),
	            _react2['default'].createElement(
	              'p',
	              null,
	              'The following settings must be configured:'
	            ),
	            _react2['default'].createElement(
	              'ul',
	              null,
	              error.required_auth_settings.map(function (setting) {
	                return _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    'code',
	                    null,
	                    setting
	                  )
	                );
	              })
	            )
	          ) : _react2['default'].createElement(
	            'p',
	            null,
	            'You still need to ',
	            _react2['default'].createElement(
	              'a',
	              { href: this.getPluginConfigureUrl() },
	              'configure this plugin'
	            ),
	            ' before you can use it.'
	          )
	        );
	      } else if (error.error_type === 'validation') {
	        var errors = [];
	        for (var _name in error.errors) {
	          errors.push(_react2['default'].createElement(
	            'p',
	            { key: _name },
	            error.errors[_name]
	          ));
	        }
	        return _react2['default'].createElement(
	          'div',
	          { className: 'alert alert-error alert-block' },
	          errors
	        );
	      } else if (error.message) {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'alert alert-error alert-block' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            error.message
	          )
	        );
	      }
	      return _react2['default'].createElement(_componentsLoadingError2['default'], null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.state === _componentsForms.FormState.LOADING) {
	        return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);
	      }
	      return _react2['default'].createElement(
	        'div',
	        null,
	        this.renderError(),
	        this.renderForm()
	      );
	    }
	  }]);
	
	  return IssueActions;
	})(_componentsBasesPluginComponentBase2['default']);
	
	IssueActions.propTypes = {
	  plugin: _react2['default'].PropTypes.object.isRequired,
	  actionType: _react2['default'].PropTypes.oneOf(['unlink', 'link', 'create']).isRequired,
	  onSuccess: _react2['default'].PropTypes.func
	};
	
	exports['default'] = IssueActions;
	module.exports = exports['default'];

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _componentsForms = __webpack_require__(36);
	
	var _componentsBasesPluginComponentBase = __webpack_require__(171);
	
	var _componentsBasesPluginComponentBase2 = _interopRequireDefault(_componentsBasesPluginComponentBase);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _locale = __webpack_require__(2);
	
	var PluginSettings = (function (_PluginComponentBase) {
	  _inherits(PluginSettings, _PluginComponentBase);
	
	  function PluginSettings(props) {
	    _classCallCheck(this, PluginSettings);
	
	    _get(Object.getPrototypeOf(PluginSettings.prototype), 'constructor', this).call(this, props);
	
	    Object.assign(this.state, {
	      fieldList: null,
	      initialData: null,
	      formData: null,
	      errors: {},
	      rawData: {},
	      // override default FormState.READY if api requests are
	      // necessary to even load the form
	      state: _componentsForms.FormState.LOADING
	    });
	  }
	
	  _createClass(PluginSettings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'getPluginEndpoint',
	    value: function getPluginEndpoint() {
	      var org = this.props.organization;
	      var project = this.props.project;
	      return '/projects/' + org.slug + '/' + project.slug + '/plugins/' + this.props.plugin.id + '/';
	    }
	  }, {
	    key: 'changeField',
	    value: function changeField(name, value) {
	      var formData = this.state.formData;
	      formData[name] = value;
	      // upon changing a field, remove errors
	      var errors = this.state.errors;
	      delete errors[name];
	      this.setState({ formData: formData, errors: errors });
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit() {
	      var _this = this;
	
	      this.api.request(this.getPluginEndpoint(), {
	        data: this.state.formData,
	        method: 'PUT',
	        success: this.onSaveSuccess.bind(this, function (data) {
	          var formData = {};
	          var initialData = {};
	          data.config.forEach(function (field) {
	            formData[field.name] = field.value || field.defaultValue;
	            initialData[field.name] = field.value;
	          });
	          _this.setState({
	            formData: formData,
	            initialData: initialData,
	            errors: {}
	          });
	        }),
	        error: this.onSaveError.bind(this, function (error) {
	          _this.setState({
	            errors: (error.responseJSON || {}).errors || {}
	          });
	        }),
	        complete: this.onSaveComplete
	      });
	    }
	  }, {
	    key: 'fetchData',
	    value: function fetchData() {
	      var _this2 = this;
	
	      this.api.request(this.getPluginEndpoint(), {
	        success: function success(data) {
	          if (!data.config) {
	            _this2.setState({
	              rawData: data
	            }, _this2.onLoadSuccess);
	            return;
	          }
	          var formData = {};
	          var initialData = {};
	          data.config.forEach(function (field) {
	            formData[field.name] = field.value || field.defaultValue;
	            initialData[field.name] = field.value;
	          });
	          _this2.setState({
	            fieldList: data.config,
	            formData: formData,
	            initialData: initialData
	            // call this here to prevent FormState.READY from being
	            // set before fieldList is
	          }, _this2.onLoadSuccess);
	        },
	        error: this.onLoadError
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      if (this.state.state === _componentsForms.FormState.LOADING) {
	        return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);
	      }
	      var isSaving = this.state.state === _componentsForms.FormState.SAVING;
	      var hasChanges = !_underscore2['default'].isEqual(this.state.initialData, this.state.formData);
	
	      var data = this.state.rawData;
	      if (data.config_error) {
	        var authUrl = data.auth_url;
	        if (authUrl.indexOf('?') === -1) {
	          authUrl += '?next=' + encodeURIComponent(document.location.pathname);
	        } else {
	          authUrl += '&next=' + encodeURIComponent(document.location.pathname);
	        }
	        return _react2['default'].createElement(
	          'div',
	          { className: 'm-b-1' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'alert alert-warning m-b-1' },
	            data.config_error
	          ),
	          _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-primary', href: authUrl },
	            (0, _locale.t)('Associate Identity')
	          )
	        );
	      }
	
	      if (this.state.state === _componentsForms.FormState.ERROR && !this.state.fieldList) {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'alert alert-error m-b-1' },
	          (0, _locale.tct)('An unknown error occurred. Need help with this? [link:Contact support]', {
	            link: _react2['default'].createElement('a', { href: 'https://sentry.io/support/' })
	          })
	        );
	      }
	      return _react2['default'].createElement(
	        _componentsForms.Form,
	        { onSubmit: this.onSubmit, submitDisabled: isSaving || !hasChanges },
	        this.state.errors.__all__ && _react2['default'].createElement(
	          'div',
	          { className: 'alert alert-block alert-error' },
	          _react2['default'].createElement(
	            'ul',
	            null,
	            _react2['default'].createElement(
	              'li',
	              null,
	              this.state.errors.__all__
	            )
	          )
	        ),
	        this.state.fieldList.map(function (f) {
	          return _this3.renderField({
	            config: f,
	            formData: _this3.state.formData,
	            formErrors: _this3.state.errors,
	            onChange: _this3.changeField.bind(_this3, f.name)
	          });
	        })
	      );
	    }
	  }]);
	
	  return PluginSettings;
	})(_componentsBasesPluginComponentBase2['default']);
	
	PluginSettings.propTypes = {
	  organization: _react2['default'].PropTypes.object.isRequired,
	  project: _react2['default'].PropTypes.object.isRequired,
	  plugin: _react2['default'].PropTypes.object.isRequired
	};
	
	exports['default'] = PluginSettings;
	module.exports = exports['default'];

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _basePlugin = __webpack_require__(192);
	
	var _basePlugin2 = _interopRequireDefault(_basePlugin);
	
	var DefaultPlugin = (function (_BasePlugin) {
	  _inherits(DefaultPlugin, _BasePlugin);
	
	  function DefaultPlugin() {
	    _classCallCheck(this, DefaultPlugin);
	
	    _get(Object.getPrototypeOf(DefaultPlugin.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  return DefaultPlugin;
	})(_basePlugin2['default']);
	
	DefaultPlugin.displayName = 'DefaultPlugin';
	
	exports.DefaultPlugin = DefaultPlugin;

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint no-console:0*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _defaultPlugin = __webpack_require__(614);
	
	var _defaultIssuePlugin = __webpack_require__(301);
	
	var _utils = __webpack_require__(7);
	
	var Registry = (function () {
	  function Registry() {
	    _classCallCheck(this, Registry);
	
	    this.plugins = {};
	    this.assetCache = {};
	  }
	
	  _createClass(Registry, [{
	    key: 'isLoaded',
	    value: function isLoaded(data) {
	      return (0, _utils.defined)(this.plugins[data.id]);
	    }
	  }, {
	    key: 'loadAll',
	    value: function loadAll(dataList, callback) {
	      var _this = this;
	
	      var remaining = dataList.length;
	      var pluginList = [];
	      dataList.map(function (data) {
	        _this.load(data, function (plugin) {
	          remaining--;
	          pluginList.push(plugin);
	          if (remaining === 0) {
	            callback(pluginList);
	          }
	        });
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(data, callback) {
	      var _this2 = this;
	
	      // TODO(dcramer): we should probably register all valid plugins
	      var remainingAssets = data.assets.length;
	      var finishLoad = (function () {
	        if (!(0, _utils.defined)(this.plugins[data.id])) {
	          if (data.type === 'issue-tracking') {
	            this.plugins[data.id] = _defaultIssuePlugin.DefaultIssuePlugin;
	          } else {
	            this.plugins[data.id] = _defaultPlugin.DefaultPlugin;
	          }
	        }
	        console.info('[plugins] Loaded ' + data.id + ' as {' + this.plugins[data.id].name + '}');
	        callback(this.get(data));
	      }).bind(this);
	
	      if (remainingAssets === 0) {
	        finishLoad();
	        return;
	      }
	
	      var onAssetLoaded = function onAssetLoaded(asset) {
	        remainingAssets--;
	        if (remainingAssets === 0) {
	          finishLoad();
	        }
	      };
	
	      var onAssetFailed = function onAssetFailed(asset) {
	        remainingAssets--;
	        console.error('[plugins] Failed to load asset ' + asset.url);
	        if (remainingAssets === 0) {
	          finishLoad();
	        }
	      };
	
	      // TODO(dcramer): what do we do on failed asset loading?
	      data.assets.forEach(function (asset) {
	        if (!(0, _utils.defined)(_this2.assetCache[asset.url])) {
	          console.info('[plugins] Loading asset for ' + data.id + ': ' + asset.url);
	          var s = document.createElement('script');
	          s.src = asset.url;
	          s.onload = onAssetLoaded.bind(_this2, asset);
	          s.onerror = onAssetFailed.bind(_this2, asset);
	          s.async = true;
	          document.body.appendChild(s);
	          _this2.assetCache[asset.url] = s;
	        } else {
	          onAssetLoaded(asset);
	        }
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(data) {
	      var cls = this.plugins[data.id];
	      if (!(0, _utils.defined)(cls)) {
	        throw new Error('Attempted to ``get`` an unloaded plugin: ' + data.id);
	      }
	      return new cls(data);
	    }
	  }, {
	    key: 'add',
	    value: function add(id, cls) {
	      this.plugins[id] = cls;
	    }
	  }]);
	
	  return Registry;
	})();
	
	exports['default'] = Registry;
	module.exports = exports['default'];

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _storesHookStore = __webpack_require__(90);
	
	var _storesHookStore2 = _interopRequireDefault(_storesHookStore);
	
	var _viewsApiDashboard = __webpack_require__(636);
	
	var _viewsApiDashboard2 = _interopRequireDefault(_viewsApiDashboard);
	
	var _viewsApiNewToken = __webpack_require__(637);
	
	var _viewsApiNewToken2 = _interopRequireDefault(_viewsApiNewToken);
	
	var _viewsAdmin = __webpack_require__(627);
	
	var _viewsAdmin2 = _interopRequireDefault(_viewsAdmin);
	
	var _viewsAdminBuffer = __webpack_require__(628);
	
	var _viewsAdminBuffer2 = _interopRequireDefault(_viewsAdminBuffer);
	
	var _viewsAdminOrganizations = __webpack_require__(629);
	
	var _viewsAdminOrganizations2 = _interopRequireDefault(_viewsAdminOrganizations);
	
	var _viewsAdminOverview = __webpack_require__(632);
	
	var _viewsAdminOverview2 = _interopRequireDefault(_viewsAdminOverview);
	
	var _viewsAdminProjects = __webpack_require__(633);
	
	var _viewsAdminProjects2 = _interopRequireDefault(_viewsAdminProjects);
	
	var _viewsAdminSettings = __webpack_require__(634);
	
	var _viewsAdminSettings2 = _interopRequireDefault(_viewsAdminSettings);
	
	var _viewsAdminUsers = __webpack_require__(635);
	
	var _viewsAdminUsers2 = _interopRequireDefault(_viewsAdminUsers);
	
	var _viewsApp = __webpack_require__(638);
	
	var _viewsApp2 = _interopRequireDefault(_viewsApp);
	
	var _viewsGroupActivity = __webpack_require__(639);
	
	var _viewsGroupActivity2 = _interopRequireDefault(_viewsGroupActivity);
	
	var _viewsGroupDetails = __webpack_require__(640);
	
	var _viewsGroupDetails2 = _interopRequireDefault(_viewsGroupDetails);
	
	var _viewsGroupEventDetails = __webpack_require__(645);
	
	var _viewsGroupEventDetails2 = _interopRequireDefault(_viewsGroupEventDetails);
	
	var _viewsGroupEvents = __webpack_require__(646);
	
	var _viewsGroupEvents2 = _interopRequireDefault(_viewsGroupEvents);
	
	var _viewsGroupHashes = __webpack_require__(647);
	
	var _viewsGroupHashes2 = _interopRequireDefault(_viewsGroupHashes);
	
	var _viewsGroupTags = __webpack_require__(649);
	
	var _viewsGroupTags2 = _interopRequireDefault(_viewsGroupTags);
	
	var _viewsGroupTagValues = __webpack_require__(648);
	
	var _viewsGroupTagValues2 = _interopRequireDefault(_viewsGroupTagValues);
	
	var _viewsGroupUserReports = __webpack_require__(650);
	
	var _viewsGroupUserReports2 = _interopRequireDefault(_viewsGroupUserReports);
	
	var _viewsMyIssuesAssignedToMe = __webpack_require__(652);
	
	var _viewsMyIssuesAssignedToMe2 = _interopRequireDefault(_viewsMyIssuesAssignedToMe);
	
	var _viewsMyIssuesBookmarked = __webpack_require__(653);
	
	var _viewsMyIssuesBookmarked2 = _interopRequireDefault(_viewsMyIssuesBookmarked);
	
	var _viewsMyIssuesViewed = __webpack_require__(654);
	
	var _viewsMyIssuesViewed2 = _interopRequireDefault(_viewsMyIssuesViewed);
	
	var _viewsOrganizationAuditLog = __webpack_require__(655);
	
	var _viewsOrganizationAuditLog2 = _interopRequireDefault(_viewsOrganizationAuditLog);
	
	var _viewsOrganizationDashboard = __webpack_require__(656);
	
	var _viewsOrganizationDashboard2 = _interopRequireDefault(_viewsOrganizationDashboard);
	
	var _viewsOrganizationDetails = __webpack_require__(657);
	
	var _viewsOrganizationDetails2 = _interopRequireDefault(_viewsOrganizationDetails);
	
	var _viewsOrganizationRateLimits = __webpack_require__(658);
	
	var _viewsOrganizationRateLimits2 = _interopRequireDefault(_viewsOrganizationRateLimits);
	
	var _viewsOrganizationRepositories = __webpack_require__(659);
	
	var _viewsOrganizationRepositories2 = _interopRequireDefault(_viewsOrganizationRepositories);
	
	var _viewsOrganizationStats = __webpack_require__(660);
	
	var _viewsOrganizationStats2 = _interopRequireDefault(_viewsOrganizationStats);
	
	var _viewsOrganizationTeams = __webpack_require__(665);
	
	var _viewsOrganizationTeams2 = _interopRequireDefault(_viewsOrganizationTeams);
	
	var _viewsOrganizationTeamsAllTeamsList = __webpack_require__(662);
	
	var _viewsOrganizationTeamsAllTeamsList2 = _interopRequireDefault(_viewsOrganizationTeamsAllTeamsList);
	
	var _viewsProjectAlertSettings = __webpack_require__(668);
	
	var _viewsProjectAlertSettings2 = _interopRequireDefault(_viewsProjectAlertSettings);
	
	var _viewsProjectAlertRules = __webpack_require__(667);
	
	var _viewsProjectAlertRules2 = _interopRequireDefault(_viewsProjectAlertRules);
	
	var _viewsProjectChooser = __webpack_require__(669);
	
	var _viewsProjectChooser2 = _interopRequireDefault(_viewsProjectChooser);
	
	var _viewsProjectCspSettings = __webpack_require__(670);
	
	var _viewsProjectCspSettings2 = _interopRequireDefault(_viewsProjectCspSettings);
	
	var _viewsProjectDashboard = __webpack_require__(671);
	
	var _viewsProjectDashboard2 = _interopRequireDefault(_viewsProjectDashboard);
	
	var _viewsProjectDetails = __webpack_require__(676);
	
	var _viewsProjectDetails2 = _interopRequireDefault(_viewsProjectDetails);
	
	var _viewsProjectEvents = __webpack_require__(677);
	
	var _viewsProjectEvents2 = _interopRequireDefault(_viewsProjectEvents);
	
	var _viewsProjectFilters = __webpack_require__(678);
	
	var _viewsProjectFilters2 = _interopRequireDefault(_viewsProjectFilters);
	
	var _viewsProjectInstallGettingStarted = __webpack_require__(679);
	
	var _viewsProjectInstallGettingStarted2 = _interopRequireDefault(_viewsProjectInstallGettingStarted);
	
	var _viewsProjectInstallDocsContext = __webpack_require__(308);
	
	var _viewsProjectInstallDocsContext2 = _interopRequireDefault(_viewsProjectInstallDocsContext);
	
	var _viewsProjectInstallOverview = __webpack_require__(681);
	
	var _viewsProjectInstallOverview2 = _interopRequireDefault(_viewsProjectInstallOverview);
	
	var _viewsProjectInstallPlatform = __webpack_require__(682);
	
	var _viewsProjectInstallPlatform2 = _interopRequireDefault(_viewsProjectInstallPlatform);
	
	var _viewsProjectReleases = __webpack_require__(684);
	
	var _viewsProjectReleases2 = _interopRequireDefault(_viewsProjectReleases);
	
	var _viewsProjectSavedSearches = __webpack_require__(686);
	
	var _viewsProjectSavedSearches2 = _interopRequireDefault(_viewsProjectSavedSearches);
	
	var _viewsProjectDebugSymbols = __webpack_require__(675);
	
	var _viewsProjectDebugSymbols2 = _interopRequireDefault(_viewsProjectDebugSymbols);
	
	var _viewsProjectSettings = __webpack_require__(687);
	
	var _viewsProjectSettings2 = _interopRequireDefault(_viewsProjectSettings);
	
	var _viewsProjectUserReports = __webpack_require__(689);
	
	var _viewsProjectUserReports2 = _interopRequireDefault(_viewsProjectUserReports);
	
	var _viewsProjectUserReportSettings = __webpack_require__(688);
	
	var _viewsProjectUserReportSettings2 = _interopRequireDefault(_viewsProjectUserReportSettings);
	
	var _viewsReleaseAllEvents = __webpack_require__(690);
	
	var _viewsReleaseAllEvents2 = _interopRequireDefault(_viewsReleaseAllEvents);
	
	var _viewsReleaseArtifacts = __webpack_require__(691);
	
	var _viewsReleaseArtifacts2 = _interopRequireDefault(_viewsReleaseArtifacts);
	
	var _viewsReleaseDetails = __webpack_require__(692);
	
	var _viewsReleaseDetails2 = _interopRequireDefault(_viewsReleaseDetails);
	
	var _viewsReleaseNewEvents = __webpack_require__(693);
	
	var _viewsReleaseNewEvents2 = _interopRequireDefault(_viewsReleaseNewEvents);
	
	var _viewsRouteNotFound = __webpack_require__(695);
	
	var _viewsRouteNotFound2 = _interopRequireDefault(_viewsRouteNotFound);
	
	var _viewsSharedGroupDetails = __webpack_require__(699);
	
	var _viewsSharedGroupDetails2 = _interopRequireDefault(_viewsSharedGroupDetails);
	
	var _viewsStream = __webpack_require__(701);
	
	var _viewsStream2 = _interopRequireDefault(_viewsStream);
	
	var _viewsTeamDetails = __webpack_require__(711);
	
	var _viewsTeamDetails2 = _interopRequireDefault(_viewsTeamDetails);
	
	var _viewsTeamMembers = __webpack_require__(712);
	
	var _viewsTeamMembers2 = _interopRequireDefault(_viewsTeamMembers);
	
	var _viewsTeamSettings = __webpack_require__(713);
	
	var _viewsTeamSettings2 = _interopRequireDefault(_viewsTeamSettings);
	
	var _viewsRequiredAdminActionsSetCallsigns = __webpack_require__(310);
	
	var _viewsRequiredAdminActionsSetCallsigns2 = _interopRequireDefault(_viewsRequiredAdminActionsSetCallsigns);
	
	var _utilsErrorHandler = __webpack_require__(304);
	
	var _utilsErrorHandler2 = _interopRequireDefault(_utilsErrorHandler);
	
	function appendTrailingSlash(nextState, replaceState) {
	  var lastChar = nextState.location.pathname.slice(-1);
	  if (lastChar !== '/') {
	    replaceState(nextState, nextState.location.pathname + '/');
	  }
	}
	
	function routes() {
	  var hooksRoutes = [];
	  _storesHookStore2['default'].get('routes').forEach(function (cb) {
	    hooksRoutes.push(cb());
	  });
	
	  var hooksAdminRoutes = [];
	  _storesHookStore2['default'].get('routes:admin').forEach(function (cb) {
	    hooksAdminRoutes.push(cb());
	  });
	
	  var hooksOrgRoutes = [];
	  _storesHookStore2['default'].get('routes:organization').forEach(function (cb) {
	    hooksOrgRoutes.push(cb());
	  });
	
	  return _react2['default'].createElement(
	    _reactRouter.Route,
	    { path: '/', component: (0, _utilsErrorHandler2['default'])(_viewsApp2['default']) },
	    _react2['default'].createElement(_reactRouter.Route, { path: '/api/', component: (0, _utilsErrorHandler2['default'])(_viewsApiDashboard2['default']) }),
	    _react2['default'].createElement(_reactRouter.Route, { path: '/api/new-token/', component: (0, _utilsErrorHandler2['default'])(_viewsApiNewToken2['default']) }),
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { path: '/manage/', component: (0, _utilsErrorHandler2['default'])(_viewsAdmin2['default']) },
	      _react2['default'].createElement(_reactRouter.IndexRoute, { component: (0, _utilsErrorHandler2['default'])(_viewsAdminOverview2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'buffer/', component: (0, _utilsErrorHandler2['default'])(_viewsAdminBuffer2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'organizations/', component: (0, _utilsErrorHandler2['default'])(_viewsAdminOrganizations2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'projects/', component: (0, _utilsErrorHandler2['default'])(_viewsAdminProjects2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'settings/', component: (0, _utilsErrorHandler2['default'])(_viewsAdminSettings2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: 'users/', component: (0, _utilsErrorHandler2['default'])(_viewsAdminUsers2['default']) }),
	      hooksAdminRoutes
	    ),
	    _react2['default'].createElement(_reactRouter.Redirect, { from: '/share/group/:shareId/', to: '/share/issue/:shareId/' }),
	    _react2['default'].createElement(_reactRouter.Route, { path: '/share/issue/:shareId/', component: (0, _utilsErrorHandler2['default'])(_viewsSharedGroupDetails2['default']) }),
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { path: '/:orgId/', component: (0, _utilsErrorHandler2['default'])(_viewsOrganizationDetails2['default']) },
	      _react2['default'].createElement(_reactRouter.IndexRoute, { component: (0, _utilsErrorHandler2['default'])(_viewsOrganizationDashboard2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/organizations/:orgId/audit-log/', component: (0, _utilsErrorHandler2['default'])(_viewsOrganizationAuditLog2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/organizations/:orgId/repos/', component: (0, _utilsErrorHandler2['default'])(_viewsOrganizationRepositories2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/organizations/:orgId/teams/', component: (0, _utilsErrorHandler2['default'])(_viewsOrganizationTeams2['default']) }),
	      _react2['default'].createElement(
	        _reactRouter.Route,
	        { path: '/organizations/:orgId/teams/:teamId/', component: (0, _utilsErrorHandler2['default'])(_viewsTeamDetails2['default']) },
	        _react2['default'].createElement(_reactRouter.IndexRedirect, { to: 'settings/' }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'settings/', component: (0, _utilsErrorHandler2['default'])(_viewsTeamSettings2['default']) }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'members/', component: (0, _utilsErrorHandler2['default'])(_viewsTeamMembers2['default']) })
	      ),
	      _react2['default'].createElement(
	        _reactRouter.Route,
	        { path: '/organizations/:orgId/all-teams/', component: (0, _utilsErrorHandler2['default'])(_viewsOrganizationTeams2['default']) },
	        _react2['default'].createElement(_reactRouter.IndexRoute, { component: (0, _utilsErrorHandler2['default'])(_viewsOrganizationTeamsAllTeamsList2['default']) })
	      ),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/organizations/:orgId/issues/assigned/', component: (0, _utilsErrorHandler2['default'])(_viewsMyIssuesAssignedToMe2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/organizations/:orgId/issues/bookmarks/', component: (0, _utilsErrorHandler2['default'])(_viewsMyIssuesBookmarked2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/organizations/:orgId/issues/history/', component: (0, _utilsErrorHandler2['default'])(_viewsMyIssuesViewed2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/organizations/:orgId/projects/choose/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectChooser2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/organizations/:orgId/rate-limits/', component: (0, _utilsErrorHandler2['default'])(_viewsOrganizationRateLimits2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/organizations/:orgId/stats/', component: (0, _utilsErrorHandler2['default'])(_viewsOrganizationStats2['default']) }),
	      _react2['default'].createElement(_reactRouter.Route, { path: '/organizations/:orgId/actions/set-callsigns/', component: (0, _utilsErrorHandler2['default'])(_viewsRequiredAdminActionsSetCallsigns2['default']) }),
	      hooksOrgRoutes,
	      _react2['default'].createElement(
	        _reactRouter.Route,
	        { path: ':projectId/getting-started/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectInstallGettingStarted2['default']) },
	        _react2['default'].createElement(_reactRouter.IndexRoute, { component: (0, _utilsErrorHandler2['default'])(_viewsProjectInstallOverview2['default']) }),
	        _react2['default'].createElement(_reactRouter.Route, { path: ':platform/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectInstallPlatform2['default']) })
	      ),
	      _react2['default'].createElement(
	        _reactRouter.Route,
	        { path: ':projectId/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectDetails2['default']) },
	        _react2['default'].createElement(_reactRouter.IndexRoute, { component: (0, _utilsErrorHandler2['default'])(_viewsStream2['default']) }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'searches/:searchId/', component: (0, _utilsErrorHandler2['default'])(_viewsStream2['default']) }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'dashboard/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectDashboard2['default']) }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'events/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectEvents2['default']) }),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'releases/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectReleases2['default']) }),
	        _react2['default'].createElement(
	          _reactRouter.Route,
	          { name: 'releaseDetails', path: 'releases/:version/', component: (0, _utilsErrorHandler2['default'])(_viewsReleaseDetails2['default']) },
	          _react2['default'].createElement(_reactRouter.IndexRoute, { component: (0, _utilsErrorHandler2['default'])(_viewsReleaseNewEvents2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'all-events/', component: (0, _utilsErrorHandler2['default'])(_viewsReleaseAllEvents2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'artifacts/', component: (0, _utilsErrorHandler2['default'])(_viewsReleaseArtifacts2['default']) })
	        ),
	        _react2['default'].createElement(_reactRouter.Route, { path: 'user-feedback/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectUserReports2['default']) }),
	        _react2['default'].createElement(
	          _reactRouter.Route,
	          { path: 'settings/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectSettings2['default']) },
	          _react2['default'].createElement(_reactRouter.Route, { path: 'alerts/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectAlertSettings2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'alerts/rules/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectAlertRules2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'filters/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectFilters2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'saved-searches/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectSavedSearches2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'debug-symbols/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectDebugSymbols2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'user-feedback/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectUserReportSettings2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'csp/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectCspSettings2['default']) }),
	          _react2['default'].createElement(
	            _reactRouter.Route,
	            { path: 'install/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectInstallDocsContext2['default']) },
	            _react2['default'].createElement(_reactRouter.IndexRoute, { component: (0, _utilsErrorHandler2['default'])(_viewsProjectInstallOverview2['default']) }),
	            _react2['default'].createElement(_reactRouter.Route, { path: ':platform/', component: (0, _utilsErrorHandler2['default'])(_viewsProjectInstallPlatform2['default']) })
	          )
	        ),
	        _react2['default'].createElement(_reactRouter.Redirect, { from: 'group/:groupId/', to: 'issues/:groupId/' }),
	        _react2['default'].createElement(
	          _reactRouter.Route,
	          { path: 'issues/:groupId/', component: (0, _utilsErrorHandler2['default'])(_viewsGroupDetails2['default']),
	            ignoreScrollBehavior: true },
	          _react2['default'].createElement(_reactRouter.IndexRoute, { component: (0, _utilsErrorHandler2['default'])(_viewsGroupEventDetails2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'activity/', component: (0, _utilsErrorHandler2['default'])(_viewsGroupActivity2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'events/:eventId/', component: (0, _utilsErrorHandler2['default'])(_viewsGroupEventDetails2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'events/', component: (0, _utilsErrorHandler2['default'])(_viewsGroupEvents2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'hashes/', component: (0, _utilsErrorHandler2['default'])(_viewsGroupHashes2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'tags/', component: (0, _utilsErrorHandler2['default'])(_viewsGroupTags2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'tags/:tagKey/', component: (0, _utilsErrorHandler2['default'])(_viewsGroupTagValues2['default']) }),
	          _react2['default'].createElement(_reactRouter.Route, { path: 'feedback/', component: (0, _utilsErrorHandler2['default'])(_viewsGroupUserReports2['default']) })
	        )
	      )
	    ),
	    hooksRoutes,
	    _react2['default'].createElement(_reactRouter.Route, { path: '*', component: (0, _utilsErrorHandler2['default'])(_viewsRouteNotFound2['default']), onEnter: appendTrailingSlash })
	  );
	}
	
	exports['default'] = routes;
	module.exports = exports['default'];

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _actionsAlertActions = __webpack_require__(62);
	
	var _actionsAlertActions2 = _interopRequireDefault(_actionsAlertActions);
	
	var _utilsLocalStorage = __webpack_require__(306);
	
	var _utils = __webpack_require__(7);
	
	var AlertStore = _reflux2['default'].createStore({
	  listenables: _actionsAlertActions2['default'],
	
	  init: function init() {
	    this.alerts = [];
	    this.count = 0;
	  },
	
	  onAddAlert: function onAddAlert(alert) {
	    var _this = this;
	
	    if ((0, _utils.defined)(alert.id)) {
	      var expirations = (0, _utilsLocalStorage.getItem)('alerts:muted');
	      if ((0, _utils.defined)(expirations)) {
	        expirations = JSON.parse(expirations);
	
	        // Remove any objects that have passed their mute duration.
	        var now = Math.floor(new Date() / 1000);
	        for (var key in expirations) {
	          if (expirations.hasOwnProperty(key) && expirations[key] < now) {
	            delete expirations[key];
	          }
	        }
	        (0, _utilsLocalStorage.setItem)('alerts:muted', JSON.stringify(expirations));
	
	        if (expirations.hasOwnProperty(alert.id)) {
	          return;
	        }
	      }
	    } else {
	      if (!(0, _utils.defined)(alert.expireAfter)) {
	        alert.expireAfter = 5000;
	      }
	    }
	
	    if (alert.expireAfter) {
	      window.setTimeout(function () {
	        _this.onCloseAlert(alert);
	      }, alert.expireAfter);
	    }
	
	    alert.key = this.count++;
	
	    // intentionally recreate array via concat because of Reflux
	    // "bug" where React components are given same reference to tracked
	    // data objects, and don't *see* that values have changed
	    this.alerts = this.alerts.concat([alert]);
	    this.trigger(this.alerts);
	  },
	
	  onCloseAlert: function onCloseAlert(alert) {
	    var duration = arguments.length <= 1 || arguments[1] === undefined ? 60 * 60 * 7 * 24 : arguments[1];
	
	    if ((0, _utils.defined)(alert.id) && (0, _utils.defined)(duration)) {
	      var expiry = Math.floor(new Date() / 1000) + duration;
	      var expirations = (0, _utilsLocalStorage.getItem)('alerts:muted');
	      if ((0, _utils.defined)(expirations)) {
	        expirations = JSON.parse(expirations);
	      } else {
	        expirations = {};
	      }
	      expirations[alert.id] = expiry;
	      (0, _utilsLocalStorage.setItem)('alerts:muted', JSON.stringify(expirations));
	    }
	
	    // TODO(dcramer): we need some animations here for closing alerts
	    this.alerts = this.alerts.filter(function (item) {
	      return alert !== item;
	    });
	    this.trigger(this.alerts);
	  }
	});
	
	exports['default'] = AlertStore;
	module.exports = exports['default'];

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _actionsIncidentActions = __webpack_require__(263);
	
	var _actionsIncidentActions2 = _interopRequireDefault(_actionsIncidentActions);
	
	var IncidentStore = _reflux2['default'].createStore({
	  init: function init() {
	    this.reset();
	
	    this.listenTo(_actionsIncidentActions2['default'].updateSuccess, this.onUpdateSuccess);
	  },
	
	  reset: function reset() {
	    this.status = {};
	  },
	
	  onUpdateSuccess: function onUpdateSuccess(data) {
	    this.status = data.status;
	    this.trigger(this.status);
	  },
	
	  getStatus: function getStatus() {
	    return this.status;
	  }
	});
	
	exports['default'] = IncidentStore;
	module.exports = exports['default'];

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	// zh-cn => zh_CN
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	exports.getTranslations = getTranslations;
	exports.translationsExist = translationsExist;
	function convertToDjangoLocaleFormat(language) {
	  var _language$split = language.split('-');
	
	  var _language$split2 = _slicedToArray(_language$split, 2);
	
	  var left = _language$split2[0];
	  var right = _language$split2[1];
	
	  return left + (right ? '_' + right.toUpperCase() : '');
	}
	
	function getTranslations(language) {
	  language = convertToDjangoLocaleFormat(language);
	  return __webpack_require__(412)("./" + language + '/LC_MESSAGES/django.po');
	}
	
	function translationsExist(language) {
	  language = convertToDjangoLocaleFormat(language);
	  try {
	    __webpack_require__(412)("./" + language + '/LC_MESSAGES/django.po');
	  } catch (e) {
	    return false;
	  }
	  return true;
	}

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var defaults = {
	  limit: null,
	  key: function key(item) {
	    return item.id;
	  }
	};
	
	function Collection(collection, options) {
	  var i = undefined;
	
	  Array.call(this);
	
	  if (_underscore2['default'].isUndefined(options)) {
	    options = {};
	  }
	
	  for (i in defaults) {
	    if (_underscore2['default'].isUndefined(options[i])) {
	      options[i] = defaults[i];
	    }
	  }
	
	  this.options = options;
	
	  if (!_underscore2['default'].isUndefined(collection)) {
	    this.push(collection);
	  }
	
	  return this;
	}
	
	Collection.prototype = [];
	
	Collection.prototype.constructor = Collection;
	
	Collection.prototype._refresh = function _refresh() {
	  if (this.options.limit && this.length > this.options.limit) {
	    this.splice(this.options.limit, this.length - this.options.limit);
	  }
	};
	
	Collection.prototype.push = function push(items) {
	  if (!_underscore2['default'].isArray(items)) {
	    items = [items];
	  }
	
	  items.forEach((function (item) {
	    var existing = this.pop(item);
	    if (existing) {
	      $.extend(true, existing, item);
	      item = existing;
	    }
	    Array.prototype.push.apply(this, [item]);
	  }).bind(this));
	  this._refresh();
	  return this;
	};
	
	Collection.prototype.unshift = function unshift(items) {
	  if (!_underscore2['default'].isArray(items)) {
	    items = [items];
	  }
	  items.reverse().forEach((function (item) {
	    var existing = this.pop(item);
	    if (existing) {
	      $.extend(true, existing, item);
	      item = existing;
	    }
	    Array.prototype.unshift.apply(this, [item]);
	  }).bind(this));
	  this._refresh();
	  return this;
	};
	
	Collection.prototype.get = function get(key) {
	  var idx = this.indexOf(key);
	  if (idx === -1) {
	    return null;
	  }
	  return this[idx];
	};
	
	Collection.prototype.pop = function pop(item) {
	  var idx = this.indexOf(this.options.key(item));
	  if (idx === -1) {
	    return null;
	  }
	  var result = this[idx];
	  this.splice(idx, idx + 1);
	  return result;
	};
	
	Collection.prototype.empty = function empty() {
	  this.splice(0, 0);
	};
	
	Collection.prototype.indexOf = function indexOf(key) {
	  var keyFunc = this.options.key;
	  for (var i = 0; i < this.length; i++) {
	    if (keyFunc(this[i]) === key) {
	      return i;
	    }
	  }
	  return -1;
	};
	
	Collection.prototype.update = function update(item) {
	  // returns true if the item already existed and was updated (as configured)
	  var existing = this.indexOf(this.options.key(item));
	  if (existing !== -1) {
	    $.extend(true, this[existing], item);
	    return true;
	  }
	  return false;
	};
	
	exports['default'] = Collection;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	exports['default'] = function (node) {
	  var el = document.createElement('div');
	  _reactDom2['default'].render(node, el);
	  return el.innerHTML;
	};
	
	module.exports = exports['default'];

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _api = __webpack_require__(131);
	
	var _parseLinkHeader = __webpack_require__(195);
	
	var _parseLinkHeader2 = _interopRequireDefault(_parseLinkHeader);
	
	var CursorPoller = (function () {
	  function CursorPoller(options) {
	    _classCallCheck(this, CursorPoller);
	
	    this.api = new _api.Client();
	    this.options = options;
	    this._timeoutId = null;
	    this._active = true;
	    this._baseDelay = 3000;
	    this._maxDelay = 60000;
	    this._reqsWithoutData = 0;
	    this._pollingEndpoint = options.endpoint;
	  }
	
	  _createClass(CursorPoller, [{
	    key: 'getDelay',
	    value: function getDelay() {
	      var delay = this._baseDelay * (this._reqsWithoutData + 1);
	      return Math.min(delay, this._maxDelay);
	    }
	  }, {
	    key: 'setEndpoint',
	    value: function setEndpoint(url) {
	      this._pollingEndpoint = url;
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      this._active = true;
	      if (!this._timeoutId) {
	        this._timeoutId = window.setTimeout(this.poll.bind(this), this.getDelay());
	      }
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this._active = false;
	      if (this._timeoutId) {
	        window.clearTimeout(this._timeoutId);
	        this._timeoutId = null;
	      }
	
	      if (this._lastRequest) {
	        this._lastRequest.cancel();
	      }
	    }
	  }, {
	    key: 'poll',
	    value: function poll() {
	      var _this = this;
	
	      this._lastRequest = this.api.request(this._pollingEndpoint, {
	        success: function success(data, _, jqXHR) {
	          // cancel in progress operation if disabled
	          if (!_this._active) {
	            return;
	          }
	
	          // if theres no data, nothing changes
	          if (!data.length) {
	            _this._reqsWithoutData += 1;
	            return;
	          }
	
	          if (_this._reqsWithoutData > 0) {
	            _this._reqsWithoutData -= 1;
	          }
	
	          var links = (0, _parseLinkHeader2['default'])(jqXHR.getResponseHeader('Link'));
	          _this._pollingEndpoint = links.previous.href;
	
	          _this.options.success(data, jqXHR.getResponseHeader('Link'));
	        },
	        complete: function complete() {
	          _this._lastRequest = null;
	
	          if (_this._active) {
	            _this._timeoutId = window.setTimeout(_this.poll.bind(_this), _this.getDelay());
	          }
	        }
	      });
	    }
	  }]);
	
	  return CursorPoller;
	})();
	
	exports['default'] = CursorPoller;
	module.exports = exports['default'];

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _iosDeviceList = __webpack_require__(314);
	
	var _iosDeviceList2 = _interopRequireDefault(_iosDeviceList);
	
	exports['default'] = function (model) {
	  if (!model) {
	    return null;
	  }
	  var modelIdentifier = model.split(' ')[0];
	  var modelId = model.split(' ').splice(1).join(' ');
	  var modelName = _iosDeviceList2['default'].generationByIdentifier(modelIdentifier);
	  return modelName === undefined ? model : modelName + ' ' + modelId;
	};
	
	module.exports = exports['default'];

/***/ },
/* 624 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PendingChangeQueue = (function (_Array) {
	  _inherits(PendingChangeQueue, _Array);
	
	  function PendingChangeQueue() {
	    _classCallCheck(this, PendingChangeQueue);
	
	    _get(Object.getPrototypeOf(PendingChangeQueue.prototype), "constructor", this).call(this);
	    this.changes = [];
	  }
	
	  _createClass(PendingChangeQueue, [{
	    key: "clear",
	    value: function clear() {
	      this.changes = [];
	    }
	  }, {
	    key: "getForItem",
	    value: function getForItem(itemId) {
	      return this.changes.filter(function (change) {
	        return change[1] === itemId;
	      });
	    }
	  }, {
	    key: "push",
	    value: function push(changeId, itemId, data) {
	      this.changes.push([changeId, itemId, data]);
	    }
	  }, {
	    key: "remove",
	    value: function remove(changeId, itemId) {
	      this.changes = this.changes.filter(function (change) {
	        return change[0] != changeId || change[1] != itemId;
	      });
	    }
	  }]);
	
	  return PendingChangeQueue;
	})(Array);
	
	exports["default"] = PendingChangeQueue;
	module.exports = exports["default"];

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.queryToObj = queryToObj;
	exports.objToQuery = objToQuery;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	/**
	 * Converts a stream query to an object representation, with
	 * keys representing tag names, and the magic __text key
	 * representing the text component of the search.
	 *
	 * Example:
	 *
	 * "python is:unresolved assigned:foo@bar.com"
	 * => {
	 *      __text: "python",
	 *      is: "unresolved",
	 *      assigned: "foo@bar.com"
	 *    }
	 */
	
	function queryToObj(queryStr) {
	  var text = [];
	
	  var queryItems = queryStr.match(/\S+:"[^"]*"?|\S+/g);
	  var queryObj = _underscore2['default'].inject(queryItems, function (obj, item) {
	    var index = item.indexOf(':');
	    if (index === -1) {
	      text.push(item);
	    } else {
	      var tagKey = item.slice(0, index);
	      var value = item.slice(index + 1).replace(/^"|"$/g, '');
	      obj[tagKey] = value;
	    }
	    return obj;
	  }, {});
	
	  if (text.length) queryObj.__text = text.join(' ');
	
	  return queryObj;
	}
	
	/**
	 * Converts an object representation of a stream query to a string
	 * (consumable by the Sentry stream HTTP API).
	 */
	
	function objToQuery(queryObj) {
	  var tags = _underscore2['default'].omit(queryObj, '__text');
	
	  var parts = _underscore2['default'].map(tags, function (value, tagKey) {
	    if (value.indexOf(' ') > -1) value = '"' + value + '"';
	
	    return tagKey + ':' + value;
	  });
	
	  if (queryObj.__text) parts.push(queryObj.__text);
	
	  return parts.join(' ');
	}

/***/ },
/* 626 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var removeFromList = function removeFromList(item, list) {
	  var idx = list.indexOf(item);
	
	  if (idx !== -1) {
	    list.splice(idx, 1);
	  }
	};
	
	var StreamManager = (function () {
	  // TODO(dcramer): this should listen to changes on GroupStore and remove
	  // items that are removed there
	
	  function StreamManager(store) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    _classCallCheck(this, StreamManager);
	
	    this.idList = [];
	    this.store = store;
	    this.limit = options.limit || 1000;
	  }
	
	  _createClass(StreamManager, [{
	    key: 'trim',
	    value: function trim() {
	      var excess = this.idList.splice(this.limit, this.idList.length - this.limit);
	      excess.forEach(this.store.remove);
	    }
	  }, {
	    key: 'push',
	    value: function push() {
	      var _this = this;
	
	      var items = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	      items = [].concat(items);
	      if (items.length === 0) return this;
	
	      items = items.filter(function (item) {
	        return item.hasOwnProperty('id');
	      });
	
	      items.forEach(function (item) {
	        return removeFromList(item.id, _this.idList);
	      });
	      var ids = items.map(function (item) {
	        return item.id;
	      });
	      this.idList = [].concat(this.idList, ids);
	
	      this.trim();
	      this.store.add(items);
	      return this;
	    }
	  }, {
	    key: 'getAllItems',
	    value: function getAllItems() {
	      var _this2 = this;
	
	      return this.store.getAllItems().slice().sort(function (a, b) {
	        return _this2.idList.indexOf(a.id) - _this2.idList.indexOf(b.id);
	      });
	    }
	  }, {
	    key: 'unshift',
	    value: function unshift() {
	      var _this3 = this;
	
	      var items = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	      items = [].concat(items);
	      if (items.length === 0) return this;
	
	      items.forEach(function (item) {
	        return removeFromList(item.id, _this3.idList);
	      });
	      var ids = items.map(function (item) {
	        return item.id;
	      });
	      this.idList = [].concat(ids, this.idList);
	
	      this.trim();
	      this.store.add(items);
	      return this;
	    }
	  }]);
	
	  return StreamManager;
	})();
	
	exports['default'] = StreamManager;
	module.exports = exports['default'];

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint getsentry/jsx-needs-il8n:0*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsFooter = __webpack_require__(105);
	
	var _componentsFooter2 = _interopRequireDefault(_componentsFooter);
	
	var _componentsSidebar = __webpack_require__(137);
	
	var _componentsSidebar2 = _interopRequireDefault(_componentsSidebar);
	
	var _storesHookStore = __webpack_require__(90);
	
	var _storesHookStore2 = _interopRequireDefault(_storesHookStore);
	
	var _componentsListLink = __webpack_require__(47);
	
	var _componentsListLink2 = _interopRequireDefault(_componentsListLink);
	
	var Admin = _react2['default'].createClass({
	  displayName: 'Admin',
	
	  getInitialState: function getInitialState() {
	    // Allow injection via getsentry et all
	    var hooksManage = [];
	    _storesHookStore2['default'].get('admin:sidebar:manage').forEach(function (cb) {
	      hooksManage.push(cb());
	    });
	
	    return {
	      hooksManage: hooksManage
	    };
	  },
	
	  getTitle: function getTitle() {
	    return 'Sentry Admin';
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { title: this.getTitle() },
	      _react2['default'].createElement(
	        'div',
	        { className: 'app' },
	        _react2['default'].createElement(_componentsSidebar2['default'], null),
	        _react2['default'].createElement(
	          'div',
	          { className: 'container' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'content' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'row' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-md-2' },
	                _react2['default'].createElement(
	                  'h6',
	                  { className: 'nav-header' },
	                  'System'
	                ),
	                _react2['default'].createElement(
	                  'ul',
	                  { className: 'nav nav-stacked' },
	                  _react2['default'].createElement(
	                    _componentsListLink2['default'],
	                    { index: true, to: '/manage/' },
	                    'Overview'
	                  ),
	                  _react2['default'].createElement(
	                    _componentsListLink2['default'],
	                    { index: true, to: '/manage/buffer/' },
	                    'Buffer'
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                      'a',
	                      { href: '/manage/queue/' },
	                      'Queue'
	                    )
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                      'a',
	                      { href: '/manage/status/environment/' },
	                      'Environment'
	                    )
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                      'a',
	                      { href: '/manage/status/packages/' },
	                      'Packages'
	                    )
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                      'a',
	                      { href: '/manage/status/mail/' },
	                      'Mail'
	                    )
	                  ),
	                  _react2['default'].createElement(
	                    _componentsListLink2['default'],
	                    { to: '/manage/settings/' },
	                    'Settings'
	                  ),
	                  _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                      'a',
	                      { href: '/manage/status/warnings/' },
	                      'Warnings'
	                    )
	                  )
	                ),
	                _react2['default'].createElement(
	                  'h6',
	                  { className: 'nav-header' },
	                  'Manage'
	                ),
	                _react2['default'].createElement(
	                  'ul',
	                  { className: 'nav nav-stacked' },
	                  _react2['default'].createElement(
	                    _componentsListLink2['default'],
	                    { to: '/manage/organizations/' },
	                    'Organizations'
	                  ),
	                  _react2['default'].createElement(
	                    _componentsListLink2['default'],
	                    { to: '/manage/projects/' },
	                    'Projects'
	                  ),
	                  _react2['default'].createElement(
	                    _componentsListLink2['default'],
	                    { to: '/manage/users/' },
	                    'Users'
	                  ),
	                  this.state.hooksManage
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'col-md-10' },
	                this.props.children
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(_componentsFooter2['default'], null)
	      )
	    );
	  }
	});
	
	exports['default'] = Admin;
	module.exports = exports['default'];

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint getsentry/jsx-needs-il8n:0*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsFlotChart = __webpack_require__(135);
	
	var _componentsFlotChart2 = _interopRequireDefault(_componentsFlotChart);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var InternalChart = _react2['default'].createClass({
	  displayName: 'InternalChart',
	
	  propTypes: {
	    since: _react2['default'].PropTypes.number.isRequired,
	    resolution: _react2['default'].PropTypes.string.isRequired,
	    stat: _react2['default'].PropTypes.string.isRequired,
	    label: _react2['default'].PropTypes.string
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      error: false,
	      loading: true,
	      data: null
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.api.request('/internal/stats/', {
	      method: 'GET',
	      data: {
	        since: this.props.since,
	        resolution: this.props.resolution,
	        key: this.props.stat
	      },
	      success: function success(data) {
	        _this.setState({
	          data: data,
	          loading: false,
	          error: false
	        });
	      },
	      error: function error(data) {
	        _this.setState({
	          error: true
	        });
	      }
	    });
	  },
	
	  getChartPoints: function getChartPoints() {
	    var points = this.state.data.map(function (point) {
	      return [point[0] * 1000, point[1]];
	    });
	
	    return [{
	      data: points,
	      label: this.props.label,
	      color: 'rgba(86, 175, 232, 1)',
	      shadowSize: 0,
	      stack: true,
	      lines: {
	        lineWidth: 2,
	        show: true,
	        fill: true
	      }
	    }];
	  },
	
	  render: function render() {
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	
	    return _react2['default'].createElement(_componentsFlotChart2['default'], { style: { height: 250 }, plotData: this.getChartPoints() });
	  }
	});
	
	var AdminBuffer = _react2['default'].createClass({
	  displayName: 'AdminBuffer',
	
	  getInitialState: function getInitialState() {
	    return {
	      since: new Date().getTime() / 1000 - 3600 * 24 * 7,
	      resolution: '1h'
	    };
	  },
	
	  render: function render() {
	    // TODO(dcramer): show buffer configuration when its moved into option store
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h3',
	        null,
	        'Buffers'
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h4',
	            null,
	            'About'
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            'Sentry buffers are responsible for making changes to cardinality counters — such as an issues event count — as well as updating attributes like ',
	            _react2['default'].createElement(
	              'em',
	              null,
	              'last seen'
	            ),
	            '. These are flushed on a regularly interval, and are directly affected by the queue backlog.'
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h4',
	            null,
	            'Updates Processed'
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          _react2['default'].createElement(InternalChart, { since: this.state.since,
	            resolution: this.state.resolution,
	            stat: 'jobs.finished.sentry.tasks.process_buffer.process_incr',
	            label: 'Jobs' })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h4',
	            null,
	            'Revoked Updates'
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          _react2['default'].createElement(InternalChart, { since: this.state.since,
	            resolution: this.state.resolution,
	            stat: 'buffer.revoked',
	            label: 'Jobs' })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = AdminBuffer;
	module.exports = exports['default'];

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable getsentry/jsx-needs-il8n */
	/* eslint-disable react/jsx-key */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _componentsResultGrid = __webpack_require__(188);
	
	var _componentsResultGrid2 = _interopRequireDefault(_componentsResultGrid);
	
	var _locale = __webpack_require__(2);
	
	var AdminOrganizations = _react2['default'].createClass({
	  displayName: 'AdminOrganizations',
	
	  getRow: function getRow(row) {
	    return [_react2['default'].createElement(
	      'td',
	      null,
	      _react2['default'].createElement(
	        'strong',
	        null,
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: '/' + row.slug + '/' },
	          row.name
	        )
	      ),
	      _react2['default'].createElement('br', null),
	      _react2['default'].createElement(
	        'small',
	        null,
	        row.slug
	      )
	    )];
	  },
	
	  render: function render() {
	    var columns = [_react2['default'].createElement(
	      'th',
	      null,
	      'Organization'
	    )];
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('Organizations')
	      ),
	      _react2['default'].createElement(_componentsResultGrid2['default'], _extends({
	        path: '/manage/organizations/',
	        endpoint: '/organizations/',
	        method: 'GET',
	        columns: columns,
	        columnsForRow: this.getRow,
	        hasSearch: true,
	        sortOptions: [['date', 'Date Joined'], ['members', 'Members'], ['events', 'Events'], ['projects', 'Projects'], ['employees', 'Employees']],
	        defaultSort: 'date'
	      }, this.props))
	    );
	  }
	});
	
	exports['default'] = AdminOrganizations;
	module.exports = exports['default'];

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsFlotChart = __webpack_require__(135);
	
	var _componentsFlotChart2 = _interopRequireDefault(_componentsFlotChart);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var ApiChart = _react2['default'].createClass({
	  displayName: 'ApiChart',
	
	  propTypes: {
	    since: _react2['default'].PropTypes.number.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      error: false,
	      loading: true,
	      rawData: {
	        'client-api.all-versions.responses.2xx': null,
	        'client-api.all-versions.responses.4xx': null,
	        'client-api.all-versions.responses.5xx': null
	      }
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var statNameList = ['client-api.all-versions.responses.2xx', 'client-api.all-versions.responses.4xx', 'client-api.all-versions.responses.5xx'];
	
	    statNameList.forEach(function (statName) {
	      _this.api.request('/internal/stats/', {
	        method: 'GET',
	        data: {
	          since: _this.props.since,
	          resolution: '1h',
	          key: statName
	        },
	        success: function success(data) {
	          _this.state.rawData[statName] = data;
	          _this.setState({
	            rawData: _this.state.rawData
	          }, _this.requestFinished);
	        },
	        error: function error(data) {
	          _this.setState({
	            error: true
	          });
	        }
	      });
	    });
	  },
	
	  requestFinished: function requestFinished() {
	    var rawData = this.state.rawData;
	
	    if (rawData['events.total'] && rawData['events.dropped']) {
	      this.processOrgData();
	    }
	    if (rawData['client-api.all-versions.responses.2xx'] && rawData['client-api.all-versions.responses.4xx'] && rawData['client-api.all-versions.responses.5xx']) {
	      this.setState({
	        loading: false
	      });
	    }
	  },
	
	  processRawSeries: function processRawSeries(series) {
	    return series.map(function (item) {
	      return [item[0] * 1000, item[1]];
	    });
	  },
	
	  getChartPoints: function getChartPoints() {
	    var rawData = this.state.rawData;
	
	    return [{
	      data: this.processRawSeries(rawData['client-api.all-versions.responses.4xx']),
	      color: 'rgb(86, 175, 232)',
	      shadowSize: 0,
	      label: '4xx',
	      stack: true,
	      lines: {
	        lineWidth: 2,
	        show: true,
	        fill: true
	      }
	    }, {
	      data: this.processRawSeries(rawData['client-api.all-versions.responses.5xx']),
	      color: 'rgb(244, 63, 32)',
	      shadowSize: 0,
	      label: '5xx',
	      stack: true,
	      lines: {
	        lineWidth: 2,
	        show: true,
	        fill: true
	      }
	    }, {
	      data: this.processRawSeries(rawData['client-api.all-versions.responses.2xx']),
	      label: '2xx',
	      color: 'rgb(78, 222, 73)',
	      shadowSize: 0,
	      stack: true,
	      lines: {
	        lineWidth: 2,
	        show: true,
	        fill: true
	      }
	    }];
	  },
	
	  render: function render() {
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	    return _react2['default'].createElement(_componentsFlotChart2['default'], { style: { height: 250 }, plotData: this.getChartPoints() });
	  }
	});
	
	exports['default'] = ApiChart;
	module.exports = exports['default'];

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsFlotChart = __webpack_require__(135);
	
	var _componentsFlotChart2 = _interopRequireDefault(_componentsFlotChart);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var EventChart = _react2['default'].createClass({
	  displayName: 'EventChart',
	
	  propTypes: {
	    since: _react2['default'].PropTypes.number.isRequired,
	    resolution: _react2['default'].PropTypes.string.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      error: false,
	      loading: true,
	      rawData: {
	        'events.total': null,
	        'events.dropped': null
	      },
	      stats: { received: [], rejected: [] },
	      systemTotal: { received: 0, rejected: 0, accepted: 0 }
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var statNameList = ['events.total', 'events.dropped'];
	
	    statNameList.forEach(function (statName) {
	      // query the organization stats via a separate call as its possible the project stats
	      // are too heavy
	      _this.api.request('/internal/stats/', {
	        method: 'GET',
	        data: {
	          since: _this.props.since,
	          resolution: _this.props.resolution,
	          key: statName
	        },
	        success: function success(data) {
	          _this.state.rawData[statName] = data;
	          _this.setState({
	            rawData: _this.state.rawData
	          }, _this.requestFinished);
	        },
	        error: function error(data) {
	          _this.setState({
	            error: true
	          });
	        }
	      });
	    });
	  },
	
	  requestFinished: function requestFinished() {
	    var rawData = this.state.rawData;
	
	    if (rawData['events.total'] && rawData['events.dropped']) {
	      this.processOrgData();
	    }
	  },
	
	  processOrgData: function processOrgData() {
	    var rawData = this.state.rawData;
	
	    var oReceived = 0;
	    var oRejected = 0;
	    var sReceived = {};
	    var sRejected = {};
	    var aReceived = [0, 0]; // received, points
	    _jquery2['default'].each(rawData['events.total'], function (idx, point) {
	      var dReceived = point[1];
	      var dRejected = rawData['events.dropped'][idx][1];
	      var ts = point[0] * 1000;
	      if (sReceived[ts] === undefined) {
	        sReceived[ts] = dReceived;
	        sRejected[ts] = dRejected;
	      } else {
	        sReceived[ts] += dReceived;
	        sRejected[ts] += dRejected;
	      }
	      oReceived += dReceived;
	      oRejected += dRejected;
	      if (dReceived > 0) {
	        aReceived[0] += dReceived;
	        aReceived[1] += 1;
	      }
	    });
	    this.setState({
	      systemTotal: {
	        received: oReceived,
	        rejected: oRejected,
	        accepted: oReceived - oRejected,
	        avgRate: parseInt(aReceived[0] / aReceived[1] / 60, 10)
	      },
	      stats: {
	        rejected: _jquery2['default'].map(sRejected, function (value, ts) {
	          return [[ts, value || null]];
	        }),
	        accepted: _jquery2['default'].map(sReceived, function (value, ts) {
	          // total number of events accepted (received - rejected)
	          return [[ts, value - sRejected[ts]]];
	        })
	      },
	      loading: false
	    });
	  },
	
	  getChartPoints: function getChartPoints() {
	    var stats = this.state.stats;
	
	    return [{
	      data: stats.accepted,
	      label: 'Accepted',
	      color: 'rgba(86, 175, 232, 1)',
	      shadowSize: 0,
	      stack: true,
	      lines: {
	        lineWidth: 2,
	        show: true,
	        fill: true
	      }
	    }, {
	      data: stats.rejected,
	      color: 'rgba(244, 63, 32, 1)',
	      shadowSize: 0,
	      label: 'Dropped',
	      stack: true,
	      lines: {
	        lineWidth: 2,
	        show: true,
	        fill: true
	      }
	    }];
	  },
	
	  render: function render() {
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	
	    return _react2['default'].createElement(_componentsFlotChart2['default'], { style: { height: 250 }, plotData: this.getChartPoints() });
	  }
	});
	
	exports['default'] = EventChart;
	module.exports = exports['default'];

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint getsentry/jsx-needs-il8n:0*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _apiChart = __webpack_require__(630);
	
	var _apiChart2 = _interopRequireDefault(_apiChart);
	
	var _eventChart = __webpack_require__(631);
	
	var _eventChart2 = _interopRequireDefault(_eventChart);
	
	var AdminOverview = _react2['default'].createClass({
	  displayName: 'AdminOverview',
	
	  getInitialState: function getInitialState() {
	    return {
	      since: new Date().getTime() / 1000 - 3600 * 24 * 7,
	      resolution: '1h'
	    };
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h3',
	        null,
	        'System Overview'
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h4',
	            null,
	            'Event Throughput',
	            _react2['default'].createElement('span', { id: 'rate', className: 'pull-right' })
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          _react2['default'].createElement(_eventChart2['default'], { since: this.state.since,
	            resolution: this.state.resolution })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h4',
	            null,
	            'API Responses'
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          _react2['default'].createElement(_apiChart2['default'], { since: this.state.since,
	            resolution: this.state.resolution })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = AdminOverview;
	module.exports = exports['default'];

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable getsentry/jsx-needs-il8n */
	/* eslint-disable react/jsx-key */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _componentsResultGrid = __webpack_require__(188);
	
	var _componentsResultGrid2 = _interopRequireDefault(_componentsResultGrid);
	
	var _locale = __webpack_require__(2);
	
	var prettyDate = function prettyDate(x) {
	  return (0, _moment2['default'])(x).format('ll');
	};
	
	exports.prettyDate = prettyDate;
	var AdminProjects = _react2['default'].createClass({
	  displayName: 'AdminProjects',
	
	  getRow: function getRow(row) {
	    return [_react2['default'].createElement(
	      'td',
	      null,
	      _react2['default'].createElement(
	        'strong',
	        null,
	        _react2['default'].createElement(
	          'a',
	          { href: '/' + row.organization.slug + '/' + row.slug + '/' },
	          row.name
	        )
	      ),
	      _react2['default'].createElement('br', null),
	      _react2['default'].createElement(
	        'small',
	        null,
	        row.organization.name
	      )
	    ), _react2['default'].createElement(
	      'td',
	      { style: { textAlign: 'center' } },
	      row.status
	    ), _react2['default'].createElement(
	      'td',
	      { style: { textAlign: 'right' } },
	      prettyDate(row.dateCreated)
	    )];
	  },
	
	  render: function render() {
	    var columns = [_react2['default'].createElement(
	      'th',
	      null,
	      'Project'
	    ), _react2['default'].createElement(
	      'th',
	      { style: { width: 150, textAlign: 'center' } },
	      'Status'
	    ), _react2['default'].createElement(
	      'th',
	      { style: { width: 200, textAlign: 'right' } },
	      'Created'
	    )];
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('Projects')
	      ),
	      _react2['default'].createElement(_componentsResultGrid2['default'], _extends({
	        path: '/manage/projects/',
	        endpoint: '/projects/',
	        method: 'GET',
	        columns: columns,
	        columnsForRow: this.getRow,
	        hasSearch: true,
	        filters: {
	          status: {
	            name: 'Status',
	            options: [['active', 'Active'], ['deleted', 'Deleted']]
	          }
	        },
	        sortOptions: [['date', 'Date Created']],
	        defaultSort: 'date'
	      }, this.props))
	    );
	  }
	});
	
	exports['default'] = AdminProjects;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _actionsAlertActions = __webpack_require__(62);
	
	var _actionsAlertActions2 = _interopRequireDefault(_actionsAlertActions);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _locale = __webpack_require__(2);
	
	var _options = __webpack_require__(300);
	
	var _componentsForms = __webpack_require__(36);
	
	var optionsAvailable = ['system.url-prefix', 'system.admin-email', 'system.rate-limit', 'auth.ip-rate-limit', 'auth.user-rate-limit', 'api.rate-limit.org-create'];
	
	var SettingsList = _react2['default'].createClass({
	  displayName: 'SettingsList',
	
	  propTypes: {
	    formDisabled: _react2['default'].PropTypes.bool,
	    options: _react2['default'].PropTypes.object.isRequired,
	    onSubmit: _react2['default'].PropTypes.func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var options = this.props.options;
	    var formData = {};
	    var required = [];
	    var fields = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = optionsAvailable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var key = _step.value;
	
	        // TODO(dcramer): we should not be mutating options
	        var option = options[key] || { field: {} };
	        if (_underscore2['default'].isUndefined(option.value) || option.value === '') {
	          var defn = (0, _options.getOption)(key);
	          formData[key] = defn.defaultValue ? defn.defaultValue() : '';
	        } else {
	          formData[key] = option.value;
	        }
	        if (option.field.required) {
	          required.push(key);
	        }
	        fields[key] = (0, _options.getOptionField)(key, this.onFieldChange.bind(this, key), formData[key], option.field);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return {
	      required: required,
	      formData: formData,
	      fields: fields
	    };
	  },
	
	  onFieldChange: function onFieldChange(name, value) {
	    var formData = this.state.formData;
	    formData[name] = value;
	    this.setState({
	      formData: formData
	    });
	  },
	
	  onSubmit: function onSubmit(e) {
	    this.props.onSubmit(this.state.formData);
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var fields = _state.fields;
	    var required = _state.required;
	    var formData = _state.formData;
	
	    var formValid = !required.filter(function (option) {
	      return !formData[option];
	    }).length;
	    var submitDisabled = !formValid || this.props.formDisabled;
	
	    return _react2['default'].createElement(
	      _componentsForms.Form,
	      { onSubmit: this.onSubmit, submitDisabled: submitDisabled },
	      _react2['default'].createElement(
	        'h4',
	        null,
	        'General'
	      ),
	      fields['system.url-prefix'],
	      fields['system.admin-email'],
	      fields['system.rate-limit'],
	      _react2['default'].createElement(
	        'h4',
	        null,
	        'Security & Abuse'
	      ),
	      fields['auth.ip-rate-limit'],
	      fields['auth.user-rate-limit'],
	      fields['api.rate-limit.org-create']
	    );
	  }
	});
	
	var AdminSettings = _react2['default'].createClass({
	  displayName: 'AdminSettings',
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      submitInProgress: false,
	      submitError: null,
	      options: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  fetchData: function fetchData(callback) {
	    var _this = this;
	
	    this.api.request('/internal/options/', {
	      method: 'GET',
	      success: function success(data) {
	        _this.setState({
	          options: data,
	          loading: false,
	          error: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  onSubmit: function onSubmit(formData) {
	    var _this2 = this;
	
	    this.setState({
	      submitInProgress: true,
	      submitError: false
	    });
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	
	    // We only want to send back the values which weren't disabled
	    formData = _underscore2['default'].pick(formData, function (value, key) {
	      return !_this2.state.options[key].field.disabled;
	    });
	    this.api.request('/internal/options/', {
	      method: 'PUT',
	      data: formData,
	      success: function success() {
	        _this2.setState({
	          submitInProgress: false
	        });
	        _actionsAlertActions2['default'].addAlert({
	          message: (0, _locale.t)('Your changes were saved, and will propagate to services shortly.'),
	          type: 'success'
	        });
	      },
	      error: function error() {
	        _this2.setState({
	          submitInProgress: false,
	          submitError: true
	        });
	      },
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  render: function render() {
	    var _state2 = this.state;
	    var error = _state2.error;
	    var loading = _state2.loading;
	    var options = _state2.options;
	    var submitError = _state2.submitError;
	    var submitInProgress = _state2.submitInProgress;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('Settings')
	      ),
	      loading ? _react2['default'].createElement(
	        _componentsLoadingIndicator2['default'],
	        null,
	        (0, _locale.t)('Please wait while we load configuration.')
	      ) : error ? _react2['default'].createElement(
	        'div',
	        { className: 'loading-error' },
	        _react2['default'].createElement('span', { className: 'icon' }),
	        (0, _locale.t)('We were unable to load the required configuration from the Sentry server. Please take a look at the service logs.')
	      ) : _react2['default'].createElement(
	        'div',
	        null,
	        submitError && _react2['default'].createElement(
	          'div',
	          { className: 'alert alert-block alert-error' },
	          (0, _locale.t)('We were unable to submit your changes to the Sentry server. Please take a look at the service logs.')
	        ),
	        _react2['default'].createElement(SettingsList, {
	          options: options,
	          onSubmit: this.onSubmit,
	          formDisabled: submitInProgress })
	      )
	    );
	  }
	});
	
	exports['default'] = AdminSettings;
	module.exports = exports['default'];

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable getsentry/jsx-needs-il8n */
	/* eslint-disable react/jsx-key */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _componentsResultGrid = __webpack_require__(188);
	
	var _componentsResultGrid2 = _interopRequireDefault(_componentsResultGrid);
	
	var _locale = __webpack_require__(2);
	
	var prettyDate = function prettyDate(x) {
	  return (0, _moment2['default'])(x).format('ll');
	};
	
	exports.prettyDate = prettyDate;
	var AdminUsers = _react2['default'].createClass({
	  displayName: 'AdminUsers',
	
	  getRow: function getRow(row) {
	    return [_react2['default'].createElement(
	      'td',
	      null,
	      _react2['default'].createElement(
	        'strong',
	        null,
	        _react2['default'].createElement(
	          'a',
	          { href: '/manage/users/' + row.id + '/' },
	          row.username
	        )
	      ),
	      _react2['default'].createElement('br', null),
	      row.email !== row.username && _react2['default'].createElement(
	        'small',
	        null,
	        row.email
	      )
	    ), _react2['default'].createElement(
	      'td',
	      { style: { textAlign: 'center' } },
	      prettyDate(row.dateJoined)
	    ), _react2['default'].createElement(
	      'td',
	      { style: { textAlign: 'center' } },
	      prettyDate(row.lastLogin)
	    )];
	  },
	
	  render: function render() {
	    var columns = [_react2['default'].createElement(
	      'th',
	      null,
	      'User'
	    ), _react2['default'].createElement(
	      'th',
	      { style: { textAlign: 'center', width: 150 } },
	      'Joined'
	    ), _react2['default'].createElement(
	      'th',
	      { style: { textAlign: 'center', width: 150 } },
	      'Last Login'
	    )];
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('Users')
	      ),
	      _react2['default'].createElement(_componentsResultGrid2['default'], _extends({
	        path: '/manage/users/',
	        endpoint: '/users/',
	        method: 'GET',
	        columns: columns,
	        columnsForRow: this.getRow,
	        hasSearch: true,
	        filters: {
	          status: {
	            name: 'Status',
	            options: [['active', 'Active'], ['disabled', 'Disabled']]
	          }
	        },
	        sortOptions: [['date', 'Date Joined']],
	        defaultSort: 'date'
	      }, this.props))
	    );
	  }
	});
	
	exports['default'] = AdminUsers;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsAutoSelectText = __webpack_require__(170);
	
	var _componentsAutoSelectText2 = _interopRequireDefault(_componentsAutoSelectText);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsListLink = __webpack_require__(47);
	
	var _componentsListLink2 = _interopRequireDefault(_componentsListLink);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsNarrowLayout = __webpack_require__(290);
	
	var _componentsNarrowLayout2 = _interopRequireDefault(_componentsNarrowLayout);
	
	var _locale = __webpack_require__(2);
	
	var ApiTokenRow = _react2['default'].createClass({
	  displayName: 'ApiTokenRow',
	
	  propTypes: {
	    token: _react2['default'].PropTypes.object.isRequired,
	    onRemove: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: false
	    };
	  },
	
	  onRemove: function onRemove() {
	    var _this = this;
	
	    if (this.state.loading) return;
	
	    var token = this.props.token;
	
	    this.setState({
	      loading: true
	    }, function () {
	      var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	      _this.api.request('/api-tokens/', {
	        method: 'DELETE',
	        data: { token: token.token },
	        success: function success(data) {
	          _this.props.onRemove();
	        },
	        complete: function complete() {
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  render: function render() {
	    var token = this.props.token;
	
	    var btnClassName = 'btn btn-default';
	    if (this.state.loading) btnClassName += ' disabled';
	
	    return _react2['default'].createElement(
	      'tr',
	      null,
	      _react2['default'].createElement(
	        'td',
	        null,
	        _react2['default'].createElement(
	          'small',
	          null,
	          _react2['default'].createElement(
	            _componentsAutoSelectText2['default'],
	            null,
	            token.token
	          )
	        ),
	        _react2['default'].createElement(
	          'small',
	          { style: { color: '#999' } },
	          token.scopes.join(', ')
	        )
	      ),
	      _react2['default'].createElement(
	        'td',
	        { style: { width: 32 } },
	        _react2['default'].createElement(
	          'a',
	          { onClick: this.onRemove.bind(this, token),
	            className: btnClassName,
	            disabled: this.state.loading },
	          _react2['default'].createElement('span', { className: 'icon icon-trash' })
	        )
	      )
	    );
	  }
	});
	
	var ApiDashboard = _react2['default'].createClass({
	  displayName: 'ApiDashboard',
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      tokenList: []
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  fetchData: function fetchData() {
	    var _this2 = this;
	
	    this.setState({
	      loading: true
	    });
	
	    this.api.request('/api-tokens/', {
	      success: function success(data, _, jqXHR) {
	        _this2.setState({
	          loading: false,
	          error: false,
	          tokenList: data
	        });
	      },
	      error: function error() {
	        _this2.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  onRemoveToken: function onRemoveToken(token) {
	    this.setState({
	      tokenList: this.state.tokenList.filter(function (tk) {
	        return tk.token !== token.token;
	      })
	    });
	  },
	
	  renderResults: function renderResults() {
	    var _this3 = this;
	
	    if (this.state.tokenList.length === 0) {
	      return _react2['default'].createElement(
	        'tr',
	        { colSpan: '2' },
	        _react2['default'].createElement(
	          'td',
	          { className: 'blankslate well' },
	          (0, _locale.t)('You haven\'t created any authentication tokens yet.')
	        )
	      );
	    }
	
	    return this.state.tokenList.map(function (token) {
	      return _react2['default'].createElement(ApiTokenRow, {
	        key: token.token,
	        token: token,
	        onRemove: _this3.onRemoveToken.bind(_this3, token) });
	    });
	  },
	
	  getTitle: function getTitle() {
	    return 'Sentry API';
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { title: this.getTitle() },
	      _react2['default'].createElement(
	        _componentsNarrowLayout2['default'],
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _locale.t)('Sentry Web API')
	        ),
	        _react2['default'].createElement(
	          'ul',
	          { className: 'nav nav-tabs border-bottom' },
	          _react2['default'].createElement(
	            _componentsListLink2['default'],
	            { to: '/api/' },
	            (0, _locale.t)('Auth Tokens')
	          )
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.t)('Authentication tokens allow you to perform actions against the Sentry API on behalf of your account. They\'re the easiest way to get started using the API.')
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.tct)('For more information on how to use the web API, see our [link:documentation].', {
	            link: _react2['default'].createElement('a', { href: 'https://docs.sentry.io/hosted/api/' })
	          })
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          _react2['default'].createElement(
	            'small',
	            null,
	            'psst. Looking for the ',
	            _react2['default'].createElement(
	              'strong',
	              null,
	              'DSN'
	            ),
	            ' for an SDK? You\'ll find that under ',
	            _react2['default'].createElement(
	              'strong',
	              null,
	              '[Project] » Settings » Client Keys'
	            ),
	            '.'
	          )
	        ),
	        _react2['default'].createElement(
	          'table',
	          { className: 'table' },
	          _react2['default'].createElement(
	            'tbody',
	            null,
	            this.state.loading ? _react2['default'].createElement(
	              'tr',
	              null,
	              _react2['default'].createElement(
	                'td',
	                { colSpan: '2' },
	                _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	              )
	            ) : this.state.error ? _react2['default'].createElement(
	              'tr',
	              null,
	              _react2['default'].createElement(
	                'td',
	                { colSpan: '2' },
	                _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData })
	              )
	            ) : this.renderResults()
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'form-actions', style: { textAlign: 'right' } },
	          _react2['default'].createElement(
	            _reactRouter.Link,
	            { to: '/api/new-token/', className: 'btn btn-primary' },
	            (0, _locale.t)('Create New Token')
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ApiDashboard;
	module.exports = exports['default'];

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsNarrowLayout = __webpack_require__(290);
	
	var _componentsNarrowLayout2 = _interopRequireDefault(_componentsNarrowLayout);
	
	var _componentsForms = __webpack_require__(36);
	
	var _locale = __webpack_require__(2);
	
	var SCOPES = new Set(['project:read', 'project:write', 'project:delete', 'project:releases', 'team:read', 'team:write', 'team:delete', 'event:read', 'event:write', 'event:delete', 'org:read', 'org:write', 'org:delete', 'member:read', 'member:write', 'member:delete']);
	
	var DEFAULT_SCOPES = new Set(['event:read', 'event:write', 'project:read', 'project:releases', 'org:read', 'team:read', 'member:read']);
	
	var TokenForm = _react2['default'].createClass({
	  displayName: 'TokenForm',
	
	  propTypes: {
	    initialData: _react2['default'].PropTypes.object,
	    onSave: _react2['default'].PropTypes.func.isRequired,
	    onCancel: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      formData: Object.assign({}, this.props.initialData),
	      errors: {}
	    };
	  },
	
	  onFieldChange: function onFieldChange(name, value) {
	    var formData = this.state.formData;
	    formData[name] = value;
	    this.setState({
	      formData: formData
	    });
	  },
	
	  onSubmit: function onSubmit(e) {
	    var _this = this;
	
	    e.preventDefault();
	
	    if (this.state.state == _componentsForms.FormState.SAVING) {
	      return;
	    }
	    this.setState({
	      state: _componentsForms.FormState.SAVING
	    }, function () {
	      var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	      _this.api.request('/api-tokens/', {
	        method: 'POST',
	        data: _this.state.formData,
	        success: function success(data) {
	          _this.setState({
	            state: _componentsForms.FormState.READY,
	            errors: {}
	          });
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	          _this.props.onSave(data);
	        },
	        error: function error(_error) {
	          _this.setState({
	            state: _componentsForms.FormState.ERROR,
	            errors: _error.responseJSON
	          });
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  render: function render() {
	    var isSaving = this.state.state === _componentsForms.FormState.SAVING;
	    var errors = this.state.errors;
	
	    return _react2['default'].createElement(
	      'form',
	      { onSubmit: this.onSubmit, className: 'form-stacked api-new-token' },
	      this.state.state === _componentsForms.FormState.ERROR && _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-error alert-block' },
	        (0, _locale.t)('Unable to save your changes. Please ensure all fields are valid and try again.')
	      ),
	      _react2['default'].createElement(
	        'fieldset',
	        null,
	        _react2['default'].createElement(_componentsForms.MultipleCheckboxField, {
	          key: 'scopes',
	          choices: Array.from(SCOPES.keys()).map(function (s) {
	            return [s, s];
	          }),
	          label: (0, _locale.t)('Scopes'),
	          value: this.state.formData.scopes,
	          required: true,
	          error: errors.scopes,
	          onChange: this.onFieldChange.bind(this, 'scopes') })
	      ),
	      _react2['default'].createElement(
	        'fieldset',
	        { className: 'form-actions' },
	        _react2['default'].createElement(
	          'button',
	          { className: 'btn btn-default',
	            disabled: isSaving, onClick: this.props.onCancel },
	          (0, _locale.t)('Cancel')
	        ),
	        _react2['default'].createElement(
	          'button',
	          { type: 'submit', className: 'btn btn-primary pull-right',
	            disabled: isSaving },
	          (0, _locale.t)('Save Changes')
	        )
	      )
	    );
	  }
	});
	
	var ApiNewToken = _react2['default'].createClass({
	  displayName: 'ApiNewToken',
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false
	    };
	  },
	
	  getTitle: function getTitle() {
	    return 'Sentry API';
	  },
	
	  onCancel: function onCancel() {
	    _reactRouter.browserHistory.pushState(null, '/api/');
	  },
	
	  onSave: function onSave() {
	    _reactRouter.browserHistory.pushState(null, '/api/');
	  },
	
	  render: function render() {
	    var defaultScopes = Array.from(DEFAULT_SCOPES);
	    defaultScopes.sort();
	
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { title: this.getTitle() },
	      _react2['default'].createElement(
	        _componentsNarrowLayout2['default'],
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _locale.t)('Create New Token')
	        ),
	        _react2['default'].createElement('hr', null),
	        _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.t)('Authentication tokens allow you to perform actions against the Sentry API on behalf of your account. They\'re the easiest way to get started using the API.')
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.tct)('For more information on how to use the web API, see our [link:documentation].', {
	            link: _react2['default'].createElement('a', { href: 'https://docs.sentry.io/hosted/api/' })
	          })
	        ),
	        _react2['default'].createElement(TokenForm, {
	          initialData: {
	            scopes: defaultScopes
	          },
	          onCancel: this.onCancel,
	          onSave: this.onSave })
	      )
	    );
	  }
	});
	
	exports['default'] = ApiNewToken;
	module.exports = exports['default'];

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _jsCookie = __webpack_require__(316);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsAlerts = __webpack_require__(268);
	
	var _componentsAlerts2 = _interopRequireDefault(_componentsAlerts);
	
	var _actionsAlertActions = __webpack_require__(62);
	
	var _actionsAlertActions2 = _interopRequireDefault(_actionsAlertActions);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _componentsIndicators = __webpack_require__(288);
	
	var _componentsIndicators2 = _interopRequireDefault(_componentsIndicators);
	
	var _installWizard = __webpack_require__(651);
	
	var _installWizard2 = _interopRequireDefault(_installWizard);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsOrganizationsOrganizationsLoader = __webpack_require__(291);
	
	var _componentsOrganizationsOrganizationsLoader2 = _interopRequireDefault(_componentsOrganizationsOrganizationsLoader);
	
	var _storesOrganizationStore = __webpack_require__(139);
	
	var _storesOrganizationStore2 = _interopRequireDefault(_storesOrganizationStore);
	
	var _locale = __webpack_require__(2);
	
	function getAlertTypeForProblem(problem) {
	  switch (problem.severity) {
	    case 'critical':
	      return 'error';
	    default:
	      return 'warning';
	  }
	}
	
	var App = _react2['default'].createClass({
	  displayName: 'App',
	
	  childContextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: false,
	      error: false,
	      needsUpgrade: _storesConfigStore2['default'].get('needsUpgrade')
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      location: this.props.location
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.api.request('/organizations/', {
	      query: {
	        'member': '1'
	      },
	      success: function success(data) {
	        _storesOrganizationStore2['default'].load(data);
	        _this.setState({
	          loading: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	
	    this.api.request('/internal/health/', {
	      success: function success(data) {
	        if (data && data.problems) {
	          data.problems.forEach(function (problem) {
	            _actionsAlertActions2['default'].addAlert({
	              id: problem.id,
	              message: problem.message,
	              type: getAlertTypeForProblem(problem),
	              url: problem.url
	            });
	          });
	        }
	      },
	      error: function error() {} // TODO: do something?
	    });
	
	    _storesConfigStore2['default'].get('messages').forEach(function (msg) {
	      _actionsAlertActions2['default'].addAlert({
	        message: msg.message,
	        type: msg.level
	      });
	    });
	
	    (0, _jquery2['default'])(document).ajaxError(function (evt, jqXHR) {
	      // TODO: Need better way of identifying anonymous pages
	      //       that don't trigger redirect
	      var pageAllowsAnon = /^\/share\//.test(window.location.pathname);
	      if (jqXHR && jqXHR.status === 401 && !pageAllowsAnon) {
	        _jsCookie2['default'].set('session_expired', 1);
	        // User has become unauthenticated; reload URL, and let Django
	        // redirect to login page
	        window.location.reload();
	      }
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _storesOrganizationStore2['default'].load([]);
	  },
	
	  onConfigured: function onConfigured() {
	    this.setState({ needsUpgrade: false });
	  },
	
	  render: function render() {
	    var user = _storesConfigStore2['default'].get('user');
	    var needsUpgrade = this.state.needsUpgrade;
	
	    if (user && user.isSuperuser && needsUpgrade) {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(_componentsIndicators2['default'], { className: 'indicators-container' }),
	        _react2['default'].createElement(_installWizard2['default'], { onConfigured: this.onConfigured })
	      );
	    }
	
	    if (this.state.loading) {
	      return _react2['default'].createElement(
	        _componentsLoadingIndicator2['default'],
	        { triangle: true },
	        (0, _locale.t)('Getting a list of all of your organizations.')
	      );
	    }
	
	    return _react2['default'].createElement(
	      _componentsOrganizationsOrganizationsLoader2['default'],
	      null,
	      _react2['default'].createElement(_componentsAlerts2['default'], { className: 'messages-container' }),
	      _react2['default'].createElement(_componentsIndicators2['default'], { className: 'indicators-container' }),
	      this.props.children
	    );
	  }
	});
	
	exports['default'] = App;
	module.exports = exports['default'];

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _componentsDuration = __webpack_require__(174);
	
	var _componentsDuration2 = _interopRequireDefault(_componentsDuration);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _componentsVersion = __webpack_require__(107);
	
	var _componentsVersion2 = _interopRequireDefault(_componentsVersion);
	
	var _componentsActivityNoteContainer = __webpack_require__(540);
	
	var _componentsActivityNoteContainer2 = _interopRequireDefault(_componentsActivityNoteContainer);
	
	var _componentsActivityNoteInput = __webpack_require__(267);
	
	var _componentsActivityNoteInput2 = _interopRequireDefault(_componentsActivityNoteInput);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _storesMemberListStore = __webpack_require__(91);
	
	var _storesMemberListStore2 = _interopRequireDefault(_storesMemberListStore);
	
	var _locale = __webpack_require__(2);
	
	var GroupActivity = _react2['default'].createClass({
	  displayName: 'GroupActivity',
	
	  // TODO(dcramer): only re-render on group/activity change
	  propTypes: {
	    group: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsGroupState2['default'], _mixinsApiMixin2['default']],
	
	  formatActivity: function formatActivity(author, item, params) {
	    var data = item.data;
	    var orgId = params.orgId;
	    var projectId = params.projectId;
	
	    switch (item.type) {
	      case 'note':
	        return (0, _locale.t)('%s left a comment', author);
	      case 'set_resolved':
	        return (0, _locale.t)('%s marked this issue as resolved', author);
	      case 'set_resolved_by_age':
	        return (0, _locale.t)('%(author)s marked this issue as resolved due to inactivity', {
	          author: author
	        });
	      case 'set_resolved_in_release':
	        return data.version ? (0, _locale.t)('%(author)s marked this issue as resolved in %(version)s', {
	          author: author,
	          version: _react2['default'].createElement(_componentsVersion2['default'], { version: data.version, orgId: orgId, projectId: projectId })
	        }) : (0, _locale.t)('%s marked this issue as resolved in the upcoming release', author);
	      case 'set_unresolved':
	        return (0, _locale.t)('%s marked this issue as unresolved', author);
	      case 'set_ignored':
	        if (data.ignoreDuration) {
	          return (0, _locale.t)('%(author)s ignored this issue for %(duration)s', {
	            author: author,
	            duration: _react2['default'].createElement(_componentsDuration2['default'], { seconds: data.ignoreDuration * 60 })
	          });
	        }
	        return (0, _locale.t)('%s ignored this issue', author);
	      case 'set_public':
	        return (0, _locale.t)('%s made this issue public', author);
	      case 'set_private':
	        return (0, _locale.t)('%s made this issue private', author);
	      case 'set_regression':
	        return data.version ? (0, _locale.t)('%(author)s marked this issue as a regression in %(version)s', {
	          author: author,
	          version: _react2['default'].createElement(_componentsVersion2['default'], { version: data.version, orgId: orgId, projectId: projectId })
	        }) : (0, _locale.t)('%s marked this issue as a regression', author);
	      case 'create_issue':
	        return (0, _locale.t)('%(author)s created an issue on %(provider)s titled %(title)s', {
	          author: author,
	          provider: data.provider,
	          title: _react2['default'].createElement(
	            'a',
	            { href: data.location },
	            data.title
	          )
	        });
	      case 'first_seen':
	        return (0, _locale.t)('%s first saw this issue', author);
	      case 'assigned':
	        var assignee = undefined;
	        if (item.user && data.assignee === item.user.id) {
	          assignee = 'themselves';
	          return (0, _locale.t)('%s assigned this event to themselves', author);
	        } else {
	          assignee = _storesMemberListStore2['default'].getById(data.assignee);
	          if (assignee && assignee.email) {
	            return (0, _locale.t)('%(author)s assigned this event to %(assignee)s', {
	              author: author,
	              assignee: assignee.email
	            });
	          } else {
	            return (0, _locale.t)('%s assigned this event to an unknown user', author);
	          }
	        }
	        return (0, _locale.t)('%(author)s assigned this event to %(assignee)s', {
	          author: author,
	          assignee: assignee.email
	        });
	      case 'unassigned':
	        return (0, _locale.t)('%s unassigned this issue', author);
	      case 'merge':
	        return (0, _locale.tn)('%2$s merged %1$d issue into this issue', '%2$s merged %1$d issues into this issue', data.issues.length, author);
	      default:
	        return ''; // should never hit (?)
	    }
	  },
	
	  onNoteDelete: function onNoteDelete(item) {
	    var group = this.props.group;
	
	    // Optimistically remove from UI
	    var index = _storesGroupStore2['default'].removeActivity(group.id, item.id);
	    if (index === -1) {
	      // I dunno, the id wasn't found in the GroupStore
	      return;
	    }
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Removing comment..'));
	
	    this.api.request('/issues/' + group.id + '/comments/' + item.id + '/', {
	      method: 'DELETE',
	      error: function error(_error) {
	        // TODO(mattrobenolt): Show an actual error that this failed,
	        // but just bring it back in place for now
	        _storesGroupStore2['default'].addActivity(group.id, item, index);
	      },
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var group = this.props.group;
	    var me = _storesConfigStore2['default'].get('user');
	
	    var children = group.activity.map(function (item, itemIdx) {
	      var avatar = item.user ? _react2['default'].createElement(_componentsAvatar2['default'], { user: item.user, size: 64, className: 'avatar' }) : _react2['default'].createElement(
	        'div',
	        { className: 'avatar sentry' },
	        _react2['default'].createElement('span', { className: 'icon-sentry-logo' })
	      );
	
	      var author = {
	        name: item.user ? item.user.name : 'Sentry',
	        avatar: avatar
	      };
	
	      if (item.type === 'note') {
	        return _react2['default'].createElement(_componentsActivityNoteContainer2['default'], { group: group, item: item, key: itemIdx, author: author, onDelete: _this.onNoteDelete });
	      } else {
	        return _react2['default'].createElement(
	          'li',
	          { className: 'activity-item', key: item.id },
	          _react2['default'].createElement('a', { name: 'event_' + item.id }),
	          _react2['default'].createElement(_componentsTimeSince2['default'], { date: item.dateCreated }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'activity-item-content' },
	            _this.formatActivity(_react2['default'].createElement(
	              'span',
	              { key: 'author' },
	              author.avatar,
	              _react2['default'].createElement(
	                'span',
	                { className: 'activity-author' },
	                author.name
	              )
	            ), item, _this.props.params)
	          )
	        );
	      }
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'row' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'col-md-9' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'activity-container' },
	          _react2['default'].createElement(
	            'ul',
	            { className: 'activity' },
	            _react2['default'].createElement(
	              'li',
	              { className: 'activity-note', key: 'activity-note' },
	              _react2['default'].createElement(_componentsAvatar2['default'], { user: me, size: 64, className: 'avatar' }),
	              _react2['default'].createElement(
	                'div',
	                { className: 'activity-bubble' },
	                _react2['default'].createElement(_componentsActivityNoteInput2['default'], { group: group })
	              )
	            ),
	            children
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = GroupActivity;
	module.exports = exports['default'];

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _groupDetailsHeader = __webpack_require__(643);
	
	var _groupDetailsHeader2 = _interopRequireDefault(_groupDetailsHeader);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _locale = __webpack_require__(2);
	
	var ERROR_TYPES = {
	  GROUP_NOT_FOUND: 'GROUP_NOT_FOUND'
	};
	
	var GroupDetails = _react2['default'].createClass({
	  displayName: 'GroupDetails',
	
	  propTypes: {
	    setProjectNavSection: _react2['default'].PropTypes.func,
	    memberList: _react2['default'].PropTypes.array
	  },
	
	  childContextTypes: {
	    group: _proptypes2['default'].Group,
	    location: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _reflux2['default'].listenTo(_storesGroupStore2['default'], 'onGroupChange')],
	
	  getInitialState: function getInitialState() {
	    return {
	      group: null,
	      loading: true,
	      error: false,
	      errorType: null
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      group: this.state.group,
	      location: this.props.location
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.setProjectNavSection('stream');
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.params.groupId !== this.props.params.groupId) {
	      this.remountComponent();
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.params.groupId !== this.props.params.groupId) {
	      this.fetchData();
	    }
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState());
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.api.request(this.getGroupDetailsEndpoint(), {
	      success: function success(data) {
	        // TODO: Ideally, this would rebuild the route before parameter
	        // interpolation, replace the `groupId` field of `this.routeParams`,
	        // and use `formatPattern` from `react-router` to rebuild the URL,
	        // rather than blindly pattern matching like we do here. Unfortunately,
	        // `formatPattern` isn't actually exported until `react-router` 2.0.1:
	        // https://github.com/reactjs/react-router/blob/v2.0.1/modules/index.js#L25
	        if (_this.props.params.groupId != data.id) {
	          var _location = _this.props.location;
	          return void _reactRouter.browserHistory.pushState(null, _location.pathname.replace('/issues/' + _this.props.params.groupId + '/', '/issues/' + data.id + '/') + _location.search + _location.hash);
	        }
	
	        _this.setState({
	          loading: false,
	          error: false,
	          errorType: null
	        });
	
	        _storesGroupStore2['default'].loadInitialData([data]);
	      }, error: function error(_, textStatus, errorThrown) {
	        var errorType = null;
	        switch (errorThrown) {
	          case 'NOT FOUND':
	            errorType = ERROR_TYPES.GROUP_NOT_FOUND;
	            break;
	          default:
	        }
	        _this.setState({
	          loading: false,
	          error: true,
	          errorType: errorType
	        });
	      }
	    });
	  },
	
	  onGroupChange: function onGroupChange(itemIds) {
	    var id = this.props.params.groupId;
	    if (itemIds.has(id)) {
	      var group = _storesGroupStore2['default'].get(id);
	      if (group.stale) {
	        this.fetchData();
	        return;
	      }
	      this.setState({
	        group: group
	      });
	    }
	  },
	
	  getGroupDetailsEndpoint: function getGroupDetailsEndpoint() {
	    var id = this.props.params.groupId;
	
	    return '/issues/' + id + '/';
	  },
	
	  getTitle: function getTitle() {
	    var group = this.state.group;
	
	    if (!group) return 'Sentry';
	
	    switch (group.type) {
	      case 'error':
	        if (group.metadata.type && group.metadata.value) return group.metadata.type + ': ' + group.metadata.value;
	        return group.metadata.type || group.metadata.value;
	      case 'csp':
	        return group.metadata.message;
	      case 'default':
	        return group.metadata.title;
	      default:
	        return group.message.split('\n')[0];
	    }
	  },
	
	  render: function render() {
	    var group = this.state.group;
	    var params = this.props.params;
	
	    if (this.state.error) {
	      switch (this.state.errorType) {
	        case ERROR_TYPES.GROUP_NOT_FOUND:
	          return _react2['default'].createElement(
	            'div',
	            { className: 'alert alert-block' },
	            (0, _locale.t)('The issue you were looking for was not found.')
	          );
	        default:
	          return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.remountComponent });
	      }
	    } else if (this.state.loading || !group) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);
	
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { title: this.getTitle() },
	      _react2['default'].createElement(
	        'div',
	        { className: this.props.className },
	        _react2['default'].createElement(_groupDetailsHeader2['default'], {
	          orgId: params.orgId,
	          projectId: params.projectId,
	          group: group,
	          memberList: this.props.memberList }),
	        _react2['default'].cloneElement(this.props.children, {
	          memberList: this.props.memberList,
	          group: group
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = GroupDetails;
	module.exports = exports['default'];

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsDropdownLink = __webpack_require__(33);
	
	var _componentsDropdownLink2 = _interopRequireDefault(_componentsDropdownLink);
	
	var _componentsCustomSnoozeModal = __webpack_require__(546);
	
	var _componentsCustomSnoozeModal2 = _interopRequireDefault(_componentsCustomSnoozeModal);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsGroupIssuePluginActions = __webpack_require__(586);
	
	var _componentsGroupIssuePluginActions2 = _interopRequireDefault(_componentsGroupIssuePluginActions);
	
	var _componentsMenuItem = __webpack_require__(37);
	
	var _componentsMenuItem2 = _interopRequireDefault(_componentsMenuItem);
	
	var _componentsLinkWithConfirmation = __webpack_require__(183);
	
	var _componentsLinkWithConfirmation2 = _interopRequireDefault(_componentsLinkWithConfirmation);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _utils = __webpack_require__(7);
	
	var _locale = __webpack_require__(2);
	
	var Snooze = {
	  // all values in minutes
	  '30MINUTES': 30,
	  '2HOURS': 60 * 2,
	  '24HOURS': 60 * 24,
	  'ONEWEEK': 60 * 24 * 7
	};
	
	var GroupActions = _react2['default'].createClass({
	  displayName: 'GroupActions',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsGroupState2['default'], (0, _mixinsTooltip2['default'])({
	    selector: '.tip',
	    container: 'body'
	  })],
	
	  onDelete: function onDelete() {
	    var group = this.getGroup();
	    var project = this.getProject();
	    var org = this.getOrganization();
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Delete event..'));
	
	    this.api.bulkDelete({
	      orgId: org.slug,
	      projectId: project.slug,
	      itemIds: [group.id]
	    }, {
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	
	        _reactRouter.browserHistory.pushState(null, '/' + org.slug + '/' + project.slug + '/');
	      }
	    });
	  },
	
	  onUpdate: function onUpdate(data) {
	    var group = this.getGroup();
	    var project = this.getProject();
	    var org = this.getOrganization();
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	
	    this.api.bulkUpdate({
	      orgId: org.slug,
	      projectId: project.slug,
	      itemIds: [group.id],
	      data: data
	    }, {
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  onToggleBookmark: function onToggleBookmark() {
	    this.onUpdate({ isBookmarked: !this.getGroup().isBookmarked });
	  },
	
	  onSnooze: function onSnooze(duration) {
	    this.onUpdate({
	      status: 'ignored',
	      ignoreDuration: duration
	    });
	  },
	
	  customSnoozeClicked: function customSnoozeClicked() {
	    this.setState({
	      isCustomSnoozeModalOpen: true
	    });
	  },
	
	  customSnoozeSelected: function customSnoozeSelected(duration) {
	    this.onSnooze(duration);
	    this.customSnoozeCanceled();
	  },
	
	  customSnoozeCanceled: function customSnoozeCanceled() {
	    this.setState({
	      isCustomSnoozeModalOpen: false
	    });
	  },
	
	  render: function render() {
	    var group = this.getGroup();
	
	    var resolveClassName = 'group-resolve btn btn-default btn-sm';
	    if (group.status === 'resolved') {
	      resolveClassName += ' active';
	    }
	
	    var resolveDropdownClasses = 'resolve-dropdown';
	
	    var bookmarkClassName = 'group-bookmark btn btn-default btn-sm';
	    if (group.isBookmarked) {
	      bookmarkClassName += ' active';
	    }
	
	    var ignoreClassName = 'group-ignore btn btn-default btn-sm';
	    if (group.status === 'ignored') {
	      ignoreClassName += ' active';
	    }
	
	    var hasRelease = (0, _utils.defined)(group.lastRelease);
	    var releaseTrackingUrl = '/' + this.getOrganization().slug + '/' + this.getProject().slug + '/settings/release-tracking/';
	
	    // account for both old and new style plugins
	    var hasIssueTracking = group.pluginActions.length || group.pluginIssues.length;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'group-actions' },
	      _react2['default'].createElement(_componentsCustomSnoozeModal2['default'], {
	        show: this.state && this.state.isCustomSnoozeModalOpen,
	        onSelected: this.customSnoozeSelected,
	        onCanceled: this.customSnoozeCanceled }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'btn-group' },
	        group.status === 'resolved' ? group.statusDetails.autoResolved ? _react2['default'].createElement(
	          'a',
	          { className: resolveClassName + ' tip',
	            title: (0, _locale.t)('This event is resolved due to the Auto Resolve configuration for this project') },
	          _react2['default'].createElement('span', { className: 'icon-checkmark' })
	        ) : _react2['default'].createElement(
	          'a',
	          { className: resolveClassName,
	            title: (0, _locale.t)('Unresolve'),
	            onClick: this.onUpdate.bind(this, { status: 'unresolved' }) },
	          _react2['default'].createElement('span', { className: 'icon-checkmark' })
	        ) : [_react2['default'].createElement(
	          'a',
	          { key: 'resolve-button',
	            className: resolveClassName,
	            title: (0, _locale.t)('Resolve'),
	            onClick: this.onUpdate.bind(this, { status: 'resolved' }) },
	          _react2['default'].createElement('span', { className: 'icon-checkmark', style: { marginRight: 5 } }),
	          (0, _locale.t)('Resolve')
	        ), _react2['default'].createElement(
	          _componentsDropdownLink2['default'],
	          {
	            key: 'resolve-dropdown',
	            caret: true,
	            className: resolveClassName,
	            topLevelClasses: resolveDropdownClasses,
	            title: '' },
	          _react2['default'].createElement(
	            _componentsMenuItem2['default'],
	            { noAnchor: true },
	            hasRelease ? _react2['default'].createElement(
	              'a',
	              { onClick: this.onUpdate.bind(this, { status: 'resolvedInNextRelease' }) },
	              _react2['default'].createElement(
	                'strong',
	                null,
	                (0, _locale.t)('Resolved in next release')
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'help-text' },
	                (0, _locale.t)('Snooze notifications until this issue reoccurs in a future release.')
	              )
	            ) : _react2['default'].createElement(
	              'a',
	              { href: releaseTrackingUrl, className: 'disabled tip', title: (0, _locale.t)('Set up release tracking in order to use this feature.') },
	              _react2['default'].createElement(
	                'strong',
	                null,
	                (0, _locale.t)('Resolved in next release.')
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'help-text' },
	                (0, _locale.t)('Snooze notifications until this issue reoccurs in a future release.')
	              )
	            )
	          )
	        )]
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'btn-group' },
	        group.status === 'ignored' ? _react2['default'].createElement(
	          'a',
	          { className: ignoreClassName,
	            title: (0, _locale.t)('Remove Ignored Status'),
	            onClick: this.onUpdate.bind(this, { status: 'unresolved' }) },
	          (0, _locale.t)('Ignore')
	        ) : _react2['default'].createElement(
	          _componentsDropdownLink2['default'],
	          {
	            caret: false,
	            className: ignoreClassName,
	            title: _react2['default'].createElement(
	              'span',
	              null,
	              (0, _locale.t)('Ignore'),
	              _react2['default'].createElement('span', { className: 'icon-arrow-down', style: { marginLeft: 3, marginRight: -3 } })
	            ) },
	          _react2['default'].createElement(
	            _componentsMenuItem2['default'],
	            { noAnchor: true },
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.onSnooze.bind(this, Snooze['30MINUTES']) },
	              (0, _locale.t)('for 30 minutes')
	            )
	          ),
	          _react2['default'].createElement(
	            _componentsMenuItem2['default'],
	            { noAnchor: true },
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.onSnooze.bind(this, Snooze['2HOURS']) },
	              (0, _locale.t)('for 2 hours')
	            )
	          ),
	          _react2['default'].createElement(
	            _componentsMenuItem2['default'],
	            { noAnchor: true },
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.onSnooze.bind(this, Snooze['24HOURS']) },
	              (0, _locale.t)('for 24 hours')
	            )
	          ),
	          _react2['default'].createElement(
	            _componentsMenuItem2['default'],
	            { noAnchor: true },
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.onSnooze.bind(this, Snooze.ONEWEEK) },
	              (0, _locale.t)('for 1 week')
	            )
	          ),
	          _react2['default'].createElement(
	            _componentsMenuItem2['default'],
	            { noAnchor: true },
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.customSnoozeClicked },
	              (0, _locale.t)('until custom date...')
	            )
	          ),
	          _react2['default'].createElement(
	            _componentsMenuItem2['default'],
	            { noAnchor: true },
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.onUpdate.bind(this, { status: 'ignored' }) },
	              (0, _locale.t)('forever')
	            )
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'btn-group' },
	        _react2['default'].createElement(
	          'a',
	          { className: bookmarkClassName,
	            title: (0, _locale.t)('Bookmark'),
	            onClick: this.onToggleBookmark },
	          _react2['default'].createElement('span', { className: 'icon-star-solid' })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'btn-group' },
	        _react2['default'].createElement(
	          _componentsLinkWithConfirmation2['default'],
	          {
	            className: 'group-remove btn btn-default btn-sm',
	            title: (0, _locale.t)('Delete'),
	            message: (0, _locale.t)('Deleting this event is permanent. Are you sure you wish to continue?'),
	            onConfirm: this.onDelete },
	          _react2['default'].createElement('span', { className: 'icon-trash' })
	        )
	      ),
	      group.pluginActions.length > 1 ? _react2['default'].createElement(
	        'div',
	        { className: 'btn-group more' },
	        _react2['default'].createElement(
	          _componentsDropdownLink2['default'],
	          {
	            className: 'btn btn-default btn-sm',
	            title: (0, _locale.t)('More') },
	          group.pluginActions.map(function (action, actionIdx) {
	            return _react2['default'].createElement(
	              _componentsMenuItem2['default'],
	              { key: actionIdx, href: action[1] },
	              action[0]
	            );
	          })
	        )
	      ) : group.pluginActions.length !== 0 && group.pluginActions.map(function (action, actionIdx) {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'btn-group', key: actionIdx },
	          _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-default btn-sm',
	              href: action[1] },
	            action[0]
	          )
	        );
	      }),
	      group.pluginIssues && group.pluginIssues.map(function (plugin) {
	        return _react2['default'].createElement(_componentsGroupIssuePluginActions2['default'], { key: plugin.slug, plugin: plugin });
	      }),
	      !hasIssueTracking && _react2['default'].createElement(
	        'a',
	        { href: '/' + this.getOrganization().slug + '/' + this.getProject().slug + '/settings/issue-tracking/',
	          className: 'btn btn-default btn-sm btn-config-issue-tracking' },
	        (0, _locale.t)('Link Issue Tracker')
	      )
	    );
	  }
	});
	
	exports['default'] = GroupActions;
	module.exports = exports['default'];

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _componentsDateTime = __webpack_require__(72);
	
	var _componentsDateTime2 = _interopRequireDefault(_componentsDateTime);
	
	var _componentsFileSize = __webpack_require__(180);
	
	var _componentsFileSize2 = _interopRequireDefault(_componentsFileSize);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _locale = __webpack_require__(2);
	
	var formatDateDelta = function formatDateDelta(reference, observed) {
	  var duration = _moment2['default'].duration(Math.abs(+observed - +reference));
	  var hours = Math.floor(+duration / (60 * 60 * 1000));
	  var minutes = duration.minutes();
	  var results = [];
	
	  if (hours) {
	    results.push(hours + ' hour' + (hours != 1 ? 's' : ''));
	  }
	
	  if (minutes) {
	    results.push(minutes + ' minute' + (minutes != 1 ? 's' : ''));
	  }
	
	  if (results.length == 0) {
	    results.push('a few seconds');
	  }
	
	  return results.join(', ');
	};
	
	var GroupEventToolbar = _react2['default'].createClass({
	  displayName: 'GroupEventToolbar',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    group: _proptypes2['default'].Group.isRequired,
	    event: _proptypes2['default'].Event.isRequired
	  },
	
	  mixins: [(0, _mixinsTooltip2['default'])({
	    html: true,
	    selector: '.tip'
	  })],
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return this.props.event.id !== nextProps.event.id;
	  },
	
	  getDateTooltip: function getDateTooltip() {
	    var evt = this.props.event;
	    var user = _storesConfigStore2['default'].get('user');
	    var options = user ? user.options : {};
	    var format = options.clock24Hours ? 'HH:mm:ss z' : 'LTS z';
	    var dateCreated = (0, _moment2['default'])(evt.dateCreated);
	    var resp = '<dl class="flat" style="text-align:left;margin:0;min-width:200px">' + '<dt>Occurred</dt>' + '<dd>' + dateCreated.format('ll') + '<br />' + dateCreated.format(format) + '</dd>';
	    if (evt.dateReceived) {
	      var dateReceived = (0, _moment2['default'])(evt.dateReceived);
	      resp += '<dt>Received</dt>' + '<dd>' + dateReceived.format('ll') + '<br />' + dateReceived.format(format) + '</dd>' + '<dt>Latency</dt>' + '<dd>' + formatDateDelta(dateCreated, dateReceived) + '</dd>';
	    }
	    return resp + '</dl>';
	  },
	
	  render: function render() {
	    var evt = this.props.event;
	
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	
	    var groupId = this.props.group.id;
	
	    var eventNavNodes = [evt.previousEventID ? _react2['default'].createElement(
	      _reactRouter.Link,
	      {
	        key: 'oldest',
	        to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/oldest/',
	        className: 'btn btn-default',
	        title: (0, _locale.t)('Oldest') },
	      _react2['default'].createElement('span', { className: 'icon-skip-back' })
	    ) : _react2['default'].createElement(
	      'a',
	      { key: 'oldest',
	        className: 'btn btn-default disabled' },
	      _react2['default'].createElement('span', { className: 'icon-skip-back' })
	    ), evt.previousEventID ? _react2['default'].createElement(
	      _reactRouter.Link,
	      {
	        key: 'prev',
	        to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' + evt.previousEventID + '/',
	        className: 'btn btn-default' },
	      (0, _locale.t)('Older')
	    ) : _react2['default'].createElement(
	      'a',
	      { key: 'prev',
	        className: 'btn btn-default disabled' },
	      (0, _locale.t)('Older')
	    ), evt.nextEventID ? _react2['default'].createElement(
	      _reactRouter.Link,
	      {
	        key: 'next',
	        to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' + evt.nextEventID + '/',
	        className: 'btn btn-default' },
	      (0, _locale.t)('Newer')
	    ) : _react2['default'].createElement(
	      'a',
	      { key: 'next',
	        className: 'btn btn-default disabled' },
	      (0, _locale.t)('Newer')
	    ), evt.nextEventID ? _react2['default'].createElement(
	      _reactRouter.Link,
	      {
	        key: 'latest',
	        to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/latest/',
	        className: 'btn btn-default',
	        title: (0, _locale.t)('Newest') },
	      _react2['default'].createElement('span', { className: 'icon-skip-forward' })
	    ) : _react2['default'].createElement(
	      'a',
	      { key: 'latest',
	        className: 'btn btn-default disabled' },
	      _react2['default'].createElement('span', { className: 'icon-skip-forward' })
	    )];
	
	    // TODO: possible to define this as a route in react-router, but without a corresponding
	    //       React component?
	    var jsonUrl = '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' + evt.id + '/json/';
	    var style = {
	      borderBottom: '1px dotted #dfe3ea'
	    };
	
	    var latencyThreshold = 30 * 60 * 1000; // 30 minutes
	    var isOverLatencyThreshold = evt.dateReceived && Math.abs(+(0, _moment2['default'])(evt.dateReceived) - +(0, _moment2['default'])(evt.dateCreated)) > latencyThreshold;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'event-toolbar' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'pull-right' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'btn-group' },
	          eventNavNodes
	        )
	      ),
	      _react2['default'].createElement(
	        'h4',
	        null,
	        (0, _locale.t)('Event'),
	        ' ',
	        _react2['default'].createElement(
	          'span',
	          { className: 'event-id' },
	          evt.eventID
	        )
	      ),
	      _react2['default'].createElement(
	        'span',
	        null,
	        _react2['default'].createElement(
	          'span',
	          { className: 'tip', 'data-title': this.getDateTooltip(), key: evt.id },
	          _react2['default'].createElement(_componentsDateTime2['default'], { date: evt.dateCreated, style: style }),
	          isOverLatencyThreshold && _react2['default'].createElement('span', { className: 'icon-alert' })
	        ),
	        _react2['default'].createElement(
	          'a',
	          { href: jsonUrl, target: '_blank', className: 'json-link' },
	          'JSON',
	          ' (',
	          _react2['default'].createElement(_componentsFileSize2['default'], { bytes: evt.size }),
	          ')'
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = GroupEventToolbar;
	module.exports = exports['default'];
	/* use a key here to force removal of tooltip parent - fixes #3341 */

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsAssigneeSelector = __webpack_require__(269);
	
	var _componentsAssigneeSelector2 = _interopRequireDefault(_componentsAssigneeSelector);
	
	var _componentsCount = __webpack_require__(71);
	
	var _componentsCount2 = _interopRequireDefault(_componentsCount);
	
	var _actions = __webpack_require__(641);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _seenBy = __webpack_require__(644);
	
	var _seenBy2 = _interopRequireDefault(_seenBy);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsListLink = __webpack_require__(47);
	
	var _componentsListLink2 = _interopRequireDefault(_componentsListLink);
	
	var _componentsShortId = __webpack_require__(294);
	
	var _componentsShortId2 = _interopRequireDefault(_componentsShortId);
	
	var _componentsGroupTitle = __webpack_require__(286);
	
	var _componentsGroupTitle2 = _interopRequireDefault(_componentsGroupTitle);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var _locale = __webpack_require__(2);
	
	var GroupHeader = _react2['default'].createClass({
	  displayName: 'GroupHeader',
	
	  propTypes: {
	    group: _react2['default'].PropTypes.object.isRequired,
	    memberList: _react2['default'].PropTypes.array.isRequired
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsProjectState2['default']],
	
	  onToggleMute: function onToggleMute() {
	    var group = this.props.group;
	    var project = this.getProject();
	    var org = this.getOrganization();
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	
	    this.api.bulkUpdate({
	      orgId: org.slug,
	      projectId: project.slug,
	      itemIds: [group.id],
	      data: {
	        status: group.status === 'ignored' ? 'unresolved' : 'ignored'
	      }
	    }, {
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  onShare: function onShare() {
	    var shareId = this.props.group.shareId;
	
	    return _reactRouter.browserHistory.pushState(null, '/share/issue/' + shareId + '/');
	  },
	
	  onTogglePublic: function onTogglePublic() {
	    var group = this.props.group;
	    var project = this.getProject();
	    var org = this.getOrganization();
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	
	    this.api.bulkUpdate({
	      orgId: org.slug,
	      projectId: project.slug,
	      itemIds: [group.id],
	      data: {
	        isPublic: !group.isPublic
	      }
	    }, {
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  getMessage: function getMessage() {
	    var data = this.props.group;
	    var metadata = data.metadata;
	    switch (data.type) {
	      case 'error':
	        return metadata.value;
	      case 'csp':
	        return metadata.message;
	      default:
	        return this.props.group.culprit || '';
	    }
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var group = this.props.group,
	        orgFeatures = new Set(this.getOrganization().features),
	        userCount = group.userCount;
	
	    var className = 'group-detail';
	
	    className += ' type-' + group.type;
	    className += ' level-' + group.level;
	
	    if (group.isBookmarked) {
	      className += ' isBookmarked';
	    }
	    if (group.hasSeen) {
	      className += ' hasSeen';
	    }
	    if (group.status === 'resolved') {
	      className += ' isResolved';
	    }
	
	    var groupId = group.id,
	        projectId = this.getProject().slug,
	        orgId = this.getOrganization().slug;
	
	    var message = this.getMessage();
	
	    return _react2['default'].createElement(
	      'div',
	      { className: className },
	      _react2['default'].createElement(
	        'div',
	        { className: 'row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-8' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            _react2['default'].createElement(_componentsGroupTitle2['default'], { data: group })
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'event-message' },
	            _react2['default'].createElement(
	              'span',
	              { className: 'error-level' },
	              group.level
	            ),
	            message && _react2['default'].createElement(
	              'span',
	              { className: 'message' },
	              message
	            ),
	            group.logger && _react2['default'].createElement(
	              'span',
	              { className: 'event-annotation' },
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: {
	                    pathname: '/' + orgId + '/' + projectId + '/',
	                    query: { query: 'logger:' + group.logger }
	                  } },
	                group.logger
	              )
	            ),
	            group.annotations.map(function (annotation, i) {
	              return _react2['default'].createElement('span', { className: 'event-annotation', key: i,
	                dangerouslySetInnerHTML: { __html: annotation } });
	            })
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-4 stats' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'flex flex-justify-right' },
	            group.shortId && this.getFeatures().has('callsigns') && _react2['default'].createElement(
	              'div',
	              { className: 'short-id-box count align-right' },
	              _react2['default'].createElement(
	                'h6',
	                { className: 'nav-header' },
	                (0, _locale.t)('Issue #')
	              ),
	              _react2['default'].createElement(_componentsShortId2['default'], { shortId: group.shortId })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'assigned-to' },
	              _react2['default'].createElement(
	                'h6',
	                { className: 'nav-header' },
	                (0, _locale.t)('Assigned')
	              ),
	              _react2['default'].createElement(_componentsAssigneeSelector2['default'], { id: group.id })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'count align-right' },
	              _react2['default'].createElement(
	                'h6',
	                { className: 'nav-header' },
	                (0, _locale.t)('Events')
	              ),
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' },
	                _react2['default'].createElement(_componentsCount2['default'], { className: 'count', value: group.count })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'count align-right' },
	              _react2['default'].createElement(
	                'h6',
	                { className: 'nav-header' },
	                (0, _locale.t)('Users')
	              ),
	              userCount !== 0 ? _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/tags/user/' },
	                _react2['default'].createElement(_componentsCount2['default'], { className: 'count', value: userCount })
	              ) : _react2['default'].createElement(
	                'span',
	                null,
	                '0'
	              )
	            )
	          )
	        )
	      ),
	      _react2['default'].createElement(_seenBy2['default'], null),
	      _react2['default'].createElement(_actions2['default'], null),
	      orgFeatures.has('shared-issues') && _react2['default'].createElement(
	        'div',
	        { className: 'pull-right' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'group-privacy' },
	          _react2['default'].createElement(
	            'a',
	            { onClick: this.onShare },
	            _react2['default'].createElement('span', { className: 'icon' }),
	            ' ',
	            (0, _locale.t)('Share this event')
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'nav nav-tabs' },
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/', isActive: function () {
	              var rootGroupPath = '/' + orgId + '/' + projectId + '/issues/' + groupId + '/';
	              var pathname = _this.context.location.pathname;
	
	              // Because react-router 1.0 removes router.isActive(route)
	              return pathname === rootGroupPath || /events\/\w+\/$/.test(pathname);
	            } },
	          (0, _locale.t)('Details')
	        ),
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/activity/' },
	          (0, _locale.t)('Comments'),
	          ' ',
	          _react2['default'].createElement(
	            'span',
	            { className: 'badge animated' },
	            group.numComments
	          )
	        ),
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/feedback/' },
	          (0, _locale.t)('User Feedback'),
	          ' ',
	          _react2['default'].createElement(
	            'span',
	            { className: 'badge animated' },
	            group.userReportCount
	          )
	        ),
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/tags/' },
	          (0, _locale.t)('Tags')
	        ),
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' },
	          (0, _locale.t)('Related Events')
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = GroupHeader;
	module.exports = exports['default'];

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _utilsFormatters = __webpack_require__(305);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var GroupSeenBy = _react2['default'].createClass({
	  displayName: 'GroupSeenBy',
	
	  mixins: [_mixinsGroupState2['default'], (0, _mixinsTooltip2['default'])({
	    html: true,
	    selector: '.tip'
	  })],
	
	  render: function render() {
	    var activeUser = _storesConfigStore2['default'].get('user');
	    var group = this.getGroup();
	
	    // NOTE: Sometimes group.seenBy is undefined, even though the /groups/{id} API
	    //       endpoint guarantees an array. We haven't figured out HOW GroupSeenBy
	    //       is getting incomplete group records, but in the interim, we are just
	    //       gracefully handing this case.
	    //
	    // See: https://github.com/getsentry/sentry/issues/2387
	
	    var seenBy = group.seenBy || [];
	    if (seenBy.length === 0) {
	      return null;
	    }
	
	    var seenByNodes = seenBy.filter(function (user, userIdx) {
	      return activeUser.id !== user.id;
	    }).map(function (user, userIdx) {
	      var title = _underscore2['default'].escape((0, _utilsFormatters.userDisplayName)(user)) + '<br/>' + _underscore2['default'].escape((0, _moment2['default'])(user.lastSeen).format('LL'));
	      return _react2['default'].createElement(
	        'li',
	        { key: userIdx, className: 'tip', 'data-title': title },
	        _react2['default'].createElement(_componentsAvatar2['default'], { size: 52, user: user })
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'seen-by' },
	      _react2['default'].createElement(
	        'ul',
	        null,
	        _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement('span', { className: 'icon-eye' })
	        ),
	        seenByNodes
	      )
	    );
	  }
	});
	
	exports['default'] = GroupSeenBy;
	module.exports = exports['default'];

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsEventsEventEntries = __webpack_require__(272);
	
	var _componentsEventsEventEntries2 = _interopRequireDefault(_componentsEventsEventEntries);
	
	var _groupDetailsEventToolbar = __webpack_require__(642);
	
	var _groupDetailsEventToolbar2 = _interopRequireDefault(_groupDetailsEventToolbar);
	
	var _componentsGroupSidebar = __webpack_require__(591);
	
	var _componentsGroupSidebar2 = _interopRequireDefault(_componentsGroupSidebar);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _componentsMutedBox = __webpack_require__(596);
	
	var _componentsMutedBox2 = _interopRequireDefault(_componentsMutedBox);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _locale = __webpack_require__(2);
	
	var GroupEventDetails = _react2['default'].createClass({
	  displayName: 'GroupEventDetails',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsGroupState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      event: null,
	      eventNavLinks: ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.params.eventId !== this.props.params.eventId) {
	      this.fetchData();
	    }
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var eventId = this.props.params.eventId || 'latest';
	
	    var url = eventId === 'latest' || eventId === 'oldest' ? '/issues/' + this.getGroup().id + '/events/' + eventId + '/' : '/events/' + eventId + '/';
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(url, {
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          event: data,
	          error: false,
	          loading: false
	        });
	
	        _this.api.bulkUpdate({
	          orgId: _this.getOrganization().slug,
	          projectId: _this.getProject().slug,
	          itemIds: [_this.getGroup().id],
	          failSilently: true,
	          data: { hasSeen: true }
	        });
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  render: function render() {
	    var group = this.getGroup();
	    var evt = this.state.event;
	    var params = this.props.params;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'event-details-container' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'primary' },
	          evt && _react2['default'].createElement(_groupDetailsEventToolbar2['default'], {
	            group: group,
	            event: evt,
	            orgId: params.orgId,
	            projectId: params.projectId }),
	          group.status != 'unresolved' && _react2['default'].createElement(
	            'div',
	            { className: 'issue-status' },
	            group.status === 'ignored' && _react2['default'].createElement(_componentsMutedBox2['default'], { statusDetails: group.statusDetails }),
	            group.status === 'resolved' && group.statusDetails.inNextRelease && _react2['default'].createElement(
	              'div',
	              { className: 'box' },
	              _react2['default'].createElement('span', { className: 'icon icon-checkmark' }),
	              _react2['default'].createElement(
	                'p',
	                null,
	                (0, _locale.t)('This issue has been marked as being resolved in the next\n                      release. Until then, you will not get notified about new\n                      occurrences.')
	              )
	            ),
	            group.status === 'resolved' && group.statusDetails.autoResolved && _react2['default'].createElement(
	              'div',
	              { className: 'box' },
	              _react2['default'].createElement('span', { className: 'icon icon-checkmark' }),
	              _react2['default'].createElement(
	                'p',
	                null,
	                (0, _locale.t)('This issue was automatically marked as resolved due to\n                      the Auto Resolve configuration for this project.')
	              )
	            )
	          ),
	          this.state.loading ? _react2['default'].createElement(_componentsLoadingIndicator2['default'], null) : this.state.error ? _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData }) : _react2['default'].createElement(_componentsEventsEventEntries2['default'], {
	            group: group,
	            event: evt,
	            orgId: params.orgId,
	            project: this.getProject() })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'secondary' },
	          _react2['default'].createElement(_componentsGroupSidebar2['default'], { group: group })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = GroupEventDetails;
	module.exports = exports['default'];

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsDateTime = __webpack_require__(72);
	
	var _componentsDateTime2 = _interopRequireDefault(_componentsDateTime);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsPagination = __webpack_require__(39);
	
	var _componentsPagination2 = _interopRequireDefault(_componentsPagination);
	
	var _componentsSearchBarJsx = __webpack_require__(189);
	
	var _componentsSearchBarJsx2 = _interopRequireDefault(_componentsSearchBarJsx);
	
	var _locale = __webpack_require__(2);
	
	var GroupEvents = _react2['default'].createClass({
	  displayName: 'GroupEvents',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsGroupState2['default']],
	
	  getInitialState: function getInitialState() {
	    var queryParams = this.props.location.query;
	    return {
	      eventList: [],
	      loading: true,
	      error: false,
	      pageLinks: '',
	      query: queryParams.query || ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.params.groupId !== this.props.params.groupId || nextProps.location.search !== this.props.location.search) {
	      var queryParams = nextProps.location.query;
	      this.setState({
	        query: queryParams.query
	      }, this.fetchData);
	    }
	  },
	
	  onSearch: function onSearch(query) {
	    var targetQueryParams = {};
	    if (query !== '') targetQueryParams.query = query;
	
	    var _props$params = this.props.params;
	    var groupId = _props$params.groupId;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    _reactRouter.browserHistory.pushState(null, '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/', targetQueryParams);
	  },
	
	  getEndpoint: function getEndpoint() {
	    var params = this.props.params;
	    var queryParams = _extends({}, this.props.location.query, {
	      limit: 50,
	      query: this.state.query
	    });
	
	    return '/issues/' + params.groupId + '/events/?' + jQuery.param(queryParams);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var queryParams = this.props.location.query;
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(this.getEndpoint(), {
	      method: 'GET',
	      data: queryParams,
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          eventList: data,
	          error: false,
	          loading: false,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error(err) {
	        var error = err.responseJSON || true;
	        error = error.detail || true;
	        _this.setState({
	          error: error,
	          loading: false
	        });
	      }
	    });
	  },
	
	  getEventTitle: function getEventTitle(event) {
	    switch (event.type) {
	      case 'error':
	        if (event.metadata.type && event.metadata.value) return event.metadata.type + ': ' + event.metadata.value;
	        return event.metadata.type || event.metadata.value || event.metadata.title;
	      case 'csp':
	        return event.metadata.message;
	      case 'default':
	        return event.metadata.title;
	      default:
	        return event.message.split('\n')[0];
	    }
	  },
	
	  renderNoQueryResults: function renderNoQueryResults() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('Sorry, no events match your search query.')
	      )
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('There don\'t seem to be any events yet.')
	      )
	    );
	  },
	
	  renderResults: function renderResults() {
	    var _this2 = this;
	
	    var group = this.getGroup();
	    var tagList = group.tags.filter(function (tag) {
	      return tag.key !== 'user';
	    });
	
	    var hasUser = false;
	    for (var i = 0; i < this.state.eventList.length; i++) {
	      if (this.state.eventList[i].user) {
	        hasUser = true;
	        break;
	      }
	    }
	
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	    var groupId = _props$params2.groupId;
	
	    var children = this.state.eventList.map(function (event) {
	      var tagMap = {};
	      event.tags.forEach(function (tag) {
	        tagMap[tag.key] = tag.value;
	      });
	
	      return _react2['default'].createElement(
	        'tr',
	        { key: event.id },
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(
	            'h5',
	            null,
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/events/' + event.id + '/' },
	              _react2['default'].createElement(_componentsDateTime2['default'], { date: event.dateCreated })
	            ),
	            _react2['default'].createElement(
	              'small',
	              null,
	              (_this2.getEventTitle(event) || '').substr(0, 100)
	            )
	          )
	        ),
	        tagList.map(function (tag) {
	          return _react2['default'].createElement(
	            'td',
	            { key: tag.key },
	            tagMap[tag.key]
	          );
	        }),
	        hasUser && _react2['default'].createElement(
	          'td',
	          { className: 'event-user table-user-info' },
	          event.user ? _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(_componentsAvatar2['default'], { user: event.user, size: 64, className: 'avatar',
	              gravatar: false }),
	            event.user.email
	          ) : _react2['default'].createElement(
	            'span',
	            null,
	            '—'
	          )
	        )
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'event-list' },
	        _react2['default'].createElement(
	          'table',
	          { className: 'table' },
	          _react2['default'].createElement(
	            'thead',
	            null,
	            _react2['default'].createElement(
	              'tr',
	              null,
	              _react2['default'].createElement(
	                'th',
	                null,
	                (0, _locale.t)('ID')
	              ),
	              tagList.map(function (tag) {
	                return _react2['default'].createElement(
	                  'th',
	                  { key: tag.key },
	                  tag.name
	                );
	              }),
	              hasUser && _react2['default'].createElement(
	                'th',
	                null,
	                (0, _locale.t)('User')
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'tbody',
	            null,
	            children
	          )
	        )
	      ),
	      _react2['default'].createElement(_componentsPagination2['default'], { pageLinks: this.state.pageLinks })
	    );
	  },
	
	  renderBody: function renderBody() {
	    var body = undefined;
	
	    if (this.state.loading) body = _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) body = _react2['default'].createElement(_componentsLoadingError2['default'], { message: this.state.error, onRetry: this.fetchData });else if (this.state.eventList.length > 0) body = this.renderResults();else if (this.state.query && this.state.query !== '') body = this.renderNoQueryResults();else body = this.renderEmpty();
	
	    return body;
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { style: { marginBottom: 20 } },
	        _react2['default'].createElement(_componentsSearchBarJsx2['default'], { defaultQuery: '',
	          placeholder: (0, _locale.t)('search event message or tags'),
	          query: this.state.query,
	          onSearch: this.onSearch })
	      ),
	      this.renderBody()
	    );
	  }
	});
	
	exports['default'] = GroupEvents;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsPagination = __webpack_require__(39);
	
	var _componentsPagination2 = _interopRequireDefault(_componentsPagination);
	
	var _locale = __webpack_require__(2);
	
	var GroupHashes = _react2['default'].createClass({
	  displayName: 'GroupHashes',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsGroupState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      hashList: [],
	      loading: true,
	      error: false,
	      pageLinks: ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.params.groupId !== this.props.params.groupId) {
	      this.setState({
	        hashList: [],
	        loading: true,
	        error: false
	      }, this.fetchData);
	    }
	  },
	
	  getEndpoint: function getEndpoint() {
	    var params = this.props.params;
	    var queryParams = _extends({}, this.props.location.query, {
	      limit: 50
	    });
	
	    return '/issues/' + params.groupId + '/hashes/?' + jQuery.param(queryParams);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var queryParams = this.props.location.query;
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(this.getEndpoint(), {
	      method: 'GET',
	      data: queryParams,
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          hashList: data,
	          error: false,
	          loading: false,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error(_error) {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('There don\'t seem to be any hashes for this issue.')
	      )
	    );
	  },
	
	  renderResults: function renderResults() {
	    var children = this.state.hashList.map(function (hash) {
	      return _react2['default'].createElement(
	        'tr',
	        { key: hash.id },
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(
	            'h5',
	            null,
	            hash.id
	          )
	        )
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'table',
	        { className: 'table' },
	        _react2['default'].createElement(
	          'thead',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement(
	              'th',
	              null,
	              (0, _locale.t)('ID')
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          children
	        )
	      ),
	      _react2['default'].createElement(_componentsPagination2['default'], { pageLinks: this.state.pageLinks })
	    );
	  },
	
	  renderBody: function renderBody() {
	    var body = undefined;
	
	    if (this.state.loading) body = _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) body = _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });else if (this.state.hashList.length > 0) body = this.renderResults();else body = this.renderEmpty();
	
	    return body;
	  },
	
	  render: function render() {
	    return this.renderBody();
	  }
	});
	
	exports['default'] = GroupHashes;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint react/jsx-key:0*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsPagination = __webpack_require__(39);
	
	var _componentsPagination2 = _interopRequireDefault(_componentsPagination);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _utils = __webpack_require__(7);
	
	var _locale = __webpack_require__(2);
	
	var GroupTagValues = _react2['default'].createClass({
	  displayName: 'GroupTagValues',
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      tagKey: null,
	      tagValueList: null,
	      loading: true,
	      error: false,
	      pageLinks: ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.location.search !== this.props.location.search) {
	      this.fetchData();
	    }
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var params = this.props.params;
	    var queryParams = this.props.location.query;
	    var querystring = _jquery2['default'].param(queryParams);
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request('/issues/' + params.groupId + '/tags/' + params.tagKey + '/', {
	      success: function success(data) {
	        _this.setState({
	          tagKey: data,
	          loading: _this.state.tagValueList === null
	        });
	      },
	      error: function error(_error) {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	
	    this.api.request('/issues/' + params.groupId + '/tags/' + params.tagKey + '/values/?' + querystring, {
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          tagValueList: data,
	          loading: _this.state.tagKey === null,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error(_error2) {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  getUserDisplayName: function getUserDisplayName(item) {
	    return item.email || item.username || item.identifier || item.ipAddress || item.value;
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    if (this.state.loading) {
	      return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);
	    } else if (this.state.error) {
	      return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	    }
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    var tagKey = this.state.tagKey;
	    var children = this.state.tagValueList.map(function (tagValue, tagValueIdx) {
	      var pct = (0, _utils.percent)(tagValue.count, tagKey.totalValues).toFixed(2);
	      return _react2['default'].createElement(
	        'tr',
	        { key: tagValueIdx },
	        _react2['default'].createElement(
	          'td',
	          { className: 'bar-cell' },
	          _react2['default'].createElement('span', { className: 'bar', style: { width: pct + '%' } }),
	          _react2['default'].createElement(
	            'span',
	            { className: 'label' },
	            pct,
	            '%'
	          )
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(
	            _reactRouter.Link,
	            {
	              to: {
	                pathname: '/' + orgId + '/' + projectId + '/',
	                query: { query: tagKey.key + ':"' + tagValue.value + '"' }
	              } },
	            tagKey.key === 'user' ? [_react2['default'].createElement(_componentsAvatar2['default'], { user: tagValue, size: 16, className: 'avatar' }), _react2['default'].createElement(
	              'span',
	              { style: { marginLeft: 10 } },
	              _this2.getUserDisplayName(tagValue)
	            )] : (0, _utils.deviceNameMapper)(tagValue.name)
	          ),
	          tagValue.email && _react2['default'].createElement(
	            'a',
	            { href: 'mailto:' + tagValue.email, className: 'external-icon' },
	            _react2['default'].createElement('em', { className: 'icon-envelope' })
	          ),
	          (0, _utils.isUrl)(tagValue.value) && _react2['default'].createElement(
	            'a',
	            { href: tagValue.value, className: 'external-icon' },
	            _react2['default'].createElement('em', { className: 'icon-open' })
	          )
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(_componentsTimeSince2['default'], { date: tagValue.lastSeen })
	        )
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h3',
	        null,
	        tagKey.key == 'user' ? (0, _locale.t)('Affected Users') : tagKey.name,
	        _react2['default'].createElement(
	          'a',
	          { href: 'export/', className: 'btn btn-default btn-sm',
	            style: { marginLeft: 10 } },
	          (0, _locale.t)('Export to CSV')
	        )
	      ),
	      _react2['default'].createElement(
	        'table',
	        { className: 'table table-striped' },
	        _react2['default'].createElement(
	          'thead',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement(
	              'th',
	              { style: { width: 30 } },
	              '%'
	            ),
	            _react2['default'].createElement('th', null),
	            _react2['default'].createElement(
	              'th',
	              { style: { width: 200 } },
	              (0, _locale.t)('Last Seen')
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          children
	        )
	      ),
	      _react2['default'].createElement(_componentsPagination2['default'], { pageLinks: this.state.pageLinks }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'small',
	          null,
	          (0, _locale.t)('Note: Percentage of issue is based on events seen in the last 7 days.')
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = GroupTagValues;
	module.exports = exports['default'];

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsCount = __webpack_require__(71);
	
	var _componentsCount2 = _interopRequireDefault(_componentsCount);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _utils = __webpack_require__(7);
	
	var _locale = __webpack_require__(2);
	
	var GroupTags = _react2['default'].createClass({
	  displayName: 'GroupTags',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsGroupState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      tagList: null,
	      loading: true,
	      error: false
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    // TODO(dcramer): each tag should be a separate query as the tags endpoint
	    // is not performant
	    this.api.request('/issues/' + this.getGroup().id + '/tags/', {
	      success: function success(data) {
	        if (!_this.isMounted()) {
	          return;
	        }
	        _this.setState({
	          tagList: data,
	          error: false,
	          loading: false
	        });
	      },
	      error: function error(_error) {
	        if (!_this.isMounted()) {
	          return;
	        }
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  getTagsDocsUrl: function getTagsDocsUrl() {
	    return 'https://docs.sentry.io/hosted/learn/context/';
	  },
	
	  render: function render() {
	    if (this.state.loading) {
	      return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);
	    } else if (this.state.error) {
	      return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	    }
	
	    var children = [];
	
	    var orgId = this.getOrganization().slug;
	    var projectId = this.getProject().slug;
	    var groupId = this.getGroup().id;
	
	    if (this.state.tagList) {
	      children = this.state.tagList.map(function (tag, tagIdx) {
	        var valueChildren = tag.topValues.map(function (tagValue, tagValueIdx) {
	          var pct = (0, _utils.percent)(tagValue.count, tag.totalValues);
	          return _react2['default'].createElement(
	            'li',
	            { key: tagValueIdx },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              {
	                className: 'tag-bar',
	                to: {
	                  pathname: '/' + orgId + '/' + projectId + '/',
	                  query: { query: tag.key + ':' + '"' + tagValue.value + '"' }
	                } },
	              _react2['default'].createElement('span', { className: 'tag-bar-background', style: { width: pct + '%' } }),
	              _react2['default'].createElement(
	                'span',
	                { className: 'tag-bar-label' },
	                (0, _utils.deviceNameMapper)(tagValue.name)
	              ),
	              _react2['default'].createElement(
	                'span',
	                { className: 'tag-bar-count' },
	                _react2['default'].createElement(_componentsCount2['default'], { value: tagValue.count })
	              )
	            )
	          );
	        });
	
	        return _react2['default'].createElement(
	          'div',
	          { className: 'col-md-6', key: tagIdx },
	          _react2['default'].createElement(
	            'div',
	            { className: 'box' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'box-header' },
	              _react2['default'].createElement(
	                'span',
	                { className: 'pull-right' },
	                _react2['default'].createElement(
	                  _reactRouter.Link,
	                  { className: 'btn btn-default btn-sm', to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/tags/' + tag.key + '/' },
	                  (0, _locale.t)('More Details')
	                )
	              ),
	              _react2['default'].createElement(
	                'h5',
	                null,
	                tag.name,
	                ' (',
	                _react2['default'].createElement(_componentsCount2['default'], { value: tag.uniqueValues }),
	                ')'
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'box-content with-padding' },
	              _react2['default'].createElement(
	                'ul',
	                { className: 'list-unstyled' },
	                valueChildren
	              )
	            )
	          )
	        );
	      });
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'row' },
	      children,
	      _react2['default'].createElement(
	        'div',
	        { className: 'col-md-12' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'alert alert-block alert-info' },
	          'Tags are automatically indexed for searching and breakdown charts. Learn how to ',
	          _react2['default'].createElement(
	            'a',
	            { href: this.getTagsDocsUrl() },
	            'add custom tags to issues'
	          ),
	          '.'
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = GroupTags;
	module.exports = exports['default'];

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _mixinsGroupState = __webpack_require__(48);
	
	var _mixinsGroupState2 = _interopRequireDefault(_mixinsGroupState);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _locale = __webpack_require__(2);
	
	var GroupUserReports = _react2['default'].createClass({
	  displayName: 'GroupUserReports',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsGroupState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      reportList: [],
	      pageLinks: ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.location.search !== this.props.location.search) {
	      this.fetchData();
	    }
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var queryParams = this.props.params;
	    var querystring = _jquery2['default'].param(queryParams);
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request('/issues/' + this.getGroup().id + '/user-reports/?' + querystring, {
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          error: false,
	          loading: false,
	          reportList: data,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error(_error) {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  getUserReportsUrl: function getUserReportsUrl() {
	    var params = this.props.params;
	
	    return '/' + params.orgId + '/' + params.projectId + '/settings/user-feedback/';
	  },
	
	  render: function render() {
	    if (this.state.loading) {
	      return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);
	    } else if (this.state.error) {
	      return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	    }
	
	    var children = this.state.reportList.map(function (item, itemIdx) {
	      var body = _utils2['default'].nl2br(_utils2['default'].urlize(_utils2['default'].escape(item.comments)));
	
	      return _react2['default'].createElement(
	        'li',
	        { className: 'activity-note', key: itemIdx },
	        _react2['default'].createElement(_componentsAvatar2['default'], { user: item, size: 64, className: 'avatar' }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'activity-bubble' },
	          _react2['default'].createElement(_componentsTimeSince2['default'], { date: item.dateCreated }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'activity-author' },
	            item.name,
	            ' ',
	            _react2['default'].createElement(
	              'small',
	              null,
	              item.email
	            )
	          ),
	          _react2['default'].createElement('p', { dangerouslySetInnerHTML: { __html: body } })
	        )
	      );
	    });
	
	    if (children.length) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-9' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'activity-container' },
	            _react2['default'].createElement(
	              'ul',
	              { className: 'activity' },
	              children
	            )
	          )
	        )
	      );
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('No user reports have been collected for this event.')
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: this.getUserReportsUrl() },
	          (0, _locale.t)('Learn how to integrate User Feedback')
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = GroupUserReports;
	module.exports = exports['default'];

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _locale = __webpack_require__(2);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesConfigStore = __webpack_require__(27);
	
	var _storesConfigStore2 = _interopRequireDefault(_storesConfigStore);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _options = __webpack_require__(300);
	
	var InstallWizardSettings = _react2['default'].createClass({
	  displayName: 'InstallWizardSettings',
	
	  propTypes: {
	    options: _react2['default'].PropTypes.object.isRequired,
	    formDisabled: _react2['default'].PropTypes.bool,
	    onSubmit: _react2['default'].PropTypes.func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var options = _extends({}, this.props.options);
	    var requiredOptions = Object.keys(_underscore2['default'].pick(options, function (option) {
	      return option.field.required && !option.field.disabled;
	    }));
	    var missingOptions = new Set(requiredOptions.filter(function (option) {
	      return !options[option].field.isSet;
	    }));
	    // This is to handle the initial installation case.
	    // Even if all options are filled out, we want to prompt to confirm
	    // them. This is a bit of a hack because we're assuming that
	    // the backend only spit back all filled out options for
	    // this case.
	    if (missingOptions.size === 0) {
	      missingOptions = new Set(requiredOptions);
	    }
	
	    // A mapping of option name to Field object
	    var fields = {};
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = missingOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var key = _step.value;
	
	        var option = options[key];
	        if (!option.field.isSet) {
	          var o = (0, _options.getOption)(key);
	          option.value = o.defaultValue ? o.defaultValue() : '';
	        }
	        fields[key] = (0, _options.getOptionField)(key, this.onFieldChange.bind(this, key), option.value, option.field);
	        // options is used for submitting to the server, and we dont submit values
	        // that are deleted
	        if (option.field.disabled) {
	          delete options[key];
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return {
	      options: options,
	      required: requiredOptions,
	      fields: fields
	    };
	  },
	
	  onFieldChange: function onFieldChange(name, value) {
	    var options = _extends({}, this.state.options);
	    options[name].value = value;
	    this.setState({
	      options: options
	    });
	  },
	
	  onSubmit: function onSubmit(e) {
	    e.preventDefault();
	    this.props.onSubmit(this.state.options);
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var fields = _state.fields;
	    var required = _state.required;
	    var options = _state.options;
	
	    var formValid = !required.filter(function (option) {
	      return !options[option].field.allowEmpty && !options[option].value;
	    }).length;
	    var disabled = !formValid || this.props.formDisabled;
	
	    return _react2['default'].createElement(
	      'form',
	      { onSubmit: this.onSubmit },
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Welcome to Sentry, yo! Complete setup by filling out the required configuration.'
	      ),
	      (0, _options.getForm)(fields),
	      _react2['default'].createElement(
	        'div',
	        { className: 'form-actions', style: { marginTop: 25 } },
	        _react2['default'].createElement(
	          'button',
	          { className: 'btn btn-primary',
	            disabled: disabled,
	            type: 'submit' },
	          (0, _locale.t)('Continue')
	        )
	      )
	    );
	  }
	});
	
	var InstallWizard = _react2['default'].createClass({
	  displayName: 'InstallWizard',
	
	  propTypes: {
	    onConfigured: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      options: {},
	      submitError: false,
	      submitErrorType: null,
	      submitInProgress: false
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	    jQuery(document.body).addClass('install-wizard');
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    jQuery(document.body).removeClass('install-wizard');
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  fetchData: function fetchData(callback) {
	    var _this = this;
	
	    // TODO(dcramer): ideally this would only be fetching options that aren't
	    // already configured
	    this.api.request('/internal/options/?query=is:required', {
	      method: 'GET',
	      success: function success(data) {
	        _this.setState({
	          options: data,
	          loading: false,
	          error: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  onSubmit: function onSubmit(options) {
	    var _this2 = this;
	
	    this.setState({
	      submitInProgress: true,
	      submitError: false
	    });
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	
	    // We only want to send back the values which weren't disabled
	    var data = _underscore2['default'].mapObject(_underscore2['default'].pick(options, function (option) {
	      return !option.field.disabled;
	    }), function (option) {
	      return option.value;
	    });
	    this.api.request('/internal/options/', {
	      method: 'PUT',
	      data: data,
	      success: function success() {
	        _this2.setState({
	          submitInProgress: false
	        });
	        _this2.props.onConfigured();
	      },
	      error: function error(xhr, textStatus, errorThrown) {
	        var err = {};
	        try {
	          err = xhr.responseJSON;
	        } catch (ex) {
	          // ...
	        }
	        var errorMessage = '';
	        if (err.detail) {
	          // err.detail comes back on some API responses
	          // specifically on a failed CSRF
	          errorMessage = err.detail;
	        } else {
	          switch (err.error) {
	            case 'unknown_option':
	              errorMessage = (0, _locale.t)('An invalid option (%s) was passed to the server. Please report this issue to the Sentry team.', err.errorDetail.option);
	              break;
	            case 'invalid_type':
	              errorMessage = (0, _locale.t)('An invalid value for (%s) was passed to the server.', err.errorDetail.option);
	              break;
	            default:
	              errorMessage = (0, _locale.t)('An unknown error occurred. Please take a look at the service logs.');
	          }
	        }
	        _this2.setState({
	          submitInProgress: false,
	          submitError: true,
	          submitErrorMessage: errorMessage,
	          submitErrorType: err.error
	        });
	      },
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  render: function render() {
	    var _state2 = this.state;
	    var error = _state2.error;
	    var loading = _state2.loading;
	    var options = _state2.options;
	    var submitError = _state2.submitError;
	    var submitErrorMessage = _state2.submitErrorMessage;
	    var submitInProgress = _state2.submitInProgress;
	
	    var version = _storesConfigStore2['default'].get('version');
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { title: (0, _locale.t)('Sentry Setup') },
	      _react2['default'].createElement(
	        'div',
	        { className: 'app' },
	        _react2['default'].createElement('div', { className: 'pattern' }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'setup-wizard' },
	          _react2['default'].createElement(
	            'h1',
	            null,
	            _react2['default'].createElement(
	              'span',
	              null,
	              (0, _locale.t)('Welcome to Sentry')
	            ),
	            _react2['default'].createElement(
	              'small',
	              null,
	              version.current
	            )
	          ),
	          loading ? _react2['default'].createElement(
	            _componentsLoadingIndicator2['default'],
	            null,
	            (0, _locale.t)('Please wait while we load configuration.')
	          ) : error ? _react2['default'].createElement(
	            'div',
	            { className: 'loading-error' },
	            _react2['default'].createElement('span', { className: 'icon-exclamation' }),
	            (0, _locale.t)('We were unable to load the required configuration from the Sentry server. Please take a look at the service logs.')
	          ) : _react2['default'].createElement(
	            'div',
	            null,
	            submitError && _react2['default'].createElement(
	              'div',
	              { className: 'alert alert-block alert-error' },
	              submitErrorMessage
	            ),
	            _react2['default'].createElement(InstallWizardSettings, {
	              options: options,
	              onSubmit: this.onSubmit,
	              formDisabled: submitInProgress })
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = InstallWizard;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsOrganizationIssueList = __webpack_require__(184);
	
	var _componentsOrganizationIssueList2 = _interopRequireDefault(_componentsOrganizationIssueList);
	
	var _locale = __webpack_require__(2);
	
	var AssignedToMe = _react2['default'].createClass({
	  displayName: 'AssignedToMe',
	
	  getEndpoint: function getEndpoint() {
	    return '/organizations/' + this.props.params.orgId + '/members/me/issues/assigned/';
	  },
	
	  getTitle: function getTitle() {
	    return (0, _locale.t)('Assigned to me');
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(_componentsOrganizationIssueList2['default'], _extends({
	      title: this.getTitle(),
	      endpoint: this.getEndpoint()
	    }, this.props));
	  }
	});
	
	exports['default'] = AssignedToMe;
	module.exports = exports['default'];

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsOrganizationIssueList = __webpack_require__(184);
	
	var _componentsOrganizationIssueList2 = _interopRequireDefault(_componentsOrganizationIssueList);
	
	var _locale = __webpack_require__(2);
	
	var Bookmarked = _react2['default'].createClass({
	  displayName: 'Bookmarked',
	
	  getEndpoint: function getEndpoint() {
	    return '/organizations/' + this.props.params.orgId + '/members/me/issues/bookmarked/';
	  },
	
	  getTitle: function getTitle() {
	    return (0, _locale.t)('Bookmarks');
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(_componentsOrganizationIssueList2['default'], _extends({
	      title: this.getTitle(),
	      endpoint: this.getEndpoint()
	    }, this.props));
	  }
	});
	
	exports['default'] = Bookmarked;
	module.exports = exports['default'];

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsOrganizationIssueList = __webpack_require__(184);
	
	var _componentsOrganizationIssueList2 = _interopRequireDefault(_componentsOrganizationIssueList);
	
	var _locale = __webpack_require__(2);
	
	var Viewed = _react2['default'].createClass({
	  displayName: 'Viewed',
	
	  getEndpoint: function getEndpoint() {
	    return '/organizations/' + this.props.params.orgId + '/members/me/issues/viewed/';
	  },
	
	  getTitle: function getTitle() {
	    return (0, _locale.t)('History');
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(_componentsOrganizationIssueList2['default'], _extends({
	      title: this.getTitle(),
	      endpoint: this.getEndpoint()
	    }, this.props));
	  }
	});
	
	exports['default'] = Viewed;
	module.exports = exports['default'];

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsDateTime = __webpack_require__(72);
	
	var _componentsDateTime2 = _interopRequireDefault(_componentsDateTime);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsOrganizationsHomeContainer = __webpack_require__(64);
	
	var _componentsOrganizationsHomeContainer2 = _interopRequireDefault(_componentsOrganizationsHomeContainer);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _componentsPagination = __webpack_require__(39);
	
	var _componentsPagination2 = _interopRequireDefault(_componentsPagination);
	
	var _componentsSelectInput = __webpack_require__(190);
	
	var _componentsSelectInput2 = _interopRequireDefault(_componentsSelectInput);
	
	var _locale = __webpack_require__(2);
	
	var EVENT_TYPES = ['member.invite', 'member.add', 'member.accept-invite', 'member.remove', 'member.edit', 'member.join-team', 'member.leave-team', 'team.create', 'team.edit', 'team.remove', 'project.create', 'project.edit', 'project.remove', 'project.set-public', 'project.set-private', 'org.create', 'org.edit', 'org.remove', 'tagkey.remove', 'projectkey.create', 'projectkey.edit', 'projectkey.remove', 'projectkey.enable', 'projectkey.disable', 'sso.enable', 'sso.disable', 'sso.edit', 'sso-identity.link', 'api-key.create', 'api-key.edit', 'api-key.remove'].sort();
	
	var OrganizationAuditLog = _react2['default'].createClass({
	  displayName: 'OrganizationAuditLog',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      entryList: []
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.location.search !== this.props.location.search || nextProps.params.orgId !== this.props.params.orgId) {
	      this.remountComponent();
	    }
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.setState({
	      loading: true
	    });
	
	    this.api.request(this.getEndpoint(), {
	      query: this.props.location.query,
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          loading: false,
	          error: false,
	          entryList: data,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  getEndpoint: function getEndpoint() {
	    return '/organizations/' + this.props.params.orgId + '/audit-logs/';
	  },
	
	  getTitle: function getTitle() {
	    var org = this.context.organization;
	    return org.name + ' Audit Log';
	  },
	
	  onEventSelect: function onEventSelect(sel) {
	    var value = sel.val();
	    if (this.props.location.query.event === value) {
	      return;
	    }
	    var queryParams = {
	      event: value
	    };
	    _reactRouter.browserHistory.pushState(null, this.props.location.pathname, queryParams);
	  },
	
	  renderResults: function renderResults() {
	    if (this.state.entryList.length === 0) {
	      return _react2['default'].createElement(
	        'tr',
	        null,
	        _react2['default'].createElement(
	          'td',
	          { colSpan: '4' },
	          (0, _locale.t)('No results found.')
	        )
	      );
	    }
	
	    return this.state.entryList.map(function (entry) {
	      return _react2['default'].createElement(
	        'tr',
	        { key: entry.id },
	        _react2['default'].createElement(
	          'td',
	          { className: 'table-user-info' },
	          entry.actor.email && _react2['default'].createElement(_componentsAvatar2['default'], { user: entry.actor }),
	          _react2['default'].createElement(
	            'h5',
	            null,
	            entry.actor.name
	          ),
	          entry.note
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          entry.event
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          entry.ipAddress
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(_componentsDateTime2['default'], { date: entry.dateCreated })
	        )
	      );
	    });
	  },
	
	  render: function render() {
	    var currentEventType = this.props.location.query.event;
	
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { title: this.getTitle() },
	      _react2['default'].createElement(
	        _componentsOrganizationsHomeContainer2['default'],
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _locale.t)('Audit Log')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'pull-right' },
	          _react2['default'].createElement(
	            'form',
	            { className: 'form-horizontal', style: { marginBottom: 20 } },
	            _react2['default'].createElement(
	              'div',
	              { className: 'control-group' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'controls' },
	                _react2['default'].createElement(
	                  _componentsSelectInput2['default'],
	                  { name: 'event', onChange: this.onEventSelect,
	                    value: currentEventType, style: { width: 250 } },
	                  _react2['default'].createElement(
	                    'option',
	                    { key: 'any', value: '' },
	                    (0, _locale.t)('Any')
	                  ),
	                  EVENT_TYPES.map(function (eventType) {
	                    return _react2['default'].createElement(
	                      'option',
	                      { key: eventType },
	                      eventType
	                    );
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.t)('Sentry keeps track of important events within your organization.')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'panel panel-default horizontal-scroll c-b' },
	          _react2['default'].createElement(
	            'table',
	            { className: 'table' },
	            _react2['default'].createElement(
	              'thead',
	              null,
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'th',
	                  null,
	                  (0, _locale.t)('Member')
	                ),
	                _react2['default'].createElement(
	                  'th',
	                  null,
	                  (0, _locale.t)('Action')
	                ),
	                _react2['default'].createElement(
	                  'th',
	                  null,
	                  (0, _locale.t)('IP')
	                ),
	                _react2['default'].createElement(
	                  'th',
	                  null,
	                  (0, _locale.t)('Time')
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'tbody',
	              null,
	              this.state.loading ? _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'td',
	                  { colSpan: '4' },
	                  _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	                )
	              ) : this.state.error ? _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'td',
	                  { colSpan: '4' },
	                  _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData })
	                )
	              ) : this.renderResults()
	            )
	          )
	        ),
	        this.state.pageLinks && _react2['default'].createElement(_componentsPagination2['default'], _extends({ pageLinks: this.state.pageLinks }, this.props))
	      )
	    );
	  }
	});
	
	exports['default'] = OrganizationAuditLog;
	module.exports = exports['default'];

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _reactRouter = __webpack_require__(8);
	
	var _reactSparklines = __webpack_require__(367);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _actionCreatorsProjects = __webpack_require__(130);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _storesTeamStore = __webpack_require__(141);
	
	var _storesTeamStore2 = _interopRequireDefault(_storesTeamStore);
	
	var _componentsActivityFeed = __webpack_require__(537);
	
	var _componentsActivityFeed2 = _interopRequireDefault(_componentsActivityFeed);
	
	var _componentsEventsEventsPerHour = __webpack_require__(558);
	
	var _componentsEventsEventsPerHour2 = _interopRequireDefault(_componentsEventsEventsPerHour);
	
	var _componentsIssueList = __webpack_require__(181);
	
	var _componentsIssueList2 = _interopRequireDefault(_componentsIssueList);
	
	var _componentsOrganizationsHomeContainer = __webpack_require__(64);
	
	var _componentsOrganizationsHomeContainer2 = _interopRequireDefault(_componentsOrganizationsHomeContainer);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _locale = __webpack_require__(2);
	
	var _utils = __webpack_require__(7);
	
	var AssignedIssues = _react2['default'].createClass({
	  displayName: 'AssignedIssues',
	
	  propTypes: {
	    statsPeriod: _react2['default'].PropTypes.string,
	    pageSize: _react2['default'].PropTypes.number
	  },
	
	  getEndpoint: function getEndpoint() {
	    return '/organizations/' + this.props.params.orgId + '/members/me/issues/assigned/?';
	  },
	
	  getViewMoreLink: function getViewMoreLink() {
	    return '/organizations/' + this.props.params.orgId + '/issues/assigned/';
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty' },
	      (0, _locale.t)('No issues have been assigned to you.')
	    );
	  },
	
	  refresh: function refresh() {
	    this.refs.issueList.remountComponent();
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'pull-right' },
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { className: 'btn btn-sm btn-default', to: this.getViewMoreLink() },
	          (0, _locale.t)('View more')
	        ),
	        _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-sm btn-default', style: { marginLeft: 5 },
	            onClick: this.refresh },
	          _react2['default'].createElement('span', { className: 'icon icon-refresh' })
	        )
	      ),
	      _react2['default'].createElement(
	        'h4',
	        null,
	        'Assigned to me'
	      ),
	      _react2['default'].createElement(_componentsIssueList2['default'], _extends({ endpoint: this.getEndpoint(), query: {
	          statsPeriod: this.props.statsPeriod,
	          per_page: this.props.pageSize,
	          status: 'unresolved'
	        }, pagination: false, renderEmpty: this.renderEmpty,
	        ref: 'issueList' }, this.props))
	    );
	  }
	});
	
	var NewIssues = _react2['default'].createClass({
	  displayName: 'NewIssues',
	
	  propTypes: {
	    statsPeriod: _react2['default'].PropTypes.string,
	    pageSize: _react2['default'].PropTypes.number
	  },
	
	  getEndpoint: function getEndpoint() {
	    return '/organizations/' + this.props.params.orgId + '/issues/new/';
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty' },
	      (0, _locale.t)('No new issues have been seen in the last week.')
	    );
	  },
	
	  refresh: function refresh() {
	    this.refs.issueList.remountComponent();
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'pull-right' },
	        _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-sm btn-default', style: { marginLeft: 5 },
	            onClick: this.refresh },
	          _react2['default'].createElement('span', { className: 'icon icon-refresh' })
	        )
	      ),
	      _react2['default'].createElement(
	        'h4',
	        null,
	        'New this week'
	      ),
	      _react2['default'].createElement(_componentsIssueList2['default'], _extends({ endpoint: this.getEndpoint(), query: {
	          statsPeriod: this.props.statsPeriod,
	          per_page: this.props.pageSize,
	          status: 'unresolved'
	        }, pagination: false, renderEmpty: this.renderEmpty,
	        ref: 'issueList' }, this.props))
	    );
	  }
	});
	
	function ProjectSparkline(props) {
	  var values = props.data.map(function (tuple) {
	    return tuple[1];
	  });
	
	  return _react2['default'].createElement(
	    _reactSparklines.Sparklines,
	    { data: values, width: 100, height: 32 },
	    _react2['default'].createElement(_reactSparklines.SparklinesLine, _extends({}, props, { style: { stroke: '#8f85d4', fill: 'none', strokeWidth: 3 } }))
	  );
	}
	ProjectSparkline.propTypes = {
	  data: _react2['default'].PropTypes.array.isRequired
	};
	
	var ProjectList = _react2['default'].createClass({
	  displayName: 'ProjectList',
	
	  propTypes: {
	    teams: _react2['default'].PropTypes.array,
	    maxProjects: _react2['default'].PropTypes.number
	  },
	
	  mixins: [_mixinsOrganizationState2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      maxProjects: 8
	    };
	  },
	
	  render: function render() {
	    var org = this.getOrganization();
	    var maxProjects = this.props.maxProjects;
	
	    var projects = [];
	    this.props.teams.forEach(function (team) {
	      if (team.isMember) {
	        team.projects.forEach(function (project) {
	          projects.push(_extends({}, project, { teamName: team.name }));
	        });
	      }
	    });
	
	    projects = (0, _utils.sortArray)(projects, function (item) {
	      return [!item.isBookmarked, item.teamName, item.name];
	    });
	
	    // project list is
	    // a) all bookmarked projects
	    // b) if bookmarked projcets < maxProjects, then fill with sorted projects until maxProjects
	
	    var bookmarkedProjects = projects.filter(function (p) {
	      return p.isBookmarked;
	    });
	    if (bookmarkedProjects.length < maxProjects) {
	      projects = bookmarkedProjects.concat(projects.slice(bookmarkedProjects.length, maxProjects));
	    } else {
	      projects = bookmarkedProjects;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'organization-dashboard-projects' },
	      _react2['default'].createElement(
	        _reactRouter.Link,
	        { className: 'btn-sidebar-header', to: '/organizations/' + org.slug + '/teams/' },
	        'View All'
	      ),
	      _react2['default'].createElement(
	        'h6',
	        { className: 'nav-header' },
	        'Projects'
	      ),
	      bookmarkedProjects.length === 0 && _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-info', style: { marginBottom: 10 } },
	        'Bookmark your most used ',
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: '/organizations/' + org.slug + '/teams/' },
	          'projects'
	        ),
	        ' to have them appear here.'
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'nav nav-stacked' },
	        projects.map(function (project) {
	          return _react2['default'].createElement(
	            'li',
	            { key: project.id },
	            _react2['default'].createElement(
	              'div',
	              { className: 'pull-right sparkline' },
	              project.stats && _react2['default'].createElement(ProjectSparkline, { data: project.stats })
	            ),
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/' + org.slug + '/' + project.slug + '/' },
	              _react2['default'].createElement(
	                'h4',
	                null,
	                project.isBookmarked && _react2['default'].createElement('span', { className: 'bookmark icon-star-solid' }),
	                project.name
	              ),
	              _react2['default'].createElement(
	                'h5',
	                null,
	                project.teamName
	              )
	            )
	          );
	        })
	      )
	    );
	  }
	});
	
	var Activity = _react2['default'].createClass({
	  displayName: 'Activity',
	
	  getEndpoint: function getEndpoint() {
	    return '/organizations/' + this.props.params.orgId + '/activity/';
	  },
	
	  refresh: function refresh() {
	    this.refs.activityFeed.remountComponent();
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'pull-right' },
	        _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-sm btn-default', style: { marginLeft: 5 },
	            onClick: this.refresh },
	          _react2['default'].createElement('span', { className: 'icon icon-refresh' })
	        )
	      ),
	      _react2['default'].createElement(
	        'h4',
	        null,
	        'Recent activity'
	      ),
	      _react2['default'].createElement(_componentsActivityFeed2['default'], _extends({ ref: 'activityFeed', endpoint: this.getEndpoint(), query: {
	          per_page: 10
	        }, pagination: false }, this.props))
	    );
	  }
	});
	
	var OrganizationDashboard = _react2['default'].createClass({
	  displayName: 'OrganizationDashboard',
	
	  mixins: [_mixinsApiMixin2['default'], _reflux2['default'].listenTo(_storesTeamStore2['default'], 'onTeamListChange')],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      statsPeriod: '24h',
	      pageSize: 5
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      teams: _storesTeamStore2['default'].getAll()
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    (0, _actionCreatorsProjects.loadStats)(this.api, {
	      orgId: this.props.params.orgId,
	      query: {
	        since: new Date().getTime() / 1000 - 3600 * 24,
	        stat: 'generated',
	        group: 'project'
	      }
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _storesGroupStore2['default'].reset();
	  },
	
	  onTeamListChange: function onTeamListChange() {
	    this.setState({
	      teams: _storesTeamStore2['default'].getAll()
	    });
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _componentsOrganizationsHomeContainer2['default'],
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-8' },
	          _react2['default'].createElement(AssignedIssues, this.props),
	          _react2['default'].createElement(NewIssues, this.props),
	          _react2['default'].createElement(Activity, this.props)
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-4' },
	          _react2['default'].createElement(_componentsEventsEventsPerHour2['default'], this.props),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(ProjectList, _extends({}, this.props, { teams: this.state.teams }))
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = OrganizationDashboard;
	module.exports = exports['default'];

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _componentsFooter = __webpack_require__(105);
	
	var _componentsFooter2 = _interopRequireDefault(_componentsFooter);
	
	var _componentsSidebar = __webpack_require__(137);
	
	var _componentsSidebar2 = _interopRequireDefault(_componentsSidebar);
	
	var _storesHookStore = __webpack_require__(90);
	
	var _storesHookStore2 = _interopRequireDefault(_storesHookStore);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _storesTeamStore = __webpack_require__(141);
	
	var _storesTeamStore2 = _interopRequireDefault(_storesTeamStore);
	
	var _storesProjectStore = __webpack_require__(194);
	
	var _storesProjectStore2 = _interopRequireDefault(_storesProjectStore);
	
	var _locale = __webpack_require__(2);
	
	var ERROR_TYPES = {
	  ORG_NOT_FOUND: 'ORG_NOT_FOUND'
	};
	
	function doProjectsNeedShortId(teams) {
	  for (var i = 0; i < teams.length; i++) {
	    for (var j = 0; j < teams[i].projects.length; j++) {
	      if (!teams[i].projects[j].callSignReviewed) {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	function getRequiredAdminActions(org) {
	  var rv = [];
	  if (doProjectsNeedShortId(org.teams)) {
	    rv.push('SET_SHORT_IDS');
	  }
	  return rv;
	}
	
	var OrganizationDetails = _react2['default'].createClass({
	  displayName: 'OrganizationDetails',
	
	  childContextTypes: {
	    organization: _proptypes2['default'].Organization
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      errorType: null,
	      organization: null
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      organization: this.state.organization
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.params.orgId !== this.props.params.orgId || nextProps.location.state === 'refresh') {
	      this.remountComponent();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _storesTeamStore2['default'].reset();
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.api.request(this.getOrganizationDetailsEndpoint(), {
	      success: function success(data) {
	        // Allow injection via getsentry et all
	        var hooks = [];
	        _storesHookStore2['default'].get('organization:header').forEach(function (cb) {
	          hooks.push(cb(data));
	        });
	
	        data.requiredAdminActions = getRequiredAdminActions(data);
	
	        _this.setState({
	          organization: data,
	          loading: false,
	          error: false,
	          errorType: null,
	          hooks: hooks
	        });
	
	        _storesTeamStore2['default'].loadInitialData(data.teams);
	        _storesProjectStore2['default'].loadInitialData(data.teams.reduce(function (out, team) {
	          return out.concat(team.projects);
	        }, []));
	      }, error: function error(_, textStatus, errorThrown) {
	        var errorType = null;
	        switch (errorThrown) {
	          case 'NOT FOUND':
	            errorType = ERROR_TYPES.ORG_NOT_FOUND;
	            break;
	          default:
	        }
	        _this.setState({
	          loading: false,
	          error: true,
	          errorType: errorType
	        });
	      }
	    });
	  },
	
	  getOrganizationDetailsEndpoint: function getOrganizationDetailsEndpoint() {
	    return '/organizations/' + this.props.params.orgId + '/';
	  },
	
	  getTitle: function getTitle() {
	    if (this.state.organization) return this.state.organization.name;
	    return 'Sentry';
	  },
	
	  render: function render() {
	    if (this.state.loading) {
	      return _react2['default'].createElement(
	        _componentsLoadingIndicator2['default'],
	        { triangle: true },
	        (0, _locale.t)('Loading data for your organization.')
	      );
	    } else if (this.state.error) {
	      switch (this.state.errorType) {
	        case ERROR_TYPES.ORG_NOT_FOUND:
	          return _react2['default'].createElement(
	            'div',
	            { className: 'container' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'alert alert-block' },
	              (0, _locale.t)('The organization you were looking for was not found.')
	            )
	          );
	        default:
	          return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.remountComponent });
	      }
	    }
	
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { title: this.getTitle() },
	      _react2['default'].createElement(
	        'div',
	        { className: 'app' },
	        this.state.hooks,
	        _react2['default'].createElement(_componentsSidebar2['default'], null),
	        this.props.children,
	        _react2['default'].createElement(_componentsFooter2['default'], null)
	      )
	    );
	  }
	});
	
	exports['default'] = OrganizationDetails;
	module.exports = exports['default'];

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsOrganizationsHomeContainer = __webpack_require__(64);
	
	var _componentsOrganizationsHomeContainer2 = _interopRequireDefault(_componentsOrganizationsHomeContainer);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _componentsForms = __webpack_require__(36);
	
	var _locale = __webpack_require__(2);
	
	var RateLimitEditor = _react2['default'].createClass({
	  displayName: 'RateLimitEditor',
	
	  propTypes: {
	    organization: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    var projectLimit = this.props.organization.quota.projectLimit;
	
	    return {
	      activeNav: 'rate-limits',
	      currentProjectLimit: projectLimit,
	      savedProjectLimit: projectLimit
	    };
	  },
	
	  onProjectLimitChange: function onProjectLimitChange(value) {
	    this.setState({
	      currentProjectLimit: value
	    });
	  },
	
	  onSubmit: function onSubmit(e) {
	    var _this = this;
	
	    e.preventDefault();
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving..'));
	
	    this.setState({
	      saving: true,
	      error: false
	    }, function () {
	      _this.api.request('/organizations/' + _this.props.organization.slug + '/', {
	        method: 'PUT',
	        data: {
	          projectRateLimit: _this.state.currentProjectLimit
	        },
	        success: function success(data) {
	          // TODO(dcramer): propagate this change correctly (how??)
	          _this.props.organization.quota = data.quota;
	          _this.setState({
	            saving: false,
	            savedProjectLimit: data.quota.projectLimit
	          });
	        },
	        complete: function complete() {
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  render: function render() {
	    var _state = this.state;
	    var currentProjectLimit = _state.currentProjectLimit;
	    var savedProjectLimit = _state.savedProjectLimit;
	    var saving = _state.saving;
	
	    var maxRate = this.props.organization.quota.maxRate;
	    var canSave = savedProjectLimit === currentProjectLimit && !saving;
	
	    return _react2['default'].createElement(
	      'form',
	      { onSubmit: this.onSubmit, className: 'ref-rate-limit-editor' },
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.tct)('Your organization is limited to [strong:[maxRate] events per minute]. When this rate is exceeded the system will begin discarding data until the next interval.', {
	          strong: _react2['default'].createElement('strong', null),
	          maxRate: maxRate
	        })
	      ),
	      _react2['default'].createElement(_componentsForms.RangeField, {
	        label: (0, _locale.t)('Max percentage a single project may send'),
	        defaultValue: savedProjectLimit,
	        onChange: this.onProjectLimitChange,
	        formatLabel: function (value) {
	          return value + '%';
	        } }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'help-block' },
	        (0, _locale.t)('The maximum percentage of your quota an individual project can consume.')
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'form-actions', style: { marginTop: 25 } },
	        _react2['default'].createElement(
	          'button',
	          {
	            type: 'submit',
	            className: 'btn btn-primary',
	            disabled: canSave },
	          (0, _locale.t)('Apply Changes')
	        )
	      )
	    );
	  }
	});
	
	var OrganizationRateLimits = _react2['default'].createClass({
	  displayName: 'OrganizationRateLimits',
	
	  mixins: [_mixinsOrganizationState2['default']],
	
	  render: function render() {
	    if (!this.context.organization) return null;
	
	    var org = this.context.organization;
	    // TODO(dcramer): defined limit is only for testing atm
	    var maxRate = org.quota.maxRate;
	
	    return _react2['default'].createElement(
	      _componentsOrganizationsHomeContainer2['default'],
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            (0, _locale.t)('Rate Limits')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          maxRate !== 0 ? _react2['default'].createElement(RateLimitEditor, { organization: org }) : _react2['default'].createElement(
	            'p',
	            { className: 'ref-no-rate-limits' },
	            (0, _locale.t)('There are no rate limits configured for your organization.')
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = OrganizationRateLimits;
	module.exports = exports['default'];
	/* This may not translate well to all languages since maxRate may affect plural form of "events per minute" */

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapLibModal = __webpack_require__(73);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsForms = __webpack_require__(36);
	
	var _componentsDropdownLink = __webpack_require__(33);
	
	var _componentsDropdownLink2 = _interopRequireDefault(_componentsDropdownLink);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsMenuItem = __webpack_require__(37);
	
	var _componentsMenuItem2 = _interopRequireDefault(_componentsMenuItem);
	
	var _componentsOrganizationsHomeContainer = __webpack_require__(64);
	
	var _componentsOrganizationsHomeContainer2 = _interopRequireDefault(_componentsOrganizationsHomeContainer);
	
	var _componentsBasesPluginComponentBase = __webpack_require__(171);
	
	var _componentsBasesPluginComponentBase2 = _interopRequireDefault(_componentsBasesPluginComponentBase);
	
	var _locale = __webpack_require__(2);
	
	var _utils = __webpack_require__(7);
	
	var UNKNOWN_ERROR = {
	  error_type: 'unknown'
	};
	
	var AddRepositoryLink = (function (_PluginComponentBase) {
	  _inherits(AddRepositoryLink, _PluginComponentBase);
	
	  function AddRepositoryLink(props) {
	    var _this = this;
	
	    _classCallCheck(this, AddRepositoryLink);
	
	    _get(Object.getPrototypeOf(AddRepositoryLink.prototype), 'constructor', this).call(this, props);
	
	    Object.assign(this.state, {
	      isModalOpen: false,
	      fieldList: null,
	      loading: true,
	      state: _componentsForms.FormState.LOADING,
	      error: {},
	      formData: {}
	    });
	
	    ['onOpen', 'onCancel', 'formSubmit', 'changeField'].map(function (method) {
	      return _this[method] = _this[method].bind(_this);
	    });
	  }
	
	  _createClass(AddRepositoryLink, [{
	    key: 'onOpen',
	    value: function onOpen() {
	      this.setState({ isModalOpen: true });
	    }
	  }, {
	    key: 'onCancel',
	    value: function onCancel() {
	      this.setState({ isModalOpen: false });
	    }
	  }, {
	    key: 'formSubmit',
	    value: function formSubmit(ev) {
	      // since this doesn't use the Form component, wrap onSubmit
	      // in a function that calls preventDefault
	      ev.preventDefault();
	      this.onSubmit();
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit() {
	      var _this2 = this;
	
	      // TODO(dcramer): set form saving state
	      this.setState({
	        state: _componentsForms.FormState.SAVING
	      }, function () {
	        _this2.api.request('/organizations/' + _this2.props.orgId + '/repos/', {
	          data: _extends({
	            provider: _this2.props.provider.id
	          }, _this2.state.formData),
	          method: 'POST',
	          success: _this2.onSaveSuccess.bind(_this2, function (data) {
	            _this2.setState({ isModalOpen: false });
	            _this2.props.onSuccess(data);
	          }),
	          error: _this2.onSaveError.bind(_this2, function (error) {
	            _this2.setState({
	              error: error.responseJSON || UNKNOWN_ERROR || UNKNOWN_ERROR,
	              state: _componentsForms.FormState.error
	            });
	          }),
	          complete: _this2.onSaveComplete
	        });
	      });
	    }
	  }, {
	    key: 'changeField',
	    value: function changeField(name, value) {
	      var formData = this.state.formData;
	      formData[name] = value;
	      this.setState(_defineProperty({}, name, formData));
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      var _this3 = this;
	
	      var errors = this.state.error.errors || {};
	      var provider = this.props.provider;
	      return _react2['default'].createElement(
	        'form',
	        { onSubmit: this.formSubmit },
	        errors.__all__ && _react2['default'].createElement(
	          'div',
	          { className: 'alert alert-error alert-block', key: '_errors' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            errors.__all__
	          )
	        ),
	        provider.config.map(function (field) {
	          return _react2['default'].createElement(
	            'div',
	            { key: field.name },
	            _this3.renderField({
	              config: field,
	              formData: _this3.state.formData,
	              formErrors: errors,
	              onChange: _this3.changeField.bind(_this3, field.name)
	            })
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      var error = this.state.error;
	      if (error.error_type === 'auth') {
	        var authUrl = error.auth_url;
	        if (authUrl.indexOf('?') === -1) {
	          authUrl += '?next=' + encodeURIComponent(document.location.pathname);
	        } else {
	          authUrl += '&next=' + encodeURIComponent(document.location.pathname);
	        }
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'div',
	            { className: 'alert alert-warning m-b-1' },
	            'You need to associate an identity with ' + error.title + ' before you can create issues with this service.'
	          ),
	          _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-primary', href: authUrl },
	            'Associate Identity'
	          )
	        );
	      } else if (error.error_type && error.error_type !== 'validation') {
	        return _react2['default'].createElement(
	          'div',
	          { className: 'alert alert-error alert-block' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            error.message ? error.message : (0, _locale.tct)('An unknown error occurred. Need help with this? [link:Contact support]', {
	              link: _react2['default'].createElement('a', { href: 'https://sentry.io/support/' })
	            })
	          )
	        );
	      }
	      return this.renderForm();
	    }
	  }, {
	    key: 'renderModal',
	    value: function renderModal() {
	      var state = this.state.state;
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: this.state.isModalOpen, animation: false },
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-header' },
	          _react2['default'].createElement(
	            'h4',
	            null,
	            (0, _locale.t)('Add Repository')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-body' },
	          this.renderBody()
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-footer' },
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-default',
	              onClick: this.onCancel,
	              disabled: state === _componentsForms.FormState.SAVING },
	            (0, _locale.t)('Cancel')
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary',
	              onClick: this.onSubmit,
	              disabled: state === _componentsForms.FormState.SAVING },
	            (0, _locale.t)('Save Changes')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var provider = this.props.provider;
	      return _react2['default'].createElement(
	        'a',
	        { onClick: this.onOpen },
	        provider.name,
	        this.renderModal()
	      );
	    }
	  }]);
	
	  return AddRepositoryLink;
	})(_componentsBasesPluginComponentBase2['default']);
	
	AddRepositoryLink.propTypes = {
	  provider: _react2['default'].PropTypes.object.isRequired
	};
	
	var OrganizationRepositories = _react2['default'].createClass({
	  displayName: 'OrganizationRepositories',
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      itemList: null,
	      repoConfig: null
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  fetchData: function fetchData() {
	    var _this4 = this;
	
	    this.api.request('/organizations/' + this.props.params.orgId + '/repos/?status=', {
	      method: 'GET',
	      success: function success(data) {
	        _this4.setState({
	          itemList: data,
	          loading: !_this4.state.repoConfig
	        });
	      },
	      error: function error() {
	        _this4.setState({
	          loading: !_this4.state.repoConfig,
	          error: true
	        });
	      }
	    });
	    this.api.request('/organizations/' + this.props.params.orgId + '/config/repos/', {
	      method: 'GET',
	      success: function success(data) {
	        _this4.setState({
	          repoConfig: data,
	          loading: !_this4.state.itemList
	        });
	      },
	      error: function error() {
	        _this4.setState({
	          loading: !_this4.state.itemList,
	          error: true
	        });
	      }
	    });
	  },
	
	  deleteRepo: function deleteRepo(repo) {
	    var _this5 = this;
	
	    if (!confirm((0, _locale.t)('Are you sure you want to remove this repository?'))) return;
	
	    var indicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	    this.api.request('/organizations/' + this.props.params.orgId + '/repos/' + repo.id + '/', {
	      method: 'DELETE',
	      success: function success(data) {
	        var itemList = _this5.state.itemList;
	        itemList.forEach(function (item) {
	          if (item.id === data.id) {
	            item.status = data.status;
	          }
	        });
	        _this5.setState({
	          itemList: itemList
	        });
	      },
	      error: function error() {
	        _storesIndicatorStore2['default'].add((0, _locale.t)('An error occurred.'), 'error', {
	          duration: 3000
	        });
	      },
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(indicator);
	      }
	    });
	  },
	
	  cancelDelete: function cancelDelete(repo) {
	    var _this6 = this;
	
	    var indicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	    this.api.request('/organizations/' + this.props.params.orgId + '/repos/' + repo.id + '/', {
	      method: 'PUT',
	      data: { status: 'visible' },
	      success: function success(data) {
	        var itemList = _this6.state.itemList;
	        itemList.forEach(function (item) {
	          if (item.id === data.id) {
	            item.status = data.status;
	          }
	        });
	        _this6.setState({
	          itemList: itemList
	        });
	      },
	      error: function error() {
	        _storesIndicatorStore2['default'].add((0, _locale.t)('An error occurred.'), 'error', {
	          duration: 3000
	        });
	      },
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(indicator);
	      }
	    });
	  },
	
	  onAddRepo: function onAddRepo(repo) {
	    var itemList = this.state.itemList;
	    itemList.push(repo);
	    this.setState({
	      itemList: (0, _utils.sortArray)(itemList, function (item) {
	        return item.name;
	      })
	    });
	  },
	
	  getStatusLabel: function getStatusLabel(repo) {
	    switch (repo.status) {
	      case 'pending_deletion':
	        return 'Deletion Queued';
	      case 'deletion_in_progress':
	        return 'Deletion in Progress';
	      case 'hidden':
	        return 'Disabled';
	      default:
	        return null;
	    }
	  },
	
	  render: function render() {
	    var _this7 = this;
	
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);
	
	    var orgId = this.props.params.orgId;
	
	    return _react2['default'].createElement(
	      _componentsOrganizationsHomeContainer2['default'],
	      null,
	      _react2['default'].createElement(
	        'table',
	        { className: 'table table-bordered' },
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          this.state.itemList.map(function (repo) {
	            return _react2['default'].createElement(
	              'tr',
	              { key: repo.id },
	              _react2['default'].createElement(
	                'td',
	                null,
	                _react2['default'].createElement(
	                  'strong',
	                  null,
	                  repo.name
	                ),
	                repo.status !== 'visible' && _react2['default'].createElement(
	                  'small',
	                  null,
	                  ' — ',
	                  _this7.getStatusLabel(repo)
	                ),
	                repo.status === 'pending_deletion' && _react2['default'].createElement(
	                  'small',
	                  null,
	                  ' (',
	                  _react2['default'].createElement(
	                    'a',
	                    { onClick: _this7.cancelDelete.bind(_this7, repo) },
	                    (0, _locale.t)('Cancel')
	                  ),
	                  ')'
	                ),
	                _react2['default'].createElement('br', null),
	                _react2['default'].createElement(
	                  'small',
	                  null,
	                  repo.provider.name
	                ),
	                repo.url && _react2['default'].createElement(
	                  'small',
	                  null,
	                  ' — ',
	                  _react2['default'].createElement(
	                    'a',
	                    { href: repo.url },
	                    repo.url
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                'td',
	                { style: { width: 60 } },
	                repo.status === 'visible' ? _react2['default'].createElement(
	                  'button',
	                  { onClick: _this7.deleteRepo.bind(_this7, repo),
	                    className: 'btn btn-default btn-xs' },
	                  _react2['default'].createElement('span', { className: 'icon icon-trash' })
	                ) : _react2['default'].createElement(
	                  'button',
	                  { onClick: _this7.deleteRepo.bind(_this7, repo),
	                    disabled: true,
	                    className: 'btn btn-default btn-xs btn-disabled' },
	                  _react2['default'].createElement('span', { className: 'icon icon-trash' })
	                )
	              )
	            );
	          })
	        )
	      ),
	      _react2['default'].createElement(
	        _componentsDropdownLink2['default'],
	        {
	          className: 'btn btn-primary btn-sm',
	          title: (0, _locale.t)('Add Repository') },
	        this.state.repoConfig.providers.map(function (provider) {
	          return _react2['default'].createElement(
	            _componentsMenuItem2['default'],
	            { noAnchor: true, key: provider.id },
	            _react2['default'].createElement(AddRepositoryLink, { provider: provider, orgId: orgId, onSuccess: _this7.onAddRepo })
	          );
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = OrganizationRepositories;
	module.exports = exports['default'];

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsOrganizationsHomeContainer = __webpack_require__(64);
	
	var _componentsOrganizationsHomeContainer2 = _interopRequireDefault(_componentsOrganizationsHomeContainer);
	
	var _componentsStackedBarChart = __webpack_require__(106);
	
	var _componentsStackedBarChart2 = _interopRequireDefault(_componentsStackedBarChart);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _projectTable = __webpack_require__(661);
	
	var _projectTable2 = _interopRequireDefault(_projectTable);
	
	var _locale = __webpack_require__(2);
	
	var _utils = __webpack_require__(7);
	
	var OrganizationStats = _react2['default'].createClass({
	  displayName: 'OrganizationStats',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    var until = Math.floor(new Date().getTime() / 1000);
	    var since = until - 3600 * 24 * 7;
	
	    return {
	      projectsError: false,
	      projectsLoading: false,
	      projectsRequestsPending: 0,
	      statsError: false,
	      statsLoading: false,
	      statsRequestsPending: 0,
	      projectMap: null,
	      rawProjectData: { received: null, rejected: null, blacklisted: null },
	      rawOrgData: { received: null, rejected: null, blacklisted: null },
	      orgStats: null,
	      orgTotal: null,
	      projectTotals: null,
	      querySince: since,
	      queryUntil: until
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var prevParams = prevProps.params,
	        currentParams = this.props.params;
	
	    if (prevParams.orgId !== currentParams.orgId) {
	      this.fetchData();
	    }
	
	    var state = this.state;
	    if (state.statsLoading && !state.statsRequestsPending) {
	      this.processOrgData();
	    }
	    if (state.projectsLoading && !state.projectsRequestsPending) {
	      this.processProjectData();
	    }
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.setState({
	      statsError: false,
	      statsLoading: true,
	      statsRequestsPending: 3,
	      projectsError: false,
	      projectsLoading: true,
	      projectsRequestsPending: 4
	    });
	
	    var statEndpoint = this.getOrganizationStatsEndpoint();
	
	    _jquery2['default'].each(this.state.rawOrgData, function (statName) {
	      _this.api.request(statEndpoint, {
	        query: {
	          since: _this.state.querySince,
	          until: _this.state.queryUntil,
	          resolution: '1h',
	          stat: statName
	        },
	        success: function success(data) {
	          _this.state.rawOrgData[statName] = data;
	          _this.state.statsRequestsPending -= 1;
	          _this.setState({
	            rawOrgData: _this.state.rawOrgData,
	            statsRequestsPending: _this.state.statsRequestsPending
	          });
	        },
	        error: function error() {
	          _this.setState({
	            statsError: true
	          });
	        }
	      });
	    });
	
	    _jquery2['default'].each(this.state.rawProjectData, function (statName) {
	      _this.api.request(statEndpoint, {
	        query: {
	          since: _this.state.querySince,
	          until: _this.state.queryUntil,
	          stat: statName,
	          group: 'project'
	        },
	        success: function success(data) {
	          _this.state.rawProjectData[statName] = data;
	          _this.state.projectsRequestsPending -= 1;
	          _this.setState({
	            rawProjectData: _this.state.rawProjectData,
	            projectsRequestsPending: _this.state.projectsRequestsPending
	          });
	        },
	        error: function error() {
	          _this.setState({
	            projectsError: true
	          });
	        }
	      });
	    });
	
	    this.api.request(this.getOrganizationProjectsEndpoint(), {
	      success: function success(data) {
	        var projectMap = {};
	        data.forEach(function (project) {
	          projectMap[project.id] = project;
	        });
	
	        _this.state.projectsRequestsPending -= 1;
	        _this.setState({
	          projectMap: projectMap,
	          projectsRequestsPending: _this.state.projectsRequestsPending
	        });
	      },
	      error: function error() {
	        _this.setState({
	          projectsError: true
	        });
	      }
	    });
	  },
	
	  getOrganizationStatsEndpoint: function getOrganizationStatsEndpoint() {
	    var params = this.props.params;
	    return '/organizations/' + params.orgId + '/stats/';
	  },
	
	  getOrganizationProjectsEndpoint: function getOrganizationProjectsEndpoint() {
	    var params = this.props.params;
	    return '/organizations/' + params.orgId + '/projects/';
	  },
	
	  processOrgData: function processOrgData() {
	    var oReceived = 0;
	    var oRejected = 0;
	    var oBlacklisted = 0;
	    var orgPoints = []; // accepted, rejected, blacklisted
	    var aReceived = [0, 0]; // received, points
	    var rawOrgData = this.state.rawOrgData;
	    _jquery2['default'].each(rawOrgData.received, function (idx, point) {
	      var dReceived = point[1];
	      var dRejected = rawOrgData.rejected[idx][1];
	      var dBlacklisted = rawOrgData.blacklisted[idx][1];
	      var dAccepted = Math.max(0, dReceived - dRejected - dBlacklisted);
	      orgPoints.push({
	        x: point[0],
	        y: [dAccepted, dRejected, dBlacklisted]
	      });
	      oReceived += dReceived;
	      oRejected += dRejected;
	      oBlacklisted += dBlacklisted;
	      if (dReceived > 0) {
	        aReceived[0] += dReceived;
	        aReceived[1] += 1;
	      }
	    });
	    this.setState({
	      orgStats: orgPoints,
	      orgTotal: {
	        received: oReceived,
	        rejected: oRejected,
	        blacklisted: oBlacklisted,
	        accepted: Math.max(0, oReceived - oRejected - oBlacklisted),
	        avgRate: aReceived[1] ? parseInt(aReceived[0] / aReceived[1] / 60, 10) : 0
	      },
	      statsLoading: false
	    });
	  },
	
	  processProjectData: function processProjectData() {
	    var rawProjectData = this.state.rawProjectData;
	    var projectTotals = [];
	    _jquery2['default'].each(rawProjectData.received, function (projectId, data) {
	      var pReceived = 0;
	      var pRejected = 0;
	      var pBlacklisted = 0;
	      _jquery2['default'].each(data, function (idx, point) {
	        pReceived += point[1];
	        pRejected += rawProjectData.rejected[projectId][idx][1];
	        pBlacklisted += rawProjectData.blacklisted[projectId][idx][1];
	      });
	      projectTotals.push({
	        id: projectId,
	        received: pReceived,
	        rejected: pRejected,
	        blacklisted: pBlacklisted,
	        accepted: pReceived - pRejected - pBlacklisted
	      });
	    });
	    this.setState({
	      projectTotals: projectTotals,
	      projectsLoading: false
	    });
	  },
	
	  renderTooltip: function renderTooltip(point, pointIdx, chart) {
	    var timeLabel = chart.getTimeLabel(point);
	
	    var _point$y = _slicedToArray(point.y, 3);
	
	    var accepted = _point$y[0];
	    var rejected = _point$y[1];
	    var blacklisted = _point$y[2];
	
	    var value = (0, _utils.intcomma)(accepted) + ' accepted';
	    if (rejected) {
	      value += '<br>' + (0, _utils.intcomma)(rejected) + ' rate limited';
	    }
	    if (blacklisted) {
	      value += '<br>' + (0, _utils.intcomma)(blacklisted) + ' filtered';
	    }
	
	    return '<div style="width:150px">' + ('<div class="time-label">' + timeLabel + '</div>') + ('<div class="value-label">' + value + '</div>') + '</div>';
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      _componentsOrganizationsHomeContainer2['default'],
	      null,
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('Stats')
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-9' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            (0, _locale.t)('The chart below reflects events the system has received\n            across your entire organization. Events are broken down into\n            three categories: Accepted, Rate Limited, and Filtered. Rate\n            Limited events are entries that the system threw away due to quotas\n            being hit, and Filtered events are events that were blocked\n            due to your data filters and blocklists.')
	          )
	        ),
	        !this.state.statsLoading && _react2['default'].createElement(
	          'div',
	          { className: 'col-md-3 stats-column' },
	          _react2['default'].createElement(
	            'h6',
	            { className: 'nav-header' },
	            (0, _locale.t)('Events per minute')
	          ),
	          _react2['default'].createElement(
	            'p',
	            { className: 'count' },
	            this.state.orgTotal.avgRate
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'organization-stats' },
	        this.state.statsLoading ? _react2['default'].createElement(_componentsLoadingIndicator2['default'], null) : this.state.statsError ? _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData }) : _react2['default'].createElement(
	          'div',
	          { className: 'bar-chart' },
	          _react2['default'].createElement(_componentsStackedBarChart2['default'], {
	            points: this.state.orgStats,
	            height: 150,
	            barClasses: ['accepted', 'rate-limited', 'black-listed'],
	            className: 'sparkline',
	            tooltip: this.renderTooltip })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            (0, _locale.t)('Events by Project')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content' },
	          this.state.statsLoading || this.state.projectsLoading ? _react2['default'].createElement(_componentsLoadingIndicator2['default'], null) : this.state.projectsError ? _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData }) : _react2['default'].createElement(_projectTable2['default'], {
	            projectTotals: this.state.projectTotals,
	            orgTotal: this.state.orgTotal,
	            organization: this.getOrganization(),
	            projectMap: this.state.projectMap })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = OrganizationStats;
	module.exports = exports['default'];

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _componentsCount = __webpack_require__(71);
	
	var _componentsCount2 = _interopRequireDefault(_componentsCount);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _locale = __webpack_require__(2);
	
	var getPercent = function getPercent(item, total) {
	  if (total === 0) {
	    return '';
	  }
	  if (item === 0) {
	    return '0%';
	  }
	  return parseInt(item / total * 100, 10) + '%';
	};
	
	var ProjectTable = _react2['default'].createClass({
	  displayName: 'ProjectTable',
	
	  propTypes: {
	    projectMap: _react2['default'].PropTypes.object.isRequired,
	    projectTotals: _react2['default'].PropTypes.array.isRequired,
	    orgTotal: _react2['default'].PropTypes.object.isRequired,
	    organization: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default']],
	
	  render: function render() {
	    var projectMap = this.props.projectMap;
	    var projectTotals = this.props.projectTotals;
	    var orgTotal = this.props.orgTotal;
	    var org = this.props.organization;
	
	    if (!projectTotals) {
	      return _react2['default'].createElement('div', null);
	    }
	
	    // Sort based on # events received in desc order
	    projectTotals.sort(function (a, b) {
	      return b.received - a.received;
	    });
	
	    return _react2['default'].createElement(
	      'table',
	      { className: 'table m-b-0' },
	      _react2['default'].createElement(
	        'thead',
	        null,
	        _react2['default'].createElement(
	          'tr',
	          null,
	          _react2['default'].createElement(
	            'th',
	            null,
	            (0, _locale.t)('Project')
	          ),
	          _react2['default'].createElement(
	            'th',
	            { className: 'align-right' },
	            (0, _locale.t)('Accepted')
	          ),
	          _react2['default'].createElement(
	            'th',
	            { className: 'align-right' },
	            (0, _locale.t)('Dropped'),
	            _react2['default'].createElement('br', null),
	            (0, _locale.t)('(Rate Limit)')
	          ),
	          _react2['default'].createElement(
	            'th',
	            { className: 'align-right' },
	            (0, _locale.t)('Dropped'),
	            _react2['default'].createElement('br', null),
	            (0, _locale.t)('(Filters)')
	          ),
	          _react2['default'].createElement(
	            'th',
	            { className: 'align-right' },
	            (0, _locale.t)('Total')
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'tbody',
	        null,
	        projectTotals.map(function (item) {
	          var project = projectMap[item.id];
	
	          return _react2['default'].createElement(
	            'tr',
	            { key: item.id },
	            _react2['default'].createElement(
	              'td',
	              null,
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: '/' + org.slug + '/' + project.slug + '/' },
	                project.team.name,
	                ' / ',
	                project.name
	              )
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'align-right' },
	              _react2['default'].createElement(_componentsCount2['default'], { value: item.accepted }),
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement(
	                'small',
	                null,
	                getPercent(item.accepted, orgTotal.accepted)
	              )
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'align-right' },
	              _react2['default'].createElement(_componentsCount2['default'], { value: item.rejected }),
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement(
	                'small',
	                null,
	                getPercent(item.rejected, orgTotal.rejected)
	              )
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'align-right' },
	              _react2['default'].createElement(_componentsCount2['default'], { value: item.blacklisted }),
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement(
	                'small',
	                null,
	                getPercent(item.blacklisted, orgTotal.blacklisted)
	              )
	            ),
	            _react2['default'].createElement(
	              'td',
	              { className: 'align-right' },
	              _react2['default'].createElement(_componentsCount2['default'], { value: item.received }),
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement(
	                'small',
	                null,
	                getPercent(item.received, orgTotal.received)
	              )
	            )
	          );
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectTable;
	module.exports = exports['default'];

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _allTeamsRow = __webpack_require__(663);
	
	var _allTeamsRow2 = _interopRequireDefault(_allTeamsRow);
	
	var _locale = __webpack_require__(2);
	
	var AllTeamsList = _react2['default'].createClass({
	  displayName: 'AllTeamsList',
	
	  propTypes: {
	    access: _react2['default'].PropTypes.object,
	    organization: _proptypes2['default'].Organization,
	    teamList: _react2['default'].PropTypes.arrayOf(_proptypes2['default'].Team),
	    openMembership: _react2['default'].PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var access = _props.access;
	    var organization = _props.organization;
	    var openMembership = _props.openMembership;
	
	    var teamNodes = this.props.teamList.map(function (team, teamIdx) {
	      return _react2['default'].createElement(_allTeamsRow2['default'], {
	        access: access,
	        team: team,
	        organization: organization,
	        openMembership: openMembership,
	        key: team.slug });
	    });
	
	    if (teamNodes.length !== 0) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'panel panel-default' },
	        _react2['default'].createElement(
	          'table',
	          { className: 'table' },
	          _react2['default'].createElement(
	            'tbody',
	            null,
	            teamNodes
	          )
	        )
	      );
	    }
	
	    return (0, _locale.tct)('You don\'t have any teams for this organization yet. Get started by [link:creating your first team].', {
	      root: _react2['default'].createElement('p', null),
	      link: _react2['default'].createElement('a', { href: '/organizations/' + organization.slug + '/teams/new/' })
	    });
	  }
	});
	
	exports['default'] = AllTeamsList;
	module.exports = exports['default'];

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _actionsAlertActions = __webpack_require__(62);
	
	var _actionsAlertActions2 = _interopRequireDefault(_actionsAlertActions);
	
	var _locale = __webpack_require__(2);
	
	// TODO(dcramer): this isnt great UX
	
	var AllTeamsRow = _react2['default'].createClass({
	  displayName: 'AllTeamsRow',
	
	  propTypes: {
	    access: _react2['default'].PropTypes.object.isRequired,
	    organization: _react2['default'].PropTypes.object.isRequired,
	    team: _react2['default'].PropTypes.object.isRequired,
	    openMembership: _react2['default'].PropTypes.bool.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: false,
	      error: false
	    };
	  },
	
	  joinTeam: function joinTeam() {
	    var _this = this;
	
	    this.setState({
	      loading: true
	    });
	
	    this.api.joinTeam({
	      orgId: this.props.organization.slug,
	      teamId: this.props.team.slug
	    }, {
	      success: function success() {
	        _this.setState({
	          loading: false,
	          error: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	        _actionsAlertActions2['default'].addAlert({
	          message: (0, _locale.t)('There was an error while trying to join the team.'),
	          type: 'error'
	        });
	      }
	    });
	  },
	
	  leaveTeam: function leaveTeam() {
	    var _this2 = this;
	
	    this.setState({
	      loading: true
	    });
	
	    this.api.leaveTeam({
	      orgId: this.props.organization.slug,
	      teamId: this.props.team.slug
	    }, {
	      success: function success() {
	        _this2.setState({
	          loading: false,
	          error: false
	        });
	      },
	      error: function error() {
	        _this2.setState({
	          loading: false,
	          error: true
	        });
	        _actionsAlertActions2['default'].addAlert({
	          message: (0, _locale.t)('There was an error while trying to leave the team.'),
	          type: 'error'
	        });
	      }
	    });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var access = _props.access;
	    var team = _props.team;
	    var openMembership = _props.openMembership;
	
	    var orgId = this.props.organization.slug;
	    return _react2['default'].createElement(
	      'tr',
	      null,
	      _react2['default'].createElement(
	        'td',
	        null,
	        _react2['default'].createElement(
	          'h5',
	          null,
	          team.name
	        )
	      ),
	      _react2['default'].createElement(
	        'td',
	        { className: 'actions align-right' },
	        this.state.loading ? _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-default btn-sm btn-loading btn-disabled' },
	          '...'
	        ) : team.isMember ? _react2['default'].createElement(
	          'a',
	          { className: 'leave-team btn btn-default btn-sm',
	            onClick: this.leaveTeam },
	          (0, _locale.t)('Leave Team')
	        ) : team.isPending ? _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-default btn-sm btn-disabled' },
	          (0, _locale.t)('Request Pending')
	        ) : openMembership ? _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-default btn-sm',
	            onClick: this.joinTeam },
	          (0, _locale.t)('Join Team')
	        ) : _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-default btn-sm',
	            onClick: this.joinTeam },
	          (0, _locale.t)('Request Access')
	        ),
	        access.has('team:write') && _react2['default'].createElement(
	          _reactRouter.Link,
	          { className: 'btn btn-default btn-sm', to: '/organizations/' + orgId + '/teams/' + team.slug + '/settings/',
	            style: { marginLeft: 5 } },
	          (0, _locale.t)('Team Settings')
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = AllTeamsRow;
	module.exports = exports['default'];

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _reactLazyLoad = __webpack_require__(354);
	
	var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _actionCreatorsProjects = __webpack_require__(130);
	
	var _componentsBarChart = __webpack_require__(132);
	
	var _componentsBarChart2 = _interopRequireDefault(_componentsBarChart);
	
	var _componentsProjectLabel = __webpack_require__(292);
	
	var _componentsProjectLabel2 = _interopRequireDefault(_componentsProjectLabel);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _utils = __webpack_require__(7);
	
	var _locale = __webpack_require__(2);
	
	var ExpandedTeamList = _react2['default'].createClass({
	  displayName: 'ExpandedTeamList',
	
	  propTypes: {
	    access: _react2['default'].PropTypes.object.isRequired,
	    organization: _proptypes2['default'].Organization.isRequired,
	    teamList: _react2['default'].PropTypes.arrayOf(_proptypes2['default'].Team).isRequired,
	    projectStats: _react2['default'].PropTypes.object,
	    hasTeams: _react2['default'].PropTypes.bool
	  },
	
	  mixins: [_mixinsApiMixin2['default'], (0, _mixinsTooltip2['default'])(function () {
	    return {
	      selector: '.tip',
	      title: function title(instance) {
	        return this.getAttribute('data-isbookmarked') === 'true' ? 'Remove from bookmarks' : 'Add to bookmarks';
	      }
	    };
	  })],
	
	  leaveTeam: function leaveTeam(team) {
	    // TODO(dcramer): handle loading indicator
	    this.api.leaveTeam({
	      orgId: this.props.organization.slug,
	      teamId: team.slug
	    });
	  },
	
	  urlPrefix: function urlPrefix() {
	    var org = this.props.organization;
	    return '/organizations/' + org.slug;
	  },
	
	  renderProjectList: function renderProjectList(team) {
	    return _react2['default'].createElement(
	      'tbody',
	      null,
	      (0, _utils.sortArray)(team.projects, function (o) {
	        return o.name;
	      }).map(this.renderProject)
	    );
	  },
	
	  renderNoProjects: function renderNoProjects(team) {
	    return _react2['default'].createElement(
	      'tbody',
	      null,
	      _react2['default'].createElement(
	        'tr',
	        null,
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(
	            'p',
	            { className: 'project-list-empty' },
	            (0, _locale.tct)('There are no projects in this team. Get started by [link:creating your first project].', {
	              link: _react2['default'].createElement('a', { href: this.urlPrefix() + '/projects/new/?team=' + team.slug })
	            })
	          )
	        )
	      )
	    );
	  },
	
	  renderTeamNode: function renderTeamNode(team, urlPrefix) {
	    // TODO: make this cleaner
	    var access = this.props.access;
	    var orgId = this.props.organization.slug;
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box', key: team.slug },
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'pull-right actions hidden-xs' },
	          _react2['default'].createElement(
	            'a',
	            { className: 'leave-team', onClick: this.leaveTeam.bind(this, team) },
	            (0, _locale.t)('Leave Team')
	          ),
	          access.has('team:write') && _react2['default'].createElement(
	            _reactRouter.Link,
	            { className: 'team-settings', to: '/organizations/' + orgId + '/teams/' + team.slug + '/settings/' },
	            (0, _locale.t)('Team Settings')
	          )
	        ),
	        _react2['default'].createElement(
	          'h3',
	          null,
	          team.name
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-content' },
	        _react2['default'].createElement(
	          'table',
	          { className: 'table table-no-top-border m-b-0' },
	          team.projects.length ? this.renderProjectList(team) : this.renderNoProjects(team)
	        )
	      )
	    );
	  },
	
	  toggleBookmark: function toggleBookmark(project) {
	    (0, _actionCreatorsProjects.update)(this.api, {
	      orgId: this.props.organization.slug,
	      projectId: project.slug,
	      data: {
	        isBookmarked: !project.isBookmarked
	      }
	    });
	  },
	
	  renderProject: function renderProject(project) {
	    var org = this.props.organization;
	    var chartData = project.stats && project.stats.map(function (point) {
	      return { x: point[0], y: point[1] };
	    });
	
	    return _react2['default'].createElement(
	      'tr',
	      { key: project.id, className: project.isBookmarked ? 'isBookmarked' : null },
	      _react2['default'].createElement(
	        'td',
	        null,
	        _react2['default'].createElement(
	          'h5',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { onClick: this.toggleBookmark.bind(this, project),
	              className: 'tip',
	              'data-isbookmarked': project.isBookmarked },
	            project.isBookmarked ? _react2['default'].createElement('span', { className: 'icon-star-solid bookmark' }) : _react2['default'].createElement('span', { className: 'icon-star-outline bookmark' })
	          ),
	          _react2['default'].createElement(
	            _reactRouter.Link,
	            { to: '/' + org.slug + '/' + project.slug + '/' },
	            _react2['default'].createElement(_componentsProjectLabel2['default'], { project: project, organization: this.props.organization })
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'td',
	        { className: 'align-right project-chart' },
	        chartData && _react2['default'].createElement(
	          _reactLazyLoad2['default'],
	          null,
	          _react2['default'].createElement(_componentsBarChart2['default'], { points: chartData, className: 'sparkline' })
	        )
	      )
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    if (this.props.hasTeams) {
	      return _react2['default'].createElement(
	        'p',
	        null,
	        this.props.access.has('project:write') ? (0, _locale.tct)('You are not a member of any teams. [joinLink:Join an existing team] or [createLink:create a new one].', {
	          joinLink: _react2['default'].createElement(_reactRouter.Link, { to: '/organizations/' + this.props.organization.slug + '/all-teams/' }),
	          createLink: _react2['default'].createElement('a', { href: this.urlPrefix() + '/teams/new/' })
	        }) : (0, _locale.tct)('You are not a member of any teams. [joinLink:Join a team].', {
	          joinLink: _react2['default'].createElement(_reactRouter.Link, { to: '/organizations/' + this.props.organization.slug + '/all-teams/' })
	        })
	      );
	    }
	    return _react2['default'].createElement(
	      'p',
	      null,
	      (0, _locale.tct)('You dont have any teams for this organization yet. Get started by [link:creating your first team].', {
	        link: _react2['default'].createElement('a', { href: this.urlPrefix() + '/teams/new/' })
	      })
	    );
	  },
	
	  renderTeamNodes: function renderTeamNodes() {
	    var _this = this;
	
	    return this.props.teamList.map(function (team) {
	      return _this.renderTeamNode(team);
	    });
	  },
	
	  render: function render() {
	    var hasTeams = this.props.teamList.length > 0;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      hasTeams ? this.renderTeamNodes() : this.renderEmpty()
	    );
	  }
	});
	
	exports['default'] = ExpandedTeamList;
	module.exports = exports['default'];

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _locale = __webpack_require__(2);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsListLink = __webpack_require__(47);
	
	var _componentsListLink2 = _interopRequireDefault(_componentsListLink);
	
	var _componentsOrganizationsHomeContainer = __webpack_require__(64);
	
	var _componentsOrganizationsHomeContainer2 = _interopRequireDefault(_componentsOrganizationsHomeContainer);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _storesTeamStore = __webpack_require__(141);
	
	var _storesTeamStore2 = _interopRequireDefault(_storesTeamStore);
	
	var _utils = __webpack_require__(7);
	
	var _expandedTeamList = __webpack_require__(664);
	
	var _expandedTeamList2 = _interopRequireDefault(_expandedTeamList);
	
	var _organizationStatOverview = __webpack_require__(666);
	
	var _organizationStatOverview2 = _interopRequireDefault(_organizationStatOverview);
	
	var _actionCreatorsProjects = __webpack_require__(130);
	
	var OrganizationTeams = _react2['default'].createClass({
	  displayName: 'OrganizationTeams',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsOrganizationState2['default'], _reflux2['default'].listenTo(_storesTeamStore2['default'], 'onTeamListChange')],
	
	  getInitialState: function getInitialState() {
	    return {
	      teamList: (0, _utils.sortArray)(_storesTeamStore2['default'].getAll(), function (o) {
	        return o.name;
	      }),
	      projectStats: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchStats();
	  },
	
	  fetchStats: function fetchStats() {
	    (0, _actionCreatorsProjects.loadStats)(this.api, {
	      orgId: this.props.params.orgId,
	      query: {
	        since: new Date().getTime() / 1000 - 3600 * 24,
	        stat: 'generated',
	        group: 'project'
	      }
	    });
	  },
	
	  onTeamListChange: function onTeamListChange() {
	    var newTeamList = _storesTeamStore2['default'].getAll();
	
	    this.setState({
	      teamList: (0, _utils.sortArray)(newTeamList, function (o) {
	        return o.name;
	      })
	    });
	  },
	
	  render: function render() {
	    if (!this.context.organization) return null;
	
	    var access = this.getAccess();
	    var features = this.getFeatures();
	    var org = this.getOrganization();
	
	    var allTeams = this.state.teamList;
	    var activeTeams = this.state.teamList.filter(function (team) {
	      return team.isMember;
	    });
	
	    return _react2['default'].createElement(
	      _componentsOrganizationsHomeContainer2['default'],
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-9' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'team-list' },
	            _react2['default'].createElement(
	              'ul',
	              { className: 'nav nav-tabs border-bottom' },
	              _react2['default'].createElement(
	                _componentsListLink2['default'],
	                { to: '/organizations/' + org.slug + '/teams/' },
	                (0, _locale.t)('Your Teams')
	              ),
	              _react2['default'].createElement(
	                _componentsListLink2['default'],
	                { to: '/organizations/' + org.slug + '/all-teams/' },
	                (0, _locale.t)('All Teams'),
	                ' ',
	                _react2['default'].createElement(
	                  'span',
	                  { className: 'badge badge-soft' },
	                  allTeams.length
	                )
	              )
	            ),
	            this.props.children ? /* should be AllTeamsList */
	            _react2['default'].cloneElement(this.props.children, {
	              organization: org,
	              teamList: allTeams,
	              access: access,
	              openMembership: features.has('open-membership') || access.has('org:write')
	            }) : _react2['default'].createElement(_expandedTeamList2['default'], {
	              organization: org, teamList: activeTeams,
	              projectStats: this.state.projectStats,
	              hasTeams: allTeams.length !== 0,
	              access: access })
	          )
	        ),
	        _react2['default'].createElement(_organizationStatOverview2['default'], { orgId: this.props.params.orgId, className: 'col-md-3 stats-column' })
	      )
	    );
	  }
	});
	
	exports['default'] = OrganizationTeams;
	module.exports = exports['default'];

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _utils = __webpack_require__(7);
	
	var _locale = __webpack_require__(2);
	
	var OrganizationStatOverview = _react2['default'].createClass({
	  displayName: 'OrganizationStatOverview',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      totalRejected: null,
	      epm: null
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  getOrganizationStatsEndpoint: function getOrganizationStatsEndpoint() {
	    return '/organizations/' + this.props.orgId + '/stats/';
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var statsEndpoint = this.getOrganizationStatsEndpoint();
	    this.api.request(statsEndpoint, {
	      query: {
	        since: new Date().getTime() / 1000 - 3600 * 24,
	        stat: 'rejected'
	      },
	      success: function success(data) {
	        var totalRejected = 0;
	        data.forEach(function (point) {
	          totalRejected += point[1];
	        });
	        _this.setState({ totalRejected: totalRejected });
	      }
	    });
	    this.api.request(statsEndpoint, {
	      query: {
	        since: new Date().getTime() / 1000 - 3600 * 3,
	        resolution: '1h',
	        stat: 'received'
	      },
	      success: function success(data) {
	        var received = [0, 0];
	        data.forEach(function (point) {
	          if (point[1] > 0) {
	            received[0] += point[1];
	            received[1] += 1;
	          }
	        });
	        var epm = received[1] ? parseInt(received[0] / received[1] / 60, 10) : 0;
	        _this.setState({ epm: epm });
	      }
	    });
	  },
	
	  render: function render() {
	    if (!(0, _utils.defined)(this.state.epm) || !(0, _utils.defined)(this.state.totalRejected)) return null;
	
	    var access = this.getAccess();
	
	    var rejectedClasses = ['count'];
	    if (this.state.totalRejected > 0) rejectedClasses.push('rejected');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: this.props.className },
	      _react2['default'].createElement(
	        'h6',
	        { className: 'nav-header' },
	        (0, _locale.t)('Events Per Minute')
	      ),
	      _react2['default'].createElement(
	        'p',
	        { className: 'count' },
	        this.state.epm
	      ),
	      _react2['default'].createElement(
	        'h6',
	        { className: 'nav-header' },
	        (0, _locale.t)('Rejected in last 24h')
	      ),
	      _react2['default'].createElement(
	        'p',
	        { className: (0, _classnames2['default'])(rejectedClasses) },
	        this.state.totalRejected
	      ),
	      access.has('org:read') && _react2['default'].createElement(
	        _reactRouter.Link,
	        { to: '/organizations/' + this.props.orgId + '/stats/', className: 'stats-link' },
	        (0, _locale.t)('View all stats')
	      )
	    );
	  }
	});
	
	exports['default'] = OrganizationStatOverview;
	module.exports = exports['default'];

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsDuration = __webpack_require__(174);
	
	var _componentsDuration2 = _interopRequireDefault(_componentsDuration);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsListLink = __webpack_require__(47);
	
	var _componentsListLink2 = _interopRequireDefault(_componentsListLink);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _locale = __webpack_require__(2);
	
	var RuleRow = _react2['default'].createClass({
	  displayName: 'RuleRow',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired,
	    onDelete: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: false,
	      error: false
	    };
	  },
	
	  onDelete: function onDelete() {
	    var _this = this;
	
	    /* eslint no-alert:0*/
	    if (!confirm('Are you sure you want to remove this rule?')) return;
	    if (this.state.loading) return;
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	    var data = _props.data;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/rules/' + data.id + '/', {
	      method: 'DELETE',
	      success: function success(d, _, jqXHR) {
	        _this.props.onDelete();
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	        _storesIndicatorStore2['default'].add((0, _locale.t)('Unable to save changes. Please try again.'), 'error');
	      }
	    });
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var orgId = _props2.orgId;
	    var projectId = _props2.projectId;
	    var data = _props2.data;
	
	    var editLink = '/' + orgId + '/' + projectId + '/settings/alerts/rules/' + data.id + '/';
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'pull-right' },
	          _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-sm btn-default',
	              href: editLink },
	            (0, _locale.t)('Edit Rule')
	          ),
	          _react2['default'].createElement(
	            'a',
	            { className: 'btn btn-sm btn-default',
	              onClick: this.onDelete },
	            _react2['default'].createElement('span', { className: 'icon-trash', style: { marginRight: 3 } })
	          )
	        ),
	        _react2['default'].createElement(
	          'h3',
	          null,
	          _react2['default'].createElement(
	            'a',
	            { href: editLink },
	            data.name
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-content with-padding' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'row' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-md-6' },
	            data.conditions.length !== 0 && _react2['default'].createElement(
	              'div',
	              null,
	              _react2['default'].createElement(
	                'h6',
	                null,
	                'When ',
	                _react2['default'].createElement(
	                  'strong',
	                  null,
	                  data.actionMatch
	                ),
	                ' of these conditions are met:'
	              ),
	              _react2['default'].createElement(
	                'table',
	                { className: 'conditions-list table' },
	                data.conditions.map(function (condition) {
	                  return _react2['default'].createElement(
	                    'tr',
	                    null,
	                    _react2['default'].createElement(
	                      'td',
	                      null,
	                      condition.name
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-md-6' },
	            data.actions.length !== 0 && _react2['default'].createElement(
	              'div',
	              null,
	              _react2['default'].createElement(
	                'h6',
	                null,
	                'Take these actions at most ',
	                _react2['default'].createElement(
	                  'strong',
	                  null,
	                  'once every ',
	                  _react2['default'].createElement(_componentsDuration2['default'], { seconds: data.frequency * 60 })
	                ),
	                ' for an issue:'
	              ),
	              _react2['default'].createElement(
	                'table',
	                { className: 'actions-list table' },
	                data.actions.map(function (action) {
	                  return _react2['default'].createElement(
	                    'tr',
	                    null,
	                    _react2['default'].createElement(
	                      'td',
	                      null,
	                      action.name
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	var ProjectAlertRules = _react2['default'].createClass({
	  displayName: 'ProjectAlertRules',
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      ruleList: []
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.fetchData();
	  },
	
	  fetchData: function fetchData() {
	    var _this2 = this;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/rules/', {
	      success: function success(data, _, jqXHR) {
	        _this2.setState({
	          error: false,
	          loading: false,
	          ruleList: data
	        });
	      },
	      error: function error() {
	        _this2.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  onDeleteRule: function onDeleteRule(rule) {
	    this.setState({
	      ruleList: this.state.ruleList.filter(function (r) {
	        return r.id !== rule.id;
	      })
	    });
	  },
	
	  renderBody: function renderBody() {
	    var body = undefined;
	
	    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });else if (this.state.ruleList.length) body = this.renderResults();else body = this.renderEmpty();
	
	    return body;
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('There are no alerts configured for this project.')
	      )
	    );
	  },
	
	  renderResults: function renderResults() {
	    var _this3 = this;
	
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'rules-list' },
	      this.state.ruleList.map(function (rule) {
	        return _react2['default'].createElement(RuleRow, {
	          key: rule.id,
	          data: rule,
	          orgId: orgId,
	          projectId: projectId,
	          onDelete: _this3.onDeleteRule.bind(_this3, rule) });
	      })
	    );
	  },
	
	  render: function render() {
	    var _props$params3 = this.props.params;
	    var orgId = _props$params3.orgId;
	    var projectId = _props$params3.projectId;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'a',
	        { href: '/' + orgId + '/' + projectId + '/settings/alerts/rules/new/',
	          className: 'btn pull-right btn-primary btn-sm' },
	        _react2['default'].createElement('span', { className: 'icon-plus' }),
	        (0, _locale.t)('New Alert Rule')
	      ),
	      _react2['default'].createElement(
	        'h2',
	        null,
	        (0, _locale.t)('Alerts')
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'nav nav-tabs', style: { borderBottom: '1px solid #ddd' } },
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: '/' + orgId + '/' + projectId + '/settings/alerts/',
	            index: true },
	          (0, _locale.t)('Settings')
	        ),
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: '/' + orgId + '/' + projectId + '/settings/alerts/rules/' },
	          (0, _locale.t)('Rules')
	        )
	      ),
	      this.renderBody()
	    );
	  }
	});
	
	exports['default'] = ProjectAlertRules;
	module.exports = exports['default'];

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsListLink = __webpack_require__(47);
	
	var _componentsListLink2 = _interopRequireDefault(_componentsListLink);
	
	var _componentsPluginConfig = __webpack_require__(187);
	
	var _componentsPluginConfig2 = _interopRequireDefault(_componentsPluginConfig);
	
	var _componentsForms = __webpack_require__(36);
	
	var _locale = __webpack_require__(2);
	
	var ProjectDigestSettings = _react2['default'].createClass({
	  displayName: 'ProjectDigestSettings',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    initialData: _react2['default'].PropTypes.object,
	    onSave: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      formData: Object.assign({}, this.props.initialData),
	      errors: {}
	    };
	  },
	
	  onFieldChange: function onFieldChange(name, value) {
	    this.setState({
	      formData: _extends({}, this.state.formData, _defineProperty({}, name, value))
	    });
	  },
	
	  onSubmit: function onSubmit(e) {
	    var _this = this;
	
	    e.preventDefault();
	
	    if (this.state.state == _componentsForms.FormState.SAVING) {
	      return;
	    }
	    this.setState({
	      state: _componentsForms.FormState.SAVING
	    }, function () {
	      var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	      var _props = _this.props;
	      var orgId = _props.orgId;
	      var projectId = _props.projectId;
	
	      _this.api.request('/projects/' + orgId + '/' + projectId + '/', {
	        method: 'PUT',
	        data: _this.state.formData,
	        success: function success(data) {
	          _this.props.onSave(data);
	          _this.setState({
	            state: _componentsForms.FormState.READY,
	            errors: {}
	          });
	        },
	        error: function error(_error) {
	          _this.setState({
	            state: _componentsForms.FormState.ERROR,
	            errors: _error.responseJSON
	          });
	        },
	        complete: function complete() {
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  render: function render() {
	    var isSaving = this.state.state === _componentsForms.FormState.SAVING;
	    var _state = this.state;
	    var errors = _state.errors;
	    var formData = _state.formData;
	
	    var hasChanges = !_underscore2['default'].isEqual(this.props.initialData, formData);
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-header' },
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _locale.t)('Digests')
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-content with-padding' },
	        _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.t)('Sentry will automatically digest alerts sent ' + 'by some services to avoid flooding your inbox ' + 'with individual issue notifications. To control ' + 'how frequently notifications are delivered, use ' + 'the sliders below.')
	        ),
	        _react2['default'].createElement(
	          'form',
	          { onSubmit: this.onSubmit, className: 'form-stacked' },
	          this.state.state === _componentsForms.FormState.ERROR && _react2['default'].createElement(
	            'div',
	            { className: 'alert alert-error alert-block' },
	            (0, _locale.t)('Unable to save your changes. Please ensure all fields are valid and try again.')
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2['default'].createElement(_componentsForms.RangeField, {
	                min: 60,
	                max: 3600,
	                step: 60,
	                defaultValue: 300,
	                label: (0, _locale.t)('Minimum delivery interval'),
	                help: (0, _locale.t)('Notifications will be delivered at most this often.'),
	                name: 'digestsMinDelay',
	                value: formData.digestsMinDelay,
	                error: errors.digestsMinDelay,
	                formatLabel: _componentsForms.RangeField.formatMinutes,
	                onChange: this.onFieldChange.bind(this, 'digestsMinDelay') })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2['default'].createElement(_componentsForms.RangeField, {
	                min: 60,
	                max: 3600,
	                step: 60,
	                defaultValue: 3600,
	                label: (0, _locale.t)('Maximum delivery interval'),
	                help: (0, _locale.t)('Notifications will be delivered at least this often.'),
	                name: 'digestsMaxDelay',
	                value: formData.digestsMaxDelay,
	                error: errors.digestsMaxDelay,
	                formatLabel: _componentsForms.RangeField.formatMinutes,
	                onChange: this.onFieldChange.bind(this, 'digestsMaxDelay') })
	            )
	          ),
	          _react2['default'].createElement(
	            'fieldset',
	            { className: 'form-actions align-right' },
	            _react2['default'].createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary',
	                disabled: isSaving || !hasChanges },
	              (0, _locale.t)('Save Changes')
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	var InactivePlugins = _react2['default'].createClass({
	  displayName: 'InactivePlugins',
	
	  propTypes: {
	    plugins: _react2['default'].PropTypes.array.isRequired,
	    onEnablePlugin: _react2['default'].PropTypes.func.isRequired
	  },
	
	  enablePlugin: function enablePlugin(plugin) {
	    return this.props.onEnablePlugin(plugin, true);
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var plugins = this.props.plugins;
	    if (plugins.length === 0) return null;
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-header' },
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _locale.t)('Inactive Integrations')
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-content with-padding' },
	        _react2['default'].createElement(
	          'ul',
	          { className: 'integration-list' },
	          plugins.map(function (plugin) {
	            return _react2['default'].createElement(
	              'li',
	              { key: plugin.id },
	              _react2['default'].createElement(
	                'button',
	                { onClick: _this2.enablePlugin.bind(_this2, plugin), className: 'ref-plugin-enable-' + plugin.id },
	                plugin.name
	              )
	            );
	          })
	        )
	      )
	    );
	  }
	});
	
	var ProjectAlertSettings = _react2['default'].createClass({
	  displayName: 'ProjectAlertSettings',
	
	  propTypes: {
	    // these are not declared as required of issues with cloned elements
	    // not initially defining them (though they are bound before) ever
	    // rendered
	    organization: _react2['default'].PropTypes.object,
	    project: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      project: this.props.project
	    };
	  },
	
	  onDigestsChange: function onDigestsChange(data) {
	    // TODO(dcramer): propagate this in a more correct way
	    this.setState({
	      project: _extends({}, this.state.project, {
	        digestsMinDelay: data.digestsMinDelay,
	        digestsMaxDelay: data.digestsMaxDelay
	      })
	    });
	  },
	
	  enablePlugin: function enablePlugin(plugin) {
	    var _this3 = this;
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/plugins/' + plugin.id + '/', {
	      method: 'POST',
	      data: this.state.formData,
	      success: function success(data) {
	        // TODO(dcramer): propagate this in a more correct way
	        plugin = _this3.state.project.plugins.find(function (p) {
	          return p.id === plugin.id;
	        });
	        plugin.enabled = true;
	        _this3.setState({ project: _this3.state.project });
	      },
	      error: function error(_error2) {
	        _storesIndicatorStore2['default'].add((0, _locale.t)('Unable to save changes. Please try again.'), 'error');
	      },
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  onDisablePlugin: function onDisablePlugin(plugin) {
	    // TODO(dcramer): propagate this in a more correct way
	    plugin = this.state.project.plugins.find(function (p) {
	      return p.id === plugin.id;
	    });
	    plugin.enabled = false;
	    this.setState({ project: this.state.project });
	  },
	
	  render: function render() {
	    var _this4 = this;
	
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	
	    var organization = this.props.organization;
	    var project = this.state.project;
	    var plugins = project.plugins.filter(function (p) {
	      return p.type == 'notification';
	    });
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'a',
	        { href: '/' + orgId + '/' + projectId + '/settings/alerts/rules/new/',
	          className: 'btn pull-right btn-primary btn-sm' },
	        _react2['default'].createElement('span', { className: 'icon-plus' }),
	        (0, _locale.t)('New Alert Rule')
	      ),
	      _react2['default'].createElement(
	        'h2',
	        null,
	        (0, _locale.t)('Alerts')
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'nav nav-tabs', style: { borderBottom: '1px solid #ddd' } },
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: '/' + orgId + '/' + projectId + '/settings/alerts/',
	            index: true },
	          (0, _locale.t)('Settings')
	        ),
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: '/' + orgId + '/' + projectId + '/settings/alerts/rules/' },
	          (0, _locale.t)('Rules')
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-block alert-info' },
	        (0, _locale.tct)('These settings cover rule-based alerts. If you\'re ' + 'looking to change which notifications you receive ' + 'you may do so from your [link:account settings].', {
	          link: _react2['default'].createElement('a', { href: '/account/settings/notifications/' })
	        })
	      ),
	      _react2['default'].createElement(ProjectDigestSettings, {
	        orgId: orgId,
	        projectId: projectId,
	        initialData: {
	          'digestsMinDelay': project.digestsMinDelay,
	          'digestsMaxDelay': project.digestsMaxDelay
	        },
	        onSave: this.onDigestsChange }),
	      plugins.filter(function (p) {
	        return p.enabled;
	      }).map(function (data) {
	        return _react2['default'].createElement(_componentsPluginConfig2['default'], {
	          data: data,
	          organization: organization,
	          project: project,
	          key: data.id,
	          onDisablePlugin: _this4.onDisablePlugin.bind(_this4, data) });
	      }),
	      _react2['default'].createElement(InactivePlugins, {
	        plugins: plugins.filter(function (p) {
	          return !p.enabled;
	        }),
	        onEnablePlugin: this.enablePlugin })
	    );
	  }
	});
	
	exports['default'] = ProjectAlertSettings;
	module.exports = exports['default'];

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _locale = __webpack_require__(2);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _componentsTodos = __webpack_require__(191);
	
	var _componentsTodos2 = _interopRequireDefault(_componentsTodos);
	
	var ProjectChooser = _react2['default'].createClass({
	  displayName: 'ProjectChooser',
	
	  mixins: [_mixinsOrganizationState2['default']],
	
	  componentWillMount: function componentWillMount() {
	    (0, _jquery2['default'])(document.body).addClass('narrow');
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    (0, _jquery2['default'])(document.body).removeClass('narrow');
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var org = this.getOrganization();
	
	    // Expect onboarding=1 and task=<task id> parameters and task.featureLocation == 'project'
	    // TODO throw up report dialog if not true
	    var task = _componentsTodos2['default'].TASKS.filter(function (task_inst) {
	      return task_inst.task == _this.props.location.query.task;
	    })[0];
	    if (task.featureLocation != 'project') {
	      throw new Error('User arrived on project chooser without a valid task id.');
	    }
	    var teamProjectList = org.teams.map(function (team) {
	
	      // Get list of projects per team
	      var projectList = team.projects.map(function (project) {
	        return _react2['default'].createElement(
	          'tr',
	          { key: project.id },
	          _react2['default'].createElement(
	            'td',
	            null,
	            _react2['default'].createElement(
	              'h5',
	              null,
	              _react2['default'].createElement(
	                'a',
	                { href: '/' + org.slug + '/' + project.slug + '/' + task.location },
	                project.name
	              )
	            )
	          )
	        );
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { key: team.id },
	          _react2['default'].createElement(
	            'div',
	            { className: 'box-header', key: team.id },
	            _react2['default'].createElement(
	              'h3',
	              null,
	              team.name
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'box-content' },
	            _react2['default'].createElement(
	              'table',
	              { className: 'table' },
	              _react2['default'].createElement(
	                'tbody',
	                null,
	                projectList
	              )
	            )
	          )
	        )
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'container' },
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('Choose a project')
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'team-list' },
	        teamProjectList
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectChooser;
	module.exports = exports['default'];

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsForms = __webpack_require__(36);
	
	var _locale = __webpack_require__(2);
	
	var ProjectCspSettingsForm = _react2['default'].createClass({
	  displayName: 'ProjectCspSettingsForm',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    initialData: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    var formData = {};
	    // We only want to work with a certain set of project options here
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = Object.keys(this.props.initialData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var key = _step.value;
	
	        if (key.lastIndexOf('sentry:csp_') === 0) {
	          formData[key] = this.props.initialData[key];
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return {
	      formData: formData,
	      errors: {}
	    };
	  },
	
	  onFieldChange: function onFieldChange(name, value) {
	    var formData = this.state.formData;
	    formData[name] = value;
	    this.setState({
	      formData: formData
	    });
	  },
	
	  onSubmit: function onSubmit(e) {
	    var _this = this;
	
	    e.preventDefault();
	
	    if (this.state.state === _componentsForms.FormState.SAVING) {
	      return;
	    }
	    this.setState({
	      state: _componentsForms.FormState.SAVING
	    }, function () {
	      var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	      var _props = _this.props;
	      var orgId = _props.orgId;
	      var projectId = _props.projectId;
	
	      _this.api.request('/projects/' + orgId + '/' + projectId + '/', {
	        method: 'PUT',
	        data: { options: _this.state.formData },
	        success: function success(data) {
	          _this.setState({
	            state: _componentsForms.FormState.READY,
	            errors: {}
	          });
	        },
	        error: function error(_error) {
	          _this.setState({
	            state: _componentsForms.FormState.ERROR,
	            errors: _error.responseJSON
	          });
	        },
	        complete: function complete() {
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  render: function render() {
	    var isSaving = this.state.state === _componentsForms.FormState.SAVING;
	    var errors = this.state.errors;
	    return _react2['default'].createElement(
	      'form',
	      { onSubmit: this.onSubmit, className: 'form-stacked' },
	      this.state.state === _componentsForms.FormState.ERROR && _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-error alert-block' },
	        (0, _locale.t)('Unable to save your changes. Please ensure all fields are valid and try again.')
	      ),
	      _react2['default'].createElement(
	        'fieldset',
	        null,
	        _react2['default'].createElement(_componentsForms.BooleanField, {
	          key: 'ignored-sources-defaults',
	          name: 'ignored-sources-defaults',
	          label: (0, _locale.t)('Use Default Ignored Sources'),
	          help: (0, _locale.t)('Our default list will attempt to ignore common issues and reduce noise.'),
	          value: this.state.formData['sentry:csp_ignored_sources_defaults'],
	          error: errors['sentry:csp_ignored_sources_defaults'],
	          onChange: this.onFieldChange.bind(this, 'sentry:csp_ignored_sources_defaults') }),
	        _react2['default'].createElement(_componentsForms.TextareaField, {
	          key: 'ignored-sources',
	          name: 'ignored-sources',
	          rows: 5,
	          label: (0, _locale.t)('Additional Ignored Sources'),
	          help: (0, _locale.t)('Separate multiple entries with a newline.'),
	          value: this.state.formData['sentry:csp_ignored_sources'],
	          placeholder: 'e.g. file://*, *.example.com, example.com, etc',
	          error: errors['sentry:csp_ignored_sources'],
	          onChange: this.onFieldChange.bind(this, 'sentry:csp_ignored_sources') })
	      ),
	      _react2['default'].createElement(
	        'fieldset',
	        { className: 'form-actions' },
	        _react2['default'].createElement(
	          'button',
	          { type: 'submit', className: 'btn btn-primary',
	            disabled: isSaving },
	          (0, _locale.t)('Save Changes')
	        )
	      )
	    );
	  }
	});
	
	var ProjectCspSettings = _react2['default'].createClass({
	  displayName: 'ProjectCspSettings',
	
	  propTypes: {
	    setProjectNavSection: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      expected: 2,
	      error: false,
	      keyList: [],
	      projectOptions: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.setProjectNavSection('settings');
	    this.fetchData();
	  },
	
	  // TODO(dcramer): abstract this into a shared helper as its common for route handlers
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var location = this.props.location;
	    var nextLocation = nextProps.location;
	    if (location.pathname != nextLocation.pathname || location.search != nextLocation.search) {
	      this.remountComponent();
	    }
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  fetchData: function fetchData() {
	    var _this2 = this;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/keys/', {
	      success: function success(data, _, jqXHR) {
	        var expected = _this2.state.expected - 1;
	        _this2.setState({
	          expected: expected,
	          loading: expected > 0,
	          keyList: data
	        });
	      },
	      error: function error() {
	        var expected = _this2.state.expected - 1;
	        _this2.setState({
	          expected: expected,
	          error: true,
	          loading: expected > 0
	        });
	      }
	    });
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/', {
	      success: function success(data, _, jqXHR) {
	        var expected = _this2.state.expected - 1;
	        _this2.setState({
	          expected: expected,
	          loading: expected > 0,
	          projectOptions: data.options
	        });
	      },
	      error: function error() {
	        var expected = _this2.state.expected - 1;
	        _this2.setState({
	          expected: expected,
	          error: true,
	          loading: expected > 0
	        });
	      }
	    });
	  },
	
	  getInstructions: function getInstructions() {
	    var endpoint = this.state.keyList.length ? this.state.keyList[0].dsn.csp : 'https://sentry.example.com/api/csp-report/';
	
	    return 'def middleware(request, response):\n' + '    response[\'Content-Security-Policy\'] = \\\n' + '        \"default-src *; \" \\\n' + '        \"script-src \'self\' \'unsafe-eval\' \'unsafe-inline\' cdn.example.com cdn.ravenjs.com; \" \\\n' + '        \"style-src \'self\' \'unsafe-inline\' cdn.example.com; \" \\\n' + '        \"img-src * data:; \" \\\n' + '        \"report-uri ' + endpoint + '\"\n' + '    return response\n';
	  },
	
	  getReportOnlyInstructions: function getReportOnlyInstructions() {
	    var endpoint = this.state.keyList.length ? this.state.keyList[0].dsn.csp : 'https://sentry.example.com/api/csp-report/';
	
	    return 'def middleware(request, response):\n' + '    response[\'Content-Security-Policy-Report-Only\'] = \\\n' + '        \"default-src \'self\'; \" \\\n' + '        \"report-uri ' + endpoint + '\"\n' + '    return response\n';
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	    );
	  },
	
	  render: function render() {
	    if (this.state.loading) return this.renderLoading();
	
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	
	    // TODO(dcramer): localize when language is final
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h1',
	        null,
	        (0, _locale.t)('CSP Reports')
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-block alert-info' },
	        'Psst! This feature is still a work-in-progress. Thanks for being an early adopter!'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'a',
	          { href: 'https://en.wikipedia.org/wiki/Content_Security_Policy' },
	          'Content Security Policy'
	        ),
	        ' (CSP) is a security standard which helps prevent cross-site scripting (XSS), clickjacking and other code injection attacks resulting from execution of malicious content in the trusted web page context. It\'s enforced by browser vendors, and Sentry supports capturing CSP violations using the standard reporting hooks.'
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            (0, _locale.t)('Settings')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          _react2['default'].createElement(ProjectCspSettingsForm, {
	            orgId: orgId,
	            projectId: projectId,
	            initialData: this.state.projectOptions })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            (0, _locale.t)('Integration')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            'To configure ',
	            _react2['default'].createElement(
	              'acronym',
	              { title: 'Content Security Policy' },
	              'CSP'
	            ),
	            ' reports in Sentry, you\'ll need to send a header from your server describing your policy, as well specifying the authenticated Sentry endpoint.'
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'For example, in Python you might achieve this via a simple web middleware:'
	          ),
	          _react2['default'].createElement(
	            'pre',
	            null,
	            this.getInstructions()
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'Alternatively you can setup CSP reports to simply send reports rather than actually enforcing the policy:'
	          ),
	          _react2['default'].createElement(
	            'pre',
	            null,
	            this.getReportOnlyInstructions()
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'We recommend setting this up to only run on a percentage of requests, as otherwise you may find that you\'ve quickly exhausted your quota. For more information, take a look at ',
	            _react2['default'].createElement(
	              'a',
	              { href: 'http://www.html5rocks.com/en/tutorials/security/content-security-policy/' },
	              'the article on html5rocks.com'
	            ),
	            '.'
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectCspSettings;
	module.exports = exports['default'];

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _projectDashboardEventList = __webpack_require__(673);
	
	var _projectDashboardEventList2 = _interopRequireDefault(_projectDashboardEventList);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var _projectDashboardChart = __webpack_require__(672);
	
	var _projectDashboardChart2 = _interopRequireDefault(_projectDashboardChart);
	
	var _locale = __webpack_require__(2);
	
	var PERIOD_HOUR = '1h';
	var PERIOD_DAY = '1d';
	var PERIOD_WEEK = '1w';
	var PERIODS = new Set([PERIOD_HOUR, PERIOD_DAY, PERIOD_WEEK]);
	
	var ProjectDashboard = _react2['default'].createClass({
	  displayName: 'ProjectDashboard',
	
	  propTypes: {
	    defaultStatsPeriod: _react2['default'].PropTypes.string,
	    setProjectNavSection: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_mixinsProjectState2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultStatsPeriod: PERIOD_DAY
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return _extends({
	      statsPeriod: this.props.defaultStatsPeriod
	    }, this.getQueryStringState());
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.setProjectNavSection('dashboard');
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState(this.getQueryStringState(nextProps));
	  },
	
	  getQueryStringState: function getQueryStringState(props) {
	    props = props || this.props;
	    var currentQuery = props.location.query;
	    var statsPeriod = currentQuery.statsPeriod;
	
	    if (!PERIODS.has(statsPeriod)) {
	      statsPeriod = props.defaultStatsPeriod;
	    }
	
	    return {
	      statsPeriod: statsPeriod
	    };
	  },
	
	  getStatsPeriodBeginTimestamp: function getStatsPeriodBeginTimestamp(statsPeriod) {
	    var now = new Date().getTime() / 1000;
	    switch (statsPeriod) {
	      case PERIOD_WEEK:
	        return now - 3600 * 24 * 7;
	      case PERIOD_HOUR:
	        return now - 3600;
	      case PERIOD_DAY:
	      default:
	        return now - 3600 * 24;
	    }
	  },
	
	  getStatsPeriodResolution: function getStatsPeriodResolution(statsPeriod) {
	    switch (statsPeriod) {
	      case PERIOD_WEEK:
	        return '1h';
	      case PERIOD_HOUR:
	        return '10s';
	      case PERIOD_DAY:
	      default:
	        return '1h';
	    }
	  },
	
	  getTrendingIssuesEndpoint: function getTrendingIssuesEndpoint(dateSince) {
	    var params = this.props.params;
	    var qs = _jquery2['default'].param({
	      sort: 'priority',
	      query: 'is:unresolved',
	      since: dateSince
	    });
	    return '/projects/' + params.orgId + '/' + params.projectId + '/issues/?' + qs;
	  },
	
	  getNewIssuesEndpoint: function getNewIssuesEndpoint(dateSince) {
	    var params = this.props.params;
	    var qs = _jquery2['default'].param({
	      sort: 'new',
	      query: 'is:unresolved',
	      since: dateSince
	    });
	    return '/projects/' + params.orgId + '/' + params.projectId + '/issues/?' + qs;
	  },
	
	  render: function render() {
	    var statsPeriod = this.state.statsPeriod;
	
	    var dateSince = this.getStatsPeriodBeginTimestamp(statsPeriod);
	    var resolution = this.getStatsPeriodResolution(statsPeriod);
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    var url = '/' + orgId + '/' + projectId + '/dashboard/';
	    var routeQuery = this.props.location.query;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: 'pull-right' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'btn-group' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: url,
	                  query: _extends({}, routeQuery, { statsPeriod: PERIOD_HOUR })
	                },
	                active: statsPeriod === PERIOD_HOUR,
	                className: 'btn btn-sm btn-default' + (statsPeriod === PERIOD_HOUR ? ' active' : '') },
	              (0, _locale.t)('1 hour')
	            ),
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: url,
	                  query: _extends({}, routeQuery, { statsPeriod: PERIOD_DAY })
	                },
	                active: statsPeriod === PERIOD_DAY,
	                className: 'btn btn-sm btn-default' + (statsPeriod === PERIOD_DAY ? ' active' : '') },
	              (0, _locale.t)('1 day')
	            ),
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: url,
	                  query: _extends({}, routeQuery, { statsPeriod: PERIOD_WEEK })
	                },
	                className: 'btn btn-sm btn-default' + (statsPeriod === PERIOD_WEEK ? ' active' : '') },
	              (0, _locale.t)('1 week')
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _locale.t)('Overview')
	        )
	      ),
	      _react2['default'].createElement(_projectDashboardChart2['default'], {
	        dateSince: dateSince,
	        resolution: resolution }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-6' },
	          _react2['default'].createElement(_projectDashboardEventList2['default'], {
	            title: (0, _locale.t)('Trending Issues'),
	            endpoint: this.getTrendingIssuesEndpoint(dateSince) })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-6' },
	          _react2['default'].createElement(_projectDashboardEventList2['default'], {
	            title: (0, _locale.t)('New Issues'),
	            endpoint: this.getNewIssuesEndpoint(dateSince) })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectDashboard;
	module.exports = exports['default'];

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsBarChart = __webpack_require__(132);
	
	var _componentsBarChart2 = _interopRequireDefault(_componentsBarChart);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var ProjectChart = _react2['default'].createClass({
	  displayName: 'ProjectChart',
	
	  propTypes: {
	    dateSince: _react2['default'].PropTypes.number.isRequired,
	    resolution: _react2['default'].PropTypes.string.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsProjectState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      stats: [],
	      releaseList: []
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    this.setState({
	      loading: true,
	      error: false
	    }, this.fetchData);
	  },
	
	  getStatsEndpoint: function getStatsEndpoint() {
	    var org = this.getOrganization();
	    var project = this.getProject();
	    return '/projects/' + org.slug + '/' + project.slug + '/stats/';
	  },
	
	  getProjectReleasesEndpoint: function getProjectReleasesEndpoint() {
	    var org = this.getOrganization();
	    var project = this.getProject();
	    return '/projects/' + org.slug + '/' + project.slug + '/releases/';
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.api.request(this.getStatsEndpoint(), {
	      query: {
	        since: this.props.dateSince,
	        resolution: this.props.resolution,
	        stat: 'generated'
	      },
	      success: function success(data) {
	        _this.setState({
	          stats: data,
	          error: false,
	          loading: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	
	    this.api.request(this.getProjectReleasesEndpoint(), {
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          releaseList: data
	        });
	      }
	    });
	  },
	
	  renderChart: function renderChart() {
	    var points = this.state.stats.map(function (point) {
	      return { x: point[0], y: point[1] };
	    });
	    var startX = new Date().getTime() / 1000 - 3600 * 24 * 7;
	    var markers = this.state.releaseList.filter(function (release) {
	      var date = new Date(release.dateCreated).getTime() / 1000;
	      return date >= startX;
	    }).map(function (release) {
	      return {
	        label: 'Version ' + release.shortVersion,
	        x: new Date(release.dateCreated).getTime() / 1000
	      };
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'chart-wrapper' },
	      _react2['default'].createElement(_componentsBarChart2['default'], {
	        points: points,
	        markers: markers,
	        className: 'sparkline' }),
	      _react2['default'].createElement(
	        'small',
	        { className: 'date-legend' },
	        (0, _moment2['default'])(this.props.dateSince * 1000).format('LL')
	      )
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box project-chart' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-content with-padding' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'bar-chart' },
	          this.state.loading ? _react2['default'].createElement(_componentsLoadingIndicator2['default'], null) : this.state.error ? _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData }) : this.renderChart()
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectChart;
	module.exports = exports['default'];

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _locale = __webpack_require__(2);
	
	var _eventNode = __webpack_require__(674);
	
	var _eventNode2 = _interopRequireDefault(_eventNode);
	
	var EventList = _react2['default'].createClass({
	  displayName: 'EventList',
	
	  propTypes: {
	    title: _react2['default'].PropTypes.string.isRequired,
	    endpoint: _react2['default'].PropTypes.string.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      groupList: [],
	      loading: true,
	      error: false,
	      statsPeriod: '24h'
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    this.setState({
	      loading: true,
	      error: false
	    }, this.fetchData);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var minutes = undefined;
	    switch (this.state.statsPeriod) {
	      case '15m':
	        minutes = '15';
	        break;
	      case '60m':
	        minutes = '60';
	        break;
	      case '24h':
	      default:
	        minutes = '1440';
	        break;
	    }
	
	    this.api.request(this.props.endpoint, {
	      query: {
	        limit: 5,
	        minutes: minutes
	      },
	      success: function success(data) {
	        _this.setState({
	          groupList: data,
	          loading: false,
	          error: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  onSelectStatsPeriod: function onSelectStatsPeriod(period) {
	    this.setState({
	      statsPeriod: period
	    });
	  },
	
	  render: function render() {
	    var eventNodes = this.state.groupList.map(function (item) {
	      return _react2['default'].createElement(_eventNode2['default'], { group: item, key: item.id });
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box dashboard-widget' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-header clearfix' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'row' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-xs-8' },
	            _react2['default'].createElement(
	              'h3',
	              null,
	              this.props.title
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-xs-2 align-right' },
	            (0, _locale.t)('Events')
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-xs-2 align-right' },
	            (0, _locale.t)('Users')
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-content' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'tab-pane active' },
	          this.state.loading ? _react2['default'].createElement(_componentsLoadingIndicator2['default'], null) : this.state.error ? _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData }) : eventNodes.length ? _react2['default'].createElement(
	            'ul',
	            { className: 'group-list group-list-small' },
	            eventNodes
	          ) : _react2['default'].createElement(
	            'div',
	            { className: 'group-list-empty' },
	            (0, _locale.t)('No data available.')
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = EventList;
	module.exports = exports['default'];

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _componentsCount = __webpack_require__(71);
	
	var _componentsCount2 = _interopRequireDefault(_componentsCount);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var EventNode = _react2['default'].createClass({
	  displayName: 'EventNode',
	
	  propTypes: {
	    group: _proptypes2['default'].Group.isRequired
	  },
	
	  mixins: [_mixinsProjectState2['default']],
	
	  makeGroupLink: function makeGroupLink(title) {
	    var group = this.props.group;
	    var org = this.getOrganization();
	
	    var orgId = org.slug;
	    var projectId = group.project.slug;
	    var groupId = group.id;
	
	    return _react2['default'].createElement(
	      _reactRouter.Link,
	      { to: '/' + orgId + '/' + projectId + '/issues/' + groupId + '/' },
	      title
	    );
	  },
	
	  render: function render() {
	    var group = this.props.group;
	    var userCount = group.userCount;
	
	    return _react2['default'].createElement(
	      'li',
	      { className: 'group' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-8 event-details' },
	          _react2['default'].createElement(
	            'h3',
	            { className: 'truncate' },
	            this.makeGroupLink(group.title)
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'event-message' },
	            group.culprit
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'event-extra' },
	            _react2['default'].createElement(
	              'ul',
	              null,
	              _react2['default'].createElement(
	                'li',
	                null,
	                _react2['default'].createElement('span', { className: 'icon icon-clock' }),
	                _react2['default'].createElement(_componentsTimeSince2['default'], { date: group.lastSeen }),
	                ' — ',
	                _react2['default'].createElement(_componentsTimeSince2['default'], { date: group.firstSeen, suffix: 'old' })
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-2 event-count align-right' },
	          _react2['default'].createElement(_componentsCount2['default'], { value: group.count })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-2 event-users align-right' },
	          _react2['default'].createElement(_componentsCount2['default'], { value: userCount })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = EventNode;
	module.exports = exports['default'];

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsDateTime = __webpack_require__(72);
	
	var _componentsDateTime2 = _interopRequireDefault(_componentsDateTime);
	
	var _componentsFileSize = __webpack_require__(180);
	
	var _componentsFileSize2 = _interopRequireDefault(_componentsFileSize);
	
	var _locale = __webpack_require__(2);
	
	var ProjectDebugSymbols = _react2['default'].createClass({
	  displayName: 'ProjectDebugSymbols',
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      debugSymbols: []
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.fetchData();
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/files/dsyms/', {
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          error: false,
	          loading: false,
	          debugSymbols: data,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  renderDebugTable: function renderDebugTable() {
	    var body = undefined;
	
	    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });else if (this.state.debugSymbols.length > 0) body = this.renderResults();else body = this.renderEmpty();
	
	    return body;
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('There are no debug symbols for this project.')
	      )
	    );
	  },
	
	  renderResults: function renderResults() {
	    return _react2['default'].createElement(
	      'table',
	      { className: 'table' },
	      _react2['default'].createElement(
	        'thead',
	        null,
	        _react2['default'].createElement(
	          'tr',
	          null,
	          _react2['default'].createElement(
	            'th',
	            null,
	            (0, _locale.t)('UUID')
	          ),
	          _react2['default'].createElement(
	            'th',
	            null,
	            (0, _locale.t)('Object Name')
	          ),
	          _react2['default'].createElement(
	            'th',
	            null,
	            (0, _locale.t)('Type')
	          ),
	          _react2['default'].createElement(
	            'th',
	            null,
	            (0, _locale.t)('Upload Date')
	          ),
	          _react2['default'].createElement(
	            'th',
	            null,
	            (0, _locale.t)('Size')
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'tbody',
	        null,
	        this.state.debugSymbols.map(function (item, idx) {
	          return _react2['default'].createElement(
	            'tr',
	            { key: idx },
	            _react2['default'].createElement(
	              'td',
	              null,
	              item.uuid
	            ),
	            _react2['default'].createElement(
	              'td',
	              null,
	              item.objectName
	            ),
	            _react2['default'].createElement(
	              'td',
	              null,
	              item.cpuName,
	              ' (',
	              item.symbolType,
	              ')'
	            ),
	            _react2['default'].createElement(
	              'td',
	              null,
	              _react2['default'].createElement(_componentsDateTime2['default'], { date: item.dateCreated })
	            ),
	            _react2['default'].createElement(
	              'td',
	              null,
	              _react2['default'].createElement(_componentsFileSize2['default'], { bytes: item.size })
	            )
	          );
	        })
	      )
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h1',
	        null,
	        (0, _locale.t)('Debug Symbols')
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('\n          Here you can find uploaded debug information (for instance debug\n          symbol files).  This is used to convert addresses from crash dumps\n          into function names and locations.  For JavaScript debug support\n          look at releases instead.\n        ')
	      ),
	      this.renderDebugTable()
	    );
	  }
	});
	
	exports['default'] = ProjectDebugSymbols;
	module.exports = exports['default'];

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projectsProjectContext = __webpack_require__(309);
	
	var _projectsProjectContext2 = _interopRequireDefault(_projectsProjectContext);
	
	var _componentsProjectHeader = __webpack_require__(598);
	
	var _componentsProjectHeader2 = _interopRequireDefault(_componentsProjectHeader);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var ProjectDetailsLayout = _react2['default'].createClass({
	  displayName: 'ProjectDetailsLayout',
	
	  mixins: [_mixinsProjectState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      projectNavSection: null
	    };
	  },
	
	  /**
	   * This callback can be invoked by the child component
	   * to update the active nav section (which is then passed
	   * to the ProjectHeader
	   */
	  setProjectNavSection: function setProjectNavSection(section) {
	    this.setState({
	      projectNavSection: section
	    });
	  },
	
	  render: function render() {
	    if (!this.context.project) return null;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(_componentsProjectHeader2['default'], {
	        activeSection: this.state.projectNavSection,
	        project: this.context.project,
	        organization: this.getOrganization() }),
	      _react2['default'].createElement(
	        'div',
	        { className: 'container' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'content' },
	          _react2['default'].cloneElement(this.props.children, {
	            setProjectNavSection: this.setProjectNavSection,
	            memberList: this.state.memberList
	          })
	        )
	      )
	    );
	  }
	});
	
	var ProjectDetails = _react2['default'].createClass({
	  displayName: 'ProjectDetails',
	
	  render: function render() {
	    var _props$params = this.props.params;
	    var projectId = _props$params.projectId;
	    var orgId = _props$params.orgId;
	
	    return _react2['default'].createElement(
	      _projectsProjectContext2['default'],
	      { orgId: orgId, projectId: projectId },
	      _react2['default'].createElement(
	        ProjectDetailsLayout,
	        null,
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectDetails;
	module.exports = exports['default'];

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsDateTime = __webpack_require__(72);
	
	var _componentsDateTime2 = _interopRequireDefault(_componentsDateTime);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsPagination = __webpack_require__(39);
	
	var _componentsPagination2 = _interopRequireDefault(_componentsPagination);
	
	var _componentsSearchBarJsx = __webpack_require__(189);
	
	var _componentsSearchBarJsx2 = _interopRequireDefault(_componentsSearchBarJsx);
	
	var _locale = __webpack_require__(2);
	
	var ProjectEvents = _react2['default'].createClass({
	  displayName: 'ProjectEvents',
	
	  propTypes: {
	    defaultQuery: _react2['default'].PropTypes.string,
	    setProjectNavSection: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultQuery: ''
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var queryParams = this.props.location.query;
	
	    return {
	      eventList: [],
	      loading: true,
	      error: false,
	      query: queryParams.query || this.props.defaultQuery,
	      pageLinks: ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.setProjectNavSection('events');
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.location.search !== this.props.location.search) {
	      var queryParams = nextProps.location.query;
	      this.setState({
	        query: queryParams.query
	      }, this.fetchData);
	    }
	  },
	
	  onSearch: function onSearch(query) {
	    var targetQueryParams = {};
	    if (query !== '') targetQueryParams.query = query;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    _reactRouter.browserHistory.pushState(null, '/' + orgId + '/' + projectId + '/events/', targetQueryParams);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(this.getEndpoint(), {
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          error: false,
	          loading: false,
	          eventList: data,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  getEventTitle: function getEventTitle(event) {
	    return event.message.split('\n')[0].substr(0, 100);
	  },
	
	  getEndpoint: function getEndpoint() {
	    var params = this.props.params;
	    var queryParams = _extends({}, this.props.location.query, {
	      limit: 50,
	      query: this.state.query
	    });
	
	    return '/projects/' + params.orgId + '/' + params.projectId + '/events/?' + _jquery2['default'].param(queryParams);
	  },
	
	  renderStreamBody: function renderStreamBody() {
	    var body = undefined;
	
	    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });else if (this.state.eventList.length > 0) body = this.renderResults();else if (this.state.query && this.state.query !== this.props.defaultQuery) body = this.renderNoQueryResults();else body = this.renderEmpty();
	
	    return body;
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	    );
	  },
	
	  renderNoQueryResults: function renderNoQueryResults() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('Sorry, no events match your filters.')
	      )
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('There don\'t seem to be any events.')
	      )
	    );
	  },
	
	  renderResults: function renderResults() {
	    var _this2 = this;
	
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	
	    var children = this.state.eventList.map(function (event, eventIdx) {
	      return _react2['default'].createElement(
	        'tr',
	        { key: event.id },
	        _react2['default'].createElement(
	          'td',
	          { style: { width: 240 } },
	          _react2['default'].createElement(
	            'small',
	            null,
	            _react2['default'].createElement(_componentsDateTime2['default'], { date: event.dateCreated })
	          )
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(
	            'h5',
	            null,
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: '/' + orgId + '/' + projectId + '/issues/' + event.groupID + '/events/' + event.id + '/' },
	              _this2.getEventTitle(event)
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'td',
	          { className: 'event-user table-user-info', style: { textAlign: 'right' } },
	          event.user ? _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(_componentsAvatar2['default'], { user: event.user, size: 64, className: 'avatar' }),
	            event.user.email
	          ) : _react2['default'].createElement(
	            'span',
	            null,
	            '—'
	          )
	        )
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'event-list' },
	      _react2['default'].createElement(
	        'table',
	        { className: 'table' },
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          children
	        )
	      )
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'row release-list-header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-7' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            (0, _locale.t)('Events')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-5 release-search' },
	          _react2['default'].createElement(_componentsSearchBarJsx2['default'], { defaultQuery: '',
	            placeholder: 'Search event message',
	            query: this.state.query,
	            onSearch: this.onSearch
	          })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-block alert-info' },
	        'Psst! This feature is still a work-in-progress. Thanks for being an early adopter!'
	      ),
	      this.renderStreamBody(),
	      _react2['default'].createElement(_componentsPagination2['default'], { pageLinks: this.state.pageLinks })
	    );
	  }
	});
	
	exports['default'] = ProjectEvents;
	module.exports = exports['default'];

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsSwitch = __webpack_require__(606);
	
	var _componentsSwitch2 = _interopRequireDefault(_componentsSwitch);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _locale = __webpack_require__(2);
	
	var _utilsMarked = __webpack_require__(307);
	
	var _utilsMarked2 = _interopRequireDefault(_utilsMarked);
	
	var FilterRow = _react2['default'].createClass({
	  displayName: 'FilterRow',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired,
	    onToggle: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default'], (0, _mixinsTooltip2['default'])({
	    selector: '.tip'
	  })],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: false,
	      error: false
	    };
	  },
	
	  toggle: function toggle() {
	    var _this = this;
	
	    if (this.state.loading) return;
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	    var data = _props.data;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/filters/' + data.id + '/', {
	      method: 'PUT',
	      data: {
	        active: !data.active
	      },
	      success: function success(d, _, jqXHR) {
	        _this.props.onToggle(!data.active);
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	        _storesIndicatorStore2['default'].add((0, _locale.t)('Unable to save changes. Please try again.'), 'error');
	      }
	    });
	  },
	
	  render: function render() {
	    var data = this.props.data;
	    return _react2['default'].createElement(
	      'tr',
	      null,
	      _react2['default'].createElement(
	        'td',
	        null,
	        _react2['default'].createElement(
	          'h5',
	          null,
	          data.name
	        ),
	        data.description && _react2['default'].createElement('small', { className: 'help-block', dangerouslySetInnerHTML: {
	            __html: (0, _utilsMarked2['default'])(data.description)
	          } })
	      ),
	      _react2['default'].createElement(
	        'td',
	        { style: { textAlign: 'right' } },
	        _react2['default'].createElement(_componentsSwitch2['default'], { size: 'lg',
	          isActive: data.active,
	          isLoading: this.state.loading,
	          toggle: this.toggle })
	      )
	    );
	  }
	});
	
	var ProjectFilters = _react2['default'].createClass({
	  displayName: 'ProjectFilters',
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      filterList: []
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.fetchData();
	  },
	
	  fetchData: function fetchData() {
	    var _this2 = this;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/filters/', {
	      success: function success(data, _, jqXHR) {
	        _this2.setState({
	          error: false,
	          loading: false,
	          filterList: data
	        });
	      },
	      error: function error() {
	        _this2.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  onToggleFilter: function onToggleFilter(filter, active) {
	    this.state.filterList.find(function (f) {
	      return f.id === filter.id;
	    }).active = active;
	    this.setState({
	      filterList: this.state.filterList
	    });
	  },
	
	  renderBody: function renderBody() {
	    var body = undefined;
	
	    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });else body = this.renderResults();
	
	    return body;
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	    );
	  },
	
	  renderResults: function renderResults() {
	    var _this3 = this;
	
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	
	    return _react2['default'].createElement(
	      'table',
	      { className: 'table' },
	      _react2['default'].createElement(
	        'tbody',
	        null,
	        this.state.filterList.map(function (filter) {
	          return _react2['default'].createElement(FilterRow, {
	            key: filter.id,
	            data: filter,
	            orgId: orgId,
	            projectId: projectId,
	            onToggle: _this3.onToggleFilter.bind(_this3, filter) });
	        })
	      )
	    );
	  },
	
	  render: function render() {
	    // TODO(dcramer): localize when language is final
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h1',
	        null,
	        (0, _locale.t)('Inbound Data Filters')
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Filters allow you to prevent Sentry from storing events in certain situations. Filtered events are tracked separately from rate limits, and do not apply to any project quotas.'
	      ),
	      this.renderBody()
	    );
	  }
	});
	
	exports['default'] = ProjectFilters;
	module.exports = exports['default'];

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projectsProjectContext = __webpack_require__(309);
	
	var _projectsProjectContext2 = _interopRequireDefault(_projectsProjectContext);
	
	var _docsContext = __webpack_require__(308);
	
	var _docsContext2 = _interopRequireDefault(_docsContext);
	
	var _componentsProjectHeaderProjectSelector = __webpack_require__(136);
	
	var _componentsProjectHeaderProjectSelector2 = _interopRequireDefault(_componentsProjectHeaderProjectSelector);
	
	var GettingStartedBody = _react2['default'].createClass({
	  displayName: 'GettingStartedBody',
	
	  contextTypes: {
	    project: _react2['default'].PropTypes.object,
	    organization: _react2['default'].PropTypes.object
	  },
	
	  render: function render() {
	    var _context = this.context;
	    var project = _context.project;
	    var organization = _context.organization;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'getting-started' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'sub-header flex flex-container flex-vertically-centered' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'p-t-1 p-b-1' },
	          _react2['default'].createElement(_componentsProjectHeaderProjectSelector2['default'], {
	            organization: organization,
	            projectId: project.slug
	          })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'container' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'content' },
	          _react2['default'].createElement(
	            _docsContext2['default'],
	            null,
	            this.props.children
	          )
	        )
	      )
	    );
	  }
	});
	
	var GettingStarted = _react2['default'].createClass({
	  displayName: 'GettingStarted',
	
	  render: function render() {
	    var _props$params = this.props.params;
	    var projectId = _props$params.projectId;
	    var orgId = _props$params.orgId;
	
	    return _react2['default'].createElement(
	      _projectsProjectContext2['default'],
	      { orgId: orgId, projectId: projectId },
	      _react2['default'].createElement(
	        GettingStartedBody,
	        null,
	        this.props.children
	      )
	    );
	  }
	});
	
	exports['default'] = GettingStarted;
	module.exports = exports['default'];

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var LanguageNav = _react2["default"].createClass({
	  displayName: "LanguageNav",
	
	  propTypes: {
	    name: _react2["default"].PropTypes.string.isRequired,
	    active: _react2["default"].PropTypes.bool
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isVisible: this.props.active || false
	    };
	  },
	
	  toggle: function toggle() {
	    this.setState({ isVisible: !this.state.isVisible });
	  },
	
	  render: function render() {
	    var isVisible = this.state.isVisible;
	
	    return _react2["default"].createElement(
	      "div",
	      null,
	      _react2["default"].createElement(
	        "ul",
	        { className: "list-group" },
	        _react2["default"].createElement(
	          "li",
	          { className: "list-group-item list-group-header" },
	          _react2["default"].createElement(
	            "a",
	            { onClick: this.toggle, style: { display: 'block' } },
	            _react2["default"].createElement(
	              "span",
	              { className: "pull-right" },
	              isVisible ? _react2["default"].createElement("span", { className: "icon-minus" }) : _react2["default"].createElement("span", { className: "icon-plus" })
	            ),
	            _react2["default"].createElement(
	              "strong",
	              null,
	              this.props.name
	            )
	          )
	        ),
	        _react2["default"].createElement(
	          "span",
	          { style: {
	              display: isVisible ? 'block' : 'none'
	            } },
	          this.props.children
	        )
	      )
	    );
	  }
	});
	
	exports["default"] = LanguageNav;
	module.exports = exports["default"];

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _componentsAutoSelectText = __webpack_require__(170);
	
	var _componentsAutoSelectText2 = _interopRequireDefault(_componentsAutoSelectText);
	
	var _locale = __webpack_require__(2);
	
	var ProjectInstallOverview = _react2['default'].createClass({
	  displayName: 'ProjectInstallOverview',
	
	  propTypes: {
	    platformData: _react2['default'].PropTypes.object
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      data: this.props.platformData
	    };
	  },
	
	  isGettingStarted: function isGettingStarted() {
	    return location.href.indexOf('getting-started') > 0;
	  },
	
	  getIntegrationLink: function getIntegrationLink(root, platform, display) {
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    var rootUrl = '/' + orgId + '/' + projectId + '/settings/install';
	    if (this.isGettingStarted()) {
	      rootUrl = '/' + orgId + '/' + projectId + '/getting-started';
	    }
	    return _react2['default'].createElement(
	      'li',
	      { className: root + ' ' + platform, key: platform },
	      _react2['default'].createElement('span', { className: 'platformicon platformicon-' + platform }),
	      _react2['default'].createElement(
	        _reactRouter.Link,
	        { to: rootUrl + '/' + platform + '/' },
	        display
	      )
	    );
	  },
	
	  toggleDsn: function toggleDsn() {
	    this.setState({ showDsn: !this.state.showDsn });
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var data = this.state.data;
	    var frameworkList = [];
	    var languageList = [];
	    data.platforms.forEach(function (platform) {
	      platform.integrations.forEach(function (integration) {
	        if (integration.type === 'framework') frameworkList.push([platform, integration]);else if (integration.type === 'language') languageList.push([platform, integration]);
	      });
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h1',
	        null,
	        (0, _locale.t)('Configure your application')
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('Get started by selecting the platform or language that powers your application.')
	      ),
	      this.state.showDsn ? _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _locale.t)('DSN')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'control-group' },
	          _react2['default'].createElement(
	            'label',
	            null,
	            (0, _locale.t)('DSN')
	          ),
	          _react2['default'].createElement(
	            _componentsAutoSelectText2['default'],
	            { className: 'form-control disabled' },
	            data.dsn
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'control-group' },
	          _react2['default'].createElement(
	            'label',
	            null,
	            (0, _locale.t)('Public DSN')
	          ),
	          _react2['default'].createElement(
	            _componentsAutoSelectText2['default'],
	            { className: 'form-control disabled' },
	            data.dsnPublic
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'help-block' },
	            (0, _locale.t)('Your public DSN should be used with JavaScript and ActionScript.')
	          )
	        )
	      ) : _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'small',
	          null,
	          (0, _locale.tct)('Already have things setup? [link:Get your DSN].', {
	            link: _react2['default'].createElement('a', { onClick: this.toggleDsn })
	          })
	        )
	      ),
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('Popular')
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'client-platform-list' },
	        this.getIntegrationLink('javascript', 'javascript', 'JavaScript'),
	        this.getIntegrationLink('python', 'python-django', 'Django'),
	        this.getIntegrationLink('ruby', 'ruby-rails', 'Rails'),
	        this.getIntegrationLink('node', 'node-express', 'Express'),
	        this.getIntegrationLink('php', 'php-laravel', 'Laravel'),
	        this.getIntegrationLink('php', 'php-symfony2', 'Symfony2'),
	        this.getIntegrationLink('java', 'java-log4j', 'Log4j')
	      ),
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('Frameworks')
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'client-platform-list' },
	        frameworkList.map(function (item) {
	          var _item = _slicedToArray(item, 2);
	
	          var platform = _item[0];
	          var integration = _item[1];
	
	          return _this.getIntegrationLink(platform.id, integration.id, integration.name);
	        })
	      ),
	      _react2['default'].createElement(
	        'h3',
	        null,
	        (0, _locale.t)('Languages')
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'client-platform-list' },
	        languageList.map(function (item) {
	          var _item2 = _slicedToArray(item, 2);
	
	          var platform = _item2[0];
	          var integration = _item2[1];
	
	          return _this.getIntegrationLink(platform.id, integration.id, integration.name);
	        })
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.tct)('\n             For a complete list of\n             client integrations, please visit see [docLink:our in-depth documentation].\n          ', {
	          docLink: _react2['default'].createElement('a', { href: 'https://docs.sentry.io' })
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectInstallOverview;
	module.exports = exports['default'];

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _languageNav = __webpack_require__(680);
	
	var _languageNav2 = _interopRequireDefault(_languageNav);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsErrorsNotFound = __webpack_require__(271);
	
	var _componentsErrorsNotFound2 = _interopRequireDefault(_componentsErrorsNotFound);
	
	var _componentsLink = __webpack_require__(182);
	
	var _componentsLink2 = _interopRequireDefault(_componentsLink);
	
	var _locale = __webpack_require__(2);
	
	var ProjectInstallPlatform = _react2['default'].createClass({
	  displayName: 'ProjectInstallPlatform',
	
	  propTypes: {
	    platformData: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState(props) {
	    props = props || this.props;
	    var params = props.params;
	    var key = params.platform;
	    var integration = undefined;
	    var platform = undefined;
	
	    props.platformData.platforms.forEach(function (p_item) {
	      if (integration) {
	        return;
	      }
	      integration = p_item.integrations.filter(function (i_item) {
	        return i_item.id == key;
	      })[0];
	      if (integration) {
	        platform = p_item;
	      }
	    });
	
	    return {
	      loading: true,
	      error: false,
	      integration: integration,
	      platform: platform,
	      html: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.fetchData();
	    $(window).scrollTop(0);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.params.platform !== this.props.params.platform) {
	      this.setState(this.getInitialState(nextProps), this.fetchData);
	      $(window).scrollTop(0);
	    }
	  },
	
	  isGettingStarted: function isGettingStarted() {
	    return location.href.indexOf('getting-started') > 0;
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	    var platform = _props$params.platform;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/docs/' + platform + '/', {
	      success: function success(data) {
	        _this.setState({
	          loading: false,
	          error: false,
	          html: data.html
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  getPlatformLink: function getPlatformLink(platform, display) {
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	
	    return _react2['default'].createElement(
	      _componentsLink2['default'],
	      {
	        key: platform,
	        to: '/' + orgId + '/' + projectId + '/settings/install/' + platform + '/',
	        className: 'list-group-item' },
	      display || platform
	    );
	  },
	
	  renderSidebar: function renderSidebar() {
	    var _this2 = this;
	
	    var platform = this.state.platform;
	    return _react2['default'].createElement(
	      'div',
	      { className: 'install-sidebar col-md-2' },
	      this.props.platformData.platforms.map(function (p_item) {
	        return _react2['default'].createElement(
	          _languageNav2['default'],
	          { key: p_item.id, name: p_item.name, active: platform && platform.id === p_item.id },
	          p_item.integrations.map(function (i_item) {
	            return _this2.getPlatformLink(i_item.id, i_item.id === p_item.id ? (0, _locale.t)('Generic') : i_item.name);
	          })
	        );
	      })
	    );
	  },
	
	  renderBody: function renderBody() {
	    var _state = this.state;
	    var integration = _state.integration;
	    var platform = _state.platform;
	    var _props$params3 = this.props.params;
	    var orgId = _props$params3.orgId;
	    var projectId = _props$params3.projectId;
	
	    if (!integration || !platform) {
	      return _react2['default'].createElement(_componentsErrorsNotFound2['default'], null);
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'pull-right' },
	          _react2['default'].createElement(
	            'a',
	            { href: integration.link, className: 'btn btn-sm btn-default' },
	            (0, _locale.t)('Full Documentation')
	          )
	        ),
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _locale.t)('Configure %(integration)s', { integration: integration.name })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box-content with-padding' },
	        _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.tct)('\n             This is a quick getting started guide. For in-depth instructions\n             on integrating Sentry with [integration], view\n             [docLink:our complete documentation].\n            ', {
	            integration: integration.name,
	            docLink: _react2['default'].createElement('a', { href: integration.link })
	          })
	        ),
	        this.state.loading ? _react2['default'].createElement(_componentsLoadingIndicator2['default'], null) : this.state.error ? _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData }) : _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: this.state.html } }),
	        this.isGettingStarted() &&
	        // Using <a /> instead of <Link /> as hashchange events are not
	        // triggered when switching views within React Router
	        _react2['default'].createElement(
	          'p',
	          null,
	          _react2['default'].createElement(
	            _componentsLink2['default'],
	            {
	              to: '/' + orgId + '/' + projectId + '/#welcome',
	              className: 'btn btn-primary btn-lg' },
	            (0, _locale.t)('Got it! Take me to the Issue Stream.')
	          )
	        )
	      )
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'install row' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'install-content col-md-10' },
	        this.renderBody()
	      ),
	      this.renderSidebar()
	    );
	  }
	});
	
	exports['default'] = ProjectInstallPlatform;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsPluginConfig = __webpack_require__(187);
	
	var _componentsPluginConfig2 = _interopRequireDefault(_componentsPluginConfig);
	
	var ProjectIssueTracking = _react2['default'].createClass({
	  displayName: 'ProjectIssueTracking',
	
	  propTypes: {
	    organization: _react2['default'].PropTypes.object.isRequired,
	    project: _react2['default'].PropTypes.object.isRequired,
	    dataList: _react2['default'].PropTypes.array.isRequired
	  },
	
	  render: function render() {
	    var _this = this;
	
	    if (!this.props.dataList.length) {
	      return null;
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.props.dataList.map(function (data) {
	        return _react2['default'].createElement(_componentsPluginConfig2['default'], _extends({ data: data }, _this.props, { key: data.id }));
	      })
	    );
	  }
	});
	
	exports['default'] = ProjectIssueTracking;
	module.exports = exports['default'];

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsPagination = __webpack_require__(39);
	
	var _componentsPagination2 = _interopRequireDefault(_componentsPagination);
	
	var _componentsSearchBarJsx = __webpack_require__(189);
	
	var _componentsSearchBarJsx2 = _interopRequireDefault(_componentsSearchBarJsx);
	
	var _locale = __webpack_require__(2);
	
	var _releaseList = __webpack_require__(685);
	
	var _releaseList2 = _interopRequireDefault(_releaseList);
	
	var ProjectReleases = _react2['default'].createClass({
	  displayName: 'ProjectReleases',
	
	  propTypes: {
	    defaultQuery: _react2['default'].PropTypes.string,
	    setProjectNavSection: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultQuery: ''
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var queryParams = this.props.location.query;
	
	    return {
	      releaseList: [],
	      loading: true,
	      error: false,
	      query: queryParams.query || this.props.defaultQuery,
	      pageLinks: ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.setProjectNavSection('releases');
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.location.search !== this.props.location.search) {
	      var queryParams = nextProps.location.query;
	      this.setState({
	        query: queryParams.query
	      }, this.fetchData);
	    }
	  },
	
	  onSearch: function onSearch(query) {
	    var targetQueryParams = {};
	    if (query !== '') targetQueryParams.query = query;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    _reactRouter.browserHistory.pushState(null, '/' + orgId + '/' + projectId + '/releases/', targetQueryParams);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(this.getProjectReleasesEndpoint(), {
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          error: false,
	          loading: false,
	          releaseList: data,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  getProjectReleasesEndpoint: function getProjectReleasesEndpoint() {
	    var params = this.props.params;
	    var queryParams = _extends({}, this.props.location.query, {
	      limit: 50,
	      query: this.state.query
	    });
	
	    return '/projects/' + params.orgId + '/' + params.projectId + '/releases/?' + _jquery2['default'].param(queryParams);
	  },
	
	  getReleaseTrackingUrl: function getReleaseTrackingUrl() {
	    var params = this.props.params;
	
	    return '/' + params.orgId + '/' + params.projectId + '/settings/release-tracking/';
	  },
	
	  renderStreamBody: function renderStreamBody() {
	    var body = undefined;
	
	    var params = this.props.params;
	
	    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });else if (this.state.releaseList.length > 0) body = _react2['default'].createElement(_releaseList2['default'], { orgId: params.orgId, projectId: params.projectId, releaseList: this.state.releaseList });else if (this.state.query && this.state.query !== this.props.defaultQuery) body = this.renderNoQueryResults();else body = this.renderEmpty();
	
	    return body;
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	    );
	  },
	
	  renderNoQueryResults: function renderNoQueryResults() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('Sorry, no releases match your filters.')
	      )
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('There don\'t seem to be any releases yet.')
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'a',
	          { href: this.getReleaseTrackingUrl() },
	          (0, _locale.t)('Learn how to integrate Release Tracking')
	        )
	      )
	    );
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'row release-list-header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-7' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            (0, _locale.t)('Releases')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-5 release-search' },
	          _react2['default'].createElement(_componentsSearchBarJsx2['default'], { defaultQuery: '',
	            placeholder: (0, _locale.t)('Search for a release.'),
	            query: this.state.query,
	            onSearch: this.onSearch
	          })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'release-group-header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'row' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-8 col-xs-6' },
	            (0, _locale.t)('Version')
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-2 col-xs-3 release-stats align-right' },
	            (0, _locale.t)('New Events')
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-2 col-xs-3 release-stats align-right' },
	            (0, _locale.t)('Last Event')
	          )
	        )
	      ),
	      this.renderStreamBody(),
	      _react2['default'].createElement(_componentsPagination2['default'], { pageLinks: this.state.pageLinks })
	    );
	  }
	});
	
	exports['default'] = ProjectReleases;
	module.exports = exports['default'];

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCount = __webpack_require__(71);
	
	var _componentsCount2 = _interopRequireDefault(_componentsCount);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _componentsVersion = __webpack_require__(107);
	
	var _componentsVersion2 = _interopRequireDefault(_componentsVersion);
	
	var ReleaseList = _react2['default'].createClass({
	  displayName: 'ReleaseList',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    releaseList: _react2['default'].PropTypes.array.isRequired
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	
	    return _react2['default'].createElement(
	      'ul',
	      { className: 'release-list' },
	      this.props.releaseList.map(function (release) {
	        return _react2['default'].createElement(
	          'li',
	          { className: 'release', key: release.version },
	          _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-8 col-xs-6' },
	              _react2['default'].createElement(
	                'h4',
	                null,
	                _react2['default'].createElement(_componentsVersion2['default'], { orgId: orgId, projectId: projectId, version: release.version })
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'release-meta' },
	                _react2['default'].createElement('span', { className: 'icon icon-clock' }),
	                ' ',
	                _react2['default'].createElement(_componentsTimeSince2['default'], { date: release.dateCreated })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-2 col-xs-3 release-stats stream-count' },
	              _react2['default'].createElement(_componentsCount2['default'], { className: 'release-count', value: release.newGroups })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-2 col-xs-3 release-stats' },
	              release.lastEvent ? _react2['default'].createElement(_componentsTimeSince2['default'], { date: release.lastEvent }) : _react2['default'].createElement(
	                'span',
	                null,
	                '—'
	              )
	            )
	          )
	        );
	      })
	    );
	  }
	});
	
	exports['default'] = ReleaseList;
	module.exports = exports['default'];

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _locale = __webpack_require__(2);
	
	var SavedSearchRow = _react2['default'].createClass({
	  displayName: 'SavedSearchRow',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    data: _react2['default'].PropTypes.object.isRequired,
	
	    onDefault: _react2['default'].PropTypes.func.isRequired,
	    onUserDefault: _react2['default'].PropTypes.func.isRequired,
	    onRemove: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: false,
	      error: false
	    };
	  },
	
	  handleRemove: function handleRemove(e) {
	    var _this = this;
	
	    e.preventDefault();
	    if (this.state.loading) return;
	
	    /* eslint no-alert:0*/
	    if (!window.confirm('Are you sure you want to remove this?')) return;
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	    var data = _props.data;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/searches/' + data.id + '/', {
	      method: 'DELETE',
	      success: function success(d, _, jqXHR) {
	        _this.props.onRemove();
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  handleUpdate: function handleUpdate(params, cb) {
	    var _this2 = this;
	
	    if (this.state.loading) return;
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	    var _props2 = this.props;
	    var orgId = _props2.orgId;
	    var projectId = _props2.projectId;
	    var data = _props2.data;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/searches/' + data.id + '/', {
	      method: 'PUT',
	      data: params,
	      success: function success(d, _, jqXHR) {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	        cb();
	      },
	      error: function error() {
	        _this2.setState({
	          error: true,
	          loading: false
	        });
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  handleDefault: function handleDefault() {
	    this.handleUpdate({
	      isDefault: true
	    }, this.props.onDefault);
	  },
	
	  handleUserDefault: function handleUserDefault() {
	    this.handleUpdate({
	      isUserDefault: true
	    }, this.props.onUserDefault);
	  },
	
	  render: function render() {
	    var data = this.props.data;
	    return _react2['default'].createElement(
	      'tr',
	      null,
	      _react2['default'].createElement(
	        'td',
	        null,
	        _react2['default'].createElement(
	          'h5',
	          { style: { marginBottom: 5 } },
	          data.name
	        ),
	        _react2['default'].createElement(
	          'code',
	          null,
	          data.query
	        )
	      ),
	      _react2['default'].createElement(
	        'td',
	        { style: { textAlign: 'center' } },
	        _react2['default'].createElement('input', { type: 'radio', name: 'userDefault', checked: data.isUserDefault,
	          onChange: this.handleUserDefault })
	      ),
	      _react2['default'].createElement(
	        'td',
	        { style: { textAlign: 'center' } },
	        _react2['default'].createElement('input', { type: 'radio', name: 'default', checked: data.isDefault,
	          onChange: this.handleDefault })
	      ),
	      _react2['default'].createElement(
	        'td',
	        { style: { textAlign: 'right' } },
	        _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-sm btn-default', onClick: this.handleRemove,
	            disabled: this.state.loading },
	          _react2['default'].createElement('span', { className: 'icon icon-trash' }),
	          '  ',
	          (0, _locale.t)('Remove')
	        )
	      )
	    );
	  }
	});
	
	var ProjectSavedSearches = _react2['default'].createClass({
	  displayName: 'ProjectSavedSearches',
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      savedSearchList: []
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.fetchData();
	  },
	
	  fetchData: function fetchData() {
	    var _this3 = this;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/searches/', {
	      success: function success(data, _, jqXHR) {
	        _this3.setState({
	          error: false,
	          loading: false,
	          savedSearchList: data,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this3.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  handleRemovedSearch: function handleRemovedSearch(data) {
	    var savedSearchList = this.state.savedSearchList;
	    this.setState({
	      savedSearchList: savedSearchList.filter(function (search) {
	        return search.id !== data.id;
	      })
	    });
	  },
	
	  handleDefaultSearch: function handleDefaultSearch(data) {
	    var savedSearchList = this.state.savedSearchList;
	    savedSearchList.forEach(function (search) {
	      search.isDefault = data.id === search.id;
	    });
	    this.setState({
	      savedSearchList: savedSearchList
	    });
	  },
	
	  handleUserDefaultSearch: function handleUserDefaultSearch(data) {
	    var savedSearchList = this.state.savedSearchList;
	    savedSearchList.forEach(function (search) {
	      search.isUserDefault = data.id === search.id;
	    });
	    this.setState({
	      savedSearchList: savedSearchList
	    });
	  },
	
	  renderBody: function renderBody() {
	    var body = undefined;
	
	    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });else if (this.state.savedSearchList.length > 0) body = this.renderResults();else body = this.renderEmpty();
	
	    return body;
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('There are no saved searches for this project.')
	      )
	    );
	  },
	
	  renderResults: function renderResults() {
	    var _this4 = this;
	
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'panel panel-default horizontal-scroll' },
	      _react2['default'].createElement(
	        'table',
	        { className: 'table' },
	        _react2['default'].createElement(
	          'thead',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement(
	              'th',
	              null,
	              'Search'
	            ),
	            _react2['default'].createElement(
	              'th',
	              { style: { textAlign: 'center', width: 140 } },
	              'My Default'
	            ),
	            _react2['default'].createElement(
	              'th',
	              { style: { textAlign: 'center', width: 140 } },
	              'Team Default'
	            ),
	            _react2['default'].createElement('th', { style: { width: 120 } })
	          )
	        ),
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          this.state.savedSearchList.map(function (search) {
	            return _react2['default'].createElement(SavedSearchRow, {
	              key: search.id,
	              orgId: orgId,
	              projectId: projectId,
	              data: search,
	              onUserDefault: _this4.handleUserDefaultSearch.bind(_this4, search),
	              onDefault: _this4.handleDefaultSearch.bind(_this4, search),
	              onRemove: _this4.handleRemovedSearch.bind(_this4, search) });
	          })
	        )
	      )
	    );
	  },
	
	  render: function render() {
	    // TODO(dcramer): localize when language is final
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h1',
	        null,
	        (0, _locale.t)('Saved Searches')
	      ),
	      this.renderBody()
	    );
	  }
	});
	
	exports['default'] = ProjectSavedSearches;
	module.exports = exports['default'];

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsListLink = __webpack_require__(47);
	
	var _componentsListLink2 = _interopRequireDefault(_componentsListLink);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _locale = __webpack_require__(2);
	
	var ProjectSettings = _react2['default'].createClass({
	  displayName: 'ProjectSettings',
	
	  propTypes: {
	    setProjectNavSection: _react2['default'].PropTypes.func
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object,
	    organization: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      project: null
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.setProjectNavSection('settings');
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var params = this.props.params;
	    if (nextProps.params.projectId !== params.projectId || nextProps.params.orgId !== params.orgId) {
	      this.setState({
	        loading: true,
	        error: false
	      }, this.fetchData);
	    }
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var params = this.props.params;
	
	    this.api.request('/projects/' + params.orgId + '/' + params.projectId + '/', {
	      success: function success(data) {
	        _this.setState({
	          project: data,
	          loading: false,
	          error: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  render: function render() {
	    // TODO(dcramer): move sidebar into component
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    var settingsUrlRoot = '/' + orgId + '/' + projectId + '/settings';
	    var project = this.state.project;
	    var features = new Set(project.features);
	    var rootInstallPath = '/' + orgId + '/' + projectId + '/settings/install/';
	    var isEarlyAdopter = this.context.organization.isEarlyAdopter;
	    var path = this.props.location.pathname;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'row' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'col-md-2' },
	        _react2['default'].createElement(
	          'h6',
	          { className: 'nav-header' },
	          (0, _locale.t)('Configuration')
	        ),
	        _react2['default'].createElement(
	          'ul',
	          { className: 'nav nav-stacked' },
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: settingsUrlRoot + '/' },
	              (0, _locale.t)('General')
	            )
	          ),
	          _react2['default'].createElement(
	            _componentsListLink2['default'],
	            { to: '/' + orgId + '/' + projectId + '/settings/alerts/',
	              isActive: function (loc) {
	                return path.indexOf(loc.pathname) === 0;
	              } },
	            (0, _locale.t)('Alerts')
	          ),
	          features.has('quotas') && _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: settingsUrlRoot + '/quotas/' },
	              (0, _locale.t)('Rate Limits')
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: settingsUrlRoot + '/tags/' },
	              (0, _locale.t)('Tags')
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: settingsUrlRoot + '/issue-tracking/' },
	              (0, _locale.t)('Issue Tracking')
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: settingsUrlRoot + '/release-tracking/' },
	              (0, _locale.t)('Release Tracking')
	            )
	          ),
	          _react2['default'].createElement(
	            _componentsListLink2['default'],
	            { to: '/' + orgId + '/' + projectId + '/settings/saved-searches/' },
	            (0, _locale.t)('Saved Searches')
	          ),
	          _react2['default'].createElement(
	            _componentsListLink2['default'],
	            { to: '/' + orgId + '/' + projectId + '/settings/debug-symbols/' },
	            (0, _locale.t)('Debug Symbols')
	          )
	        ),
	        _react2['default'].createElement(
	          'h6',
	          { className: 'nav-header' },
	          (0, _locale.t)('Data')
	        ),
	        _react2['default'].createElement(
	          'ul',
	          { className: 'nav nav-stacked' },
	          _react2['default'].createElement(
	            _componentsListLink2['default'],
	            { to: rootInstallPath, isActive: function (loc) {
	                // Because react-router 1.0 removes router.isActive(route)
	                return path === rootInstallPath || /install\/[\w\-]+\/$/.test(path);
	              } },
	            (0, _locale.t)('Error Tracking')
	          ),
	          isEarlyAdopter && _react2['default'].createElement(
	            _componentsListLink2['default'],
	            { to: '/' + orgId + '/' + projectId + '/settings/csp/' },
	            (0, _locale.t)('CSP Reports')
	          ),
	          _react2['default'].createElement(
	            _componentsListLink2['default'],
	            { to: '/' + orgId + '/' + projectId + '/settings/user-feedback/' },
	            (0, _locale.t)('User Feedback')
	          ),
	          _react2['default'].createElement(
	            _componentsListLink2['default'],
	            { to: '/' + orgId + '/' + projectId + '/settings/filters/' },
	            (0, _locale.t)('Inbound Filters')
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: settingsUrlRoot + '/keys/' },
	              (0, _locale.t)('Client Keys'),
	              ' (DSN)'
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'h6',
	          { className: 'nav-header' },
	          (0, _locale.t)('Integrations')
	        ),
	        _react2['default'].createElement(
	          'ul',
	          { className: 'nav nav-stacked' },
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: settingsUrlRoot + '/plugins/' },
	              (0, _locale.t)('All Integrations')
	            )
	          ),
	          project.plugins.filter(function (p) {
	            return p.enabled;
	          }).map(function (plugin) {
	            return _react2['default'].createElement(
	              'li',
	              { key: plugin.id },
	              _react2['default'].createElement(
	                'a',
	                { href: settingsUrlRoot + '/plugins/' + plugin.id + '/' },
	                plugin.name
	              )
	            );
	          })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'col-md-10' },
	        _react2['default'].cloneElement(this.props.children, {
	          setProjectNavSection: this.props.setProjectNavSection,
	          project: project,
	          organization: this.context.organization
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectSettings;
	module.exports = exports['default'];

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Raven) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsForms = __webpack_require__(36);
	
	var _locale = __webpack_require__(2);
	
	var ProjectFeedbackSettingsForm = _react2['default'].createClass({
	  displayName: 'ProjectFeedbackSettingsForm',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    initialData: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    var formData = {};
	    // We only want to work with a certain set of project options here
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = Object.keys(this.props.initialData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var key = _step.value;
	
	        if (key.lastIndexOf('feedback:') === 0) {
	          formData[key] = this.props.initialData[key];
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return {
	      formData: formData,
	      errors: {}
	    };
	  },
	
	  onFieldChange: function onFieldChange(name, value) {
	    var formData = this.state.formData;
	    formData[name] = value;
	    this.setState({
	      formData: formData
	    });
	  },
	
	  onSubmit: function onSubmit(e) {
	    var _this = this;
	
	    e.preventDefault();
	
	    if (this.state.state === _componentsForms.FormState.SAVING) {
	      return;
	    }
	    this.setState({
	      state: _componentsForms.FormState.SAVING
	    }, function () {
	      var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	      var _props = _this.props;
	      var orgId = _props.orgId;
	      var projectId = _props.projectId;
	
	      _this.api.request('/projects/' + orgId + '/' + projectId + '/', {
	        method: 'PUT',
	        data: { options: _this.state.formData },
	        success: function success(data) {
	          _this.setState({
	            state: _componentsForms.FormState.READY,
	            errors: {}
	          });
	        },
	        error: function error(_error) {
	          _this.setState({
	            state: _componentsForms.FormState.ERROR,
	            errors: _error.responseJSON
	          });
	        },
	        complete: function complete() {
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  render: function render() {
	    var isSaving = this.state.state === _componentsForms.FormState.SAVING;
	    var errors = this.state.errors;
	    return _react2['default'].createElement(
	      'form',
	      { onSubmit: this.onSubmit, className: 'form-stacked' },
	      this.state.state === _componentsForms.FormState.ERROR && _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-error alert-block' },
	        (0, _locale.t)('Unable to save your changes. Please ensure all fields are valid and try again.')
	      ),
	      _react2['default'].createElement(
	        'fieldset',
	        null,
	        _react2['default'].createElement(_componentsForms.BooleanField, {
	          key: 'branding',
	          name: 'branding',
	          label: (0, _locale.t)('Show Sentry Branding'),
	          help: (0, _locale.t)('Show "powered by Sentry" within the feedback dialog. We appreciate you helping get the word out about Sentry! <3'),
	          value: this.state.formData['feedback:branding'],
	          error: errors['feedback:branding'],
	          onChange: this.onFieldChange.bind(this, 'feedback:branding') })
	      ),
	      _react2['default'].createElement(
	        'fieldset',
	        { className: 'form-actions' },
	        _react2['default'].createElement(
	          'button',
	          { type: 'submit', className: 'btn btn-primary',
	            disabled: isSaving },
	          (0, _locale.t)('Save Changes')
	        )
	      )
	    );
	  }
	});
	
	var ProjectUserReportSettings = _react2['default'].createClass({
	  displayName: 'ProjectUserReportSettings',
	
	  propTypes: {
	    setProjectNavSection: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      expected: 2,
	
	      keyList: [],
	      projectOptions: {}
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.setProjectNavSection('settings');
	    this.fetchData();
	  },
	
	  componentDidMount: function componentDidMount() {
	    window.sentryEmbedCallback = function (embed) {
	      // Mock the embed's submit xhr to always be successful
	      // NOTE: this will not have errors if the form is empty
	      embed.submit = function (body) {
	        this._submitInProgress = true;
	        setTimeout((function () {
	          this._submitInProgress = false;
	          this.onSuccess();
	        }).bind(this), 500);
	      };
	    };
	  },
	
	  // TODO(dcramer): abstract this into a shared helper as its common for route handlers
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var location = this.props.location;
	    var nextLocation = nextProps.location;
	    if (location.pathname != nextLocation.pathname || location.search != nextLocation.search) {
	      this.remountComponent();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    window.sentryEmbedCallback = null;
	  },
	
	  remountComponent: function remountComponent() {
	    this.setState(this.getInitialState(), this.fetchData);
	  },
	
	  fetchData: function fetchData() {
	    var _this2 = this;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/keys/', {
	      success: function success(data, _, jqXHR) {
	        var expected = _this2.state.expected - 1;
	        _this2.setState({
	          expected: expected,
	          loading: expected > 0,
	          keyList: data
	        });
	      },
	      error: function error() {
	        var expected = _this2.state.expected - 1;
	        _this2.setState({
	          error: true,
	          expected: expected,
	          loading: expected > 0
	        });
	      }
	    });
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/', {
	      success: function success(data, _, jqXHR) {
	        var expected = _this2.state.expected - 1;
	        _this2.setState({
	          expected: expected,
	          loading: expected > 0,
	          projectOptions: data.options
	        });
	      },
	      error: function error() {
	        var expected = _this2.state.expected - 1;
	        _this2.setState({
	          expected: expected,
	          error: true,
	          loading: expected > 0
	        });
	      }
	    });
	  },
	
	  getInstructions: function getInstructions() {
	    var dsn = this.state.keyList.length ? this.state.keyList[0].dsn['public'] : 'https://public@sentry.example.com/1';
	
	    return '<!-- Sentry JS SDK 2.1.+ required -->\n' + '<script src="https://cdn.ravenjs.com/2.1.0/raven.min.js"></script>\n\n' + '{% if request.sentry.id %}\n' + '  <script>\n' + '  Raven.showReportDialog({\n' + '    // grab the eventId generated by the Sentry SDK\n' + '    eventId: \'{{ request.sentry.id }}\',\n\n' + '    // use the public DSN (dont include your secret!)\n' + '    dsn: \'' + dsn + '\'\n' + '  });\n' + '  </script>\n' + '{% endif %}\n';
	  },
	
	  getBrowserJSInstructions: function getBrowserJSInstructions() {
	    var dsn = this.state.keyList.length ? this.state.keyList[0].dsn['public'] : 'https://public@sentry.example.com/1';
	
	    return '<!-- Sentry JS SDK 2.1.+ required -->\n' + '<script src="https://cdn.ravenjs.com/2.1.0/raven.min.js"></script>\n\n' + '<script>\n' + '// configure the SDK as you normally would\n' + 'Raven.config(\'' + dsn + '\').install();\n\n' + '/**\n' + ' * Report a routing error to Sentry and show a feedback dialog to\n' + ' * the user.\n' + ' * \n' + ' * > try {\n' + ' * >   renderRoute()\n' + ' * > } catch (err) {\n' + ' * >   handleRouteError(err);\n' + ' * > }\n' + ' */\n' + 'function handleRouteError(err) {\n' + '  Raven.captureException(err);\n' + '  Raven.showReportDialog();\n' + '};\n' + '</script>\n';
	  },
	
	  handleClick: function handleClick() {
	    Raven.showReportDialog({
	      // should never make it to the Sentry API, but just in case, use throwaway id
	      eventId: '00000000000000000000000000000000'
	    });
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	    );
	  },
	
	  render: function render() {
	    if (this.state.loading) return this.renderLoading();
	
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	
	    // TODO(dcramer): localize when language is final
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'h1',
	        null,
	        (0, _locale.t)('User Feedback')
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-block alert-info' },
	        'Psst! This feature is still a work-in-progress. Thanks for being an early adopter!'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'Enabling User Feedback allows you to interact with your users on an unprecedented level. Collect additional details about issues affecting them, and more importantly reach out to them with resolutions.'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'When configured, your users will be presented with a dialog prompting them for additional information. That information will get attached to the issue in Sentry'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-primary', onClick: this.handleClick },
	          'See the report dialog in action'
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            (0, _locale.t)('Integration')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            'The following example uses our Django integration. Check the documentation for the SDK you\'re using for more details.'
	          ),
	          _react2['default'].createElement(
	            'pre',
	            null,
	            this.getInstructions()
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'If you\'re capturing an error with our Browser JS SDK, things get even simpler:'
	          ),
	          _react2['default'].createElement(
	            'pre',
	            null,
	            this.getBrowserJSInstructions()
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            (0, _locale.t)('Settings')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          _react2['default'].createElement(ProjectFeedbackSettingsForm, {
	            orgId: orgId,
	            projectId: projectId,
	            initialData: this.state.projectOptions })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ProjectUserReportSettings;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)))

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsPagination = __webpack_require__(39);
	
	var _componentsPagination2 = _interopRequireDefault(_componentsPagination);
	
	var _componentsCompactIssue = __webpack_require__(270);
	
	var _componentsCompactIssue2 = _interopRequireDefault(_componentsCompactIssue);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _locale = __webpack_require__(2);
	
	var ProjectUserReports = _react2['default'].createClass({
	  displayName: 'ProjectUserReports',
	
	  propTypes: {
	    defaultQuery: _react2['default'].PropTypes.string,
	    defaultStatus: _react2['default'].PropTypes.string,
	    setProjectNavSection: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultQuery: '',
	      defaultStatus: 'unresolved'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return _extends({
	      reportList: [],
	      loading: true,
	      error: false,
	      pageLinks: '',
	      query: this.props.defaultQuery,
	      status: this.props.defaultStatus
	    }, this.getQueryStringState(this.props));
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.setProjectNavSection('user-feedback');
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.location.search !== this.props.location.search) {
	      this.setState(this.getQueryStringState(nextProps), this.fetchData);
	    }
	  },
	
	  getQueryStringState: function getQueryStringState(props) {
	    var location = props.location;
	    var status = location.query.hasOwnProperty('status') ? location.query.status : this.props.defaultStatus;
	    var query = location.query.hasOwnProperty('query') ? location.query.query : this.props.defaultQuery;
	    return {
	      query: query,
	      status: status
	    };
	  },
	
	  onSearch: function onSearch(query) {
	    var targetQueryParams = {};
	    if (query !== '') targetQueryParams.query = query;
	    if (this.state.status !== this.props.defaultStatus) targetQueryParams.status = this.state.status;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    _reactRouter.browserHistory.pushState(null, '/' + orgId + '/' + projectId + '/user-feedback/', targetQueryParams);
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(this.getEndpoint(), {
	      success: function success(data, _, jqXHR) {
	        var issues = data.map(function (r) {
	          return r.issue;
	        });
	        _storesGroupStore2['default'].add(issues);
	        _this.setState({
	          error: false,
	          loading: false,
	          reportList: data,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  getEndpoint: function getEndpoint() {
	    var params = this.props.params;
	    var queryParams = _extends({}, this.props.location.query, {
	      limit: 50,
	      query: this.state.query,
	      status: this.state.status
	    });
	
	    return '/projects/' + params.orgId + '/' + params.projectId + '/user-reports/?' + _jquery2['default'].param(queryParams);
	  },
	
	  getUserReportsUrl: function getUserReportsUrl() {
	    var params = this.props.params;
	
	    return '/' + params.orgId + '/' + params.projectId + '/settings/user-feedback/';
	  },
	
	  renderStreamBody: function renderStreamBody() {
	    var body = undefined;
	
	    if (this.state.loading) body = this.renderLoading();else if (this.state.error) body = _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });else if (this.state.reportList.length > 0) body = this.renderResults();else if (this.state.query && this.state.query !== this.props.defaultQuery) body = this.renderNoQueryResults();else body = this.renderEmpty();
	
	    return body;
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	    );
	  },
	
	  renderNoQueryResults: function renderNoQueryResults() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('Sorry, no results match your search query.')
	      )
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('No user reports have been collected for this project.')
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: this.getUserReportsUrl() },
	          (0, _locale.t)('Learn how to integrate User Feedback')
	        )
	      )
	    );
	  },
	
	  renderResults: function renderResults() {
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	
	    var children = this.state.reportList.map(function (item, itemIdx) {
	      var body = _utils2['default'].nl2br(_utils2['default'].urlize(_utils2['default'].escape(item.comments)));
	      var issue = item.issue;
	
	      return _react2['default'].createElement(
	        _componentsCompactIssue2['default'],
	        {
	          key: item.id,
	          id: issue.id,
	          data: issue,
	          orgId: orgId,
	          projectId: projectId },
	        _react2['default'].createElement(
	          'div',
	          { className: 'activity-container', style: { margin: '10px 0 5px' } },
	          _react2['default'].createElement(
	            'ul',
	            { className: 'activity' },
	            _react2['default'].createElement(
	              'li',
	              { className: 'activity-note', style: { paddingBottom: 0 } },
	              _react2['default'].createElement(_componentsAvatar2['default'], { user: item, size: 64, className: 'avatar' }),
	              _react2['default'].createElement(
	                'div',
	                { className: 'activity-bubble' },
	                _react2['default'].createElement(_componentsTimeSince2['default'], { date: item.dateCreated }),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'activity-author' },
	                  item.name,
	                  ' ',
	                  _react2['default'].createElement(
	                    'small',
	                    null,
	                    item.email
	                  )
	                ),
	                _react2['default'].createElement('p', { dangerouslySetInnerHTML: { __html: body } })
	              )
	            )
	          )
	        )
	      );
	    });
	
	    return _react2['default'].createElement(
	      'ul',
	      { className: 'issue-list' },
	      children
	    );
	  },
	
	  render: function render() {
	    var path = this.props.location.pathname;
	    var status = this.state.status;
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'row release-list-header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-9' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            (0, _locale.t)('User Feedback')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-3', style: { textAlign: 'right' } },
	          _react2['default'].createElement(
	            'div',
	            { className: 'btn-group' },
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: path,
	                className: 'btn btn-sm btn-default' + (status === 'unresolved' ? ' active' : '') },
	              (0, _locale.t)('Unresolved')
	            ),
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: { pathname: path, query: { status: '' } },
	                className: 'btn btn-sm btn-default' + (status === '' ? ' active' : '') },
	              (0, _locale.t)('All Issues')
	            )
	          )
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-block alert-info' },
	        'Psst! This feature is still a work-in-progress. Thanks for being an early adopter!'
	      ),
	      this.renderStreamBody(),
	      _react2['default'].createElement(_componentsPagination2['default'], { pageLinks: this.state.pageLinks })
	    );
	  }
	});
	
	exports['default'] = ProjectUserReports;
	module.exports = exports['default'];

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _componentsGroupList = __webpack_require__(287);
	
	var _componentsGroupList2 = _interopRequireDefault(_componentsGroupList);
	
	var _locale = __webpack_require__(2);
	
	var ReleaseAllEvents = _react2['default'].createClass({
	  displayName: 'ReleaseAllEvents',
	
	  contextTypes: {
	    release: _react2['default'].PropTypes.object
	  },
	
	  render: function render() {
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-block' },
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: {
	              pathname: '/' + orgId + '/' + projectId + '/',
	              query: { query: 'release:' + this.context.release.version }
	            } },
	          _react2['default'].createElement('span', { className: 'icon icon-open' }),
	          (0, _locale.t)('View all events seen in this release in the stream')
	        )
	      ),
	      _react2['default'].createElement(_componentsGroupList2['default'], {
	        orgId: orgId,
	        projectId: projectId,
	        query: 'release:"' + this.context.release.version + '"',
	        canSelectGroups: false, bulkActions: false })
	    );
	  }
	});
	
	exports['default'] = ReleaseAllEvents;
	module.exports = exports['default'];

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsFileSize = __webpack_require__(180);
	
	var _componentsFileSize2 = _interopRequireDefault(_componentsFileSize);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsPagination = __webpack_require__(39);
	
	var _componentsPagination2 = _interopRequireDefault(_componentsPagination);
	
	var _componentsLinkWithConfirmation = __webpack_require__(183);
	
	var _componentsLinkWithConfirmation2 = _interopRequireDefault(_componentsLinkWithConfirmation);
	
	var _locale = __webpack_require__(2);
	
	var ReleaseArtifacts = _react2['default'].createClass({
	  displayName: 'ReleaseArtifacts',
	
	  contextTypes: {
	    release: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      fileList: [],
	      pageLinks: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.fetchData();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (this.props.location.search !== prevProps.location.search) {
	      this.fetchData();
	    }
	  },
	
	  getFilesEndpoint: function getFilesEndpoint() {
	    var params = this.props.params;
	    return '/projects/' + params.orgId + '/' + params.projectId + '/releases/' + params.version + '/files/';
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(this.getFilesEndpoint(), {
	      method: 'GET',
	      data: this.props.location.query,
	      success: function success(data, _, jqXHR) {
	        _this.setState({
	          error: false,
	          loading: false,
	          fileList: data,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error() {
	        _this.setState({
	          error: true,
	          loading: false
	        });
	      }
	    });
	  },
	
	  handleRemove: function handleRemove(id) {
	    var _this2 = this;
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Removing artifact..'));
	
	    this.api.request(this.getFilesEndpoint() + (id + '/'), {
	      method: 'DELETE',
	      success: function success() {
	        var fileList = _this2.state.fileList.filter(function (file) {
	          return file.id !== id;
	        });
	
	        _this2.setState({
	          fileList: fileList
	        });
	
	        _storesIndicatorStore2['default'].add((0, _locale.t)('Artifact removed.'), 'success', {
	          duration: 4000
	        });
	      },
	      error: function error() {
	        _storesIndicatorStore2['default'].add((0, _locale.t)('Unable to remove artifact. Please try again.'), 'error', {
	          duration: 4000
	        });
	      },
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  render: function render() {
	    var _this3 = this;
	
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });else if (this.state.fileList.length === 0) return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('There are no artifacts uploaded for this release.')
	      )
	    );
	
	    // TODO(dcramer): files should allow you to download them
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'release-group-header' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'row' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-9 col-xs-8' },
	            'Name'
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-sm-2 col-xs-2 align-right' },
	            'Size'
	          ),
	          _react2['default'].createElement('div', { className: 'col-sm-1 col-xs-2 align-right' })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'release-list' },
	        this.state.fileList.map(function (file) {
	          return _react2['default'].createElement(
	            'div',
	            { className: 'release release-artifact row', key: file.id },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-9 col-xs-8', style: { wordWrap: 'break-word' } },
	              _react2['default'].createElement(
	                'strong',
	                null,
	                file.name || '(empty)'
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-2 col-xs-2 align-right' },
	              _react2['default'].createElement(_componentsFileSize2['default'], { bytes: file.size })
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-1 col-xs-2 align-right' },
	              _react2['default'].createElement(
	                _componentsLinkWithConfirmation2['default'],
	                {
	                  className: 'btn btn-sm btn-default',
	                  title: (0, _locale.t)('Delete artifact'),
	                  message: (0, _locale.t)('Are you sure you want to remove this artifact?'),
	                  onConfirm: _this3.handleRemove.bind(_this3, file.id) },
	                _react2['default'].createElement('span', { className: 'icon icon-trash' })
	              )
	            )
	          );
	        })
	      ),
	      _react2['default'].createElement(_componentsPagination2['default'], { pageLinks: this.state.pageLinks })
	    );
	  }
	});
	
	exports['default'] = ReleaseArtifacts;
	module.exports = exports['default'];

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsCount = __webpack_require__(71);
	
	var _componentsCount2 = _interopRequireDefault(_componentsCount);
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _componentsListLink = __webpack_require__(47);
	
	var _componentsListLink2 = _interopRequireDefault(_componentsListLink);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var _componentsTimeSince = __webpack_require__(40);
	
	var _componentsTimeSince2 = _interopRequireDefault(_componentsTimeSince);
	
	var _componentsVersion = __webpack_require__(107);
	
	var _componentsVersion2 = _interopRequireDefault(_componentsVersion);
	
	var _locale = __webpack_require__(2);
	
	var ReleaseDetails = _react2['default'].createClass({
	  displayName: 'ReleaseDetails',
	
	  propTypes: {
	    setProjectNavSection: _react2['default'].PropTypes.func
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  childContextTypes: {
	    release: _react2['default'].PropTypes.object
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsProjectState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      release: null,
	      loading: true,
	      error: false
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      release: this.state.release
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.setProjectNavSection('releases');
	    this.fetchData();
	  },
	
	  getTitle: function getTitle() {
	    var project = this.getProject();
	    var team = this.getTeam();
	    var params = this.props.params;
	    return 'Release ' + params.version + ' | ' + team.name + ' / ' + project.name;
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(this.getReleaseDetailsEndpoint(), {
	      success: function success(data) {
	        _this.setState({
	          loading: false,
	          release: data
	        });
	      }, error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  getReleaseDetailsEndpoint: function getReleaseDetailsEndpoint() {
	    var params = this.props.params;
	    var orgId = params.orgId;
	    var projectId = params.projectId;
	    var version = params.version;
	
	    return '/projects/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(version) + '/';
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	
	    var release = this.state.release;
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { title: this.getTitle() },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: 'release-details' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-6 col-xs-12' },
	              _react2['default'].createElement(
	                'h3',
	                null,
	                (0, _locale.t)('Release'),
	                ' ',
	                _react2['default'].createElement(
	                  'strong',
	                  null,
	                  _react2['default'].createElement(_componentsVersion2['default'], { orgId: orgId, projectId: projectId, version: release.version, anchor: false })
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                { className: 'release-meta' },
	                _react2['default'].createElement('span', { className: 'icon icon-clock' }),
	                ' ',
	                _react2['default'].createElement(_componentsTimeSince2['default'], { date: release.dateCreated })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-2 hidden-xs' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'release-stats' },
	                _react2['default'].createElement(
	                  'h6',
	                  { className: 'nav-header' },
	                  (0, _locale.t)('New Issues')
	                ),
	                _react2['default'].createElement(
	                  'span',
	                  { className: 'stream-count' },
	                  _react2['default'].createElement(_componentsCount2['default'], { value: release.newGroups })
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-2 hidden-xs' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'release-stats' },
	                _react2['default'].createElement(
	                  'h6',
	                  { className: 'nav-header' },
	                  (0, _locale.t)('First Event')
	                ),
	                release.firstEvent ? _react2['default'].createElement(
	                  'span',
	                  { className: 'stream-count' },
	                  _react2['default'].createElement(_componentsTimeSince2['default'], { date: release.firstEvent })
	                ) : _react2['default'].createElement(
	                  'span',
	                  null,
	                  '—'
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-sm-2 hidden-xs' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'release-stats' },
	                _react2['default'].createElement(
	                  'h6',
	                  { className: 'nav-header' },
	                  (0, _locale.t)('Last Event')
	                ),
	                release.lastEvent ? _react2['default'].createElement(
	                  'span',
	                  { className: 'stream-count' },
	                  _react2['default'].createElement(_componentsTimeSince2['default'], { date: release.lastEvent })
	                ) : _react2['default'].createElement(
	                  'span',
	                  null,
	                  '—'
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'ul',
	            { className: 'nav nav-tabs' },
	            _react2['default'].createElement(
	              _componentsListLink2['default'],
	              { to: '/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(release.version) + '/', isActive: function (loc) {
	                  // react-router isActive will return true for any route that is part of the active route
	                  // e.g. parent routes. To avoid matching on sub-routes, insist on strict path equality.
	                  return loc.pathname === _this2.props.location.pathname;
	                } },
	              (0, _locale.t)('New Issues')
	            ),
	            _react2['default'].createElement(
	              _componentsListLink2['default'],
	              { to: '/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(release.version) + '/all-events/' },
	              (0, _locale.t)('All Issues')
	            ),
	            _react2['default'].createElement(
	              _componentsListLink2['default'],
	              { to: '/' + orgId + '/' + projectId + '/releases/' + encodeURIComponent(release.version) + '/artifacts/' },
	              (0, _locale.t)('Artifacts')
	            )
	          )
	        ),
	        _react2['default'].cloneElement(this.props.children, {
	          release: release
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = ReleaseDetails;
	module.exports = exports['default'];

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _componentsGroupList = __webpack_require__(287);
	
	var _componentsGroupList2 = _interopRequireDefault(_componentsGroupList);
	
	var _locale = __webpack_require__(2);
	
	var ReleaseNewEvents = _react2['default'].createClass({
	  displayName: 'ReleaseNewEvents',
	
	  contextTypes: {
	    release: _react2['default'].PropTypes.object
	  },
	
	  render: function render() {
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-block' },
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: {
	              pathname: '/' + orgId + '/' + projectId + '/',
	              query: { query: 'first-release:' + this.context.release.version }
	            } },
	          _react2['default'].createElement('span', { className: 'icon icon-open' }),
	          (0, _locale.t)('View new events seen in this release in the stream')
	        )
	      ),
	      _react2['default'].createElement(_componentsGroupList2['default'], {
	        orgId: orgId,
	        projectId: projectId,
	        query: 'first-release:"' + this.context.release.version + '"',
	        canSelectGroups: false, bulkActions: false })
	    );
	  }
	});
	
	exports['default'] = ReleaseNewEvents;
	module.exports = exports['default'];

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ravenJs = __webpack_require__(108);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var RouteError = _react2['default'].createClass({
	  displayName: 'RouteError',
	
	  propTypes: {
	    error: _react2['default'].PropTypes.object.isRequired
	  },
	
	  componentWillMount: function componentWillMount() {
	    // TODO(dcramer): show something in addition to embed (that contains it?)
	    // TODO(dcramer): capture better context
	    // throw this in a timeout so if it errors we dont fall over
	    this._timeout = window.setTimeout((function () {
	      _ravenJs2['default'].captureException(this.props.error);
	      // TODO(dcramer): we do not have errorId until send() is called which
	      // has latency in production so this will literally never fire
	      _ravenJs2['default'].showReportDialog();
	    }).bind(this));
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._timeout) {
	      window.clearTimeout(this._timeout);
	    }
	    (0, _jquery2['default'])('.sentry-error-embed-wrapper').remove();
	  },
	
	  render: function render() {
	    // TODO(dcramer): show additional resource links
	    return _react2['default'].createElement(
	      'div',
	      { className: 'alert alert-block alert-error' },
	      _react2['default'].createElement(
	        'div',
	        { style: { fontSize: 24, marginBottom: 10 } },
	        _react2['default'].createElement('span', { className: 'icon-exclamation', style: { fontSize: 20, marginRight: 10 } }),
	        _react2['default'].createElement(
	          'span',
	          null,
	          'Oops! Something went wrong'
	        )
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'It looks like you\'ve hit an issue in our client application. Don\'t worry though! We use Sentry to monitor Sentry and it\'s likely we\'re already looking into this!'
	      ),
	      _react2['default'].createElement(
	        'p',
	        null,
	        'If you\'re daring, you may want to try the following:'
	      ),
	      _react2['default'].createElement(
	        'ul',
	        null,
	        window && window.adblockSuspected && _react2['default'].createElement(
	          'li',
	          null,
	          'We detected something AdBlock-like. Try disabling it, as it\'s known to cause issues.'
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          'Give it a few seconds and ',
	          _react2['default'].createElement(
	            'a',
	            { onClick: function () {
	                window.location.href = window.location.href;
	              } },
	            'reload the page'
	          ),
	          '.'
	        ),
	        _react2['default'].createElement(
	          'li',
	          null,
	          'If all else fails, ',
	          _react2['default'].createElement(
	            'a',
	            { href: 'http://github.com/getsentry/sentry/issues' },
	            'create an issue'
	          ),
	          ' with more details.'
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = RouteError;
	module.exports = exports['default'];

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _componentsFooter = __webpack_require__(105);
	
	var _componentsFooter2 = _interopRequireDefault(_componentsFooter);
	
	var _componentsSidebar = __webpack_require__(137);
	
	var _componentsSidebar2 = _interopRequireDefault(_componentsSidebar);
	
	var _componentsErrorsNotFound = __webpack_require__(271);
	
	var _componentsErrorsNotFound2 = _interopRequireDefault(_componentsErrorsNotFound);
	
	var RouteNotFound = _react2['default'].createClass({
	  displayName: 'RouteNotFound',
	
	  getTitle: function getTitle() {
	    return 'Page Not Found';
	  },
	
	  render: function render() {
	    // TODO(dcramer): show additional resource links
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { title: this.getTitle() },
	      _react2['default'].createElement(
	        'div',
	        { className: 'app' },
	        _react2['default'].createElement(_componentsSidebar2['default'], null),
	        _react2['default'].createElement(
	          'div',
	          { className: 'container' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'content' },
	            _react2['default'].createElement(
	              'section',
	              { className: 'body' },
	              _react2['default'].createElement(_componentsErrorsNotFound2['default'], null)
	            )
	          )
	        ),
	        _react2['default'].createElement(_componentsFooter2['default'], null)
	      )
	    );
	  }
	});
	
	exports['default'] = RouteNotFound;
	module.exports = exports['default'];

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsSelectInput = __webpack_require__(190);
	
	var _componentsSelectInput2 = _interopRequireDefault(_componentsSelectInput);
	
	var _locale = __webpack_require__(2);
	
	var _ruleNodeList = __webpack_require__(698);
	
	var _ruleNodeList2 = _interopRequireDefault(_ruleNodeList);
	
	var RuleEditor = _react2['default'].createClass({
	  displayName: 'RuleEditor',
	
	  propTypes: {
	    actions: _react2['default'].PropTypes.array.isRequired,
	    conditions: _react2['default'].PropTypes.array.isRequired,
	    rule: _react2['default'].PropTypes.object.isRequired,
	    project: _react2['default'].PropTypes.object.isRequired,
	    organization: _react2['default'].PropTypes.object.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: false,
	      error: null
	    };
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.state.error) {
	      (0, _jquery2['default'])(document.body).scrollTop((0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this.refs.form)).offset().top);
	    }
	  },
	
	  serializeNode: function serializeNode(node) {
	    var result = {};
	    (0, _jquery2['default'])(node).find('input, select').each(function (_, el) {
	      if (el.name) {
	        result[el.name] = (0, _jquery2['default'])(el).val();
	      }
	    });
	    return result;
	  },
	
	  onSubmit: function onSubmit(e) {
	    var _this = this;
	
	    e.preventDefault();
	    var form = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this.refs.form));
	    var conditions = [];
	    form.find('.rule-condition-list .rule-form').each(function (_, el) {
	      conditions.push(_this.serializeNode(el));
	    });
	    var actions = [];
	    form.find('.rule-action-list .rule-form').each(function (_, el) {
	      actions.push(_this.serializeNode(el));
	    });
	    var actionMatch = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this.refs.actionMatch)).val();
	    var frequency = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this.refs.frequency)).val();
	    var name = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this.refs.name)).val();
	    var data = {
	      actionMatch: actionMatch,
	      actions: actions,
	      conditions: conditions,
	      frequency: frequency,
	      name: name
	    };
	    var rule = this.props.rule;
	    var project = this.props.project;
	    var org = this.props.organization;
	    var endpoint = '/projects/' + org.slug + '/' + project.slug + '/rules/';
	    if (rule.id) {
	      endpoint += rule.id + '/';
	    }
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add('Saving...');
	    this.api.request(endpoint, {
	      method: rule.id ? 'PUT' : 'POST',
	      data: data,
	      success: function success() {
	        window.location.href = '../';
	      },
	      error: function error(response) {
	        _this.setState({
	          error: response.responseJSON || { '__all__': 'Unknown error' },
	          loading: false
	        });
	      },
	      complete: function complete() {
	        _storesIndicatorStore2['default'].remove(loadingIndicator);
	      }
	    });
	  },
	
	  hasError: function hasError(field) {
	    var error = this.state.error;
	
	    if (!error) return false;
	    return !!error[field];
	  },
	
	  render: function render() {
	    var rule = this.props.rule;
	    var _state = this.state;
	    var loading = _state.loading;
	    var error = _state.error;
	    var actionMatch = rule.actionMatch;
	    var actions = rule.actions;
	    var conditions = rule.conditions;
	    var frequency = rule.frequency;
	    var name = rule.name;
	
	    return _react2['default'].createElement(
	      'form',
	      { onSubmit: this.onSubmit, ref: 'form' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'box rule-detail' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-header' },
	          _react2['default'].createElement(
	            'h3',
	            null,
	            rule.id ? 'Edit Alert Rule' : 'New Alert Rule'
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          error && _react2['default'].createElement(
	            'div',
	            { className: 'alert alert-block alert-error' },
	            _react2['default'].createElement(
	              'p',
	              null,
	              (0, _locale.t)('There was an error saving your changes. Make sure all fields are valid and try again.')
	            )
	          ),
	          _react2['default'].createElement(
	            'h6',
	            null,
	            (0, _locale.t)('Rule name'),
	            ':'
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'control-group' },
	            _react2['default'].createElement('input', { ref: 'name',
	              type: 'text', className: 'form-control',
	              defaultValue: name,
	              required: true,
	              placeholder: (0, _locale.t)('My Rule Name') })
	          ),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(
	            'div',
	            { className: 'node-match-selector' },
	            _react2['default'].createElement(
	              'h6',
	              null,
	              (0, _locale.t)('Every time %s of these conditions are met:', _react2['default'].createElement(
	                _componentsSelectInput2['default'],
	                { ref: 'actionMatch',
	                  className: this.hasError('actionMatch') ? ' error' : '',
	                  value: actionMatch,
	                  style: { width: 80 },
	                  required: true },
	                _react2['default'].createElement(
	                  'option',
	                  { value: 'all' },
	                  (0, _locale.t)('all')
	                ),
	                _react2['default'].createElement(
	                  'option',
	                  { value: 'any' },
	                  (0, _locale.t)('any')
	                ),
	                _react2['default'].createElement(
	                  'option',
	                  { value: 'none' },
	                  (0, _locale.t)('none')
	                )
	              ))
	            )
	          ),
	          this.hasError('conditions') && _react2['default'].createElement(
	            'p',
	            { className: 'error' },
	            (0, _locale.t)('Ensure at least one condition is enabled and all required fields are filled in.')
	          ),
	          _react2['default'].createElement(_ruleNodeList2['default'], { nodes: this.props.conditions,
	            initialItems: conditions,
	            className: 'rule-condition-list',
	            onChange: this.onConditionsChange }),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(
	            'h6',
	            null,
	            (0, _locale.t)('Take these actions:')
	          ),
	          this.hasError('actions') && _react2['default'].createElement(
	            'p',
	            { className: 'error' },
	            (0, _locale.t)('Ensure at least one action is enabled and all required fields are filled in.')
	          ),
	          _react2['default'].createElement(_ruleNodeList2['default'], { nodes: this.props.actions,
	            initialItems: actions,
	            className: 'rule-action-list',
	            onChange: this.onActionsChange }),
	          _react2['default'].createElement('hr', null),
	          _react2['default'].createElement(
	            'div',
	            { className: 'node-frequency-selector' },
	            _react2['default'].createElement(
	              'h6',
	              null,
	              (0, _locale.tct)('Perform these actions at most once every [frequency] for an issue.', {
	                frequency: _react2['default'].createElement(
	                  _componentsSelectInput2['default'],
	                  { ref: 'frequency',
	                    className: this.hasError('frequency') ? ' error' : '',
	                    value: frequency,
	                    style: { width: 150 },
	                    required: true },
	                  _react2['default'].createElement(
	                    'option',
	                    { value: '5' },
	                    (0, _locale.t)('5 minutes')
	                  ),
	                  _react2['default'].createElement(
	                    'option',
	                    { value: '10' },
	                    (0, _locale.t)('10 minutes')
	                  ),
	                  _react2['default'].createElement(
	                    'option',
	                    { value: '30' },
	                    (0, _locale.t)('30 minutes')
	                  ),
	                  _react2['default'].createElement(
	                    'option',
	                    { value: '60' },
	                    (0, _locale.t)('60 minutes')
	                  ),
	                  _react2['default'].createElement(
	                    'option',
	                    { value: '180' },
	                    (0, _locale.t)('3 hours')
	                  ),
	                  _react2['default'].createElement(
	                    'option',
	                    { value: '720' },
	                    (0, _locale.t)('12 hours')
	                  ),
	                  _react2['default'].createElement(
	                    'option',
	                    { value: '1440' },
	                    (0, _locale.t)('24 hours')
	                  )
	                )
	              })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'actions' },
	            _react2['default'].createElement(
	              'button',
	              { className: 'btn btn-primary btn-lg',
	                disabled: loading },
	              (0, _locale.t)('Save Rule')
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = RuleEditor;
	module.exports = exports['default'];

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var RuleNode = _react2['default'].createClass({
	  displayName: 'RuleNode',
	
	  propTypes: {
	    data: _react2['default'].PropTypes.object.isRequired,
	    node: _react2['default'].PropTypes.shape({
	      html: _react2['default'].PropTypes.string.isRequired
	    }).isRequired,
	    onDelete: _react2['default'].PropTypes.func.isRequired
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var $html = (0, _jquery2['default'])(_reactDom2['default'].findDOMNode(this.refs.html));
	
	    $html.find('select, input, textarea').each(function (_, el) {
	      var $el = (0, _jquery2['default'])(el);
	      $el.attr('id', '');
	      $el.val(_this.props.data[el.name]);
	    });
	
	    $html.find('select').select2();
	
	    $html.find('input.typeahead').each(function (_, el) {
	      var $el = (0, _jquery2['default'])(el);
	      $el.select2({
	        initSelection: function initSelection(option, callback) {
	          var $option = (0, _jquery2['default'])(option);
	          callback({ id: $option.val(), text: $option.val() });
	        },
	        data: $el.data('choices'),
	        createSearchChoice: function createSearchChoice(term) {
	          return { id: _jquery2['default'].trim(term), text: _jquery2['default'].trim(term) };
	        }
	      });
	    });
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var data = _props.data;
	    var node = _props.node;
	
	    return _react2['default'].createElement(
	      'tr',
	      null,
	      _react2['default'].createElement(
	        'td',
	        { className: 'rule-form' },
	        _react2['default'].createElement('input', { type: 'hidden', name: 'id', value: data.id }),
	        _react2['default'].createElement('span', { ref: 'html', dangerouslySetInnerHTML: { __html: node.html } })
	      ),
	      _react2['default'].createElement(
	        'td',
	        { className: 'align-right' },
	        _react2['default'].createElement(
	          'a',
	          { onClick: this.props.onDelete },
	          _react2['default'].createElement('span', { className: 'icon-trash' })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = RuleNode;
	module.exports = exports['default'];

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsSelectInput = __webpack_require__(190);
	
	var _componentsSelectInput2 = _interopRequireDefault(_componentsSelectInput);
	
	var _ruleNode = __webpack_require__(697);
	
	var _ruleNode2 = _interopRequireDefault(_ruleNode);
	
	var RuleNodeList = _react2['default'].createClass({
	  displayName: 'RuleNodeList',
	
	  propTypes: {
	    initialItems: _react2['default'].PropTypes.array,
	    nodes: _react2['default'].PropTypes.array.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var counter = 0;
	    var initialItems = (this.props.initialItems || []).map(function (item) {
	      return _extends({}, item, { key_attr: counter++ });
	    });
	
	    return {
	      items: initialItems,
	      counter: counter
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this._nodesById = {};
	
	    this.props.nodes.forEach(function (node) {
	      _this._nodesById[node.id] = node;
	    });
	  },
	
	  onAddRow: function onAddRow(sel) {
	    var nodeId = sel.val();
	    if (!nodeId) return;
	
	    sel.val('');
	
	    this.state.items.push({
	      id: nodeId,
	      // Since RuleNode item state is stored outside of React (using innerHTML),
	      // need to make sure elements aren't accidentally re-rendered. So, give each
	      // row a consistent key using a counter that initializes at 0 when RuleNodeList
	      // is mounted.
	      key_attr: this.state.counter
	    });
	    this.setState({
	      items: this.state.items,
	      counter: this.state.counter + 1
	    });
	  },
	
	  onDeleteRow: function onDeleteRow(idx, e) {
	    this.state.items.splice(idx, 1);
	    this.setState({
	      items: this.state.items
	    });
	  },
	
	  getNode: function getNode(id) {
	    return this._nodesById[id];
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: this.props.className },
	      _react2['default'].createElement(
	        'table',
	        { className: 'node-list table', style: { marginBottom: '10px' } },
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          this.state.items.map(function (item, idx) {
	            return _react2['default'].createElement(_ruleNode2['default'], { key: item.key_attr,
	              node: _this2.getNode(item.id),
	              onDelete: _this2.onDeleteRow.bind(_this2, idx),
	              data: item });
	          })
	        )
	      ),
	      _react2['default'].createElement(
	        'fieldset',
	        { className: 'node-selector' },
	        _react2['default'].createElement(
	          _componentsSelectInput2['default'],
	          { onChange: this.onAddRow, style: { width: '100%' } },
	          _react2['default'].createElement('option', { key: 'blank' }),
	          this.props.nodes.map(function (node) {
	            return _react2['default'].createElement(
	              'option',
	              { value: node.id, key: node.id },
	              node.label
	            );
	          })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = RuleNodeList;
	module.exports = exports['default'];

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _reactDocumentTitle = __webpack_require__(43);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsEventsEventEntries = __webpack_require__(272);
	
	var _componentsEventsEventEntries2 = _interopRequireDefault(_componentsEventsEventEntries);
	
	var _componentsFooter = __webpack_require__(105);
	
	var _componentsFooter2 = _interopRequireDefault(_componentsFooter);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _proptypes = __webpack_require__(14);
	
	var _proptypes2 = _interopRequireDefault(_proptypes);
	
	var _sharedGroupHeader = __webpack_require__(700);
	
	var _sharedGroupHeader2 = _interopRequireDefault(_sharedGroupHeader);
	
	var SharedGroupDetails = _react2['default'].createClass({
	  displayName: 'SharedGroupDetails',
	
	  childContextTypes: {
	    group: _proptypes2['default'].Group
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      group: null,
	      loading: true,
	      error: false
	    };
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      group: this.state.group
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	    (0, _jquery2['default'])(document.body).addClass('shared-group');
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    (0, _jquery2['default'])(document.body).removeClass('shared-group');
	  },
	
	  getTitle: function getTitle() {
	    if (this.state.group) return this.state.group.title;
	    return 'Sentry';
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    this.setState({
	      loading: true,
	      error: false
	    });
	
	    this.api.request(this.getGroupDetailsEndpoint(), {
	      success: function success(data) {
	        _this.setState({
	          loading: false,
	          group: data
	        });
	      }, error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  getGroupDetailsEndpoint: function getGroupDetailsEndpoint() {
	    var id = this.props.params.shareId;
	
	    return '/shared/issues/' + id + '/';
	  },
	
	  render: function render() {
	    var group = this.state.group;
	
	    if (this.state.loading || !group) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	
	    var evt = this.state.group.latestEvent;
	
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      { title: this.getTitle() },
	      _react2['default'].createElement(
	        'div',
	        { className: 'app' },
	        _react2['default'].createElement('div', { className: 'pattern-bg' }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'container' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'box box-modal' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'box-header' },
	              _react2['default'].createElement(
	                'a',
	                { href: '/' },
	                _react2['default'].createElement('span', { className: 'icon-sentry-logo-full' })
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'box-content' },
	              _react2['default'].createElement(
	                'div',
	                { className: 'content' },
	                _react2['default'].createElement(_sharedGroupHeader2['default'], { group: group }),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'group-overview event-details-container' },
	                  _react2['default'].createElement(
	                    'div',
	                    { className: 'primary' },
	                    _react2['default'].createElement(_componentsEventsEventEntries2['default'], {
	                      group: group,
	                      event: evt,
	                      orgId: group.project.organization.slug,
	                      project: group.project,
	                      isShare: true })
	                  )
	                ),
	                _react2['default'].createElement(_componentsFooter2['default'], null)
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = SharedGroupDetails;
	module.exports = exports['default'];

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var SharedGroupHeader = _react2["default"].createClass({
	  displayName: "SharedGroupHeader",
	
	  propTypes: {
	    group: _react2["default"].PropTypes.object.isRequired
	  },
	
	  render: function render() {
	    var group = this.props.group;
	
	    return _react2["default"].createElement(
	      "div",
	      { className: "group-detail", style: { paddingBottom: 20 } },
	      _react2["default"].createElement(
	        "div",
	        { className: "details" },
	        _react2["default"].createElement(
	          "h3",
	          null,
	          group.title
	        ),
	        _react2["default"].createElement(
	          "div",
	          { className: "event-message" },
	          _react2["default"].createElement(
	            "span",
	            { className: "message" },
	            group.culprit
	          )
	        )
	      )
	    );
	  }
	});
	
	exports["default"] = SharedGroupHeader;
	module.exports = exports["default"];

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _reactRouter = __webpack_require__(8);
	
	var _jsCookie = __webpack_require__(316);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _reactSticky = __webpack_require__(866);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesGroupStore = __webpack_require__(42);
	
	var _storesGroupStore2 = _interopRequireDefault(_storesGroupStore);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _mixinsProjectState = __webpack_require__(41);
	
	var _mixinsProjectState2 = _interopRequireDefault(_mixinsProjectState);
	
	var _componentsPagination = __webpack_require__(39);
	
	var _componentsPagination2 = _interopRequireDefault(_componentsPagination);
	
	var _componentsStreamGroup = __webpack_require__(296);
	
	var _componentsStreamGroup2 = _interopRequireDefault(_componentsStreamGroup);
	
	var _streamActions = __webpack_require__(703);
	
	var _streamActions2 = _interopRequireDefault(_streamActions);
	
	var _actionsStreamTagActions = __webpack_require__(265);
	
	var _actionsStreamTagActions2 = _interopRequireDefault(_actionsStreamTagActions);
	
	var _storesStreamTagStore = __webpack_require__(303);
	
	var _storesStreamTagStore2 = _interopRequireDefault(_storesStreamTagStore);
	
	var _streamFilters = __webpack_require__(704);
	
	var _streamFilters2 = _interopRequireDefault(_streamFilters);
	
	var _streamSidebar = __webpack_require__(708);
	
	var _streamSidebar2 = _interopRequireDefault(_streamSidebar);
	
	var _utils = __webpack_require__(7);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _utilsLogging = __webpack_require__(142);
	
	var _utilsParseLinkHeader = __webpack_require__(195);
	
	var _utilsParseLinkHeader2 = _interopRequireDefault(_utilsParseLinkHeader);
	
	var _locale = __webpack_require__(2);
	
	var Stream = _react2['default'].createClass({
	  displayName: 'Stream',
	
	  propTypes: {
	    defaultSort: _react2['default'].PropTypes.string,
	    defaultStatsPeriod: _react2['default'].PropTypes.string,
	    defaultQuery: _react2['default'].PropTypes.string,
	    maxItems: _react2['default'].PropTypes.number,
	    setProjectNavSection: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_reflux2['default'].listenTo(_storesGroupStore2['default'], 'onGroupChange'), _reflux2['default'].listenTo(_storesStreamTagStore2['default'], 'onStreamTagChange'), _mixinsApiMixin2['default'], _mixinsProjectState2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultQuery: null,
	      defaultSort: 'date',
	      defaultStatsPeriod: '24h',
	      maxItems: 25
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var searchId = this.props.params.searchId || null;
	    return _extends({
	      groupIds: [],
	      isDefaultSearch: null,
	      searchId: searchId,
	      // if we have no query then we can go ahead and fetch data
	      loading: searchId || !this.hasQuery() ? true : false,
	      savedSearchLoading: true,
	      savedSearchList: [],
	      selectAllActive: false,
	      multiSelected: false,
	      anySelected: false,
	      statsPeriod: this.props.defaultStatsPeriod,
	      realtimeActive: _jsCookie2['default'].get('realtimeActive') === 'true',
	      pageLinks: '',
	      dataLoading: true,
	      error: false,
	      query: '',
	      sort: this.props.defaultSort,
	      tags: _storesStreamTagStore2['default'].getAllTags(),
	      tagsLoading: true,
	      isSidebarVisible: false,
	      isStickyHeader: false
	    }, this.getQueryState());
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.props.setProjectNavSection('stream');
	
	    this._streamManager = new _utils2['default'].StreamManager(_storesGroupStore2['default']);
	    this._poller = new _utils2['default'].CursorPoller({
	      success: this.onRealtimePoll
	    });
	
	    this.fetchSavedSearches();
	    this.fetchTags();
	    if (!this.state.loading) {
	      this.fetchData();
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    // you cannot apply both a query and a saved search (our routes do not
	    // support it), so the searchId takes priority
	    if (this.state.loading) {
	      return;
	    }
	
	    var searchIdChanged = this.state.isDefaultSearch ? nextProps.params.searchId : nextProps.params.searchId !== this.state.searchId;
	
	    if (searchIdChanged || nextProps.location.search !== this.props.location.search) {
	      // TODO(dcramer): handle 404 from popState on searchId
	      this.setState(this.getQueryState(nextProps), this.fetchData);
	    }
	  },
	
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !_underscore2['default'].isEqual(this.state, nextState, true);
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.realtimeActive !== this.state.realtimeActive) {
	      // User toggled realtime button
	      if (this.state.realtimeActive) {
	        this.resumePolling();
	      } else {
	        this._poller.disable();
	      }
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._poller.disable();
	    _storesGroupStore2['default'].reset();
	  },
	
	  fetchSavedSearches: function fetchSavedSearches() {
	    var _this = this;
	
	    this.setState({
	      savedSearchLoading: true
	    });
	
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var projectId = _props$params.projectId;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/searches/', {
	      success: function success(data) {
	        var newState = {
	          isDefaultSearch: false,
	          savedSearchLoading: false,
	          savedSearchList: data,
	          loading: false
	        };
	        var needsData = _this.state.loading;
	        var searchId = _this.state.searchId;
	        if (searchId) {
	          var match = data.filter(function (search) {
	            return search.id === searchId;
	          });
	          if (match.length) {
	            newState.query = match[0].query;
	          } else {
	            return void _this.setState({
	              savedSearchLoading: false,
	              savedSearchList: data,
	              searchId: null,
	              isDefaultSearch: true
	            }, _this.transitionTo);
	          }
	        } else if (!_this.hasQuery()) {
	          var defaultResults = data.filter(function (search) {
	            return search.isUserDefault;
	          });
	          if (!defaultResults.length) {
	            defaultResults = data.filter(function (search) {
	              return search.isDefault;
	            });
	          }
	          if (defaultResults.length) {
	            newState.searchId = defaultResults[0].id;
	            newState.query = defaultResults[0].query;
	            newState.isDefaultSearch = true;
	          }
	        }
	        _this.setState(newState, needsData ? _this.fetchData : null);
	      },
	      error: function error(_error) {
	        // XXX(dcramer): fail gracefully by still loading the stream
	        (0, _utilsLogging.logAjaxError)(_error);
	        _this.setState({
	          loading: false,
	          isDefaultSearch: null,
	          searchId: null,
	          savedSearchList: [],
	          savedSearchLoading: false,
	          query: ''
	        });
	      }
	    });
	  },
	
	  fetchTags: function fetchTags() {
	    var _this2 = this;
	
	    _storesStreamTagStore2['default'].reset();
	    _actionsStreamTagActions2['default'].loadTags();
	
	    this.setState({
	      tagsLoading: true
	    });
	
	    var params = this.props.params;
	    this.api.request('/projects/' + params.orgId + '/' + params.projectId + '/tags/', {
	      success: function success(tags) {
	        _this2.setState({ tagsLoading: false });
	        _actionsStreamTagActions2['default'].loadTagsSuccess(tags);
	      },
	      error: function error(_error2) {
	        _this2.setState({ tagsLoading: false });
	        _actionsStreamTagActions2['default'].loadTagsError();
	      }
	    });
	  },
	
	  onSavedSearchCreate: function onSavedSearchCreate(data) {
	    var _props$params2 = this.props.params;
	    var orgId = _props$params2.orgId;
	    var projectId = _props$params2.projectId;
	
	    var savedSearchList = this.state.savedSearchList;
	    savedSearchList.push(data);
	    // TODO(dcramer): sort
	    this.setState({
	      savedSearchList: savedSearchList
	    });
	    _reactRouter.browserHistory.pushState(null, '/' + orgId + '/' + projectId + '/searches/' + data.id + '/');
	  },
	
	  getQueryState: function getQueryState(props) {
	    props = props || this.props;
	    var currentQuery = props.location.query || {};
	    // state may not yet be defined at this point
	    var state = this.state || {};
	
	    var hasQuery = currentQuery.hasOwnProperty('query');
	
	    var searchId = hasQuery ? null : props.params.searchId || state.searchId || null;
	
	    var sort = currentQuery.hasOwnProperty('sort') ? currentQuery.sort : this.props.defaultSort;
	
	    var statsPeriod = currentQuery.hasOwnProperty('statsPeriod') ? currentQuery.statsPeriod : this.props.defaultStatsPeriod;
	
	    if (statsPeriod !== '14d' && statsPeriod !== '24h') {
	      statsPeriod = this.props.defaultStatsPeriod;
	    }
	
	    var newState = {
	      sort: sort,
	      statsPeriod: statsPeriod,
	      query: hasQuery ? currentQuery.query : '',
	      searchId: searchId,
	      isDefaultSearch: false
	    };
	
	    // state is not yet defined
	    if (this.state === null) return newState;
	
	    if (searchId) {
	      var searchResult = this.state.savedSearchList.filter(function (search) {
	        return search.id === searchId;
	      });
	      if (searchResult.length) {
	        newState.query = searchResult[0].query;
	      } else {
	        newState.searchId = null;
	      }
	    } else if (!hasQuery) {
	      var defaultResult = this.state.savedSearchList.filter(function (search) {
	        return search.isDefault;
	      });
	      if (defaultResult.length) {
	        newState.isDefaultSearch = true;
	        newState.searchId = defaultResult[0].id;
	        newState.query = defaultResult[0].query;
	      } else {
	        newState.searchId = null;
	      }
	    }
	    newState.loading = false;
	    return newState;
	  },
	
	  hasQuery: function hasQuery(props) {
	    props = props || this.props;
	    var currentQuery = props.location.query || {};
	    return currentQuery.hasOwnProperty('query');
	  },
	
	  fetchData: function fetchData() {
	    var _this3 = this;
	
	    _storesGroupStore2['default'].loadInitialData([]);
	
	    this.setState({
	      dataLoading: true,
	      error: false
	    });
	
	    var url = this.getGroupListEndpoint();
	
	    var requestParams = {
	      query: this.state.query.replace(/^\s+|\s+$/g, ''),
	      limit: this.props.maxItems,
	      sort: this.state.sort,
	      statsPeriod: this.state.statsPeriod,
	      shortIdLookup: '1'
	    };
	
	    var currentQuery = this.props.location.query || {};
	    if (currentQuery.hasOwnProperty('cursor')) {
	      requestParams.cursor = currentQuery.cursor;
	    }
	
	    if (this.lastRequest) {
	      this.lastRequest.cancel();
	    }
	
	    this._poller.disable();
	
	    this.lastRequest = this.api.request(url, {
	      method: 'GET',
	      data: requestParams,
	      success: function success(data, ignore, jqXHR) {
	        // if this is a direct hit, we redirect to the intended result directly.
	        // we have to use the project slug from the result data instead of the
	        // the current props one as the shortIdLookup can return results for
	        // different projects.
	        if (jqXHR.getResponseHeader('X-Sentry-Direct-Hit') === '1') {
	          return void _reactRouter.browserHistory.pushState(null, '/' + _this3.props.params.orgId + '/' + data[0].project.slug + '/issues/' + data[0].id + '/');
	        }
	
	        _this3._streamManager.push(data);
	
	        _this3.setState({
	          error: false,
	          dataLoading: false,
	          pageLinks: jqXHR.getResponseHeader('Link')
	        });
	      },
	      error: function error(err) {
	        var error = err.responseJSON || true;
	        error = error.detail || true;
	        _this3.setState({
	          error: error,
	          dataLoading: false
	        });
	      },
	      complete: function complete(jqXHR) {
	        _this3.lastRequest = null;
	
	        _this3.resumePolling();
	      }
	    });
	  },
	
	  resumePolling: function resumePolling() {
	    if (!this.state.pageLinks) return;
	
	    // Only resume polling if we're on the first page of results
	    var links = (0, _utilsParseLinkHeader2['default'])(this.state.pageLinks);
	    if (links && !links.previous.results && this.state.realtimeActive) {
	      this._poller.setEndpoint(links.previous.href);
	      this._poller.enable();
	    }
	  },
	
	  getGroupListEndpoint: function getGroupListEndpoint() {
	    var params = this.props.params;
	
	    return '/projects/' + params.orgId + '/' + params.projectId + '/issues/';
	  },
	
	  onRealtimeChange: function onRealtimeChange(realtime) {
	    _jsCookie2['default'].set('realtimeActive', realtime.toString());
	    this.setState({
	      realtimeActive: realtime
	    });
	  },
	
	  onSelectStatsPeriod: function onSelectStatsPeriod(period) {
	    if (period != this.state.statsPeriod) {
	      // TODO(dcramer): all charts should now suggest "loading"
	      this.setState({
	        statsPeriod: period
	      }, function () {
	        this.transitionTo();
	      });
	    }
	  },
	
	  onRealtimePoll: function onRealtimePoll(data, links) {
	    this._streamManager.unshift(data);
	    if (!_utils2['default'].valueIsEqual(this.state.pageLinks, links, true)) {
	      this.setState({
	        pageLinks: links
	      });
	    }
	  },
	
	  onGroupChange: function onGroupChange() {
	    var groupIds = this._streamManager.getAllItems().map(function (item) {
	      return item.id;
	    });
	    if (!_utils2['default'].valueIsEqual(groupIds, this.state.groupIds)) {
	      this.setState({
	        groupIds: groupIds
	      });
	    }
	  },
	
	  onStreamTagChange: function onStreamTagChange(tags) {
	    // new object to trigger state change
	    this.setState({
	      tags: _extends({}, tags)
	    });
	  },
	
	  onSearch: function onSearch(query) {
	    if (query === this.state.query) {
	      // if query is the same, just re-fetch data
	      this.fetchData();
	    } else {
	      this.setState({
	        query: query,
	        searchId: null
	      }, this.transitionTo);
	    }
	  },
	
	  onSortChange: function onSortChange(sort) {
	    this.setState({
	      sort: sort
	    }, this.transitionTo);
	  },
	
	  onSidebarToggle: function onSidebarToggle() {
	    this.setState({
	      isSidebarVisible: !this.state.isSidebarVisible
	    });
	  },
	
	  onStickyStateChange: function onStickyStateChange(state) {
	    this.setState({
	      isStickyHeader: state
	    });
	  },
	
	  /**
	   * Returns true if all results in the current query are visible/on this page
	   */
	  allResultsVisible: function allResultsVisible() {
	    if (!this.state.pageLinks) return false;
	
	    var links = (0, _utilsParseLinkHeader2['default'])(this.state.pageLinks);
	    return links && !links.previous.results && !links.next.results;
	  },
	
	  transitionTo: function transitionTo() {
	    var queryParams = {};
	
	    if (!this.state.searchId && this.state.query !== this.props.defaultQuery) {
	      queryParams.query = this.state.query;
	    }
	
	    if (this.state.sort !== this.props.defaultSort) {
	      queryParams.sort = this.state.sort;
	    }
	
	    if (this.state.statsPeriod !== this.props.defaultStatsPeriod) {
	      queryParams.statsPeriod = this.state.statsPeriod;
	    }
	
	    var params = this.props.params;
	    var path = this.state.searchId ? '/' + params.orgId + '/' + params.projectId + '/searches/' + this.state.searchId + '/' : '/' + params.orgId + '/' + params.projectId + '/';
	
	    _reactRouter.browserHistory.pushState(null, path, queryParams);
	  },
	
	  renderGroupNodes: function renderGroupNodes(ids, statsPeriod) {
	    var _props$params3 = this.props.params;
	    var orgId = _props$params3.orgId;
	    var projectId = _props$params3.projectId;
	
	    var groupNodes = ids.map(function (id) {
	      return _react2['default'].createElement(_componentsStreamGroup2['default'], {
	        key: id,
	        id: id,
	        orgId: orgId,
	        projectId: projectId,
	        statsPeriod: statsPeriod });
	    });
	
	    return _react2['default'].createElement(
	      'ul',
	      { className: 'group-list', ref: 'groupList' },
	      groupNodes
	    );
	  },
	
	  renderAwaitingEvents: function renderAwaitingEvents() {
	    var org = this.getOrganization();
	    var project = this.getProject();
	    var sampleLink = null;
	
	    if (this.state.groupIds.length > 0) {
	      var sampleIssueId = this.state.groupIds[0];
	      sampleLink = _react2['default'].createElement(
	        'p',
	        null,
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: '/' + org.slug + '/' + project.slug + '/issues/' + sampleIssueId + '/?sample' },
	          (0, _locale.t)('Or see a sample Javascript event')
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box awaiting-events' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'wrap' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'robot' },
	          _react2['default'].createElement('span', { className: 'eye' })
	        ),
	        _react2['default'].createElement(
	          'h3',
	          null,
	          (0, _locale.t)('Waiting for events…')
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.tct)('Our error robot is waiting to [cross:devour] receive your first event.', { cross: _react2['default'].createElement('span', { className: 'strikethrough' }) })
	        ),
	        _react2['default'].createElement(
	          'p',
	          null,
	          _react2['default'].createElement(
	            _reactRouter.Link,
	            { to: '/' + org.slug + '/' + project.slug + '/getting-started/', className: 'btn btn-primary btn-lg' },
	            (0, _locale.t)('Installation Instructions')
	          )
	        ),
	        sampleLink
	      )
	    );
	  },
	
	  renderEmpty: function renderEmpty() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box empty-stream' },
	      _react2['default'].createElement('span', { className: 'icon icon-exclamation' }),
	      _react2['default'].createElement(
	        'p',
	        null,
	        (0, _locale.t)('Sorry, no events match your filters.')
	      )
	    );
	  },
	
	  renderLoading: function renderLoading() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'box' },
	      _react2['default'].createElement(_componentsLoadingIndicator2['default'], null)
	    );
	  },
	
	  renderStreamBody: function renderStreamBody() {
	    var body = undefined;
	
	    var project = this.getProject();
	    if (this.state.dataLoading) {
	      body = this.renderLoading();
	    } else if (this.state.error) {
	      body = _react2['default'].createElement(_componentsLoadingError2['default'], {
	        message: this.state.error,
	        onRetry: this.fetchData });
	    } else if (!project.firstEvent) {
	      body = this.renderAwaitingEvents();
	    } else if (this.state.groupIds.length > 0) {
	      body = this.renderGroupNodes(this.state.groupIds, this.state.statsPeriod);
	    } else {
	      body = this.renderEmpty();
	    }
	
	    return body;
	  },
	
	  render: function render() {
	    // global loading
	    if (this.state.loading) {
	      return this.renderLoading();
	    }
	
	    var params = this.props.params;
	
	    var classes = ['stream-row'];
	    if (this.state.isSidebarVisible) classes.push('show-sidebar');
	
	    var _props$params4 = this.props.params;
	    var orgId = _props$params4.orgId;
	    var projectId = _props$params4.projectId;
	
	    var searchId = this.state.searchId;
	    var access = this.getAccess();
	
	    return _react2['default'].createElement(
	      _reactSticky.StickyContainer,
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(classes) },
	        _react2['default'].createElement(
	          'div',
	          { className: 'stream-content' },
	          _react2['default'].createElement(_streamFilters2['default'], {
	            access: access,
	            orgId: orgId,
	            projectId: projectId,
	            query: this.state.query,
	            sort: this.state.sort,
	            tags: this.state.tags,
	            searchId: searchId,
	            defaultQuery: this.props.defaultQuery,
	            onSortChange: this.onSortChange,
	            onSearch: this.onSearch,
	            onSavedSearchCreate: this.onSavedSearchCreate,
	            onSidebarToggle: this.onSidebarToggle,
	            isSearchDisabled: this.state.isSidebarVisible,
	            savedSearchList: this.state.savedSearchList
	          }),
	          _react2['default'].createElement(
	            _reactSticky.Sticky,
	            { onStickyStateChange: this.onStickyStateChange },
	            _react2['default'].createElement(
	              'div',
	              { className: 'group-header' },
	              _react2['default'].createElement(
	                'div',
	                { className: this.state.isStickyHeader ? 'container' : null },
	                _react2['default'].createElement(_streamActions2['default'], {
	                  orgId: params.orgId,
	                  projectId: params.projectId,
	                  query: this.state.query,
	                  onSelectStatsPeriod: this.onSelectStatsPeriod,
	                  onRealtimeChange: this.onRealtimeChange,
	                  realtimeActive: this.state.realtimeActive,
	                  statsPeriod: this.state.statsPeriod,
	                  groupIds: this.state.groupIds,
	                  allResultsVisible: this.allResultsVisible() })
	              )
	            )
	          ),
	          this.renderStreamBody(),
	          _react2['default'].createElement(_componentsPagination2['default'], { pageLinks: this.state.pageLinks })
	        ),
	        _react2['default'].createElement(_streamSidebar2['default'], {
	          loading: this.state.tagsLoading,
	          tags: this.state.tags,
	          query: this.state.query,
	          onQueryChange: this.onSearch,
	          orgId: params.orgId,
	          projectId: params.projectId
	        })
	      )
	    );
	  }
	
	});
	
	exports['default'] = Stream;
	module.exports = exports['default'];

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactBootstrapLibModal = __webpack_require__(73);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _storesSelectedGroupStore = __webpack_require__(140);
	
	var _storesSelectedGroupStore2 = _interopRequireDefault(_storesSelectedGroupStore);
	
	var _mixinsTooltip = __webpack_require__(38);
	
	var _mixinsTooltip2 = _interopRequireDefault(_mixinsTooltip);
	
	var _locale = __webpack_require__(2);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	// TODO(mitsuhiko): very unclear how to translate this
	var ActionLink = _react2['default'].createClass({
	  displayName: 'ActionLink',
	
	  propTypes: {
	    confirmationQuestion: _react2['default'].PropTypes.any,
	    buttonTitle: _react2['default'].PropTypes.string,
	    confirmLabel: _react2['default'].PropTypes.any,
	    disabled: _react2['default'].PropTypes.bool,
	    onAction: _react2['default'].PropTypes.func.isRequired,
	    onlyIfBulk: _react2['default'].PropTypes.bool,
	    selectAllActive: _react2['default'].PropTypes.bool.isRequired, // "select all" checkbox
	    tooltip: _react2['default'].PropTypes.string,
	    extraDescription: _react2['default'].PropTypes.string
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default'], (0, _mixinsTooltip2['default'])({
	    html: false,
	    container: 'body'
	  })],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      buttonTitle: null, // title="..." (optional)
	      onlyIfBulk: false,
	      disabled: false,
	      extraDescription: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isModalOpen: false
	    };
	  },
	
	  handleClick: function handleClick() {
	    var selectedItemIds = _storesSelectedGroupStore2['default'].getSelectedIds();
	    if (!this.state.isModalOpen && !this.shouldConfirm(selectedItemIds.size)) {
	      return void this.handleAction();
	    }
	
	    this.handleToggle();
	  },
	
	  handleToggle: function handleToggle() {
	    if (this.props.disabled) {
	      return;
	    }
	    this.setState({
	      isModalOpen: !this.state.isModalOpen
	    });
	  },
	
	  handleAction: function handleAction(evt) {
	    this.props.onAction(evt);
	    this.setState({
	      isModalOpen: false
	    });
	  },
	
	  shouldConfirm: function shouldConfirm(numSelectedItems) {
	    // By default, should confirm ...
	    var shouldConfirm = true;
	
	    // Unless `onlyIfBulk` is true, then return false if all items are not selected
	    if (this.props.onlyIfBulk === true && (!this.props.selectAllActive || numSelectedItems === 1)) {
	      shouldConfirm = false;
	    }
	
	    return shouldConfirm;
	  },
	
	  render: function render() {
	    var className = this.props.className;
	    if (this.props.disabled) {
	      className += ' disabled';
	    }
	    className += ' tip';
	
	    var numEvents = _storesSelectedGroupStore2['default'].getSelectedIds().size;
	
	    function resolveLabel(obj) {
	      if (_underscore2['default'].isFunction(obj)) {
	        return obj(numEvents);
	      }
	      return obj;
	    }
	
	    var confirmationQuestion = resolveLabel(this.props.confirmationQuestion);
	
	    return _react2['default'].createElement(
	      'a',
	      { title: this.props.tooltip || this.props.buttonTitle,
	        className: className,
	        disabled: this.props.disabled,
	        onClick: this.handleClick,
	        'data-placement': 'bottom'
	      },
	      this.props.children,
	      _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: this.state.isModalOpen, title: (0, _locale.t)('Please confirm'), animation: false, onHide: this.handleToggle },
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-body' },
	          _react2['default'].createElement(
	            'p',
	            null,
	            _react2['default'].createElement(
	              'strong',
	              null,
	              confirmationQuestion
	            )
	          ),
	          this.props.extraDescription,
	          _react2['default'].createElement(
	            'p',
	            null,
	            (0, _locale.t)('This action cannot be undone.')
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'modal-footer' },
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-default',
	              onClick: this.handleToggle },
	            (0, _locale.t)('Cancel')
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-primary',
	              onClick: this.handleAction },
	            resolveLabel(this.props.confirmLabel)
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = ActionLink;
	module.exports = exports['default'];

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _actionLink = __webpack_require__(702);
	
	var _actionLink2 = _interopRequireDefault(_actionLink);
	
	var _componentsDropdownLink = __webpack_require__(33);
	
	var _componentsDropdownLink2 = _interopRequireDefault(_componentsDropdownLink);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsMenuItem = __webpack_require__(37);
	
	var _componentsMenuItem2 = _interopRequireDefault(_componentsMenuItem);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _storesSelectedGroupStore = __webpack_require__(140);
	
	var _storesSelectedGroupStore2 = _interopRequireDefault(_storesSelectedGroupStore);
	
	var _locale = __webpack_require__(2);
	
	var StreamActions = _react2['default'].createClass({
	  displayName: 'StreamActions',
	
	  propTypes: {
	    allResultsVisible: _react2['default'].PropTypes.bool,
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    groupIds: _react2['default'].PropTypes.instanceOf(Array).isRequired,
	    onRealtimeChange: _react2['default'].PropTypes.func.isRequired,
	    onSelectStatsPeriod: _react2['default'].PropTypes.func.isRequired,
	    realtimeActive: _react2['default'].PropTypes.bool.isRequired,
	    statsPeriod: _react2['default'].PropTypes.string.isRequired,
	    query: _react2['default'].PropTypes.string.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _reflux2['default'].listenTo(_storesSelectedGroupStore2['default'], 'onSelectedGroupChange'), _reactAddonsPureRenderMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      datePickerActive: false,
	
	      anySelected: false,
	      multiSelected: false, // more than one selected
	      pageSelected: false, // all on current page selected (e.g. 25)
	      allInQuerySelected: false };
	  },
	
	  // all in current search query selected (e.g. 1000+)
	  selectAll: function selectAll() {
	    this.setState({
	      allInQuerySelected: true
	    });
	  },
	
	  selectStatsPeriod: function selectStatsPeriod(period) {
	    return this.props.onSelectStatsPeriod(period);
	  },
	
	  actionSelectedGroups: function actionSelectedGroups(callback) {
	    var _this = this;
	
	    var selectedIds = undefined;
	
	    if (this.state.allInQuerySelected) {
	      selectedIds = undefined; // undefined means "all"
	    } else {
	        (function () {
	          var itemIdSet = _storesSelectedGroupStore2['default'].getSelectedIds();
	          selectedIds = _this.props.groupIds.filter(function (itemId) {
	            return itemIdSet.has(itemId);
	          });
	        })();
	      }
	
	    callback(selectedIds);
	
	    this.deselectAll();
	  },
	
	  deselectAll: function deselectAll() {
	    _storesSelectedGroupStore2['default'].deselectAll();
	    this.setState({ allInQuerySelected: false });
	  },
	
	  onUpdate: function onUpdate(data, event) {
	    var _this2 = this;
	
	    this.actionSelectedGroups(function (itemIds) {
	      var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	
	      _this2.api.bulkUpdate({
	        orgId: _this2.props.orgId,
	        projectId: _this2.props.projectId,
	        itemIds: itemIds,
	        data: data,
	        query: _this2.props.query
	      }, {
	        complete: function complete() {
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  onDelete: function onDelete(event) {
	    var _this3 = this;
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Removing events..'));
	
	    this.actionSelectedGroups(function (itemIds) {
	      _this3.api.bulkDelete({
	        orgId: _this3.props.orgId,
	        projectId: _this3.props.projectId,
	        itemIds: itemIds,
	        query: _this3.props.query
	      }, {
	        complete: function complete() {
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  onMerge: function onMerge(event) {
	    var _this4 = this;
	
	    var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Merging events..'));
	
	    this.actionSelectedGroups(function (itemIds) {
	      _this4.api.merge({
	        orgId: _this4.props.orgId,
	        projectId: _this4.props.projectId,
	        itemIds: itemIds,
	        query: _this4.props.query
	      }, {
	        complete: function complete() {
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  onSelectedGroupChange: function onSelectedGroupChange() {
	    this.setState({
	      pageSelected: _storesSelectedGroupStore2['default'].allSelected(),
	      multiSelected: _storesSelectedGroupStore2['default'].multiSelected(),
	      anySelected: _storesSelectedGroupStore2['default'].anySelected(),
	      allInQuerySelected: false // any change resets
	    });
	  },
	
	  onSelectAll: function onSelectAll() {
	    _storesSelectedGroupStore2['default'].toggleSelectAll();
	  },
	
	  onRealtimeChange: function onRealtimeChange(evt) {
	    this.props.onRealtimeChange(!this.props.realtimeActive);
	  },
	
	  render: function render() {
	    // TODO(mitsuhiko): very unclear how to translate this
	    var numIssues = _storesSelectedGroupStore2['default'].getSelectedIds().size;
	    var extraDescription = null;
	    if (this.state.allInQuerySelected) {
	      extraDescription = this.props.query ? _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'p',
	          null,
	          (0, _locale.t)('This will apply to the current search query:')
	        ),
	        _react2['default'].createElement(
	          'pre',
	          null,
	          this.props.query
	        )
	      ) : _react2['default'].createElement(
	        'p',
	        { className: 'error' },
	        _react2['default'].createElement(
	          'strong',
	          null,
	          (0, _locale.t)('This will apply to ALL issues in this project!')
	        )
	      );
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'stream-actions row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'stream-actions-left col-md-6 col-sm-8 col-xs-8' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'checkbox' },
	            _react2['default'].createElement('input', { type: 'checkbox', className: 'chk-select-all',
	              onChange: this.onSelectAll,
	              checked: this.state.pageSelected })
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'btn-group' },
	            _react2['default'].createElement(
	              _actionLink2['default'],
	              {
	                className: 'btn btn-default btn-sm action-resolve',
	                disabled: !this.state.anySelected,
	                onAction: this.onUpdate.bind(this, { status: 'resolved' }),
	                buttonTitle: (0, _locale.t)('Resolve'),
	                extraDescription: extraDescription,
	                confirmationQuestion: this.state.allInQuerySelected ? (0, _locale.t)('Are you sure you want to resolve all issues matching this search query?') : function (count) {
	                  return (0, _locale.tn)('Are you sure you want to resolve this %d issue?', 'Are you sure you want to resolve these %d issues?', count);
	                },
	                confirmLabel: this.state.allInQuerySelected ? (0, _locale.t)('Resolve all issues') : function (count) {
	                  return (0, _locale.tn)('Resolve %d selected issue', 'Resolve %d selected issues', count);
	                },
	                tooltip: (0, _locale.t)('Set Status to Resolved'),
	                onlyIfBulk: true,
	                selectAllActive: this.state.pageSelected },
	              _react2['default'].createElement('i', { 'aria-hidden': 'true', className: 'icon-checkmark' })
	            ),
	            _react2['default'].createElement(
	              _actionLink2['default'],
	              {
	                className: 'btn btn-default btn-sm action-bookmark',
	                disabled: !this.state.anySelected,
	                onAction: this.onUpdate.bind(this, { isBookmarked: true }),
	                buttonTitle: (0, _locale.t)('Bookmark'),
	                extraDescription: extraDescription,
	                confirmationQuestion: this.state.allInQuerySelected ? (0, _locale.t)('Are you sure you want to bookmark all issues matching this search query?') : function (count) {
	                  return (0, _locale.tn)('Are you sure you want to bookmark this %d issue?', 'Are you sure you want to bookmark these %d issues?', count);
	                },
	                confirmLabel: this.state.allInQuerySelected ? (0, _locale.t)('Bookmark all issues') : function (count) {
	                  return (0, _locale.tn)('Bookmark %d selected issue', 'Bookmark %d selected issues', count);
	                },
	                tooltip: (0, _locale.t)('Add to Bookmarks'),
	                onlyIfBulk: true,
	                selectAllActive: this.state.pageSelected },
	              _react2['default'].createElement('i', { 'aria-hidden': 'true', className: 'icon-star-solid' })
	            ),
	            _react2['default'].createElement(
	              _componentsDropdownLink2['default'],
	              {
	                key: 'actions',
	                btnGroup: true,
	                caret: false,
	                className: 'btn btn-sm btn-default hidden-xs action-more',
	                title: _react2['default'].createElement('span', { className: 'icon-ellipsis' }) },
	              _react2['default'].createElement(
	                _componentsMenuItem2['default'],
	                { noAnchor: true },
	                _react2['default'].createElement(
	                  _actionLink2['default'],
	                  {
	                    className: 'action-merge',
	                    disabled: !this.state.anySelected,
	                    onAction: this.onMerge,
	                    extraDescription: extraDescription,
	                    confirmationQuestion: this.state.allInQuerySelected ? (0, _locale.t)('Are you sure you want to merge all issues matching this search query?') : function (count) {
	                      return (0, _locale.tn)('Are you sure you want to merge %d issue?', 'Are you sure you want to merge %d issues?', count);
	                    },
	                    confirmLabel: this.state.allInQuerySelected ? (0, _locale.t)('Merge all issues') : function (count) {
	                      return (0, _locale.tn)('Merge %d selected issue', 'Merge %d selected issues', count);
	                    },
	                    selectAllActive: this.state.pageSelected },
	                  (0, _locale.t)('Merge Events')
	                )
	              ),
	              _react2['default'].createElement(
	                _componentsMenuItem2['default'],
	                { noAnchor: true },
	                _react2['default'].createElement(
	                  _actionLink2['default'],
	                  {
	                    className: 'action-remove-bookmark',
	                    disabled: !this.state.anySelected,
	                    onAction: this.onUpdate.bind(this, { isBookmarked: false }),
	                    extraDescription: extraDescription,
	                    confirmationQuestion: this.state.allInQuerySelected ? (0, _locale.t)('Are you sure you want to remove all issues matching this search query from your bookmarks?') : function (count) {
	                      return (0, _locale.tn)('Are you sure you want to remove this %d issue from your bookmarks?', 'Are you sure you want to remove these %d issues from your bookmarks?', count);
	                    },
	                    confirmLabel: this.state.allInQuerySelected ? (0, _locale.t)('Remove all issues from bookmarks') : function (count) {
	                      return (0, _locale.tn)('Remove %d selected issue from bookmarks', 'Remove %d selected issues from bookmarks', count);
	                    },
	                    onlyIfBulk: true,
	                    selectAllActive: this.state.pageSelected },
	                  (0, _locale.t)('Remove from Bookmarks')
	                )
	              ),
	              _react2['default'].createElement(_componentsMenuItem2['default'], { divider: true }),
	              _react2['default'].createElement(
	                _componentsMenuItem2['default'],
	                { noAnchor: true },
	                _react2['default'].createElement(
	                  _actionLink2['default'],
	                  {
	                    className: 'action-unresolve',
	                    disabled: !this.state.anySelected,
	                    onAction: this.onUpdate.bind(this, { status: 'unresolved' }),
	                    extraDescription: extraDescription,
	                    confirmationQuestion: this.state.allInQuerySelected ? (0, _locale.t)('Are you sure you want to unresolve all issues matching this search query?') : function (count) {
	                      return (0, _locale.tn)('Are you sure you want to unresolve this %d issue?', 'Are you sure you want to unresolve these %d issues?', count);
	                    },
	                    confirmLabel: this.state.allInQuerySelected ? (0, _locale.t)('Unresolve all issues') : function (count) {
	                      return (0, _locale.tn)('Unresolve %d selected issue', 'Unresolve %d selected issues', count);
	                    },
	                    onlyIfBulk: true,
	                    selectAllActive: this.state.pageSelected,
	                    groupIds: this.props.groupIds },
	                  (0, _locale.t)('Set status to: Unresolved')
	                )
	              ),
	              _react2['default'].createElement(
	                _componentsMenuItem2['default'],
	                { noAnchor: true },
	                _react2['default'].createElement(
	                  _actionLink2['default'],
	                  {
	                    className: 'action-ignore',
	                    disabled: !this.state.anySelected,
	                    onAction: this.onUpdate.bind(this, { status: 'ignored' }),
	                    extraDescription: extraDescription,
	                    confirmationQuestion: this.state.allInQuerySelected ? (0, _locale.t)('Are you sure you want to ignore all issues matching this search query?') : function (count) {
	                      return (0, _locale.tn)('Are you sure you want to ignore this %d issue?', 'Are you sure you want to ignore these %d issues?', count);
	                    },
	                    confirmLabel: this.state.allInQuerySelected ? (0, _locale.t)('Ignore all issues') : function (count) {
	                      return (0, _locale.tn)('Ignore %d selected issue', 'Ignore %d selected issues', count);
	                    },
	                    onlyIfBulk: true,
	                    selectAllActive: this.state.pageSelected },
	                  (0, _locale.t)('Set status to: Ignored')
	                )
	              ),
	              _react2['default'].createElement(_componentsMenuItem2['default'], { divider: true }),
	              _react2['default'].createElement(
	                _componentsMenuItem2['default'],
	                { noAnchor: true },
	                _react2['default'].createElement(
	                  _actionLink2['default'],
	                  {
	                    className: 'action-delete',
	                    disabled: !this.state.anySelected || this.state.allInQuerySelected,
	                    onAction: this.onDelete,
	                    extraDescription: extraDescription,
	                    confirmationQuestion: function (count) {
	                      return (0, _locale.tn)('Are you sure you want to delete %d issue?', 'Are you sure you want to delete %d issues?', count);
	                    },
	                    confirmLabel: function (count) {
	                      return (0, _locale.tn)('Delete %d selected issue', 'Delete %d selected issues', count);
	                    },
	                    selectAllActive: this.state.pageSelected },
	                  (0, _locale.t)('Delete Events')
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'btn-group' },
	            _react2['default'].createElement(
	              'a',
	              { className: 'btn btn-default btn-sm hidden-xs realtime-control',
	                onClick: this.onRealtimeChange },
	              this.props.realtimeActive ? _react2['default'].createElement('span', { className: 'icon icon-pause' }) : _react2['default'].createElement('span', { className: 'icon icon-play' })
	            )
	          )
	        ),
	        _react2['default'].createElement('div', { className: 'hidden-sm stream-actions-assignee col-md-1' }),
	        _react2['default'].createElement('div', { className: 'stream-actions-level col-md-1 hidden-xs' }),
	        _react2['default'].createElement(
	          'div',
	          { className: 'hidden-sm hidden-xs stream-actions-graph col-md-2' },
	          _react2['default'].createElement(
	            'span',
	            { className: 'stream-actions-graph-label' },
	            (0, _locale.t)('Graph:')
	          ),
	          _react2['default'].createElement(
	            'ul',
	            { className: 'toggle-graph' },
	            _react2['default'].createElement(
	              'li',
	              { className: this.props.statsPeriod === '24h' ? 'active' : '' },
	              _react2['default'].createElement(
	                'a',
	                { onClick: this.selectStatsPeriod.bind(this, '24h') },
	                (0, _locale.t)('24h')
	              )
	            ),
	            _react2['default'].createElement(
	              'li',
	              { className: this.props.statsPeriod === '14d' ? 'active' : '' },
	              _react2['default'].createElement(
	                'a',
	                { onClick: this.selectStatsPeriod.bind(this, '14d') },
	                (0, _locale.t)('14d')
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'stream-actions-count align-right col-md-1 col-sm-2 col-xs-2' },
	          (0, _locale.t)('Events')
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'stream-actions-users align-right col-md-1 col-sm-2 col-xs-2' },
	          (0, _locale.t)('Users')
	        )
	      ),
	      !this.props.allResultsVisible && this.state.pageSelected && _react2['default'].createElement(
	        'div',
	        { className: 'row stream-select-all-notice' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-md-12' },
	          this.state.allInQuerySelected ? _react2['default'].createElement(
	            'strong',
	            null,
	            (0, _locale.t)('All issues matching this search query selected.')
	          ) : _react2['default'].createElement(
	            'span',
	            null,
	            (0, _locale.tn)('%d issue on this page selected.', '%d issues on this page selected.', numIssues),
	            _react2['default'].createElement(
	              'a',
	              { onClick: this.selectAll },
	              (0, _locale.t)('Select all issues matching this search query.')
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = StreamActions;
	module.exports = exports['default'];

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _savedSearchSelector = __webpack_require__(705);
	
	var _savedSearchSelector2 = _interopRequireDefault(_savedSearchSelector);
	
	var _searchBar = __webpack_require__(706);
	
	var _searchBar2 = _interopRequireDefault(_searchBar);
	
	var _sortOptions = __webpack_require__(709);
	
	var _sortOptions2 = _interopRequireDefault(_sortOptions);
	
	var _locale = __webpack_require__(2);
	
	var StreamFilters = _react2['default'].createClass({
	  displayName: 'StreamFilters',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    access: _react2['default'].PropTypes.object.isRequired,
	    tags: _react2['default'].PropTypes.object.isRequired,
	
	    searchId: _react2['default'].PropTypes.string,
	    savedSearchList: _react2['default'].PropTypes.array.isRequired,
	
	    defaultQuery: _react2['default'].PropTypes.string,
	    sort: _react2['default'].PropTypes.string,
	    filter: _react2['default'].PropTypes.string,
	    query: _react2['default'].PropTypes.string,
	    isSearchDisabled: _react2['default'].PropTypes.bool,
	
	    onSortChange: _react2['default'].PropTypes.func,
	    onSearch: _react2['default'].PropTypes.func,
	    onSidebarToggle: _react2['default'].PropTypes.func,
	    onSavedSearchCreate: _react2['default'].PropTypes.func.isRequired
	  },
	
	  contextTypes: {
	    location: _react2['default'].PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultQuery: '',
	      sort: '',
	      filter: '',
	      query: null,
	      onSortChange: function onSortChange() {},
	      onSearch: function onSearch() {},
	      onSidebarToggle: function onSidebarToggle() {}
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var access = _props.access;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	    var searchId = _props.searchId;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'stream-header' },
	      _react2['default'].createElement(
	        'div',
	        { className: 'row' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-5' },
	          _react2['default'].createElement(_savedSearchSelector2['default'], {
	            access: access,
	            orgId: orgId,
	            projectId: projectId,
	            searchId: searchId,
	            query: this.props.query,
	            onSavedSearchCreate: this.props.onSavedSearchCreate,
	            savedSearchList: this.props.savedSearchList })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-sm-7' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'search-container' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'stream-sort' },
	              _react2['default'].createElement(_sortOptions2['default'], {
	                sort: this.props.sort,
	                onSelect: this.props.onSortChange })
	            ),
	            _react2['default'].createElement(_searchBar2['default'], {
	              orgId: orgId,
	              projectId: projectId,
	              ref: 'searchBar',
	              tags: this.props.tags,
	              defaultQuery: this.props.defaultQuery || '',
	              placeholder: (0, _locale.t)('Search for events, users, tags, and everything else.'),
	              query: this.props.query || '',
	              onSearch: this.props.onSearch,
	              disabled: this.props.isSearchDisabled }),
	            _react2['default'].createElement(
	              'a',
	              { className: 'btn btn-default toggle-stream-sidebar', onClick: this.props.onSidebarToggle },
	              _react2['default'].createElement('span', { className: 'icon-filter' })
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = StreamFilters;
	module.exports = exports['default'];

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapLibModal = __webpack_require__(73);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsDropdownLink = __webpack_require__(33);
	
	var _componentsDropdownLink2 = _interopRequireDefault(_componentsDropdownLink);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsMenuItem = __webpack_require__(37);
	
	var _componentsMenuItem2 = _interopRequireDefault(_componentsMenuItem);
	
	var _locale = __webpack_require__(2);
	
	var _componentsForms = __webpack_require__(36);
	
	var SaveSearchState = {
	  READY: 'Ready',
	  SAVING: 'Saving',
	  ERROR: 'Error'
	};
	
	var SaveSearchButton = _react2['default'].createClass({
	  displayName: 'SaveSearchButton',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	
	    query: _react2['default'].PropTypes.string.isRequired,
	    disabled: _react2['default'].PropTypes.bool,
	    style: _react2['default'].PropTypes.object,
	    tooltip: _react2['default'].PropTypes.string,
	    buttonTitle: _react2['default'].PropTypes.string,
	
	    onSave: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      isModalOpen: false,
	      state: SaveSearchState.READY,
	      formData: {
	        query: this.props.query
	      }
	    };
	  },
	
	  onToggle: function onToggle() {
	    if (this.props.disabled) {
	      return;
	    }
	    this.setState({
	      isModalOpen: !this.state.isModalOpen,
	      state: SaveSearchState.READY,
	      formData: {
	        query: this.props.query
	      }
	    });
	  },
	
	  onFieldChange: function onFieldChange(name, value) {
	    var formData = this.state.formData;
	    formData[name] = value;
	    this.setState({
	      formData: formData
	    });
	  },
	
	  onDefaultChange: function onDefaultChange(e) {
	    this.onFieldChange('isDefault', e.target.checked);
	  },
	
	  onUserDefaultChange: function onUserDefaultChange(e) {
	    this.onFieldChange('isUserDefault', e.target.checked);
	  },
	
	  onSubmit: function onSubmit(e) {
	    var _this = this;
	
	    e.preventDefault();
	
	    if (this.state.state == SaveSearchState.SAVING) {
	      return;
	    }
	    this.setState({
	      state: SaveSearchState.SAVING
	    }, function () {
	      var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	      var _props = _this.props;
	      var orgId = _props.orgId;
	      var projectId = _props.projectId;
	
	      _this.api.request('/projects/' + orgId + '/' + projectId + '/searches/', {
	        method: 'POST',
	        data: _this.state.formData,
	        success: function success(data) {
	          _this.onToggle();
	          _this.props.onSave(data);
	        },
	        complete: function complete() {
	          _this.setState({ state: SaveSearchState.ERROR });
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  render: function render() {
	    var isSaving = this.state.state === SaveSearchState.SAVING;
	    return _react2['default'].createElement(
	      'a',
	      { title: this.props.tooltip || this.props.buttonTitle,
	        className: this.props.className,
	        disabled: this.props.disabled,
	        onClick: this.onToggle,
	        style: this.props.style },
	      this.props.children,
	      _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: this.state.isModalOpen,
	          animation: false,
	          onHide: this.onToggle },
	        _react2['default'].createElement(
	          'form',
	          { onSubmit: this.onSubmit },
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-header' },
	            _react2['default'].createElement(
	              'h4',
	              null,
	              (0, _locale.t)('Save Current Search')
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-body' },
	            _react2['default'].createElement(
	              'p',
	              null,
	              (0, _locale.t)('Saving this search will give you and your team quick access to it in the future.')
	            ),
	            _react2['default'].createElement(_componentsForms.TextField, {
	              key: 'name',
	              name: 'name',
	              label: (0, _locale.t)('Name'),
	              placeholder: 'e.g. My Search Results',
	              required: true,
	              onChange: this.onFieldChange.bind(this, 'name') }),
	            _react2['default'].createElement(_componentsForms.TextField, {
	              key: 'query',
	              name: 'query',
	              label: (0, _locale.t)('Query'),
	              value: this.state.formData.query,
	              required: true,
	              onChange: this.onFieldChange.bind(this, 'query') }),
	            _react2['default'].createElement(_componentsForms.BooleanField, {
	              key: 'isUserDefault',
	              name: 'is-user-default',
	              label: (0, _locale.t)('Make this the default view for myself.'),
	              onChange: this.onFieldChange.bind(this, 'isUserDefault') }),
	            _react2['default'].createElement(_componentsForms.BooleanField, {
	              key: 'isDefault',
	              name: 'is-default',
	              label: (0, _locale.t)('Make this the default view for my team.'),
	              onChange: this.onFieldChange.bind(this, 'isDefault') })
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'modal-footer' },
	            _react2['default'].createElement(
	              'button',
	              { type: 'button', className: 'btn btn-default',
	                disabled: isSaving,
	                onClick: this.onToggle },
	              (0, _locale.t)('Cancel')
	            ),
	            _react2['default'].createElement(
	              'button',
	              { type: 'submit', className: 'btn btn-primary',
	                disabled: isSaving },
	              (0, _locale.t)('Save')
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	var SavedSearchSelector = _react2['default'].createClass({
	  displayName: 'SavedSearchSelector',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    searchId: _react2['default'].PropTypes.string,
	    access: _react2['default'].PropTypes.object.isRequired,
	    savedSearchList: _react2['default'].PropTypes.array.isRequired,
	    onSavedSearchCreate: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getTitle: function getTitle() {
	    var searchId = this.props.searchId || null;
	    if (!searchId) return (0, _locale.t)('Custom Search');
	    var results = this.props.savedSearchList.filter(function (search) {
	      return searchId === search.id;
	    });
	    return results.length ? results[0].name : (0, _locale.t)('Custom Search');
	  },
	
	  render: function render() {
	    var _props2 = this.props;
	    var access = _props2.access;
	    var orgId = _props2.orgId;
	    var projectId = _props2.projectId;
	
	    var children = this.props.savedSearchList.map(function (search) {
	      // TODO(dcramer): we want these to link directly to the saved
	      // search ID, and pass that into the backend (probably)
	      return _react2['default'].createElement(
	        _componentsMenuItem2['default'],
	        { to: '/' + orgId + '/' + projectId + '/searches/' + search.id + '/',
	          key: search.id },
	        _react2['default'].createElement(
	          'strong',
	          null,
	          search.name
	        ),
	        _react2['default'].createElement(
	          'code',
	          null,
	          search.query
	        )
	      );
	    });
	    return _react2['default'].createElement(
	      'div',
	      { className: 'saved-search-selector' },
	      _react2['default'].createElement(
	        _componentsDropdownLink2['default'],
	        { title: this.getTitle() },
	        children.length ? children : _react2['default'].createElement(
	          'li',
	          { className: 'empty' },
	          (0, _locale.t)('There don\'t seem to be any saved searches yet.')
	        ),
	        access.has('project:write') && _react2['default'].createElement(_componentsMenuItem2['default'], { divider: true }),
	        access.has('project:write') && _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'div',
	            { className: 'row' },
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-md-7' },
	              _react2['default'].createElement(
	                SaveSearchButton,
	                _extends({
	                  className: 'btn btn-sm btn-default',
	                  onSave: this.props.onSavedSearchCreate
	                }, this.props),
	                (0, _locale.t)('Save Current Search')
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { className: 'col-md-5' },
	              _react2['default'].createElement(
	                _reactRouter.Link,
	                {
	                  to: '/' + orgId + '/' + projectId + '/settings/saved-searches/',
	                  className: 'btn btn-sm btn-default' },
	                (0, _locale.t)('Manage')
	              )
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = SavedSearchSelector;
	module.exports = exports['default'];

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reflux = __webpack_require__(11);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _storesStreamTagStore = __webpack_require__(303);
	
	var _storesStreamTagStore2 = _interopRequireDefault(_storesStreamTagStore);
	
	var _storesMemberListStore = __webpack_require__(91);
	
	var _storesMemberListStore2 = _interopRequireDefault(_storesMemberListStore);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _locale = __webpack_require__(2);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _searchDropdown = __webpack_require__(707);
	
	var _searchDropdown2 = _interopRequireDefault(_searchDropdown);
	
	var SearchBar = _react2['default'].createClass({
	  displayName: 'SearchBar',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	
	    defaultQuery: _react2['default'].PropTypes.string,
	    query: _react2['default'].PropTypes.string,
	    defaultSearchItems: _react2['default'].PropTypes.array.isRequired,
	    disabled: _react2['default'].PropTypes.bool,
	    placeholder: _react2['default'].PropTypes.string,
	
	    onQueryChange: _react2['default'].PropTypes.func,
	    onSearch: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_mixinsApiMixin2['default'], _reactAddonsPureRenderMixin2['default'], _reflux2['default'].listenTo(_storesMemberListStore2['default'], 'onMemberListStoreChange')],
	
	  statics: {
	    /**
	     * Given a query, and the current cursor position, return the string-delimiting
	     * index of the search term designated by the cursor.
	     */
	    getLastTermIndex: function getLastTermIndex(query, cursor) {
	      // TODO: work with quoted-terms
	      var cursorOffset = query.slice(cursor).search(/\s|$/);
	      return cursor + (cursorOffset === -1 ? 0 : cursorOffset);
	    },
	
	    /**
	     * Returns an array of query terms, including incomplete terms
	     *
	     * e.g. ["is:unassigned", "browser:\"Chrome 33.0\"", "assigned"]
	     */
	    getQueryTerms: function getQueryTerms(query, cursor) {
	      return query.slice(0, cursor).match(/\S+:"[^"]*"?|\S+/g);
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultQuery: '',
	      query: null,
	      onSearch: function onSearch() {},
	      onQueryChange: function onQueryChange() {},
	
	      defaultSearchItems: [{
	        title: (0, _locale.t)('Tag'),
	        desc: (0, _locale.t)('key/value pair associated to an issue'),
	        example: 'browser:"Chrome 34", has:browser',
	        className: 'icon-tag',
	        value: 'browser:'
	      }, {
	        title: (0, _locale.t)('Status'),
	        desc: (0, _locale.t)('State of an issue'),
	        example: 'is:resolved, unresolved, ignored, assigned, unassigned',
	        className: 'icon-toggle',
	        value: 'is:'
	      }, {
	        title: (0, _locale.t)('Assigned'),
	        desc: (0, _locale.t)('team member assigned to an issue'),
	        example: 'assigned:[me|user@example.com]',
	        className: 'icon-user',
	        value: 'assigned:'
	      }, {
	        title: (0, _locale.t)('Bookmarked By'),
	        desc: (0, _locale.t)('team member who bookmarked an issue'),
	        example: 'bookmarks:[me|user@example.com]',
	        className: 'icon-user',
	        value: 'bookmarks:'
	      }, {
	        desc: (0, _locale.t)('or paste an event id to jump straight to it'),
	        className: 'icon-hash',
	        value: ''
	      }]
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      query: this.props.query !== null ? this.props.query : this.props.defaultQuery,
	
	      searchTerm: '',
	      searchItems: [],
	      activeSearchItem: 0,
	
	      tags: {},
	      members: _storesMemberListStore2['default'].getAll(),
	
	      dropdownVisible: false,
	      loading: false
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    // query was updated by another source (e.g. sidebar filters)
	    if (nextProps.query !== this.state.query) {
	      this.setState({
	        query: nextProps.query
	      });
	    }
	  },
	
	  DROPDOWN_BLUR_DURATION: 200,
	
	  blur: function blur() {
	    _reactDom2['default'].findDOMNode(this.refs.searchInput).blur();
	  },
	
	  onSubmit: function onSubmit(evt) {
	    evt.preventDefault();
	    this.blur();
	    this.props.onSearch(this.state.query);
	  },
	
	  clearSearch: function clearSearch() {
	    var _this = this;
	
	    this.setState({ query: '' }, function () {
	      return _this.props.onSearch(_this.state.query);
	    });
	  },
	
	  onQueryFocus: function onQueryFocus() {
	    this.setState({
	      dropdownVisible: true
	    });
	  },
	
	  onQueryBlur: function onQueryBlur() {
	    var _this2 = this;
	
	    // wait 200ms before closing dropdown in case blur was a result of
	    // clicking a menu option
	    this.blurTimeout = setTimeout(function () {
	      _this2.blurTimeout = null;
	      _this2.setState({ dropdownVisible: false });
	    }, this.DROPDOWN_BLUR_DURATION);
	  },
	
	  onQueryChange: function onQueryChange(evt) {
	    var _this3 = this;
	
	    this.setState({ query: evt.target.value }, function () {
	      return _this3.updateAutoCompleteItems();
	    });
	  },
	
	  onKeyUp: function onKeyUp(evt) {
	    if (evt.key === 'Escape' || evt.keyCode === 27) {
	      // blur handler should additionally hide dropdown
	      this.blur();
	    }
	  },
	
	  getCursorPosition: function getCursorPosition() {
	    return _reactDom2['default'].findDOMNode(this.refs.searchInput).selectionStart;
	  },
	
	  /**
	   * Returns array of possible key values that substring match `query`
	   *
	   * e.g. ['is:', 'assigned:', 'url:', 'release:']
	   */
	  getTagKeys: function getTagKeys(query) {
	    return _storesStreamTagStore2['default'].getTagKeys().map(function (key) {
	      return key + ':';
	    }).filter(function (key) {
	      return key.indexOf(query) > -1;
	    });
	  },
	
	  /**
	   * Returns array of tag values that substring match `query`; invokes `callback`
	   * with data when ready
	   */
	  getTagValues: _underscore2['default'].debounce(function (tag, query, callback) {
	    var _this4 = this;
	
	    // Strip double quotes if there are any
	    query = query.replace('"', '').trim();
	
	    this.setState({
	      loading: true
	    });
	
	    var _props = this.props;
	    var orgId = _props.orgId;
	    var projectId = _props.projectId;
	
	    this.api.request('/projects/' + orgId + '/' + projectId + '/tags/' + tag.key + '/values/', {
	      data: {
	        query: query
	      },
	      method: 'GET',
	      success: function success(values) {
	        _this4.setState({ loading: false });
	        callback(values.map(function (v) {
	          // Wrap in quotes if there is a space
	          return v.value.indexOf(' ') > -1 ? '"' + v.value + '"' : v.value;
	        }), tag.key, query);
	      }
	    });
	  }, 300),
	
	  /**
	   * Returns array of tag values that substring match `query`; invokes `callback`
	   * with results
	   */
	  getPredefinedTagValues: function getPredefinedTagValues(tag, query, callback) {
	    var values = tag.values.filter(function (value) {
	      return value.indexOf(query) > -1;
	    });
	
	    callback(values, tag.key);
	  },
	
	  onInputClick: function onInputClick() {
	    var _this5 = this;
	
	    var cursor = this.getCursorPosition();
	
	    if (cursor === this.state.query.length && this.state.query.charAt(cursor - 1) !== ' ') {
	      // If the cursor lands at the end of the input value, and the preceding character
	      // is not whitespace, then add a space and move the cursor beyond that space.
	      this.setState({ query: this.state.query + ' ' }, function () {
	        _reactDom2['default'].findDOMNode(_this5.refs.searchInput).setSelectionRange(cursor + 1, cursor + 1);
	        _this5.updateAutoCompleteItems();
	      });
	    } else {
	      this.updateAutoCompleteItems();
	    }
	  },
	
	  updateAutoCompleteItems: function updateAutoCompleteItems() {
	    if (this.blurTimeout) {
	      clearTimeout(this.blurTimeout);
	      this.blurTimeout = null;
	    }
	
	    var cursor = this.getCursorPosition();
	    var query = this.state.query;
	
	    var lastTermIndex = SearchBar.getLastTermIndex(query, cursor);
	    var terms = SearchBar.getQueryTerms(query.slice(0, lastTermIndex));
	
	    if (!terms || // no terms
	    terms.length === 0 || // no terms
	    terms.length === 1 && terms[0] === this.props.defaultQuery || // default term
	    /^\s+$/.test(query.slice(cursor - 1, cursor + 1))) // cursor on whitespace
	      {
	        // show default "help" search terms
	        return void this.setState({
	          searchTerm: '',
	          searchItems: this.props.defaultSearchItems,
	          activeSearchItem: 0
	        });
	      }
	
	    var last = terms.pop();
	    var autoCompleteItems = undefined;
	    var matchValue = undefined;
	    var tagName = undefined;
	    var index = last.indexOf(':');
	
	    if (index === -1) {
	      // No colon present; must still be deciding key
	      matchValue = last;
	      autoCompleteItems = this.getTagKeys(matchValue);
	
	      this.setState({ searchTerm: matchValue });
	      this.updateAutoCompleteState(autoCompleteItems, matchValue);
	    } else {
	      tagName = last.slice(0, index);
	      query = last.slice(index + 1);
	
	      // filter existing items immediately, until API can return
	      // with actual tag value results
	      var filteredSearchItems = this.state.searchItems.filter(function (item) {
	        return query && item.value.indexOf(query) !== -1;
	      });
	
	      this.setState({
	        searchTerm: query,
	        searchItems: filteredSearchItems
	      });
	
	      var tag = _storesStreamTagStore2['default'].getTag(tagName);
	      if (!tag) return undefined;
	
	      return void (tag.predefined ? this.getPredefinedTagValues : this.getTagValues)(tag, query, this.updateAutoCompleteState);
	    }
	  },
	
	  isDefaultDropdown: function isDefaultDropdown() {
	    return this.state.searchItems === this.props.defaultSearchItems;
	  },
	
	  updateAutoCompleteState: function updateAutoCompleteState(autoCompleteItems, tagName) {
	    autoCompleteItems = autoCompleteItems.map(function (item) {
	      var out = {
	        desc: item,
	        value: item
	      };
	
	      // Specify icons according to tag value
	      switch (tagName || item.replace(':', '')) {
	        case 'is':
	          out.className = 'icon-toggle';
	          break;
	        case 'assigned':
	        case 'bookmarks':
	          out.className = 'icon-user';
	          break;
	        default:
	          out.className = 'icon-tag';
	      }
	      return out;
	    });
	
	    if (autoCompleteItems.length > 0 && !this.isDefaultDropdown()) {
	      autoCompleteItems[0].active = true;
	    }
	
	    this.setState({
	      searchItems: autoCompleteItems.slice(0, 5), // only show 5
	      activeSearchItem: 0
	    });
	  },
	
	  onKeyDown: function onKeyDown(evt) {
	    var state = this.state;
	    var searchItems = state.searchItems;
	
	    if (!searchItems.length) return;
	
	    if (evt.key === 'ArrowDown' || evt.key === 'ArrowUp') {
	      evt.preventDefault();
	
	      // Move active selection up/down
	      delete searchItems[state.activeSearchItem].active;
	
	      state.activeSearchItem = evt.key === 'ArrowDown' ? Math.min(state.activeSearchItem + 1, searchItems.length - 1) : Math.max(state.activeSearchItem - 1, 0);
	
	      searchItems[state.activeSearchItem].active = true;
	      this.setState({ searchItems: searchItems.slice(0) });
	    } else if (evt.key === 'Tab' && !this.isDefaultDropdown()) {
	      evt.preventDefault();
	
	      this.onAutoComplete(searchItems[state.activeSearchItem].value);
	    }
	  },
	
	  onAutoComplete: function onAutoComplete(replaceText) {
	    var _this6 = this;
	
	    var cursor = this.getCursorPosition();
	    var query = this.state.query;
	
	    var lastTermIndex = SearchBar.getLastTermIndex(query, cursor);
	    var terms = SearchBar.getQueryTerms(query.slice(0, lastTermIndex));
	    var newQuery = undefined;
	
	    // If not postfixed with : (tag value), add trailing space
	    replaceText += replaceText.charAt(replaceText.length - 1) === ':' ? '' : ' ';
	
	    if (!terms) {
	      newQuery = replaceText;
	    } else {
	      var last = terms.pop();
	
	      newQuery = query.slice(0, lastTermIndex); // get text preceding last term
	
	      newQuery = last.indexOf(':') > -1
	      // tag key present: replace everything after colon with replaceText
	      ? newQuery.replace(/\:"[^"]*"?$|\:\S*$/, ':' + replaceText)
	      // no tag key present: replace last token with replaceText
	      : newQuery.replace(/\S+$/, replaceText);
	
	      newQuery = newQuery.concat(query.slice(lastTermIndex));
	    }
	
	    this.setState({
	      query: newQuery
	    }, function () {
	      // setting a new input value will lose focus; restore it
	      var node = _reactDom2['default'].findDOMNode(_this6.refs.searchInput);
	      node.focus();
	
	      // then update the autocomplete box with new contextTypes
	      _this6.updateAutoCompleteItems();
	    });
	  },
	
	  onMemberListStoreChange: function onMemberListStoreChange(members) {
	    this.setState({
	      members: members
	    }, this.updateAutoCompleteItems);
	  },
	
	  render: function render() {
	    var dropdownStyle = {
	      display: this.state.dropdownVisible ? 'block' : 'none'
	    };
	
	    var rootClassNames = ['search'];
	    if (this.props.disabled) rootClassNames.push('disabled');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: (0, _classnames2['default'])(rootClassNames) },
	      _react2['default'].createElement(
	        'form',
	        { className: 'form-horizontal', ref: 'searchForm', onSubmit: this.onSubmit },
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('input', { type: 'text', className: 'search-input form-control',
	            placeholder: this.props.placeholder,
	            name: 'query',
	            ref: 'searchInput',
	            autoComplete: 'off',
	            value: this.state.query,
	            onFocus: this.onQueryFocus,
	            onBlur: this.onQueryBlur,
	            onKeyUp: this.onKeyUp,
	            onKeyDown: this.onKeyDown,
	            onChange: this.onQueryChange,
	            onClick: this.onInputClick,
	            disabled: this.props.disabled
	          }),
	          _react2['default'].createElement('span', { className: 'icon-search' }),
	          this.state.query !== '' && _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { className: 'search-clear-form', onClick: this.clearSearch },
	              _react2['default'].createElement('span', { className: 'icon-circle-cross' })
	            )
	          )
	        ),
	        (this.state.loading || this.state.searchItems.length > 0) && _react2['default'].createElement(
	          'div',
	          { style: dropdownStyle },
	          _react2['default'].createElement(_searchDropdown2['default'], {
	            style: dropdownStyle,
	            items: this.state.searchItems,
	            onClick: this.onAutoComplete,
	            loading: this.state.loading,
	            searchSubstring: this.state.searchTerm
	          })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = SearchBar;
	module.exports = exports['default'];

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(49);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var SearchDropdown = _react2['default'].createClass({
	  displayName: 'SearchDropdown',
	
	  propTypes: {
	    items: _react2['default'].PropTypes.array.isRequired,
	    searchSubstring: _react2['default'].PropTypes.string,
	    onClick: _react2['default'].PropTypes.func.isRequired,
	    loading: _react2['default'].PropTypes.bool
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      searchSubstring: '',
	      onClick: function onClick() {}
	    };
	  },
	
	  onClick: function onClick(itemValue) {
	    this.props.onClick(itemValue);
	  },
	
	  renderDescription: function renderDescription(item) {
	    var searchSubstring = this.props.searchSubstring;
	    if (!searchSubstring) return item.desc;
	
	    var text = item.desc;
	    var idx = text.toLowerCase().indexOf(searchSubstring.toLowerCase());
	
	    if (idx === -1) return item.desc;
	
	    return _react2['default'].createElement(
	      'span',
	      null,
	      text.substr(0, idx),
	      _react2['default'].createElement(
	        'strong',
	        null,
	        text.substr(idx, searchSubstring.length)
	      ),
	      text.substr(idx + searchSubstring.length)
	    );
	  },
	
	  render: function render() {
	    var _this = this;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'search-dropdown' },
	      _react2['default'].createElement(
	        'ul',
	        { className: 'search-helper search-autocomplete-list' },
	        this.props.loading ? _react2['default'].createElement(
	          'li',
	          { key: 'loading', className: 'search-autocomplete-item' },
	          _react2['default'].createElement(_componentsLoadingIndicator2['default'], { mini: true })
	        ) : this.props.items.map(function (item) {
	          return _react2['default'].createElement(
	            'li',
	            { key: item.value || item.desc, className: (0, _classnames2['default'])('search-autocomplete-item', item.active && 'active'), onClick: _this.onClick.bind(_this, item.value) },
	            _react2['default'].createElement('span', { className: (0, _classnames2['default'])('icon', item.className) }),
	            _react2['default'].createElement(
	              'h4',
	              null,
	              item.title && item.title + ' - ',
	              _react2['default'].createElement(
	                'span',
	                { className: 'search-description' },
	                _this.renderDescription(item)
	              )
	            ),
	            item.example ? _react2['default'].createElement(
	              'p',
	              { className: 'search-example' },
	              item.example
	            ) : ''
	          );
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = SearchDropdown;
	module.exports = exports['default'];

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _tagFilter = __webpack_require__(710);
	
	var _tagFilter2 = _interopRequireDefault(_tagFilter);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _utilsStream = __webpack_require__(625);
	
	var _locale = __webpack_require__(2);
	
	var TEXT_FILTER_DEBOUNCE_IN_MS = 300;
	
	var StreamSidebar = _react2['default'].createClass({
	  displayName: 'StreamSidebar',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	
	    tags: _react2['default'].PropTypes.object.isRequired,
	    query: _react2['default'].PropTypes.string,
	    onQueryChange: _react2['default'].PropTypes.func.isRequired,
	    defaultQuery: _react2['default'].PropTypes.string,
	    loading: _react2['default'].PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      tags: {},
	      query: '',
	      onQueryChange: function onQueryChange() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var queryObj = (0, _utilsStream.queryToObj)(this.props.query);
	    return {
	      queryObj: queryObj,
	      textFilter: queryObj.__text
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    // If query was updated by another source (e.g. SearchBar),
	    // clobber state of sidebar with new query.
	    var query = (0, _utilsStream.objToQuery)(this.state.queryObj);
	
	    if (!_underscore2['default'].isEqual(nextProps.query, query)) {
	      var queryObj = (0, _utilsStream.queryToObj)(nextProps.query);
	      this.setState({
	        queryObj: queryObj,
	        textFilter: queryObj.__text
	      });
	    }
	  },
	
	  onSelectTag: function onSelectTag(tag, value) {
	    var newQuery = _extends({}, this.state.queryObj);
	    if (value) newQuery[tag.key] = value;else delete newQuery[tag.key];
	
	    this.setState({
	      queryObj: newQuery
	    }, this.onQueryChange);
	  },
	
	  onTextChange: function onTextChange(evt) {
	    this.setState({ textFilter: evt.target.value });
	  },
	
	  debouncedTextChange: _underscore2['default'].debounce(function (text) {
	    this.setState({
	      queryObj: _extends({}, this.state.queryObj, { __text: text })
	    }, this.onQueryChange);
	  }, TEXT_FILTER_DEBOUNCE_IN_MS),
	
	  onTextFilterSubmit: function onTextFilterSubmit(evt) {
	    evt && evt.preventDefault();
	
	    var newQueryObj = _extends({}, this.state.queryObj, {
	      __text: this.state.textFilter
	    });
	
	    this.setState({
	      queryObj: newQueryObj
	    }, this.onQueryChange);
	  },
	
	  onQueryChange: function onQueryChange() {
	    var query = (0, _utilsStream.objToQuery)(this.state.queryObj);
	    this.props.onQueryChange && this.props.onQueryChange(query);
	  },
	
	  onClearSearch: function onClearSearch() {
	    this.setState({
	      textFilter: ''
	    }, this.onTextFilterSubmit);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'stream-sidebar' },
	      this.props.loading ? _react2['default'].createElement(_componentsLoadingIndicator2['default'], null) : _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: 'stream-tag-filter' },
	          _react2['default'].createElement(
	            'h6',
	            { className: 'nav-header' },
	            (0, _locale.t)('Text')
	          ),
	          _react2['default'].createElement(
	            'form',
	            { onSubmit: this.onTextFilterSubmit },
	            _react2['default'].createElement('input', {
	              className: 'form-control',
	              placeholder: (0, _locale.t)('Search title and culprit text body'),
	              onChange: this.onTextChange,
	              value: this.state.textFilter
	            }),
	            this.state.textFilter && _react2['default'].createElement(
	              'a',
	              { className: 'search-clear-form', onClick: this.onClearSearch },
	              _react2['default'].createElement('span', { className: 'icon-circle-cross' })
	            )
	          ),
	          _react2['default'].createElement('hr', null)
	        ),
	        _underscore2['default'].map(this.props.tags, function (tag) {
	          return _react2['default'].createElement(_tagFilter2['default'], {
	            value: _this.state.queryObj[tag.key],
	            key: tag.key,
	            tag: tag,
	            onSelect: _this.onSelectTag,
	            orgId: _this.props.orgId,
	            projectId: _this.props.projectId
	          });
	        })
	      )
	    );
	  }
	});
	
	exports['default'] = StreamSidebar;
	module.exports = exports['default'];

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactAddonsPureRenderMixin = __webpack_require__(31);
	
	var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsDropdownLink = __webpack_require__(33);
	
	var _componentsDropdownLink2 = _interopRequireDefault(_componentsDropdownLink);
	
	var _componentsMenuItem = __webpack_require__(37);
	
	var _componentsMenuItem2 = _interopRequireDefault(_componentsMenuItem);
	
	var _locale = __webpack_require__(2);
	
	var SortOptions = _react2['default'].createClass({
	  displayName: 'SortOptions',
	
	  propTypes: {
	    sort: _react2['default'].PropTypes.string,
	    onSelect: _react2['default'].PropTypes.func
	  },
	
	  mixins: [_reactAddonsPureRenderMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      sortKey: this.props.sort || 'date'
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({
	      sortKey: nextProps.sort || 'date'
	    });
	  },
	
	  getMenuItem: function getMenuItem(key) {
	    return _react2['default'].createElement(
	      _componentsMenuItem2['default'],
	      { onSelect: this.onSelect, eventKey: key, isActive: this.state.sortKey === key },
	      this.getSortLabel(key)
	    );
	  },
	
	  onSelect: function onSelect(sort) {
	    this.setState({ sortKey: sort });
	    if (this.props.onSelect) {
	      this.props.onSelect(sort);
	    }
	  },
	
	  getSortLabel: function getSortLabel(key) {
	    switch (key) {
	      case 'new':
	        return (0, _locale.t)('First Seen');
	      case 'priority':
	        return (0, _locale.t)('Priority');
	      case 'freq':
	        return (0, _locale.t)('Frequency');
	      case 'date':
	      default:
	        return (0, _locale.t)('Last Seen');
	    }
	  },
	
	  render: function render() {
	    var dropdownTitle = _react2['default'].createElement(
	      'span',
	      null,
	      _react2['default'].createElement(
	        'strong',
	        null,
	        (0, _locale.t)('Sort by'),
	        ':'
	      ),
	      '  ',
	      this.getSortLabel(this.state.sortKey)
	    );
	
	    return _react2['default'].createElement(
	      _componentsDropdownLink2['default'],
	      {
	        btnGroup: true,
	        title: dropdownTitle },
	      this.getMenuItem('priority'),
	      this.getMenuItem('date'),
	      this.getMenuItem('new'),
	      this.getMenuItem('freq')
	    );
	  }
	});
	
	exports['default'] = SortOptions;
	module.exports = exports['default'];

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var StreamTagFilter = _react2['default'].createClass({
	  displayName: 'StreamTagFilter',
	
	  propTypes: {
	    tag: _react2['default'].PropTypes.object.isRequired,
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    projectId: _react2['default'].PropTypes.string.isRequired,
	    value: _react2['default'].PropTypes.string,
	    onSelect: _react2['default'].PropTypes.func
	  },
	
	  statics: {
	    tagValueToSelect2Format: function tagValueToSelect2Format(key) {
	      return {
	        id: key,
	        text: key
	      };
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      tag: {},
	      value: ''
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      query: '',
	      loading: false,
	      value: this.props.value
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var select = this.refs.select;
	
	    var selectOpts = {
	      placeholder: '--',
	      allowClear: true
	    };
	
	    if (!this.props.tag.predefined) {
	      Object.assign(selectOpts, {
	        initSelection: function initSelection(element, callback) {
	          callback(StreamTagFilter.tagValueToSelect2Format(_this.props.value));
	        },
	        ajax: {
	          url: this.getTagValuesAPIEndpoint(),
	          dataType: 'json',
	          delay: 250,
	          data: function data(term, page) {
	            return {
	              query: term
	            };
	          },
	          results: function results(data, page) {
	            // parse the results into the format expected by Select2
	            return {
	              results: _underscore2['default'].map(data, function (val) {
	                return StreamTagFilter.tagValueToSelect2Format(val.value);
	              })
	            };
	          },
	          cache: true
	        }
	      });
	    }
	
	    $(select).select2(selectOpts).select2('val', this.state.value).on('change', this.onSelectValue);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (nextProps.value !== this.state.value) {
	      this.setState({
	        value: nextProps.value
	      }, function () {
	        var select = _this2.refs.select;
	        $(select).select2('val', _this2.state.value);
	      });
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    var select = _reactDom2['default'].findDOMNode(this.refs.select);
	    $(select).select2('destroy');
	  },
	
	  getTagValuesAPIEndpoint: function getTagValuesAPIEndpoint() {
	    return '/api/0/projects/' + this.props.orgId + '/' + this.props.projectId + '/tags/' + this.props.tag.key + '/values/';
	  },
	
	  onSelectValue: function onSelectValue(evt) {
	    var val = evt.target.value;
	    this.setState({
	      value: val
	    });
	
	    this.props.onSelect && this.props.onSelect(this.props.tag, val);
	  },
	
	  render: function render() {
	    // NOTE: need to specify empty onChange handler on <select> - even though this
	    //       will get overridden by select2 - because React will complain with
	    //       a warning
	    var tag = this.props.tag;
	    return _react2['default'].createElement(
	      'div',
	      { className: 'stream-tag-filter' },
	      _react2['default'].createElement(
	        'h6',
	        { className: 'nav-header' },
	        tag.name
	      ),
	      this.props.tag.predefined ? _react2['default'].createElement(
	        'select',
	        { ref: 'select', onChange: function () {} },
	        _react2['default'].createElement('option', { key: 'empty' }),
	        this.props.tag.values.map(function (val) {
	          return _react2['default'].createElement(
	            'option',
	            { key: val },
	            val
	          );
	        })
	      ) : _react2['default'].createElement('input', { type: 'hidden', ref: 'select', value: this.props.value })
	    );
	  }
	});
	
	exports['default'] = StreamTagFilter;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsDropdownLink = __webpack_require__(33);
	
	var _componentsDropdownLink2 = _interopRequireDefault(_componentsDropdownLink);
	
	var _componentsListLink = __webpack_require__(47);
	
	var _componentsListLink2 = _interopRequireDefault(_componentsListLink);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _componentsMenuItem = __webpack_require__(37);
	
	var _componentsMenuItem2 = _interopRequireDefault(_componentsMenuItem);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _componentsOrganizationsHomeContainer = __webpack_require__(64);
	
	var _componentsOrganizationsHomeContainer2 = _interopRequireDefault(_componentsOrganizationsHomeContainer);
	
	var _locale = __webpack_require__(2);
	
	var TeamDetails = _react2['default'].createClass({
	  displayName: 'TeamDetails',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      team: null
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var params = this.props.params;
	    if (nextProps.params.teamId !== params.teamId || nextProps.params.orgId !== params.orgId) {
	      this.setState({
	        loading: true,
	        error: false
	      }, this.fetchData);
	    }
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var params = this.props.params;
	
	    this.api.request('/teams/' + params.orgId + '/' + params.teamId + '/', {
	      success: function success(data) {
	        _this.setState({
	          team: data,
	          loading: false,
	          error: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  onTeamChange: function onTeamChange(data) {
	    var team = this.state.team;
	    if (data.slug !== team.slug) {
	      var orgId = this.props.params.orgId;
	      _reactRouter.browserHistory.pushState(null, '/organizations/' + orgId + '/teams/' + data.slug + '/settings/');
	    } else {
	      Object.assign({}, team, data);
	      this.setState({ team: team });
	    }
	  },
	
	  render: function render() {
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	
	    var team = this.state.team;
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var teamId = _props$params.teamId;
	
	    var routePrefix = '/organizations/' + orgId + '/teams/' + teamId;
	    var access = this.getAccess();
	
	    return _react2['default'].createElement(
	      _componentsOrganizationsHomeContainer2['default'],
	      null,
	      _react2['default'].createElement(
	        'h3',
	        null,
	        team.name
	      ),
	      access.has('team:delete') && _react2['default'].createElement(
	        _componentsDropdownLink2['default'],
	        { topLevelClasses: 'pull-right anchor-right', className: 'dropdown-menu-right', title: (0, _locale.t)('More') },
	        _react2['default'].createElement(
	          _componentsMenuItem2['default'],
	          { href: routePrefix + '/remove/' },
	          (0, _locale.t)('Remove Team')
	        )
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: 'nav nav-tabs border-bottom' },
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: routePrefix + '/settings/' },
	          (0, _locale.t)('Settings')
	        ),
	        _react2['default'].createElement(
	          _componentsListLink2['default'],
	          { to: routePrefix + '/members/' },
	          (0, _locale.t)('Members')
	        )
	      ),
	      _react2['default'].cloneElement(this.props.children, {
	        team: team,
	        onTeamChange: this.onTeamChange
	      })
	    );
	  }
	});
	
	exports['default'] = TeamDetails;
	module.exports = exports['default'];

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _componentsAvatar = __webpack_require__(29);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _componentsLoadingError = __webpack_require__(9);
	
	var _componentsLoadingError2 = _interopRequireDefault(_componentsLoadingError);
	
	var _componentsLoadingIndicator = __webpack_require__(6);
	
	var _componentsLoadingIndicator2 = _interopRequireDefault(_componentsLoadingIndicator);
	
	var _mixinsOrganizationState = __webpack_require__(26);
	
	var _mixinsOrganizationState2 = _interopRequireDefault(_mixinsOrganizationState);
	
	var _locale = __webpack_require__(2);
	
	var TeamMembers = _react2['default'].createClass({
	  displayName: 'TeamMembers',
	
	  mixins: [_mixinsApiMixin2['default'], _mixinsOrganizationState2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      loading: true,
	      error: false,
	      memberList: null
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.fetchData();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var params = this.props.params;
	    if (nextProps.params.teamId !== params.teamId || nextProps.params.orgId !== params.orgId) {
	      this.setState({
	        loading: true,
	        error: false
	      }, this.fetchData);
	    }
	  },
	
	  fetchData: function fetchData() {
	    var _this = this;
	
	    var params = this.props.params;
	
	    this.api.request('/teams/' + params.orgId + '/' + params.teamId + '/members/', {
	      success: function success(data) {
	        _this.setState({
	          memberList: data,
	          loading: false,
	          error: false
	        });
	      },
	      error: function error() {
	        _this.setState({
	          loading: false,
	          error: true
	        });
	      }
	    });
	  },
	
	  render: function render() {
	    if (this.state.loading) return _react2['default'].createElement(_componentsLoadingIndicator2['default'], null);else if (this.state.error) return _react2['default'].createElement(_componentsLoadingError2['default'], { onRetry: this.fetchData });
	
	    var orgId = this.props.params.orgId;
	
	    var memberPrefix = '/organizations/' + orgId + '/members';
	    var access = this.getAccess();
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { style: { marginBottom: 20 }, className: 'clearfix' },
	        access.has('org:write') ? _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-primary btn-sm pull-right', href: memberPrefix + '/new/' },
	          _react2['default'].createElement('span', { className: 'icon-plus' }),
	          ' ',
	          (0, _locale.t)('Invite Member')
	        ) : _react2['default'].createElement(
	          'a',
	          { className: 'btn btn-primary btn-sm btn-disabled tip pull-right',
	            title: (0, _locale.t)('You do not have enough permission to add new members') },
	          _react2['default'].createElement('span', { className: 'icon-plus' }),
	          ' ',
	          (0, _locale.t)('Invite Member')
	        )
	      ),
	      _react2['default'].createElement(
	        'table',
	        { className: 'table member-list' },
	        _react2['default'].createElement(
	          'colgroup',
	          null,
	          _react2['default'].createElement('col', null),
	          _react2['default'].createElement('col', { width: '150' })
	        ),
	        _react2['default'].createElement(
	          'thead',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement(
	              'th',
	              null,
	              (0, _locale.t)('Member')
	            ),
	            _react2['default'].createElement(
	              'th',
	              null,
	              (0, _locale.t)('Role')
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          this.state.memberList.map(function (member) {
	            return _react2['default'].createElement(
	              'tr',
	              null,
	              _react2['default'].createElement(
	                'td',
	                { className: 'table-user-info' },
	                _react2['default'].createElement(_componentsAvatar2['default'], { user: member, size: 80 }),
	                _react2['default'].createElement(
	                  'h5',
	                  null,
	                  _react2['default'].createElement(
	                    'a',
	                    { href: memberPrefix + '/' + member.id + '/' },
	                    member.email
	                  )
	                ),
	                member.email
	              ),
	              _react2['default'].createElement(
	                'td',
	                null,
	                member.roleName
	              )
	            );
	          })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = TeamMembers;
	module.exports = exports['default'];

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mixinsApiMixin = __webpack_require__(3);
	
	var _mixinsApiMixin2 = _interopRequireDefault(_mixinsApiMixin);
	
	var _storesIndicatorStore = __webpack_require__(17);
	
	var _storesIndicatorStore2 = _interopRequireDefault(_storesIndicatorStore);
	
	var _componentsForms = __webpack_require__(36);
	
	var _locale = __webpack_require__(2);
	
	var TeamSettingsForm = _react2['default'].createClass({
	  displayName: 'TeamSettingsForm',
	
	  propTypes: {
	    orgId: _react2['default'].PropTypes.string.isRequired,
	    teamId: _react2['default'].PropTypes.string.isRequired,
	    initialData: _react2['default'].PropTypes.object,
	    onSave: _react2['default'].PropTypes.func.isRequired
	  },
	
	  mixins: [_mixinsApiMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return {
	      formData: Object.assign({}, this.props.initialData),
	      errors: {}
	    };
	  },
	
	  onFieldChange: function onFieldChange(name, value) {
	    var formData = this.state.formData;
	    formData[name] = value;
	    this.setState({
	      formData: formData
	    });
	  },
	
	  onSubmit: function onSubmit(e) {
	    var _this = this;
	
	    e.preventDefault();
	
	    if (this.state.state == _componentsForms.FormState.SAVING) {
	      return;
	    }
	    this.setState({
	      state: _componentsForms.FormState.SAVING
	    }, function () {
	      var loadingIndicator = _storesIndicatorStore2['default'].add((0, _locale.t)('Saving changes..'));
	      var _props = _this.props;
	      var orgId = _props.orgId;
	      var teamId = _props.teamId;
	
	      _this.api.request('/teams/' + orgId + '/' + teamId + '/', {
	        method: 'PUT',
	        data: _this.state.formData,
	        success: function success(data) {
	          _this.props.onSave(data);
	          _this.setState({
	            state: _componentsForms.FormState.READY,
	            errors: {}
	          });
	        },
	        error: function error(_error) {
	          _this.setState({
	            state: _componentsForms.FormState.ERROR,
	            errors: _error.responseJSON
	          });
	        },
	        complete: function complete() {
	          _storesIndicatorStore2['default'].remove(loadingIndicator);
	        }
	      });
	    });
	  },
	
	  render: function render() {
	    var isSaving = this.state.state === _componentsForms.FormState.SAVING;
	    var errors = this.state.errors;
	    return _react2['default'].createElement(
	      'form',
	      { onSubmit: this.onSubmit, className: 'form-stacked' },
	      this.state.state === _componentsForms.FormState.ERROR && _react2['default'].createElement(
	        'div',
	        { className: 'alert alert-error alert-block' },
	        (0, _locale.t)('Unable to save your changes. Please ensure all fields are valid and try again.')
	      ),
	      _react2['default'].createElement(
	        'fieldset',
	        null,
	        _react2['default'].createElement(_componentsForms.TextField, {
	          key: 'name',
	          label: (0, _locale.t)('Name'),
	          placeholder: (0, _locale.t)('e.g. API Team'),
	          value: this.state.formData.name,
	          required: true,
	          error: errors.name,
	          onChange: this.onFieldChange.bind(this, 'name') }),
	        _react2['default'].createElement(_componentsForms.TextField, {
	          key: 'slug',
	          label: (0, _locale.t)('Short name'),
	          value: this.state.formData.slug,
	          required: true,
	          error: errors.slug,
	          onChange: this.onFieldChange.bind(this, 'slug') })
	      ),
	      _react2['default'].createElement(
	        'fieldset',
	        { className: 'form-actions' },
	        _react2['default'].createElement(
	          'button',
	          { type: 'submit', className: 'btn btn-primary',
	            disabled: isSaving },
	          (0, _locale.t)('Save Changes')
	        )
	      )
	    );
	  }
	});
	
	var TeamSettings = _react2['default'].createClass({
	  displayName: 'TeamSettings',
	
	  propTypes: {
	    team: _react2['default'].PropTypes.object.isRequired,
	    onTeamChange: _react2['default'].PropTypes.func.isRequired
	  },
	
	  render: function render() {
	    var _props$params = this.props.params;
	    var orgId = _props$params.orgId;
	    var teamId = _props$params.teamId;
	
	    var team = this.props.team;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].createElement(
	        'div',
	        { className: 'box' },
	        _react2['default'].createElement(
	          'div',
	          { className: 'box-content with-padding' },
	          _react2['default'].createElement(TeamSettingsForm, {
	            orgId: orgId,
	            teamId: teamId,
	            initialData: team,
	            onSave: this.props.onTeamChange })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = TeamSettings;
	module.exports = exports['default'];

/***/ },
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */
/***/ function(module, exports) {

	module.exports = {"":{"domain":"sentry"}};

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(732);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (Array.isArray(val)) {
				return val.sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 732 */
849,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(877);

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(934);

/***/ },
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */
/***/ function(module, exports) {

	'use strict';
	
	var isHidden = function isHidden(element) {
	  return element.offsetParent === null;
	};
	
	var offset = function offset(element) {
	  var rect = element.getBoundingClientRect();
	
	  return {
	    top: rect.top + window.pageYOffset,
	    left: rect.left + window.pageXOffset
	  };
	};
	
	var inViewport = function inViewport(element, container, customOffset) {
	  if (isHidden(element)) {
	    return false;
	  }
	
	  var top = undefined,
	      left = undefined,
	      bottom = undefined,
	      right = undefined;
	
	  if (typeof container === 'undefined' || container === window) {
	    top = window.pageYOffset;
	    left = window.pageXOffset;
	    bottom = top + window.innerHeight;
	    right = left + window.innerWidth;
	  } else {
	    var containerOffset = offset(container);
	
	    top = containerOffset.top;
	    left = containerOffset.left;
	    bottom = top + container.offsetHeight;
	    right = left + container.offsetWidth;
	  }
	
	  var elementOffset = offset(element);
	
	  return top < elementOffset.top + customOffset.bottom + element.offsetHeight && bottom > elementOffset.top - customOffset.top && left < elementOffset.left + customOffset.right + element.offsetWidth && right > elementOffset.left - customOffset.left;
	};
	
	module.exports = inViewport;

/***/ },
/* 816 */
/***/ function(module, exports) {

	'use strict';
	
	var style = function style(element, prop) {
	  return typeof getComputedStyle !== 'undefined' ? getComputedStyle(element, null).getPropertyValue(prop) : element.style[prop];
	};
	
	var overflow = function overflow(element) {
	  return style(element, 'overflow') + style(element, 'overflow-y') + style(element, 'overflow-x');
	};
	
	var scrollParent = function scrollParent(element) {
	  if (!(element instanceof HTMLElement)) {
	    return window;
	  }
	
	  var parent = element;
	
	  while (parent) {
	    if (parent === document.body || parent === document.documentElement) {
	      break;
	    }
	
	    if (!parent.parentNode) {
	      break;
	    }
	
	    if (/(scroll|auto)/.test(overflow(parent))) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return window;
	};
	
	module.exports = scrollParent;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root,factory){
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.eventListener = factory();
	  }
	}(this, function () {
		function wrap(standard, fallback) {
			return function (el, evtName, listener, useCapture) {
				if (el[standard]) {
					el[standard](evtName, listener, useCapture);
				} else if (el[fallback]) {
					el[fallback]('on' + evtName, listener);
				}
			}
		}
	
	    return {
			add: wrap('addEventListener', 'attachEvent'),
			remove: wrap('removeEventListener', 'detachEvent')
		};
	}));

/***/ },
/* 818 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 819 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _channel = __webpack_require__(373);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_React$Component) {
	  _inherits(Container, _React$Component);
	
	  function Container(props) {
	    _classCallCheck(this, Container);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Container).call(this, props));
	
	    _this.updateOffset = function (_ref) {
	      var inherited = _ref.inherited;
	      var offset = _ref.offset;
	
	      _this.channel.update(function (data) {
	        data.inherited = inherited + offset;
	      });
	    };
	
	    _this.channel = new _channel2.default({ inherited: 0, offset: 0, node: null });
	    return _this;
	  }
	
	  _createClass(Container, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { 'sticky-channel': this.channel };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var parentChannel = this.context['sticky-channel'];
	      if (parentChannel) parentChannel.subscribe(this.updateOffset);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var node = _reactDom2.default.findDOMNode(this);
	      this.channel.update(function (data) {
	        data.node = node;
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.channel.update(function (data) {
	        data.node = null;
	      });
	
	      var parentChannel = this.context['sticky-channel'];
	      if (parentChannel) parentChannel.unsubscribe(this.updateOffset);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        this.props,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Container;
	}(_react2.default.Component);
	
	Container.contextTypes = {
	  'sticky-channel': _react2.default.PropTypes.any
	};
	Container.childContextTypes = {
	  'sticky-channel': _react2.default.PropTypes.any
	};
	exports.default = Container;
	module.exports = exports['default'];

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Channel = exports.StickyContainer = exports.Sticky = undefined;
	
	var _sticky = __webpack_require__(867);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _container = __webpack_require__(865);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _channel = __webpack_require__(373);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Sticky = _sticky2.default;
	exports.StickyContainer = _container2.default;
	exports.Channel = _channel2.default;
	exports.default = _sticky2.default;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sticky = function (_React$Component) {
	  _inherits(Sticky, _React$Component);
	
	  function Sticky(props) {
	    _classCallCheck(this, Sticky);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Sticky).call(this, props));
	
	    _this.updateContext = function (_ref) {
	      var inherited = _ref.inherited;
	      var node = _ref.node;
	
	      _this.containerNode = node;
	      _this.setState({
	        containerOffset: inherited,
	        distanceFromBottom: _this.getDistanceFromBottom()
	      });
	    };
	
	    _this.recomputeState = function () {
	      var isSticky = _this.isSticky();
	      var height = _this.getHeight();
	      var width = _this.getWidth();
	      var xOffset = _this.getXOffset();
	      var distanceFromBottom = _this.getDistanceFromBottom();
	      var hasChanged = _this.state.isSticky !== isSticky;
	
	      _this.setState({ isSticky: isSticky, height: height, width: width, xOffset: xOffset, distanceFromBottom: distanceFromBottom });
	
	      if (hasChanged) {
	        if (_this.channel) {
	          _this.channel.update(function (data) {
	            data.offset = isSticky ? _this.state.height : 0;
	          });
	        }
	
	        _this.props.onStickyStateChange(isSticky);
	      }
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Sticky, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.channel = this.context['sticky-channel'];
	      this.channel.subscribe(this.updateContext);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.on(['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], this.recomputeState);
	      this.recomputeState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.recomputeState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.off(['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], this.recomputeState);
	      this.channel.unsubscribe(this.updateContext);
	    }
	  }, {
	    key: 'getXOffset',
	    value: function getXOffset() {
	      return this.refs.placeholder.getBoundingClientRect().left;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth() {
	      return this.refs.placeholder.getBoundingClientRect().width;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight() {
	      return _reactDom2.default.findDOMNode(this.refs.children).getBoundingClientRect().height;
	    }
	  }, {
	    key: 'getDistanceFromTop',
	    value: function getDistanceFromTop() {
	      return this.refs.placeholder.getBoundingClientRect().top;
	    }
	  }, {
	    key: 'getDistanceFromBottom',
	    value: function getDistanceFromBottom() {
	      if (!this.containerNode) return 0;
	      return this.containerNode.getBoundingClientRect().bottom;
	    }
	  }, {
	    key: 'isSticky',
	    value: function isSticky() {
	      if (!this.props.isActive) return false;
	
	      var fromTop = this.getDistanceFromTop();
	      var fromBottom = this.getDistanceFromBottom();
	
	      var topBreakpoint = this.state.containerOffset - this.props.topOffset;
	      var bottomBreakpoint = this.state.containerOffset + this.props.bottomOffset;
	
	      return fromTop <= topBreakpoint && fromBottom >= bottomBreakpoint;
	    }
	  }, {
	    key: 'on',
	    value: function on(events, callback) {
	      events.forEach(function (evt) {
	        window.addEventListener(evt, callback);
	      });
	    }
	  }, {
	    key: 'off',
	    value: function off(events, callback) {
	      events.forEach(function (evt) {
	        window.removeEventListener(evt, callback);
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(newProps, newState) {
	      var _this2 = this;
	
	      // Have we changed the number of props?
	      var propNames = Object.keys(this.props);
	      if (Object.keys(newProps).length != propNames.length) return true;
	
	      // Have we changed any prop values?
	      var valuesMatch = propNames.every(function (key) {
	        return newProps.hasOwnProperty(key) && newProps[key] === _this2.props[key];
	      });
	      if (!valuesMatch) return true;
	
	      // Have we changed any state that will always impact rendering?
	      var state = this.state;
	      if (newState.isSticky !== state.isSticky) return true;
	
	      // If we are sticky, have we changed any state that will impact rendering?
	      if (state.isSticky) {
	        if (newState.height !== state.height) return true;
	        if (newState.width !== state.width) return true;
	        if (newState.xOffset !== state.xOffset) return true;
	        if (newState.containerOffset !== state.containerOffset) return true;
	        if (newState.distanceFromBottom !== state.distanceFromBottom) return true;
	      }
	
	      return false;
	    }
	
	    /*
	     * The special sauce.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var placeholderStyle = { paddingBottom: 0 };
	      var className = this.props.className;
	      var style = this.props.style;
	
	      if (this.state.isSticky) {
	        var _stickyStyle = {
	          position: 'fixed',
	          top: this.state.containerOffset,
	          left: this.state.xOffset,
	          width: this.state.width
	        };
	
	        var bottomLimit = this.state.distanceFromBottom - this.state.height - this.props.bottomOffset;
	        if (this.state.containerOffset > bottomLimit) {
	          _stickyStyle.top = bottomLimit;
	        }
	
	        placeholderStyle.paddingBottom = this.state.height;
	
	        className += ' ' + this.props.stickyClassName;
	        style = _extends({}, style, _stickyStyle, this.props.stickyStyle);
	      }
	
	      var _props = this.props;
	      var topOffset = _props.topOffset;
	      var isActive = _props.isActive;
	      var stickyClassName = _props.stickyClassName;
	      var stickyStyle = _props.stickyStyle;
	      var bottomOffset = _props.bottomOffset;
	      var onStickyStateChange = _props.onStickyStateChange;
	
	      var props = _objectWithoutProperties(_props, ['topOffset', 'isActive', 'stickyClassName', 'stickyStyle', 'bottomOffset', 'onStickyStateChange']);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { ref: 'placeholder', style: placeholderStyle }),
	        _react2.default.createElement(
	          'div',
	          _extends({}, props, { ref: 'children', className: className, style: style }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Sticky;
	}(_react2.default.Component);
	
	Sticky.propTypes = {
	  isActive: _react2.default.PropTypes.bool,
	  className: _react2.default.PropTypes.string,
	  style: _react2.default.PropTypes.object,
	  stickyClassName: _react2.default.PropTypes.string,
	  stickyStyle: _react2.default.PropTypes.object,
	  topOffset: _react2.default.PropTypes.number,
	  bottomOffset: _react2.default.PropTypes.number,
	  onStickyStateChange: _react2.default.PropTypes.func
	};
	Sticky.defaultProps = {
	  isActive: true,
	  className: '',
	  style: {},
	  stickyClassName: 'sticky',
	  stickyStyle: {},
	  topOffset: 0,
	  bottomOffset: 0,
	  onStickyStateChange: function onStickyStateChange() {}
	};
	Sticky.contextTypes = {
	  'sticky-channel': _react2.default.PropTypes.any
	};
	exports.default = Sticky;
	module.exports = exports['default'];

/***/ },
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCSSTransitionGroup
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var React = __webpack_require__(152);
	
	var ReactTransitionGroup = __webpack_require__(911);
	var ReactCSSTransitionGroupChild = __webpack_require__(878);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	        }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',
	
	  propTypes: {
	    transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool,
	    transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	    transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	    transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	  },
	
	  getDefaultProps: function () {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },
	
	  _wrapChild: function (child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return React.createElement(ReactCSSTransitionGroupChild, {
	      name: this.props.transitionName,
	      appear: this.props.transitionAppear,
	      enter: this.props.transitionEnter,
	      leave: this.props.transitionLeave,
	      appearTimeout: this.props.transitionAppearTimeout,
	      enterTimeout: this.props.transitionEnterTimeout,
	      leaveTimeout: this.props.transitionLeaveTimeout
	    }, child);
	  },
	
	  render: function () {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  }
	});
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCSSTransitionGroupChild
	 */
	
	'use strict';
	
	var React = __webpack_require__(152);
	var ReactDOM = __webpack_require__(379);
	
	var CSSCore = __webpack_require__(935);
	var ReactTransitionEvents = __webpack_require__(910);
	
	var onlyChild = __webpack_require__(402);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactDOM.findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClassAndNode: function (className, node) {
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameAndNodeQueue, TICK);
	    }
	  },
	
	  flushClassNameAndNodeQueue: function () {
	    if (this.isMounted()) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        CSSCore.addClass(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 879 */,
/* 880 */,
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentWithPureRenderMixin
	 */
	
	'use strict';
	
	var shallowCompare = __webpack_require__(933);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 *
	 * See https://facebook.github.io/react/docs/pure-render-mixin.html
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function (nextProps, nextState) {
	    return shallowCompare(this, nextProps, nextState);
	  }
	};
	
	module.exports = ReactComponentWithPureRenderMixin;

/***/ },
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(394);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(35);
	
	var getVendorPrefixedEventName = __webpack_require__(399);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var React = __webpack_require__(152);
	var ReactInstanceMap = __webpack_require__(98);
	var ReactTransitionChildMapping = __webpack_require__(909);
	
	var emptyFunction = __webpack_require__(44);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function () {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function () {
	    return {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function () {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function () {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function (nextProps) {
	    var nextChildMapping;
	    if (false) {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    }
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function () {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function (key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      this.setState(function (state) {
	        var newChildren = _assign({}, state.children);
	        delete newChildren[key];
	        return { children: newChildren };
	      });
	    }
	  },
	
	  render: function () {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  }
	});
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule shallowCompare
	*/
	
	'use strict';
	
	var shallowEqual = __webpack_require__(158);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule update
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(13),
	    _assign = __webpack_require__(18);
	
	var keyOf = __webpack_require__(67);
	var invariant = __webpack_require__(10);
	var hasOwnProperty = {}.hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return _assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = keyOf({ $push: null });
	var COMMAND_UNSHIFT = keyOf({ $unshift: null });
	var COMMAND_SPLICE = keyOf({ $splice: null });
	var COMMAND_SET = keyOf({ $set: null });
	var COMMAND_MERGE = keyOf({ $merge: null });
	var COMMAND_APPLY = keyOf({ $apply: null });
	
	var ALL_COMMANDS_LIST = [COMMAND_PUSH, COMMAND_UNSHIFT, COMMAND_SPLICE, COMMAND_SET, COMMAND_MERGE, COMMAND_APPLY];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function (command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  !Array.isArray(value) ?  false ? invariant(false, 'update(): expected target of %s to be an array; got %s.', command, value) : _prodInvariant('1', command, value) : void 0;
	  var specValue = spec[command];
	  !Array.isArray(specValue) ?  false ? invariant(false, 'update(): expected spec of %s to be an array; got %s. Did you forget to wrap your parameter in an array?', command, specValue) : _prodInvariant('2', command, specValue) : void 0;
	}
	
	/**
	 * Returns a updated shallow copy of an object without mutating the original.
	 * See https://facebook.github.io/react/docs/update.html for details.
	 */
	function update(value, spec) {
	  !(typeof spec === 'object') ?  false ? invariant(false, 'update(): You provided a key path to update() that did not contain one of %s. Did you forget to include {%s: ...}?', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : _prodInvariant('3', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : void 0;
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    !(Object.keys(spec).length === 1) ?  false ? invariant(false, 'Cannot have more than one key in an object with %s', COMMAND_SET) : _prodInvariant('4', COMMAND_SET) : void 0;
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    !(mergeObj && typeof mergeObj === 'object') ?  false ? invariant(false, 'update(): %s expects a spec of type \'object\'; got %s', COMMAND_MERGE, mergeObj) : _prodInvariant('5', COMMAND_MERGE, mergeObj) : void 0;
	    !(nextValue && typeof nextValue === 'object') ?  false ? invariant(false, 'update(): %s expects a target of type \'object\'; got %s', COMMAND_MERGE, nextValue) : _prodInvariant('6', COMMAND_MERGE, nextValue) : void 0;
	    _assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function (item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function (item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    !Array.isArray(value) ?  false ? invariant(false, 'Expected %s target to be an array; got %s', COMMAND_SPLICE, value) : _prodInvariant('7', COMMAND_SPLICE, value) : void 0;
	    !Array.isArray(spec[COMMAND_SPLICE]) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
	    spec[COMMAND_SPLICE].forEach(function (args) {
	      !Array.isArray(args) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    !(typeof spec[COMMAND_APPLY] === 'function') ?  false ? invariant(false, 'update(): expected spec of %s to be a function; got %s.', COMMAND_APPLY, spec[COMMAND_APPLY]) : _prodInvariant('9', COMMAND_APPLY, spec[COMMAND_APPLY]) : void 0;
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(10);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__( 960 );

/***/ },
/* 959 */
/***/ function(module, exports) {

	// Copyright 2014 Google Inc. All rights reserved
	//
	// Use of this source code is governed by a BSD-style
	// license that can be found in the LICENSE file or at
	// https://developers.google.com/open-source/licenses/bsd
	
	/**
	 * @fileoverview The U2F api.
	 */
	
	'use strict';
	
	/** Namespace for the U2F api.
	 * @type {Object}
	 */
	var u2f = u2f || {};
	
	module.exports = u2f; // Adaptation for u2f-api package
	
	/**
	 * The U2F extension id
	 * @type {string}
	 * @const
	 */
	u2f.EXTENSION_ID = 'kmendfapggjehodndflmmgagdbamhnfd';
	
	/**
	 * Message types for messsages to/from the extension
	 * @const
	 * @enum {string}
	 */
	u2f.MessageTypes = {
	  'U2F_REGISTER_REQUEST': 'u2f_register_request',
	  'U2F_SIGN_REQUEST': 'u2f_sign_request',
	  'U2F_REGISTER_RESPONSE': 'u2f_register_response',
	  'U2F_SIGN_RESPONSE': 'u2f_sign_response'
	};
	
	/**
	 * Response status codes
	 * @const
	 * @enum {number}
	 */
	u2f.ErrorCodes = {
	  'OK': 0,
	  'OTHER_ERROR': 1,
	  'BAD_REQUEST': 2,
	  'CONFIGURATION_UNSUPPORTED': 3,
	  'DEVICE_INELIGIBLE': 4,
	  'TIMEOUT': 5
	};
	
	/**
	 * A message type for registration requests
	 * @typedef {{
	 *   type: u2f.MessageTypes,
	 *   signRequests: Array.<u2f.SignRequest>,
	 *   registerRequests: ?Array.<u2f.RegisterRequest>,
	 *   timeoutSeconds: ?number,
	 *   requestId: ?number
	 * }}
	 */
	u2f.Request;
	
	/**
	 * A message for registration responses
	 * @typedef {{
	 *   type: u2f.MessageTypes,
	 *   responseData: (u2f.Error | u2f.RegisterResponse | u2f.SignResponse),
	 *   requestId: ?number
	 * }}
	 */
	u2f.Response;
	
	/**
	 * An error object for responses
	 * @typedef {{
	 *   errorCode: u2f.ErrorCodes,
	 *   errorMessage: ?string
	 * }}
	 */
	u2f.Error;
	
	/**
	 * Data object for a single sign request.
	 * @typedef {{
	 *   version: string,
	 *   challenge: string,
	 *   keyHandle: string,
	 *   appId: string
	 * }}
	 */
	u2f.SignRequest;
	
	/**
	 * Data object for a sign response.
	 * @typedef {{
	 *   keyHandle: string,
	 *   signatureData: string,
	 *   clientData: string
	 * }}
	 */
	u2f.SignResponse;
	
	/**
	 * Data object for a registration request.
	 * @typedef {{
	 *   version: string,
	 *   challenge: string,
	 *   appId: string
	 * }}
	 */
	u2f.RegisterRequest;
	
	/**
	 * Data object for a registration response.
	 * @typedef {{
	 *   registrationData: string,
	 *   clientData: string
	 * }}
	 */
	u2f.RegisterResponse;
	
	
	// Low level MessagePort API support
	
	/**
	 * Sets up a MessagePort to the U2F extension using the
	 * available mechanisms.
	 * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
	 */
	u2f.getMessagePort = function(callback) {
	  if (typeof chrome != 'undefined' && chrome.runtime) {
	    // The actual message here does not matter, but we need to get a reply
	    // for the callback to run. Thus, send an empty signature request
	    // in order to get a failure response.
	    var msg = {
	      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
	      signRequests: []
	    };
	    chrome.runtime.sendMessage(u2f.EXTENSION_ID, msg, function() {
	      if (!chrome.runtime.lastError) {
	        // We are on a whitelisted origin and can talk directly
	        // with the extension.
	        u2f.getChromeRuntimePort_(callback);
	      } else {
	        // chrome.runtime was available, but we couldn't message
	        // the extension directly, use iframe
	        u2f.getIframePort_(callback);
	      }
	    });
	  } else {
	    // chrome.runtime was not available at all, which is normal
	    // when this origin doesn't have access to any extensions.
	    u2f.getIframePort_(callback);
	  }
	};
	
	/**
	 * Connects directly to the extension via chrome.runtime.connect
	 * @param {function(u2f.WrappedChromeRuntimePort_)} callback
	 * @private
	 */
	u2f.getChromeRuntimePort_ = function(callback) {
	  var port = chrome.runtime.connect(u2f.EXTENSION_ID,
	    {'includeTlsChannelId': true});
	  setTimeout(function() {
	    callback(null, new u2f.WrappedChromeRuntimePort_(port));
	  }, 0);
	};
	
	/**
	 * A wrapper for chrome.runtime.Port that is compatible with MessagePort.
	 * @param {Port} port
	 * @constructor
	 * @private
	 */
	u2f.WrappedChromeRuntimePort_ = function(port) {
	  this.port_ = port;
	};
	
	/**
	 * Posts a message on the underlying channel.
	 * @param {Object} message
	 */
	u2f.WrappedChromeRuntimePort_.prototype.postMessage = function(message) {
	  this.port_.postMessage(message);
	};
	
	/**
	 * Emulates the HTML 5 addEventListener interface. Works only for the
	 * onmessage event, which is hooked up to the chrome.runtime.Port.onMessage.
	 * @param {string} eventName
	 * @param {function({data: Object})} handler
	 */
	u2f.WrappedChromeRuntimePort_.prototype.addEventListener =
	    function(eventName, handler) {
	  var name = eventName.toLowerCase();
	  if (name == 'message' || name == 'onmessage') {
	    this.port_.onMessage.addListener(function(message) {
	      // Emulate a minimal MessageEvent object
	      handler({'data': message});
	    });
	  } else {
	    console.error('WrappedChromeRuntimePort only supports onMessage');
	  }
	};
	
	/**
	 * Sets up an embedded trampoline iframe, sourced from the extension.
	 * @param {function(MessagePort)} callback
	 * @private
	 */
	u2f.getIframePort_ = function(callback) {
	  // Create the iframe
	  var iframeOrigin = 'chrome-extension://' + u2f.EXTENSION_ID;
	  var iframe = document.createElement('iframe');
	  iframe.src = iframeOrigin + '/u2f-comms.html';
	  iframe.setAttribute('style', 'display:none');
	  document.body.appendChild(iframe);
	
	  var hasCalledBack = false;
	
	  var channel = new MessageChannel();
	  var ready = function(message) {
	    if (message.data == 'ready') {
	      channel.port1.removeEventListener('message', ready);
	      if (!hasCalledBack)
	      {
	        hasCalledBack = true;
	        callback(null, channel.port1);
	      }
	    } else {
	      console.error('First event on iframe port was not "ready"');
	    }
	  };
	  channel.port1.addEventListener('message', ready);
	  channel.port1.start();
	
	  iframe.addEventListener('load', function() {
	    // Deliver the port to the iframe and initialize
	    iframe.contentWindow.postMessage('init', iframeOrigin, [channel.port2]);
	  });
	
	  // Give this 200ms to initialize, after that, we treat this method as failed
	  setTimeout(function() {
	    if (!hasCalledBack)
	    {
	      hasCalledBack = true;
	      callback(new Error("IFrame extension not supported"));
	    }
	  }, 200);
	};
	
	
	// High-level JS API
	
	/**
	 * Default extension response timeout in seconds.
	 * @const
	 */
	u2f.EXTENSION_TIMEOUT_SEC = 30;
	
	/**
	 * A singleton instance for a MessagePort to the extension.
	 * @type {MessagePort|u2f.WrappedChromeRuntimePort_}
	 * @private
	 */
	u2f.port_ = null;
	
	/**
	 * Callbacks waiting for a port
	 * @type {Array.<function((MessagePort|u2f.WrappedChromeRuntimePort_))>}
	 * @private
	 */
	u2f.waitingForPort_ = [];
	
	/**
	 * A counter for requestIds.
	 * @type {number}
	 * @private
	 */
	u2f.reqCounter_ = 0;
	
	/**
	 * A map from requestIds to client callbacks
	 * @type {Object.<number,(function((u2f.Error|u2f.RegisterResponse))
	 *                       |function((u2f.Error|u2f.SignResponse)))>}
	 * @private
	 */
	u2f.callbackMap_ = {};
	
	/**
	 * Creates or retrieves the MessagePort singleton to use.
	 * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
	 * @private
	 */
	u2f.getPortSingleton_ = function(callback) {
	  if (u2f.port_) {
	    callback(null, u2f.port_);
	  } else {
	    if (u2f.waitingForPort_.length == 0) {
	      u2f.getMessagePort(function(err, port) {
	        if (!err) {
	          u2f.port_ = port;
	          u2f.port_.addEventListener('message',
	            /** @type {function(Event)} */ (u2f.responseHandler_));
	        }
	
	        // Careful, here be async callbacks. Maybe.
	        while (u2f.waitingForPort_.length)
	          u2f.waitingForPort_.shift()(err, port);
	      });
	    }
	    u2f.waitingForPort_.push(callback);
	  }
	};
	
	/**
	 * Handles response messages from the extension.
	 * @param {MessageEvent.<u2f.Response>} message
	 * @private
	 */
	u2f.responseHandler_ = function(message) {
	  var response = message.data;
	  var reqId = response['requestId'];
	  if (!reqId || !u2f.callbackMap_[reqId]) {
	    console.error('Unknown or missing requestId in response.');
	    return;
	  }
	  var cb = u2f.callbackMap_[reqId];
	  delete u2f.callbackMap_[reqId];
	  cb(null, response['responseData']);
	};
	
	/**
	 * Calls the callback with true or false as first and only argument
	 * @param {Function} callback
	 */
	u2f.isSupported = function(callback) {
	  u2f.getPortSingleton_(function(err, port) {
	    callback(!err);
	  });
	}
	
	/**
	 * Dispatches an array of sign requests to available U2F tokens.
	 * @param {Array.<u2f.SignRequest>} signRequests
	 * @param {function((u2f.Error|u2f.SignResponse))} callback
	 * @param {number=} opt_timeoutSeconds
	 */
	u2f.sign = function(signRequests, callback, opt_timeoutSeconds) {
	  u2f.getPortSingleton_(function(err, port) {
	    if (err)
	      return callback(err);
	
	    var reqId = ++u2f.reqCounter_;
	    u2f.callbackMap_[reqId] = callback;
	    var req = {
	      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
	      signRequests: signRequests,
	      timeoutSeconds: (typeof opt_timeoutSeconds !== 'undefined' ?
	        opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC),
	      requestId: reqId
	    };
	    port.postMessage(req);
	  });
	};
	
	/**
	 * Dispatches register requests to available U2F tokens. An array of sign
	 * requests identifies already registered tokens.
	 * @param {Array.<u2f.RegisterRequest>} registerRequests
	 * @param {Array.<u2f.SignRequest>} signRequests
	 * @param {function((u2f.Error|u2f.RegisterResponse))} callback
	 * @param {number=} opt_timeoutSeconds
	 */
	u2f.register = function(registerRequests, signRequests,
	    callback, opt_timeoutSeconds) {
	  u2f.getPortSingleton_(function(err, port) {
	    if (err)
	      return callback(err);
	
	    var reqId = ++u2f.reqCounter_;
	    u2f.callbackMap_[reqId] = callback;
	    var req = {
	      type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
	      signRequests: signRequests,
	      registerRequests: registerRequests,
	      timeoutSeconds: (typeof opt_timeoutSeconds !== 'undefined' ?
	        opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC),
	      requestId: reqId
	    };
	    port.postMessage(req);
	  });
	};


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var coreApi = __webpack_require__( 959 );
	
	module.exports = API;
	
	function API( Promise )
	{
		return {
			isSupported   : isSupported.bind( Promise ),
			ensureSupport : ensureSupport.bind( Promise ),
			register      : register.bind( Promise ),
			sign          : sign.bind( Promise ),
			ErrorCodes    : API.ErrorCodes
		};
	}
	
	API.ErrorCodes = {
		CANCELED: -1
	};
	var errorMap = {
		'-1': 'CANCELED'
	};
	
	Object.keys( coreApi.ErrorCodes ).forEach( function( key ) {
		API.ErrorCodes[ key ] = coreApi.ErrorCodes[ key ];
		errorMap[ '' + coreApi.ErrorCodes[ key ] ] = key;
	} );
	
	function makeError( msg, err )
	{
		var code = err != null ? err.errorCode : 1; // Default to OTHER_ERROR
		var type = errorMap[ '' + code ];
		var error = new Error( msg );
		error.metaData = {
			type: type,
			code: code
		}
		return error;
	}
	
	function defer( Promise, fun )
	{
		var ret = { };
		ret.promise = new Promise( function( resolve, reject ) {
			ret.resolve = resolve;
			ret.reject = reject;
			try
			{
				fun && fun( resolve, reject );
			}
			catch ( err )
			{
				reject( err );
			}
		} );
		ret.promise.cancel = function( msg )
		{
			ret.reject( makeError( msg, { errorCode: -1 } ) )
		}
		return ret;
	}
	
	function isSupported( )
	{
		var Promise = this;
	
		var isSafari = navigator.userAgent.match( /Safari\// )
			&& !navigator.userAgent.match( /Chrome\// );
	
		var isEDGE = navigator.userAgent.match( /Edge\/12/ );
	
		if ( isSafari || isEDGE )
			return Promise.resolve( false );
	
		return defer( Promise, coreApi.isSupported ).promise;
	}
	
	function ensureSupport( )
	{
		var Promise = this;
	
		return defer( Promise, coreApi.isSupported ).promise
		.then( function( value ) {
			if ( !value )
				throw new Error( "U2F not supported" );
		} );
	}
	
	function register( registerRequests, signRequests /* = null */, timeout )
	{
		var Promise = this;
	
		if ( !Array.isArray( registerRequests ) )
			registerRequests = [ registerRequests ];
	
		if ( typeof signRequests === 'number' && typeof timeout === 'undefined' )
		{
			timeout = signRequests;
			signRequests = null;
		}
	
		if ( !signRequests )
			signRequests = [ ];
	
		return defer( Promise, function( resolve, reject ) {
			function cb( err, response ) {
				if ( err )
					reject( err );
				else if ( response.errorCode )
					reject( makeError( "Registration failed", response ) );
				else
					resolve( response );
			}
			coreApi.register( registerRequests, signRequests, cb, timeout );
		} ).promise;
	}
	
	function sign( signRequests, timeout )
	{
		var Promise = this;
	
		if ( !Array.isArray( signRequests ) )
			signRequests = [ signRequests ];
	
		return defer( Promise, function( resolve, reject ) {
			function cb( err, response ) {
				if ( err )
					reject( err );
				else if ( response.errorCode )
					reject( makeError( "Sign failed", response ) );
				else
					resolve( response );
			}
			coreApi.sign( signRequests, cb, timeout );
		} ).promise;
	}
	
	function makeDefault( func )
	{
		API[ func ] = function( )
		{
			if ( !global.Promise )
				// This is very unlikely to ever happen, since browsers
				// supporting U2F will most likely support Promises.
				throw new Error( "The platform doesn't natively support promises" );
	
			var args = [ ].slice.call( arguments );
			return API( global.Promise )[ func ].apply( null, args );
		};
	}
	
	// Provide default functions using the built-in Promise if available.
	makeDefault( 'isSupported' );
	makeDefault( 'ensureSupport' );
	makeDefault( 'register' );
	makeDefault( 'sign' );
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.js
 **/